/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $fd4eb456bcbd06f8$var$t1 = (t1, e)=>"method" === e.kind && e.descriptor && !("value" in e.descriptor) ? {
        ...e,
        finisher (n) {
            n.createProperty(e.key, t1);
        }
    } : {
        kind: "field",
        key: Symbol(),
        placement: "own",
        descriptor: {},
        originalKey: e.key,
        initializer () {
            "function" == typeof e.initializer && (this[e.key] = e.initializer.call(this));
        },
        finisher (n) {
            n.createProperty(e.key, t1);
        }
    };
function $fd4eb456bcbd06f8$var$e(e) {
    return (n, i)=>void 0 !== i ? ((t1, e, n)=>{
            e.constructor.createProperty(n, t1);
        })(e, n, i) : $fd4eb456bcbd06f8$var$t1(e, n);
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ }
var $fd4eb456bcbd06f8$var$n;
null === ($fd4eb456bcbd06f8$var$n = window.HTMLSlotElement) || void 0 === $fd4eb456bcbd06f8$var$n || $fd4eb456bcbd06f8$var$n.prototype.assignedElements;
class $fd4eb456bcbd06f8$var$i {
    addEventListener(t1, e) {
        void 0 === this._listeners && (this._listeners = {});
        const n = this._listeners;
        void 0 === n[t1] && (n[t1] = []), -1 === n[t1].indexOf(e) && n[t1].push(e);
    }
    hasEventListener(t1, e) {
        if (void 0 === this._listeners) return !1;
        const n = this._listeners;
        return void 0 !== n[t1] && -1 !== n[t1].indexOf(e);
    }
    removeEventListener(t1, e) {
        if (void 0 === this._listeners) return;
        const n = this._listeners[t1];
        if (void 0 !== n) {
            const t1 = n.indexOf(e);
            -1 !== t1 && n.splice(t1, 1);
        }
    }
    dispatchEvent(t1) {
        if (void 0 === this._listeners) return;
        const e = this._listeners[t1.type];
        if (void 0 !== e) {
            t1.target = this;
            const n = e.slice(0);
            for(let e = 0, i = n.length; e < i; e++)n[e].call(this, t1);
            t1.target = null;
        }
    }
}
const $fd4eb456bcbd06f8$var$r = [];
for(let t1 = 0; t1 < 256; t1++)$fd4eb456bcbd06f8$var$r[t1] = (t1 < 16 ? "0" : "") + t1.toString(16);
let $fd4eb456bcbd06f8$var$s = 1234567;
const $fd4eb456bcbd06f8$var$a = Math.PI / 180, $fd4eb456bcbd06f8$var$o = 180 / Math.PI;
function $fd4eb456bcbd06f8$var$l() {
    const t1 = 4294967295 * Math.random() | 0, e = 4294967295 * Math.random() | 0, n = 4294967295 * Math.random() | 0, i = 4294967295 * Math.random() | 0;
    return ($fd4eb456bcbd06f8$var$r[255 & t1] + $fd4eb456bcbd06f8$var$r[t1 >> 8 & 255] + $fd4eb456bcbd06f8$var$r[t1 >> 16 & 255] + $fd4eb456bcbd06f8$var$r[t1 >> 24 & 255] + "-" + $fd4eb456bcbd06f8$var$r[255 & e] + $fd4eb456bcbd06f8$var$r[e >> 8 & 255] + "-" + $fd4eb456bcbd06f8$var$r[e >> 16 & 15 | 64] + $fd4eb456bcbd06f8$var$r[e >> 24 & 255] + "-" + $fd4eb456bcbd06f8$var$r[63 & n | 128] + $fd4eb456bcbd06f8$var$r[n >> 8 & 255] + "-" + $fd4eb456bcbd06f8$var$r[n >> 16 & 255] + $fd4eb456bcbd06f8$var$r[n >> 24 & 255] + $fd4eb456bcbd06f8$var$r[255 & i] + $fd4eb456bcbd06f8$var$r[i >> 8 & 255] + $fd4eb456bcbd06f8$var$r[i >> 16 & 255] + $fd4eb456bcbd06f8$var$r[i >> 24 & 255]).toLowerCase();
}
function $fd4eb456bcbd06f8$var$h(t1, e, n) {
    return Math.max(e, Math.min(n, t1));
}
function $fd4eb456bcbd06f8$var$c(t1, e) {
    return (t1 % e + e) % e;
}
function $fd4eb456bcbd06f8$var$u(t1, e, n) {
    return (1 - n) * t1 + n * e;
}
function $fd4eb456bcbd06f8$var$d(t1) {
    return 0 == (t1 & t1 - 1) && 0 !== t1;
}
function $fd4eb456bcbd06f8$var$p(t1) {
    return Math.pow(2, Math.ceil(Math.log(t1) / Math.LN2));
}
function $fd4eb456bcbd06f8$var$m(t1) {
    return Math.pow(2, Math.floor(Math.log(t1) / Math.LN2));
}
var $fd4eb456bcbd06f8$var$f = Object.freeze({
    __proto__: null,
    DEG2RAD: $fd4eb456bcbd06f8$var$a,
    RAD2DEG: $fd4eb456bcbd06f8$var$o,
    generateUUID: $fd4eb456bcbd06f8$var$l,
    clamp: $fd4eb456bcbd06f8$var$h,
    euclideanModulo: $fd4eb456bcbd06f8$var$c,
    mapLinear: function(t1, e, n, i, r) {
        return i + (t1 - e) * (r - i) / (n - e);
    },
    inverseLerp: function(t1, e, n) {
        return t1 !== e ? (n - t1) / (e - t1) : 0;
    },
    lerp: $fd4eb456bcbd06f8$var$u,
    damp: function(t1, e, n, i) {
        return $fd4eb456bcbd06f8$var$u(t1, e, 1 - Math.exp(-n * i));
    },
    pingpong: function(t1, e = 1) {
        return e - Math.abs($fd4eb456bcbd06f8$var$c(t1, 2 * e) - e);
    },
    smoothstep: function(t1, e, n) {
        return t1 <= e ? 0 : t1 >= n ? 1 : (t1 = (t1 - e) / (n - e)) * t1 * (3 - 2 * t1);
    },
    smootherstep: function(t1, e, n) {
        return t1 <= e ? 0 : t1 >= n ? 1 : (t1 = (t1 - e) / (n - e)) * t1 * t1 * (t1 * (6 * t1 - 15) + 10);
    },
    randInt: function(t1, e) {
        return t1 + Math.floor(Math.random() * (e - t1 + 1));
    },
    randFloat: function(t1, e) {
        return t1 + Math.random() * (e - t1);
    },
    randFloatSpread: function(t1) {
        return t1 * (.5 - Math.random());
    },
    seededRandom: function(t1) {
        void 0 !== t1 && ($fd4eb456bcbd06f8$var$s = t1);
        let e = $fd4eb456bcbd06f8$var$s += 1831565813;
        return e = Math.imul(e ^ e >>> 15, 1 | e), e ^= e + Math.imul(e ^ e >>> 7, 61 | e), ((e ^ e >>> 14) >>> 0) / 4294967296;
    },
    degToRad: function(t1) {
        return t1 * $fd4eb456bcbd06f8$var$a;
    },
    radToDeg: function(t1) {
        return t1 * $fd4eb456bcbd06f8$var$o;
    },
    isPowerOfTwo: $fd4eb456bcbd06f8$var$d,
    ceilPowerOfTwo: $fd4eb456bcbd06f8$var$p,
    floorPowerOfTwo: $fd4eb456bcbd06f8$var$m,
    setQuaternionFromProperEuler: function(t1, e, n, i, r) {
        const s = Math.cos, a = Math.sin, o = s(n / 2), l = a(n / 2), h = s((e + i) / 2), c = a((e + i) / 2), u = s((e - i) / 2), d = a((e - i) / 2), p = s((i - e) / 2), m = a((i - e) / 2);
        switch(r){
            case "XYX":
                t1.set(o * c, l * u, l * d, o * h);
                break;
            case "YZY":
                t1.set(l * d, o * c, l * u, o * h);
                break;
            case "ZXZ":
                t1.set(l * u, l * d, o * c, o * h);
                break;
            case "XZX":
                t1.set(o * c, l * m, l * p, o * h);
                break;
            case "YXY":
                t1.set(l * p, o * c, l * m, o * h);
                break;
            case "ZYZ":
                t1.set(l * m, l * p, o * c, o * h);
                break;
            default:
                console.warn("THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " + r);
        }
    },
    normalize: function(t1, e) {
        switch(e.constructor){
            case Float32Array:
                return t1;
            case Uint16Array:
                return Math.round(65535 * t1);
            case Uint8Array:
                return Math.round(255 * t1);
            case Int16Array:
                return Math.round(32767 * t1);
            case Int8Array:
                return Math.round(127 * t1);
            default:
                throw new Error("Invalid component type.");
        }
    },
    denormalize: function(t1, e) {
        switch(e.constructor){
            case Float32Array:
                return t1;
            case Uint16Array:
                return t1 / 65535;
            case Uint8Array:
                return t1 / 255;
            case Int16Array:
                return Math.max(t1 / 32767, -1);
            case Int8Array:
                return Math.max(t1 / 127, -1);
            default:
                throw new Error("Invalid component type.");
        }
    }
});
class $fd4eb456bcbd06f8$var$g {
    constructor(t1 = 0, e = 0){
        this.x = t1, this.y = e;
    }
    get width() {
        return this.x;
    }
    set width(t1) {
        this.x = t1;
    }
    get height() {
        return this.y;
    }
    set height(t1) {
        this.y = t1;
    }
    set(t1, e) {
        return this.x = t1, this.y = e, this;
    }
    setScalar(t1) {
        return this.x = t1, this.y = t1, this;
    }
    setX(t1) {
        return this.x = t1, this;
    }
    setY(t1) {
        return this.y = t1, this;
    }
    setComponent(t1, e) {
        switch(t1){
            case 0:
                this.x = e;
                break;
            case 1:
                this.y = e;
                break;
            default:
                throw new Error("index is out of range: " + t1);
        }
        return this;
    }
    getComponent(t1) {
        switch(t1){
            case 0:
                return this.x;
            case 1:
                return this.y;
            default:
                throw new Error("index is out of range: " + t1);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y);
    }
    copy(t1) {
        return this.x = t1.x, this.y = t1.y, this;
    }
    add(t1, e) {
        return void 0 !== e ? (console.warn("THREE.Vector2: .add() now only accepts one argument. Use .addVectors( a, b ) instead."), this.addVectors(t1, e)) : (this.x += t1.x, this.y += t1.y, this);
    }
    addScalar(t1) {
        return this.x += t1, this.y += t1, this;
    }
    addVectors(t1, e) {
        return this.x = t1.x + e.x, this.y = t1.y + e.y, this;
    }
    addScaledVector(t1, e) {
        return this.x += t1.x * e, this.y += t1.y * e, this;
    }
    sub(t1, e) {
        return void 0 !== e ? (console.warn("THREE.Vector2: .sub() now only accepts one argument. Use .subVectors( a, b ) instead."), this.subVectors(t1, e)) : (this.x -= t1.x, this.y -= t1.y, this);
    }
    subScalar(t1) {
        return this.x -= t1, this.y -= t1, this;
    }
    subVectors(t1, e) {
        return this.x = t1.x - e.x, this.y = t1.y - e.y, this;
    }
    multiply(t1) {
        return this.x *= t1.x, this.y *= t1.y, this;
    }
    multiplyScalar(t1) {
        return this.x *= t1, this.y *= t1, this;
    }
    divide(t1) {
        return this.x /= t1.x, this.y /= t1.y, this;
    }
    divideScalar(t1) {
        return this.multiplyScalar(1 / t1);
    }
    applyMatrix3(t1) {
        const e = this.x, n = this.y, i = t1.elements;
        return this.x = i[0] * e + i[3] * n + i[6], this.y = i[1] * e + i[4] * n + i[7], this;
    }
    min(t1) {
        return this.x = Math.min(this.x, t1.x), this.y = Math.min(this.y, t1.y), this;
    }
    max(t1) {
        return this.x = Math.max(this.x, t1.x), this.y = Math.max(this.y, t1.y), this;
    }
    clamp(t1, e) {
        return this.x = Math.max(t1.x, Math.min(e.x, this.x)), this.y = Math.max(t1.y, Math.min(e.y, this.y)), this;
    }
    clampScalar(t1, e) {
        return this.x = Math.max(t1, Math.min(e, this.x)), this.y = Math.max(t1, Math.min(e, this.y)), this;
    }
    clampLength(t1, e) {
        const n = this.length();
        return this.divideScalar(n || 1).multiplyScalar(Math.max(t1, Math.min(e, n)));
    }
    floor() {
        return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this;
    }
    ceil() {
        return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this;
    }
    round() {
        return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
    }
    roundToZero() {
        return this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x), this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y), this;
    }
    negate() {
        return this.x = -this.x, this.y = -this.y, this;
    }
    dot(t1) {
        return this.x * t1.x + this.y * t1.y;
    }
    cross(t1) {
        return this.x * t1.y - this.y * t1.x;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    angle() {
        return Math.atan2(-this.y, -this.x) + Math.PI;
    }
    distanceTo(t1) {
        return Math.sqrt(this.distanceToSquared(t1));
    }
    distanceToSquared(t1) {
        const e = this.x - t1.x, n = this.y - t1.y;
        return e * e + n * n;
    }
    manhattanDistanceTo(t1) {
        return Math.abs(this.x - t1.x) + Math.abs(this.y - t1.y);
    }
    setLength(t1) {
        return this.normalize().multiplyScalar(t1);
    }
    lerp(t1, e) {
        return this.x += (t1.x - this.x) * e, this.y += (t1.y - this.y) * e, this;
    }
    lerpVectors(t1, e, n) {
        return this.x = t1.x + (e.x - t1.x) * n, this.y = t1.y + (e.y - t1.y) * n, this;
    }
    equals(t1) {
        return t1.x === this.x && t1.y === this.y;
    }
    fromArray(t1, e = 0) {
        return this.x = t1[e], this.y = t1[e + 1], this;
    }
    toArray(t1 = [], e = 0) {
        return t1[e] = this.x, t1[e + 1] = this.y, t1;
    }
    fromBufferAttribute(t1, e, n) {
        return void 0 !== n && console.warn("THREE.Vector2: offset has been removed from .fromBufferAttribute()."), this.x = t1.getX(e), this.y = t1.getY(e), this;
    }
    rotateAround(t1, e) {
        const n = Math.cos(e), i = Math.sin(e), r = this.x - t1.x, s = this.y - t1.y;
        return this.x = r * n - s * i + t1.x, this.y = r * i + s * n + t1.y, this;
    }
    random() {
        return this.x = Math.random(), this.y = Math.random(), this;
    }
    *[Symbol.iterator]() {
        yield this.x, yield this.y;
    }
}
$fd4eb456bcbd06f8$var$g.prototype.isVector2 = !0;
class $fd4eb456bcbd06f8$var$v {
    constructor(){
        this.elements = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ], arguments.length > 0 && console.error("THREE.Matrix3: the constructor no longer reads arguments. use .set() instead.");
    }
    set(t1, e, n, i, r, s, a, o, l) {
        const h = this.elements;
        return h[0] = t1, h[1] = i, h[2] = a, h[3] = e, h[4] = r, h[5] = o, h[6] = n, h[7] = s, h[8] = l, this;
    }
    identity() {
        return this.set(1, 0, 0, 0, 1, 0, 0, 0, 1), this;
    }
    copy(t1) {
        const e = this.elements, n = t1.elements;
        return e[0] = n[0], e[1] = n[1], e[2] = n[2], e[3] = n[3], e[4] = n[4], e[5] = n[5], e[6] = n[6], e[7] = n[7], e[8] = n[8], this;
    }
    extractBasis(t1, e, n) {
        return t1.setFromMatrix3Column(this, 0), e.setFromMatrix3Column(this, 1), n.setFromMatrix3Column(this, 2), this;
    }
    setFromMatrix4(t1) {
        const e = t1.elements;
        return this.set(e[0], e[4], e[8], e[1], e[5], e[9], e[2], e[6], e[10]), this;
    }
    multiply(t1) {
        return this.multiplyMatrices(this, t1);
    }
    premultiply(t1) {
        return this.multiplyMatrices(t1, this);
    }
    multiplyMatrices(t1, e) {
        const n = t1.elements, i = e.elements, r = this.elements, s = n[0], a = n[3], o = n[6], l = n[1], h = n[4], c = n[7], u = n[2], d = n[5], p = n[8], m = i[0], f = i[3], g = i[6], v = i[1], y = i[4], x = i[7], b = i[2], _ = i[5], w = i[8];
        return r[0] = s * m + a * v + o * b, r[3] = s * f + a * y + o * _, r[6] = s * g + a * x + o * w, r[1] = l * m + h * v + c * b, r[4] = l * f + h * y + c * _, r[7] = l * g + h * x + c * w, r[2] = u * m + d * v + p * b, r[5] = u * f + d * y + p * _, r[8] = u * g + d * x + p * w, this;
    }
    multiplyScalar(t1) {
        const e = this.elements;
        return e[0] *= t1, e[3] *= t1, e[6] *= t1, e[1] *= t1, e[4] *= t1, e[7] *= t1, e[2] *= t1, e[5] *= t1, e[8] *= t1, this;
    }
    determinant() {
        const t1 = this.elements, e = t1[0], n = t1[1], i = t1[2], r = t1[3], s = t1[4], a = t1[5], o = t1[6], l = t1[7], h = t1[8];
        return e * s * h - e * a * l - n * r * h + n * a * o + i * r * l - i * s * o;
    }
    invert() {
        const t1 = this.elements, e = t1[0], n = t1[1], i = t1[2], r = t1[3], s = t1[4], a = t1[5], o = t1[6], l = t1[7], h = t1[8], c = h * s - a * l, u = a * o - h * r, d = l * r - s * o, p = e * c + n * u + i * d;
        if (0 === p) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
        const m = 1 / p;
        return t1[0] = c * m, t1[1] = (i * l - h * n) * m, t1[2] = (a * n - i * s) * m, t1[3] = u * m, t1[4] = (h * e - i * o) * m, t1[5] = (i * r - a * e) * m, t1[6] = d * m, t1[7] = (n * o - l * e) * m, t1[8] = (s * e - n * r) * m, this;
    }
    transpose() {
        let t1;
        const e = this.elements;
        return t1 = e[1], e[1] = e[3], e[3] = t1, t1 = e[2], e[2] = e[6], e[6] = t1, t1 = e[5], e[5] = e[7], e[7] = t1, this;
    }
    getNormalMatrix(t1) {
        return this.setFromMatrix4(t1).invert().transpose();
    }
    transposeIntoArray(t1) {
        const e = this.elements;
        return t1[0] = e[0], t1[1] = e[3], t1[2] = e[6], t1[3] = e[1], t1[4] = e[4], t1[5] = e[7], t1[6] = e[2], t1[7] = e[5], t1[8] = e[8], this;
    }
    setUvTransform(t1, e, n, i, r, s, a) {
        const o = Math.cos(r), l = Math.sin(r);
        return this.set(n * o, n * l, -n * (o * s + l * a) + s + t1, -i * l, i * o, -i * (-l * s + o * a) + a + e, 0, 0, 1), this;
    }
    scale(t1, e) {
        const n = this.elements;
        return n[0] *= t1, n[3] *= t1, n[6] *= t1, n[1] *= e, n[4] *= e, n[7] *= e, this;
    }
    rotate(t1) {
        const e = Math.cos(t1), n = Math.sin(t1), i = this.elements, r = i[0], s = i[3], a = i[6], o = i[1], l = i[4], h = i[7];
        return i[0] = e * r + n * o, i[3] = e * s + n * l, i[6] = e * a + n * h, i[1] = -n * r + e * o, i[4] = -n * s + e * l, i[7] = -n * a + e * h, this;
    }
    translate(t1, e) {
        const n = this.elements;
        return n[0] += t1 * n[2], n[3] += t1 * n[5], n[6] += t1 * n[8], n[1] += e * n[2], n[4] += e * n[5], n[7] += e * n[8], this;
    }
    equals(t1) {
        const e = this.elements, n = t1.elements;
        for(let t1 = 0; t1 < 9; t1++)if (e[t1] !== n[t1]) return !1;
        return !0;
    }
    fromArray(t1, e = 0) {
        for(let n = 0; n < 9; n++)this.elements[n] = t1[n + e];
        return this;
    }
    toArray(t1 = [], e = 0) {
        const n = this.elements;
        return t1[e] = n[0], t1[e + 1] = n[1], t1[e + 2] = n[2], t1[e + 3] = n[3], t1[e + 4] = n[4], t1[e + 5] = n[5], t1[e + 6] = n[6], t1[e + 7] = n[7], t1[e + 8] = n[8], t1;
    }
    clone() {
        return (new this.constructor).fromArray(this.elements);
    }
}
function $fd4eb456bcbd06f8$var$y(t1) {
    for(let e = t1.length - 1; e >= 0; --e)if (t1[e] > 65535) return !0;
    return !1;
}
function $fd4eb456bcbd06f8$var$x(t1) {
    return document.createElementNS("http://www.w3.org/1999/xhtml", t1);
}
function $fd4eb456bcbd06f8$var$b(t1) {
    return t1 < .04045 ? .0773993808 * t1 : Math.pow(.9478672986 * t1 + .0521327014, 2.4);
}
function $fd4eb456bcbd06f8$var$_(t1) {
    return t1 < .0031308 ? 12.92 * t1 : 1.055 * Math.pow(t1, .41666) - .055;
}
$fd4eb456bcbd06f8$var$v.prototype.isMatrix3 = !0;
const $fd4eb456bcbd06f8$var$w = {
    srgb: {
        "srgb-linear": $fd4eb456bcbd06f8$var$b
    },
    "srgb-linear": {
        srgb: $fd4eb456bcbd06f8$var$_
    }
}, $fd4eb456bcbd06f8$var$M = {
    legacyMode: !0,
    get workingColorSpace () {
        return "srgb-linear";
    },
    set workingColorSpace (t){
        console.warn("THREE.ColorManagement: .workingColorSpace is readonly.");
    },
    convert: function(t1, e, n) {
        if (this.legacyMode || e === n || !e || !n) return t1;
        if ($fd4eb456bcbd06f8$var$w[e] && void 0 !== $fd4eb456bcbd06f8$var$w[e][n]) {
            const i = $fd4eb456bcbd06f8$var$w[e][n];
            return t1.r = i(t1.r), t1.g = i(t1.g), t1.b = i(t1.b), t1;
        }
        throw new Error("Unsupported color space conversion.");
    },
    fromWorkingColorSpace: function(t1, e) {
        return this.convert(t1, this.workingColorSpace, e);
    },
    toWorkingColorSpace: function(t1, e) {
        return this.convert(t1, e, this.workingColorSpace);
    }
}, $fd4eb456bcbd06f8$var$S = {
    aliceblue: 15792383,
    antiquewhite: 16444375,
    aqua: 65535,
    aquamarine: 8388564,
    azure: 15794175,
    beige: 16119260,
    bisque: 16770244,
    black: 0,
    blanchedalmond: 16772045,
    blue: 255,
    blueviolet: 9055202,
    brown: 10824234,
    burlywood: 14596231,
    cadetblue: 6266528,
    chartreuse: 8388352,
    chocolate: 13789470,
    coral: 16744272,
    cornflowerblue: 6591981,
    cornsilk: 16775388,
    crimson: 14423100,
    cyan: 65535,
    darkblue: 139,
    darkcyan: 35723,
    darkgoldenrod: 12092939,
    darkgray: 11119017,
    darkgreen: 25600,
    darkgrey: 11119017,
    darkkhaki: 12433259,
    darkmagenta: 9109643,
    darkolivegreen: 5597999,
    darkorange: 16747520,
    darkorchid: 10040012,
    darkred: 9109504,
    darksalmon: 15308410,
    darkseagreen: 9419919,
    darkslateblue: 4734347,
    darkslategray: 3100495,
    darkslategrey: 3100495,
    darkturquoise: 52945,
    darkviolet: 9699539,
    deeppink: 16716947,
    deepskyblue: 49151,
    dimgray: 6908265,
    dimgrey: 6908265,
    dodgerblue: 2003199,
    firebrick: 11674146,
    floralwhite: 16775920,
    forestgreen: 2263842,
    fuchsia: 16711935,
    gainsboro: 14474460,
    ghostwhite: 16316671,
    gold: 16766720,
    goldenrod: 14329120,
    gray: 8421504,
    green: 32768,
    greenyellow: 11403055,
    grey: 8421504,
    honeydew: 15794160,
    hotpink: 16738740,
    indianred: 13458524,
    indigo: 4915330,
    ivory: 16777200,
    khaki: 15787660,
    lavender: 15132410,
    lavenderblush: 16773365,
    lawngreen: 8190976,
    lemonchiffon: 16775885,
    lightblue: 11393254,
    lightcoral: 15761536,
    lightcyan: 14745599,
    lightgoldenrodyellow: 16448210,
    lightgray: 13882323,
    lightgreen: 9498256,
    lightgrey: 13882323,
    lightpink: 16758465,
    lightsalmon: 16752762,
    lightseagreen: 2142890,
    lightskyblue: 8900346,
    lightslategray: 7833753,
    lightslategrey: 7833753,
    lightsteelblue: 11584734,
    lightyellow: 16777184,
    lime: 65280,
    limegreen: 3329330,
    linen: 16445670,
    magenta: 16711935,
    maroon: 8388608,
    mediumaquamarine: 6737322,
    mediumblue: 205,
    mediumorchid: 12211667,
    mediumpurple: 9662683,
    mediumseagreen: 3978097,
    mediumslateblue: 8087790,
    mediumspringgreen: 64154,
    mediumturquoise: 4772300,
    mediumvioletred: 13047173,
    midnightblue: 1644912,
    mintcream: 16121850,
    mistyrose: 16770273,
    moccasin: 16770229,
    navajowhite: 16768685,
    navy: 128,
    oldlace: 16643558,
    olive: 8421376,
    olivedrab: 7048739,
    orange: 16753920,
    orangered: 16729344,
    orchid: 14315734,
    palegoldenrod: 15657130,
    palegreen: 10025880,
    paleturquoise: 11529966,
    palevioletred: 14381203,
    papayawhip: 16773077,
    peachpuff: 16767673,
    peru: 13468991,
    pink: 16761035,
    plum: 14524637,
    powderblue: 11591910,
    purple: 8388736,
    rebeccapurple: 6697881,
    red: 16711680,
    rosybrown: 12357519,
    royalblue: 4286945,
    saddlebrown: 9127187,
    salmon: 16416882,
    sandybrown: 16032864,
    seagreen: 3050327,
    seashell: 16774638,
    sienna: 10506797,
    silver: 12632256,
    skyblue: 8900331,
    slateblue: 6970061,
    slategray: 7372944,
    slategrey: 7372944,
    snow: 16775930,
    springgreen: 65407,
    steelblue: 4620980,
    tan: 13808780,
    teal: 32896,
    thistle: 14204888,
    tomato: 16737095,
    turquoise: 4251856,
    violet: 15631086,
    wheat: 16113331,
    white: 16777215,
    whitesmoke: 16119285,
    yellow: 16776960,
    yellowgreen: 10145074
}, $fd4eb456bcbd06f8$var$T = {
    r: 0,
    g: 0,
    b: 0
}, $fd4eb456bcbd06f8$var$E = {
    h: 0,
    s: 0,
    l: 0
}, $fd4eb456bcbd06f8$var$A = {
    h: 0,
    s: 0,
    l: 0
};
function $fd4eb456bcbd06f8$var$R(t1, e, n) {
    return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? t1 + 6 * (e - t1) * n : n < .5 ? e : n < 2 / 3 ? t1 + 6 * (e - t1) * (2 / 3 - n) : t1;
}
function $fd4eb456bcbd06f8$var$C(t1, e) {
    return e.r = t1.r, e.g = t1.g, e.b = t1.b, e;
}
class $fd4eb456bcbd06f8$var$L {
    constructor(t1, e, n){
        return void 0 === e && void 0 === n ? this.set(t1) : this.setRGB(t1, e, n);
    }
    set(t1) {
        return t1 && t1.isColor ? this.copy(t1) : "number" == typeof t1 ? this.setHex(t1) : "string" == typeof t1 && this.setStyle(t1), this;
    }
    setScalar(t1) {
        return this.r = t1, this.g = t1, this.b = t1, this;
    }
    setHex(t1, e = "srgb") {
        return t1 = Math.floor(t1), this.r = (t1 >> 16 & 255) / 255, this.g = (t1 >> 8 & 255) / 255, this.b = (255 & t1) / 255, $fd4eb456bcbd06f8$var$M.toWorkingColorSpace(this, e), this;
    }
    setRGB(t1, e, n, i = "srgb-linear") {
        return this.r = t1, this.g = e, this.b = n, $fd4eb456bcbd06f8$var$M.toWorkingColorSpace(this, i), this;
    }
    setHSL(t1, e, n, i = "srgb-linear") {
        if (t1 = $fd4eb456bcbd06f8$var$c(t1, 1), e = $fd4eb456bcbd06f8$var$h(e, 0, 1), n = $fd4eb456bcbd06f8$var$h(n, 0, 1), 0 === e) this.r = this.g = this.b = n;
        else {
            const i = n <= .5 ? n * (1 + e) : n + e - n * e, r = 2 * n - i;
            this.r = $fd4eb456bcbd06f8$var$R(r, i, t1 + 1 / 3), this.g = $fd4eb456bcbd06f8$var$R(r, i, t1), this.b = $fd4eb456bcbd06f8$var$R(r, i, t1 - 1 / 3);
        }
        return $fd4eb456bcbd06f8$var$M.toWorkingColorSpace(this, i), this;
    }
    setStyle(t1, e = "srgb") {
        function n(e) {
            void 0 !== e && parseFloat(e) < 1 && console.warn("THREE.Color: Alpha component of " + t1 + " will be ignored.");
        }
        let i;
        if (i = /^((?:rgb|hsl)a?)\(([^\)]*)\)/.exec(t1)) {
            let t1;
            const r = i[1], s = i[2];
            switch(r){
                case "rgb":
                case "rgba":
                    if (t1 = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(s)) return this.r = Math.min(255, parseInt(t1[1], 10)) / 255, this.g = Math.min(255, parseInt(t1[2], 10)) / 255, this.b = Math.min(255, parseInt(t1[3], 10)) / 255, $fd4eb456bcbd06f8$var$M.toWorkingColorSpace(this, e), n(t1[4]), this;
                    if (t1 = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(s)) return this.r = Math.min(100, parseInt(t1[1], 10)) / 100, this.g = Math.min(100, parseInt(t1[2], 10)) / 100, this.b = Math.min(100, parseInt(t1[3], 10)) / 100, $fd4eb456bcbd06f8$var$M.toWorkingColorSpace(this, e), n(t1[4]), this;
                    break;
                case "hsl":
                case "hsla":
                    if (t1 = /^\s*(\d*\.?\d+)\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(s)) {
                        const i = parseFloat(t1[1]) / 360, r = parseInt(t1[2], 10) / 100, s = parseInt(t1[3], 10) / 100;
                        return n(t1[4]), this.setHSL(i, r, s, e);
                    }
            }
        } else if (i = /^\#([A-Fa-f\d]+)$/.exec(t1)) {
            const t1 = i[1], n = t1.length;
            if (3 === n) return this.r = parseInt(t1.charAt(0) + t1.charAt(0), 16) / 255, this.g = parseInt(t1.charAt(1) + t1.charAt(1), 16) / 255, this.b = parseInt(t1.charAt(2) + t1.charAt(2), 16) / 255, $fd4eb456bcbd06f8$var$M.toWorkingColorSpace(this, e), this;
            if (6 === n) return this.r = parseInt(t1.charAt(0) + t1.charAt(1), 16) / 255, this.g = parseInt(t1.charAt(2) + t1.charAt(3), 16) / 255, this.b = parseInt(t1.charAt(4) + t1.charAt(5), 16) / 255, $fd4eb456bcbd06f8$var$M.toWorkingColorSpace(this, e), this;
        }
        return t1 && t1.length > 0 ? this.setColorName(t1, e) : this;
    }
    setColorName(t1, e = "srgb") {
        const n = $fd4eb456bcbd06f8$var$S[t1.toLowerCase()];
        return void 0 !== n ? this.setHex(n, e) : console.warn("THREE.Color: Unknown color " + t1), this;
    }
    clone() {
        return new this.constructor(this.r, this.g, this.b);
    }
    copy(t1) {
        return this.r = t1.r, this.g = t1.g, this.b = t1.b, this;
    }
    copySRGBToLinear(t1) {
        return this.r = $fd4eb456bcbd06f8$var$b(t1.r), this.g = $fd4eb456bcbd06f8$var$b(t1.g), this.b = $fd4eb456bcbd06f8$var$b(t1.b), this;
    }
    copyLinearToSRGB(t1) {
        return this.r = $fd4eb456bcbd06f8$var$_(t1.r), this.g = $fd4eb456bcbd06f8$var$_(t1.g), this.b = $fd4eb456bcbd06f8$var$_(t1.b), this;
    }
    convertSRGBToLinear() {
        return this.copySRGBToLinear(this), this;
    }
    convertLinearToSRGB() {
        return this.copyLinearToSRGB(this), this;
    }
    getHex(t1 = "srgb") {
        return $fd4eb456bcbd06f8$var$M.fromWorkingColorSpace($fd4eb456bcbd06f8$var$C(this, $fd4eb456bcbd06f8$var$T), t1), $fd4eb456bcbd06f8$var$h(255 * $fd4eb456bcbd06f8$var$T.r, 0, 255) << 16 ^ $fd4eb456bcbd06f8$var$h(255 * $fd4eb456bcbd06f8$var$T.g, 0, 255) << 8 ^ $fd4eb456bcbd06f8$var$h(255 * $fd4eb456bcbd06f8$var$T.b, 0, 255) << 0;
    }
    getHexString(t1 = "srgb") {
        return ("000000" + this.getHex(t1).toString(16)).slice(-6);
    }
    getHSL(t1, e = "srgb-linear") {
        $fd4eb456bcbd06f8$var$M.fromWorkingColorSpace($fd4eb456bcbd06f8$var$C(this, $fd4eb456bcbd06f8$var$T), e);
        const n = $fd4eb456bcbd06f8$var$T.r, i = $fd4eb456bcbd06f8$var$T.g, r = $fd4eb456bcbd06f8$var$T.b, s = Math.max(n, i, r), a = Math.min(n, i, r);
        let o, l;
        const h = (a + s) / 2;
        if (a === s) o = 0, l = 0;
        else {
            const t1 = s - a;
            switch(l = h <= .5 ? t1 / (s + a) : t1 / (2 - s - a), s){
                case n:
                    o = (i - r) / t1 + (i < r ? 6 : 0);
                    break;
                case i:
                    o = (r - n) / t1 + 2;
                    break;
                case r:
                    o = (n - i) / t1 + 4;
            }
            o /= 6;
        }
        return t1.h = o, t1.s = l, t1.l = h, t1;
    }
    getRGB(t1, e = "srgb-linear") {
        return $fd4eb456bcbd06f8$var$M.fromWorkingColorSpace($fd4eb456bcbd06f8$var$C(this, $fd4eb456bcbd06f8$var$T), e), t1.r = $fd4eb456bcbd06f8$var$T.r, t1.g = $fd4eb456bcbd06f8$var$T.g, t1.b = $fd4eb456bcbd06f8$var$T.b, t1;
    }
    getStyle(t1 = "srgb") {
        return $fd4eb456bcbd06f8$var$M.fromWorkingColorSpace($fd4eb456bcbd06f8$var$C(this, $fd4eb456bcbd06f8$var$T), t1), "srgb" !== t1 ? `color(${t1} ${$fd4eb456bcbd06f8$var$T.r} ${$fd4eb456bcbd06f8$var$T.g} ${$fd4eb456bcbd06f8$var$T.b})` : `rgb(${255 * $fd4eb456bcbd06f8$var$T.r | 0},${255 * $fd4eb456bcbd06f8$var$T.g | 0},${255 * $fd4eb456bcbd06f8$var$T.b | 0})`;
    }
    offsetHSL(t1, e, n) {
        return this.getHSL($fd4eb456bcbd06f8$var$E), $fd4eb456bcbd06f8$var$E.h += t1, $fd4eb456bcbd06f8$var$E.s += e, $fd4eb456bcbd06f8$var$E.l += n, this.setHSL($fd4eb456bcbd06f8$var$E.h, $fd4eb456bcbd06f8$var$E.s, $fd4eb456bcbd06f8$var$E.l), this;
    }
    add(t1) {
        return this.r += t1.r, this.g += t1.g, this.b += t1.b, this;
    }
    addColors(t1, e) {
        return this.r = t1.r + e.r, this.g = t1.g + e.g, this.b = t1.b + e.b, this;
    }
    addScalar(t1) {
        return this.r += t1, this.g += t1, this.b += t1, this;
    }
    sub(t1) {
        return this.r = Math.max(0, this.r - t1.r), this.g = Math.max(0, this.g - t1.g), this.b = Math.max(0, this.b - t1.b), this;
    }
    multiply(t1) {
        return this.r *= t1.r, this.g *= t1.g, this.b *= t1.b, this;
    }
    multiplyScalar(t1) {
        return this.r *= t1, this.g *= t1, this.b *= t1, this;
    }
    lerp(t1, e) {
        return this.r += (t1.r - this.r) * e, this.g += (t1.g - this.g) * e, this.b += (t1.b - this.b) * e, this;
    }
    lerpColors(t1, e, n) {
        return this.r = t1.r + (e.r - t1.r) * n, this.g = t1.g + (e.g - t1.g) * n, this.b = t1.b + (e.b - t1.b) * n, this;
    }
    lerpHSL(t1, e) {
        this.getHSL($fd4eb456bcbd06f8$var$E), t1.getHSL($fd4eb456bcbd06f8$var$A);
        const n = $fd4eb456bcbd06f8$var$u($fd4eb456bcbd06f8$var$E.h, $fd4eb456bcbd06f8$var$A.h, e), i = $fd4eb456bcbd06f8$var$u($fd4eb456bcbd06f8$var$E.s, $fd4eb456bcbd06f8$var$A.s, e), r = $fd4eb456bcbd06f8$var$u($fd4eb456bcbd06f8$var$E.l, $fd4eb456bcbd06f8$var$A.l, e);
        return this.setHSL(n, i, r), this;
    }
    equals(t1) {
        return t1.r === this.r && t1.g === this.g && t1.b === this.b;
    }
    fromArray(t1, e = 0) {
        return this.r = t1[e], this.g = t1[e + 1], this.b = t1[e + 2], this;
    }
    toArray(t1 = [], e = 0) {
        return t1[e] = this.r, t1[e + 1] = this.g, t1[e + 2] = this.b, t1;
    }
    fromBufferAttribute(t1, e) {
        return this.r = t1.getX(e), this.g = t1.getY(e), this.b = t1.getZ(e), !0 === t1.normalized && (this.r /= 255, this.g /= 255, this.b /= 255), this;
    }
    toJSON() {
        return this.getHex();
    }
}
let $fd4eb456bcbd06f8$var$P;
$fd4eb456bcbd06f8$var$L.NAMES = $fd4eb456bcbd06f8$var$S, $fd4eb456bcbd06f8$var$L.prototype.isColor = !0, $fd4eb456bcbd06f8$var$L.prototype.r = 1, $fd4eb456bcbd06f8$var$L.prototype.g = 1, $fd4eb456bcbd06f8$var$L.prototype.b = 1;
class $fd4eb456bcbd06f8$var$D {
    static getDataURL(t1) {
        if (/^data:/i.test(t1.src)) return t1.src;
        if ("undefined" == typeof HTMLCanvasElement) return t1.src;
        let e;
        if (t1 instanceof HTMLCanvasElement) e = t1;
        else {
            void 0 === $fd4eb456bcbd06f8$var$P && ($fd4eb456bcbd06f8$var$P = $fd4eb456bcbd06f8$var$x("canvas")), $fd4eb456bcbd06f8$var$P.width = t1.width, $fd4eb456bcbd06f8$var$P.height = t1.height;
            const n = $fd4eb456bcbd06f8$var$P.getContext("2d");
            t1 instanceof ImageData ? n.putImageData(t1, 0, 0) : n.drawImage(t1, 0, 0, t1.width, t1.height), e = $fd4eb456bcbd06f8$var$P;
        }
        return e.width > 2048 || e.height > 2048 ? (console.warn("THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons", t1), e.toDataURL("image/jpeg", .6)) : e.toDataURL("image/png");
    }
    static sRGBToLinear(t1) {
        if ("undefined" != typeof HTMLImageElement && t1 instanceof HTMLImageElement || "undefined" != typeof HTMLCanvasElement && t1 instanceof HTMLCanvasElement || "undefined" != typeof ImageBitmap && t1 instanceof ImageBitmap) {
            const e = $fd4eb456bcbd06f8$var$x("canvas");
            e.width = t1.width, e.height = t1.height;
            const n = e.getContext("2d");
            n.drawImage(t1, 0, 0, t1.width, t1.height);
            const i = n.getImageData(0, 0, t1.width, t1.height), r = i.data;
            for(let t1 = 0; t1 < r.length; t1++)r[t1] = 255 * $fd4eb456bcbd06f8$var$b(r[t1] / 255);
            return n.putImageData(i, 0, 0), e;
        }
        if (t1.data) {
            const e = t1.data.slice(0);
            for(let t1 = 0; t1 < e.length; t1++)e instanceof Uint8Array || e instanceof Uint8ClampedArray ? e[t1] = Math.floor(255 * $fd4eb456bcbd06f8$var$b(e[t1] / 255)) : e[t1] = $fd4eb456bcbd06f8$var$b(e[t1]);
            return {
                data: e,
                width: t1.width,
                height: t1.height
            };
        }
        return console.warn("THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied."), t1;
    }
}
class $fd4eb456bcbd06f8$var$I {
    constructor(t1 = null){
        this.uuid = $fd4eb456bcbd06f8$var$l(), this.data = t1, this.version = 0;
    }
    set needsUpdate(t1) {
        !0 === t1 && this.version++;
    }
    toJSON(t1) {
        const e = void 0 === t1 || "string" == typeof t1;
        if (!e && void 0 !== t1.images[this.uuid]) return t1.images[this.uuid];
        const n = {
            uuid: this.uuid,
            url: ""
        }, i = this.data;
        if (null !== i) {
            let t1;
            if (Array.isArray(i)) {
                t1 = [];
                for(let e = 0, n = i.length; e < n; e++)i[e].isDataTexture ? t1.push($fd4eb456bcbd06f8$var$O(i[e].image)) : t1.push($fd4eb456bcbd06f8$var$O(i[e]));
            } else t1 = $fd4eb456bcbd06f8$var$O(i);
            n.url = t1;
        }
        return e || (t1.images[this.uuid] = n), n;
    }
}
function $fd4eb456bcbd06f8$var$O(t1) {
    return "undefined" != typeof HTMLImageElement && t1 instanceof HTMLImageElement || "undefined" != typeof HTMLCanvasElement && t1 instanceof HTMLCanvasElement || "undefined" != typeof ImageBitmap && t1 instanceof ImageBitmap ? $fd4eb456bcbd06f8$var$D.getDataURL(t1) : t1.data ? {
        data: Array.prototype.slice.call(t1.data),
        width: t1.width,
        height: t1.height,
        type: t1.data.constructor.name
    } : (console.warn("THREE.Texture: Unable to serialize Texture."), {});
}
$fd4eb456bcbd06f8$var$I.prototype.isSource = !0;
let $fd4eb456bcbd06f8$var$N = 0;
class $fd4eb456bcbd06f8$var$F extends $fd4eb456bcbd06f8$var$i {
    constructor(t1 = $fd4eb456bcbd06f8$var$F.DEFAULT_IMAGE, e = $fd4eb456bcbd06f8$var$F.DEFAULT_MAPPING, n = 1001, i = 1001, r = 1006, s = 1008, a = 1023, o = 1009, h = 1, c = 3e3){
        super(), Object.defineProperty(this, "id", {
            value: $fd4eb456bcbd06f8$var$N++
        }), this.uuid = $fd4eb456bcbd06f8$var$l(), this.name = "", this.source = new $fd4eb456bcbd06f8$var$I(t1), this.mipmaps = [], this.mapping = e, this.wrapS = n, this.wrapT = i, this.magFilter = r, this.minFilter = s, this.anisotropy = h, this.format = a, this.internalFormat = null, this.type = o, this.offset = new $fd4eb456bcbd06f8$var$g(0, 0), this.repeat = new $fd4eb456bcbd06f8$var$g(1, 1), this.center = new $fd4eb456bcbd06f8$var$g(0, 0), this.rotation = 0, this.matrixAutoUpdate = !0, this.matrix = new $fd4eb456bcbd06f8$var$v, this.generateMipmaps = !0, this.premultiplyAlpha = !1, this.flipY = !0, this.unpackAlignment = 4, this.encoding = c, this.userData = {}, this.version = 0, this.onUpdate = null, this.isRenderTargetTexture = !1, this.needsPMREMUpdate = !1;
    }
    get image() {
        return this.source.data;
    }
    set image(t1) {
        this.source.data = t1;
    }
    updateMatrix() {
        this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
    }
    clone() {
        return (new this.constructor).copy(this);
    }
    copy(t1) {
        return this.name = t1.name, this.source = t1.source, this.mipmaps = t1.mipmaps.slice(0), this.mapping = t1.mapping, this.wrapS = t1.wrapS, this.wrapT = t1.wrapT, this.magFilter = t1.magFilter, this.minFilter = t1.minFilter, this.anisotropy = t1.anisotropy, this.format = t1.format, this.internalFormat = t1.internalFormat, this.type = t1.type, this.offset.copy(t1.offset), this.repeat.copy(t1.repeat), this.center.copy(t1.center), this.rotation = t1.rotation, this.matrixAutoUpdate = t1.matrixAutoUpdate, this.matrix.copy(t1.matrix), this.generateMipmaps = t1.generateMipmaps, this.premultiplyAlpha = t1.premultiplyAlpha, this.flipY = t1.flipY, this.unpackAlignment = t1.unpackAlignment, this.encoding = t1.encoding, this.userData = JSON.parse(JSON.stringify(t1.userData)), this.needsUpdate = !0, this;
    }
    toJSON(t1) {
        const e = void 0 === t1 || "string" == typeof t1;
        if (!e && void 0 !== t1.textures[this.uuid]) return t1.textures[this.uuid];
        const n = {
            metadata: {
                version: 4.5,
                type: "Texture",
                generator: "Texture.toJSON"
            },
            uuid: this.uuid,
            name: this.name,
            image: this.source.toJSON(t1).uuid,
            mapping: this.mapping,
            repeat: [
                this.repeat.x,
                this.repeat.y
            ],
            offset: [
                this.offset.x,
                this.offset.y
            ],
            center: [
                this.center.x,
                this.center.y
            ],
            rotation: this.rotation,
            wrap: [
                this.wrapS,
                this.wrapT
            ],
            format: this.format,
            type: this.type,
            encoding: this.encoding,
            minFilter: this.minFilter,
            magFilter: this.magFilter,
            anisotropy: this.anisotropy,
            flipY: this.flipY,
            premultiplyAlpha: this.premultiplyAlpha,
            unpackAlignment: this.unpackAlignment
        };
        return "{}" !== JSON.stringify(this.userData) && (n.userData = this.userData), e || (t1.textures[this.uuid] = n), n;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
    transformUv(t1) {
        if (300 !== this.mapping) return t1;
        if (t1.applyMatrix3(this.matrix), t1.x < 0 || t1.x > 1) switch(this.wrapS){
            case 1e3:
                t1.x = t1.x - Math.floor(t1.x);
                break;
            case 1001:
                t1.x = t1.x < 0 ? 0 : 1;
                break;
            case 1002:
                1 === Math.abs(Math.floor(t1.x) % 2) ? t1.x = Math.ceil(t1.x) - t1.x : t1.x = t1.x - Math.floor(t1.x);
        }
        if (t1.y < 0 || t1.y > 1) switch(this.wrapT){
            case 1e3:
                t1.y = t1.y - Math.floor(t1.y);
                break;
            case 1001:
                t1.y = t1.y < 0 ? 0 : 1;
                break;
            case 1002:
                1 === Math.abs(Math.floor(t1.y) % 2) ? t1.y = Math.ceil(t1.y) - t1.y : t1.y = t1.y - Math.floor(t1.y);
        }
        return this.flipY && (t1.y = 1 - t1.y), t1;
    }
    set needsUpdate(t1) {
        !0 === t1 && (this.version++, this.source.needsUpdate = !0);
    }
}
$fd4eb456bcbd06f8$var$F.DEFAULT_IMAGE = null, $fd4eb456bcbd06f8$var$F.DEFAULT_MAPPING = 300, $fd4eb456bcbd06f8$var$F.prototype.isTexture = !0;
class $fd4eb456bcbd06f8$var$U {
    constructor(t1 = 0, e = 0, n = 0, i = 1){
        this.x = t1, this.y = e, this.z = n, this.w = i;
    }
    get width() {
        return this.z;
    }
    set width(t1) {
        this.z = t1;
    }
    get height() {
        return this.w;
    }
    set height(t1) {
        this.w = t1;
    }
    set(t1, e, n, i) {
        return this.x = t1, this.y = e, this.z = n, this.w = i, this;
    }
    setScalar(t1) {
        return this.x = t1, this.y = t1, this.z = t1, this.w = t1, this;
    }
    setX(t1) {
        return this.x = t1, this;
    }
    setY(t1) {
        return this.y = t1, this;
    }
    setZ(t1) {
        return this.z = t1, this;
    }
    setW(t1) {
        return this.w = t1, this;
    }
    setComponent(t1, e) {
        switch(t1){
            case 0:
                this.x = e;
                break;
            case 1:
                this.y = e;
                break;
            case 2:
                this.z = e;
                break;
            case 3:
                this.w = e;
                break;
            default:
                throw new Error("index is out of range: " + t1);
        }
        return this;
    }
    getComponent(t1) {
        switch(t1){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            case 3:
                return this.w;
            default:
                throw new Error("index is out of range: " + t1);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z, this.w);
    }
    copy(t1) {
        return this.x = t1.x, this.y = t1.y, this.z = t1.z, this.w = void 0 !== t1.w ? t1.w : 1, this;
    }
    add(t1, e) {
        return void 0 !== e ? (console.warn("THREE.Vector4: .add() now only accepts one argument. Use .addVectors( a, b ) instead."), this.addVectors(t1, e)) : (this.x += t1.x, this.y += t1.y, this.z += t1.z, this.w += t1.w, this);
    }
    addScalar(t1) {
        return this.x += t1, this.y += t1, this.z += t1, this.w += t1, this;
    }
    addVectors(t1, e) {
        return this.x = t1.x + e.x, this.y = t1.y + e.y, this.z = t1.z + e.z, this.w = t1.w + e.w, this;
    }
    addScaledVector(t1, e) {
        return this.x += t1.x * e, this.y += t1.y * e, this.z += t1.z * e, this.w += t1.w * e, this;
    }
    sub(t1, e) {
        return void 0 !== e ? (console.warn("THREE.Vector4: .sub() now only accepts one argument. Use .subVectors( a, b ) instead."), this.subVectors(t1, e)) : (this.x -= t1.x, this.y -= t1.y, this.z -= t1.z, this.w -= t1.w, this);
    }
    subScalar(t1) {
        return this.x -= t1, this.y -= t1, this.z -= t1, this.w -= t1, this;
    }
    subVectors(t1, e) {
        return this.x = t1.x - e.x, this.y = t1.y - e.y, this.z = t1.z - e.z, this.w = t1.w - e.w, this;
    }
    multiply(t1) {
        return this.x *= t1.x, this.y *= t1.y, this.z *= t1.z, this.w *= t1.w, this;
    }
    multiplyScalar(t1) {
        return this.x *= t1, this.y *= t1, this.z *= t1, this.w *= t1, this;
    }
    applyMatrix4(t1) {
        const e = this.x, n = this.y, i = this.z, r = this.w, s = t1.elements;
        return this.x = s[0] * e + s[4] * n + s[8] * i + s[12] * r, this.y = s[1] * e + s[5] * n + s[9] * i + s[13] * r, this.z = s[2] * e + s[6] * n + s[10] * i + s[14] * r, this.w = s[3] * e + s[7] * n + s[11] * i + s[15] * r, this;
    }
    divideScalar(t1) {
        return this.multiplyScalar(1 / t1);
    }
    setAxisAngleFromQuaternion(t1) {
        this.w = 2 * Math.acos(t1.w);
        const e = Math.sqrt(1 - t1.w * t1.w);
        return e < 1e-4 ? (this.x = 1, this.y = 0, this.z = 0) : (this.x = t1.x / e, this.y = t1.y / e, this.z = t1.z / e), this;
    }
    setAxisAngleFromRotationMatrix(t1) {
        let e, n, i, r;
        const s = .01, a = .1, o = t1.elements, l = o[0], h = o[4], c = o[8], u = o[1], d = o[5], p = o[9], m = o[2], f = o[6], g = o[10];
        if (Math.abs(h - u) < s && Math.abs(c - m) < s && Math.abs(p - f) < s) {
            if (Math.abs(h + u) < a && Math.abs(c + m) < a && Math.abs(p + f) < a && Math.abs(l + d + g - 3) < a) return this.set(1, 0, 0, 0), this;
            e = Math.PI;
            const t1 = (l + 1) / 2, o = (d + 1) / 2, v = (g + 1) / 2, y = (h + u) / 4, x = (c + m) / 4, b = (p + f) / 4;
            return t1 > o && t1 > v ? t1 < s ? (n = 0, i = .707106781, r = .707106781) : (n = Math.sqrt(t1), i = y / n, r = x / n) : o > v ? o < s ? (n = .707106781, i = 0, r = .707106781) : (i = Math.sqrt(o), n = y / i, r = b / i) : v < s ? (n = .707106781, i = .707106781, r = 0) : (r = Math.sqrt(v), n = x / r, i = b / r), this.set(n, i, r, e), this;
        }
        let v = Math.sqrt((f - p) * (f - p) + (c - m) * (c - m) + (u - h) * (u - h));
        return Math.abs(v) < .001 && (v = 1), this.x = (f - p) / v, this.y = (c - m) / v, this.z = (u - h) / v, this.w = Math.acos((l + d + g - 1) / 2), this;
    }
    min(t1) {
        return this.x = Math.min(this.x, t1.x), this.y = Math.min(this.y, t1.y), this.z = Math.min(this.z, t1.z), this.w = Math.min(this.w, t1.w), this;
    }
    max(t1) {
        return this.x = Math.max(this.x, t1.x), this.y = Math.max(this.y, t1.y), this.z = Math.max(this.z, t1.z), this.w = Math.max(this.w, t1.w), this;
    }
    clamp(t1, e) {
        return this.x = Math.max(t1.x, Math.min(e.x, this.x)), this.y = Math.max(t1.y, Math.min(e.y, this.y)), this.z = Math.max(t1.z, Math.min(e.z, this.z)), this.w = Math.max(t1.w, Math.min(e.w, this.w)), this;
    }
    clampScalar(t1, e) {
        return this.x = Math.max(t1, Math.min(e, this.x)), this.y = Math.max(t1, Math.min(e, this.y)), this.z = Math.max(t1, Math.min(e, this.z)), this.w = Math.max(t1, Math.min(e, this.w)), this;
    }
    clampLength(t1, e) {
        const n = this.length();
        return this.divideScalar(n || 1).multiplyScalar(Math.max(t1, Math.min(e, n)));
    }
    floor() {
        return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this.w = Math.floor(this.w), this;
    }
    ceil() {
        return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this.w = Math.ceil(this.w), this;
    }
    round() {
        return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this.w = Math.round(this.w), this;
    }
    roundToZero() {
        return this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x), this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y), this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z), this.w = this.w < 0 ? Math.ceil(this.w) : Math.floor(this.w), this;
    }
    negate() {
        return this.x = -this.x, this.y = -this.y, this.z = -this.z, this.w = -this.w, this;
    }
    dot(t1) {
        return this.x * t1.x + this.y * t1.y + this.z * t1.z + this.w * t1.w;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(t1) {
        return this.normalize().multiplyScalar(t1);
    }
    lerp(t1, e) {
        return this.x += (t1.x - this.x) * e, this.y += (t1.y - this.y) * e, this.z += (t1.z - this.z) * e, this.w += (t1.w - this.w) * e, this;
    }
    lerpVectors(t1, e, n) {
        return this.x = t1.x + (e.x - t1.x) * n, this.y = t1.y + (e.y - t1.y) * n, this.z = t1.z + (e.z - t1.z) * n, this.w = t1.w + (e.w - t1.w) * n, this;
    }
    equals(t1) {
        return t1.x === this.x && t1.y === this.y && t1.z === this.z && t1.w === this.w;
    }
    fromArray(t1, e = 0) {
        return this.x = t1[e], this.y = t1[e + 1], this.z = t1[e + 2], this.w = t1[e + 3], this;
    }
    toArray(t1 = [], e = 0) {
        return t1[e] = this.x, t1[e + 1] = this.y, t1[e + 2] = this.z, t1[e + 3] = this.w, t1;
    }
    fromBufferAttribute(t1, e, n) {
        return void 0 !== n && console.warn("THREE.Vector4: offset has been removed from .fromBufferAttribute()."), this.x = t1.getX(e), this.y = t1.getY(e), this.z = t1.getZ(e), this.w = t1.getW(e), this;
    }
    random() {
        return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this.w = Math.random(), this;
    }
    *[Symbol.iterator]() {
        yield this.x, yield this.y, yield this.z, yield this.w;
    }
}
$fd4eb456bcbd06f8$var$U.prototype.isVector4 = !0;
class $fd4eb456bcbd06f8$var$k extends $fd4eb456bcbd06f8$var$i {
    constructor(t1, e, n = {}){
        super(), this.width = t1, this.height = e, this.depth = 1, this.scissor = new $fd4eb456bcbd06f8$var$U(0, 0, t1, e), this.scissorTest = !1, this.viewport = new $fd4eb456bcbd06f8$var$U(0, 0, t1, e);
        const i = {
            width: t1,
            height: e,
            depth: 1
        };
        this.texture = new $fd4eb456bcbd06f8$var$F(i, n.mapping, n.wrapS, n.wrapT, n.magFilter, n.minFilter, n.format, n.type, n.anisotropy, n.encoding), this.texture.isRenderTargetTexture = !0, this.texture.flipY = !1, this.texture.generateMipmaps = void 0 !== n.generateMipmaps && n.generateMipmaps, this.texture.internalFormat = void 0 !== n.internalFormat ? n.internalFormat : null, this.texture.minFilter = void 0 !== n.minFilter ? n.minFilter : 1006, this.depthBuffer = void 0 === n.depthBuffer || n.depthBuffer, this.stencilBuffer = void 0 !== n.stencilBuffer && n.stencilBuffer, this.depthTexture = void 0 !== n.depthTexture ? n.depthTexture : null, this.samples = void 0 !== n.samples ? n.samples : 0;
    }
    setSize(t1, e, n = 1) {
        this.width === t1 && this.height === e && this.depth === n || (this.width = t1, this.height = e, this.depth = n, this.texture.image.width = t1, this.texture.image.height = e, this.texture.image.depth = n, this.dispose()), this.viewport.set(0, 0, t1, e), this.scissor.set(0, 0, t1, e);
    }
    clone() {
        return (new this.constructor).copy(this);
    }
    copy(t1) {
        return this.width = t1.width, this.height = t1.height, this.depth = t1.depth, this.viewport.copy(t1.viewport), this.texture = t1.texture.clone(), this.texture.isRenderTargetTexture = !0, this.texture.image = Object.assign({}, t1.texture.image), this.depthBuffer = t1.depthBuffer, this.stencilBuffer = t1.stencilBuffer, null !== t1.depthTexture && (this.depthTexture = t1.depthTexture.clone()), this.samples = t1.samples, this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}
$fd4eb456bcbd06f8$var$k.prototype.isWebGLRenderTarget = !0;
class $fd4eb456bcbd06f8$var$B extends $fd4eb456bcbd06f8$var$F {
    constructor(t1 = null, e = 1, n = 1, i = 1){
        super(null), this.image = {
            data: t1,
            width: e,
            height: n,
            depth: i
        }, this.magFilter = 1003, this.minFilter = 1003, this.wrapR = 1001, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
    }
}
$fd4eb456bcbd06f8$var$B.prototype.isDataArrayTexture = !0;
(class extends $fd4eb456bcbd06f8$var$k {
    constructor(t1, e, n){
        super(t1, e), this.depth = n, this.texture = new $fd4eb456bcbd06f8$var$B(null, t1, e, n), this.texture.isRenderTargetTexture = !0;
    }
}).prototype.isWebGLArrayRenderTarget = !0;
class $fd4eb456bcbd06f8$var$z extends $fd4eb456bcbd06f8$var$F {
    constructor(t1 = null, e = 1, n = 1, i = 1){
        super(null), this.image = {
            data: t1,
            width: e,
            height: n,
            depth: i
        }, this.magFilter = 1003, this.minFilter = 1003, this.wrapR = 1001, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
    }
}
$fd4eb456bcbd06f8$var$z.prototype.isData3DTexture = !0;
(class extends $fd4eb456bcbd06f8$var$k {
    constructor(t1, e, n){
        super(t1, e), this.depth = n, this.texture = new $fd4eb456bcbd06f8$var$z(null, t1, e, n), this.texture.isRenderTargetTexture = !0;
    }
}).prototype.isWebGL3DRenderTarget = !0;
(class extends $fd4eb456bcbd06f8$var$k {
    constructor(t1, e, n, i = {}){
        super(t1, e, i);
        const r = this.texture;
        this.texture = [];
        for(let t1 = 0; t1 < n; t1++)this.texture[t1] = r.clone(), this.texture[t1].isRenderTargetTexture = !0;
    }
    setSize(t1, e, n = 1) {
        if (this.width !== t1 || this.height !== e || this.depth !== n) {
            this.width = t1, this.height = e, this.depth = n;
            for(let i = 0, r = this.texture.length; i < r; i++)this.texture[i].image.width = t1, this.texture[i].image.height = e, this.texture[i].image.depth = n;
            this.dispose();
        }
        return this.viewport.set(0, 0, t1, e), this.scissor.set(0, 0, t1, e), this;
    }
    copy(t1) {
        this.dispose(), this.width = t1.width, this.height = t1.height, this.depth = t1.depth, this.viewport.set(0, 0, this.width, this.height), this.scissor.set(0, 0, this.width, this.height), this.depthBuffer = t1.depthBuffer, this.stencilBuffer = t1.stencilBuffer, this.depthTexture = t1.depthTexture, this.texture.length = 0;
        for(let e = 0, n = t1.texture.length; e < n; e++)this.texture[e] = t1.texture[e].clone();
        return this;
    }
}).prototype.isWebGLMultipleRenderTargets = !0;
class $fd4eb456bcbd06f8$var$H {
    constructor(t1 = 0, e = 0, n = 0, i = 1){
        this._x = t1, this._y = e, this._z = n, this._w = i;
    }
    static slerp(t1, e, n, i) {
        return console.warn("THREE.Quaternion: Static .slerp() has been deprecated. Use qm.slerpQuaternions( qa, qb, t ) instead."), n.slerpQuaternions(t1, e, i);
    }
    static slerpFlat(t1, e, n, i, r, s, a) {
        let o = n[i + 0], l = n[i + 1], h = n[i + 2], c = n[i + 3];
        const u = r[s + 0], d = r[s + 1], p = r[s + 2], m = r[s + 3];
        if (0 === a) return t1[e + 0] = o, t1[e + 1] = l, t1[e + 2] = h, void (t1[e + 3] = c);
        if (1 === a) return t1[e + 0] = u, t1[e + 1] = d, t1[e + 2] = p, void (t1[e + 3] = m);
        if (c !== m || o !== u || l !== d || h !== p) {
            let t1 = 1 - a;
            const e = o * u + l * d + h * p + c * m, n = e >= 0 ? 1 : -1, i = 1 - e * e;
            if (i > Number.EPSILON) {
                const r = Math.sqrt(i), s = Math.atan2(r, e * n);
                t1 = Math.sin(t1 * s) / r, a = Math.sin(a * s) / r;
            }
            const r = a * n;
            if (o = o * t1 + u * r, l = l * t1 + d * r, h = h * t1 + p * r, c = c * t1 + m * r, t1 === 1 - a) {
                const t1 = 1 / Math.sqrt(o * o + l * l + h * h + c * c);
                o *= t1, l *= t1, h *= t1, c *= t1;
            }
        }
        t1[e] = o, t1[e + 1] = l, t1[e + 2] = h, t1[e + 3] = c;
    }
    static multiplyQuaternionsFlat(t1, e, n, i, r, s) {
        const a = n[i], o = n[i + 1], l = n[i + 2], h = n[i + 3], c = r[s], u = r[s + 1], d = r[s + 2], p = r[s + 3];
        return t1[e] = a * p + h * c + o * d - l * u, t1[e + 1] = o * p + h * u + l * c - a * d, t1[e + 2] = l * p + h * d + a * u - o * c, t1[e + 3] = h * p - a * c - o * u - l * d, t1;
    }
    get x() {
        return this._x;
    }
    set x(t1) {
        this._x = t1, this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(t1) {
        this._y = t1, this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(t1) {
        this._z = t1, this._onChangeCallback();
    }
    get w() {
        return this._w;
    }
    set w(t1) {
        this._w = t1, this._onChangeCallback();
    }
    set(t1, e, n, i) {
        return this._x = t1, this._y = e, this._z = n, this._w = i, this._onChangeCallback(), this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._w);
    }
    copy(t1) {
        return this._x = t1.x, this._y = t1.y, this._z = t1.z, this._w = t1.w, this._onChangeCallback(), this;
    }
    setFromEuler(t1, e) {
        if (!t1 || !t1.isEuler) throw new Error("THREE.Quaternion: .setFromEuler() now expects an Euler rotation rather than a Vector3 and order.");
        const n = t1._x, i = t1._y, r = t1._z, s = t1._order, a = Math.cos, o = Math.sin, l = a(n / 2), h = a(i / 2), c = a(r / 2), u = o(n / 2), d = o(i / 2), p = o(r / 2);
        switch(s){
            case "XYZ":
                this._x = u * h * c + l * d * p, this._y = l * d * c - u * h * p, this._z = l * h * p + u * d * c, this._w = l * h * c - u * d * p;
                break;
            case "YXZ":
                this._x = u * h * c + l * d * p, this._y = l * d * c - u * h * p, this._z = l * h * p - u * d * c, this._w = l * h * c + u * d * p;
                break;
            case "ZXY":
                this._x = u * h * c - l * d * p, this._y = l * d * c + u * h * p, this._z = l * h * p + u * d * c, this._w = l * h * c - u * d * p;
                break;
            case "ZYX":
                this._x = u * h * c - l * d * p, this._y = l * d * c + u * h * p, this._z = l * h * p - u * d * c, this._w = l * h * c + u * d * p;
                break;
            case "YZX":
                this._x = u * h * c + l * d * p, this._y = l * d * c + u * h * p, this._z = l * h * p - u * d * c, this._w = l * h * c - u * d * p;
                break;
            case "XZY":
                this._x = u * h * c - l * d * p, this._y = l * d * c - u * h * p, this._z = l * h * p + u * d * c, this._w = l * h * c + u * d * p;
                break;
            default:
                console.warn("THREE.Quaternion: .setFromEuler() encountered an unknown order: " + s);
        }
        return !1 !== e && this._onChangeCallback(), this;
    }
    setFromAxisAngle(t1, e) {
        const n = e / 2, i = Math.sin(n);
        return this._x = t1.x * i, this._y = t1.y * i, this._z = t1.z * i, this._w = Math.cos(n), this._onChangeCallback(), this;
    }
    setFromRotationMatrix(t1) {
        const e = t1.elements, n = e[0], i = e[4], r = e[8], s = e[1], a = e[5], o = e[9], l = e[2], h = e[6], c = e[10], u = n + a + c;
        if (u > 0) {
            const t1 = .5 / Math.sqrt(u + 1);
            this._w = .25 / t1, this._x = (h - o) * t1, this._y = (r - l) * t1, this._z = (s - i) * t1;
        } else if (n > a && n > c) {
            const t1 = 2 * Math.sqrt(1 + n - a - c);
            this._w = (h - o) / t1, this._x = .25 * t1, this._y = (i + s) / t1, this._z = (r + l) / t1;
        } else if (a > c) {
            const t1 = 2 * Math.sqrt(1 + a - n - c);
            this._w = (r - l) / t1, this._x = (i + s) / t1, this._y = .25 * t1, this._z = (o + h) / t1;
        } else {
            const t1 = 2 * Math.sqrt(1 + c - n - a);
            this._w = (s - i) / t1, this._x = (r + l) / t1, this._y = (o + h) / t1, this._z = .25 * t1;
        }
        return this._onChangeCallback(), this;
    }
    setFromUnitVectors(t1, e) {
        let n = t1.dot(e) + 1;
        return n < Number.EPSILON ? (n = 0, Math.abs(t1.x) > Math.abs(t1.z) ? (this._x = -t1.y, this._y = t1.x, this._z = 0, this._w = n) : (this._x = 0, this._y = -t1.z, this._z = t1.y, this._w = n)) : (this._x = t1.y * e.z - t1.z * e.y, this._y = t1.z * e.x - t1.x * e.z, this._z = t1.x * e.y - t1.y * e.x, this._w = n), this.normalize();
    }
    angleTo(t1) {
        return 2 * Math.acos(Math.abs($fd4eb456bcbd06f8$var$h(this.dot(t1), -1, 1)));
    }
    rotateTowards(t1, e) {
        const n = this.angleTo(t1);
        if (0 === n) return this;
        const i = Math.min(1, e / n);
        return this.slerp(t1, i), this;
    }
    identity() {
        return this.set(0, 0, 0, 1);
    }
    invert() {
        return this.conjugate();
    }
    conjugate() {
        return this._x *= -1, this._y *= -1, this._z *= -1, this._onChangeCallback(), this;
    }
    dot(t1) {
        return this._x * t1._x + this._y * t1._y + this._z * t1._z + this._w * t1._w;
    }
    lengthSq() {
        return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
    }
    length() {
        return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
    }
    normalize() {
        let t1 = this.length();
        return 0 === t1 ? (this._x = 0, this._y = 0, this._z = 0, this._w = 1) : (t1 = 1 / t1, this._x = this._x * t1, this._y = this._y * t1, this._z = this._z * t1, this._w = this._w * t1), this._onChangeCallback(), this;
    }
    multiply(t1, e) {
        return void 0 !== e ? (console.warn("THREE.Quaternion: .multiply() now only accepts one argument. Use .multiplyQuaternions( a, b ) instead."), this.multiplyQuaternions(t1, e)) : this.multiplyQuaternions(this, t1);
    }
    premultiply(t1) {
        return this.multiplyQuaternions(t1, this);
    }
    multiplyQuaternions(t1, e) {
        const n = t1._x, i = t1._y, r = t1._z, s = t1._w, a = e._x, o = e._y, l = e._z, h = e._w;
        return this._x = n * h + s * a + i * l - r * o, this._y = i * h + s * o + r * a - n * l, this._z = r * h + s * l + n * o - i * a, this._w = s * h - n * a - i * o - r * l, this._onChangeCallback(), this;
    }
    slerp(t1, e) {
        if (0 === e) return this;
        if (1 === e) return this.copy(t1);
        const n = this._x, i = this._y, r = this._z, s = this._w;
        let a = s * t1._w + n * t1._x + i * t1._y + r * t1._z;
        if (a < 0 ? (this._w = -t1._w, this._x = -t1._x, this._y = -t1._y, this._z = -t1._z, a = -a) : this.copy(t1), a >= 1) return this._w = s, this._x = n, this._y = i, this._z = r, this;
        const o = 1 - a * a;
        if (o <= Number.EPSILON) {
            const t1 = 1 - e;
            return this._w = t1 * s + e * this._w, this._x = t1 * n + e * this._x, this._y = t1 * i + e * this._y, this._z = t1 * r + e * this._z, this.normalize(), this._onChangeCallback(), this;
        }
        const l = Math.sqrt(o), h = Math.atan2(l, a), c = Math.sin((1 - e) * h) / l, u = Math.sin(e * h) / l;
        return this._w = s * c + this._w * u, this._x = n * c + this._x * u, this._y = i * c + this._y * u, this._z = r * c + this._z * u, this._onChangeCallback(), this;
    }
    slerpQuaternions(t1, e, n) {
        return this.copy(t1).slerp(e, n);
    }
    random() {
        const t1 = Math.random(), e = Math.sqrt(1 - t1), n = Math.sqrt(t1), i = 2 * Math.PI * Math.random(), r = 2 * Math.PI * Math.random();
        return this.set(e * Math.cos(i), n * Math.sin(r), n * Math.cos(r), e * Math.sin(i));
    }
    equals(t1) {
        return t1._x === this._x && t1._y === this._y && t1._z === this._z && t1._w === this._w;
    }
    fromArray(t1, e = 0) {
        return this._x = t1[e], this._y = t1[e + 1], this._z = t1[e + 2], this._w = t1[e + 3], this._onChangeCallback(), this;
    }
    toArray(t1 = [], e = 0) {
        return t1[e] = this._x, t1[e + 1] = this._y, t1[e + 2] = this._z, t1[e + 3] = this._w, t1;
    }
    fromBufferAttribute(t1, e) {
        return this._x = t1.getX(e), this._y = t1.getY(e), this._z = t1.getZ(e), this._w = t1.getW(e), this;
    }
    _onChange(t1) {
        return this._onChangeCallback = t1, this;
    }
    _onChangeCallback() {}
}
$fd4eb456bcbd06f8$var$H.prototype.isQuaternion = !0;
class $fd4eb456bcbd06f8$var$V {
    constructor(t1 = 0, e = 0, n = 0){
        this.x = t1, this.y = e, this.z = n;
    }
    set(t1, e, n) {
        return void 0 === n && (n = this.z), this.x = t1, this.y = e, this.z = n, this;
    }
    setScalar(t1) {
        return this.x = t1, this.y = t1, this.z = t1, this;
    }
    setX(t1) {
        return this.x = t1, this;
    }
    setY(t1) {
        return this.y = t1, this;
    }
    setZ(t1) {
        return this.z = t1, this;
    }
    setComponent(t1, e) {
        switch(t1){
            case 0:
                this.x = e;
                break;
            case 1:
                this.y = e;
                break;
            case 2:
                this.z = e;
                break;
            default:
                throw new Error("index is out of range: " + t1);
        }
        return this;
    }
    getComponent(t1) {
        switch(t1){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            default:
                throw new Error("index is out of range: " + t1);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z);
    }
    copy(t1) {
        return this.x = t1.x, this.y = t1.y, this.z = t1.z, this;
    }
    add(t1, e) {
        return void 0 !== e ? (console.warn("THREE.Vector3: .add() now only accepts one argument. Use .addVectors( a, b ) instead."), this.addVectors(t1, e)) : (this.x += t1.x, this.y += t1.y, this.z += t1.z, this);
    }
    addScalar(t1) {
        return this.x += t1, this.y += t1, this.z += t1, this;
    }
    addVectors(t1, e) {
        return this.x = t1.x + e.x, this.y = t1.y + e.y, this.z = t1.z + e.z, this;
    }
    addScaledVector(t1, e) {
        return this.x += t1.x * e, this.y += t1.y * e, this.z += t1.z * e, this;
    }
    sub(t1, e) {
        return void 0 !== e ? (console.warn("THREE.Vector3: .sub() now only accepts one argument. Use .subVectors( a, b ) instead."), this.subVectors(t1, e)) : (this.x -= t1.x, this.y -= t1.y, this.z -= t1.z, this);
    }
    subScalar(t1) {
        return this.x -= t1, this.y -= t1, this.z -= t1, this;
    }
    subVectors(t1, e) {
        return this.x = t1.x - e.x, this.y = t1.y - e.y, this.z = t1.z - e.z, this;
    }
    multiply(t1, e) {
        return void 0 !== e ? (console.warn("THREE.Vector3: .multiply() now only accepts one argument. Use .multiplyVectors( a, b ) instead."), this.multiplyVectors(t1, e)) : (this.x *= t1.x, this.y *= t1.y, this.z *= t1.z, this);
    }
    multiplyScalar(t1) {
        return this.x *= t1, this.y *= t1, this.z *= t1, this;
    }
    multiplyVectors(t1, e) {
        return this.x = t1.x * e.x, this.y = t1.y * e.y, this.z = t1.z * e.z, this;
    }
    applyEuler(t1) {
        return t1 && t1.isEuler || console.error("THREE.Vector3: .applyEuler() now expects an Euler rotation rather than a Vector3 and order."), this.applyQuaternion($fd4eb456bcbd06f8$var$W.setFromEuler(t1));
    }
    applyAxisAngle(t1, e) {
        return this.applyQuaternion($fd4eb456bcbd06f8$var$W.setFromAxisAngle(t1, e));
    }
    applyMatrix3(t1) {
        const e = this.x, n = this.y, i = this.z, r = t1.elements;
        return this.x = r[0] * e + r[3] * n + r[6] * i, this.y = r[1] * e + r[4] * n + r[7] * i, this.z = r[2] * e + r[5] * n + r[8] * i, this;
    }
    applyNormalMatrix(t1) {
        return this.applyMatrix3(t1).normalize();
    }
    applyMatrix4(t1) {
        const e = this.x, n = this.y, i = this.z, r = t1.elements, s = 1 / (r[3] * e + r[7] * n + r[11] * i + r[15]);
        return this.x = (r[0] * e + r[4] * n + r[8] * i + r[12]) * s, this.y = (r[1] * e + r[5] * n + r[9] * i + r[13]) * s, this.z = (r[2] * e + r[6] * n + r[10] * i + r[14]) * s, this;
    }
    applyQuaternion(t1) {
        const e = this.x, n = this.y, i = this.z, r = t1.x, s = t1.y, a = t1.z, o = t1.w, l = o * e + s * i - a * n, h = o * n + a * e - r * i, c = o * i + r * n - s * e, u = -r * e - s * n - a * i;
        return this.x = l * o + u * -r + h * -a - c * -s, this.y = h * o + u * -s + c * -r - l * -a, this.z = c * o + u * -a + l * -s - h * -r, this;
    }
    project(t1) {
        return this.applyMatrix4(t1.matrixWorldInverse).applyMatrix4(t1.projectionMatrix);
    }
    unproject(t1) {
        return this.applyMatrix4(t1.projectionMatrixInverse).applyMatrix4(t1.matrixWorld);
    }
    transformDirection(t1) {
        const e = this.x, n = this.y, i = this.z, r = t1.elements;
        return this.x = r[0] * e + r[4] * n + r[8] * i, this.y = r[1] * e + r[5] * n + r[9] * i, this.z = r[2] * e + r[6] * n + r[10] * i, this.normalize();
    }
    divide(t1) {
        return this.x /= t1.x, this.y /= t1.y, this.z /= t1.z, this;
    }
    divideScalar(t1) {
        return this.multiplyScalar(1 / t1);
    }
    min(t1) {
        return this.x = Math.min(this.x, t1.x), this.y = Math.min(this.y, t1.y), this.z = Math.min(this.z, t1.z), this;
    }
    max(t1) {
        return this.x = Math.max(this.x, t1.x), this.y = Math.max(this.y, t1.y), this.z = Math.max(this.z, t1.z), this;
    }
    clamp(t1, e) {
        return this.x = Math.max(t1.x, Math.min(e.x, this.x)), this.y = Math.max(t1.y, Math.min(e.y, this.y)), this.z = Math.max(t1.z, Math.min(e.z, this.z)), this;
    }
    clampScalar(t1, e) {
        return this.x = Math.max(t1, Math.min(e, this.x)), this.y = Math.max(t1, Math.min(e, this.y)), this.z = Math.max(t1, Math.min(e, this.z)), this;
    }
    clampLength(t1, e) {
        const n = this.length();
        return this.divideScalar(n || 1).multiplyScalar(Math.max(t1, Math.min(e, n)));
    }
    floor() {
        return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this;
    }
    ceil() {
        return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this;
    }
    round() {
        return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this;
    }
    roundToZero() {
        return this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x), this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y), this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z), this;
    }
    negate() {
        return this.x = -this.x, this.y = -this.y, this.z = -this.z, this;
    }
    dot(t1) {
        return this.x * t1.x + this.y * t1.y + this.z * t1.z;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(t1) {
        return this.normalize().multiplyScalar(t1);
    }
    lerp(t1, e) {
        return this.x += (t1.x - this.x) * e, this.y += (t1.y - this.y) * e, this.z += (t1.z - this.z) * e, this;
    }
    lerpVectors(t1, e, n) {
        return this.x = t1.x + (e.x - t1.x) * n, this.y = t1.y + (e.y - t1.y) * n, this.z = t1.z + (e.z - t1.z) * n, this;
    }
    cross(t1, e) {
        return void 0 !== e ? (console.warn("THREE.Vector3: .cross() now only accepts one argument. Use .crossVectors( a, b ) instead."), this.crossVectors(t1, e)) : this.crossVectors(this, t1);
    }
    crossVectors(t1, e) {
        const n = t1.x, i = t1.y, r = t1.z, s = e.x, a = e.y, o = e.z;
        return this.x = i * o - r * a, this.y = r * s - n * o, this.z = n * a - i * s, this;
    }
    projectOnVector(t1) {
        const e = t1.lengthSq();
        if (0 === e) return this.set(0, 0, 0);
        const n = t1.dot(this) / e;
        return this.copy(t1).multiplyScalar(n);
    }
    projectOnPlane(t1) {
        return $fd4eb456bcbd06f8$var$G.copy(this).projectOnVector(t1), this.sub($fd4eb456bcbd06f8$var$G);
    }
    reflect(t1) {
        return this.sub($fd4eb456bcbd06f8$var$G.copy(t1).multiplyScalar(2 * this.dot(t1)));
    }
    angleTo(t1) {
        const e = Math.sqrt(this.lengthSq() * t1.lengthSq());
        if (0 === e) return Math.PI / 2;
        const n = this.dot(t1) / e;
        return Math.acos($fd4eb456bcbd06f8$var$h(n, -1, 1));
    }
    distanceTo(t1) {
        return Math.sqrt(this.distanceToSquared(t1));
    }
    distanceToSquared(t1) {
        const e = this.x - t1.x, n = this.y - t1.y, i = this.z - t1.z;
        return e * e + n * n + i * i;
    }
    manhattanDistanceTo(t1) {
        return Math.abs(this.x - t1.x) + Math.abs(this.y - t1.y) + Math.abs(this.z - t1.z);
    }
    setFromSpherical(t1) {
        return this.setFromSphericalCoords(t1.radius, t1.phi, t1.theta);
    }
    setFromSphericalCoords(t1, e, n) {
        const i = Math.sin(e) * t1;
        return this.x = i * Math.sin(n), this.y = Math.cos(e) * t1, this.z = i * Math.cos(n), this;
    }
    setFromCylindrical(t1) {
        return this.setFromCylindricalCoords(t1.radius, t1.theta, t1.y);
    }
    setFromCylindricalCoords(t1, e, n) {
        return this.x = t1 * Math.sin(e), this.y = n, this.z = t1 * Math.cos(e), this;
    }
    setFromMatrixPosition(t1) {
        const e = t1.elements;
        return this.x = e[12], this.y = e[13], this.z = e[14], this;
    }
    setFromMatrixScale(t1) {
        const e = this.setFromMatrixColumn(t1, 0).length(), n = this.setFromMatrixColumn(t1, 1).length(), i = this.setFromMatrixColumn(t1, 2).length();
        return this.x = e, this.y = n, this.z = i, this;
    }
    setFromMatrixColumn(t1, e) {
        return this.fromArray(t1.elements, 4 * e);
    }
    setFromMatrix3Column(t1, e) {
        return this.fromArray(t1.elements, 3 * e);
    }
    setFromEuler(t1) {
        return this.x = t1._x, this.y = t1._y, this.z = t1._z, this;
    }
    equals(t1) {
        return t1.x === this.x && t1.y === this.y && t1.z === this.z;
    }
    fromArray(t1, e = 0) {
        return this.x = t1[e], this.y = t1[e + 1], this.z = t1[e + 2], this;
    }
    toArray(t1 = [], e = 0) {
        return t1[e] = this.x, t1[e + 1] = this.y, t1[e + 2] = this.z, t1;
    }
    fromBufferAttribute(t1, e, n) {
        return void 0 !== n && console.warn("THREE.Vector3: offset has been removed from .fromBufferAttribute()."), this.x = t1.getX(e), this.y = t1.getY(e), this.z = t1.getZ(e), this;
    }
    random() {
        return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this;
    }
    randomDirection() {
        const t1 = 2 * (Math.random() - .5), e = Math.random() * Math.PI * 2, n = Math.sqrt(1 - t1 ** 2);
        return this.x = n * Math.cos(e), this.y = n * Math.sin(e), this.z = t1, this;
    }
    *[Symbol.iterator]() {
        yield this.x, yield this.y, yield this.z;
    }
}
$fd4eb456bcbd06f8$var$V.prototype.isVector3 = !0;
const $fd4eb456bcbd06f8$var$G = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$W = new $fd4eb456bcbd06f8$var$H;
class $fd4eb456bcbd06f8$var$j {
    constructor(t1 = new $fd4eb456bcbd06f8$var$V(1 / 0, 1 / 0, 1 / 0), e = new $fd4eb456bcbd06f8$var$V(-1 / 0, -1 / 0, -1 / 0)){
        this.min = t1, this.max = e;
    }
    set(t1, e) {
        return this.min.copy(t1), this.max.copy(e), this;
    }
    setFromArray(t1) {
        let e = 1 / 0, n = 1 / 0, i = 1 / 0, r = -1 / 0, s = -1 / 0, a = -1 / 0;
        for(let o = 0, l = t1.length; o < l; o += 3){
            const l = t1[o], h = t1[o + 1], c = t1[o + 2];
            l < e && (e = l), h < n && (n = h), c < i && (i = c), l > r && (r = l), h > s && (s = h), c > a && (a = c);
        }
        return this.min.set(e, n, i), this.max.set(r, s, a), this;
    }
    setFromBufferAttribute(t1) {
        let e = 1 / 0, n = 1 / 0, i = 1 / 0, r = -1 / 0, s = -1 / 0, a = -1 / 0;
        for(let o = 0, l = t1.count; o < l; o++){
            const l = t1.getX(o), h = t1.getY(o), c = t1.getZ(o);
            l < e && (e = l), h < n && (n = h), c < i && (i = c), l > r && (r = l), h > s && (s = h), c > a && (a = c);
        }
        return this.min.set(e, n, i), this.max.set(r, s, a), this;
    }
    setFromPoints(t1) {
        this.makeEmpty();
        for(let e = 0, n = t1.length; e < n; e++)this.expandByPoint(t1[e]);
        return this;
    }
    setFromCenterAndSize(t1, e) {
        const n = $fd4eb456bcbd06f8$var$X.copy(e).multiplyScalar(.5);
        return this.min.copy(t1).sub(n), this.max.copy(t1).add(n), this;
    }
    setFromObject(t1, e = !1) {
        return this.makeEmpty(), this.expandByObject(t1, e);
    }
    clone() {
        return (new this.constructor).copy(this);
    }
    copy(t1) {
        return this.min.copy(t1.min), this.max.copy(t1.max), this;
    }
    makeEmpty() {
        return this.min.x = this.min.y = this.min.z = 1 / 0, this.max.x = this.max.y = this.max.z = -1 / 0, this;
    }
    isEmpty() {
        return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
    }
    getCenter(t1) {
        return this.isEmpty() ? t1.set(0, 0, 0) : t1.addVectors(this.min, this.max).multiplyScalar(.5);
    }
    getSize(t1) {
        return this.isEmpty() ? t1.set(0, 0, 0) : t1.subVectors(this.max, this.min);
    }
    expandByPoint(t1) {
        return this.min.min(t1), this.max.max(t1), this;
    }
    expandByVector(t1) {
        return this.min.sub(t1), this.max.add(t1), this;
    }
    expandByScalar(t1) {
        return this.min.addScalar(-t1), this.max.addScalar(t1), this;
    }
    expandByObject(t1, e = !1) {
        t1.updateWorldMatrix(!1, !1);
        const n = t1.geometry;
        if (void 0 !== n) {
            if (e && null != n.attributes && void 0 !== n.attributes.position) {
                const e = n.attributes.position;
                for(let n = 0, i = e.count; n < i; n++)$fd4eb456bcbd06f8$var$X.fromBufferAttribute(e, n).applyMatrix4(t1.matrixWorld), this.expandByPoint($fd4eb456bcbd06f8$var$X);
            } else null === n.boundingBox && n.computeBoundingBox(), $fd4eb456bcbd06f8$var$$.copy(n.boundingBox), $fd4eb456bcbd06f8$var$$.applyMatrix4(t1.matrixWorld), this.union($fd4eb456bcbd06f8$var$$);
        }
        const i = t1.children;
        for(let t1 = 0, n = i.length; t1 < n; t1++)this.expandByObject(i[t1], e);
        return this;
    }
    containsPoint(t1) {
        return !(t1.x < this.min.x || t1.x > this.max.x || t1.y < this.min.y || t1.y > this.max.y || t1.z < this.min.z || t1.z > this.max.z);
    }
    containsBox(t1) {
        return this.min.x <= t1.min.x && t1.max.x <= this.max.x && this.min.y <= t1.min.y && t1.max.y <= this.max.y && this.min.z <= t1.min.z && t1.max.z <= this.max.z;
    }
    getParameter(t1, e) {
        return e.set((t1.x - this.min.x) / (this.max.x - this.min.x), (t1.y - this.min.y) / (this.max.y - this.min.y), (t1.z - this.min.z) / (this.max.z - this.min.z));
    }
    intersectsBox(t1) {
        return !(t1.max.x < this.min.x || t1.min.x > this.max.x || t1.max.y < this.min.y || t1.min.y > this.max.y || t1.max.z < this.min.z || t1.min.z > this.max.z);
    }
    intersectsSphere(t1) {
        return this.clampPoint(t1.center, $fd4eb456bcbd06f8$var$X), $fd4eb456bcbd06f8$var$X.distanceToSquared(t1.center) <= t1.radius * t1.radius;
    }
    intersectsPlane(t1) {
        let e, n;
        return t1.normal.x > 0 ? (e = t1.normal.x * this.min.x, n = t1.normal.x * this.max.x) : (e = t1.normal.x * this.max.x, n = t1.normal.x * this.min.x), t1.normal.y > 0 ? (e += t1.normal.y * this.min.y, n += t1.normal.y * this.max.y) : (e += t1.normal.y * this.max.y, n += t1.normal.y * this.min.y), t1.normal.z > 0 ? (e += t1.normal.z * this.min.z, n += t1.normal.z * this.max.z) : (e += t1.normal.z * this.max.z, n += t1.normal.z * this.min.z), e <= -t1.constant && n >= -t1.constant;
    }
    intersectsTriangle(t1) {
        if (this.isEmpty()) return !1;
        this.getCenter($fd4eb456bcbd06f8$var$et), $fd4eb456bcbd06f8$var$nt.subVectors(this.max, $fd4eb456bcbd06f8$var$et), $fd4eb456bcbd06f8$var$Y.subVectors(t1.a, $fd4eb456bcbd06f8$var$et), $fd4eb456bcbd06f8$var$J.subVectors(t1.b, $fd4eb456bcbd06f8$var$et), $fd4eb456bcbd06f8$var$K.subVectors(t1.c, $fd4eb456bcbd06f8$var$et), $fd4eb456bcbd06f8$var$Z.subVectors($fd4eb456bcbd06f8$var$J, $fd4eb456bcbd06f8$var$Y), $fd4eb456bcbd06f8$var$Q.subVectors($fd4eb456bcbd06f8$var$K, $fd4eb456bcbd06f8$var$J), $fd4eb456bcbd06f8$var$tt.subVectors($fd4eb456bcbd06f8$var$Y, $fd4eb456bcbd06f8$var$K);
        let e = [
            0,
            -$fd4eb456bcbd06f8$var$Z.z,
            $fd4eb456bcbd06f8$var$Z.y,
            0,
            -$fd4eb456bcbd06f8$var$Q.z,
            $fd4eb456bcbd06f8$var$Q.y,
            0,
            -$fd4eb456bcbd06f8$var$tt.z,
            $fd4eb456bcbd06f8$var$tt.y,
            $fd4eb456bcbd06f8$var$Z.z,
            0,
            -$fd4eb456bcbd06f8$var$Z.x,
            $fd4eb456bcbd06f8$var$Q.z,
            0,
            -$fd4eb456bcbd06f8$var$Q.x,
            $fd4eb456bcbd06f8$var$tt.z,
            0,
            -$fd4eb456bcbd06f8$var$tt.x,
            -$fd4eb456bcbd06f8$var$Z.y,
            $fd4eb456bcbd06f8$var$Z.x,
            0,
            -$fd4eb456bcbd06f8$var$Q.y,
            $fd4eb456bcbd06f8$var$Q.x,
            0,
            -$fd4eb456bcbd06f8$var$tt.y,
            $fd4eb456bcbd06f8$var$tt.x,
            0
        ];
        return !!$fd4eb456bcbd06f8$var$st(e, $fd4eb456bcbd06f8$var$Y, $fd4eb456bcbd06f8$var$J, $fd4eb456bcbd06f8$var$K, $fd4eb456bcbd06f8$var$nt) && (e = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ], !!$fd4eb456bcbd06f8$var$st(e, $fd4eb456bcbd06f8$var$Y, $fd4eb456bcbd06f8$var$J, $fd4eb456bcbd06f8$var$K, $fd4eb456bcbd06f8$var$nt) && ($fd4eb456bcbd06f8$var$it.crossVectors($fd4eb456bcbd06f8$var$Z, $fd4eb456bcbd06f8$var$Q), e = [
            $fd4eb456bcbd06f8$var$it.x,
            $fd4eb456bcbd06f8$var$it.y,
            $fd4eb456bcbd06f8$var$it.z
        ], $fd4eb456bcbd06f8$var$st(e, $fd4eb456bcbd06f8$var$Y, $fd4eb456bcbd06f8$var$J, $fd4eb456bcbd06f8$var$K, $fd4eb456bcbd06f8$var$nt)));
    }
    clampPoint(t1, e) {
        return e.copy(t1).clamp(this.min, this.max);
    }
    distanceToPoint(t1) {
        return $fd4eb456bcbd06f8$var$X.copy(t1).clamp(this.min, this.max).sub(t1).length();
    }
    getBoundingSphere(t1) {
        return this.getCenter(t1.center), t1.radius = .5 * this.getSize($fd4eb456bcbd06f8$var$X).length(), t1;
    }
    intersect(t1) {
        return this.min.max(t1.min), this.max.min(t1.max), this.isEmpty() && this.makeEmpty(), this;
    }
    union(t1) {
        return this.min.min(t1.min), this.max.max(t1.max), this;
    }
    applyMatrix4(t1) {
        return this.isEmpty() || ($fd4eb456bcbd06f8$var$q[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(t1), $fd4eb456bcbd06f8$var$q[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(t1), $fd4eb456bcbd06f8$var$q[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(t1), $fd4eb456bcbd06f8$var$q[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(t1), $fd4eb456bcbd06f8$var$q[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(t1), $fd4eb456bcbd06f8$var$q[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(t1), $fd4eb456bcbd06f8$var$q[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(t1), $fd4eb456bcbd06f8$var$q[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(t1), this.setFromPoints($fd4eb456bcbd06f8$var$q)), this;
    }
    translate(t1) {
        return this.min.add(t1), this.max.add(t1), this;
    }
    equals(t1) {
        return t1.min.equals(this.min) && t1.max.equals(this.max);
    }
}
$fd4eb456bcbd06f8$var$j.prototype.isBox3 = !0;
const $fd4eb456bcbd06f8$var$q = [
    new $fd4eb456bcbd06f8$var$V,
    new $fd4eb456bcbd06f8$var$V,
    new $fd4eb456bcbd06f8$var$V,
    new $fd4eb456bcbd06f8$var$V,
    new $fd4eb456bcbd06f8$var$V,
    new $fd4eb456bcbd06f8$var$V,
    new $fd4eb456bcbd06f8$var$V,
    new $fd4eb456bcbd06f8$var$V
], $fd4eb456bcbd06f8$var$X = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$$ = new $fd4eb456bcbd06f8$var$j, $fd4eb456bcbd06f8$var$Y = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$J = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$K = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$Z = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$Q = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$tt = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$et = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$nt = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$it = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$rt = new $fd4eb456bcbd06f8$var$V;
function $fd4eb456bcbd06f8$var$st(t1, e, n, i, r) {
    for(let s = 0, a = t1.length - 3; s <= a; s += 3){
        $fd4eb456bcbd06f8$var$rt.fromArray(t1, s);
        const a = r.x * Math.abs($fd4eb456bcbd06f8$var$rt.x) + r.y * Math.abs($fd4eb456bcbd06f8$var$rt.y) + r.z * Math.abs($fd4eb456bcbd06f8$var$rt.z), o = e.dot($fd4eb456bcbd06f8$var$rt), l = n.dot($fd4eb456bcbd06f8$var$rt), h = i.dot($fd4eb456bcbd06f8$var$rt);
        if (Math.max(-Math.max(o, l, h), Math.min(o, l, h)) > a) return !1;
    }
    return !0;
}
const $fd4eb456bcbd06f8$var$at = new $fd4eb456bcbd06f8$var$j, $fd4eb456bcbd06f8$var$ot = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$lt = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$ht = new $fd4eb456bcbd06f8$var$V;
class $fd4eb456bcbd06f8$var$ct {
    constructor(t1 = new $fd4eb456bcbd06f8$var$V, e = -1){
        this.center = t1, this.radius = e;
    }
    set(t1, e) {
        return this.center.copy(t1), this.radius = e, this;
    }
    setFromPoints(t1, e) {
        const n = this.center;
        void 0 !== e ? n.copy(e) : $fd4eb456bcbd06f8$var$at.setFromPoints(t1).getCenter(n);
        let i = 0;
        for(let e = 0, r = t1.length; e < r; e++)i = Math.max(i, n.distanceToSquared(t1[e]));
        return this.radius = Math.sqrt(i), this;
    }
    copy(t1) {
        return this.center.copy(t1.center), this.radius = t1.radius, this;
    }
    isEmpty() {
        return this.radius < 0;
    }
    makeEmpty() {
        return this.center.set(0, 0, 0), this.radius = -1, this;
    }
    containsPoint(t1) {
        return t1.distanceToSquared(this.center) <= this.radius * this.radius;
    }
    distanceToPoint(t1) {
        return t1.distanceTo(this.center) - this.radius;
    }
    intersectsSphere(t1) {
        const e = this.radius + t1.radius;
        return t1.center.distanceToSquared(this.center) <= e * e;
    }
    intersectsBox(t1) {
        return t1.intersectsSphere(this);
    }
    intersectsPlane(t1) {
        return Math.abs(t1.distanceToPoint(this.center)) <= this.radius;
    }
    clampPoint(t1, e) {
        const n = this.center.distanceToSquared(t1);
        return e.copy(t1), n > this.radius * this.radius && (e.sub(this.center).normalize(), e.multiplyScalar(this.radius).add(this.center)), e;
    }
    getBoundingBox(t1) {
        return this.isEmpty() ? (t1.makeEmpty(), t1) : (t1.set(this.center, this.center), t1.expandByScalar(this.radius), t1);
    }
    applyMatrix4(t1) {
        return this.center.applyMatrix4(t1), this.radius = this.radius * t1.getMaxScaleOnAxis(), this;
    }
    translate(t1) {
        return this.center.add(t1), this;
    }
    expandByPoint(t1) {
        $fd4eb456bcbd06f8$var$ht.subVectors(t1, this.center);
        const e = $fd4eb456bcbd06f8$var$ht.lengthSq();
        if (e > this.radius * this.radius) {
            const t1 = Math.sqrt(e), n = .5 * (t1 - this.radius);
            this.center.add($fd4eb456bcbd06f8$var$ht.multiplyScalar(n / t1)), this.radius += n;
        }
        return this;
    }
    union(t1) {
        return !0 === this.center.equals(t1.center) ? $fd4eb456bcbd06f8$var$lt.set(0, 0, 1).multiplyScalar(t1.radius) : $fd4eb456bcbd06f8$var$lt.subVectors(t1.center, this.center).normalize().multiplyScalar(t1.radius), this.expandByPoint($fd4eb456bcbd06f8$var$ot.copy(t1.center).add($fd4eb456bcbd06f8$var$lt)), this.expandByPoint($fd4eb456bcbd06f8$var$ot.copy(t1.center).sub($fd4eb456bcbd06f8$var$lt)), this;
    }
    equals(t1) {
        return t1.center.equals(this.center) && t1.radius === this.radius;
    }
    clone() {
        return (new this.constructor).copy(this);
    }
}
const $fd4eb456bcbd06f8$var$ut = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$dt = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$pt = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$mt = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$ft = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$gt = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$vt = new $fd4eb456bcbd06f8$var$V;
class $fd4eb456bcbd06f8$var$yt {
    constructor(t1 = new $fd4eb456bcbd06f8$var$V, e = new $fd4eb456bcbd06f8$var$V(0, 0, -1)){
        this.origin = t1, this.direction = e;
    }
    set(t1, e) {
        return this.origin.copy(t1), this.direction.copy(e), this;
    }
    copy(t1) {
        return this.origin.copy(t1.origin), this.direction.copy(t1.direction), this;
    }
    at(t1, e) {
        return e.copy(this.direction).multiplyScalar(t1).add(this.origin);
    }
    lookAt(t1) {
        return this.direction.copy(t1).sub(this.origin).normalize(), this;
    }
    recast(t1) {
        return this.origin.copy(this.at(t1, $fd4eb456bcbd06f8$var$ut)), this;
    }
    closestPointToPoint(t1, e) {
        e.subVectors(t1, this.origin);
        const n = e.dot(this.direction);
        return n < 0 ? e.copy(this.origin) : e.copy(this.direction).multiplyScalar(n).add(this.origin);
    }
    distanceToPoint(t1) {
        return Math.sqrt(this.distanceSqToPoint(t1));
    }
    distanceSqToPoint(t1) {
        const e = $fd4eb456bcbd06f8$var$ut.subVectors(t1, this.origin).dot(this.direction);
        return e < 0 ? this.origin.distanceToSquared(t1) : ($fd4eb456bcbd06f8$var$ut.copy(this.direction).multiplyScalar(e).add(this.origin), $fd4eb456bcbd06f8$var$ut.distanceToSquared(t1));
    }
    distanceSqToSegment(t1, e, n, i) {
        $fd4eb456bcbd06f8$var$dt.copy(t1).add(e).multiplyScalar(.5), $fd4eb456bcbd06f8$var$pt.copy(e).sub(t1).normalize(), $fd4eb456bcbd06f8$var$mt.copy(this.origin).sub($fd4eb456bcbd06f8$var$dt);
        const r = .5 * t1.distanceTo(e), s = -this.direction.dot($fd4eb456bcbd06f8$var$pt), a = $fd4eb456bcbd06f8$var$mt.dot(this.direction), o = -$fd4eb456bcbd06f8$var$mt.dot($fd4eb456bcbd06f8$var$pt), l = $fd4eb456bcbd06f8$var$mt.lengthSq(), h = Math.abs(1 - s * s);
        let c, u, d, p;
        if (h > 0) {
            if (c = s * o - a, u = s * a - o, p = r * h, c >= 0) {
                if (u >= -p) {
                    if (u <= p) {
                        const t1 = 1 / h;
                        c *= t1, u *= t1, d = c * (c + s * u + 2 * a) + u * (s * c + u + 2 * o) + l;
                    } else u = r, c = Math.max(0, -(s * u + a)), d = -c * c + u * (u + 2 * o) + l;
                } else u = -r, c = Math.max(0, -(s * u + a)), d = -c * c + u * (u + 2 * o) + l;
            } else u <= -p ? (c = Math.max(0, -(-s * r + a)), u = c > 0 ? -r : Math.min(Math.max(-r, -o), r), d = -c * c + u * (u + 2 * o) + l) : u <= p ? (c = 0, u = Math.min(Math.max(-r, -o), r), d = u * (u + 2 * o) + l) : (c = Math.max(0, -(s * r + a)), u = c > 0 ? r : Math.min(Math.max(-r, -o), r), d = -c * c + u * (u + 2 * o) + l);
        } else u = s > 0 ? -r : r, c = Math.max(0, -(s * u + a)), d = -c * c + u * (u + 2 * o) + l;
        return n && n.copy(this.direction).multiplyScalar(c).add(this.origin), i && i.copy($fd4eb456bcbd06f8$var$pt).multiplyScalar(u).add($fd4eb456bcbd06f8$var$dt), d;
    }
    intersectSphere(t1, e) {
        $fd4eb456bcbd06f8$var$ut.subVectors(t1.center, this.origin);
        const n = $fd4eb456bcbd06f8$var$ut.dot(this.direction), i = $fd4eb456bcbd06f8$var$ut.dot($fd4eb456bcbd06f8$var$ut) - n * n, r = t1.radius * t1.radius;
        if (i > r) return null;
        const s = Math.sqrt(r - i), a = n - s, o = n + s;
        return a < 0 && o < 0 ? null : a < 0 ? this.at(o, e) : this.at(a, e);
    }
    intersectsSphere(t1) {
        return this.distanceSqToPoint(t1.center) <= t1.radius * t1.radius;
    }
    distanceToPlane(t1) {
        const e = t1.normal.dot(this.direction);
        if (0 === e) return 0 === t1.distanceToPoint(this.origin) ? 0 : null;
        const n = -(this.origin.dot(t1.normal) + t1.constant) / e;
        return n >= 0 ? n : null;
    }
    intersectPlane(t1, e) {
        const n = this.distanceToPlane(t1);
        return null === n ? null : this.at(n, e);
    }
    intersectsPlane(t1) {
        const e = t1.distanceToPoint(this.origin);
        if (0 === e) return !0;
        return t1.normal.dot(this.direction) * e < 0;
    }
    intersectBox(t1, e) {
        let n, i, r, s, a, o;
        const l = 1 / this.direction.x, h = 1 / this.direction.y, c = 1 / this.direction.z, u = this.origin;
        return l >= 0 ? (n = (t1.min.x - u.x) * l, i = (t1.max.x - u.x) * l) : (n = (t1.max.x - u.x) * l, i = (t1.min.x - u.x) * l), h >= 0 ? (r = (t1.min.y - u.y) * h, s = (t1.max.y - u.y) * h) : (r = (t1.max.y - u.y) * h, s = (t1.min.y - u.y) * h), n > s || r > i ? null : ((r > n || n != n) && (n = r), (s < i || i != i) && (i = s), c >= 0 ? (a = (t1.min.z - u.z) * c, o = (t1.max.z - u.z) * c) : (a = (t1.max.z - u.z) * c, o = (t1.min.z - u.z) * c), n > o || a > i ? null : ((a > n || n != n) && (n = a), (o < i || i != i) && (i = o), i < 0 ? null : this.at(n >= 0 ? n : i, e)));
    }
    intersectsBox(t1) {
        return null !== this.intersectBox(t1, $fd4eb456bcbd06f8$var$ut);
    }
    intersectTriangle(t1, e, n, i, r) {
        $fd4eb456bcbd06f8$var$ft.subVectors(e, t1), $fd4eb456bcbd06f8$var$gt.subVectors(n, t1), $fd4eb456bcbd06f8$var$vt.crossVectors($fd4eb456bcbd06f8$var$ft, $fd4eb456bcbd06f8$var$gt);
        let s, a = this.direction.dot($fd4eb456bcbd06f8$var$vt);
        if (a > 0) {
            if (i) return null;
            s = 1;
        } else {
            if (!(a < 0)) return null;
            s = -1, a = -a;
        }
        $fd4eb456bcbd06f8$var$mt.subVectors(this.origin, t1);
        const o = s * this.direction.dot($fd4eb456bcbd06f8$var$gt.crossVectors($fd4eb456bcbd06f8$var$mt, $fd4eb456bcbd06f8$var$gt));
        if (o < 0) return null;
        const l = s * this.direction.dot($fd4eb456bcbd06f8$var$ft.cross($fd4eb456bcbd06f8$var$mt));
        if (l < 0) return null;
        if (o + l > a) return null;
        const h = -s * $fd4eb456bcbd06f8$var$mt.dot($fd4eb456bcbd06f8$var$vt);
        return h < 0 ? null : this.at(h / a, r);
    }
    applyMatrix4(t1) {
        return this.origin.applyMatrix4(t1), this.direction.transformDirection(t1), this;
    }
    equals(t1) {
        return t1.origin.equals(this.origin) && t1.direction.equals(this.direction);
    }
    clone() {
        return (new this.constructor).copy(this);
    }
}
class $fd4eb456bcbd06f8$var$xt {
    constructor(){
        this.elements = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ], arguments.length > 0 && console.error("THREE.Matrix4: the constructor no longer reads arguments. use .set() instead.");
    }
    set(t1, e, n, i, r, s, a, o, l, h, c, u, d, p, m, f) {
        const g = this.elements;
        return g[0] = t1, g[4] = e, g[8] = n, g[12] = i, g[1] = r, g[5] = s, g[9] = a, g[13] = o, g[2] = l, g[6] = h, g[10] = c, g[14] = u, g[3] = d, g[7] = p, g[11] = m, g[15] = f, this;
    }
    identity() {
        return this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
    }
    clone() {
        return (new $fd4eb456bcbd06f8$var$xt).fromArray(this.elements);
    }
    copy(t1) {
        const e = this.elements, n = t1.elements;
        return e[0] = n[0], e[1] = n[1], e[2] = n[2], e[3] = n[3], e[4] = n[4], e[5] = n[5], e[6] = n[6], e[7] = n[7], e[8] = n[8], e[9] = n[9], e[10] = n[10], e[11] = n[11], e[12] = n[12], e[13] = n[13], e[14] = n[14], e[15] = n[15], this;
    }
    copyPosition(t1) {
        const e = this.elements, n = t1.elements;
        return e[12] = n[12], e[13] = n[13], e[14] = n[14], this;
    }
    setFromMatrix3(t1) {
        const e = t1.elements;
        return this.set(e[0], e[3], e[6], 0, e[1], e[4], e[7], 0, e[2], e[5], e[8], 0, 0, 0, 0, 1), this;
    }
    extractBasis(t1, e, n) {
        return t1.setFromMatrixColumn(this, 0), e.setFromMatrixColumn(this, 1), n.setFromMatrixColumn(this, 2), this;
    }
    makeBasis(t1, e, n) {
        return this.set(t1.x, e.x, n.x, 0, t1.y, e.y, n.y, 0, t1.z, e.z, n.z, 0, 0, 0, 0, 1), this;
    }
    extractRotation(t1) {
        const e = this.elements, n = t1.elements, i = 1 / $fd4eb456bcbd06f8$var$bt.setFromMatrixColumn(t1, 0).length(), r = 1 / $fd4eb456bcbd06f8$var$bt.setFromMatrixColumn(t1, 1).length(), s = 1 / $fd4eb456bcbd06f8$var$bt.setFromMatrixColumn(t1, 2).length();
        return e[0] = n[0] * i, e[1] = n[1] * i, e[2] = n[2] * i, e[3] = 0, e[4] = n[4] * r, e[5] = n[5] * r, e[6] = n[6] * r, e[7] = 0, e[8] = n[8] * s, e[9] = n[9] * s, e[10] = n[10] * s, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, this;
    }
    makeRotationFromEuler(t1) {
        t1 && t1.isEuler || console.error("THREE.Matrix4: .makeRotationFromEuler() now expects a Euler rotation rather than a Vector3 and order.");
        const e = this.elements, n = t1.x, i = t1.y, r = t1.z, s = Math.cos(n), a = Math.sin(n), o = Math.cos(i), l = Math.sin(i), h = Math.cos(r), c = Math.sin(r);
        if ("XYZ" === t1.order) {
            const t1 = s * h, n = s * c, i = a * h, r = a * c;
            e[0] = o * h, e[4] = -o * c, e[8] = l, e[1] = n + i * l, e[5] = t1 - r * l, e[9] = -a * o, e[2] = r - t1 * l, e[6] = i + n * l, e[10] = s * o;
        } else if ("YXZ" === t1.order) {
            const t1 = o * h, n = o * c, i = l * h, r = l * c;
            e[0] = t1 + r * a, e[4] = i * a - n, e[8] = s * l, e[1] = s * c, e[5] = s * h, e[9] = -a, e[2] = n * a - i, e[6] = r + t1 * a, e[10] = s * o;
        } else if ("ZXY" === t1.order) {
            const t1 = o * h, n = o * c, i = l * h, r = l * c;
            e[0] = t1 - r * a, e[4] = -s * c, e[8] = i + n * a, e[1] = n + i * a, e[5] = s * h, e[9] = r - t1 * a, e[2] = -s * l, e[6] = a, e[10] = s * o;
        } else if ("ZYX" === t1.order) {
            const t1 = s * h, n = s * c, i = a * h, r = a * c;
            e[0] = o * h, e[4] = i * l - n, e[8] = t1 * l + r, e[1] = o * c, e[5] = r * l + t1, e[9] = n * l - i, e[2] = -l, e[6] = a * o, e[10] = s * o;
        } else if ("YZX" === t1.order) {
            const t1 = s * o, n = s * l, i = a * o, r = a * l;
            e[0] = o * h, e[4] = r - t1 * c, e[8] = i * c + n, e[1] = c, e[5] = s * h, e[9] = -a * h, e[2] = -l * h, e[6] = n * c + i, e[10] = t1 - r * c;
        } else if ("XZY" === t1.order) {
            const t1 = s * o, n = s * l, i = a * o, r = a * l;
            e[0] = o * h, e[4] = -c, e[8] = l * h, e[1] = t1 * c + r, e[5] = s * h, e[9] = n * c - i, e[2] = i * c - n, e[6] = a * h, e[10] = r * c + t1;
        }
        return e[3] = 0, e[7] = 0, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, this;
    }
    makeRotationFromQuaternion(t1) {
        return this.compose($fd4eb456bcbd06f8$var$wt, t1, $fd4eb456bcbd06f8$var$Mt);
    }
    lookAt(t1, e, n) {
        const i = this.elements;
        return $fd4eb456bcbd06f8$var$Et.subVectors(t1, e), 0 === $fd4eb456bcbd06f8$var$Et.lengthSq() && ($fd4eb456bcbd06f8$var$Et.z = 1), $fd4eb456bcbd06f8$var$Et.normalize(), $fd4eb456bcbd06f8$var$St.crossVectors(n, $fd4eb456bcbd06f8$var$Et), 0 === $fd4eb456bcbd06f8$var$St.lengthSq() && (1 === Math.abs(n.z) ? $fd4eb456bcbd06f8$var$Et.x += 1e-4 : $fd4eb456bcbd06f8$var$Et.z += 1e-4, $fd4eb456bcbd06f8$var$Et.normalize(), $fd4eb456bcbd06f8$var$St.crossVectors(n, $fd4eb456bcbd06f8$var$Et)), $fd4eb456bcbd06f8$var$St.normalize(), $fd4eb456bcbd06f8$var$Tt.crossVectors($fd4eb456bcbd06f8$var$Et, $fd4eb456bcbd06f8$var$St), i[0] = $fd4eb456bcbd06f8$var$St.x, i[4] = $fd4eb456bcbd06f8$var$Tt.x, i[8] = $fd4eb456bcbd06f8$var$Et.x, i[1] = $fd4eb456bcbd06f8$var$St.y, i[5] = $fd4eb456bcbd06f8$var$Tt.y, i[9] = $fd4eb456bcbd06f8$var$Et.y, i[2] = $fd4eb456bcbd06f8$var$St.z, i[6] = $fd4eb456bcbd06f8$var$Tt.z, i[10] = $fd4eb456bcbd06f8$var$Et.z, this;
    }
    multiply(t1, e) {
        return void 0 !== e ? (console.warn("THREE.Matrix4: .multiply() now only accepts one argument. Use .multiplyMatrices( a, b ) instead."), this.multiplyMatrices(t1, e)) : this.multiplyMatrices(this, t1);
    }
    premultiply(t1) {
        return this.multiplyMatrices(t1, this);
    }
    multiplyMatrices(t1, e) {
        const n = t1.elements, i = e.elements, r = this.elements, s = n[0], a = n[4], o = n[8], l = n[12], h = n[1], c = n[5], u = n[9], d = n[13], p = n[2], m = n[6], f = n[10], g = n[14], v = n[3], y = n[7], x = n[11], b = n[15], _ = i[0], w = i[4], M = i[8], S = i[12], T = i[1], E = i[5], A = i[9], R = i[13], C = i[2], L = i[6], P = i[10], D = i[14], I = i[3], O = i[7], N = i[11], F = i[15];
        return r[0] = s * _ + a * T + o * C + l * I, r[4] = s * w + a * E + o * L + l * O, r[8] = s * M + a * A + o * P + l * N, r[12] = s * S + a * R + o * D + l * F, r[1] = h * _ + c * T + u * C + d * I, r[5] = h * w + c * E + u * L + d * O, r[9] = h * M + c * A + u * P + d * N, r[13] = h * S + c * R + u * D + d * F, r[2] = p * _ + m * T + f * C + g * I, r[6] = p * w + m * E + f * L + g * O, r[10] = p * M + m * A + f * P + g * N, r[14] = p * S + m * R + f * D + g * F, r[3] = v * _ + y * T + x * C + b * I, r[7] = v * w + y * E + x * L + b * O, r[11] = v * M + y * A + x * P + b * N, r[15] = v * S + y * R + x * D + b * F, this;
    }
    multiplyScalar(t1) {
        const e = this.elements;
        return e[0] *= t1, e[4] *= t1, e[8] *= t1, e[12] *= t1, e[1] *= t1, e[5] *= t1, e[9] *= t1, e[13] *= t1, e[2] *= t1, e[6] *= t1, e[10] *= t1, e[14] *= t1, e[3] *= t1, e[7] *= t1, e[11] *= t1, e[15] *= t1, this;
    }
    determinant() {
        const t1 = this.elements, e = t1[0], n = t1[4], i = t1[8], r = t1[12], s = t1[1], a = t1[5], o = t1[9], l = t1[13], h = t1[2], c = t1[6], u = t1[10], d = t1[14];
        return t1[3] * (+r * o * c - i * l * c - r * a * u + n * l * u + i * a * d - n * o * d) + t1[7] * (+e * o * d - e * l * u + r * s * u - i * s * d + i * l * h - r * o * h) + t1[11] * (+e * l * c - e * a * d - r * s * c + n * s * d + r * a * h - n * l * h) + t1[15] * (-i * a * h - e * o * c + e * a * u + i * s * c - n * s * u + n * o * h);
    }
    transpose() {
        const t1 = this.elements;
        let e;
        return e = t1[1], t1[1] = t1[4], t1[4] = e, e = t1[2], t1[2] = t1[8], t1[8] = e, e = t1[6], t1[6] = t1[9], t1[9] = e, e = t1[3], t1[3] = t1[12], t1[12] = e, e = t1[7], t1[7] = t1[13], t1[13] = e, e = t1[11], t1[11] = t1[14], t1[14] = e, this;
    }
    setPosition(t1, e, n) {
        const i = this.elements;
        return t1.isVector3 ? (i[12] = t1.x, i[13] = t1.y, i[14] = t1.z) : (i[12] = t1, i[13] = e, i[14] = n), this;
    }
    invert() {
        const t1 = this.elements, e = t1[0], n = t1[1], i = t1[2], r = t1[3], s = t1[4], a = t1[5], o = t1[6], l = t1[7], h = t1[8], c = t1[9], u = t1[10], d = t1[11], p = t1[12], m = t1[13], f = t1[14], g = t1[15], v = c * f * l - m * u * l + m * o * d - a * f * d - c * o * g + a * u * g, y = p * u * l - h * f * l - p * o * d + s * f * d + h * o * g - s * u * g, x = h * m * l - p * c * l + p * a * d - s * m * d - h * a * g + s * c * g, b = p * c * o - h * m * o - p * a * u + s * m * u + h * a * f - s * c * f, _ = e * v + n * y + i * x + r * b;
        if (0 === _) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
        const w = 1 / _;
        return t1[0] = v * w, t1[1] = (m * u * r - c * f * r - m * i * d + n * f * d + c * i * g - n * u * g) * w, t1[2] = (a * f * r - m * o * r + m * i * l - n * f * l - a * i * g + n * o * g) * w, t1[3] = (c * o * r - a * u * r - c * i * l + n * u * l + a * i * d - n * o * d) * w, t1[4] = y * w, t1[5] = (h * f * r - p * u * r + p * i * d - e * f * d - h * i * g + e * u * g) * w, t1[6] = (p * o * r - s * f * r - p * i * l + e * f * l + s * i * g - e * o * g) * w, t1[7] = (s * u * r - h * o * r + h * i * l - e * u * l - s * i * d + e * o * d) * w, t1[8] = x * w, t1[9] = (p * c * r - h * m * r - p * n * d + e * m * d + h * n * g - e * c * g) * w, t1[10] = (s * m * r - p * a * r + p * n * l - e * m * l - s * n * g + e * a * g) * w, t1[11] = (h * a * r - s * c * r - h * n * l + e * c * l + s * n * d - e * a * d) * w, t1[12] = b * w, t1[13] = (h * m * i - p * c * i + p * n * u - e * m * u - h * n * f + e * c * f) * w, t1[14] = (p * a * i - s * m * i - p * n * o + e * m * o + s * n * f - e * a * f) * w, t1[15] = (s * c * i - h * a * i + h * n * o - e * c * o - s * n * u + e * a * u) * w, this;
    }
    scale(t1) {
        const e = this.elements, n = t1.x, i = t1.y, r = t1.z;
        return e[0] *= n, e[4] *= i, e[8] *= r, e[1] *= n, e[5] *= i, e[9] *= r, e[2] *= n, e[6] *= i, e[10] *= r, e[3] *= n, e[7] *= i, e[11] *= r, this;
    }
    getMaxScaleOnAxis() {
        const t1 = this.elements, e = t1[0] * t1[0] + t1[1] * t1[1] + t1[2] * t1[2], n = t1[4] * t1[4] + t1[5] * t1[5] + t1[6] * t1[6], i = t1[8] * t1[8] + t1[9] * t1[9] + t1[10] * t1[10];
        return Math.sqrt(Math.max(e, n, i));
    }
    makeTranslation(t1, e, n) {
        return this.set(1, 0, 0, t1, 0, 1, 0, e, 0, 0, 1, n, 0, 0, 0, 1), this;
    }
    makeRotationX(t1) {
        const e = Math.cos(t1), n = Math.sin(t1);
        return this.set(1, 0, 0, 0, 0, e, -n, 0, 0, n, e, 0, 0, 0, 0, 1), this;
    }
    makeRotationY(t1) {
        const e = Math.cos(t1), n = Math.sin(t1);
        return this.set(e, 0, n, 0, 0, 1, 0, 0, -n, 0, e, 0, 0, 0, 0, 1), this;
    }
    makeRotationZ(t1) {
        const e = Math.cos(t1), n = Math.sin(t1);
        return this.set(e, -n, 0, 0, n, e, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
    }
    makeRotationAxis(t1, e) {
        const n = Math.cos(e), i = Math.sin(e), r = 1 - n, s = t1.x, a = t1.y, o = t1.z, l = r * s, h = r * a;
        return this.set(l * s + n, l * a - i * o, l * o + i * a, 0, l * a + i * o, h * a + n, h * o - i * s, 0, l * o - i * a, h * o + i * s, r * o * o + n, 0, 0, 0, 0, 1), this;
    }
    makeScale(t1, e, n) {
        return this.set(t1, 0, 0, 0, 0, e, 0, 0, 0, 0, n, 0, 0, 0, 0, 1), this;
    }
    makeShear(t1, e, n, i, r, s) {
        return this.set(1, n, r, 0, t1, 1, s, 0, e, i, 1, 0, 0, 0, 0, 1), this;
    }
    compose(t1, e, n) {
        const i = this.elements, r = e._x, s = e._y, a = e._z, o = e._w, l = r + r, h = s + s, c = a + a, u = r * l, d = r * h, p = r * c, m = s * h, f = s * c, g = a * c, v = o * l, y = o * h, x = o * c, b = n.x, _ = n.y, w = n.z;
        return i[0] = (1 - (m + g)) * b, i[1] = (d + x) * b, i[2] = (p - y) * b, i[3] = 0, i[4] = (d - x) * _, i[5] = (1 - (u + g)) * _, i[6] = (f + v) * _, i[7] = 0, i[8] = (p + y) * w, i[9] = (f - v) * w, i[10] = (1 - (u + m)) * w, i[11] = 0, i[12] = t1.x, i[13] = t1.y, i[14] = t1.z, i[15] = 1, this;
    }
    decompose(t1, e, n) {
        const i = this.elements;
        let r = $fd4eb456bcbd06f8$var$bt.set(i[0], i[1], i[2]).length();
        const s = $fd4eb456bcbd06f8$var$bt.set(i[4], i[5], i[6]).length(), a = $fd4eb456bcbd06f8$var$bt.set(i[8], i[9], i[10]).length();
        this.determinant() < 0 && (r = -r), t1.x = i[12], t1.y = i[13], t1.z = i[14], $fd4eb456bcbd06f8$var$_t.copy(this);
        const o = 1 / r, l = 1 / s, h = 1 / a;
        return $fd4eb456bcbd06f8$var$_t.elements[0] *= o, $fd4eb456bcbd06f8$var$_t.elements[1] *= o, $fd4eb456bcbd06f8$var$_t.elements[2] *= o, $fd4eb456bcbd06f8$var$_t.elements[4] *= l, $fd4eb456bcbd06f8$var$_t.elements[5] *= l, $fd4eb456bcbd06f8$var$_t.elements[6] *= l, $fd4eb456bcbd06f8$var$_t.elements[8] *= h, $fd4eb456bcbd06f8$var$_t.elements[9] *= h, $fd4eb456bcbd06f8$var$_t.elements[10] *= h, e.setFromRotationMatrix($fd4eb456bcbd06f8$var$_t), n.x = r, n.y = s, n.z = a, this;
    }
    makePerspective(t1, e, n, i, r, s) {
        void 0 === s && console.warn("THREE.Matrix4: .makePerspective() has been redefined and has a new signature. Please check the docs.");
        const a = this.elements, o = 2 * r / (e - t1), l = 2 * r / (n - i), h = (e + t1) / (e - t1), c = (n + i) / (n - i), u = -(s + r) / (s - r), d = -2 * s * r / (s - r);
        return a[0] = o, a[4] = 0, a[8] = h, a[12] = 0, a[1] = 0, a[5] = l, a[9] = c, a[13] = 0, a[2] = 0, a[6] = 0, a[10] = u, a[14] = d, a[3] = 0, a[7] = 0, a[11] = -1, a[15] = 0, this;
    }
    makeOrthographic(t1, e, n, i, r, s) {
        const a = this.elements, o = 1 / (e - t1), l = 1 / (n - i), h = 1 / (s - r), c = (e + t1) * o, u = (n + i) * l, d = (s + r) * h;
        return a[0] = 2 * o, a[4] = 0, a[8] = 0, a[12] = -c, a[1] = 0, a[5] = 2 * l, a[9] = 0, a[13] = -u, a[2] = 0, a[6] = 0, a[10] = -2 * h, a[14] = -d, a[3] = 0, a[7] = 0, a[11] = 0, a[15] = 1, this;
    }
    equals(t1) {
        const e = this.elements, n = t1.elements;
        for(let t1 = 0; t1 < 16; t1++)if (e[t1] !== n[t1]) return !1;
        return !0;
    }
    fromArray(t1, e = 0) {
        for(let n = 0; n < 16; n++)this.elements[n] = t1[n + e];
        return this;
    }
    toArray(t1 = [], e = 0) {
        const n = this.elements;
        return t1[e] = n[0], t1[e + 1] = n[1], t1[e + 2] = n[2], t1[e + 3] = n[3], t1[e + 4] = n[4], t1[e + 5] = n[5], t1[e + 6] = n[6], t1[e + 7] = n[7], t1[e + 8] = n[8], t1[e + 9] = n[9], t1[e + 10] = n[10], t1[e + 11] = n[11], t1[e + 12] = n[12], t1[e + 13] = n[13], t1[e + 14] = n[14], t1[e + 15] = n[15], t1;
    }
}
$fd4eb456bcbd06f8$var$xt.prototype.isMatrix4 = !0;
const $fd4eb456bcbd06f8$var$bt = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$_t = new $fd4eb456bcbd06f8$var$xt, $fd4eb456bcbd06f8$var$wt = new $fd4eb456bcbd06f8$var$V(0, 0, 0), $fd4eb456bcbd06f8$var$Mt = new $fd4eb456bcbd06f8$var$V(1, 1, 1), $fd4eb456bcbd06f8$var$St = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$Tt = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$Et = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$At = new $fd4eb456bcbd06f8$var$xt, $fd4eb456bcbd06f8$var$Rt = new $fd4eb456bcbd06f8$var$H;
class $fd4eb456bcbd06f8$var$Ct {
    constructor(t1 = 0, e = 0, n = 0, i = $fd4eb456bcbd06f8$var$Ct.DefaultOrder){
        this._x = t1, this._y = e, this._z = n, this._order = i;
    }
    get x() {
        return this._x;
    }
    set x(t1) {
        this._x = t1, this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(t1) {
        this._y = t1, this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(t1) {
        this._z = t1, this._onChangeCallback();
    }
    get order() {
        return this._order;
    }
    set order(t1) {
        this._order = t1, this._onChangeCallback();
    }
    set(t1, e, n, i = this._order) {
        return this._x = t1, this._y = e, this._z = n, this._order = i, this._onChangeCallback(), this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._order);
    }
    copy(t1) {
        return this._x = t1._x, this._y = t1._y, this._z = t1._z, this._order = t1._order, this._onChangeCallback(), this;
    }
    setFromRotationMatrix(t1, e = this._order, n = !0) {
        const i = t1.elements, r = i[0], s = i[4], a = i[8], o = i[1], l = i[5], c = i[9], u = i[2], d = i[6], p = i[10];
        switch(e){
            case "XYZ":
                this._y = Math.asin($fd4eb456bcbd06f8$var$h(a, -1, 1)), Math.abs(a) < .9999999 ? (this._x = Math.atan2(-c, p), this._z = Math.atan2(-s, r)) : (this._x = Math.atan2(d, l), this._z = 0);
                break;
            case "YXZ":
                this._x = Math.asin(-$fd4eb456bcbd06f8$var$h(c, -1, 1)), Math.abs(c) < .9999999 ? (this._y = Math.atan2(a, p), this._z = Math.atan2(o, l)) : (this._y = Math.atan2(-u, r), this._z = 0);
                break;
            case "ZXY":
                this._x = Math.asin($fd4eb456bcbd06f8$var$h(d, -1, 1)), Math.abs(d) < .9999999 ? (this._y = Math.atan2(-u, p), this._z = Math.atan2(-s, l)) : (this._y = 0, this._z = Math.atan2(o, r));
                break;
            case "ZYX":
                this._y = Math.asin(-$fd4eb456bcbd06f8$var$h(u, -1, 1)), Math.abs(u) < .9999999 ? (this._x = Math.atan2(d, p), this._z = Math.atan2(o, r)) : (this._x = 0, this._z = Math.atan2(-s, l));
                break;
            case "YZX":
                this._z = Math.asin($fd4eb456bcbd06f8$var$h(o, -1, 1)), Math.abs(o) < .9999999 ? (this._x = Math.atan2(-c, l), this._y = Math.atan2(-u, r)) : (this._x = 0, this._y = Math.atan2(a, p));
                break;
            case "XZY":
                this._z = Math.asin(-$fd4eb456bcbd06f8$var$h(s, -1, 1)), Math.abs(s) < .9999999 ? (this._x = Math.atan2(d, l), this._y = Math.atan2(a, r)) : (this._x = Math.atan2(-c, p), this._y = 0);
                break;
            default:
                console.warn("THREE.Euler: .setFromRotationMatrix() encountered an unknown order: " + e);
        }
        return this._order = e, !0 === n && this._onChangeCallback(), this;
    }
    setFromQuaternion(t1, e, n) {
        return $fd4eb456bcbd06f8$var$At.makeRotationFromQuaternion(t1), this.setFromRotationMatrix($fd4eb456bcbd06f8$var$At, e, n);
    }
    setFromVector3(t1, e = this._order) {
        return this.set(t1.x, t1.y, t1.z, e);
    }
    reorder(t1) {
        return $fd4eb456bcbd06f8$var$Rt.setFromEuler(this), this.setFromQuaternion($fd4eb456bcbd06f8$var$Rt, t1);
    }
    equals(t1) {
        return t1._x === this._x && t1._y === this._y && t1._z === this._z && t1._order === this._order;
    }
    fromArray(t1) {
        return this._x = t1[0], this._y = t1[1], this._z = t1[2], void 0 !== t1[3] && (this._order = t1[3]), this._onChangeCallback(), this;
    }
    toArray(t1 = [], e = 0) {
        return t1[e] = this._x, t1[e + 1] = this._y, t1[e + 2] = this._z, t1[e + 3] = this._order, t1;
    }
    _onChange(t1) {
        return this._onChangeCallback = t1, this;
    }
    _onChangeCallback() {}
}
$fd4eb456bcbd06f8$var$Ct.prototype.isEuler = !0, $fd4eb456bcbd06f8$var$Ct.DefaultOrder = "XYZ", $fd4eb456bcbd06f8$var$Ct.RotationOrders = [
    "XYZ",
    "YZX",
    "ZXY",
    "XZY",
    "YXZ",
    "ZYX"
];
class $fd4eb456bcbd06f8$var$Lt {
    constructor(){
        this.mask = 1;
    }
    set(t1) {
        this.mask = (1 << t1 | 0) >>> 0;
    }
    enable(t1) {
        this.mask |= 1 << t1 | 0;
    }
    enableAll() {
        this.mask = -1;
    }
    toggle(t1) {
        this.mask ^= 1 << t1 | 0;
    }
    disable(t1) {
        this.mask &= ~(1 << t1 | 0);
    }
    disableAll() {
        this.mask = 0;
    }
    test(t1) {
        return 0 != (this.mask & t1.mask);
    }
    isEnabled(t1) {
        return 0 != (this.mask & (1 << t1 | 0));
    }
}
let $fd4eb456bcbd06f8$var$Pt = 0;
const $fd4eb456bcbd06f8$var$Dt = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$It = new $fd4eb456bcbd06f8$var$H, $fd4eb456bcbd06f8$var$Ot = new $fd4eb456bcbd06f8$var$xt, $fd4eb456bcbd06f8$var$Nt = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$Ft = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$Ut = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$kt = new $fd4eb456bcbd06f8$var$H, $fd4eb456bcbd06f8$var$Bt = new $fd4eb456bcbd06f8$var$V(1, 0, 0), $fd4eb456bcbd06f8$var$zt = new $fd4eb456bcbd06f8$var$V(0, 1, 0), $fd4eb456bcbd06f8$var$Ht = new $fd4eb456bcbd06f8$var$V(0, 0, 1), $fd4eb456bcbd06f8$var$Vt = {
    type: "added"
}, $fd4eb456bcbd06f8$var$Gt = {
    type: "removed"
};
class $fd4eb456bcbd06f8$var$Wt extends $fd4eb456bcbd06f8$var$i {
    constructor(){
        super(), Object.defineProperty(this, "id", {
            value: $fd4eb456bcbd06f8$var$Pt++
        }), this.uuid = $fd4eb456bcbd06f8$var$l(), this.name = "", this.type = "Object3D", this.parent = null, this.children = [], this.up = $fd4eb456bcbd06f8$var$Wt.DefaultUp.clone();
        const t1 = new $fd4eb456bcbd06f8$var$V, e = new $fd4eb456bcbd06f8$var$Ct, n = new $fd4eb456bcbd06f8$var$H, i = new $fd4eb456bcbd06f8$var$V(1, 1, 1);
        e._onChange(function() {
            n.setFromEuler(e, !1);
        }), n._onChange(function() {
            e.setFromQuaternion(n, void 0, !1);
        }), Object.defineProperties(this, {
            position: {
                configurable: !0,
                enumerable: !0,
                value: t1
            },
            rotation: {
                configurable: !0,
                enumerable: !0,
                value: e
            },
            quaternion: {
                configurable: !0,
                enumerable: !0,
                value: n
            },
            scale: {
                configurable: !0,
                enumerable: !0,
                value: i
            },
            modelViewMatrix: {
                value: new $fd4eb456bcbd06f8$var$xt
            },
            normalMatrix: {
                value: new $fd4eb456bcbd06f8$var$v
            }
        }), this.matrix = new $fd4eb456bcbd06f8$var$xt, this.matrixWorld = new $fd4eb456bcbd06f8$var$xt, this.matrixAutoUpdate = $fd4eb456bcbd06f8$var$Wt.DefaultMatrixAutoUpdate, this.matrixWorldNeedsUpdate = !1, this.layers = new $fd4eb456bcbd06f8$var$Lt, this.visible = !0, this.castShadow = !1, this.receiveShadow = !1, this.frustumCulled = !0, this.renderOrder = 0, this.animations = [], this.userData = {};
    }
    onBeforeRender() {}
    onAfterRender() {}
    applyMatrix4(t1) {
        this.matrixAutoUpdate && this.updateMatrix(), this.matrix.premultiply(t1), this.matrix.decompose(this.position, this.quaternion, this.scale);
    }
    applyQuaternion(t1) {
        return this.quaternion.premultiply(t1), this;
    }
    setRotationFromAxisAngle(t1, e) {
        this.quaternion.setFromAxisAngle(t1, e);
    }
    setRotationFromEuler(t1) {
        this.quaternion.setFromEuler(t1, !0);
    }
    setRotationFromMatrix(t1) {
        this.quaternion.setFromRotationMatrix(t1);
    }
    setRotationFromQuaternion(t1) {
        this.quaternion.copy(t1);
    }
    rotateOnAxis(t1, e) {
        return $fd4eb456bcbd06f8$var$It.setFromAxisAngle(t1, e), this.quaternion.multiply($fd4eb456bcbd06f8$var$It), this;
    }
    rotateOnWorldAxis(t1, e) {
        return $fd4eb456bcbd06f8$var$It.setFromAxisAngle(t1, e), this.quaternion.premultiply($fd4eb456bcbd06f8$var$It), this;
    }
    rotateX(t1) {
        return this.rotateOnAxis($fd4eb456bcbd06f8$var$Bt, t1);
    }
    rotateY(t1) {
        return this.rotateOnAxis($fd4eb456bcbd06f8$var$zt, t1);
    }
    rotateZ(t1) {
        return this.rotateOnAxis($fd4eb456bcbd06f8$var$Ht, t1);
    }
    translateOnAxis(t1, e) {
        return $fd4eb456bcbd06f8$var$Dt.copy(t1).applyQuaternion(this.quaternion), this.position.add($fd4eb456bcbd06f8$var$Dt.multiplyScalar(e)), this;
    }
    translateX(t1) {
        return this.translateOnAxis($fd4eb456bcbd06f8$var$Bt, t1);
    }
    translateY(t1) {
        return this.translateOnAxis($fd4eb456bcbd06f8$var$zt, t1);
    }
    translateZ(t1) {
        return this.translateOnAxis($fd4eb456bcbd06f8$var$Ht, t1);
    }
    localToWorld(t1) {
        return t1.applyMatrix4(this.matrixWorld);
    }
    worldToLocal(t1) {
        return t1.applyMatrix4($fd4eb456bcbd06f8$var$Ot.copy(this.matrixWorld).invert());
    }
    lookAt(t1, e, n) {
        t1.isVector3 ? $fd4eb456bcbd06f8$var$Nt.copy(t1) : $fd4eb456bcbd06f8$var$Nt.set(t1, e, n);
        const i = this.parent;
        this.updateWorldMatrix(!0, !1), $fd4eb456bcbd06f8$var$Ft.setFromMatrixPosition(this.matrixWorld), this.isCamera || this.isLight ? $fd4eb456bcbd06f8$var$Ot.lookAt($fd4eb456bcbd06f8$var$Ft, $fd4eb456bcbd06f8$var$Nt, this.up) : $fd4eb456bcbd06f8$var$Ot.lookAt($fd4eb456bcbd06f8$var$Nt, $fd4eb456bcbd06f8$var$Ft, this.up), this.quaternion.setFromRotationMatrix($fd4eb456bcbd06f8$var$Ot), i && ($fd4eb456bcbd06f8$var$Ot.extractRotation(i.matrixWorld), $fd4eb456bcbd06f8$var$It.setFromRotationMatrix($fd4eb456bcbd06f8$var$Ot), this.quaternion.premultiply($fd4eb456bcbd06f8$var$It.invert()));
    }
    add(t1) {
        if (arguments.length > 1) {
            for(let t1 = 0; t1 < arguments.length; t1++)this.add(arguments[t1]);
            return this;
        }
        return t1 === this ? (console.error("THREE.Object3D.add: object can't be added as a child of itself.", t1), this) : (t1 && t1.isObject3D ? (null !== t1.parent && t1.parent.remove(t1), t1.parent = this, this.children.push(t1), t1.dispatchEvent($fd4eb456bcbd06f8$var$Vt)) : console.error("THREE.Object3D.add: object not an instance of THREE.Object3D.", t1), this);
    }
    remove(t1) {
        if (arguments.length > 1) {
            for(let t1 = 0; t1 < arguments.length; t1++)this.remove(arguments[t1]);
            return this;
        }
        const e = this.children.indexOf(t1);
        return -1 !== e && (t1.parent = null, this.children.splice(e, 1), t1.dispatchEvent($fd4eb456bcbd06f8$var$Gt)), this;
    }
    removeFromParent() {
        const t1 = this.parent;
        return null !== t1 && t1.remove(this), this;
    }
    clear() {
        for(let t1 = 0; t1 < this.children.length; t1++){
            const e = this.children[t1];
            e.parent = null, e.dispatchEvent($fd4eb456bcbd06f8$var$Gt);
        }
        return this.children.length = 0, this;
    }
    attach(t1) {
        return this.updateWorldMatrix(!0, !1), $fd4eb456bcbd06f8$var$Ot.copy(this.matrixWorld).invert(), null !== t1.parent && (t1.parent.updateWorldMatrix(!0, !1), $fd4eb456bcbd06f8$var$Ot.multiply(t1.parent.matrixWorld)), t1.applyMatrix4($fd4eb456bcbd06f8$var$Ot), this.add(t1), t1.updateWorldMatrix(!1, !0), this;
    }
    getObjectById(t1) {
        return this.getObjectByProperty("id", t1);
    }
    getObjectByName(t1) {
        return this.getObjectByProperty("name", t1);
    }
    getObjectByProperty(t1, e) {
        if (this[t1] === e) return this;
        for(let n = 0, i = this.children.length; n < i; n++){
            const i = this.children[n].getObjectByProperty(t1, e);
            if (void 0 !== i) return i;
        }
    }
    getWorldPosition(t1) {
        return this.updateWorldMatrix(!0, !1), t1.setFromMatrixPosition(this.matrixWorld);
    }
    getWorldQuaternion(t1) {
        return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose($fd4eb456bcbd06f8$var$Ft, t1, $fd4eb456bcbd06f8$var$Ut), t1;
    }
    getWorldScale(t1) {
        return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose($fd4eb456bcbd06f8$var$Ft, $fd4eb456bcbd06f8$var$kt, t1), t1;
    }
    getWorldDirection(t1) {
        this.updateWorldMatrix(!0, !1);
        const e = this.matrixWorld.elements;
        return t1.set(e[8], e[9], e[10]).normalize();
    }
    raycast() {}
    traverse(t1) {
        t1(this);
        const e = this.children;
        for(let n = 0, i = e.length; n < i; n++)e[n].traverse(t1);
    }
    traverseVisible(t1) {
        if (!1 === this.visible) return;
        t1(this);
        const e = this.children;
        for(let n = 0, i = e.length; n < i; n++)e[n].traverseVisible(t1);
    }
    traverseAncestors(t1) {
        const e = this.parent;
        null !== e && (t1(e), e.traverseAncestors(t1));
    }
    updateMatrix() {
        this.matrix.compose(this.position, this.quaternion, this.scale), this.matrixWorldNeedsUpdate = !0;
    }
    updateMatrixWorld(t1) {
        this.matrixAutoUpdate && this.updateMatrix(), (this.matrixWorldNeedsUpdate || t1) && (null === this.parent ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix), this.matrixWorldNeedsUpdate = !1, t1 = !0);
        const e = this.children;
        for(let n = 0, i = e.length; n < i; n++)e[n].updateMatrixWorld(t1);
    }
    updateWorldMatrix(t1, e) {
        const n = this.parent;
        if (!0 === t1 && null !== n && n.updateWorldMatrix(!0, !1), this.matrixAutoUpdate && this.updateMatrix(), null === this.parent ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix), !0 === e) {
            const t1 = this.children;
            for(let e = 0, n = t1.length; e < n; e++)t1[e].updateWorldMatrix(!1, !0);
        }
    }
    toJSON(t1) {
        const e = void 0 === t1 || "string" == typeof t1, n = {};
        e && (t1 = {
            geometries: {},
            materials: {},
            textures: {},
            images: {},
            shapes: {},
            skeletons: {},
            animations: {},
            nodes: {}
        }, n.metadata = {
            version: 4.5,
            type: "Object",
            generator: "Object3D.toJSON"
        });
        const i = {};
        function r(e, n) {
            return void 0 === e[n.uuid] && (e[n.uuid] = n.toJSON(t1)), n.uuid;
        }
        if (i.uuid = this.uuid, i.type = this.type, "" !== this.name && (i.name = this.name), !0 === this.castShadow && (i.castShadow = !0), !0 === this.receiveShadow && (i.receiveShadow = !0), !1 === this.visible && (i.visible = !1), !1 === this.frustumCulled && (i.frustumCulled = !1), 0 !== this.renderOrder && (i.renderOrder = this.renderOrder), "{}" !== JSON.stringify(this.userData) && (i.userData = this.userData), i.layers = this.layers.mask, i.matrix = this.matrix.toArray(), !1 === this.matrixAutoUpdate && (i.matrixAutoUpdate = !1), this.isInstancedMesh && (i.type = "InstancedMesh", i.count = this.count, i.instanceMatrix = this.instanceMatrix.toJSON(), null !== this.instanceColor && (i.instanceColor = this.instanceColor.toJSON())), this.isScene) this.background && (this.background.isColor ? i.background = this.background.toJSON() : this.background.isTexture && (i.background = this.background.toJSON(t1).uuid)), this.environment && this.environment.isTexture && (i.environment = this.environment.toJSON(t1).uuid);
        else if (this.isMesh || this.isLine || this.isPoints) {
            i.geometry = r(t1.geometries, this.geometry);
            const e = this.geometry.parameters;
            if (void 0 !== e && void 0 !== e.shapes) {
                const n = e.shapes;
                if (Array.isArray(n)) for(let e = 0, i = n.length; e < i; e++){
                    const i = n[e];
                    r(t1.shapes, i);
                }
                else r(t1.shapes, n);
            }
        }
        if (this.isSkinnedMesh && (i.bindMode = this.bindMode, i.bindMatrix = this.bindMatrix.toArray(), void 0 !== this.skeleton && (r(t1.skeletons, this.skeleton), i.skeleton = this.skeleton.uuid)), void 0 !== this.material) {
            if (Array.isArray(this.material)) {
                const e = [];
                for(let n = 0, i = this.material.length; n < i; n++)e.push(r(t1.materials, this.material[n]));
                i.material = e;
            } else i.material = r(t1.materials, this.material);
        }
        if (this.children.length > 0) {
            i.children = [];
            for(let e = 0; e < this.children.length; e++)i.children.push(this.children[e].toJSON(t1).object);
        }
        if (this.animations.length > 0) {
            i.animations = [];
            for(let e = 0; e < this.animations.length; e++){
                const n = this.animations[e];
                i.animations.push(r(t1.animations, n));
            }
        }
        if (e) {
            const e = s(t1.geometries), i = s(t1.materials), r = s(t1.textures), a = s(t1.images), o = s(t1.shapes), l = s(t1.skeletons), h = s(t1.animations), c = s(t1.nodes);
            e.length > 0 && (n.geometries = e), i.length > 0 && (n.materials = i), r.length > 0 && (n.textures = r), a.length > 0 && (n.images = a), o.length > 0 && (n.shapes = o), l.length > 0 && (n.skeletons = l), h.length > 0 && (n.animations = h), c.length > 0 && (n.nodes = c);
        }
        return n.object = i, n;
        function s(t1) {
            const e = [];
            for(const n in t1){
                const i = t1[n];
                delete i.metadata, e.push(i);
            }
            return e;
        }
    }
    clone(t1) {
        return (new this.constructor).copy(this, t1);
    }
    copy(t1, e = !0) {
        if (this.name = t1.name, this.up.copy(t1.up), this.position.copy(t1.position), this.rotation.order = t1.rotation.order, this.quaternion.copy(t1.quaternion), this.scale.copy(t1.scale), this.matrix.copy(t1.matrix), this.matrixWorld.copy(t1.matrixWorld), this.matrixAutoUpdate = t1.matrixAutoUpdate, this.matrixWorldNeedsUpdate = t1.matrixWorldNeedsUpdate, this.layers.mask = t1.layers.mask, this.visible = t1.visible, this.castShadow = t1.castShadow, this.receiveShadow = t1.receiveShadow, this.frustumCulled = t1.frustumCulled, this.renderOrder = t1.renderOrder, this.userData = JSON.parse(JSON.stringify(t1.userData)), !0 === e) for(let e = 0; e < t1.children.length; e++){
            const n = t1.children[e];
            this.add(n.clone());
        }
        return this;
    }
}
$fd4eb456bcbd06f8$var$Wt.DefaultUp = new $fd4eb456bcbd06f8$var$V(0, 1, 0), $fd4eb456bcbd06f8$var$Wt.DefaultMatrixAutoUpdate = !0, $fd4eb456bcbd06f8$var$Wt.prototype.isObject3D = !0;
const $fd4eb456bcbd06f8$var$jt = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$qt = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$Xt = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$$t = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$Yt = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$Jt = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$Kt = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$Zt = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$Qt = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$te = new $fd4eb456bcbd06f8$var$V;
class $fd4eb456bcbd06f8$var$ee {
    constructor(t1 = new $fd4eb456bcbd06f8$var$V, e = new $fd4eb456bcbd06f8$var$V, n = new $fd4eb456bcbd06f8$var$V){
        this.a = t1, this.b = e, this.c = n;
    }
    static getNormal(t1, e, n, i) {
        i.subVectors(n, e), $fd4eb456bcbd06f8$var$jt.subVectors(t1, e), i.cross($fd4eb456bcbd06f8$var$jt);
        const r = i.lengthSq();
        return r > 0 ? i.multiplyScalar(1 / Math.sqrt(r)) : i.set(0, 0, 0);
    }
    static getBarycoord(t1, e, n, i, r) {
        $fd4eb456bcbd06f8$var$jt.subVectors(i, e), $fd4eb456bcbd06f8$var$qt.subVectors(n, e), $fd4eb456bcbd06f8$var$Xt.subVectors(t1, e);
        const s = $fd4eb456bcbd06f8$var$jt.dot($fd4eb456bcbd06f8$var$jt), a = $fd4eb456bcbd06f8$var$jt.dot($fd4eb456bcbd06f8$var$qt), o = $fd4eb456bcbd06f8$var$jt.dot($fd4eb456bcbd06f8$var$Xt), l = $fd4eb456bcbd06f8$var$qt.dot($fd4eb456bcbd06f8$var$qt), h = $fd4eb456bcbd06f8$var$qt.dot($fd4eb456bcbd06f8$var$Xt), c = s * l - a * a;
        if (0 === c) return r.set(-2, -1, -1);
        const u = 1 / c, d = (l * o - a * h) * u, p = (s * h - a * o) * u;
        return r.set(1 - d - p, p, d);
    }
    static containsPoint(t1, e, n, i) {
        return this.getBarycoord(t1, e, n, i, $fd4eb456bcbd06f8$var$$t), $fd4eb456bcbd06f8$var$$t.x >= 0 && $fd4eb456bcbd06f8$var$$t.y >= 0 && $fd4eb456bcbd06f8$var$$t.x + $fd4eb456bcbd06f8$var$$t.y <= 1;
    }
    static getUV(t1, e, n, i, r, s, a, o) {
        return this.getBarycoord(t1, e, n, i, $fd4eb456bcbd06f8$var$$t), o.set(0, 0), o.addScaledVector(r, $fd4eb456bcbd06f8$var$$t.x), o.addScaledVector(s, $fd4eb456bcbd06f8$var$$t.y), o.addScaledVector(a, $fd4eb456bcbd06f8$var$$t.z), o;
    }
    static isFrontFacing(t1, e, n, i) {
        return $fd4eb456bcbd06f8$var$jt.subVectors(n, e), $fd4eb456bcbd06f8$var$qt.subVectors(t1, e), $fd4eb456bcbd06f8$var$jt.cross($fd4eb456bcbd06f8$var$qt).dot(i) < 0;
    }
    set(t1, e, n) {
        return this.a.copy(t1), this.b.copy(e), this.c.copy(n), this;
    }
    setFromPointsAndIndices(t1, e, n, i) {
        return this.a.copy(t1[e]), this.b.copy(t1[n]), this.c.copy(t1[i]), this;
    }
    setFromAttributeAndIndices(t1, e, n, i) {
        return this.a.fromBufferAttribute(t1, e), this.b.fromBufferAttribute(t1, n), this.c.fromBufferAttribute(t1, i), this;
    }
    clone() {
        return (new this.constructor).copy(this);
    }
    copy(t1) {
        return this.a.copy(t1.a), this.b.copy(t1.b), this.c.copy(t1.c), this;
    }
    getArea() {
        return $fd4eb456bcbd06f8$var$jt.subVectors(this.c, this.b), $fd4eb456bcbd06f8$var$qt.subVectors(this.a, this.b), .5 * $fd4eb456bcbd06f8$var$jt.cross($fd4eb456bcbd06f8$var$qt).length();
    }
    getMidpoint(t1) {
        return t1.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
    }
    getNormal(t1) {
        return $fd4eb456bcbd06f8$var$ee.getNormal(this.a, this.b, this.c, t1);
    }
    getPlane(t1) {
        return t1.setFromCoplanarPoints(this.a, this.b, this.c);
    }
    getBarycoord(t1, e) {
        return $fd4eb456bcbd06f8$var$ee.getBarycoord(t1, this.a, this.b, this.c, e);
    }
    getUV(t1, e, n, i, r) {
        return $fd4eb456bcbd06f8$var$ee.getUV(t1, this.a, this.b, this.c, e, n, i, r);
    }
    containsPoint(t1) {
        return $fd4eb456bcbd06f8$var$ee.containsPoint(t1, this.a, this.b, this.c);
    }
    isFrontFacing(t1) {
        return $fd4eb456bcbd06f8$var$ee.isFrontFacing(this.a, this.b, this.c, t1);
    }
    intersectsBox(t1) {
        return t1.intersectsTriangle(this);
    }
    closestPointToPoint(t1, e) {
        const n = this.a, i = this.b, r = this.c;
        let s, a;
        $fd4eb456bcbd06f8$var$Yt.subVectors(i, n), $fd4eb456bcbd06f8$var$Jt.subVectors(r, n), $fd4eb456bcbd06f8$var$Zt.subVectors(t1, n);
        const o = $fd4eb456bcbd06f8$var$Yt.dot($fd4eb456bcbd06f8$var$Zt), l = $fd4eb456bcbd06f8$var$Jt.dot($fd4eb456bcbd06f8$var$Zt);
        if (o <= 0 && l <= 0) return e.copy(n);
        $fd4eb456bcbd06f8$var$Qt.subVectors(t1, i);
        const h = $fd4eb456bcbd06f8$var$Yt.dot($fd4eb456bcbd06f8$var$Qt), c = $fd4eb456bcbd06f8$var$Jt.dot($fd4eb456bcbd06f8$var$Qt);
        if (h >= 0 && c <= h) return e.copy(i);
        const u = o * c - h * l;
        if (u <= 0 && o >= 0 && h <= 0) return s = o / (o - h), e.copy(n).addScaledVector($fd4eb456bcbd06f8$var$Yt, s);
        $fd4eb456bcbd06f8$var$te.subVectors(t1, r);
        const d = $fd4eb456bcbd06f8$var$Yt.dot($fd4eb456bcbd06f8$var$te), p = $fd4eb456bcbd06f8$var$Jt.dot($fd4eb456bcbd06f8$var$te);
        if (p >= 0 && d <= p) return e.copy(r);
        const m = d * l - o * p;
        if (m <= 0 && l >= 0 && p <= 0) return a = l / (l - p), e.copy(n).addScaledVector($fd4eb456bcbd06f8$var$Jt, a);
        const f = h * p - d * c;
        if (f <= 0 && c - h >= 0 && d - p >= 0) return $fd4eb456bcbd06f8$var$Kt.subVectors(r, i), a = (c - h) / (c - h + (d - p)), e.copy(i).addScaledVector($fd4eb456bcbd06f8$var$Kt, a);
        const g = 1 / (f + m + u);
        return s = m * g, a = u * g, e.copy(n).addScaledVector($fd4eb456bcbd06f8$var$Yt, s).addScaledVector($fd4eb456bcbd06f8$var$Jt, a);
    }
    equals(t1) {
        return t1.a.equals(this.a) && t1.b.equals(this.b) && t1.c.equals(this.c);
    }
}
let $fd4eb456bcbd06f8$var$ne = 0;
class $fd4eb456bcbd06f8$var$ie extends $fd4eb456bcbd06f8$var$i {
    constructor(){
        super(), Object.defineProperty(this, "id", {
            value: $fd4eb456bcbd06f8$var$ne++
        }), this.uuid = $fd4eb456bcbd06f8$var$l(), this.name = "", this.type = "Material", this.fog = !0, this.blending = 1, this.side = 0, this.vertexColors = !1, this.opacity = 1, this.transparent = !1, this.blendSrc = 204, this.blendDst = 205, this.blendEquation = 100, this.blendSrcAlpha = null, this.blendDstAlpha = null, this.blendEquationAlpha = null, this.depthFunc = 3, this.depthTest = !0, this.depthWrite = !0, this.stencilWriteMask = 255, this.stencilFunc = 519, this.stencilRef = 0, this.stencilFuncMask = 255, this.stencilFail = 7680, this.stencilZFail = 7680, this.stencilZPass = 7680, this.stencilWrite = !1, this.clippingPlanes = null, this.clipIntersection = !1, this.clipShadows = !1, this.shadowSide = null, this.colorWrite = !0, this.precision = null, this.polygonOffset = !1, this.polygonOffsetFactor = 0, this.polygonOffsetUnits = 0, this.dithering = !1, this.alphaToCoverage = !1, this.premultipliedAlpha = !1, this.visible = !0, this.toneMapped = !0, this.userData = {}, this.version = 0, this._alphaTest = 0;
    }
    get alphaTest() {
        return this._alphaTest;
    }
    set alphaTest(t1) {
        this._alphaTest > 0 != t1 > 0 && this.version++, this._alphaTest = t1;
    }
    onBuild() {}
    onBeforeRender() {}
    onBeforeCompile() {}
    customProgramCacheKey() {
        return this.onBeforeCompile.toString();
    }
    setValues(t1) {
        if (void 0 !== t1) for(const e in t1){
            const n = t1[e];
            if (void 0 === n) {
                console.warn("THREE.Material: '" + e + "' parameter is undefined.");
                continue;
            }
            if ("shading" === e) {
                console.warn("THREE." + this.type + ": .shading has been removed. Use the boolean .flatShading instead."), this.flatShading = 1 === n;
                continue;
            }
            const i = this[e];
            void 0 !== i ? i && i.isColor ? i.set(n) : i && i.isVector3 && n && n.isVector3 ? i.copy(n) : this[e] = n : console.warn("THREE." + this.type + ": '" + e + "' is not a property of this material.");
        }
    }
    toJSON(t1) {
        const e = void 0 === t1 || "string" == typeof t1;
        e && (t1 = {
            textures: {},
            images: {}
        });
        const n = {
            metadata: {
                version: 4.5,
                type: "Material",
                generator: "Material.toJSON"
            }
        };
        function i(t1) {
            const e = [];
            for(const n in t1){
                const i = t1[n];
                delete i.metadata, e.push(i);
            }
            return e;
        }
        if (n.uuid = this.uuid, n.type = this.type, "" !== this.name && (n.name = this.name), this.color && this.color.isColor && (n.color = this.color.getHex()), void 0 !== this.roughness && (n.roughness = this.roughness), void 0 !== this.metalness && (n.metalness = this.metalness), void 0 !== this.sheen && (n.sheen = this.sheen), this.sheenColor && this.sheenColor.isColor && (n.sheenColor = this.sheenColor.getHex()), void 0 !== this.sheenRoughness && (n.sheenRoughness = this.sheenRoughness), this.emissive && this.emissive.isColor && (n.emissive = this.emissive.getHex()), this.emissiveIntensity && 1 !== this.emissiveIntensity && (n.emissiveIntensity = this.emissiveIntensity), this.specular && this.specular.isColor && (n.specular = this.specular.getHex()), void 0 !== this.specularIntensity && (n.specularIntensity = this.specularIntensity), this.specularColor && this.specularColor.isColor && (n.specularColor = this.specularColor.getHex()), void 0 !== this.shininess && (n.shininess = this.shininess), void 0 !== this.clearcoat && (n.clearcoat = this.clearcoat), void 0 !== this.clearcoatRoughness && (n.clearcoatRoughness = this.clearcoatRoughness), this.clearcoatMap && this.clearcoatMap.isTexture && (n.clearcoatMap = this.clearcoatMap.toJSON(t1).uuid), this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture && (n.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(t1).uuid), this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture && (n.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(t1).uuid, n.clearcoatNormalScale = this.clearcoatNormalScale.toArray()), this.map && this.map.isTexture && (n.map = this.map.toJSON(t1).uuid), this.matcap && this.matcap.isTexture && (n.matcap = this.matcap.toJSON(t1).uuid), this.alphaMap && this.alphaMap.isTexture && (n.alphaMap = this.alphaMap.toJSON(t1).uuid), this.lightMap && this.lightMap.isTexture && (n.lightMap = this.lightMap.toJSON(t1).uuid, n.lightMapIntensity = this.lightMapIntensity), this.aoMap && this.aoMap.isTexture && (n.aoMap = this.aoMap.toJSON(t1).uuid, n.aoMapIntensity = this.aoMapIntensity), this.bumpMap && this.bumpMap.isTexture && (n.bumpMap = this.bumpMap.toJSON(t1).uuid, n.bumpScale = this.bumpScale), this.normalMap && this.normalMap.isTexture && (n.normalMap = this.normalMap.toJSON(t1).uuid, n.normalMapType = this.normalMapType, n.normalScale = this.normalScale.toArray()), this.displacementMap && this.displacementMap.isTexture && (n.displacementMap = this.displacementMap.toJSON(t1).uuid, n.displacementScale = this.displacementScale, n.displacementBias = this.displacementBias), this.roughnessMap && this.roughnessMap.isTexture && (n.roughnessMap = this.roughnessMap.toJSON(t1).uuid), this.metalnessMap && this.metalnessMap.isTexture && (n.metalnessMap = this.metalnessMap.toJSON(t1).uuid), this.emissiveMap && this.emissiveMap.isTexture && (n.emissiveMap = this.emissiveMap.toJSON(t1).uuid), this.specularMap && this.specularMap.isTexture && (n.specularMap = this.specularMap.toJSON(t1).uuid), this.specularIntensityMap && this.specularIntensityMap.isTexture && (n.specularIntensityMap = this.specularIntensityMap.toJSON(t1).uuid), this.specularColorMap && this.specularColorMap.isTexture && (n.specularColorMap = this.specularColorMap.toJSON(t1).uuid), this.envMap && this.envMap.isTexture && (n.envMap = this.envMap.toJSON(t1).uuid, void 0 !== this.combine && (n.combine = this.combine)), void 0 !== this.envMapIntensity && (n.envMapIntensity = this.envMapIntensity), void 0 !== this.reflectivity && (n.reflectivity = this.reflectivity), void 0 !== this.refractionRatio && (n.refractionRatio = this.refractionRatio), this.gradientMap && this.gradientMap.isTexture && (n.gradientMap = this.gradientMap.toJSON(t1).uuid), void 0 !== this.transmission && (n.transmission = this.transmission), this.transmissionMap && this.transmissionMap.isTexture && (n.transmissionMap = this.transmissionMap.toJSON(t1).uuid), void 0 !== this.thickness && (n.thickness = this.thickness), this.thicknessMap && this.thicknessMap.isTexture && (n.thicknessMap = this.thicknessMap.toJSON(t1).uuid), void 0 !== this.attenuationDistance && (n.attenuationDistance = this.attenuationDistance), void 0 !== this.attenuationColor && (n.attenuationColor = this.attenuationColor.getHex()), void 0 !== this.size && (n.size = this.size), null !== this.shadowSide && (n.shadowSide = this.shadowSide), void 0 !== this.sizeAttenuation && (n.sizeAttenuation = this.sizeAttenuation), 1 !== this.blending && (n.blending = this.blending), 0 !== this.side && (n.side = this.side), this.vertexColors && (n.vertexColors = !0), this.opacity < 1 && (n.opacity = this.opacity), !0 === this.transparent && (n.transparent = this.transparent), n.depthFunc = this.depthFunc, n.depthTest = this.depthTest, n.depthWrite = this.depthWrite, n.colorWrite = this.colorWrite, n.stencilWrite = this.stencilWrite, n.stencilWriteMask = this.stencilWriteMask, n.stencilFunc = this.stencilFunc, n.stencilRef = this.stencilRef, n.stencilFuncMask = this.stencilFuncMask, n.stencilFail = this.stencilFail, n.stencilZFail = this.stencilZFail, n.stencilZPass = this.stencilZPass, void 0 !== this.rotation && 0 !== this.rotation && (n.rotation = this.rotation), !0 === this.polygonOffset && (n.polygonOffset = !0), 0 !== this.polygonOffsetFactor && (n.polygonOffsetFactor = this.polygonOffsetFactor), 0 !== this.polygonOffsetUnits && (n.polygonOffsetUnits = this.polygonOffsetUnits), void 0 !== this.linewidth && 1 !== this.linewidth && (n.linewidth = this.linewidth), void 0 !== this.dashSize && (n.dashSize = this.dashSize), void 0 !== this.gapSize && (n.gapSize = this.gapSize), void 0 !== this.scale && (n.scale = this.scale), !0 === this.dithering && (n.dithering = !0), this.alphaTest > 0 && (n.alphaTest = this.alphaTest), !0 === this.alphaToCoverage && (n.alphaToCoverage = this.alphaToCoverage), !0 === this.premultipliedAlpha && (n.premultipliedAlpha = this.premultipliedAlpha), !0 === this.wireframe && (n.wireframe = this.wireframe), this.wireframeLinewidth > 1 && (n.wireframeLinewidth = this.wireframeLinewidth), "round" !== this.wireframeLinecap && (n.wireframeLinecap = this.wireframeLinecap), "round" !== this.wireframeLinejoin && (n.wireframeLinejoin = this.wireframeLinejoin), !0 === this.flatShading && (n.flatShading = this.flatShading), !1 === this.visible && (n.visible = !1), !1 === this.toneMapped && (n.toneMapped = !1), "{}" !== JSON.stringify(this.userData) && (n.userData = this.userData), e) {
            const e = i(t1.textures), r = i(t1.images);
            e.length > 0 && (n.textures = e), r.length > 0 && (n.images = r);
        }
        return n;
    }
    clone() {
        return (new this.constructor).copy(this);
    }
    copy(t1) {
        this.name = t1.name, this.fog = t1.fog, this.blending = t1.blending, this.side = t1.side, this.vertexColors = t1.vertexColors, this.opacity = t1.opacity, this.transparent = t1.transparent, this.blendSrc = t1.blendSrc, this.blendDst = t1.blendDst, this.blendEquation = t1.blendEquation, this.blendSrcAlpha = t1.blendSrcAlpha, this.blendDstAlpha = t1.blendDstAlpha, this.blendEquationAlpha = t1.blendEquationAlpha, this.depthFunc = t1.depthFunc, this.depthTest = t1.depthTest, this.depthWrite = t1.depthWrite, this.stencilWriteMask = t1.stencilWriteMask, this.stencilFunc = t1.stencilFunc, this.stencilRef = t1.stencilRef, this.stencilFuncMask = t1.stencilFuncMask, this.stencilFail = t1.stencilFail, this.stencilZFail = t1.stencilZFail, this.stencilZPass = t1.stencilZPass, this.stencilWrite = t1.stencilWrite;
        const e = t1.clippingPlanes;
        let n = null;
        if (null !== e) {
            const t1 = e.length;
            n = new Array(t1);
            for(let i = 0; i !== t1; ++i)n[i] = e[i].clone();
        }
        return this.clippingPlanes = n, this.clipIntersection = t1.clipIntersection, this.clipShadows = t1.clipShadows, this.shadowSide = t1.shadowSide, this.colorWrite = t1.colorWrite, this.precision = t1.precision, this.polygonOffset = t1.polygonOffset, this.polygonOffsetFactor = t1.polygonOffsetFactor, this.polygonOffsetUnits = t1.polygonOffsetUnits, this.dithering = t1.dithering, this.alphaTest = t1.alphaTest, this.alphaToCoverage = t1.alphaToCoverage, this.premultipliedAlpha = t1.premultipliedAlpha, this.visible = t1.visible, this.toneMapped = t1.toneMapped, this.userData = JSON.parse(JSON.stringify(t1.userData)), this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
    set needsUpdate(t1) {
        !0 === t1 && this.version++;
    }
}
$fd4eb456bcbd06f8$var$ie.prototype.isMaterial = !0, $fd4eb456bcbd06f8$var$ie.fromType = function() {
    return null;
};
class $fd4eb456bcbd06f8$var$re extends $fd4eb456bcbd06f8$var$ie {
    constructor(t1){
        super(), this.type = "MeshBasicMaterial", this.color = new $fd4eb456bcbd06f8$var$L(16777215), this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.combine = 0, this.reflectivity = 1, this.refractionRatio = .98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.setValues(t1);
    }
    copy(t1) {
        return super.copy(t1), this.color.copy(t1.color), this.map = t1.map, this.lightMap = t1.lightMap, this.lightMapIntensity = t1.lightMapIntensity, this.aoMap = t1.aoMap, this.aoMapIntensity = t1.aoMapIntensity, this.specularMap = t1.specularMap, this.alphaMap = t1.alphaMap, this.envMap = t1.envMap, this.combine = t1.combine, this.reflectivity = t1.reflectivity, this.refractionRatio = t1.refractionRatio, this.wireframe = t1.wireframe, this.wireframeLinewidth = t1.wireframeLinewidth, this.wireframeLinecap = t1.wireframeLinecap, this.wireframeLinejoin = t1.wireframeLinejoin, this;
    }
}
$fd4eb456bcbd06f8$var$re.prototype.isMeshBasicMaterial = !0;
const $fd4eb456bcbd06f8$var$se = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$ae = new $fd4eb456bcbd06f8$var$g;
class $fd4eb456bcbd06f8$var$oe {
    constructor(t1, e, n){
        if (Array.isArray(t1)) throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
        this.name = "", this.array = t1, this.itemSize = e, this.count = void 0 !== t1 ? t1.length / e : 0, this.normalized = !0 === n, this.usage = 35044, this.updateRange = {
            offset: 0,
            count: -1
        }, this.version = 0;
    }
    onUploadCallback() {}
    set needsUpdate(t1) {
        !0 === t1 && this.version++;
    }
    setUsage(t1) {
        return this.usage = t1, this;
    }
    copy(t1) {
        return this.name = t1.name, this.array = new t1.array.constructor(t1.array), this.itemSize = t1.itemSize, this.count = t1.count, this.normalized = t1.normalized, this.usage = t1.usage, this;
    }
    copyAt(t1, e, n) {
        t1 *= this.itemSize, n *= e.itemSize;
        for(let i = 0, r = this.itemSize; i < r; i++)this.array[t1 + i] = e.array[n + i];
        return this;
    }
    copyArray(t1) {
        return this.array.set(t1), this;
    }
    copyColorsArray(t1) {
        const e = this.array;
        let n = 0;
        for(let i = 0, r = t1.length; i < r; i++){
            let r = t1[i];
            void 0 === r && (console.warn("THREE.BufferAttribute.copyColorsArray(): color is undefined", i), r = new $fd4eb456bcbd06f8$var$L), e[n++] = r.r, e[n++] = r.g, e[n++] = r.b;
        }
        return this;
    }
    copyVector2sArray(t1) {
        const e = this.array;
        let n = 0;
        for(let i = 0, r = t1.length; i < r; i++){
            let r = t1[i];
            void 0 === r && (console.warn("THREE.BufferAttribute.copyVector2sArray(): vector is undefined", i), r = new $fd4eb456bcbd06f8$var$g), e[n++] = r.x, e[n++] = r.y;
        }
        return this;
    }
    copyVector3sArray(t1) {
        const e = this.array;
        let n = 0;
        for(let i = 0, r = t1.length; i < r; i++){
            let r = t1[i];
            void 0 === r && (console.warn("THREE.BufferAttribute.copyVector3sArray(): vector is undefined", i), r = new $fd4eb456bcbd06f8$var$V), e[n++] = r.x, e[n++] = r.y, e[n++] = r.z;
        }
        return this;
    }
    copyVector4sArray(t1) {
        const e = this.array;
        let n = 0;
        for(let i = 0, r = t1.length; i < r; i++){
            let r = t1[i];
            void 0 === r && (console.warn("THREE.BufferAttribute.copyVector4sArray(): vector is undefined", i), r = new $fd4eb456bcbd06f8$var$U), e[n++] = r.x, e[n++] = r.y, e[n++] = r.z, e[n++] = r.w;
        }
        return this;
    }
    applyMatrix3(t1) {
        if (2 === this.itemSize) for(let e = 0, n = this.count; e < n; e++)$fd4eb456bcbd06f8$var$ae.fromBufferAttribute(this, e), $fd4eb456bcbd06f8$var$ae.applyMatrix3(t1), this.setXY(e, $fd4eb456bcbd06f8$var$ae.x, $fd4eb456bcbd06f8$var$ae.y);
        else if (3 === this.itemSize) for(let e = 0, n = this.count; e < n; e++)$fd4eb456bcbd06f8$var$se.fromBufferAttribute(this, e), $fd4eb456bcbd06f8$var$se.applyMatrix3(t1), this.setXYZ(e, $fd4eb456bcbd06f8$var$se.x, $fd4eb456bcbd06f8$var$se.y, $fd4eb456bcbd06f8$var$se.z);
        return this;
    }
    applyMatrix4(t1) {
        for(let e = 0, n = this.count; e < n; e++)$fd4eb456bcbd06f8$var$se.fromBufferAttribute(this, e), $fd4eb456bcbd06f8$var$se.applyMatrix4(t1), this.setXYZ(e, $fd4eb456bcbd06f8$var$se.x, $fd4eb456bcbd06f8$var$se.y, $fd4eb456bcbd06f8$var$se.z);
        return this;
    }
    applyNormalMatrix(t1) {
        for(let e = 0, n = this.count; e < n; e++)$fd4eb456bcbd06f8$var$se.fromBufferAttribute(this, e), $fd4eb456bcbd06f8$var$se.applyNormalMatrix(t1), this.setXYZ(e, $fd4eb456bcbd06f8$var$se.x, $fd4eb456bcbd06f8$var$se.y, $fd4eb456bcbd06f8$var$se.z);
        return this;
    }
    transformDirection(t1) {
        for(let e = 0, n = this.count; e < n; e++)$fd4eb456bcbd06f8$var$se.fromBufferAttribute(this, e), $fd4eb456bcbd06f8$var$se.transformDirection(t1), this.setXYZ(e, $fd4eb456bcbd06f8$var$se.x, $fd4eb456bcbd06f8$var$se.y, $fd4eb456bcbd06f8$var$se.z);
        return this;
    }
    set(t1, e = 0) {
        return this.array.set(t1, e), this;
    }
    getX(t1) {
        return this.array[t1 * this.itemSize];
    }
    setX(t1, e) {
        return this.array[t1 * this.itemSize] = e, this;
    }
    getY(t1) {
        return this.array[t1 * this.itemSize + 1];
    }
    setY(t1, e) {
        return this.array[t1 * this.itemSize + 1] = e, this;
    }
    getZ(t1) {
        return this.array[t1 * this.itemSize + 2];
    }
    setZ(t1, e) {
        return this.array[t1 * this.itemSize + 2] = e, this;
    }
    getW(t1) {
        return this.array[t1 * this.itemSize + 3];
    }
    setW(t1, e) {
        return this.array[t1 * this.itemSize + 3] = e, this;
    }
    setXY(t1, e, n) {
        return t1 *= this.itemSize, this.array[t1 + 0] = e, this.array[t1 + 1] = n, this;
    }
    setXYZ(t1, e, n, i) {
        return t1 *= this.itemSize, this.array[t1 + 0] = e, this.array[t1 + 1] = n, this.array[t1 + 2] = i, this;
    }
    setXYZW(t1, e, n, i, r) {
        return t1 *= this.itemSize, this.array[t1 + 0] = e, this.array[t1 + 1] = n, this.array[t1 + 2] = i, this.array[t1 + 3] = r, this;
    }
    onUpload(t1) {
        return this.onUploadCallback = t1, this;
    }
    clone() {
        return new this.constructor(this.array, this.itemSize).copy(this);
    }
    toJSON() {
        const t1 = {
            itemSize: this.itemSize,
            type: this.array.constructor.name,
            array: Array.prototype.slice.call(this.array),
            normalized: this.normalized
        };
        return "" !== this.name && (t1.name = this.name), 35044 !== this.usage && (t1.usage = this.usage), 0 === this.updateRange.offset && -1 === this.updateRange.count || (t1.updateRange = this.updateRange), t1;
    }
}
$fd4eb456bcbd06f8$var$oe.prototype.isBufferAttribute = !0;
class $fd4eb456bcbd06f8$var$le extends $fd4eb456bcbd06f8$var$oe {
    constructor(t1, e, n){
        super(new Uint16Array(t1), e, n);
    }
}
class $fd4eb456bcbd06f8$var$he extends $fd4eb456bcbd06f8$var$oe {
    constructor(t1, e, n){
        super(new Uint32Array(t1), e, n);
    }
}
(class extends $fd4eb456bcbd06f8$var$oe {
    constructor(t1, e, n){
        super(new Uint16Array(t1), e, n);
    }
}).prototype.isFloat16BufferAttribute = !0;
class $fd4eb456bcbd06f8$var$ce extends $fd4eb456bcbd06f8$var$oe {
    constructor(t1, e, n){
        super(new Float32Array(t1), e, n);
    }
}
let $fd4eb456bcbd06f8$var$ue = 0;
const $fd4eb456bcbd06f8$var$de = new $fd4eb456bcbd06f8$var$xt, $fd4eb456bcbd06f8$var$pe = new $fd4eb456bcbd06f8$var$Wt, $fd4eb456bcbd06f8$var$me = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$fe = new $fd4eb456bcbd06f8$var$j, $fd4eb456bcbd06f8$var$ge = new $fd4eb456bcbd06f8$var$j, $fd4eb456bcbd06f8$var$ve = new $fd4eb456bcbd06f8$var$V;
class $fd4eb456bcbd06f8$var$ye extends $fd4eb456bcbd06f8$var$i {
    constructor(){
        super(), Object.defineProperty(this, "id", {
            value: $fd4eb456bcbd06f8$var$ue++
        }), this.uuid = $fd4eb456bcbd06f8$var$l(), this.name = "", this.type = "BufferGeometry", this.index = null, this.attributes = {}, this.morphAttributes = {}, this.morphTargetsRelative = !1, this.groups = [], this.boundingBox = null, this.boundingSphere = null, this.drawRange = {
            start: 0,
            count: 1 / 0
        }, this.userData = {};
    }
    getIndex() {
        return this.index;
    }
    setIndex(t1) {
        return Array.isArray(t1) ? this.index = new ($fd4eb456bcbd06f8$var$y(t1) ? $fd4eb456bcbd06f8$var$he : $fd4eb456bcbd06f8$var$le)(t1, 1) : this.index = t1, this;
    }
    getAttribute(t1) {
        return this.attributes[t1];
    }
    setAttribute(t1, e) {
        return this.attributes[t1] = e, this;
    }
    deleteAttribute(t1) {
        return delete this.attributes[t1], this;
    }
    hasAttribute(t1) {
        return void 0 !== this.attributes[t1];
    }
    addGroup(t1, e, n = 0) {
        this.groups.push({
            start: t1,
            count: e,
            materialIndex: n
        });
    }
    clearGroups() {
        this.groups = [];
    }
    setDrawRange(t1, e) {
        this.drawRange.start = t1, this.drawRange.count = e;
    }
    applyMatrix4(t1) {
        const e = this.attributes.position;
        void 0 !== e && (e.applyMatrix4(t1), e.needsUpdate = !0);
        const n = this.attributes.normal;
        if (void 0 !== n) {
            const e = (new $fd4eb456bcbd06f8$var$v).getNormalMatrix(t1);
            n.applyNormalMatrix(e), n.needsUpdate = !0;
        }
        const i = this.attributes.tangent;
        return void 0 !== i && (i.transformDirection(t1), i.needsUpdate = !0), null !== this.boundingBox && this.computeBoundingBox(), null !== this.boundingSphere && this.computeBoundingSphere(), this;
    }
    applyQuaternion(t1) {
        return $fd4eb456bcbd06f8$var$de.makeRotationFromQuaternion(t1), this.applyMatrix4($fd4eb456bcbd06f8$var$de), this;
    }
    rotateX(t1) {
        return $fd4eb456bcbd06f8$var$de.makeRotationX(t1), this.applyMatrix4($fd4eb456bcbd06f8$var$de), this;
    }
    rotateY(t1) {
        return $fd4eb456bcbd06f8$var$de.makeRotationY(t1), this.applyMatrix4($fd4eb456bcbd06f8$var$de), this;
    }
    rotateZ(t1) {
        return $fd4eb456bcbd06f8$var$de.makeRotationZ(t1), this.applyMatrix4($fd4eb456bcbd06f8$var$de), this;
    }
    translate(t1, e, n) {
        return $fd4eb456bcbd06f8$var$de.makeTranslation(t1, e, n), this.applyMatrix4($fd4eb456bcbd06f8$var$de), this;
    }
    scale(t1, e, n) {
        return $fd4eb456bcbd06f8$var$de.makeScale(t1, e, n), this.applyMatrix4($fd4eb456bcbd06f8$var$de), this;
    }
    lookAt(t1) {
        return $fd4eb456bcbd06f8$var$pe.lookAt(t1), $fd4eb456bcbd06f8$var$pe.updateMatrix(), this.applyMatrix4($fd4eb456bcbd06f8$var$pe.matrix), this;
    }
    center() {
        return this.computeBoundingBox(), this.boundingBox.getCenter($fd4eb456bcbd06f8$var$me).negate(), this.translate($fd4eb456bcbd06f8$var$me.x, $fd4eb456bcbd06f8$var$me.y, $fd4eb456bcbd06f8$var$me.z), this;
    }
    setFromPoints(t1) {
        const e = [];
        for(let n = 0, i = t1.length; n < i; n++){
            const i = t1[n];
            e.push(i.x, i.y, i.z || 0);
        }
        return this.setAttribute("position", new $fd4eb456bcbd06f8$var$ce(e, 3)), this;
    }
    computeBoundingBox() {
        null === this.boundingBox && (this.boundingBox = new $fd4eb456bcbd06f8$var$j);
        const t1 = this.attributes.position, e = this.morphAttributes.position;
        if (t1 && t1.isGLBufferAttribute) return console.error('THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box. Alternatively set "mesh.frustumCulled" to "false".', this), void this.boundingBox.set(new $fd4eb456bcbd06f8$var$V(-1 / 0, -1 / 0, -1 / 0), new $fd4eb456bcbd06f8$var$V(1 / 0, 1 / 0, 1 / 0));
        if (void 0 !== t1) {
            if (this.boundingBox.setFromBufferAttribute(t1), e) for(let t1 = 0, n = e.length; t1 < n; t1++){
                const n = e[t1];
                $fd4eb456bcbd06f8$var$fe.setFromBufferAttribute(n), this.morphTargetsRelative ? ($fd4eb456bcbd06f8$var$ve.addVectors(this.boundingBox.min, $fd4eb456bcbd06f8$var$fe.min), this.boundingBox.expandByPoint($fd4eb456bcbd06f8$var$ve), $fd4eb456bcbd06f8$var$ve.addVectors(this.boundingBox.max, $fd4eb456bcbd06f8$var$fe.max), this.boundingBox.expandByPoint($fd4eb456bcbd06f8$var$ve)) : (this.boundingBox.expandByPoint($fd4eb456bcbd06f8$var$fe.min), this.boundingBox.expandByPoint($fd4eb456bcbd06f8$var$fe.max));
            }
        } else this.boundingBox.makeEmpty();
        (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) && console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
    }
    computeBoundingSphere() {
        null === this.boundingSphere && (this.boundingSphere = new $fd4eb456bcbd06f8$var$ct);
        const t1 = this.attributes.position, e = this.morphAttributes.position;
        if (t1 && t1.isGLBufferAttribute) return console.error('THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere. Alternatively set "mesh.frustumCulled" to "false".', this), void this.boundingSphere.set(new $fd4eb456bcbd06f8$var$V, 1 / 0);
        if (t1) {
            const n = this.boundingSphere.center;
            if ($fd4eb456bcbd06f8$var$fe.setFromBufferAttribute(t1), e) for(let t1 = 0, n = e.length; t1 < n; t1++){
                const n = e[t1];
                $fd4eb456bcbd06f8$var$ge.setFromBufferAttribute(n), this.morphTargetsRelative ? ($fd4eb456bcbd06f8$var$ve.addVectors($fd4eb456bcbd06f8$var$fe.min, $fd4eb456bcbd06f8$var$ge.min), $fd4eb456bcbd06f8$var$fe.expandByPoint($fd4eb456bcbd06f8$var$ve), $fd4eb456bcbd06f8$var$ve.addVectors($fd4eb456bcbd06f8$var$fe.max, $fd4eb456bcbd06f8$var$ge.max), $fd4eb456bcbd06f8$var$fe.expandByPoint($fd4eb456bcbd06f8$var$ve)) : ($fd4eb456bcbd06f8$var$fe.expandByPoint($fd4eb456bcbd06f8$var$ge.min), $fd4eb456bcbd06f8$var$fe.expandByPoint($fd4eb456bcbd06f8$var$ge.max));
            }
            $fd4eb456bcbd06f8$var$fe.getCenter(n);
            let i = 0;
            for(let e = 0, r = t1.count; e < r; e++)$fd4eb456bcbd06f8$var$ve.fromBufferAttribute(t1, e), i = Math.max(i, n.distanceToSquared($fd4eb456bcbd06f8$var$ve));
            if (e) for(let r = 0, s = e.length; r < s; r++){
                const s = e[r], a = this.morphTargetsRelative;
                for(let e = 0, r = s.count; e < r; e++)$fd4eb456bcbd06f8$var$ve.fromBufferAttribute(s, e), a && ($fd4eb456bcbd06f8$var$me.fromBufferAttribute(t1, e), $fd4eb456bcbd06f8$var$ve.add($fd4eb456bcbd06f8$var$me)), i = Math.max(i, n.distanceToSquared($fd4eb456bcbd06f8$var$ve));
            }
            this.boundingSphere.radius = Math.sqrt(i), isNaN(this.boundingSphere.radius) && console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
        }
    }
    computeTangents() {
        const t1 = this.index, e = this.attributes;
        if (null === t1 || void 0 === e.position || void 0 === e.normal || void 0 === e.uv) return void console.error("THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");
        const n = t1.array, i = e.position.array, r = e.normal.array, s = e.uv.array, a = i.length / 3;
        !1 === this.hasAttribute("tangent") && this.setAttribute("tangent", new $fd4eb456bcbd06f8$var$oe(new Float32Array(4 * a), 4));
        const o = this.getAttribute("tangent").array, l = [], h = [];
        for(let t1 = 0; t1 < a; t1++)l[t1] = new $fd4eb456bcbd06f8$var$V, h[t1] = new $fd4eb456bcbd06f8$var$V;
        const c = new $fd4eb456bcbd06f8$var$V, u = new $fd4eb456bcbd06f8$var$V, d = new $fd4eb456bcbd06f8$var$V, p = new $fd4eb456bcbd06f8$var$g, m = new $fd4eb456bcbd06f8$var$g, f = new $fd4eb456bcbd06f8$var$g, v = new $fd4eb456bcbd06f8$var$V, y = new $fd4eb456bcbd06f8$var$V;
        function x(t1, e, n) {
            c.fromArray(i, 3 * t1), u.fromArray(i, 3 * e), d.fromArray(i, 3 * n), p.fromArray(s, 2 * t1), m.fromArray(s, 2 * e), f.fromArray(s, 2 * n), u.sub(c), d.sub(c), m.sub(p), f.sub(p);
            const r = 1 / (m.x * f.y - f.x * m.y);
            isFinite(r) && (v.copy(u).multiplyScalar(f.y).addScaledVector(d, -m.y).multiplyScalar(r), y.copy(d).multiplyScalar(m.x).addScaledVector(u, -f.x).multiplyScalar(r), l[t1].add(v), l[e].add(v), l[n].add(v), h[t1].add(y), h[e].add(y), h[n].add(y));
        }
        let b = this.groups;
        0 === b.length && (b = [
            {
                start: 0,
                count: n.length
            }
        ]);
        for(let t1 = 0, e = b.length; t1 < e; ++t1){
            const e = b[t1], i = e.start;
            for(let t1 = i, r = i + e.count; t1 < r; t1 += 3)x(n[t1 + 0], n[t1 + 1], n[t1 + 2]);
        }
        const _ = new $fd4eb456bcbd06f8$var$V, w = new $fd4eb456bcbd06f8$var$V, M = new $fd4eb456bcbd06f8$var$V, S = new $fd4eb456bcbd06f8$var$V;
        function T(t1) {
            M.fromArray(r, 3 * t1), S.copy(M);
            const e = l[t1];
            _.copy(e), _.sub(M.multiplyScalar(M.dot(e))).normalize(), w.crossVectors(S, e);
            const n = w.dot(h[t1]) < 0 ? -1 : 1;
            o[4 * t1] = _.x, o[4 * t1 + 1] = _.y, o[4 * t1 + 2] = _.z, o[4 * t1 + 3] = n;
        }
        for(let t1 = 0, e = b.length; t1 < e; ++t1){
            const e = b[t1], i = e.start;
            for(let t1 = i, r = i + e.count; t1 < r; t1 += 3)T(n[t1 + 0]), T(n[t1 + 1]), T(n[t1 + 2]);
        }
    }
    computeVertexNormals() {
        const t1 = this.index, e = this.getAttribute("position");
        if (void 0 !== e) {
            let n = this.getAttribute("normal");
            if (void 0 === n) n = new $fd4eb456bcbd06f8$var$oe(new Float32Array(3 * e.count), 3), this.setAttribute("normal", n);
            else for(let t1 = 0, e = n.count; t1 < e; t1++)n.setXYZ(t1, 0, 0, 0);
            const i = new $fd4eb456bcbd06f8$var$V, r = new $fd4eb456bcbd06f8$var$V, s = new $fd4eb456bcbd06f8$var$V, a = new $fd4eb456bcbd06f8$var$V, o = new $fd4eb456bcbd06f8$var$V, l = new $fd4eb456bcbd06f8$var$V, h = new $fd4eb456bcbd06f8$var$V, c = new $fd4eb456bcbd06f8$var$V;
            if (t1) for(let u = 0, d = t1.count; u < d; u += 3){
                const d = t1.getX(u + 0), p = t1.getX(u + 1), m = t1.getX(u + 2);
                i.fromBufferAttribute(e, d), r.fromBufferAttribute(e, p), s.fromBufferAttribute(e, m), h.subVectors(s, r), c.subVectors(i, r), h.cross(c), a.fromBufferAttribute(n, d), o.fromBufferAttribute(n, p), l.fromBufferAttribute(n, m), a.add(h), o.add(h), l.add(h), n.setXYZ(d, a.x, a.y, a.z), n.setXYZ(p, o.x, o.y, o.z), n.setXYZ(m, l.x, l.y, l.z);
            }
            else for(let t1 = 0, a = e.count; t1 < a; t1 += 3)i.fromBufferAttribute(e, t1 + 0), r.fromBufferAttribute(e, t1 + 1), s.fromBufferAttribute(e, t1 + 2), h.subVectors(s, r), c.subVectors(i, r), h.cross(c), n.setXYZ(t1 + 0, h.x, h.y, h.z), n.setXYZ(t1 + 1, h.x, h.y, h.z), n.setXYZ(t1 + 2, h.x, h.y, h.z);
            this.normalizeNormals(), n.needsUpdate = !0;
        }
    }
    merge(t1, e) {
        if (!t1 || !t1.isBufferGeometry) return void console.error("THREE.BufferGeometry.merge(): geometry not an instance of THREE.BufferGeometry.", t1);
        void 0 === e && (e = 0, console.warn("THREE.BufferGeometry.merge(): Overwriting original geometry, starting at offset=0. Use BufferGeometryUtils.mergeBufferGeometries() for lossless merge."));
        const n = this.attributes;
        for(const i in n){
            if (void 0 === t1.attributes[i]) continue;
            const r = n[i].array, s = t1.attributes[i], a = s.array, o = s.itemSize * e, l = Math.min(a.length, r.length - o);
            for(let t1 = 0, e = o; t1 < l; t1++, e++)r[e] = a[t1];
        }
        return this;
    }
    normalizeNormals() {
        const t1 = this.attributes.normal;
        for(let e = 0, n = t1.count; e < n; e++)$fd4eb456bcbd06f8$var$ve.fromBufferAttribute(t1, e), $fd4eb456bcbd06f8$var$ve.normalize(), t1.setXYZ(e, $fd4eb456bcbd06f8$var$ve.x, $fd4eb456bcbd06f8$var$ve.y, $fd4eb456bcbd06f8$var$ve.z);
    }
    toNonIndexed() {
        function t1(t1, e) {
            const n = t1.array, i = t1.itemSize, r = t1.normalized, s = new n.constructor(e.length * i);
            let a = 0, o = 0;
            for(let r = 0, l = e.length; r < l; r++){
                a = t1.isInterleavedBufferAttribute ? e[r] * t1.data.stride + t1.offset : e[r] * i;
                for(let t1 = 0; t1 < i; t1++)s[o++] = n[a++];
            }
            return new $fd4eb456bcbd06f8$var$oe(s, i, r);
        }
        if (null === this.index) return console.warn("THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed."), this;
        const e = new $fd4eb456bcbd06f8$var$ye, n = this.index.array, i = this.attributes;
        for(const r in i){
            const s = t1(i[r], n);
            e.setAttribute(r, s);
        }
        const r = this.morphAttributes;
        for(const i in r){
            const s = [], a = r[i];
            for(let e = 0, i = a.length; e < i; e++){
                const i = t1(a[e], n);
                s.push(i);
            }
            e.morphAttributes[i] = s;
        }
        e.morphTargetsRelative = this.morphTargetsRelative;
        const s = this.groups;
        for(let t1 = 0, n = s.length; t1 < n; t1++){
            const n = s[t1];
            e.addGroup(n.start, n.count, n.materialIndex);
        }
        return e;
    }
    toJSON() {
        const t1 = {
            metadata: {
                version: 4.5,
                type: "BufferGeometry",
                generator: "BufferGeometry.toJSON"
            }
        };
        if (t1.uuid = this.uuid, t1.type = this.type, "" !== this.name && (t1.name = this.name), Object.keys(this.userData).length > 0 && (t1.userData = this.userData), void 0 !== this.parameters) {
            const e = this.parameters;
            for(const n in e)void 0 !== e[n] && (t1[n] = e[n]);
            return t1;
        }
        t1.data = {
            attributes: {}
        };
        const e = this.index;
        null !== e && (t1.data.index = {
            type: e.array.constructor.name,
            array: Array.prototype.slice.call(e.array)
        });
        const n = this.attributes;
        for(const e in n){
            const i = n[e];
            t1.data.attributes[e] = i.toJSON(t1.data);
        }
        const i = {};
        let r = !1;
        for(const e in this.morphAttributes){
            const n = this.morphAttributes[e], s = [];
            for(let e = 0, i = n.length; e < i; e++){
                const i = n[e];
                s.push(i.toJSON(t1.data));
            }
            s.length > 0 && (i[e] = s, r = !0);
        }
        r && (t1.data.morphAttributes = i, t1.data.morphTargetsRelative = this.morphTargetsRelative);
        const s = this.groups;
        s.length > 0 && (t1.data.groups = JSON.parse(JSON.stringify(s)));
        const a = this.boundingSphere;
        return null !== a && (t1.data.boundingSphere = {
            center: a.center.toArray(),
            radius: a.radius
        }), t1;
    }
    clone() {
        return (new this.constructor).copy(this);
    }
    copy(t1) {
        this.index = null, this.attributes = {}, this.morphAttributes = {}, this.groups = [], this.boundingBox = null, this.boundingSphere = null;
        const e = {};
        this.name = t1.name;
        const n = t1.index;
        null !== n && this.setIndex(n.clone(e));
        const i = t1.attributes;
        for(const t1 in i){
            const n = i[t1];
            this.setAttribute(t1, n.clone(e));
        }
        const r = t1.morphAttributes;
        for(const t1 in r){
            const n = [], i = r[t1];
            for(let t1 = 0, r = i.length; t1 < r; t1++)n.push(i[t1].clone(e));
            this.morphAttributes[t1] = n;
        }
        this.morphTargetsRelative = t1.morphTargetsRelative;
        const s = t1.groups;
        for(let t1 = 0, e = s.length; t1 < e; t1++){
            const e = s[t1];
            this.addGroup(e.start, e.count, e.materialIndex);
        }
        const a = t1.boundingBox;
        null !== a && (this.boundingBox = a.clone());
        const o = t1.boundingSphere;
        return null !== o && (this.boundingSphere = o.clone()), this.drawRange.start = t1.drawRange.start, this.drawRange.count = t1.drawRange.count, this.userData = t1.userData, void 0 !== t1.parameters && (this.parameters = Object.assign({}, t1.parameters)), this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}
$fd4eb456bcbd06f8$var$ye.prototype.isBufferGeometry = !0;
const $fd4eb456bcbd06f8$var$xe = new $fd4eb456bcbd06f8$var$xt, $fd4eb456bcbd06f8$var$be = new $fd4eb456bcbd06f8$var$yt, $fd4eb456bcbd06f8$var$_e = new $fd4eb456bcbd06f8$var$ct, $fd4eb456bcbd06f8$var$we = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$Me = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$Se = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$Te = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$Ee = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$Ae = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$Re = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$Ce = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$Le = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$Pe = new $fd4eb456bcbd06f8$var$g, $fd4eb456bcbd06f8$var$De = new $fd4eb456bcbd06f8$var$g, $fd4eb456bcbd06f8$var$Ie = new $fd4eb456bcbd06f8$var$g, $fd4eb456bcbd06f8$var$Oe = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$Ne = new $fd4eb456bcbd06f8$var$V;
class $fd4eb456bcbd06f8$var$Fe extends $fd4eb456bcbd06f8$var$Wt {
    constructor(t1 = new $fd4eb456bcbd06f8$var$ye, e = new $fd4eb456bcbd06f8$var$re){
        super(), this.type = "Mesh", this.geometry = t1, this.material = e, this.updateMorphTargets();
    }
    copy(t1) {
        return super.copy(t1), void 0 !== t1.morphTargetInfluences && (this.morphTargetInfluences = t1.morphTargetInfluences.slice()), void 0 !== t1.morphTargetDictionary && (this.morphTargetDictionary = Object.assign({}, t1.morphTargetDictionary)), this.material = t1.material, this.geometry = t1.geometry, this;
    }
    updateMorphTargets() {
        const t1 = this.geometry;
        if (t1.isBufferGeometry) {
            const e = t1.morphAttributes, n = Object.keys(e);
            if (n.length > 0) {
                const t1 = e[n[0]];
                if (void 0 !== t1) {
                    this.morphTargetInfluences = [], this.morphTargetDictionary = {};
                    for(let e = 0, n = t1.length; e < n; e++){
                        const n = t1[e].name || String(e);
                        this.morphTargetInfluences.push(0), this.morphTargetDictionary[n] = e;
                    }
                }
            }
        } else {
            const e = t1.morphTargets;
            void 0 !== e && e.length > 0 && console.error("THREE.Mesh.updateMorphTargets() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
        }
    }
    raycast(t1, e) {
        const n = this.geometry, i = this.material, r = this.matrixWorld;
        if (void 0 === i) return;
        if (null === n.boundingSphere && n.computeBoundingSphere(), $fd4eb456bcbd06f8$var$_e.copy(n.boundingSphere), $fd4eb456bcbd06f8$var$_e.applyMatrix4(r), !1 === t1.ray.intersectsSphere($fd4eb456bcbd06f8$var$_e)) return;
        if ($fd4eb456bcbd06f8$var$xe.copy(r).invert(), $fd4eb456bcbd06f8$var$be.copy(t1.ray).applyMatrix4($fd4eb456bcbd06f8$var$xe), null !== n.boundingBox && !1 === $fd4eb456bcbd06f8$var$be.intersectsBox(n.boundingBox)) return;
        let s;
        if (n.isBufferGeometry) {
            const r = n.index, a = n.attributes.position, o = n.morphAttributes.position, l = n.morphTargetsRelative, h = n.attributes.uv, c = n.attributes.uv2, u = n.groups, d = n.drawRange;
            if (null !== r) {
                if (Array.isArray(i)) for(let n = 0, p = u.length; n < p; n++){
                    const p = u[n], m = i[p.materialIndex];
                    for(let n = Math.max(p.start, d.start), i = Math.min(r.count, Math.min(p.start + p.count, d.start + d.count)); n < i; n += 3){
                        const i = r.getX(n), u = r.getX(n + 1), d = r.getX(n + 2);
                        s = $fd4eb456bcbd06f8$var$Ue(this, m, t1, $fd4eb456bcbd06f8$var$be, a, o, l, h, c, i, u, d), s && (s.faceIndex = Math.floor(n / 3), s.face.materialIndex = p.materialIndex, e.push(s));
                    }
                }
                else for(let n = Math.max(0, d.start), u = Math.min(r.count, d.start + d.count); n < u; n += 3){
                    const u = r.getX(n), d = r.getX(n + 1), p = r.getX(n + 2);
                    s = $fd4eb456bcbd06f8$var$Ue(this, i, t1, $fd4eb456bcbd06f8$var$be, a, o, l, h, c, u, d, p), s && (s.faceIndex = Math.floor(n / 3), e.push(s));
                }
            } else if (void 0 !== a) {
                if (Array.isArray(i)) for(let n = 0, r = u.length; n < r; n++){
                    const r = u[n], p = i[r.materialIndex];
                    for(let n = Math.max(r.start, d.start), i = Math.min(a.count, Math.min(r.start + r.count, d.start + d.count)); n < i; n += 3)s = $fd4eb456bcbd06f8$var$Ue(this, p, t1, $fd4eb456bcbd06f8$var$be, a, o, l, h, c, n, n + 1, n + 2), s && (s.faceIndex = Math.floor(n / 3), s.face.materialIndex = r.materialIndex, e.push(s));
                }
                else for(let n = Math.max(0, d.start), r = Math.min(a.count, d.start + d.count); n < r; n += 3)s = $fd4eb456bcbd06f8$var$Ue(this, i, t1, $fd4eb456bcbd06f8$var$be, a, o, l, h, c, n, n + 1, n + 2), s && (s.faceIndex = Math.floor(n / 3), e.push(s));
            }
        } else n.isGeometry && console.error("THREE.Mesh.raycast() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
    }
}
function $fd4eb456bcbd06f8$var$Ue(t1, e, n, i, r, s, a, o, l, h, c, u) {
    $fd4eb456bcbd06f8$var$we.fromBufferAttribute(r, h), $fd4eb456bcbd06f8$var$Me.fromBufferAttribute(r, c), $fd4eb456bcbd06f8$var$Se.fromBufferAttribute(r, u);
    const d = t1.morphTargetInfluences;
    if (s && d) {
        $fd4eb456bcbd06f8$var$Re.set(0, 0, 0), $fd4eb456bcbd06f8$var$Ce.set(0, 0, 0), $fd4eb456bcbd06f8$var$Le.set(0, 0, 0);
        for(let t1 = 0, e = s.length; t1 < e; t1++){
            const e = d[t1], n = s[t1];
            0 !== e && ($fd4eb456bcbd06f8$var$Te.fromBufferAttribute(n, h), $fd4eb456bcbd06f8$var$Ee.fromBufferAttribute(n, c), $fd4eb456bcbd06f8$var$Ae.fromBufferAttribute(n, u), a ? ($fd4eb456bcbd06f8$var$Re.addScaledVector($fd4eb456bcbd06f8$var$Te, e), $fd4eb456bcbd06f8$var$Ce.addScaledVector($fd4eb456bcbd06f8$var$Ee, e), $fd4eb456bcbd06f8$var$Le.addScaledVector($fd4eb456bcbd06f8$var$Ae, e)) : ($fd4eb456bcbd06f8$var$Re.addScaledVector($fd4eb456bcbd06f8$var$Te.sub($fd4eb456bcbd06f8$var$we), e), $fd4eb456bcbd06f8$var$Ce.addScaledVector($fd4eb456bcbd06f8$var$Ee.sub($fd4eb456bcbd06f8$var$Me), e), $fd4eb456bcbd06f8$var$Le.addScaledVector($fd4eb456bcbd06f8$var$Ae.sub($fd4eb456bcbd06f8$var$Se), e)));
        }
        $fd4eb456bcbd06f8$var$we.add($fd4eb456bcbd06f8$var$Re), $fd4eb456bcbd06f8$var$Me.add($fd4eb456bcbd06f8$var$Ce), $fd4eb456bcbd06f8$var$Se.add($fd4eb456bcbd06f8$var$Le);
    }
    t1.isSkinnedMesh && (t1.boneTransform(h, $fd4eb456bcbd06f8$var$we), t1.boneTransform(c, $fd4eb456bcbd06f8$var$Me), t1.boneTransform(u, $fd4eb456bcbd06f8$var$Se));
    const p = function(t1, e, n, i, r, s, a, o) {
        let l;
        if (l = 1 === e.side ? i.intersectTriangle(a, s, r, !0, o) : i.intersectTriangle(r, s, a, 2 !== e.side, o), null === l) return null;
        $fd4eb456bcbd06f8$var$Ne.copy(o), $fd4eb456bcbd06f8$var$Ne.applyMatrix4(t1.matrixWorld);
        const h = n.ray.origin.distanceTo($fd4eb456bcbd06f8$var$Ne);
        return h < n.near || h > n.far ? null : {
            distance: h,
            point: $fd4eb456bcbd06f8$var$Ne.clone(),
            object: t1
        };
    }(t1, e, n, i, $fd4eb456bcbd06f8$var$we, $fd4eb456bcbd06f8$var$Me, $fd4eb456bcbd06f8$var$Se, $fd4eb456bcbd06f8$var$Oe);
    if (p) {
        o && ($fd4eb456bcbd06f8$var$Pe.fromBufferAttribute(o, h), $fd4eb456bcbd06f8$var$De.fromBufferAttribute(o, c), $fd4eb456bcbd06f8$var$Ie.fromBufferAttribute(o, u), p.uv = $fd4eb456bcbd06f8$var$ee.getUV($fd4eb456bcbd06f8$var$Oe, $fd4eb456bcbd06f8$var$we, $fd4eb456bcbd06f8$var$Me, $fd4eb456bcbd06f8$var$Se, $fd4eb456bcbd06f8$var$Pe, $fd4eb456bcbd06f8$var$De, $fd4eb456bcbd06f8$var$Ie, new $fd4eb456bcbd06f8$var$g)), l && ($fd4eb456bcbd06f8$var$Pe.fromBufferAttribute(l, h), $fd4eb456bcbd06f8$var$De.fromBufferAttribute(l, c), $fd4eb456bcbd06f8$var$Ie.fromBufferAttribute(l, u), p.uv2 = $fd4eb456bcbd06f8$var$ee.getUV($fd4eb456bcbd06f8$var$Oe, $fd4eb456bcbd06f8$var$we, $fd4eb456bcbd06f8$var$Me, $fd4eb456bcbd06f8$var$Se, $fd4eb456bcbd06f8$var$Pe, $fd4eb456bcbd06f8$var$De, $fd4eb456bcbd06f8$var$Ie, new $fd4eb456bcbd06f8$var$g));
        const t1 = {
            a: h,
            b: c,
            c: u,
            normal: new $fd4eb456bcbd06f8$var$V,
            materialIndex: 0
        };
        $fd4eb456bcbd06f8$var$ee.getNormal($fd4eb456bcbd06f8$var$we, $fd4eb456bcbd06f8$var$Me, $fd4eb456bcbd06f8$var$Se, t1.normal), p.face = t1;
    }
    return p;
}
$fd4eb456bcbd06f8$var$Fe.prototype.isMesh = !0;
class $fd4eb456bcbd06f8$var$ke extends $fd4eb456bcbd06f8$var$ye {
    constructor(t1 = 1, e = 1, n = 1, i = 1, r = 1, s = 1){
        super(), this.type = "BoxGeometry", this.parameters = {
            width: t1,
            height: e,
            depth: n,
            widthSegments: i,
            heightSegments: r,
            depthSegments: s
        };
        const a = this;
        i = Math.floor(i), r = Math.floor(r), s = Math.floor(s);
        const o = [], l = [], h = [], c = [];
        let u = 0, d = 0;
        function p(t1, e, n, i, r, s, p, m, f, g, v) {
            const y = s / f, x = p / g, b = s / 2, _ = p / 2, w = m / 2, M = f + 1, S = g + 1;
            let T = 0, E = 0;
            const A = new $fd4eb456bcbd06f8$var$V;
            for(let s = 0; s < S; s++){
                const a = s * x - _;
                for(let o = 0; o < M; o++){
                    const u = o * y - b;
                    A[t1] = u * i, A[e] = a * r, A[n] = w, l.push(A.x, A.y, A.z), A[t1] = 0, A[e] = 0, A[n] = m > 0 ? 1 : -1, h.push(A.x, A.y, A.z), c.push(o / f), c.push(1 - s / g), T += 1;
                }
            }
            for(let t1 = 0; t1 < g; t1++)for(let e = 0; e < f; e++){
                const n = u + e + M * t1, i = u + e + M * (t1 + 1), r = u + (e + 1) + M * (t1 + 1), s = u + (e + 1) + M * t1;
                o.push(n, i, s), o.push(i, r, s), E += 6;
            }
            a.addGroup(d, E, v), d += E, u += T;
        }
        p("z", "y", "x", -1, -1, n, e, t1, s, r, 0), p("z", "y", "x", 1, -1, n, e, -t1, s, r, 1), p("x", "z", "y", 1, 1, t1, n, e, i, s, 2), p("x", "z", "y", 1, -1, t1, n, -e, i, s, 3), p("x", "y", "z", 1, -1, t1, e, n, i, r, 4), p("x", "y", "z", -1, -1, t1, e, -n, i, r, 5), this.setIndex(o), this.setAttribute("position", new $fd4eb456bcbd06f8$var$ce(l, 3)), this.setAttribute("normal", new $fd4eb456bcbd06f8$var$ce(h, 3)), this.setAttribute("uv", new $fd4eb456bcbd06f8$var$ce(c, 2));
    }
    static fromJSON(t1) {
        return new $fd4eb456bcbd06f8$var$ke(t1.width, t1.height, t1.depth, t1.widthSegments, t1.heightSegments, t1.depthSegments);
    }
}
function $fd4eb456bcbd06f8$var$Be(t1) {
    const e = {};
    for(const n in t1){
        e[n] = {};
        for(const i in t1[n]){
            const r = t1[n][i];
            r && (r.isColor || r.isMatrix3 || r.isMatrix4 || r.isVector2 || r.isVector3 || r.isVector4 || r.isTexture || r.isQuaternion) ? e[n][i] = r.clone() : Array.isArray(r) ? e[n][i] = r.slice() : e[n][i] = r;
        }
    }
    return e;
}
function $fd4eb456bcbd06f8$var$ze(t1) {
    const e = {};
    for(let n = 0; n < t1.length; n++){
        const i = $fd4eb456bcbd06f8$var$Be(t1[n]);
        for(const t1 in i)e[t1] = i[t1];
    }
    return e;
}
const $fd4eb456bcbd06f8$var$He = {
    clone: $fd4eb456bcbd06f8$var$Be,
    merge: $fd4eb456bcbd06f8$var$ze
};
class $fd4eb456bcbd06f8$var$Ve extends $fd4eb456bcbd06f8$var$ie {
    constructor(t1){
        super(), this.type = "ShaderMaterial", this.defines = {}, this.uniforms = {}, this.vertexShader = "void main() {\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}", this.fragmentShader = "void main() {\n\tgl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}", this.linewidth = 1, this.wireframe = !1, this.wireframeLinewidth = 1, this.fog = !1, this.lights = !1, this.clipping = !1, this.extensions = {
            derivatives: !1,
            fragDepth: !1,
            drawBuffers: !1,
            shaderTextureLOD: !1
        }, this.defaultAttributeValues = {
            color: [
                1,
                1,
                1
            ],
            uv: [
                0,
                0
            ],
            uv2: [
                0,
                0
            ]
        }, this.index0AttributeName = void 0, this.uniformsNeedUpdate = !1, this.glslVersion = null, void 0 !== t1 && (void 0 !== t1.attributes && console.error("THREE.ShaderMaterial: attributes should now be defined in THREE.BufferGeometry instead."), this.setValues(t1));
    }
    copy(t1) {
        return super.copy(t1), this.fragmentShader = t1.fragmentShader, this.vertexShader = t1.vertexShader, this.uniforms = $fd4eb456bcbd06f8$var$Be(t1.uniforms), this.defines = Object.assign({}, t1.defines), this.wireframe = t1.wireframe, this.wireframeLinewidth = t1.wireframeLinewidth, this.lights = t1.lights, this.clipping = t1.clipping, this.extensions = Object.assign({}, t1.extensions), this.glslVersion = t1.glslVersion, this;
    }
    toJSON(t1) {
        const e = super.toJSON(t1);
        e.glslVersion = this.glslVersion, e.uniforms = {};
        for(const n in this.uniforms){
            const i = this.uniforms[n].value;
            i && i.isTexture ? e.uniforms[n] = {
                type: "t",
                value: i.toJSON(t1).uuid
            } : i && i.isColor ? e.uniforms[n] = {
                type: "c",
                value: i.getHex()
            } : i && i.isVector2 ? e.uniforms[n] = {
                type: "v2",
                value: i.toArray()
            } : i && i.isVector3 ? e.uniforms[n] = {
                type: "v3",
                value: i.toArray()
            } : i && i.isVector4 ? e.uniforms[n] = {
                type: "v4",
                value: i.toArray()
            } : i && i.isMatrix3 ? e.uniforms[n] = {
                type: "m3",
                value: i.toArray()
            } : i && i.isMatrix4 ? e.uniforms[n] = {
                type: "m4",
                value: i.toArray()
            } : e.uniforms[n] = {
                value: i
            };
        }
        Object.keys(this.defines).length > 0 && (e.defines = this.defines), e.vertexShader = this.vertexShader, e.fragmentShader = this.fragmentShader;
        const n = {};
        for(const t1 in this.extensions)!0 === this.extensions[t1] && (n[t1] = !0);
        return Object.keys(n).length > 0 && (e.extensions = n), e;
    }
}
$fd4eb456bcbd06f8$var$Ve.prototype.isShaderMaterial = !0;
class $fd4eb456bcbd06f8$var$Ge extends $fd4eb456bcbd06f8$var$Wt {
    constructor(){
        super(), this.type = "Camera", this.matrixWorldInverse = new $fd4eb456bcbd06f8$var$xt, this.projectionMatrix = new $fd4eb456bcbd06f8$var$xt, this.projectionMatrixInverse = new $fd4eb456bcbd06f8$var$xt;
    }
    copy(t1, e) {
        return super.copy(t1, e), this.matrixWorldInverse.copy(t1.matrixWorldInverse), this.projectionMatrix.copy(t1.projectionMatrix), this.projectionMatrixInverse.copy(t1.projectionMatrixInverse), this;
    }
    getWorldDirection(t1) {
        this.updateWorldMatrix(!0, !1);
        const e = this.matrixWorld.elements;
        return t1.set(-e[8], -e[9], -e[10]).normalize();
    }
    updateMatrixWorld(t1) {
        super.updateMatrixWorld(t1), this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    updateWorldMatrix(t1, e) {
        super.updateWorldMatrix(t1, e), this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    clone() {
        return (new this.constructor).copy(this);
    }
}
$fd4eb456bcbd06f8$var$Ge.prototype.isCamera = !0;
class $fd4eb456bcbd06f8$var$We extends $fd4eb456bcbd06f8$var$Ge {
    constructor(t1 = 50, e = 1, n = .1, i = 2e3){
        super(), this.type = "PerspectiveCamera", this.fov = t1, this.zoom = 1, this.near = n, this.far = i, this.focus = 10, this.aspect = e, this.view = null, this.filmGauge = 35, this.filmOffset = 0, this.updateProjectionMatrix();
    }
    copy(t1, e) {
        return super.copy(t1, e), this.fov = t1.fov, this.zoom = t1.zoom, this.near = t1.near, this.far = t1.far, this.focus = t1.focus, this.aspect = t1.aspect, this.view = null === t1.view ? null : Object.assign({}, t1.view), this.filmGauge = t1.filmGauge, this.filmOffset = t1.filmOffset, this;
    }
    setFocalLength(t1) {
        const e = .5 * this.getFilmHeight() / t1;
        this.fov = 2 * $fd4eb456bcbd06f8$var$o * Math.atan(e), this.updateProjectionMatrix();
    }
    getFocalLength() {
        const t1 = Math.tan(.5 * $fd4eb456bcbd06f8$var$a * this.fov);
        return .5 * this.getFilmHeight() / t1;
    }
    getEffectiveFOV() {
        return 2 * $fd4eb456bcbd06f8$var$o * Math.atan(Math.tan(.5 * $fd4eb456bcbd06f8$var$a * this.fov) / this.zoom);
    }
    getFilmWidth() {
        return this.filmGauge * Math.min(this.aspect, 1);
    }
    getFilmHeight() {
        return this.filmGauge / Math.max(this.aspect, 1);
    }
    setViewOffset(t1, e, n, i, r, s) {
        this.aspect = t1 / e, null === this.view && (this.view = {
            enabled: !0,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        }), this.view.enabled = !0, this.view.fullWidth = t1, this.view.fullHeight = e, this.view.offsetX = n, this.view.offsetY = i, this.view.width = r, this.view.height = s, this.updateProjectionMatrix();
    }
    clearViewOffset() {
        null !== this.view && (this.view.enabled = !1), this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        const t1 = this.near;
        let e = t1 * Math.tan(.5 * $fd4eb456bcbd06f8$var$a * this.fov) / this.zoom, n = 2 * e, i = this.aspect * n, r = -0.5 * i;
        const s = this.view;
        if (null !== this.view && this.view.enabled) {
            const t1 = s.fullWidth, a = s.fullHeight;
            r += s.offsetX * i / t1, e -= s.offsetY * n / a, i *= s.width / t1, n *= s.height / a;
        }
        const o = this.filmOffset;
        0 !== o && (r += t1 * o / this.getFilmWidth()), this.projectionMatrix.makePerspective(r, r + i, e, e - n, t1, this.far), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(t1) {
        const e = super.toJSON(t1);
        return e.object.fov = this.fov, e.object.zoom = this.zoom, e.object.near = this.near, e.object.far = this.far, e.object.focus = this.focus, e.object.aspect = this.aspect, null !== this.view && (e.object.view = Object.assign({}, this.view)), e.object.filmGauge = this.filmGauge, e.object.filmOffset = this.filmOffset, e;
    }
}
$fd4eb456bcbd06f8$var$We.prototype.isPerspectiveCamera = !0;
class $fd4eb456bcbd06f8$var$je extends $fd4eb456bcbd06f8$var$Wt {
    constructor(t1, e, n){
        if (super(), this.type = "CubeCamera", !0 !== n.isWebGLCubeRenderTarget) return void console.error("THREE.CubeCamera: The constructor now expects an instance of WebGLCubeRenderTarget as third parameter.");
        this.renderTarget = n;
        const i = new $fd4eb456bcbd06f8$var$We(90, 1, t1, e);
        i.layers = this.layers, i.up.set(0, -1, 0), i.lookAt(new $fd4eb456bcbd06f8$var$V(1, 0, 0)), this.add(i);
        const r = new $fd4eb456bcbd06f8$var$We(90, 1, t1, e);
        r.layers = this.layers, r.up.set(0, -1, 0), r.lookAt(new $fd4eb456bcbd06f8$var$V(-1, 0, 0)), this.add(r);
        const s = new $fd4eb456bcbd06f8$var$We(90, 1, t1, e);
        s.layers = this.layers, s.up.set(0, 0, 1), s.lookAt(new $fd4eb456bcbd06f8$var$V(0, 1, 0)), this.add(s);
        const a = new $fd4eb456bcbd06f8$var$We(90, 1, t1, e);
        a.layers = this.layers, a.up.set(0, 0, -1), a.lookAt(new $fd4eb456bcbd06f8$var$V(0, -1, 0)), this.add(a);
        const o = new $fd4eb456bcbd06f8$var$We(90, 1, t1, e);
        o.layers = this.layers, o.up.set(0, -1, 0), o.lookAt(new $fd4eb456bcbd06f8$var$V(0, 0, 1)), this.add(o);
        const l = new $fd4eb456bcbd06f8$var$We(90, 1, t1, e);
        l.layers = this.layers, l.up.set(0, -1, 0), l.lookAt(new $fd4eb456bcbd06f8$var$V(0, 0, -1)), this.add(l);
    }
    update(t1, e) {
        null === this.parent && this.updateMatrixWorld();
        const n = this.renderTarget, [i, r, s, a, o, l] = this.children, h = t1.getRenderTarget(), c = t1.outputEncoding, u = t1.toneMapping, d = t1.xr.enabled;
        t1.outputEncoding = 3e3, t1.toneMapping = 0, t1.xr.enabled = !1;
        const p = n.texture.generateMipmaps;
        n.texture.generateMipmaps = !1, t1.setRenderTarget(n, 0), t1.render(e, i), t1.setRenderTarget(n, 1), t1.render(e, r), t1.setRenderTarget(n, 2), t1.render(e, s), t1.setRenderTarget(n, 3), t1.render(e, a), t1.setRenderTarget(n, 4), t1.render(e, o), n.texture.generateMipmaps = p, t1.setRenderTarget(n, 5), t1.render(e, l), t1.setRenderTarget(h), t1.outputEncoding = c, t1.toneMapping = u, t1.xr.enabled = d, n.texture.needsPMREMUpdate = !0;
    }
}
class $fd4eb456bcbd06f8$var$qe extends $fd4eb456bcbd06f8$var$F {
    constructor(t1, e, n, i, r, s, a, o, l, h){
        super(t1 = void 0 !== t1 ? t1 : [], e = void 0 !== e ? e : 301, n, i, r, s, a, o, l, h), this.flipY = !1;
    }
    get images() {
        return this.image;
    }
    set images(t1) {
        this.image = t1;
    }
}
$fd4eb456bcbd06f8$var$qe.prototype.isCubeTexture = !0;
class $fd4eb456bcbd06f8$var$Xe extends $fd4eb456bcbd06f8$var$k {
    constructor(t1, e = {}){
        super(t1, t1, e);
        const n = {
            width: t1,
            height: t1,
            depth: 1
        }, i = [
            n,
            n,
            n,
            n,
            n,
            n
        ];
        this.texture = new $fd4eb456bcbd06f8$var$qe(i, e.mapping, e.wrapS, e.wrapT, e.magFilter, e.minFilter, e.format, e.type, e.anisotropy, e.encoding), this.texture.isRenderTargetTexture = !0, this.texture.generateMipmaps = void 0 !== e.generateMipmaps && e.generateMipmaps, this.texture.minFilter = void 0 !== e.minFilter ? e.minFilter : 1006;
    }
    fromEquirectangularTexture(t1, e) {
        this.texture.type = e.type, this.texture.encoding = e.encoding, this.texture.generateMipmaps = e.generateMipmaps, this.texture.minFilter = e.minFilter, this.texture.magFilter = e.magFilter;
        const n = {
            uniforms: {
                tEquirect: {
                    value: null
                }
            },
            vertexShader: "\n\n\t\t\t\tvarying vec3 vWorldDirection;\n\n\t\t\t\tvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\n\t\t\t\t\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n\n\t\t\t\t}\n\n\t\t\t\tvoid main() {\n\n\t\t\t\t\tvWorldDirection = transformDirection( position, modelMatrix );\n\n\t\t\t\t\t#include <begin_vertex>\n\t\t\t\t\t#include <project_vertex>\n\n\t\t\t\t}\n\t\t\t",
            fragmentShader: "\n\n\t\t\t\tuniform sampler2D tEquirect;\n\n\t\t\t\tvarying vec3 vWorldDirection;\n\n\t\t\t\t#include <common>\n\n\t\t\t\tvoid main() {\n\n\t\t\t\t\tvec3 direction = normalize( vWorldDirection );\n\n\t\t\t\t\tvec2 sampleUV = equirectUv( direction );\n\n\t\t\t\t\tgl_FragColor = texture2D( tEquirect, sampleUV );\n\n\t\t\t\t}\n\t\t\t"
        }, i = new $fd4eb456bcbd06f8$var$ke(5, 5, 5), r = new $fd4eb456bcbd06f8$var$Ve({
            name: "CubemapFromEquirect",
            uniforms: $fd4eb456bcbd06f8$var$Be(n.uniforms),
            vertexShader: n.vertexShader,
            fragmentShader: n.fragmentShader,
            side: 1,
            blending: 0
        });
        r.uniforms.tEquirect.value = e;
        const s = new $fd4eb456bcbd06f8$var$Fe(i, r), a = e.minFilter;
        1008 === e.minFilter && (e.minFilter = 1006);
        return new $fd4eb456bcbd06f8$var$je(1, 10, this).update(t1, s), e.minFilter = a, s.geometry.dispose(), s.material.dispose(), this;
    }
    clear(t1, e, n, i) {
        const r = t1.getRenderTarget();
        for(let r = 0; r < 6; r++)t1.setRenderTarget(this, r), t1.clear(e, n, i);
        t1.setRenderTarget(r);
    }
}
$fd4eb456bcbd06f8$var$Xe.prototype.isWebGLCubeRenderTarget = !0;
const $fd4eb456bcbd06f8$var$$e = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$Ye = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$Je = new $fd4eb456bcbd06f8$var$v;
class $fd4eb456bcbd06f8$var$Ke {
    constructor(t1 = new $fd4eb456bcbd06f8$var$V(1, 0, 0), e = 0){
        this.normal = t1, this.constant = e;
    }
    set(t1, e) {
        return this.normal.copy(t1), this.constant = e, this;
    }
    setComponents(t1, e, n, i) {
        return this.normal.set(t1, e, n), this.constant = i, this;
    }
    setFromNormalAndCoplanarPoint(t1, e) {
        return this.normal.copy(t1), this.constant = -e.dot(this.normal), this;
    }
    setFromCoplanarPoints(t1, e, n) {
        const i = $fd4eb456bcbd06f8$var$$e.subVectors(n, e).cross($fd4eb456bcbd06f8$var$Ye.subVectors(t1, e)).normalize();
        return this.setFromNormalAndCoplanarPoint(i, t1), this;
    }
    copy(t1) {
        return this.normal.copy(t1.normal), this.constant = t1.constant, this;
    }
    normalize() {
        const t1 = 1 / this.normal.length();
        return this.normal.multiplyScalar(t1), this.constant *= t1, this;
    }
    negate() {
        return this.constant *= -1, this.normal.negate(), this;
    }
    distanceToPoint(t1) {
        return this.normal.dot(t1) + this.constant;
    }
    distanceToSphere(t1) {
        return this.distanceToPoint(t1.center) - t1.radius;
    }
    projectPoint(t1, e) {
        return e.copy(this.normal).multiplyScalar(-this.distanceToPoint(t1)).add(t1);
    }
    intersectLine(t1, e) {
        const n = t1.delta($fd4eb456bcbd06f8$var$$e), i = this.normal.dot(n);
        if (0 === i) return 0 === this.distanceToPoint(t1.start) ? e.copy(t1.start) : null;
        const r = -(t1.start.dot(this.normal) + this.constant) / i;
        return r < 0 || r > 1 ? null : e.copy(n).multiplyScalar(r).add(t1.start);
    }
    intersectsLine(t1) {
        const e = this.distanceToPoint(t1.start), n = this.distanceToPoint(t1.end);
        return e < 0 && n > 0 || n < 0 && e > 0;
    }
    intersectsBox(t1) {
        return t1.intersectsPlane(this);
    }
    intersectsSphere(t1) {
        return t1.intersectsPlane(this);
    }
    coplanarPoint(t1) {
        return t1.copy(this.normal).multiplyScalar(-this.constant);
    }
    applyMatrix4(t1, e) {
        const n = e || $fd4eb456bcbd06f8$var$Je.getNormalMatrix(t1), i = this.coplanarPoint($fd4eb456bcbd06f8$var$$e).applyMatrix4(t1), r = this.normal.applyMatrix3(n).normalize();
        return this.constant = -i.dot(r), this;
    }
    translate(t1) {
        return this.constant -= t1.dot(this.normal), this;
    }
    equals(t1) {
        return t1.normal.equals(this.normal) && t1.constant === this.constant;
    }
    clone() {
        return (new this.constructor).copy(this);
    }
}
$fd4eb456bcbd06f8$var$Ke.prototype.isPlane = !0;
const $fd4eb456bcbd06f8$var$Ze = new $fd4eb456bcbd06f8$var$ct, $fd4eb456bcbd06f8$var$Qe = new $fd4eb456bcbd06f8$var$V;
class $fd4eb456bcbd06f8$var$tn {
    constructor(t1 = new $fd4eb456bcbd06f8$var$Ke, e = new $fd4eb456bcbd06f8$var$Ke, n = new $fd4eb456bcbd06f8$var$Ke, i = new $fd4eb456bcbd06f8$var$Ke, r = new $fd4eb456bcbd06f8$var$Ke, s = new $fd4eb456bcbd06f8$var$Ke){
        this.planes = [
            t1,
            e,
            n,
            i,
            r,
            s
        ];
    }
    set(t1, e, n, i, r, s) {
        const a = this.planes;
        return a[0].copy(t1), a[1].copy(e), a[2].copy(n), a[3].copy(i), a[4].copy(r), a[5].copy(s), this;
    }
    copy(t1) {
        const e = this.planes;
        for(let n = 0; n < 6; n++)e[n].copy(t1.planes[n]);
        return this;
    }
    setFromProjectionMatrix(t1) {
        const e = this.planes, n = t1.elements, i = n[0], r = n[1], s = n[2], a = n[3], o = n[4], l = n[5], h = n[6], c = n[7], u = n[8], d = n[9], p = n[10], m = n[11], f = n[12], g = n[13], v = n[14], y = n[15];
        return e[0].setComponents(a - i, c - o, m - u, y - f).normalize(), e[1].setComponents(a + i, c + o, m + u, y + f).normalize(), e[2].setComponents(a + r, c + l, m + d, y + g).normalize(), e[3].setComponents(a - r, c - l, m - d, y - g).normalize(), e[4].setComponents(a - s, c - h, m - p, y - v).normalize(), e[5].setComponents(a + s, c + h, m + p, y + v).normalize(), this;
    }
    intersectsObject(t1) {
        const e = t1.geometry;
        return null === e.boundingSphere && e.computeBoundingSphere(), $fd4eb456bcbd06f8$var$Ze.copy(e.boundingSphere).applyMatrix4(t1.matrixWorld), this.intersectsSphere($fd4eb456bcbd06f8$var$Ze);
    }
    intersectsSprite(t1) {
        return $fd4eb456bcbd06f8$var$Ze.center.set(0, 0, 0), $fd4eb456bcbd06f8$var$Ze.radius = .7071067811865476, $fd4eb456bcbd06f8$var$Ze.applyMatrix4(t1.matrixWorld), this.intersectsSphere($fd4eb456bcbd06f8$var$Ze);
    }
    intersectsSphere(t1) {
        const e = this.planes, n = t1.center, i = -t1.radius;
        for(let t1 = 0; t1 < 6; t1++){
            if (e[t1].distanceToPoint(n) < i) return !1;
        }
        return !0;
    }
    intersectsBox(t1) {
        const e = this.planes;
        for(let n = 0; n < 6; n++){
            const i = e[n];
            if ($fd4eb456bcbd06f8$var$Qe.x = i.normal.x > 0 ? t1.max.x : t1.min.x, $fd4eb456bcbd06f8$var$Qe.y = i.normal.y > 0 ? t1.max.y : t1.min.y, $fd4eb456bcbd06f8$var$Qe.z = i.normal.z > 0 ? t1.max.z : t1.min.z, i.distanceToPoint($fd4eb456bcbd06f8$var$Qe) < 0) return !1;
        }
        return !0;
    }
    containsPoint(t1) {
        const e = this.planes;
        for(let n = 0; n < 6; n++)if (e[n].distanceToPoint(t1) < 0) return !1;
        return !0;
    }
    clone() {
        return (new this.constructor).copy(this);
    }
}
function $fd4eb456bcbd06f8$var$en() {
    let t1 = null, e = !1, n = null, i = null;
    function r(e, s) {
        n(e, s), i = t1.requestAnimationFrame(r);
    }
    return {
        start: function() {
            !0 !== e && null !== n && (i = t1.requestAnimationFrame(r), e = !0);
        },
        stop: function() {
            t1.cancelAnimationFrame(i), e = !1;
        },
        setAnimationLoop: function(t1) {
            n = t1;
        },
        setContext: function(e) {
            t1 = e;
        }
    };
}
function $fd4eb456bcbd06f8$var$nn(t1, e) {
    const n = e.isWebGL2, i = new WeakMap;
    return {
        get: function(t1) {
            return t1.isInterleavedBufferAttribute && (t1 = t1.data), i.get(t1);
        },
        remove: function(e) {
            e.isInterleavedBufferAttribute && (e = e.data);
            const n = i.get(e);
            n && (t1.deleteBuffer(n.buffer), i.delete(e));
        },
        update: function(e, r) {
            if (e.isGLBufferAttribute) {
                const t1 = i.get(e);
                return void ((!t1 || t1.version < e.version) && i.set(e, {
                    buffer: e.buffer,
                    type: e.type,
                    bytesPerElement: e.elementSize,
                    version: e.version
                }));
            }
            e.isInterleavedBufferAttribute && (e = e.data);
            const s = i.get(e);
            void 0 === s ? i.set(e, function(e, i) {
                const r = e.array, s = e.usage, a = t1.createBuffer();
                let o;
                if (t1.bindBuffer(i, a), t1.bufferData(i, r, s), e.onUploadCallback(), r instanceof Float32Array) o = 5126;
                else if (r instanceof Uint16Array) {
                    if (e.isFloat16BufferAttribute) {
                        if (!n) throw new Error("THREE.WebGLAttributes: Usage of Float16BufferAttribute requires WebGL2.");
                        o = 5131;
                    } else o = 5123;
                } else if (r instanceof Int16Array) o = 5122;
                else if (r instanceof Uint32Array) o = 5125;
                else if (r instanceof Int32Array) o = 5124;
                else if (r instanceof Int8Array) o = 5120;
                else if (r instanceof Uint8Array) o = 5121;
                else {
                    if (!(r instanceof Uint8ClampedArray)) throw new Error("THREE.WebGLAttributes: Unsupported buffer data format: " + r);
                    o = 5121;
                }
                return {
                    buffer: a,
                    type: o,
                    bytesPerElement: r.BYTES_PER_ELEMENT,
                    version: e.version
                };
            }(e, r)) : s.version < e.version && (!function(e, i, r) {
                const s = i.array, a = i.updateRange;
                t1.bindBuffer(r, e), -1 === a.count ? t1.bufferSubData(r, 0, s) : (n ? t1.bufferSubData(r, a.offset * s.BYTES_PER_ELEMENT, s, a.offset, a.count) : t1.bufferSubData(r, a.offset * s.BYTES_PER_ELEMENT, s.subarray(a.offset, a.offset + a.count)), a.count = -1);
            }(s.buffer, e, r), s.version = e.version);
        }
    };
}
class $fd4eb456bcbd06f8$var$rn extends $fd4eb456bcbd06f8$var$ye {
    constructor(t1 = 1, e = 1, n = 1, i = 1){
        super(), this.type = "PlaneGeometry", this.parameters = {
            width: t1,
            height: e,
            widthSegments: n,
            heightSegments: i
        };
        const r = t1 / 2, s = e / 2, a = Math.floor(n), o = Math.floor(i), l = a + 1, h = o + 1, c = t1 / a, u = e / o, d = [], p = [], m = [], f = [];
        for(let t1 = 0; t1 < h; t1++){
            const e = t1 * u - s;
            for(let n = 0; n < l; n++){
                const i = n * c - r;
                p.push(i, -e, 0), m.push(0, 0, 1), f.push(n / a), f.push(1 - t1 / o);
            }
        }
        for(let t1 = 0; t1 < o; t1++)for(let e = 0; e < a; e++){
            const n = e + l * t1, i = e + l * (t1 + 1), r = e + 1 + l * (t1 + 1), s = e + 1 + l * t1;
            d.push(n, i, s), d.push(i, r, s);
        }
        this.setIndex(d), this.setAttribute("position", new $fd4eb456bcbd06f8$var$ce(p, 3)), this.setAttribute("normal", new $fd4eb456bcbd06f8$var$ce(m, 3)), this.setAttribute("uv", new $fd4eb456bcbd06f8$var$ce(f, 2));
    }
    static fromJSON(t1) {
        return new $fd4eb456bcbd06f8$var$rn(t1.width, t1.height, t1.widthSegments, t1.heightSegments);
    }
}
const $fd4eb456bcbd06f8$var$sn = {
    alphamap_fragment: "#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, vUv ).g;\n#endif",
    alphamap_pars_fragment: "#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif",
    alphatest_fragment: "#ifdef USE_ALPHATEST\n\tif ( diffuseColor.a < alphaTest ) discard;\n#endif",
    alphatest_pars_fragment: "#ifdef USE_ALPHATEST\n\tuniform float alphaTest;\n#endif",
    aomap_fragment: "#ifdef USE_AOMAP\n\tfloat ambientOcclusion = ( texture2D( aoMap, vUv2 ).r - 1.0 ) * aoMapIntensity + 1.0;\n\treflectedLight.indirectDiffuse *= ambientOcclusion;\n\t#if defined( USE_ENVMAP ) && defined( STANDARD )\n\t\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\t\treflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n\t#endif\n#endif",
    aomap_pars_fragment: "#ifdef USE_AOMAP\n\tuniform sampler2D aoMap;\n\tuniform float aoMapIntensity;\n#endif",
    begin_vertex: "vec3 transformed = vec3( position );",
    beginnormal_vertex: "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n\tvec3 objectTangent = vec3( tangent.xyz );\n#endif",
    bsdfs: "vec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n\treturn RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\tfloat gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\treturn 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n\tfloat a2 = pow2( alpha );\n\tfloat denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n\treturn RECIPROCAL_PI * a2 / pow2( denom );\n}\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 f0, const in float f90, const in float roughness ) {\n\tfloat alpha = pow2( roughness );\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( f0, f90, dotVH );\n\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\tfloat D = D_GGX( alpha, dotNH );\n\treturn F * ( V * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n\tconst float LUT_SIZE = 64.0;\n\tconst float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n\tconst float LUT_BIAS = 0.5 / LUT_SIZE;\n\tfloat dotNV = saturate( dot( N, V ) );\n\tvec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n\tuv = uv * LUT_SCALE + LUT_BIAS;\n\treturn uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n\tfloat l = length( f );\n\treturn max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n\tfloat x = dot( v1, v2 );\n\tfloat y = abs( x );\n\tfloat a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n\tfloat b = 3.4175940 + ( 4.1616724 + y ) * y;\n\tfloat v = a / b;\n\tfloat theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n\treturn cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n\tvec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n\tvec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n\tvec3 lightNormal = cross( v1, v2 );\n\tif( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n\tvec3 T1, T2;\n\tT1 = normalize( V - N * dot( V, N ) );\n\tT2 = - cross( N, T1 );\n\tmat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n\tvec3 coords[ 4 ];\n\tcoords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n\tcoords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n\tcoords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n\tcoords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n\tcoords[ 0 ] = normalize( coords[ 0 ] );\n\tcoords[ 1 ] = normalize( coords[ 1 ] );\n\tcoords[ 2 ] = normalize( coords[ 2 ] );\n\tcoords[ 3 ] = normalize( coords[ 3 ] );\n\tvec3 vectorFormFactor = vec3( 0.0 );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n\tfloat result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n\treturn vec3( result );\n}\nfloat G_BlinnPhong_Implicit( ) {\n\treturn 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n\treturn RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, 1.0, dotVH );\n\tfloat G = G_BlinnPhong_Implicit( );\n\tfloat D = D_BlinnPhong( shininess, dotNH );\n\treturn F * ( G * D );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n\tfloat alpha = pow2( roughness );\n\tfloat invAlpha = 1.0 / alpha;\n\tfloat cos2h = dotNH * dotNH;\n\tfloat sin2h = max( 1.0 - cos2h, 0.0078125 );\n\treturn ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n\treturn saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat D = D_Charlie( sheenRoughness, dotNH );\n\tfloat V = V_Neubelt( dotNV, dotNL );\n\treturn sheenColor * ( D * V );\n}\n#endif",
    bumpmap_pars_fragment: "#ifdef USE_BUMPMAP\n\tuniform sampler2D bumpMap;\n\tuniform float bumpScale;\n\tvec2 dHdxy_fwd() {\n\t\tvec2 dSTdx = dFdx( vUv );\n\t\tvec2 dSTdy = dFdy( vUv );\n\t\tfloat Hll = bumpScale * texture2D( bumpMap, vUv ).x;\n\t\tfloat dBx = bumpScale * texture2D( bumpMap, vUv + dSTdx ).x - Hll;\n\t\tfloat dBy = bumpScale * texture2D( bumpMap, vUv + dSTdy ).x - Hll;\n\t\treturn vec2( dBx, dBy );\n\t}\n\tvec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n\t\tvec3 vSigmaX = vec3( dFdx( surf_pos.x ), dFdx( surf_pos.y ), dFdx( surf_pos.z ) );\n\t\tvec3 vSigmaY = vec3( dFdy( surf_pos.x ), dFdy( surf_pos.y ), dFdy( surf_pos.z ) );\n\t\tvec3 vN = surf_norm;\n\t\tvec3 R1 = cross( vSigmaY, vN );\n\t\tvec3 R2 = cross( vN, vSigmaX );\n\t\tfloat fDet = dot( vSigmaX, R1 ) * faceDirection;\n\t\tvec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n\t\treturn normalize( abs( fDet ) * surf_norm - vGrad );\n\t}\n#endif",
    clipping_planes_fragment: "#if NUM_CLIPPING_PLANES > 0\n\tvec4 plane;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\tplane = clippingPlanes[ i ];\n\t\tif ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n\t}\n\t#pragma unroll_loop_end\n\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\tbool clipped = true;\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tclipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\tif ( clipped ) discard;\n\t#endif\n#endif",
    clipping_planes_pars_fragment: "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n\tuniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif",
    clipping_planes_pars_vertex: "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n#endif",
    clipping_planes_vertex: "#if NUM_CLIPPING_PLANES > 0\n\tvClipPosition = - mvPosition.xyz;\n#endif",
    color_fragment: "#if defined( USE_COLOR_ALPHA )\n\tdiffuseColor *= vColor;\n#elif defined( USE_COLOR )\n\tdiffuseColor.rgb *= vColor;\n#endif",
    color_pars_fragment: "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR )\n\tvarying vec3 vColor;\n#endif",
    color_pars_vertex: "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n\tvarying vec3 vColor;\n#endif",
    color_vertex: "#if defined( USE_COLOR_ALPHA )\n\tvColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n\tvColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n\tvColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n\tvColor.xyz *= instanceColor.xyz;\n#endif",
    common: "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 color ) { return dot( color, vec3( 0.3333 ) ); }\nhighp float rand( const in vec2 uv ) {\n\tconst highp float a = 12.9898, b = 78.233, c = 43758.5453;\n\thighp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n\treturn fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n\tfloat precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n\tfloat precisionSafeLength( vec3 v ) {\n\t\tfloat maxComponent = max3( abs( v ) );\n\t\treturn length( v / maxComponent ) * maxComponent;\n\t}\n#endif\nstruct IncidentLight {\n\tvec3 color;\n\tvec3 direction;\n\tbool visible;\n};\nstruct ReflectedLight {\n\tvec3 directDiffuse;\n\tvec3 directSpecular;\n\tvec3 indirectDiffuse;\n\tvec3 indirectSpecular;\n};\nstruct GeometricContext {\n\tvec3 position;\n\tvec3 normal;\n\tvec3 viewDir;\n#ifdef USE_CLEARCOAT\n\tvec3 clearcoatNormal;\n#endif\n};\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nmat3 transposeMat3( const in mat3 m ) {\n\tmat3 tmp;\n\ttmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n\ttmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n\ttmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n\treturn tmp;\n}\nfloat linearToRelativeLuminance( const in vec3 color ) {\n\tvec3 weights = vec3( 0.2126, 0.7152, 0.0722 );\n\treturn dot( weights, color.rgb );\n}\nbool isPerspectiveMatrix( mat4 m ) {\n\treturn m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n\tfloat u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n\tfloat v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\treturn vec2( u, v );\n}",
    cube_uv_reflection_fragment: "#ifdef ENVMAP_TYPE_CUBE_UV\n\t#define cubeUV_minMipLevel 4.0\n\t#define cubeUV_minTileSize 16.0\n\tfloat getFace( vec3 direction ) {\n\t\tvec3 absDirection = abs( direction );\n\t\tfloat face = - 1.0;\n\t\tif ( absDirection.x > absDirection.z ) {\n\t\t\tif ( absDirection.x > absDirection.y )\n\t\t\t\tface = direction.x > 0.0 ? 0.0 : 3.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t} else {\n\t\t\tif ( absDirection.z > absDirection.y )\n\t\t\t\tface = direction.z > 0.0 ? 2.0 : 5.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t}\n\t\treturn face;\n\t}\n\tvec2 getUV( vec3 direction, float face ) {\n\t\tvec2 uv;\n\t\tif ( face == 0.0 ) {\n\t\t\tuv = vec2( direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 1.0 ) {\n\t\t\tuv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n\t\t} else if ( face == 2.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.y ) / abs( direction.z );\n\t\t} else if ( face == 3.0 ) {\n\t\t\tuv = vec2( - direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 4.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.z ) / abs( direction.y );\n\t\t} else {\n\t\t\tuv = vec2( direction.x, direction.y ) / abs( direction.z );\n\t\t}\n\t\treturn 0.5 * ( uv + 1.0 );\n\t}\n\tvec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n\t\tfloat face = getFace( direction );\n\t\tfloat filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n\t\tmipInt = max( mipInt, cubeUV_minMipLevel );\n\t\tfloat faceSize = exp2( mipInt );\n\t\tvec2 uv = getUV( direction, face ) * ( faceSize - 1.0 ) + 0.5;\n\t\tif ( face > 2.0 ) {\n\t\t\tuv.y += faceSize;\n\t\t\tface -= 3.0;\n\t\t}\n\t\tuv.x += face * faceSize;\n\t\tuv.x += filterInt * 3.0 * cubeUV_minTileSize;\n\t\tuv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\n\t\tuv.x *= CUBEUV_TEXEL_WIDTH;\n\t\tuv.y *= CUBEUV_TEXEL_HEIGHT;\n\t\t#ifdef texture2DGradEXT\n\t\t\treturn texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\n\t\t#else\n\t\t\treturn texture2D( envMap, uv ).rgb;\n\t\t#endif\n\t}\n\t#define r0 1.0\n\t#define v0 0.339\n\t#define m0 - 2.0\n\t#define r1 0.8\n\t#define v1 0.276\n\t#define m1 - 1.0\n\t#define r4 0.4\n\t#define v4 0.046\n\t#define m4 2.0\n\t#define r5 0.305\n\t#define v5 0.016\n\t#define m5 3.0\n\t#define r6 0.21\n\t#define v6 0.0038\n\t#define m6 4.0\n\tfloat roughnessToMip( float roughness ) {\n\t\tfloat mip = 0.0;\n\t\tif ( roughness >= r1 ) {\n\t\t\tmip = ( r0 - roughness ) * ( m1 - m0 ) / ( r0 - r1 ) + m0;\n\t\t} else if ( roughness >= r4 ) {\n\t\t\tmip = ( r1 - roughness ) * ( m4 - m1 ) / ( r1 - r4 ) + m1;\n\t\t} else if ( roughness >= r5 ) {\n\t\t\tmip = ( r4 - roughness ) * ( m5 - m4 ) / ( r4 - r5 ) + m4;\n\t\t} else if ( roughness >= r6 ) {\n\t\t\tmip = ( r5 - roughness ) * ( m6 - m5 ) / ( r5 - r6 ) + m5;\n\t\t} else {\n\t\t\tmip = - 2.0 * log2( 1.16 * roughness );\t\t}\n\t\treturn mip;\n\t}\n\tvec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n\t\tfloat mip = clamp( roughnessToMip( roughness ), m0, CUBEUV_MAX_MIP );\n\t\tfloat mipF = fract( mip );\n\t\tfloat mipInt = floor( mip );\n\t\tvec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n\t\tif ( mipF == 0.0 ) {\n\t\t\treturn vec4( color0, 1.0 );\n\t\t} else {\n\t\t\tvec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n\t\t\treturn vec4( mix( color0, color1, mipF ), 1.0 );\n\t\t}\n\t}\n#endif",
    defaultnormal_vertex: "vec3 transformedNormal = objectNormal;\n#ifdef USE_INSTANCING\n\tmat3 m = mat3( instanceMatrix );\n\ttransformedNormal /= vec3( dot( m[ 0 ], m[ 0 ] ), dot( m[ 1 ], m[ 1 ] ), dot( m[ 2 ], m[ 2 ] ) );\n\ttransformedNormal = m * transformedNormal;\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n\ttransformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n\tvec3 transformedTangent = ( modelViewMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#ifdef FLIP_SIDED\n\t\ttransformedTangent = - transformedTangent;\n\t#endif\n#endif",
    displacementmap_pars_vertex: "#ifdef USE_DISPLACEMENTMAP\n\tuniform sampler2D displacementMap;\n\tuniform float displacementScale;\n\tuniform float displacementBias;\n#endif",
    displacementmap_vertex: "#ifdef USE_DISPLACEMENTMAP\n\ttransformed += normalize( objectNormal ) * ( texture2D( displacementMap, vUv ).x * displacementScale + displacementBias );\n#endif",
    emissivemap_fragment: "#ifdef USE_EMISSIVEMAP\n\tvec4 emissiveColor = texture2D( emissiveMap, vUv );\n\ttotalEmissiveRadiance *= emissiveColor.rgb;\n#endif",
    emissivemap_pars_fragment: "#ifdef USE_EMISSIVEMAP\n\tuniform sampler2D emissiveMap;\n#endif",
    encodings_fragment: "gl_FragColor = linearToOutputTexel( gl_FragColor );",
    encodings_pars_fragment: "vec4 LinearToLinear( in vec4 value ) {\n\treturn value;\n}\nvec4 LinearTosRGB( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}",
    envmap_fragment: "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvec3 cameraToFrag;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToFrag = normalize( vWorldPosition - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( cameraToFrag, worldNormal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n\t\t#endif\n\t#else\n\t\tvec3 reflectVec = vReflect;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\tvec4 envColor = textureCubeUV( envMap, reflectVec, 0.0 );\n\t#else\n\t\tvec4 envColor = vec4( 0.0 );\n\t#endif\n\t#ifdef ENVMAP_BLENDING_MULTIPLY\n\t\toutgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_MIX )\n\t\toutgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_ADD )\n\t\toutgoingLight += envColor.xyz * specularStrength * reflectivity;\n\t#endif\n#endif",
    envmap_common_pars_fragment: "#ifdef USE_ENVMAP\n\tuniform float envMapIntensity;\n\tuniform float flipEnvMap;\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tuniform samplerCube envMap;\n\t#else\n\t\tuniform sampler2D envMap;\n\t#endif\n\t\n#endif",
    envmap_pars_fragment: "#ifdef USE_ENVMAP\n\tuniform float reflectivity;\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\tvarying vec3 vWorldPosition;\n\t\tuniform float refractionRatio;\n\t#else\n\t\tvarying vec3 vReflect;\n\t#endif\n#endif",
    envmap_pars_vertex: "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) ||defined( PHONG )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\t\n\t\tvarying vec3 vWorldPosition;\n\t#else\n\t\tvarying vec3 vReflect;\n\t\tuniform float refractionRatio;\n\t#endif\n#endif",
    envmap_physical_pars_fragment: "#if defined( USE_ENVMAP )\n\tvec3 getIBLIrradiance( const in vec3 normal ) {\n\t\t#if defined( ENVMAP_TYPE_CUBE_UV )\n\t\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, worldNormal, 1.0 );\n\t\t\treturn PI * envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\tvec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n\t\t#if defined( ENVMAP_TYPE_CUBE_UV )\n\t\t\tvec3 reflectVec = reflect( - viewDir, normal );\n\t\t\treflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n\t\t\treflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, reflectVec, roughness );\n\t\t\treturn envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n#endif",
    envmap_vertex: "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvWorldPosition = worldPosition.xyz;\n\t#else\n\t\tvec3 cameraToVertex;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvReflect = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#endif\n#endif",
    fog_vertex: "#ifdef USE_FOG\n\tvFogDepth = - mvPosition.z;\n#endif",
    fog_pars_vertex: "#ifdef USE_FOG\n\tvarying float vFogDepth;\n#endif",
    fog_fragment: "#ifdef USE_FOG\n\t#ifdef FOG_EXP2\n\t\tfloat fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n\t#else\n\t\tfloat fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n\t#endif\n\tgl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif",
    fog_pars_fragment: "#ifdef USE_FOG\n\tuniform vec3 fogColor;\n\tvarying float vFogDepth;\n\t#ifdef FOG_EXP2\n\t\tuniform float fogDensity;\n\t#else\n\t\tuniform float fogNear;\n\t\tuniform float fogFar;\n\t#endif\n#endif",
    gradientmap_pars_fragment: "#ifdef USE_GRADIENTMAP\n\tuniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n\tfloat dotNL = dot( normal, lightDirection );\n\tvec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n\t#ifdef USE_GRADIENTMAP\n\t\treturn vec3( texture2D( gradientMap, coord ).r );\n\t#else\n\t\treturn ( coord.x < 0.7 ) ? vec3( 0.7 ) : vec3( 1.0 );\n\t#endif\n}",
    lightmap_fragment: "#ifdef USE_LIGHTMAP\n\tvec4 lightMapTexel = texture2D( lightMap, vUv2 );\n\tvec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n\treflectedLight.indirectDiffuse += lightMapIrradiance;\n#endif",
    lightmap_pars_fragment: "#ifdef USE_LIGHTMAP\n\tuniform sampler2D lightMap;\n\tuniform float lightMapIntensity;\n#endif",
    lights_lambert_vertex: "vec3 diffuse = vec3( 1.0 );\nGeometricContext geometry;\ngeometry.position = mvPosition.xyz;\ngeometry.normal = normalize( transformedNormal );\ngeometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( -mvPosition.xyz );\nGeometricContext backGeometry;\nbackGeometry.position = geometry.position;\nbackGeometry.normal = -geometry.normal;\nbackGeometry.viewDir = geometry.viewDir;\nvLightFront = vec3( 0.0 );\nvIndirectFront = vec3( 0.0 );\n#ifdef DOUBLE_SIDED\n\tvLightBack = vec3( 0.0 );\n\tvIndirectBack = vec3( 0.0 );\n#endif\nIncidentLight directLight;\nfloat dotNL;\nvec3 directLightColor_Diffuse;\nvIndirectFront += getAmbientLightIrradiance( ambientLightColor );\nvIndirectFront += getLightProbeIrradiance( lightProbe, geometry.normal );\n#ifdef DOUBLE_SIDED\n\tvIndirectBack += getAmbientLightIrradiance( ambientLightColor );\n\tvIndirectBack += getLightProbeIrradiance( lightProbe, backGeometry.normal );\n#endif\n#if NUM_POINT_LIGHTS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tgetPointLightInfo( pointLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( - dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tgetSpotLightInfo( spotLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( - dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if NUM_DIR_LIGHTS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tgetDirectionalLightInfo( directionalLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( - dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\tvIndirectFront += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry.normal );\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvIndirectBack += getHemisphereLightIrradiance( hemisphereLights[ i ], backGeometry.normal );\n\t\t#endif\n\t}\n\t#pragma unroll_loop_end\n#endif",
    lights_pars_begin: "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\nuniform vec3 lightProbe[ 9 ];\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n\tfloat x = normal.x, y = normal.y, z = normal.z;\n\tvec3 result = shCoefficients[ 0 ] * 0.886227;\n\tresult += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n\tresult += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n\tresult += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n\tresult += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n\tresult += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n\tresult += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n\tresult += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n\tresult += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n\treturn result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\tvec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n\treturn irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n\tvec3 irradiance = ambientLightColor;\n\treturn irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n\t#if defined ( PHYSICALLY_CORRECT_LIGHTS )\n\t\tfloat distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n\t\tif ( cutoffDistance > 0.0 ) {\n\t\t\tdistanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n\t\t}\n\t\treturn distanceFalloff;\n\t#else\n\t\tif ( cutoffDistance > 0.0 && decayExponent > 0.0 ) {\n\t\t\treturn pow( saturate( - lightDistance / cutoffDistance + 1.0 ), decayExponent );\n\t\t}\n\t\treturn 1.0;\n\t#endif\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n\treturn smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n\tstruct DirectionalLight {\n\t\tvec3 direction;\n\t\tvec3 color;\n\t};\n\tuniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n\tvoid getDirectionalLightInfo( const in DirectionalLight directionalLight, const in GeometricContext geometry, out IncidentLight light ) {\n\t\tlight.color = directionalLight.color;\n\t\tlight.direction = directionalLight.direction;\n\t\tlight.visible = true;\n\t}\n#endif\n#if NUM_POINT_LIGHTS > 0\n\tstruct PointLight {\n\t\tvec3 position;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t};\n\tuniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n\tvoid getPointLightInfo( const in PointLight pointLight, const in GeometricContext geometry, out IncidentLight light ) {\n\t\tvec3 lVector = pointLight.position - geometry.position;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tlight.color = pointLight.color;\n\t\tlight.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tstruct SpotLight {\n\t\tvec3 position;\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tfloat coneCos;\n\t\tfloat penumbraCos;\n\t};\n\tuniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n\tvoid getSpotLightInfo( const in SpotLight spotLight, const in GeometricContext geometry, out IncidentLight light ) {\n\t\tvec3 lVector = spotLight.position - geometry.position;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat angleCos = dot( light.direction, spotLight.direction );\n\t\tfloat spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n\t\tif ( spotAttenuation > 0.0 ) {\n\t\t\tfloat lightDistance = length( lVector );\n\t\t\tlight.color = spotLight.color * spotAttenuation;\n\t\t\tlight.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n\t\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t\t} else {\n\t\t\tlight.color = vec3( 0.0 );\n\t\t\tlight.visible = false;\n\t\t}\n\t}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n\tstruct RectAreaLight {\n\t\tvec3 color;\n\t\tvec3 position;\n\t\tvec3 halfWidth;\n\t\tvec3 halfHeight;\n\t};\n\tuniform sampler2D ltc_1;\tuniform sampler2D ltc_2;\n\tuniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tstruct HemisphereLight {\n\t\tvec3 direction;\n\t\tvec3 skyColor;\n\t\tvec3 groundColor;\n\t};\n\tuniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n\tvec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n\t\tfloat dotNL = dot( normal, hemiLight.direction );\n\t\tfloat hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n\t\tvec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n\t\treturn irradiance;\n\t}\n#endif",
    lights_toon_fragment: "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;",
    lights_toon_pars_fragment: "varying vec3 vViewPosition;\nstruct ToonMaterial {\n\tvec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\tvec3 irradiance = getGradientIrradiance( geometry.normal, directLight.direction ) * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Toon\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Toon\n#define Material_LightProbeLOD( material )\t(0)",
    lights_phong_fragment: "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;",
    lights_phong_pars_fragment: "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n\tvec3 diffuseColor;\n\tvec3 specularColor;\n\tfloat specularShininess;\n\tfloat specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n\treflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_BlinnPhong\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_BlinnPhong\n#define Material_LightProbeLOD( material )\t(0)",
    lights_physical_fragment: "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( geometryNormal ) ), abs( dFdy( geometryNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n\t#ifdef SPECULAR\n\t\tfloat specularIntensityFactor = specularIntensity;\n\t\tvec3 specularColorFactor = specularColor;\n\t\t#ifdef USE_SPECULARINTENSITYMAP\n\t\t\tspecularIntensityFactor *= texture2D( specularIntensityMap, vUv ).a;\n\t\t#endif\n\t\t#ifdef USE_SPECULARCOLORMAP\n\t\t\tspecularColorFactor *= texture2D( specularColorMap, vUv ).rgb;\n\t\t#endif\n\t\tmaterial.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n\t#else\n\t\tfloat specularIntensityFactor = 1.0;\n\t\tvec3 specularColorFactor = vec3( 1.0 );\n\t\tmaterial.specularF90 = 1.0;\n\t#endif\n\tmaterial.specularColor = mix( min( pow2( ( ior - 1.0 ) / ( ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );\n#else\n\tmaterial.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );\n\tmaterial.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n\tmaterial.clearcoat = clearcoat;\n\tmaterial.clearcoatRoughness = clearcoatRoughness;\n\tmaterial.clearcoatF0 = vec3( 0.04 );\n\tmaterial.clearcoatF90 = 1.0;\n\t#ifdef USE_CLEARCOATMAP\n\t\tmaterial.clearcoat *= texture2D( clearcoatMap, vUv ).x;\n\t#endif\n\t#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\t\tmaterial.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vUv ).y;\n\t#endif\n\tmaterial.clearcoat = saturate( material.clearcoat );\tmaterial.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n\tmaterial.clearcoatRoughness += geometryRoughness;\n\tmaterial.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_SHEEN\n\tmaterial.sheenColor = sheenColor;\n\t#ifdef USE_SHEENCOLORMAP\n\t\tmaterial.sheenColor *= texture2D( sheenColorMap, vUv ).rgb;\n\t#endif\n\tmaterial.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );\n\t#ifdef USE_SHEENROUGHNESSMAP\n\t\tmaterial.sheenRoughness *= texture2D( sheenRoughnessMap, vUv ).a;\n\t#endif\n#endif",
    lights_physical_pars_fragment: "struct PhysicalMaterial {\n\tvec3 diffuseColor;\n\tfloat roughness;\n\tvec3 specularColor;\n\tfloat specularF90;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat clearcoat;\n\t\tfloat clearcoatRoughness;\n\t\tvec3 clearcoatF0;\n\t\tfloat clearcoatF90;\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tvec3 sheenColor;\n\t\tfloat sheenRoughness;\n\t#endif\n};\nvec3 clearcoatSpecular = vec3( 0.0 );\nvec3 sheenSpecular = vec3( 0.0 );\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat r2 = roughness * roughness;\n\tfloat a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;\n\tfloat b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;\n\tfloat DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );\n\treturn saturate( DG * RECIPROCAL_PI );\n}\nvec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tconst vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n\tconst vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n\tvec4 r = roughness * c0 + c1;\n\tfloat a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n\tvec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;\n\treturn fab;\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\treturn specularColor * fab.x + specularF90 * fab.y;\n}\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\tvec3 FssEss = specularColor * fab.x + specularF90 * fab.y;\n\tfloat Ess = fab.x + fab.y;\n\tfloat Ems = 1.0 - Ess;\n\tvec3 Favg = specularColor + ( 1.0 - specularColor ) * 0.047619;\tvec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n\tsingleScatter += FssEss;\n\tmultiScatter += Fms * Ems;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n\tvoid RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t\tvec3 normal = geometry.normal;\n\t\tvec3 viewDir = geometry.viewDir;\n\t\tvec3 position = geometry.position;\n\t\tvec3 lightPos = rectAreaLight.position;\n\t\tvec3 halfWidth = rectAreaLight.halfWidth;\n\t\tvec3 halfHeight = rectAreaLight.halfHeight;\n\t\tvec3 lightColor = rectAreaLight.color;\n\t\tfloat roughness = material.roughness;\n\t\tvec3 rectCoords[ 4 ];\n\t\trectCoords[ 0 ] = lightPos + halfWidth - halfHeight;\t\trectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n\t\trectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n\t\trectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n\t\tvec2 uv = LTC_Uv( normal, viewDir, roughness );\n\t\tvec4 t1 = texture2D( ltc_1, uv );\n\t\tvec4 t2 = texture2D( ltc_2, uv );\n\t\tmat3 mInv = mat3(\n\t\t\tvec3( t1.x, 0, t1.y ),\n\t\t\tvec3(    0, 1,    0 ),\n\t\t\tvec3( t1.z, 0, t1.w )\n\t\t);\n\t\tvec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n\t\treflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n\t\treflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n\t}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNLcc = saturate( dot( geometry.clearcoatNormal, directLight.direction ) );\n\t\tvec3 ccIrradiance = dotNLcc * directLight.color;\n\t\tclearcoatSpecular += ccIrradiance * BRDF_GGX( directLight.direction, geometry.viewDir, geometry.clearcoatNormal, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecular += irradiance * BRDF_Sheen( directLight.direction, geometry.viewDir, geometry.normal, material.sheenColor, material.sheenRoughness );\n\t#endif\n\treflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularF90, material.roughness );\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatSpecular += clearcoatRadiance * EnvironmentBRDF( geometry.clearcoatNormal, geometry.viewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecular += irradiance * material.sheenColor * IBLSheenBRDF( geometry.normal, geometry.viewDir, material.sheenRoughness );\n\t#endif\n\tvec3 singleScattering = vec3( 0.0 );\n\tvec3 multiScattering = vec3( 0.0 );\n\tvec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n\tcomputeMultiscattering( geometry.normal, geometry.viewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );\n\tvec3 diffuse = material.diffuseColor * ( 1.0 - ( singleScattering + multiScattering ) );\n\treflectedLight.indirectSpecular += radiance * singleScattering;\n\treflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n\treflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct\t\t\t\tRE_Direct_Physical\n#define RE_Direct_RectArea\t\tRE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular\t\tRE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n\treturn saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}",
    lights_fragment_begin: "\nGeometricContext geometry;\ngeometry.position = - vViewPosition;\ngeometry.normal = normal;\ngeometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\n#ifdef USE_CLEARCOAT\n\tgeometry.clearcoatNormal = clearcoatNormal;\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n\tPointLight pointLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tgetPointLightInfo( pointLight, geometry, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n\t\tpointLightShadow = pointLightShadows[ i ];\n\t\tdirectLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n\tSpotLight spotLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tgetSpotLightInfo( spotLight, geometry, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\tspotLightShadow = spotLightShadows[ i ];\n\t\tdirectLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n\tDirectionalLight directionalLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tgetDirectionalLightInfo( directionalLight, geometry, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n\t\tdirectionalLightShadow = directionalLightShadows[ i ];\n\t\tdirectLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n\tRectAreaLight rectAreaLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n\t\trectAreaLight = rectAreaLights[ i ];\n\t\tRE_Direct_RectArea( rectAreaLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n\tvec3 iblIrradiance = vec3( 0.0 );\n\tvec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n\tirradiance += getLightProbeIrradiance( lightProbe, geometry.normal );\n\t#if ( NUM_HEMI_LIGHTS > 0 )\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\t\tirradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry.normal );\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if defined( RE_IndirectSpecular )\n\tvec3 radiance = vec3( 0.0 );\n\tvec3 clearcoatRadiance = vec3( 0.0 );\n#endif",
    lights_fragment_maps: "#if defined( RE_IndirectDiffuse )\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vUv2 );\n\t\tvec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n\t\tirradiance += lightMapIrradiance;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n\t\tiblIrradiance += getIBLIrradiance( geometry.normal );\n\t#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n\tradiance += getIBLRadiance( geometry.viewDir, geometry.normal, material.roughness );\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatRadiance += getIBLRadiance( geometry.viewDir, geometry.clearcoatNormal, material.clearcoatRoughness );\n\t#endif\n#endif",
    lights_fragment_end: "#if defined( RE_IndirectDiffuse )\n\tRE_IndirectDiffuse( irradiance, geometry, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n\tRE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometry, material, reflectedLight );\n#endif",
    logdepthbuf_fragment: "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n\tgl_FragDepthEXT = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif",
    logdepthbuf_pars_fragment: "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n\tuniform float logDepthBufFC;\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif",
    logdepthbuf_pars_vertex: "#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvarying float vFragDepth;\n\t\tvarying float vIsPerspective;\n\t#else\n\t\tuniform float logDepthBufFC;\n\t#endif\n#endif",
    logdepthbuf_vertex: "#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvFragDepth = 1.0 + gl_Position.w;\n\t\tvIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n\t#else\n\t\tif ( isPerspectiveMatrix( projectionMatrix ) ) {\n\t\t\tgl_Position.z = log2( max( EPSILON, gl_Position.w + 1.0 ) ) * logDepthBufFC - 1.0;\n\t\t\tgl_Position.z *= gl_Position.w;\n\t\t}\n\t#endif\n#endif",
    map_fragment: "#ifdef USE_MAP\n\tvec4 sampledDiffuseColor = texture2D( map, vUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\tsampledDiffuseColor = vec4( mix( pow( sampledDiffuseColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), sampledDiffuseColor.rgb * 0.0773993808, vec3( lessThanEqual( sampledDiffuseColor.rgb, vec3( 0.04045 ) ) ) ), sampledDiffuseColor.w );\n\t#endif\n\tdiffuseColor *= sampledDiffuseColor;\n#endif",
    map_pars_fragment: "#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif",
    map_particle_fragment: "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\tvec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n#endif\n#ifdef USE_MAP\n\tdiffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif",
    map_particle_pars_fragment: "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\tuniform mat3 uvTransform;\n#endif\n#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif",
    metalnessmap_fragment: "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n\tvec4 texelMetalness = texture2D( metalnessMap, vUv );\n\tmetalnessFactor *= texelMetalness.b;\n#endif",
    metalnessmap_pars_fragment: "#ifdef USE_METALNESSMAP\n\tuniform sampler2D metalnessMap;\n#endif",
    morphcolor_vertex: "#if defined( USE_MORPHCOLORS ) && defined( MORPHTARGETS_TEXTURE )\n\tvColor *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t#if defined( USE_COLOR_ALPHA )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\n\t\t#elif defined( USE_COLOR )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];\n\t\t#endif\n\t}\n#endif",
    morphnormal_vertex: "#ifdef USE_MORPHNORMALS\n\tobjectNormal *= morphTargetBaseInfluence;\n\t#ifdef MORPHTARGETS_TEXTURE\n\t\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\n\t\t}\n\t#else\n\t\tobjectNormal += morphNormal0 * morphTargetInfluences[ 0 ];\n\t\tobjectNormal += morphNormal1 * morphTargetInfluences[ 1 ];\n\t\tobjectNormal += morphNormal2 * morphTargetInfluences[ 2 ];\n\t\tobjectNormal += morphNormal3 * morphTargetInfluences[ 3 ];\n\t#endif\n#endif",
    morphtarget_pars_vertex: "#ifdef USE_MORPHTARGETS\n\tuniform float morphTargetBaseInfluence;\n\t#ifdef MORPHTARGETS_TEXTURE\n\t\tuniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n\t\tuniform sampler2DArray morphTargetsTexture;\n\t\tuniform ivec2 morphTargetsTextureSize;\n\t\tvec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\n\t\t\tint texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;\n\t\t\tint y = texelIndex / morphTargetsTextureSize.x;\n\t\t\tint x = texelIndex - y * morphTargetsTextureSize.x;\n\t\t\tivec3 morphUV = ivec3( x, y, morphTargetIndex );\n\t\t\treturn texelFetch( morphTargetsTexture, morphUV, 0 );\n\t\t}\n\t#else\n\t\t#ifndef USE_MORPHNORMALS\n\t\t\tuniform float morphTargetInfluences[ 8 ];\n\t\t#else\n\t\t\tuniform float morphTargetInfluences[ 4 ];\n\t\t#endif\n\t#endif\n#endif",
    morphtarget_vertex: "#ifdef USE_MORPHTARGETS\n\ttransformed *= morphTargetBaseInfluence;\n\t#ifdef MORPHTARGETS_TEXTURE\n\t\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\n\t\t}\n\t#else\n\t\ttransformed += morphTarget0 * morphTargetInfluences[ 0 ];\n\t\ttransformed += morphTarget1 * morphTargetInfluences[ 1 ];\n\t\ttransformed += morphTarget2 * morphTargetInfluences[ 2 ];\n\t\ttransformed += morphTarget3 * morphTargetInfluences[ 3 ];\n\t\t#ifndef USE_MORPHNORMALS\n\t\t\ttransformed += morphTarget4 * morphTargetInfluences[ 4 ];\n\t\t\ttransformed += morphTarget5 * morphTargetInfluences[ 5 ];\n\t\t\ttransformed += morphTarget6 * morphTargetInfluences[ 6 ];\n\t\t\ttransformed += morphTarget7 * morphTargetInfluences[ 7 ];\n\t\t#endif\n\t#endif\n#endif",
    normal_fragment_begin: "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n\tvec3 fdx = vec3( dFdx( vViewPosition.x ), dFdx( vViewPosition.y ), dFdx( vViewPosition.z ) );\n\tvec3 fdy = vec3( dFdy( vViewPosition.x ), dFdy( vViewPosition.y ), dFdy( vViewPosition.z ) );\n\tvec3 normal = normalize( cross( fdx, fdy ) );\n#else\n\tvec3 normal = normalize( vNormal );\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * faceDirection;\n\t#endif\n\t#ifdef USE_TANGENT\n\t\tvec3 tangent = normalize( vTangent );\n\t\tvec3 bitangent = normalize( vBitangent );\n\t\t#ifdef DOUBLE_SIDED\n\t\t\ttangent = tangent * faceDirection;\n\t\t\tbitangent = bitangent * faceDirection;\n\t\t#endif\n\t\t#if defined( TANGENTSPACE_NORMALMAP ) || defined( USE_CLEARCOAT_NORMALMAP )\n\t\t\tmat3 vTBN = mat3( tangent, bitangent, normal );\n\t\t#endif\n\t#endif\n#endif\nvec3 geometryNormal = normal;",
    normal_fragment_maps: "#ifdef OBJECTSPACE_NORMALMAP\n\tnormal = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;\n\t#ifdef FLIP_SIDED\n\t\tnormal = - normal;\n\t#endif\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * faceDirection;\n\t#endif\n\tnormal = normalize( normalMatrix * normal );\n#elif defined( TANGENTSPACE_NORMALMAP )\n\tvec3 mapN = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;\n\tmapN.xy *= normalScale;\n\t#ifdef USE_TANGENT\n\t\tnormal = normalize( vTBN * mapN );\n\t#else\n\t\tnormal = perturbNormal2Arb( - vViewPosition, normal, mapN, faceDirection );\n\t#endif\n#elif defined( USE_BUMPMAP )\n\tnormal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif",
    normal_pars_fragment: "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif",
    normal_pars_vertex: "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif",
    normal_vertex: "#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n\t#ifdef USE_TANGENT\n\t\tvTangent = normalize( transformedTangent );\n\t\tvBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n\t#endif\n#endif",
    normalmap_pars_fragment: "#ifdef USE_NORMALMAP\n\tuniform sampler2D normalMap;\n\tuniform vec2 normalScale;\n#endif\n#ifdef OBJECTSPACE_NORMALMAP\n\tuniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( TANGENTSPACE_NORMALMAP ) || defined ( USE_CLEARCOAT_NORMALMAP ) )\n\tvec3 perturbNormal2Arb( vec3 eye_pos, vec3 surf_norm, vec3 mapN, float faceDirection ) {\n\t\tvec3 q0 = vec3( dFdx( eye_pos.x ), dFdx( eye_pos.y ), dFdx( eye_pos.z ) );\n\t\tvec3 q1 = vec3( dFdy( eye_pos.x ), dFdy( eye_pos.y ), dFdy( eye_pos.z ) );\n\t\tvec2 st0 = dFdx( vUv.st );\n\t\tvec2 st1 = dFdy( vUv.st );\n\t\tvec3 N = surf_norm;\n\t\tvec3 q1perp = cross( q1, N );\n\t\tvec3 q0perp = cross( N, q0 );\n\t\tvec3 T = q1perp * st0.x + q0perp * st1.x;\n\t\tvec3 B = q1perp * st0.y + q0perp * st1.y;\n\t\tfloat det = max( dot( T, T ), dot( B, B ) );\n\t\tfloat scale = ( det == 0.0 ) ? 0.0 : faceDirection * inversesqrt( det );\n\t\treturn normalize( T * ( mapN.x * scale ) + B * ( mapN.y * scale ) + N * mapN.z );\n\t}\n#endif",
    clearcoat_normal_fragment_begin: "#ifdef USE_CLEARCOAT\n\tvec3 clearcoatNormal = geometryNormal;\n#endif",
    clearcoat_normal_fragment_maps: "#ifdef USE_CLEARCOAT_NORMALMAP\n\tvec3 clearcoatMapN = texture2D( clearcoatNormalMap, vUv ).xyz * 2.0 - 1.0;\n\tclearcoatMapN.xy *= clearcoatNormalScale;\n\t#ifdef USE_TANGENT\n\t\tclearcoatNormal = normalize( vTBN * clearcoatMapN );\n\t#else\n\t\tclearcoatNormal = perturbNormal2Arb( - vViewPosition, clearcoatNormal, clearcoatMapN, faceDirection );\n\t#endif\n#endif",
    clearcoat_pars_fragment: "#ifdef USE_CLEARCOATMAP\n\tuniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform sampler2D clearcoatRoughnessMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform sampler2D clearcoatNormalMap;\n\tuniform vec2 clearcoatNormalScale;\n#endif",
    output_fragment: "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= transmissionAlpha + 0.1;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );",
    packing: "vec3 packNormalToRGB( const in vec3 normal ) {\n\treturn normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n\treturn 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;\nconst vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256., 256. );\nconst vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\nconst float ShiftRight8 = 1. / 256.;\nvec4 packDepthToRGBA( const in float v ) {\n\tvec4 r = vec4( fract( v * PackFactors ), v );\n\tr.yzw -= r.xyz * ShiftRight8;\treturn r * PackUpscale;\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n\treturn dot( v, UnpackFactors );\n}\nvec4 pack2HalfToRGBA( vec2 v ) {\n\tvec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n\treturn vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( vec4 v ) {\n\treturn vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float linearClipZ, const in float near, const in float far ) {\n\treturn linearClipZ * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float invClipZ, const in float near, const in float far ) {\n\treturn ( near * far ) / ( ( far - near ) * invClipZ - far );\n}",
    premultiplied_alpha_fragment: "#ifdef PREMULTIPLIED_ALPHA\n\tgl_FragColor.rgb *= gl_FragColor.a;\n#endif",
    project_vertex: "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_INSTANCING\n\tmvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;",
    dithering_fragment: "#ifdef DITHERING\n\tgl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif",
    dithering_pars_fragment: "#ifdef DITHERING\n\tvec3 dithering( vec3 color ) {\n\t\tfloat grid_position = rand( gl_FragCoord.xy );\n\t\tvec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n\t\tdither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n\t\treturn color + dither_shift_RGB;\n\t}\n#endif",
    roughnessmap_fragment: "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n\tvec4 texelRoughness = texture2D( roughnessMap, vUv );\n\troughnessFactor *= texelRoughness.g;\n#endif",
    roughnessmap_pars_fragment: "#ifdef USE_ROUGHNESSMAP\n\tuniform sampler2D roughnessMap;\n#endif",
    shadowmap_pars_fragment: "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n\tfloat texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n\t\treturn step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n\t}\n\tvec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n\t\treturn unpackRGBATo2Half( texture2D( shadow, uv ) );\n\t}\n\tfloat VSMShadow (sampler2D shadow, vec2 uv, float compare ){\n\t\tfloat occlusion = 1.0;\n\t\tvec2 distribution = texture2DDistribution( shadow, uv );\n\t\tfloat hard_shadow = step( compare , distribution.x );\n\t\tif (hard_shadow != 1.0 ) {\n\t\t\tfloat distance = compare - distribution.x ;\n\t\t\tfloat variance = max( 0.00000, distribution.y * distribution.y );\n\t\t\tfloat softness_probability = variance / (variance + distance * distance );\t\t\tsoftness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );\t\t\tocclusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n\t\t}\n\t\treturn occlusion;\n\t}\n\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\tfloat shadow = 1.0;\n\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\tshadowCoord.z += shadowBias;\n\t\tbvec4 inFrustumVec = bvec4 ( shadowCoord.x >= 0.0, shadowCoord.x <= 1.0, shadowCoord.y >= 0.0, shadowCoord.y <= 1.0 );\n\t\tbool inFrustum = all( inFrustumVec );\n\t\tbvec2 frustumTestVec = bvec2( inFrustum, shadowCoord.z <= 1.0 );\n\t\tbool frustumTest = all( frustumTestVec );\n\t\tif ( frustumTest ) {\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\tfloat dx2 = dx0 / 2.0;\n\t\t\tfloat dy2 = dy0 / 2.0;\n\t\t\tfloat dx3 = dx1 / 2.0;\n\t\t\tfloat dy3 = dy1 / 2.0;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 17.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx = texelSize.x;\n\t\t\tfloat dy = texelSize.y;\n\t\t\tvec2 uv = shadowCoord.xy;\n\t\t\tvec2 f = fract( uv * shadowMapSize + 0.5 );\n\t\t\tuv -= f * texelSize;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, uv, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ), \n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ), \n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ), \n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ), \n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ), \n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ), \n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t f.y )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_VSM )\n\t\t\tshadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#else\n\t\t\tshadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#endif\n\t\t}\n\t\treturn shadow;\n\t}\n\tvec2 cubeToUV( vec3 v, float texelSizeY ) {\n\t\tvec3 absV = abs( v );\n\t\tfloat scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n\t\tabsV *= scaleToCube;\n\t\tv *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n\t\tvec2 planar = v.xy;\n\t\tfloat almostATexel = 1.5 * texelSizeY;\n\t\tfloat almostOne = 1.0 - almostATexel;\n\t\tif ( absV.z >= almostOne ) {\n\t\t\tif ( v.z > 0.0 )\n\t\t\t\tplanar.x = 4.0 - v.x;\n\t\t} else if ( absV.x >= almostOne ) {\n\t\t\tfloat signX = sign( v.x );\n\t\t\tplanar.x = v.z * signX + 2.0 * signX;\n\t\t} else if ( absV.y >= almostOne ) {\n\t\t\tfloat signY = sign( v.y );\n\t\t\tplanar.x = v.x + 2.0 * signY + 2.0;\n\t\t\tplanar.y = v.z * signY - 2.0;\n\t\t}\n\t\treturn vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n\t}\n\tfloat getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n\t\tvec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\tfloat dp = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );\t\tdp += shadowBias;\n\t\tvec3 bd3D = normalize( lightToPosition );\n\t\t#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n\t\t\tvec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n\t\t\treturn (\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#else\n\t\t\treturn texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n\t\t#endif\n\t}\n#endif",
    shadowmap_pars_vertex: "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tuniform mat4 spotShadowMatrix[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n#endif",
    shadowmap_vertex: "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0 || NUM_SPOT_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0\n\t\tvec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\tvec4 shadowWorldPosition;\n\t#endif\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n\t\tvDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias, 0 );\n\t\tvSpotShadowCoord[ i ] = spotShadowMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n\t\tvPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n#endif",
    shadowmask_pars_fragment: "float getShadowMask() {\n\tfloat shadow = 1.0;\n\t#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\tdirectionalLight = directionalLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n\t\tspotLight = spotLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\tpointLight = pointLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#endif\n\treturn shadow;\n}",
    skinbase_vertex: "#ifdef USE_SKINNING\n\tmat4 boneMatX = getBoneMatrix( skinIndex.x );\n\tmat4 boneMatY = getBoneMatrix( skinIndex.y );\n\tmat4 boneMatZ = getBoneMatrix( skinIndex.z );\n\tmat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif",
    skinning_pars_vertex: "#ifdef USE_SKINNING\n\tuniform mat4 bindMatrix;\n\tuniform mat4 bindMatrixInverse;\n\t#ifdef BONE_TEXTURE\n\t\tuniform highp sampler2D boneTexture;\n\t\tuniform int boneTextureSize;\n\t\tmat4 getBoneMatrix( const in float i ) {\n\t\t\tfloat j = i * 4.0;\n\t\t\tfloat x = mod( j, float( boneTextureSize ) );\n\t\t\tfloat y = floor( j / float( boneTextureSize ) );\n\t\t\tfloat dx = 1.0 / float( boneTextureSize );\n\t\t\tfloat dy = 1.0 / float( boneTextureSize );\n\t\t\ty = dy * ( y + 0.5 );\n\t\t\tvec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );\n\t\t\tvec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );\n\t\t\tvec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );\n\t\t\tvec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );\n\t\t\tmat4 bone = mat4( v1, v2, v3, v4 );\n\t\t\treturn bone;\n\t\t}\n\t#else\n\t\tuniform mat4 boneMatrices[ MAX_BONES ];\n\t\tmat4 getBoneMatrix( const in float i ) {\n\t\t\tmat4 bone = boneMatrices[ int(i) ];\n\t\t\treturn bone;\n\t\t}\n\t#endif\n#endif",
    skinning_vertex: "#ifdef USE_SKINNING\n\tvec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n\tvec4 skinned = vec4( 0.0 );\n\tskinned += boneMatX * skinVertex * skinWeight.x;\n\tskinned += boneMatY * skinVertex * skinWeight.y;\n\tskinned += boneMatZ * skinVertex * skinWeight.z;\n\tskinned += boneMatW * skinVertex * skinWeight.w;\n\ttransformed = ( bindMatrixInverse * skinned ).xyz;\n#endif",
    skinnormal_vertex: "#ifdef USE_SKINNING\n\tmat4 skinMatrix = mat4( 0.0 );\n\tskinMatrix += skinWeight.x * boneMatX;\n\tskinMatrix += skinWeight.y * boneMatY;\n\tskinMatrix += skinWeight.z * boneMatZ;\n\tskinMatrix += skinWeight.w * boneMatW;\n\tskinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n\tobjectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n\t#ifdef USE_TANGENT\n\t\tobjectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#endif\n#endif",
    specularmap_fragment: "float specularStrength;\n#ifdef USE_SPECULARMAP\n\tvec4 texelSpecular = texture2D( specularMap, vUv );\n\tspecularStrength = texelSpecular.r;\n#else\n\tspecularStrength = 1.0;\n#endif",
    specularmap_pars_fragment: "#ifdef USE_SPECULARMAP\n\tuniform sampler2D specularMap;\n#endif",
    tonemapping_fragment: "#if defined( TONE_MAPPING )\n\tgl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif",
    tonemapping_pars_fragment: "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n\treturn toneMappingExposure * color;\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 OptimizedCineonToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\tcolor = max( vec3( 0.0 ), color - 0.004 );\n\treturn pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n\tvec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n\tvec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n\treturn a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n\tconst mat3 ACESInputMat = mat3(\n\t\tvec3( 0.59719, 0.07600, 0.02840 ),\t\tvec3( 0.35458, 0.90834, 0.13383 ),\n\t\tvec3( 0.04823, 0.01566, 0.83777 )\n\t);\n\tconst mat3 ACESOutputMat = mat3(\n\t\tvec3(  1.60475, -0.10208, -0.00327 ),\t\tvec3( -0.53108,  1.10813, -0.07276 ),\n\t\tvec3( -0.07367, -0.00605,  1.07602 )\n\t);\n\tcolor *= toneMappingExposure / 0.6;\n\tcolor = ACESInputMat * color;\n\tcolor = RRTAndODTFit( color );\n\tcolor = ACESOutputMat * color;\n\treturn saturate( color );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }",
    transmission_fragment: "#ifdef USE_TRANSMISSION\n\tfloat transmissionAlpha = 1.0;\n\tfloat transmissionFactor = transmission;\n\tfloat thicknessFactor = thickness;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\ttransmissionFactor *= texture2D( transmissionMap, vUv ).r;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tthicknessFactor *= texture2D( thicknessMap, vUv ).g;\n\t#endif\n\tvec3 pos = vWorldPosition;\n\tvec3 v = normalize( cameraPosition - pos );\n\tvec3 n = inverseTransformDirection( normal, viewMatrix );\n\tvec4 transmission = getIBLVolumeRefraction(\n\t\tn, v, roughnessFactor, material.diffuseColor, material.specularColor, material.specularF90,\n\t\tpos, modelMatrix, viewMatrix, projectionMatrix, ior, thicknessFactor,\n\t\tattenuationColor, attenuationDistance );\n\ttotalDiffuse = mix( totalDiffuse, transmission.rgb, transmissionFactor );\n\ttransmissionAlpha = mix( transmissionAlpha, transmission.a, transmissionFactor );\n#endif",
    transmission_pars_fragment: "#ifdef USE_TRANSMISSION\n\tuniform float transmission;\n\tuniform float thickness;\n\tuniform float attenuationDistance;\n\tuniform vec3 attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tuniform sampler2D transmissionMap;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tuniform sampler2D thicknessMap;\n\t#endif\n\tuniform vec2 transmissionSamplerSize;\n\tuniform sampler2D transmissionSamplerMap;\n\tuniform mat4 modelMatrix;\n\tuniform mat4 projectionMatrix;\n\tvarying vec3 vWorldPosition;\n\tvec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n\t\tvec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n\t\tvec3 modelScale;\n\t\tmodelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n\t\tmodelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n\t\tmodelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n\t\treturn normalize( refractionVector ) * thickness * modelScale;\n\t}\n\tfloat applyIorToRoughness( const in float roughness, const in float ior ) {\n\t\treturn roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n\t}\n\tvec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n\t\tfloat framebufferLod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n\t\t#ifdef texture2DLodEXT\n\t\t\treturn texture2DLodEXT( transmissionSamplerMap, fragCoord.xy, framebufferLod );\n\t\t#else\n\t\t\treturn texture2D( transmissionSamplerMap, fragCoord.xy, framebufferLod );\n\t\t#endif\n\t}\n\tvec3 applyVolumeAttenuation( const in vec3 radiance, const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tif ( attenuationDistance == 0.0 ) {\n\t\t\treturn radiance;\n\t\t} else {\n\t\t\tvec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n\t\t\tvec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );\t\t\treturn transmittance * radiance;\n\t\t}\n\t}\n\tvec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n\t\tconst in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n\t\tconst in mat4 viewMatrix, const in mat4 projMatrix, const in float ior, const in float thickness,\n\t\tconst in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tvec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\trefractionCoords += 1.0;\n\t\trefractionCoords /= 2.0;\n\t\tvec4 transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n\t\tvec3 attenuatedColor = applyVolumeAttenuation( transmittedLight.rgb, length( transmissionRay ), attenuationColor, attenuationDistance );\n\t\tvec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n\t\treturn vec4( ( 1.0 - F ) * attenuatedColor * diffuseColor, transmittedLight.a );\n\t}\n#endif",
    uv_pars_fragment: "#if ( defined( USE_UV ) && ! defined( UVS_VERTEX_ONLY ) )\n\tvarying vec2 vUv;\n#endif",
    uv_pars_vertex: "#ifdef USE_UV\n\t#ifdef UVS_VERTEX_ONLY\n\t\tvec2 vUv;\n\t#else\n\t\tvarying vec2 vUv;\n\t#endif\n\tuniform mat3 uvTransform;\n#endif",
    uv_vertex: "#ifdef USE_UV\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n#endif",
    uv2_pars_fragment: "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tvarying vec2 vUv2;\n#endif",
    uv2_pars_vertex: "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tattribute vec2 uv2;\n\tvarying vec2 vUv2;\n\tuniform mat3 uv2Transform;\n#endif",
    uv2_vertex: "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tvUv2 = ( uv2Transform * vec3( uv2, 1 ) ).xy;\n#endif",
    worldpos_vertex: "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION )\n\tvec4 worldPosition = vec4( transformed, 1.0 );\n\t#ifdef USE_INSTANCING\n\t\tworldPosition = instanceMatrix * worldPosition;\n\t#endif\n\tworldPosition = modelMatrix * worldPosition;\n#endif",
    background_vert: "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\tgl_Position = vec4( position.xy, 1.0, 1.0 );\n}",
    background_frag: "uniform sampler2D t2D;\nvarying vec2 vUv;\nvoid main() {\n\tgl_FragColor = texture2D( t2D, vUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\tgl_FragColor = vec4( mix( pow( gl_FragColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), gl_FragColor.rgb * 0.0773993808, vec3( lessThanEqual( gl_FragColor.rgb, vec3( 0.04045 ) ) ) ), gl_FragColor.w );\n\t#endif\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n}",
    cube_vert: "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}",
    cube_frag: "#include <envmap_common_pars_fragment>\nuniform float opacity;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n\tvec3 vReflect = vWorldDirection;\n\t#include <envmap_fragment>\n\tgl_FragColor = envColor;\n\tgl_FragColor.a *= opacity;\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n}",
    depth_vert: "#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvHighPrecisionZW = gl_Position.zw;\n}",
    depth_frag: "#if DEPTH_PACKING == 3200\n\tuniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#if DEPTH_PACKING == 3200\n\t\tdiffuseColor.a = opacity;\n\t#endif\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <logdepthbuf_fragment>\n\tfloat fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\n\t#if DEPTH_PACKING == 3200\n\t\tgl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n\t#elif DEPTH_PACKING == 3201\n\t\tgl_FragColor = packDepthToRGBA( fragCoordZ );\n\t#endif\n}",
    distanceRGBA_vert: "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\tvWorldPosition = worldPosition.xyz;\n}",
    distanceRGBA_frag: "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\tfloat dist = length( vWorldPosition - referencePosition );\n\tdist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n\tdist = saturate( dist );\n\tgl_FragColor = packDepthToRGBA( dist );\n}",
    equirect_vert: "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}",
    equirect_frag: "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvec3 direction = normalize( vWorldDirection );\n\tvec2 sampleUV = equirectUv( direction );\n\tgl_FragColor = texture2D( tEquirect, sampleUV );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n}",
    linedashed_vert: "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\tvLineDistance = scale * lineDistance;\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}",
    linedashed_frag: "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tif ( mod( vLineDistance, totalSize ) > dashSize ) {\n\t\tdiscard;\n\t}\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <color_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}",
    meshbasic_vert: "#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinbase_vertex>\n\t\t#include <skinnormal_vertex>\n\t\t#include <defaultnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <fog_vertex>\n}",
    meshbasic_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vUv2 );\n\t\treflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\n\t#else\n\t\treflectedLight.indirectDiffuse += vec3( 1.0 );\n\t#endif\n\t#include <aomap_fragment>\n\treflectedLight.indirectDiffuse *= diffuseColor.rgb;\n\tvec3 outgoingLight = reflectedLight.indirectDiffuse;\n\t#include <envmap_fragment>\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
    meshlambert_vert: "#define LAMBERT\nvarying vec3 vLightFront;\nvarying vec3 vIndirectFront;\n#ifdef DOUBLE_SIDED\n\tvarying vec3 vLightBack;\n\tvarying vec3 vIndirectBack;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <lights_lambert_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}",
    meshlambert_frag: "uniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\nvarying vec3 vLightFront;\nvarying vec3 vIndirectFront;\n#ifdef DOUBLE_SIDED\n\tvarying vec3 vLightBack;\n\tvarying vec3 vIndirectBack;\n#endif\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <fog_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <emissivemap_fragment>\n\t#ifdef DOUBLE_SIDED\n\t\treflectedLight.indirectDiffuse += ( gl_FrontFacing ) ? vIndirectFront : vIndirectBack;\n\t#else\n\t\treflectedLight.indirectDiffuse += vIndirectFront;\n\t#endif\n\t#include <lightmap_fragment>\n\treflectedLight.indirectDiffuse *= BRDF_Lambert( diffuseColor.rgb );\n\t#ifdef DOUBLE_SIDED\n\t\treflectedLight.directDiffuse = ( gl_FrontFacing ) ? vLightFront : vLightBack;\n\t#else\n\t\treflectedLight.directDiffuse = vLightFront;\n\t#endif\n\treflectedLight.directDiffuse *= BRDF_Lambert( diffuseColor.rgb ) * getShadowMask();\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
    meshmatcap_vert: "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n\tvViewPosition = - mvPosition.xyz;\n}",
    meshmatcap_frag: "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tvec3 viewDir = normalize( vViewPosition );\n\tvec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n\tvec3 y = cross( viewDir, x );\n\tvec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n\t#ifdef USE_MATCAP\n\t\tvec4 matcapColor = texture2D( matcap, uv );\n\t#else\n\t\tvec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n\t#endif\n\tvec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
    meshnormal_vert: "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n\tvarying vec3 vViewPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n}",
    meshnormal_frag: "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n\tvarying vec3 vViewPosition;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tgl_FragColor = vec4( packNormalToRGB( normal ), opacity );\n\t#ifdef OPAQUE\n\t\tgl_FragColor.a = 1.0;\n\t#endif\n}",
    meshphong_vert: "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}",
    meshphong_frag: "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_phong_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
    meshphysical_vert: "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n\tvarying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n\tvWorldPosition = worldPosition.xyz;\n#endif\n}",
    meshphysical_frag: "#define STANDARD\n#ifdef PHYSICAL\n\t#define IOR\n\t#define SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n\tuniform float ior;\n#endif\n#ifdef SPECULAR\n\tuniform float specularIntensity;\n\tuniform vec3 specularColor;\n\t#ifdef USE_SPECULARINTENSITYMAP\n\t\tuniform sampler2D specularIntensityMap;\n\t#endif\n\t#ifdef USE_SPECULARCOLORMAP\n\t\tuniform sampler2D specularColorMap;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT\n\tuniform float clearcoat;\n\tuniform float clearcoatRoughness;\n#endif\n#ifdef USE_SHEEN\n\tuniform vec3 sheenColor;\n\tuniform float sheenRoughness;\n\t#ifdef USE_SHEENCOLORMAP\n\t\tuniform sampler2D sheenColorMap;\n\t#endif\n\t#ifdef USE_SHEENROUGHNESSMAP\n\t\tuniform sampler2D sheenRoughnessMap;\n\t#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <bsdfs>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <roughnessmap_fragment>\n\t#include <metalnessmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <clearcoat_normal_fragment_begin>\n\t#include <clearcoat_normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_physical_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n\tvec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n\t#include <transmission_fragment>\n\tvec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n\t#ifdef USE_SHEEN\n\t\tfloat sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );\n\t\toutgoingLight = outgoingLight * sheenEnergyComp + sheenSpecular;\n\t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNVcc = saturate( dot( geometry.clearcoatNormal, geometry.viewDir ) );\n\t\tvec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n\t\toutgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + clearcoatSpecular * material.clearcoat;\n\t#endif\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
    meshtoon_vert: "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}",
    meshtoon_frag: "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_toon_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
    points_vert: "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\tgl_PointSize = size;\n\t#ifdef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n\t#endif\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <fog_vertex>\n}",
    points_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_particle_fragment>\n\t#include <color_fragment>\n\t#include <alphatest_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}",
    shadow_vert: "#include <common>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}",
    shadow_frag: "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n\tgl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}",
    sprite_vert: "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\tvec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );\n\tvec2 scale;\n\tscale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );\n\tscale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );\n\t#ifndef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) scale *= - mvPosition.z;\n\t#endif\n\tvec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n\tvec2 rotatedPosition;\n\trotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n\trotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n\tmvPosition.xy += rotatedPosition;\n\tgl_Position = projectionMatrix * mvPosition;\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}",
    sprite_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}"
}, $fd4eb456bcbd06f8$var$an = {
    common: {
        diffuse: {
            value: new $fd4eb456bcbd06f8$var$L(16777215)
        },
        opacity: {
            value: 1
        },
        map: {
            value: null
        },
        uvTransform: {
            value: new $fd4eb456bcbd06f8$var$v
        },
        uv2Transform: {
            value: new $fd4eb456bcbd06f8$var$v
        },
        alphaMap: {
            value: null
        },
        alphaTest: {
            value: 0
        }
    },
    specularmap: {
        specularMap: {
            value: null
        }
    },
    envmap: {
        envMap: {
            value: null
        },
        flipEnvMap: {
            value: -1
        },
        reflectivity: {
            value: 1
        },
        ior: {
            value: 1.5
        },
        refractionRatio: {
            value: .98
        }
    },
    aomap: {
        aoMap: {
            value: null
        },
        aoMapIntensity: {
            value: 1
        }
    },
    lightmap: {
        lightMap: {
            value: null
        },
        lightMapIntensity: {
            value: 1
        }
    },
    emissivemap: {
        emissiveMap: {
            value: null
        }
    },
    bumpmap: {
        bumpMap: {
            value: null
        },
        bumpScale: {
            value: 1
        }
    },
    normalmap: {
        normalMap: {
            value: null
        },
        normalScale: {
            value: new $fd4eb456bcbd06f8$var$g(1, 1)
        }
    },
    displacementmap: {
        displacementMap: {
            value: null
        },
        displacementScale: {
            value: 1
        },
        displacementBias: {
            value: 0
        }
    },
    roughnessmap: {
        roughnessMap: {
            value: null
        }
    },
    metalnessmap: {
        metalnessMap: {
            value: null
        }
    },
    gradientmap: {
        gradientMap: {
            value: null
        }
    },
    fog: {
        fogDensity: {
            value: 25e-5
        },
        fogNear: {
            value: 1
        },
        fogFar: {
            value: 2e3
        },
        fogColor: {
            value: new $fd4eb456bcbd06f8$var$L(16777215)
        }
    },
    lights: {
        ambientLightColor: {
            value: []
        },
        lightProbe: {
            value: []
        },
        directionalLights: {
            value: [],
            properties: {
                direction: {},
                color: {}
            }
        },
        directionalLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        directionalShadowMap: {
            value: []
        },
        directionalShadowMatrix: {
            value: []
        },
        spotLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                direction: {},
                distance: {},
                coneCos: {},
                penumbraCos: {},
                decay: {}
            }
        },
        spotLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        spotShadowMap: {
            value: []
        },
        spotShadowMatrix: {
            value: []
        },
        pointLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                decay: {},
                distance: {}
            }
        },
        pointLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {},
                shadowCameraNear: {},
                shadowCameraFar: {}
            }
        },
        pointShadowMap: {
            value: []
        },
        pointShadowMatrix: {
            value: []
        },
        hemisphereLights: {
            value: [],
            properties: {
                direction: {},
                skyColor: {},
                groundColor: {}
            }
        },
        rectAreaLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                width: {},
                height: {}
            }
        },
        ltc_1: {
            value: null
        },
        ltc_2: {
            value: null
        }
    },
    points: {
        diffuse: {
            value: new $fd4eb456bcbd06f8$var$L(16777215)
        },
        opacity: {
            value: 1
        },
        size: {
            value: 1
        },
        scale: {
            value: 1
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        alphaTest: {
            value: 0
        },
        uvTransform: {
            value: new $fd4eb456bcbd06f8$var$v
        }
    },
    sprite: {
        diffuse: {
            value: new $fd4eb456bcbd06f8$var$L(16777215)
        },
        opacity: {
            value: 1
        },
        center: {
            value: new $fd4eb456bcbd06f8$var$g(.5, .5)
        },
        rotation: {
            value: 0
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        alphaTest: {
            value: 0
        },
        uvTransform: {
            value: new $fd4eb456bcbd06f8$var$v
        }
    }
}, $fd4eb456bcbd06f8$var$on = {
    basic: {
        uniforms: $fd4eb456bcbd06f8$var$ze([
            $fd4eb456bcbd06f8$var$an.common,
            $fd4eb456bcbd06f8$var$an.specularmap,
            $fd4eb456bcbd06f8$var$an.envmap,
            $fd4eb456bcbd06f8$var$an.aomap,
            $fd4eb456bcbd06f8$var$an.lightmap,
            $fd4eb456bcbd06f8$var$an.fog
        ]),
        vertexShader: $fd4eb456bcbd06f8$var$sn.meshbasic_vert,
        fragmentShader: $fd4eb456bcbd06f8$var$sn.meshbasic_frag
    },
    lambert: {
        uniforms: $fd4eb456bcbd06f8$var$ze([
            $fd4eb456bcbd06f8$var$an.common,
            $fd4eb456bcbd06f8$var$an.specularmap,
            $fd4eb456bcbd06f8$var$an.envmap,
            $fd4eb456bcbd06f8$var$an.aomap,
            $fd4eb456bcbd06f8$var$an.lightmap,
            $fd4eb456bcbd06f8$var$an.emissivemap,
            $fd4eb456bcbd06f8$var$an.fog,
            $fd4eb456bcbd06f8$var$an.lights,
            {
                emissive: {
                    value: new $fd4eb456bcbd06f8$var$L(0)
                }
            }
        ]),
        vertexShader: $fd4eb456bcbd06f8$var$sn.meshlambert_vert,
        fragmentShader: $fd4eb456bcbd06f8$var$sn.meshlambert_frag
    },
    phong: {
        uniforms: $fd4eb456bcbd06f8$var$ze([
            $fd4eb456bcbd06f8$var$an.common,
            $fd4eb456bcbd06f8$var$an.specularmap,
            $fd4eb456bcbd06f8$var$an.envmap,
            $fd4eb456bcbd06f8$var$an.aomap,
            $fd4eb456bcbd06f8$var$an.lightmap,
            $fd4eb456bcbd06f8$var$an.emissivemap,
            $fd4eb456bcbd06f8$var$an.bumpmap,
            $fd4eb456bcbd06f8$var$an.normalmap,
            $fd4eb456bcbd06f8$var$an.displacementmap,
            $fd4eb456bcbd06f8$var$an.fog,
            $fd4eb456bcbd06f8$var$an.lights,
            {
                emissive: {
                    value: new $fd4eb456bcbd06f8$var$L(0)
                },
                specular: {
                    value: new $fd4eb456bcbd06f8$var$L(1118481)
                },
                shininess: {
                    value: 30
                }
            }
        ]),
        vertexShader: $fd4eb456bcbd06f8$var$sn.meshphong_vert,
        fragmentShader: $fd4eb456bcbd06f8$var$sn.meshphong_frag
    },
    standard: {
        uniforms: $fd4eb456bcbd06f8$var$ze([
            $fd4eb456bcbd06f8$var$an.common,
            $fd4eb456bcbd06f8$var$an.envmap,
            $fd4eb456bcbd06f8$var$an.aomap,
            $fd4eb456bcbd06f8$var$an.lightmap,
            $fd4eb456bcbd06f8$var$an.emissivemap,
            $fd4eb456bcbd06f8$var$an.bumpmap,
            $fd4eb456bcbd06f8$var$an.normalmap,
            $fd4eb456bcbd06f8$var$an.displacementmap,
            $fd4eb456bcbd06f8$var$an.roughnessmap,
            $fd4eb456bcbd06f8$var$an.metalnessmap,
            $fd4eb456bcbd06f8$var$an.fog,
            $fd4eb456bcbd06f8$var$an.lights,
            {
                emissive: {
                    value: new $fd4eb456bcbd06f8$var$L(0)
                },
                roughness: {
                    value: 1
                },
                metalness: {
                    value: 0
                },
                envMapIntensity: {
                    value: 1
                }
            }
        ]),
        vertexShader: $fd4eb456bcbd06f8$var$sn.meshphysical_vert,
        fragmentShader: $fd4eb456bcbd06f8$var$sn.meshphysical_frag
    },
    toon: {
        uniforms: $fd4eb456bcbd06f8$var$ze([
            $fd4eb456bcbd06f8$var$an.common,
            $fd4eb456bcbd06f8$var$an.aomap,
            $fd4eb456bcbd06f8$var$an.lightmap,
            $fd4eb456bcbd06f8$var$an.emissivemap,
            $fd4eb456bcbd06f8$var$an.bumpmap,
            $fd4eb456bcbd06f8$var$an.normalmap,
            $fd4eb456bcbd06f8$var$an.displacementmap,
            $fd4eb456bcbd06f8$var$an.gradientmap,
            $fd4eb456bcbd06f8$var$an.fog,
            $fd4eb456bcbd06f8$var$an.lights,
            {
                emissive: {
                    value: new $fd4eb456bcbd06f8$var$L(0)
                }
            }
        ]),
        vertexShader: $fd4eb456bcbd06f8$var$sn.meshtoon_vert,
        fragmentShader: $fd4eb456bcbd06f8$var$sn.meshtoon_frag
    },
    matcap: {
        uniforms: $fd4eb456bcbd06f8$var$ze([
            $fd4eb456bcbd06f8$var$an.common,
            $fd4eb456bcbd06f8$var$an.bumpmap,
            $fd4eb456bcbd06f8$var$an.normalmap,
            $fd4eb456bcbd06f8$var$an.displacementmap,
            $fd4eb456bcbd06f8$var$an.fog,
            {
                matcap: {
                    value: null
                }
            }
        ]),
        vertexShader: $fd4eb456bcbd06f8$var$sn.meshmatcap_vert,
        fragmentShader: $fd4eb456bcbd06f8$var$sn.meshmatcap_frag
    },
    points: {
        uniforms: $fd4eb456bcbd06f8$var$ze([
            $fd4eb456bcbd06f8$var$an.points,
            $fd4eb456bcbd06f8$var$an.fog
        ]),
        vertexShader: $fd4eb456bcbd06f8$var$sn.points_vert,
        fragmentShader: $fd4eb456bcbd06f8$var$sn.points_frag
    },
    dashed: {
        uniforms: $fd4eb456bcbd06f8$var$ze([
            $fd4eb456bcbd06f8$var$an.common,
            $fd4eb456bcbd06f8$var$an.fog,
            {
                scale: {
                    value: 1
                },
                dashSize: {
                    value: 1
                },
                totalSize: {
                    value: 2
                }
            }
        ]),
        vertexShader: $fd4eb456bcbd06f8$var$sn.linedashed_vert,
        fragmentShader: $fd4eb456bcbd06f8$var$sn.linedashed_frag
    },
    depth: {
        uniforms: $fd4eb456bcbd06f8$var$ze([
            $fd4eb456bcbd06f8$var$an.common,
            $fd4eb456bcbd06f8$var$an.displacementmap
        ]),
        vertexShader: $fd4eb456bcbd06f8$var$sn.depth_vert,
        fragmentShader: $fd4eb456bcbd06f8$var$sn.depth_frag
    },
    normal: {
        uniforms: $fd4eb456bcbd06f8$var$ze([
            $fd4eb456bcbd06f8$var$an.common,
            $fd4eb456bcbd06f8$var$an.bumpmap,
            $fd4eb456bcbd06f8$var$an.normalmap,
            $fd4eb456bcbd06f8$var$an.displacementmap,
            {
                opacity: {
                    value: 1
                }
            }
        ]),
        vertexShader: $fd4eb456bcbd06f8$var$sn.meshnormal_vert,
        fragmentShader: $fd4eb456bcbd06f8$var$sn.meshnormal_frag
    },
    sprite: {
        uniforms: $fd4eb456bcbd06f8$var$ze([
            $fd4eb456bcbd06f8$var$an.sprite,
            $fd4eb456bcbd06f8$var$an.fog
        ]),
        vertexShader: $fd4eb456bcbd06f8$var$sn.sprite_vert,
        fragmentShader: $fd4eb456bcbd06f8$var$sn.sprite_frag
    },
    background: {
        uniforms: {
            uvTransform: {
                value: new $fd4eb456bcbd06f8$var$v
            },
            t2D: {
                value: null
            }
        },
        vertexShader: $fd4eb456bcbd06f8$var$sn.background_vert,
        fragmentShader: $fd4eb456bcbd06f8$var$sn.background_frag
    },
    cube: {
        uniforms: $fd4eb456bcbd06f8$var$ze([
            $fd4eb456bcbd06f8$var$an.envmap,
            {
                opacity: {
                    value: 1
                }
            }
        ]),
        vertexShader: $fd4eb456bcbd06f8$var$sn.cube_vert,
        fragmentShader: $fd4eb456bcbd06f8$var$sn.cube_frag
    },
    equirect: {
        uniforms: {
            tEquirect: {
                value: null
            }
        },
        vertexShader: $fd4eb456bcbd06f8$var$sn.equirect_vert,
        fragmentShader: $fd4eb456bcbd06f8$var$sn.equirect_frag
    },
    distanceRGBA: {
        uniforms: $fd4eb456bcbd06f8$var$ze([
            $fd4eb456bcbd06f8$var$an.common,
            $fd4eb456bcbd06f8$var$an.displacementmap,
            {
                referencePosition: {
                    value: new $fd4eb456bcbd06f8$var$V
                },
                nearDistance: {
                    value: 1
                },
                farDistance: {
                    value: 1e3
                }
            }
        ]),
        vertexShader: $fd4eb456bcbd06f8$var$sn.distanceRGBA_vert,
        fragmentShader: $fd4eb456bcbd06f8$var$sn.distanceRGBA_frag
    },
    shadow: {
        uniforms: $fd4eb456bcbd06f8$var$ze([
            $fd4eb456bcbd06f8$var$an.lights,
            $fd4eb456bcbd06f8$var$an.fog,
            {
                color: {
                    value: new $fd4eb456bcbd06f8$var$L(0)
                },
                opacity: {
                    value: 1
                }
            }
        ]),
        vertexShader: $fd4eb456bcbd06f8$var$sn.shadow_vert,
        fragmentShader: $fd4eb456bcbd06f8$var$sn.shadow_frag
    }
};
function $fd4eb456bcbd06f8$var$ln(t1, e, n, i, r, s) {
    const a = new $fd4eb456bcbd06f8$var$L(0);
    let o, l, h = !0 === r ? 0 : 1, c = null, u = 0, d = null;
    function p(t1, e) {
        n.buffers.color.setClear(t1.r, t1.g, t1.b, e, s);
    }
    return {
        getClearColor: function() {
            return a;
        },
        setClearColor: function(t1, e = 1) {
            a.set(t1), h = e, p(a, h);
        },
        getClearAlpha: function() {
            return h;
        },
        setClearAlpha: function(t1) {
            h = t1, p(a, h);
        },
        render: function(n, r) {
            let s = !1, m = !0 === r.isScene ? r.background : null;
            m && m.isTexture && (m = e.get(m));
            const f = t1.xr, g = f.getSession && f.getSession();
            g && "additive" === g.environmentBlendMode && (m = null), null === m ? p(a, h) : m && m.isColor && (p(m, 1), s = !0), (t1.autoClear || s) && t1.clear(t1.autoClearColor, t1.autoClearDepth, t1.autoClearStencil), m && (m.isCubeTexture || 306 === m.mapping) ? (void 0 === l && (l = new $fd4eb456bcbd06f8$var$Fe(new $fd4eb456bcbd06f8$var$ke(1, 1, 1), new $fd4eb456bcbd06f8$var$Ve({
                name: "BackgroundCubeMaterial",
                uniforms: $fd4eb456bcbd06f8$var$Be($fd4eb456bcbd06f8$var$on.cube.uniforms),
                vertexShader: $fd4eb456bcbd06f8$var$on.cube.vertexShader,
                fragmentShader: $fd4eb456bcbd06f8$var$on.cube.fragmentShader,
                side: 1,
                depthTest: !1,
                depthWrite: !1,
                fog: !1
            })), l.geometry.deleteAttribute("normal"), l.geometry.deleteAttribute("uv"), l.onBeforeRender = function(t1, e, n) {
                this.matrixWorld.copyPosition(n.matrixWorld);
            }, Object.defineProperty(l.material, "envMap", {
                get: function() {
                    return this.uniforms.envMap.value;
                }
            }), i.update(l)), l.material.uniforms.envMap.value = m, l.material.uniforms.flipEnvMap.value = m.isCubeTexture && !1 === m.isRenderTargetTexture ? -1 : 1, c === m && u === m.version && d === t1.toneMapping || (l.material.needsUpdate = !0, c = m, u = m.version, d = t1.toneMapping), n.unshift(l, l.geometry, l.material, 0, 0, null)) : m && m.isTexture && (void 0 === o && (o = new $fd4eb456bcbd06f8$var$Fe(new $fd4eb456bcbd06f8$var$rn(2, 2), new $fd4eb456bcbd06f8$var$Ve({
                name: "BackgroundMaterial",
                uniforms: $fd4eb456bcbd06f8$var$Be($fd4eb456bcbd06f8$var$on.background.uniforms),
                vertexShader: $fd4eb456bcbd06f8$var$on.background.vertexShader,
                fragmentShader: $fd4eb456bcbd06f8$var$on.background.fragmentShader,
                side: 0,
                depthTest: !1,
                depthWrite: !1,
                fog: !1
            })), o.geometry.deleteAttribute("normal"), Object.defineProperty(o.material, "map", {
                get: function() {
                    return this.uniforms.t2D.value;
                }
            }), i.update(o)), o.material.uniforms.t2D.value = m, !0 === m.matrixAutoUpdate && m.updateMatrix(), o.material.uniforms.uvTransform.value.copy(m.matrix), c === m && u === m.version && d === t1.toneMapping || (o.material.needsUpdate = !0, c = m, u = m.version, d = t1.toneMapping), n.unshift(o, o.geometry, o.material, 0, 0, null));
        }
    };
}
function $fd4eb456bcbd06f8$var$hn(t1, e, n, i) {
    const r = t1.getParameter(34921), s = i.isWebGL2 ? null : e.get("OES_vertex_array_object"), a = i.isWebGL2 || null !== s, o = {}, l = p(null);
    let h = l, c = !1;
    function u(e) {
        return i.isWebGL2 ? t1.bindVertexArray(e) : s.bindVertexArrayOES(e);
    }
    function d(e) {
        return i.isWebGL2 ? t1.deleteVertexArray(e) : s.deleteVertexArrayOES(e);
    }
    function p(t1) {
        const e = [], n = [], i = [];
        for(let t1 = 0; t1 < r; t1++)e[t1] = 0, n[t1] = 0, i[t1] = 0;
        return {
            geometry: null,
            program: null,
            wireframe: !1,
            newAttributes: e,
            enabledAttributes: n,
            attributeDivisors: i,
            object: t1,
            attributes: {},
            index: null
        };
    }
    function m() {
        const t1 = h.newAttributes;
        for(let e = 0, n = t1.length; e < n; e++)t1[e] = 0;
    }
    function f(t1) {
        g(t1, 0);
    }
    function g(n, r) {
        const s = h.newAttributes, a = h.enabledAttributes, o = h.attributeDivisors;
        if (s[n] = 1, 0 === a[n] && (t1.enableVertexAttribArray(n), a[n] = 1), o[n] !== r) (i.isWebGL2 ? t1 : e.get("ANGLE_instanced_arrays"))[i.isWebGL2 ? "vertexAttribDivisor" : "vertexAttribDivisorANGLE"](n, r), o[n] = r;
    }
    function v() {
        const e = h.newAttributes, n = h.enabledAttributes;
        for(let i = 0, r = n.length; i < r; i++)n[i] !== e[i] && (t1.disableVertexAttribArray(i), n[i] = 0);
    }
    function y(e, n, r, s, a, o) {
        !0 !== i.isWebGL2 || 5124 !== r && 5125 !== r ? t1.vertexAttribPointer(e, n, r, s, a, o) : t1.vertexAttribIPointer(e, n, r, a, o);
    }
    function x() {
        b(), c = !0, h !== l && (h = l, u(h.object));
    }
    function b() {
        l.geometry = null, l.program = null, l.wireframe = !1;
    }
    return {
        setup: function(r, l, d, x, b) {
            let _ = !1;
            if (a) {
                const e = function(e, n, r) {
                    const a = !0 === r.wireframe;
                    let l = o[e.id];
                    void 0 === l && (l = {}, o[e.id] = l);
                    let h = l[n.id];
                    void 0 === h && (h = {}, l[n.id] = h);
                    let c = h[a];
                    void 0 === c && (c = p(i.isWebGL2 ? t1.createVertexArray() : s.createVertexArrayOES()), h[a] = c);
                    return c;
                }(x, d, l);
                h !== e && (h = e, u(h.object)), _ = function(t1, e) {
                    const n = h.attributes, i = t1.attributes;
                    let r = 0;
                    for(const t1 in i){
                        const e = n[t1], s = i[t1];
                        if (void 0 === e) return !0;
                        if (e.attribute !== s) return !0;
                        if (e.data !== s.data) return !0;
                        r++;
                    }
                    return h.attributesNum !== r || h.index !== e;
                }(x, b), _ && function(t1, e) {
                    const n = {}, i = t1.attributes;
                    let r = 0;
                    for(const t1 in i){
                        const e = i[t1], s = {};
                        s.attribute = e, e.data && (s.data = e.data), n[t1] = s, r++;
                    }
                    h.attributes = n, h.attributesNum = r, h.index = e;
                }(x, b);
            } else {
                const t1 = !0 === l.wireframe;
                h.geometry === x.id && h.program === d.id && h.wireframe === t1 || (h.geometry = x.id, h.program = d.id, h.wireframe = t1, _ = !0);
            }
            !0 === r.isInstancedMesh && (_ = !0), null !== b && n.update(b, 34963), (_ || c) && (c = !1, function(r, s, a, o) {
                if (!1 === i.isWebGL2 && (r.isInstancedMesh || o.isInstancedBufferGeometry) && null === e.get("ANGLE_instanced_arrays")) return;
                m();
                const l = o.attributes, h = a.getAttributes(), c = s.defaultAttributeValues;
                for(const e in h){
                    const i = h[e];
                    if (i.location >= 0) {
                        let s = l[e];
                        if (void 0 === s && ("instanceMatrix" === e && r.instanceMatrix && (s = r.instanceMatrix), "instanceColor" === e && r.instanceColor && (s = r.instanceColor)), void 0 !== s) {
                            const e = s.normalized, a = s.itemSize, l = n.get(s);
                            if (void 0 === l) continue;
                            const h = l.buffer, c = l.type, u = l.bytesPerElement;
                            if (s.isInterleavedBufferAttribute) {
                                const n = s.data, l = n.stride, d = s.offset;
                                if (n.isInstancedInterleavedBuffer) {
                                    for(let t1 = 0; t1 < i.locationSize; t1++)g(i.location + t1, n.meshPerAttribute);
                                    !0 !== r.isInstancedMesh && void 0 === o._maxInstanceCount && (o._maxInstanceCount = n.meshPerAttribute * n.count);
                                } else for(let t1 = 0; t1 < i.locationSize; t1++)f(i.location + t1);
                                t1.bindBuffer(34962, h);
                                for(let t1 = 0; t1 < i.locationSize; t1++)y(i.location + t1, a / i.locationSize, c, e, l * u, (d + a / i.locationSize * t1) * u);
                            } else {
                                if (s.isInstancedBufferAttribute) {
                                    for(let t1 = 0; t1 < i.locationSize; t1++)g(i.location + t1, s.meshPerAttribute);
                                    !0 !== r.isInstancedMesh && void 0 === o._maxInstanceCount && (o._maxInstanceCount = s.meshPerAttribute * s.count);
                                } else for(let t1 = 0; t1 < i.locationSize; t1++)f(i.location + t1);
                                t1.bindBuffer(34962, h);
                                for(let t1 = 0; t1 < i.locationSize; t1++)y(i.location + t1, a / i.locationSize, c, e, a * u, a / i.locationSize * t1 * u);
                            }
                        } else if (void 0 !== c) {
                            const n = c[e];
                            if (void 0 !== n) switch(n.length){
                                case 2:
                                    t1.vertexAttrib2fv(i.location, n);
                                    break;
                                case 3:
                                    t1.vertexAttrib3fv(i.location, n);
                                    break;
                                case 4:
                                    t1.vertexAttrib4fv(i.location, n);
                                    break;
                                default:
                                    t1.vertexAttrib1fv(i.location, n);
                            }
                        }
                    }
                }
                v();
            }(r, l, d, x), null !== b && t1.bindBuffer(34963, n.get(b).buffer));
        },
        reset: x,
        resetDefaultState: b,
        dispose: function() {
            x();
            for(const t1 in o){
                const e = o[t1];
                for(const t1 in e){
                    const n = e[t1];
                    for(const t1 in n)d(n[t1].object), delete n[t1];
                    delete e[t1];
                }
                delete o[t1];
            }
        },
        releaseStatesOfGeometry: function(t1) {
            if (void 0 === o[t1.id]) return;
            const e = o[t1.id];
            for(const t1 in e){
                const n = e[t1];
                for(const t1 in n)d(n[t1].object), delete n[t1];
                delete e[t1];
            }
            delete o[t1.id];
        },
        releaseStatesOfProgram: function(t1) {
            for(const e in o){
                const n = o[e];
                if (void 0 === n[t1.id]) continue;
                const i = n[t1.id];
                for(const t1 in i)d(i[t1].object), delete i[t1];
                delete n[t1.id];
            }
        },
        initAttributes: m,
        enableAttribute: f,
        disableUnusedAttributes: v
    };
}
function $fd4eb456bcbd06f8$var$cn(t1, e, n, i) {
    const r = i.isWebGL2;
    let s;
    this.setMode = function(t1) {
        s = t1;
    }, this.render = function(e, i) {
        t1.drawArrays(s, e, i), n.update(i, s, 1);
    }, this.renderInstances = function(i, a, o) {
        if (0 === o) return;
        let l, h;
        if (r) l = t1, h = "drawArraysInstanced";
        else if (l = e.get("ANGLE_instanced_arrays"), h = "drawArraysInstancedANGLE", null === l) return void console.error("THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
        l[h](s, i, a, o), n.update(a, s, o);
    };
}
function $fd4eb456bcbd06f8$var$un(t1, e, n) {
    let i;
    function r(e) {
        if ("highp" === e) {
            if (t1.getShaderPrecisionFormat(35633, 36338).precision > 0 && t1.getShaderPrecisionFormat(35632, 36338).precision > 0) return "highp";
            e = "mediump";
        }
        return "mediump" === e && t1.getShaderPrecisionFormat(35633, 36337).precision > 0 && t1.getShaderPrecisionFormat(35632, 36337).precision > 0 ? "mediump" : "lowp";
    }
    const s = "undefined" != typeof WebGL2RenderingContext && t1 instanceof WebGL2RenderingContext || "undefined" != typeof WebGL2ComputeRenderingContext && t1 instanceof WebGL2ComputeRenderingContext;
    let a = void 0 !== n.precision ? n.precision : "highp";
    const o = r(a);
    o !== a && (console.warn("THREE.WebGLRenderer:", a, "not supported, using", o, "instead."), a = o);
    const l = s || e.has("WEBGL_draw_buffers"), h = !0 === n.logarithmicDepthBuffer, c = t1.getParameter(34930), u = t1.getParameter(35660), d = t1.getParameter(3379), p = t1.getParameter(34076), m = t1.getParameter(34921), f = t1.getParameter(36347), g = t1.getParameter(36348), v = t1.getParameter(36349), y = u > 0, x = s || e.has("OES_texture_float");
    return {
        isWebGL2: s,
        drawBuffers: l,
        getMaxAnisotropy: function() {
            if (void 0 !== i) return i;
            if (!0 === e.has("EXT_texture_filter_anisotropic")) {
                const n = e.get("EXT_texture_filter_anisotropic");
                i = t1.getParameter(n.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
            } else i = 0;
            return i;
        },
        getMaxPrecision: r,
        precision: a,
        logarithmicDepthBuffer: h,
        maxTextures: c,
        maxVertexTextures: u,
        maxTextureSize: d,
        maxCubemapSize: p,
        maxAttributes: m,
        maxVertexUniforms: f,
        maxVaryings: g,
        maxFragmentUniforms: v,
        vertexTextures: y,
        floatFragmentTextures: x,
        floatVertexTextures: y && x,
        maxSamples: s ? t1.getParameter(36183) : 0
    };
}
function $fd4eb456bcbd06f8$var$dn(t1) {
    const e = this;
    let n = null, i = 0, r = !1, s = !1;
    const a = new $fd4eb456bcbd06f8$var$Ke, o = new $fd4eb456bcbd06f8$var$v, l = {
        value: null,
        needsUpdate: !1
    };
    function h() {
        l.value !== n && (l.value = n, l.needsUpdate = i > 0), e.numPlanes = i, e.numIntersection = 0;
    }
    function c(t1, n, i, r) {
        const s = null !== t1 ? t1.length : 0;
        let h = null;
        if (0 !== s) {
            if (h = l.value, !0 !== r || null === h) {
                const e = i + 4 * s, r = n.matrixWorldInverse;
                o.getNormalMatrix(r), (null === h || h.length < e) && (h = new Float32Array(e));
                for(let e = 0, n = i; e !== s; ++e, n += 4)a.copy(t1[e]).applyMatrix4(r, o), a.normal.toArray(h, n), h[n + 3] = a.constant;
            }
            l.value = h, l.needsUpdate = !0;
        }
        return e.numPlanes = s, e.numIntersection = 0, h;
    }
    this.uniform = l, this.numPlanes = 0, this.numIntersection = 0, this.init = function(t1, e, s) {
        const a = 0 !== t1.length || e || 0 !== i || r;
        return r = e, n = c(t1, s, 0), i = t1.length, a;
    }, this.beginShadows = function() {
        s = !0, c(null);
    }, this.endShadows = function() {
        s = !1, h();
    }, this.setState = function(e, a, o) {
        const u = e.clippingPlanes, d = e.clipIntersection, p = e.clipShadows, m = t1.get(e);
        if (!r || null === u || 0 === u.length || s && !p) s ? c(null) : h();
        else {
            const t1 = s ? 0 : i, e = 4 * t1;
            let r = m.clippingState || null;
            l.value = r, r = c(u, a, e, o);
            for(let t1 = 0; t1 !== e; ++t1)r[t1] = n[t1];
            m.clippingState = r, this.numIntersection = d ? this.numPlanes : 0, this.numPlanes += t1;
        }
    };
}
function $fd4eb456bcbd06f8$var$pn(t1) {
    let e = new WeakMap;
    function n(t1, e) {
        return 303 === e ? t1.mapping = 301 : 304 === e && (t1.mapping = 302), t1;
    }
    function i(t1) {
        const n = t1.target;
        n.removeEventListener("dispose", i);
        const r = e.get(n);
        void 0 !== r && (e.delete(n), r.dispose());
    }
    return {
        get: function(r) {
            if (r && r.isTexture && !1 === r.isRenderTargetTexture) {
                const s = r.mapping;
                if (303 === s || 304 === s) {
                    if (e.has(r)) return n(e.get(r).texture, r.mapping);
                    {
                        const s = r.image;
                        if (s && s.height > 0) {
                            const a = new $fd4eb456bcbd06f8$var$Xe(s.height / 2);
                            return a.fromEquirectangularTexture(t1, r), e.set(r, a), r.addEventListener("dispose", i), n(a.texture, r.mapping);
                        }
                        return null;
                    }
                }
            }
            return r;
        },
        dispose: function() {
            e = new WeakMap;
        }
    };
}
$fd4eb456bcbd06f8$var$on.physical = {
    uniforms: $fd4eb456bcbd06f8$var$ze([
        $fd4eb456bcbd06f8$var$on.standard.uniforms,
        {
            clearcoat: {
                value: 0
            },
            clearcoatMap: {
                value: null
            },
            clearcoatRoughness: {
                value: 0
            },
            clearcoatRoughnessMap: {
                value: null
            },
            clearcoatNormalScale: {
                value: new $fd4eb456bcbd06f8$var$g(1, 1)
            },
            clearcoatNormalMap: {
                value: null
            },
            sheen: {
                value: 0
            },
            sheenColor: {
                value: new $fd4eb456bcbd06f8$var$L(0)
            },
            sheenColorMap: {
                value: null
            },
            sheenRoughness: {
                value: 1
            },
            sheenRoughnessMap: {
                value: null
            },
            transmission: {
                value: 0
            },
            transmissionMap: {
                value: null
            },
            transmissionSamplerSize: {
                value: new $fd4eb456bcbd06f8$var$g
            },
            transmissionSamplerMap: {
                value: null
            },
            thickness: {
                value: 0
            },
            thicknessMap: {
                value: null
            },
            attenuationDistance: {
                value: 0
            },
            attenuationColor: {
                value: new $fd4eb456bcbd06f8$var$L(0)
            },
            specularIntensity: {
                value: 1
            },
            specularIntensityMap: {
                value: null
            },
            specularColor: {
                value: new $fd4eb456bcbd06f8$var$L(1, 1, 1)
            },
            specularColorMap: {
                value: null
            }
        }
    ]),
    vertexShader: $fd4eb456bcbd06f8$var$sn.meshphysical_vert,
    fragmentShader: $fd4eb456bcbd06f8$var$sn.meshphysical_frag
};
class $fd4eb456bcbd06f8$var$mn extends $fd4eb456bcbd06f8$var$Ge {
    constructor(t1 = -1, e = 1, n = 1, i = -1, r = .1, s = 2e3){
        super(), this.type = "OrthographicCamera", this.zoom = 1, this.view = null, this.left = t1, this.right = e, this.top = n, this.bottom = i, this.near = r, this.far = s, this.updateProjectionMatrix();
    }
    copy(t1, e) {
        return super.copy(t1, e), this.left = t1.left, this.right = t1.right, this.top = t1.top, this.bottom = t1.bottom, this.near = t1.near, this.far = t1.far, this.zoom = t1.zoom, this.view = null === t1.view ? null : Object.assign({}, t1.view), this;
    }
    setViewOffset(t1, e, n, i, r, s) {
        null === this.view && (this.view = {
            enabled: !0,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        }), this.view.enabled = !0, this.view.fullWidth = t1, this.view.fullHeight = e, this.view.offsetX = n, this.view.offsetY = i, this.view.width = r, this.view.height = s, this.updateProjectionMatrix();
    }
    clearViewOffset() {
        null !== this.view && (this.view.enabled = !1), this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        const t1 = (this.right - this.left) / (2 * this.zoom), e = (this.top - this.bottom) / (2 * this.zoom), n = (this.right + this.left) / 2, i = (this.top + this.bottom) / 2;
        let r = n - t1, s = n + t1, a = i + e, o = i - e;
        if (null !== this.view && this.view.enabled) {
            const t1 = (this.right - this.left) / this.view.fullWidth / this.zoom, e = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
            r += t1 * this.view.offsetX, s = r + t1 * this.view.width, a -= e * this.view.offsetY, o = a - e * this.view.height;
        }
        this.projectionMatrix.makeOrthographic(r, s, a, o, this.near, this.far), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(t1) {
        const e = super.toJSON(t1);
        return e.object.zoom = this.zoom, e.object.left = this.left, e.object.right = this.right, e.object.top = this.top, e.object.bottom = this.bottom, e.object.near = this.near, e.object.far = this.far, null !== this.view && (e.object.view = Object.assign({}, this.view)), e;
    }
}
$fd4eb456bcbd06f8$var$mn.prototype.isOrthographicCamera = !0;
const $fd4eb456bcbd06f8$var$fn = [
    .125,
    .215,
    .35,
    .446,
    .526,
    .582
], $fd4eb456bcbd06f8$var$gn = new $fd4eb456bcbd06f8$var$mn, $fd4eb456bcbd06f8$var$vn = new $fd4eb456bcbd06f8$var$L;
let $fd4eb456bcbd06f8$var$yn = null;
const $fd4eb456bcbd06f8$var$xn = (1 + Math.sqrt(5)) / 2, $fd4eb456bcbd06f8$var$bn = 1 / $fd4eb456bcbd06f8$var$xn, $fd4eb456bcbd06f8$var$_n = [
    new $fd4eb456bcbd06f8$var$V(1, 1, 1),
    new $fd4eb456bcbd06f8$var$V(-1, 1, 1),
    new $fd4eb456bcbd06f8$var$V(1, 1, -1),
    new $fd4eb456bcbd06f8$var$V(-1, 1, -1),
    new $fd4eb456bcbd06f8$var$V(0, $fd4eb456bcbd06f8$var$xn, $fd4eb456bcbd06f8$var$bn),
    new $fd4eb456bcbd06f8$var$V(0, $fd4eb456bcbd06f8$var$xn, -$fd4eb456bcbd06f8$var$bn),
    new $fd4eb456bcbd06f8$var$V($fd4eb456bcbd06f8$var$bn, 0, $fd4eb456bcbd06f8$var$xn),
    new $fd4eb456bcbd06f8$var$V(-$fd4eb456bcbd06f8$var$bn, 0, $fd4eb456bcbd06f8$var$xn),
    new $fd4eb456bcbd06f8$var$V($fd4eb456bcbd06f8$var$xn, $fd4eb456bcbd06f8$var$bn, 0),
    new $fd4eb456bcbd06f8$var$V(-$fd4eb456bcbd06f8$var$xn, $fd4eb456bcbd06f8$var$bn, 0)
];
class $fd4eb456bcbd06f8$var$wn {
    constructor(t1){
        this._renderer = t1, this._pingPongRenderTarget = null, this._lodMax = 0, this._cubeSize = 0, this._lodPlanes = [], this._sizeLods = [], this._sigmas = [], this._blurMaterial = null, this._cubemapMaterial = null, this._equirectMaterial = null, this._compileMaterial(this._blurMaterial);
    }
    fromScene(t1, e = 0, n = .1, i = 100) {
        $fd4eb456bcbd06f8$var$yn = this._renderer.getRenderTarget(), this._setSize(256);
        const r = this._allocateTargets();
        return r.depthBuffer = !0, this._sceneToCubeUV(t1, n, i, r), e > 0 && this._blur(r, 0, 0, e), this._applyPMREM(r), this._cleanup(r), r;
    }
    fromEquirectangular(t1, e = null) {
        return this._fromTexture(t1, e);
    }
    fromCubemap(t1, e = null) {
        return this._fromTexture(t1, e);
    }
    compileCubemapShader() {
        null === this._cubemapMaterial && (this._cubemapMaterial = $fd4eb456bcbd06f8$var$En(), this._compileMaterial(this._cubemapMaterial));
    }
    compileEquirectangularShader() {
        null === this._equirectMaterial && (this._equirectMaterial = $fd4eb456bcbd06f8$var$Tn(), this._compileMaterial(this._equirectMaterial));
    }
    dispose() {
        this._dispose(), null !== this._cubemapMaterial && this._cubemapMaterial.dispose(), null !== this._equirectMaterial && this._equirectMaterial.dispose();
    }
    _setSize(t1) {
        this._lodMax = Math.floor(Math.log2(t1)), this._cubeSize = Math.pow(2, this._lodMax);
    }
    _dispose() {
        null !== this._blurMaterial && this._blurMaterial.dispose(), null !== this._pingPongRenderTarget && this._pingPongRenderTarget.dispose();
        for(let t1 = 0; t1 < this._lodPlanes.length; t1++)this._lodPlanes[t1].dispose();
    }
    _cleanup(t1) {
        this._renderer.setRenderTarget($fd4eb456bcbd06f8$var$yn), t1.scissorTest = !1, $fd4eb456bcbd06f8$var$Sn(t1, 0, 0, t1.width, t1.height);
    }
    _fromTexture(t1, e) {
        301 === t1.mapping || 302 === t1.mapping ? this._setSize(0 === t1.image.length ? 16 : t1.image[0].width || t1.image[0].image.width) : this._setSize(t1.image.width / 4), $fd4eb456bcbd06f8$var$yn = this._renderer.getRenderTarget();
        const n = e || this._allocateTargets();
        return this._textureToCubeUV(t1, n), this._applyPMREM(n), this._cleanup(n), n;
    }
    _allocateTargets() {
        const t1 = 3 * Math.max(this._cubeSize, 112), e = 4 * this._cubeSize - 32, n = {
            magFilter: 1006,
            minFilter: 1006,
            generateMipmaps: !1,
            type: 1016,
            format: 1023,
            encoding: 3e3,
            depthBuffer: !1
        }, i = $fd4eb456bcbd06f8$var$Mn(t1, e, n);
        if (null === this._pingPongRenderTarget || this._pingPongRenderTarget.width !== t1) {
            null !== this._pingPongRenderTarget && this._dispose(), this._pingPongRenderTarget = $fd4eb456bcbd06f8$var$Mn(t1, e, n);
            const { _lodMax: i } = this;
            ({ sizeLods: this._sizeLods, lodPlanes: this._lodPlanes, sigmas: this._sigmas } = function(t1) {
                const e = [], n = [], i = [];
                let r = t1;
                const s = t1 - 4 + 1 + $fd4eb456bcbd06f8$var$fn.length;
                for(let a = 0; a < s; a++){
                    const s = Math.pow(2, r);
                    n.push(s);
                    let o = 1 / s;
                    a > t1 - 4 ? o = $fd4eb456bcbd06f8$var$fn[a - t1 + 4 - 1] : 0 === a && (o = 0), i.push(o);
                    const l = 1 / (s - 1), h = -l / 2, c = 1 + l / 2, u = [
                        h,
                        h,
                        c,
                        h,
                        c,
                        c,
                        h,
                        h,
                        c,
                        c,
                        h,
                        c
                    ], d = 6, p = 6, m = 3, f = 2, g = 1, v = new Float32Array(m * p * d), y = new Float32Array(f * p * d), x = new Float32Array(g * p * d);
                    for(let t1 = 0; t1 < d; t1++){
                        const e = t1 % 3 * 2 / 3 - 1, n = t1 > 2 ? 0 : -1, i = [
                            e,
                            n,
                            0,
                            e + 2 / 3,
                            n,
                            0,
                            e + 2 / 3,
                            n + 1,
                            0,
                            e,
                            n,
                            0,
                            e + 2 / 3,
                            n + 1,
                            0,
                            e,
                            n + 1,
                            0
                        ];
                        v.set(i, m * p * t1), y.set(u, f * p * t1);
                        const r = [
                            t1,
                            t1,
                            t1,
                            t1,
                            t1,
                            t1
                        ];
                        x.set(r, g * p * t1);
                    }
                    const b = new $fd4eb456bcbd06f8$var$ye;
                    b.setAttribute("position", new $fd4eb456bcbd06f8$var$oe(v, m)), b.setAttribute("uv", new $fd4eb456bcbd06f8$var$oe(y, f)), b.setAttribute("faceIndex", new $fd4eb456bcbd06f8$var$oe(x, g)), e.push(b), r > 4 && r--;
                }
                return {
                    lodPlanes: e,
                    sizeLods: n,
                    sigmas: i
                };
            }(i)), this._blurMaterial = function(t1, e, n) {
                const i = new Float32Array(20), r = new $fd4eb456bcbd06f8$var$V(0, 1, 0);
                return new $fd4eb456bcbd06f8$var$Ve({
                    name: "SphericalGaussianBlur",
                    defines: {
                        n: 20,
                        CUBEUV_TEXEL_WIDTH: 1 / e,
                        CUBEUV_TEXEL_HEIGHT: 1 / n,
                        CUBEUV_MAX_MIP: `${t1}.0`
                    },
                    uniforms: {
                        envMap: {
                            value: null
                        },
                        samples: {
                            value: 1
                        },
                        weights: {
                            value: i
                        },
                        latitudinal: {
                            value: !1
                        },
                        dTheta: {
                            value: 0
                        },
                        mipInt: {
                            value: 0
                        },
                        poleAxis: {
                            value: r
                        }
                    },
                    vertexShader: $fd4eb456bcbd06f8$var$An(),
                    fragmentShader: "\n\n\t\t\tprecision mediump float;\n\t\t\tprecision mediump int;\n\n\t\t\tvarying vec3 vOutputDirection;\n\n\t\t\tuniform sampler2D envMap;\n\t\t\tuniform int samples;\n\t\t\tuniform float weights[ n ];\n\t\t\tuniform bool latitudinal;\n\t\t\tuniform float dTheta;\n\t\t\tuniform float mipInt;\n\t\t\tuniform vec3 poleAxis;\n\n\t\t\t#define ENVMAP_TYPE_CUBE_UV\n\t\t\t#include <cube_uv_reflection_fragment>\n\n\t\t\tvec3 getSample( float theta, vec3 axis ) {\n\n\t\t\t\tfloat cosTheta = cos( theta );\n\t\t\t\t// Rodrigues' axis-angle rotation\n\t\t\t\tvec3 sampleDirection = vOutputDirection * cosTheta\n\t\t\t\t\t+ cross( axis, vOutputDirection ) * sin( theta )\n\t\t\t\t\t+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );\n\n\t\t\t\treturn bilinearCubeUV( envMap, sampleDirection, mipInt );\n\n\t\t\t}\n\n\t\t\tvoid main() {\n\n\t\t\t\tvec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );\n\n\t\t\t\tif ( all( equal( axis, vec3( 0.0 ) ) ) ) {\n\n\t\t\t\t\taxis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );\n\n\t\t\t\t}\n\n\t\t\t\taxis = normalize( axis );\n\n\t\t\t\tgl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n\t\t\t\tgl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );\n\n\t\t\t\tfor ( int i = 1; i < n; i++ ) {\n\n\t\t\t\t\tif ( i >= samples ) {\n\n\t\t\t\t\t\tbreak;\n\n\t\t\t\t\t}\n\n\t\t\t\t\tfloat theta = dTheta * float( i );\n\t\t\t\t\tgl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );\n\t\t\t\t\tgl_FragColor.rgb += weights[ i ] * getSample( theta, axis );\n\n\t\t\t\t}\n\n\t\t\t}\n\t\t",
                    blending: 0,
                    depthTest: !1,
                    depthWrite: !1
                });
            }(i, t1, e);
        }
        return i;
    }
    _compileMaterial(t1) {
        const e = new $fd4eb456bcbd06f8$var$Fe(this._lodPlanes[0], t1);
        this._renderer.compile(e, $fd4eb456bcbd06f8$var$gn);
    }
    _sceneToCubeUV(t1, e, n, i) {
        const r = new $fd4eb456bcbd06f8$var$We(90, 1, e, n), s = [
            1,
            -1,
            1,
            1,
            1,
            1
        ], a = [
            1,
            1,
            1,
            -1,
            -1,
            -1
        ], o = this._renderer, l = o.autoClear, h = o.toneMapping;
        o.getClearColor($fd4eb456bcbd06f8$var$vn), o.toneMapping = 0, o.autoClear = !1;
        const c = new $fd4eb456bcbd06f8$var$re({
            name: "PMREM.Background",
            side: 1,
            depthWrite: !1,
            depthTest: !1
        }), u = new $fd4eb456bcbd06f8$var$Fe(new $fd4eb456bcbd06f8$var$ke, c);
        let d = !1;
        const p = t1.background;
        p ? p.isColor && (c.color.copy(p), t1.background = null, d = !0) : (c.color.copy($fd4eb456bcbd06f8$var$vn), d = !0);
        for(let e = 0; e < 6; e++){
            const n = e % 3;
            0 === n ? (r.up.set(0, s[e], 0), r.lookAt(a[e], 0, 0)) : 1 === n ? (r.up.set(0, 0, s[e]), r.lookAt(0, a[e], 0)) : (r.up.set(0, s[e], 0), r.lookAt(0, 0, a[e]));
            const l = this._cubeSize;
            $fd4eb456bcbd06f8$var$Sn(i, n * l, e > 2 ? l : 0, l, l), o.setRenderTarget(i), d && o.render(u, r), o.render(t1, r);
        }
        u.geometry.dispose(), u.material.dispose(), o.toneMapping = h, o.autoClear = l, t1.background = p;
    }
    _textureToCubeUV(t1, e) {
        const n = this._renderer, i = 301 === t1.mapping || 302 === t1.mapping;
        i ? (null === this._cubemapMaterial && (this._cubemapMaterial = $fd4eb456bcbd06f8$var$En()), this._cubemapMaterial.uniforms.flipEnvMap.value = !1 === t1.isRenderTargetTexture ? -1 : 1) : null === this._equirectMaterial && (this._equirectMaterial = $fd4eb456bcbd06f8$var$Tn());
        const r = i ? this._cubemapMaterial : this._equirectMaterial, s = new $fd4eb456bcbd06f8$var$Fe(this._lodPlanes[0], r);
        r.uniforms.envMap.value = t1;
        const a = this._cubeSize;
        $fd4eb456bcbd06f8$var$Sn(e, 0, 0, 3 * a, 2 * a), n.setRenderTarget(e), n.render(s, $fd4eb456bcbd06f8$var$gn);
    }
    _applyPMREM(t1) {
        const e = this._renderer, n = e.autoClear;
        e.autoClear = !1;
        for(let e = 1; e < this._lodPlanes.length; e++){
            const n = Math.sqrt(this._sigmas[e] * this._sigmas[e] - this._sigmas[e - 1] * this._sigmas[e - 1]), i = $fd4eb456bcbd06f8$var$_n[(e - 1) % $fd4eb456bcbd06f8$var$_n.length];
            this._blur(t1, e - 1, e, n, i);
        }
        e.autoClear = n;
    }
    _blur(t1, e, n, i, r) {
        const s = this._pingPongRenderTarget;
        this._halfBlur(t1, s, e, n, i, "latitudinal", r), this._halfBlur(s, t1, n, n, i, "longitudinal", r);
    }
    _halfBlur(t1, e, n, i, r, s, a) {
        const o = this._renderer, l = this._blurMaterial;
        "latitudinal" !== s && "longitudinal" !== s && console.error("blur direction must be either latitudinal or longitudinal!");
        const h = new $fd4eb456bcbd06f8$var$Fe(this._lodPlanes[i], l), c = l.uniforms, u = this._sizeLods[n] - 1, d = isFinite(r) ? Math.PI / (2 * u) : 2 * Math.PI / 39, p = r / d, m = isFinite(r) ? 1 + Math.floor(3 * p) : 20;
        m > 20 && console.warn(`sigmaRadians, ${r}, is too large and will clip, as it requested ${m} samples when the maximum is set to 20`);
        const f = [];
        let g = 0;
        for(let t1 = 0; t1 < 20; ++t1){
            const e = t1 / p, n = Math.exp(-e * e / 2);
            f.push(n), 0 === t1 ? g += n : t1 < m && (g += 2 * n);
        }
        for(let t1 = 0; t1 < f.length; t1++)f[t1] = f[t1] / g;
        c.envMap.value = t1.texture, c.samples.value = m, c.weights.value = f, c.latitudinal.value = "latitudinal" === s, a && (c.poleAxis.value = a);
        const { _lodMax: v } = this;
        c.dTheta.value = d, c.mipInt.value = v - n;
        const y = this._sizeLods[i];
        $fd4eb456bcbd06f8$var$Sn(e, 3 * y * (i > v - 4 ? i - v + 4 : 0), 4 * (this._cubeSize - y), 3 * y, 2 * y), o.setRenderTarget(e), o.render(h, $fd4eb456bcbd06f8$var$gn);
    }
}
function $fd4eb456bcbd06f8$var$Mn(t1, e, n) {
    const i = new $fd4eb456bcbd06f8$var$k(t1, e, n);
    return i.texture.mapping = 306, i.texture.name = "PMREM.cubeUv", i.scissorTest = !0, i;
}
function $fd4eb456bcbd06f8$var$Sn(t1, e, n, i, r) {
    t1.viewport.set(e, n, i, r), t1.scissor.set(e, n, i, r);
}
function $fd4eb456bcbd06f8$var$Tn() {
    return new $fd4eb456bcbd06f8$var$Ve({
        name: "EquirectangularToCubeUV",
        uniforms: {
            envMap: {
                value: null
            }
        },
        vertexShader: $fd4eb456bcbd06f8$var$An(),
        fragmentShader: "\n\n\t\t\tprecision mediump float;\n\t\t\tprecision mediump int;\n\n\t\t\tvarying vec3 vOutputDirection;\n\n\t\t\tuniform sampler2D envMap;\n\n\t\t\t#include <common>\n\n\t\t\tvoid main() {\n\n\t\t\t\tvec3 outputDirection = normalize( vOutputDirection );\n\t\t\t\tvec2 uv = equirectUv( outputDirection );\n\n\t\t\t\tgl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );\n\n\t\t\t}\n\t\t",
        blending: 0,
        depthTest: !1,
        depthWrite: !1
    });
}
function $fd4eb456bcbd06f8$var$En() {
    return new $fd4eb456bcbd06f8$var$Ve({
        name: "CubemapToCubeUV",
        uniforms: {
            envMap: {
                value: null
            },
            flipEnvMap: {
                value: -1
            }
        },
        vertexShader: $fd4eb456bcbd06f8$var$An(),
        fragmentShader: "\n\n\t\t\tprecision mediump float;\n\t\t\tprecision mediump int;\n\n\t\t\tuniform float flipEnvMap;\n\n\t\t\tvarying vec3 vOutputDirection;\n\n\t\t\tuniform samplerCube envMap;\n\n\t\t\tvoid main() {\n\n\t\t\t\tgl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );\n\n\t\t\t}\n\t\t",
        blending: 0,
        depthTest: !1,
        depthWrite: !1
    });
}
function $fd4eb456bcbd06f8$var$An() {
    return "\n\n\t\tprecision mediump float;\n\t\tprecision mediump int;\n\n\t\tattribute float faceIndex;\n\n\t\tvarying vec3 vOutputDirection;\n\n\t\t// RH coordinate system; PMREM face-indexing convention\n\t\tvec3 getDirection( vec2 uv, float face ) {\n\n\t\t\tuv = 2.0 * uv - 1.0;\n\n\t\t\tvec3 direction = vec3( uv, 1.0 );\n\n\t\t\tif ( face == 0.0 ) {\n\n\t\t\t\tdirection = direction.zyx; // ( 1, v, u ) pos x\n\n\t\t\t} else if ( face == 1.0 ) {\n\n\t\t\t\tdirection = direction.xzy;\n\t\t\t\tdirection.xz *= -1.0; // ( -u, 1, -v ) pos y\n\n\t\t\t} else if ( face == 2.0 ) {\n\n\t\t\t\tdirection.x *= -1.0; // ( -u, v, 1 ) pos z\n\n\t\t\t} else if ( face == 3.0 ) {\n\n\t\t\t\tdirection = direction.zyx;\n\t\t\t\tdirection.xz *= -1.0; // ( -1, v, -u ) neg x\n\n\t\t\t} else if ( face == 4.0 ) {\n\n\t\t\t\tdirection = direction.xzy;\n\t\t\t\tdirection.xy *= -1.0; // ( -u, -1, v ) neg y\n\n\t\t\t} else if ( face == 5.0 ) {\n\n\t\t\t\tdirection.z *= -1.0; // ( u, v, -1 ) neg z\n\n\t\t\t}\n\n\t\t\treturn direction;\n\n\t\t}\n\n\t\tvoid main() {\n\n\t\t\tvOutputDirection = getDirection( uv, faceIndex );\n\t\t\tgl_Position = vec4( position, 1.0 );\n\n\t\t}\n\t";
}
function $fd4eb456bcbd06f8$var$Rn(t1) {
    let e = new WeakMap, n = null;
    function i(t1) {
        const n = t1.target;
        n.removeEventListener("dispose", i);
        const r = e.get(n);
        void 0 !== r && (e.delete(n), r.dispose());
    }
    return {
        get: function(r) {
            if (r && r.isTexture) {
                const s = r.mapping, a = 303 === s || 304 === s, o = 301 === s || 302 === s;
                if (a || o) {
                    if (r.isRenderTargetTexture && !0 === r.needsPMREMUpdate) {
                        r.needsPMREMUpdate = !1;
                        let i = e.get(r);
                        return null === n && (n = new $fd4eb456bcbd06f8$var$wn(t1)), i = a ? n.fromEquirectangular(r, i) : n.fromCubemap(r, i), e.set(r, i), i.texture;
                    }
                    if (e.has(r)) return e.get(r).texture;
                    {
                        const s = r.image;
                        if (a && s && s.height > 0 || o && s && function(t1) {
                            let e = 0;
                            const n = 6;
                            for(let i = 0; i < n; i++)void 0 !== t1[i] && e++;
                            return e === n;
                        }(s)) {
                            null === n && (n = new $fd4eb456bcbd06f8$var$wn(t1));
                            const s = a ? n.fromEquirectangular(r) : n.fromCubemap(r);
                            return e.set(r, s), r.addEventListener("dispose", i), s.texture;
                        }
                        return null;
                    }
                }
            }
            return r;
        },
        dispose: function() {
            e = new WeakMap, null !== n && (n.dispose(), n = null);
        }
    };
}
function $fd4eb456bcbd06f8$var$Cn(t1) {
    const e = {};
    function n(n) {
        if (void 0 !== e[n]) return e[n];
        let i;
        switch(n){
            case "WEBGL_depth_texture":
                i = t1.getExtension("WEBGL_depth_texture") || t1.getExtension("MOZ_WEBGL_depth_texture") || t1.getExtension("WEBKIT_WEBGL_depth_texture");
                break;
            case "EXT_texture_filter_anisotropic":
                i = t1.getExtension("EXT_texture_filter_anisotropic") || t1.getExtension("MOZ_EXT_texture_filter_anisotropic") || t1.getExtension("WEBKIT_EXT_texture_filter_anisotropic");
                break;
            case "WEBGL_compressed_texture_s3tc":
                i = t1.getExtension("WEBGL_compressed_texture_s3tc") || t1.getExtension("MOZ_WEBGL_compressed_texture_s3tc") || t1.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc");
                break;
            case "WEBGL_compressed_texture_pvrtc":
                i = t1.getExtension("WEBGL_compressed_texture_pvrtc") || t1.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc");
                break;
            default:
                i = t1.getExtension(n);
        }
        return e[n] = i, i;
    }
    return {
        has: function(t1) {
            return null !== n(t1);
        },
        init: function(t1) {
            t1.isWebGL2 ? n("EXT_color_buffer_float") : (n("WEBGL_depth_texture"), n("OES_texture_float"), n("OES_texture_half_float"), n("OES_texture_half_float_linear"), n("OES_standard_derivatives"), n("OES_element_index_uint"), n("OES_vertex_array_object"), n("ANGLE_instanced_arrays")), n("OES_texture_float_linear"), n("EXT_color_buffer_half_float"), n("WEBGL_multisampled_render_to_texture");
        },
        get: function(t1) {
            const e = n(t1);
            return null === e && console.warn("THREE.WebGLRenderer: " + t1 + " extension not supported."), e;
        }
    };
}
function $fd4eb456bcbd06f8$var$Ln(t1, e, n, i) {
    const r = {}, s = new WeakMap;
    function a(t1) {
        const o = t1.target;
        null !== o.index && e.remove(o.index);
        for(const t1 in o.attributes)e.remove(o.attributes[t1]);
        o.removeEventListener("dispose", a), delete r[o.id];
        const l = s.get(o);
        l && (e.remove(l), s.delete(o)), i.releaseStatesOfGeometry(o), !0 === o.isInstancedBufferGeometry && delete o._maxInstanceCount, n.memory.geometries--;
    }
    function o(t1) {
        const n = [], i = t1.index, r = t1.attributes.position;
        let a = 0;
        if (null !== i) {
            const t1 = i.array;
            a = i.version;
            for(let e = 0, i = t1.length; e < i; e += 3){
                const i = t1[e + 0], r = t1[e + 1], s = t1[e + 2];
                n.push(i, r, r, s, s, i);
            }
        } else {
            const t1 = r.array;
            a = r.version;
            for(let e = 0, i = t1.length / 3 - 1; e < i; e += 3){
                const t1 = e + 0, i = e + 1, r = e + 2;
                n.push(t1, i, i, r, r, t1);
            }
        }
        const o = new ($fd4eb456bcbd06f8$var$y(n) ? $fd4eb456bcbd06f8$var$he : $fd4eb456bcbd06f8$var$le)(n, 1);
        o.version = a;
        const l = s.get(t1);
        l && e.remove(l), s.set(t1, o);
    }
    return {
        get: function(t1, e) {
            return !0 === r[e.id] || (e.addEventListener("dispose", a), r[e.id] = !0, n.memory.geometries++), e;
        },
        update: function(t1) {
            const n = t1.attributes;
            for(const t1 in n)e.update(n[t1], 34962);
            const i = t1.morphAttributes;
            for(const t1 in i){
                const n = i[t1];
                for(let t1 = 0, i = n.length; t1 < i; t1++)e.update(n[t1], 34962);
            }
        },
        getWireframeAttribute: function(t1) {
            const e = s.get(t1);
            if (e) {
                const n = t1.index;
                null !== n && e.version < n.version && o(t1);
            } else o(t1);
            return s.get(t1);
        }
    };
}
function $fd4eb456bcbd06f8$var$Pn(t1, e, n, i) {
    const r = i.isWebGL2;
    let s, a, o;
    this.setMode = function(t1) {
        s = t1;
    }, this.setIndex = function(t1) {
        a = t1.type, o = t1.bytesPerElement;
    }, this.render = function(e, i) {
        t1.drawElements(s, i, a, e * o), n.update(i, s, 1);
    }, this.renderInstances = function(i, l, h) {
        if (0 === h) return;
        let c, u;
        if (r) c = t1, u = "drawElementsInstanced";
        else if (c = e.get("ANGLE_instanced_arrays"), u = "drawElementsInstancedANGLE", null === c) return void console.error("THREE.WebGLIndexedBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
        c[u](s, l, a, i * o, h), n.update(l, s, h);
    };
}
function $fd4eb456bcbd06f8$var$Dn(t1) {
    const e = {
        frame: 0,
        calls: 0,
        triangles: 0,
        points: 0,
        lines: 0
    };
    return {
        memory: {
            geometries: 0,
            textures: 0
        },
        render: e,
        programs: null,
        autoReset: !0,
        reset: function() {
            e.frame++, e.calls = 0, e.triangles = 0, e.points = 0, e.lines = 0;
        },
        update: function(t1, n, i) {
            switch(e.calls++, n){
                case 4:
                    e.triangles += i * (t1 / 3);
                    break;
                case 1:
                    e.lines += i * (t1 / 2);
                    break;
                case 3:
                    e.lines += i * (t1 - 1);
                    break;
                case 2:
                    e.lines += i * t1;
                    break;
                case 0:
                    e.points += i * t1;
                    break;
                default:
                    console.error("THREE.WebGLInfo: Unknown draw mode:", n);
            }
        }
    };
}
function $fd4eb456bcbd06f8$var$In(t1, e) {
    return t1[0] - e[0];
}
function $fd4eb456bcbd06f8$var$On(t1, e) {
    return Math.abs(e[1]) - Math.abs(t1[1]);
}
function $fd4eb456bcbd06f8$var$Nn(t1, e) {
    let n = 1;
    const i = e.isInterleavedBufferAttribute ? e.data.array : e.array;
    i instanceof Int8Array ? n = 127 : i instanceof Int16Array ? n = 32767 : i instanceof Int32Array ? n = 2147483647 : console.error("THREE.WebGLMorphtargets: Unsupported morph attribute data type: ", i), t1.divideScalar(n);
}
function $fd4eb456bcbd06f8$var$Fn(t1, e, n) {
    const i = {}, r = new Float32Array(8), s = new WeakMap, a = new $fd4eb456bcbd06f8$var$U, o = [];
    for(let t1 = 0; t1 < 8; t1++)o[t1] = [
        t1,
        0
    ];
    return {
        update: function(l, h, c, u) {
            const d = l.morphTargetInfluences;
            if (!0 === e.isWebGL2) {
                const i = h.morphAttributes.position || h.morphAttributes.normal || h.morphAttributes.color, r = void 0 !== i ? i.length : 0;
                let o = s.get(h);
                if (void 0 === o || o.count !== r) {
                    void 0 !== o && o.texture.dispose();
                    const t1 = void 0 !== h.morphAttributes.position, n = void 0 !== h.morphAttributes.normal, i = void 0 !== h.morphAttributes.color, l = h.morphAttributes.position || [], c = h.morphAttributes.normal || [], u = h.morphAttributes.color || [];
                    let d = 0;
                    !0 === t1 && (d = 1), !0 === n && (d = 2), !0 === i && (d = 3);
                    let p = h.attributes.position.count * d, m = 1;
                    p > e.maxTextureSize && (m = Math.ceil(p / e.maxTextureSize), p = e.maxTextureSize);
                    const f = new Float32Array(p * m * 4 * r), v = new $fd4eb456bcbd06f8$var$B(f, p, m, r);
                    v.type = 1015, v.needsUpdate = !0;
                    const y = 4 * d;
                    for(let e = 0; e < r; e++){
                        const r = l[e], s = c[e], o = u[e], h = p * m * 4 * e;
                        for(let e = 0; e < r.count; e++){
                            const l = e * y;
                            !0 === t1 && (a.fromBufferAttribute(r, e), !0 === r.normalized && $fd4eb456bcbd06f8$var$Nn(a, r), f[h + l + 0] = a.x, f[h + l + 1] = a.y, f[h + l + 2] = a.z, f[h + l + 3] = 0), !0 === n && (a.fromBufferAttribute(s, e), !0 === s.normalized && $fd4eb456bcbd06f8$var$Nn(a, s), f[h + l + 4] = a.x, f[h + l + 5] = a.y, f[h + l + 6] = a.z, f[h + l + 7] = 0), !0 === i && (a.fromBufferAttribute(o, e), !0 === o.normalized && $fd4eb456bcbd06f8$var$Nn(a, o), f[h + l + 8] = a.x, f[h + l + 9] = a.y, f[h + l + 10] = a.z, f[h + l + 11] = 4 === o.itemSize ? a.w : 1);
                        }
                    }
                    o = {
                        count: r,
                        texture: v,
                        size: new $fd4eb456bcbd06f8$var$g(p, m)
                    }, s.set(h, o), h.addEventListener("dispose", function t1() {
                        v.dispose(), s.delete(h), h.removeEventListener("dispose", t1);
                    });
                }
                let l = 0;
                for(let t1 = 0; t1 < d.length; t1++)l += d[t1];
                const c = h.morphTargetsRelative ? 1 : 1 - l;
                u.getUniforms().setValue(t1, "morphTargetBaseInfluence", c), u.getUniforms().setValue(t1, "morphTargetInfluences", d), u.getUniforms().setValue(t1, "morphTargetsTexture", o.texture, n), u.getUniforms().setValue(t1, "morphTargetsTextureSize", o.size);
            } else {
                const e = void 0 === d ? 0 : d.length;
                let n = i[h.id];
                if (void 0 === n || n.length !== e) {
                    n = [];
                    for(let t1 = 0; t1 < e; t1++)n[t1] = [
                        t1,
                        0
                    ];
                    i[h.id] = n;
                }
                for(let t1 = 0; t1 < e; t1++){
                    const e = n[t1];
                    e[0] = t1, e[1] = d[t1];
                }
                n.sort($fd4eb456bcbd06f8$var$On);
                for(let t1 = 0; t1 < 8; t1++)t1 < e && n[t1][1] ? (o[t1][0] = n[t1][0], o[t1][1] = n[t1][1]) : (o[t1][0] = Number.MAX_SAFE_INTEGER, o[t1][1] = 0);
                o.sort($fd4eb456bcbd06f8$var$In);
                const s = h.morphAttributes.position, a = h.morphAttributes.normal;
                let l = 0;
                for(let t1 = 0; t1 < 8; t1++){
                    const e = o[t1], n = e[0], i = e[1];
                    n !== Number.MAX_SAFE_INTEGER && i ? (s && h.getAttribute("morphTarget" + t1) !== s[n] && h.setAttribute("morphTarget" + t1, s[n]), a && h.getAttribute("morphNormal" + t1) !== a[n] && h.setAttribute("morphNormal" + t1, a[n]), r[t1] = i, l += i) : (s && !0 === h.hasAttribute("morphTarget" + t1) && h.deleteAttribute("morphTarget" + t1), a && !0 === h.hasAttribute("morphNormal" + t1) && h.deleteAttribute("morphNormal" + t1), r[t1] = 0);
                }
                const c = h.morphTargetsRelative ? 1 : 1 - l;
                u.getUniforms().setValue(t1, "morphTargetBaseInfluence", c), u.getUniforms().setValue(t1, "morphTargetInfluences", r);
            }
        }
    };
}
function $fd4eb456bcbd06f8$var$Un(t1, e, n, i) {
    let r = new WeakMap;
    function s(t1) {
        const e = t1.target;
        e.removeEventListener("dispose", s), n.remove(e.instanceMatrix), null !== e.instanceColor && n.remove(e.instanceColor);
    }
    return {
        update: function(t1) {
            const a = i.render.frame, o = t1.geometry, l = e.get(t1, o);
            return r.get(l) !== a && (e.update(l), r.set(l, a)), t1.isInstancedMesh && (!1 === t1.hasEventListener("dispose", s) && t1.addEventListener("dispose", s), n.update(t1.instanceMatrix, 34962), null !== t1.instanceColor && n.update(t1.instanceColor, 34962)), l;
        },
        dispose: function() {
            r = new WeakMap;
        }
    };
}
const $fd4eb456bcbd06f8$var$kn = new $fd4eb456bcbd06f8$var$F, $fd4eb456bcbd06f8$var$Bn = new $fd4eb456bcbd06f8$var$B, $fd4eb456bcbd06f8$var$zn = new $fd4eb456bcbd06f8$var$z, $fd4eb456bcbd06f8$var$Hn = new $fd4eb456bcbd06f8$var$qe, $fd4eb456bcbd06f8$var$Vn = [], $fd4eb456bcbd06f8$var$Gn = [], $fd4eb456bcbd06f8$var$Wn = new Float32Array(16), $fd4eb456bcbd06f8$var$jn = new Float32Array(9), $fd4eb456bcbd06f8$var$qn = new Float32Array(4);
function $fd4eb456bcbd06f8$var$Xn(t1, e, n) {
    const i = t1[0];
    if (i <= 0 || i > 0) return t1;
    const r = e * n;
    let s = $fd4eb456bcbd06f8$var$Vn[r];
    if (void 0 === s && (s = new Float32Array(r), $fd4eb456bcbd06f8$var$Vn[r] = s), 0 !== e) {
        i.toArray(s, 0);
        for(let i = 1, r = 0; i !== e; ++i)r += n, t1[i].toArray(s, r);
    }
    return s;
}
function $fd4eb456bcbd06f8$var$$n(t1, e) {
    if (t1.length !== e.length) return !1;
    for(let n = 0, i = t1.length; n < i; n++)if (t1[n] !== e[n]) return !1;
    return !0;
}
function $fd4eb456bcbd06f8$var$Yn(t1, e) {
    for(let n = 0, i = e.length; n < i; n++)t1[n] = e[n];
}
function $fd4eb456bcbd06f8$var$Jn(t1, e) {
    let n = $fd4eb456bcbd06f8$var$Gn[e];
    void 0 === n && (n = new Int32Array(e), $fd4eb456bcbd06f8$var$Gn[e] = n);
    for(let i = 0; i !== e; ++i)n[i] = t1.allocateTextureUnit();
    return n;
}
function $fd4eb456bcbd06f8$var$Kn(t1, e) {
    const n = this.cache;
    n[0] !== e && (t1.uniform1f(this.addr, e), n[0] = e);
}
function $fd4eb456bcbd06f8$var$Zn(t1, e) {
    const n = this.cache;
    if (void 0 !== e.x) n[0] === e.x && n[1] === e.y || (t1.uniform2f(this.addr, e.x, e.y), n[0] = e.x, n[1] = e.y);
    else {
        if ($fd4eb456bcbd06f8$var$$n(n, e)) return;
        t1.uniform2fv(this.addr, e), $fd4eb456bcbd06f8$var$Yn(n, e);
    }
}
function $fd4eb456bcbd06f8$var$Qn(t1, e) {
    const n = this.cache;
    if (void 0 !== e.x) n[0] === e.x && n[1] === e.y && n[2] === e.z || (t1.uniform3f(this.addr, e.x, e.y, e.z), n[0] = e.x, n[1] = e.y, n[2] = e.z);
    else if (void 0 !== e.r) n[0] === e.r && n[1] === e.g && n[2] === e.b || (t1.uniform3f(this.addr, e.r, e.g, e.b), n[0] = e.r, n[1] = e.g, n[2] = e.b);
    else {
        if ($fd4eb456bcbd06f8$var$$n(n, e)) return;
        t1.uniform3fv(this.addr, e), $fd4eb456bcbd06f8$var$Yn(n, e);
    }
}
function $fd4eb456bcbd06f8$var$ti(t1, e) {
    const n = this.cache;
    if (void 0 !== e.x) n[0] === e.x && n[1] === e.y && n[2] === e.z && n[3] === e.w || (t1.uniform4f(this.addr, e.x, e.y, e.z, e.w), n[0] = e.x, n[1] = e.y, n[2] = e.z, n[3] = e.w);
    else {
        if ($fd4eb456bcbd06f8$var$$n(n, e)) return;
        t1.uniform4fv(this.addr, e), $fd4eb456bcbd06f8$var$Yn(n, e);
    }
}
function $fd4eb456bcbd06f8$var$ei(t1, e) {
    const n = this.cache, i = e.elements;
    if (void 0 === i) {
        if ($fd4eb456bcbd06f8$var$$n(n, e)) return;
        t1.uniformMatrix2fv(this.addr, !1, e), $fd4eb456bcbd06f8$var$Yn(n, e);
    } else {
        if ($fd4eb456bcbd06f8$var$$n(n, i)) return;
        $fd4eb456bcbd06f8$var$qn.set(i), t1.uniformMatrix2fv(this.addr, !1, $fd4eb456bcbd06f8$var$qn), $fd4eb456bcbd06f8$var$Yn(n, i);
    }
}
function $fd4eb456bcbd06f8$var$ni(t1, e) {
    const n = this.cache, i = e.elements;
    if (void 0 === i) {
        if ($fd4eb456bcbd06f8$var$$n(n, e)) return;
        t1.uniformMatrix3fv(this.addr, !1, e), $fd4eb456bcbd06f8$var$Yn(n, e);
    } else {
        if ($fd4eb456bcbd06f8$var$$n(n, i)) return;
        $fd4eb456bcbd06f8$var$jn.set(i), t1.uniformMatrix3fv(this.addr, !1, $fd4eb456bcbd06f8$var$jn), $fd4eb456bcbd06f8$var$Yn(n, i);
    }
}
function $fd4eb456bcbd06f8$var$ii(t1, e) {
    const n = this.cache, i = e.elements;
    if (void 0 === i) {
        if ($fd4eb456bcbd06f8$var$$n(n, e)) return;
        t1.uniformMatrix4fv(this.addr, !1, e), $fd4eb456bcbd06f8$var$Yn(n, e);
    } else {
        if ($fd4eb456bcbd06f8$var$$n(n, i)) return;
        $fd4eb456bcbd06f8$var$Wn.set(i), t1.uniformMatrix4fv(this.addr, !1, $fd4eb456bcbd06f8$var$Wn), $fd4eb456bcbd06f8$var$Yn(n, i);
    }
}
function $fd4eb456bcbd06f8$var$ri(t1, e) {
    const n = this.cache;
    n[0] !== e && (t1.uniform1i(this.addr, e), n[0] = e);
}
function $fd4eb456bcbd06f8$var$si(t1, e) {
    const n = this.cache;
    $fd4eb456bcbd06f8$var$$n(n, e) || (t1.uniform2iv(this.addr, e), $fd4eb456bcbd06f8$var$Yn(n, e));
}
function $fd4eb456bcbd06f8$var$ai(t1, e) {
    const n = this.cache;
    $fd4eb456bcbd06f8$var$$n(n, e) || (t1.uniform3iv(this.addr, e), $fd4eb456bcbd06f8$var$Yn(n, e));
}
function $fd4eb456bcbd06f8$var$oi(t1, e) {
    const n = this.cache;
    $fd4eb456bcbd06f8$var$$n(n, e) || (t1.uniform4iv(this.addr, e), $fd4eb456bcbd06f8$var$Yn(n, e));
}
function $fd4eb456bcbd06f8$var$li(t1, e) {
    const n = this.cache;
    n[0] !== e && (t1.uniform1ui(this.addr, e), n[0] = e);
}
function $fd4eb456bcbd06f8$var$hi(t1, e) {
    const n = this.cache;
    $fd4eb456bcbd06f8$var$$n(n, e) || (t1.uniform2uiv(this.addr, e), $fd4eb456bcbd06f8$var$Yn(n, e));
}
function $fd4eb456bcbd06f8$var$ci(t1, e) {
    const n = this.cache;
    $fd4eb456bcbd06f8$var$$n(n, e) || (t1.uniform3uiv(this.addr, e), $fd4eb456bcbd06f8$var$Yn(n, e));
}
function $fd4eb456bcbd06f8$var$ui(t1, e) {
    const n = this.cache;
    $fd4eb456bcbd06f8$var$$n(n, e) || (t1.uniform4uiv(this.addr, e), $fd4eb456bcbd06f8$var$Yn(n, e));
}
function $fd4eb456bcbd06f8$var$di(t1, e, n) {
    const i = this.cache, r = n.allocateTextureUnit();
    i[0] !== r && (t1.uniform1i(this.addr, r), i[0] = r), n.setTexture2D(e || $fd4eb456bcbd06f8$var$kn, r);
}
function $fd4eb456bcbd06f8$var$pi(t1, e, n) {
    const i = this.cache, r = n.allocateTextureUnit();
    i[0] !== r && (t1.uniform1i(this.addr, r), i[0] = r), n.setTexture3D(e || $fd4eb456bcbd06f8$var$zn, r);
}
function $fd4eb456bcbd06f8$var$mi(t1, e, n) {
    const i = this.cache, r = n.allocateTextureUnit();
    i[0] !== r && (t1.uniform1i(this.addr, r), i[0] = r), n.setTextureCube(e || $fd4eb456bcbd06f8$var$Hn, r);
}
function $fd4eb456bcbd06f8$var$fi(t1, e, n) {
    const i = this.cache, r = n.allocateTextureUnit();
    i[0] !== r && (t1.uniform1i(this.addr, r), i[0] = r), n.setTexture2DArray(e || $fd4eb456bcbd06f8$var$Bn, r);
}
function $fd4eb456bcbd06f8$var$gi(t1, e) {
    t1.uniform1fv(this.addr, e);
}
function $fd4eb456bcbd06f8$var$vi(t1, e) {
    const n = $fd4eb456bcbd06f8$var$Xn(e, this.size, 2);
    t1.uniform2fv(this.addr, n);
}
function $fd4eb456bcbd06f8$var$yi(t1, e) {
    const n = $fd4eb456bcbd06f8$var$Xn(e, this.size, 3);
    t1.uniform3fv(this.addr, n);
}
function $fd4eb456bcbd06f8$var$xi(t1, e) {
    const n = $fd4eb456bcbd06f8$var$Xn(e, this.size, 4);
    t1.uniform4fv(this.addr, n);
}
function $fd4eb456bcbd06f8$var$bi(t1, e) {
    const n = $fd4eb456bcbd06f8$var$Xn(e, this.size, 4);
    t1.uniformMatrix2fv(this.addr, !1, n);
}
function $fd4eb456bcbd06f8$var$_i(t1, e) {
    const n = $fd4eb456bcbd06f8$var$Xn(e, this.size, 9);
    t1.uniformMatrix3fv(this.addr, !1, n);
}
function $fd4eb456bcbd06f8$var$wi(t1, e) {
    const n = $fd4eb456bcbd06f8$var$Xn(e, this.size, 16);
    t1.uniformMatrix4fv(this.addr, !1, n);
}
function $fd4eb456bcbd06f8$var$Mi(t1, e) {
    t1.uniform1iv(this.addr, e);
}
function $fd4eb456bcbd06f8$var$Si(t1, e) {
    t1.uniform2iv(this.addr, e);
}
function $fd4eb456bcbd06f8$var$Ti(t1, e) {
    t1.uniform3iv(this.addr, e);
}
function $fd4eb456bcbd06f8$var$Ei(t1, e) {
    t1.uniform4iv(this.addr, e);
}
function $fd4eb456bcbd06f8$var$Ai(t1, e) {
    t1.uniform1uiv(this.addr, e);
}
function $fd4eb456bcbd06f8$var$Ri(t1, e) {
    t1.uniform2uiv(this.addr, e);
}
function $fd4eb456bcbd06f8$var$Ci(t1, e) {
    t1.uniform3uiv(this.addr, e);
}
function $fd4eb456bcbd06f8$var$Li(t1, e) {
    t1.uniform4uiv(this.addr, e);
}
function $fd4eb456bcbd06f8$var$Pi(t1, e, n) {
    const i = e.length, r = $fd4eb456bcbd06f8$var$Jn(n, i);
    t1.uniform1iv(this.addr, r);
    for(let t1 = 0; t1 !== i; ++t1)n.setTexture2D(e[t1] || $fd4eb456bcbd06f8$var$kn, r[t1]);
}
function $fd4eb456bcbd06f8$var$Di(t1, e, n) {
    const i = e.length, r = $fd4eb456bcbd06f8$var$Jn(n, i);
    t1.uniform1iv(this.addr, r);
    for(let t1 = 0; t1 !== i; ++t1)n.setTexture3D(e[t1] || $fd4eb456bcbd06f8$var$zn, r[t1]);
}
function $fd4eb456bcbd06f8$var$Ii(t1, e, n) {
    const i = e.length, r = $fd4eb456bcbd06f8$var$Jn(n, i);
    t1.uniform1iv(this.addr, r);
    for(let t1 = 0; t1 !== i; ++t1)n.setTextureCube(e[t1] || $fd4eb456bcbd06f8$var$Hn, r[t1]);
}
function $fd4eb456bcbd06f8$var$Oi(t1, e, n) {
    const i = e.length, r = $fd4eb456bcbd06f8$var$Jn(n, i);
    t1.uniform1iv(this.addr, r);
    for(let t1 = 0; t1 !== i; ++t1)n.setTexture2DArray(e[t1] || $fd4eb456bcbd06f8$var$Bn, r[t1]);
}
function $fd4eb456bcbd06f8$var$Ni(t1, e, n) {
    this.id = t1, this.addr = n, this.cache = [], this.setValue = function(t1) {
        switch(t1){
            case 5126:
                return $fd4eb456bcbd06f8$var$Kn;
            case 35664:
                return $fd4eb456bcbd06f8$var$Zn;
            case 35665:
                return $fd4eb456bcbd06f8$var$Qn;
            case 35666:
                return $fd4eb456bcbd06f8$var$ti;
            case 35674:
                return $fd4eb456bcbd06f8$var$ei;
            case 35675:
                return $fd4eb456bcbd06f8$var$ni;
            case 35676:
                return $fd4eb456bcbd06f8$var$ii;
            case 5124:
            case 35670:
                return $fd4eb456bcbd06f8$var$ri;
            case 35667:
            case 35671:
                return $fd4eb456bcbd06f8$var$si;
            case 35668:
            case 35672:
                return $fd4eb456bcbd06f8$var$ai;
            case 35669:
            case 35673:
                return $fd4eb456bcbd06f8$var$oi;
            case 5125:
                return $fd4eb456bcbd06f8$var$li;
            case 36294:
                return $fd4eb456bcbd06f8$var$hi;
            case 36295:
                return $fd4eb456bcbd06f8$var$ci;
            case 36296:
                return $fd4eb456bcbd06f8$var$ui;
            case 35678:
            case 36198:
            case 36298:
            case 36306:
            case 35682:
                return $fd4eb456bcbd06f8$var$di;
            case 35679:
            case 36299:
            case 36307:
                return $fd4eb456bcbd06f8$var$pi;
            case 35680:
            case 36300:
            case 36308:
            case 36293:
                return $fd4eb456bcbd06f8$var$mi;
            case 36289:
            case 36303:
            case 36311:
            case 36292:
                return $fd4eb456bcbd06f8$var$fi;
        }
    }(e.type);
}
function $fd4eb456bcbd06f8$var$Fi(t1, e, n) {
    this.id = t1, this.addr = n, this.cache = [], this.size = e.size, this.setValue = function(t1) {
        switch(t1){
            case 5126:
                return $fd4eb456bcbd06f8$var$gi;
            case 35664:
                return $fd4eb456bcbd06f8$var$vi;
            case 35665:
                return $fd4eb456bcbd06f8$var$yi;
            case 35666:
                return $fd4eb456bcbd06f8$var$xi;
            case 35674:
                return $fd4eb456bcbd06f8$var$bi;
            case 35675:
                return $fd4eb456bcbd06f8$var$_i;
            case 35676:
                return $fd4eb456bcbd06f8$var$wi;
            case 5124:
            case 35670:
                return $fd4eb456bcbd06f8$var$Mi;
            case 35667:
            case 35671:
                return $fd4eb456bcbd06f8$var$Si;
            case 35668:
            case 35672:
                return $fd4eb456bcbd06f8$var$Ti;
            case 35669:
            case 35673:
                return $fd4eb456bcbd06f8$var$Ei;
            case 5125:
                return $fd4eb456bcbd06f8$var$Ai;
            case 36294:
                return $fd4eb456bcbd06f8$var$Ri;
            case 36295:
                return $fd4eb456bcbd06f8$var$Ci;
            case 36296:
                return $fd4eb456bcbd06f8$var$Li;
            case 35678:
            case 36198:
            case 36298:
            case 36306:
            case 35682:
                return $fd4eb456bcbd06f8$var$Pi;
            case 35679:
            case 36299:
            case 36307:
                return $fd4eb456bcbd06f8$var$Di;
            case 35680:
            case 36300:
            case 36308:
            case 36293:
                return $fd4eb456bcbd06f8$var$Ii;
            case 36289:
            case 36303:
            case 36311:
            case 36292:
                return $fd4eb456bcbd06f8$var$Oi;
        }
    }(e.type);
}
function $fd4eb456bcbd06f8$var$Ui(t1) {
    this.id = t1, this.seq = [], this.map = {};
}
$fd4eb456bcbd06f8$var$Fi.prototype.updateCache = function(t1) {
    const e = this.cache;
    t1 instanceof Float32Array && e.length !== t1.length && (this.cache = new Float32Array(t1.length)), $fd4eb456bcbd06f8$var$Yn(e, t1);
}, $fd4eb456bcbd06f8$var$Ui.prototype.setValue = function(t1, e, n) {
    const i = this.seq;
    for(let r = 0, s = i.length; r !== s; ++r){
        const s = i[r];
        s.setValue(t1, e[s.id], n);
    }
};
const $fd4eb456bcbd06f8$var$ki = /(\w+)(\])?(\[|\.)?/g;
function $fd4eb456bcbd06f8$var$Bi(t1, e) {
    t1.seq.push(e), t1.map[e.id] = e;
}
function $fd4eb456bcbd06f8$var$zi(t1, e, n) {
    const i = t1.name, r = i.length;
    for($fd4eb456bcbd06f8$var$ki.lastIndex = 0;;){
        const s = $fd4eb456bcbd06f8$var$ki.exec(i), a = $fd4eb456bcbd06f8$var$ki.lastIndex;
        let o = s[1];
        const l = "]" === s[2], h = s[3];
        if (l && (o |= 0), void 0 === h || "[" === h && a + 2 === r) {
            $fd4eb456bcbd06f8$var$Bi(n, void 0 === h ? new $fd4eb456bcbd06f8$var$Ni(o, t1, e) : new $fd4eb456bcbd06f8$var$Fi(o, t1, e));
            break;
        }
        {
            let t1 = n.map[o];
            void 0 === t1 && (t1 = new $fd4eb456bcbd06f8$var$Ui(o), $fd4eb456bcbd06f8$var$Bi(n, t1)), n = t1;
        }
    }
}
function $fd4eb456bcbd06f8$var$Hi(t1, e) {
    this.seq = [], this.map = {};
    const n = t1.getProgramParameter(e, 35718);
    for(let i = 0; i < n; ++i){
        const n = t1.getActiveUniform(e, i);
        $fd4eb456bcbd06f8$var$zi(n, t1.getUniformLocation(e, n.name), this);
    }
}
function $fd4eb456bcbd06f8$var$Vi(t1, e, n) {
    const i = t1.createShader(e);
    return t1.shaderSource(i, n), t1.compileShader(i), i;
}
$fd4eb456bcbd06f8$var$Hi.prototype.setValue = function(t1, e, n, i) {
    const r = this.map[e];
    void 0 !== r && r.setValue(t1, n, i);
}, $fd4eb456bcbd06f8$var$Hi.prototype.setOptional = function(t1, e, n) {
    const i = e[n];
    void 0 !== i && this.setValue(t1, n, i);
}, $fd4eb456bcbd06f8$var$Hi.upload = function(t1, e, n, i) {
    for(let r = 0, s = e.length; r !== s; ++r){
        const s = e[r], a = n[s.id];
        !1 !== a.needsUpdate && s.setValue(t1, a.value, i);
    }
}, $fd4eb456bcbd06f8$var$Hi.seqWithValue = function(t1, e) {
    const n = [];
    for(let i = 0, r = t1.length; i !== r; ++i){
        const r = t1[i];
        r.id in e && n.push(r);
    }
    return n;
};
let $fd4eb456bcbd06f8$var$Gi = 0;
function $fd4eb456bcbd06f8$var$Wi(t1, e, n) {
    const i = t1.getShaderParameter(e, 35713), r = t1.getShaderInfoLog(e).trim();
    if (i && "" === r) return "";
    const s = parseInt(/ERROR: 0:(\d+)/.exec(r)[1]);
    return n.toUpperCase() + "\n\n" + r + "\n\n" + function(t1, e) {
        const n = t1.split("\n"), i = [], r = Math.max(e - 6, 0), s = Math.min(e + 6, n.length);
        for(let t1 = r; t1 < s; t1++)i.push(t1 + 1 + ": " + n[t1]);
        return i.join("\n");
    }(t1.getShaderSource(e), s);
}
function $fd4eb456bcbd06f8$var$ji(t1, e) {
    const n = function(t1) {
        switch(t1){
            case 3e3:
                return [
                    "Linear",
                    "( value )"
                ];
            case 3001:
                return [
                    "sRGB",
                    "( value )"
                ];
            default:
                return console.warn("THREE.WebGLProgram: Unsupported encoding:", t1), [
                    "Linear",
                    "( value )"
                ];
        }
    }(e);
    return "vec4 " + t1 + "( vec4 value ) { return LinearTo" + n[0] + n[1] + "; }";
}
function $fd4eb456bcbd06f8$var$qi(t1, e) {
    let n;
    switch(e){
        case 1:
            n = "Linear";
            break;
        case 2:
            n = "Reinhard";
            break;
        case 3:
            n = "OptimizedCineon";
            break;
        case 4:
            n = "ACESFilmic";
            break;
        case 5:
            n = "Custom";
            break;
        default:
            console.warn("THREE.WebGLProgram: Unsupported toneMapping:", e), n = "Linear";
    }
    return "vec3 " + t1 + "( vec3 color ) { return " + n + "ToneMapping( color ); }";
}
function $fd4eb456bcbd06f8$var$Xi(t1) {
    return "" !== t1;
}
function $fd4eb456bcbd06f8$var$$i(t1, e) {
    return t1.replace(/NUM_DIR_LIGHTS/g, e.numDirLights).replace(/NUM_SPOT_LIGHTS/g, e.numSpotLights).replace(/NUM_RECT_AREA_LIGHTS/g, e.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, e.numPointLights).replace(/NUM_HEMI_LIGHTS/g, e.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, e.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS/g, e.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, e.numPointLightShadows);
}
function $fd4eb456bcbd06f8$var$Yi(t1, e) {
    return t1.replace(/NUM_CLIPPING_PLANES/g, e.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, e.numClippingPlanes - e.numClipIntersection);
}
const $fd4eb456bcbd06f8$var$Ji = /^[ \t]*#include +<([\w\d./]+)>/gm;
function $fd4eb456bcbd06f8$var$Ki(t1) {
    return t1.replace($fd4eb456bcbd06f8$var$Ji, $fd4eb456bcbd06f8$var$Zi);
}
function $fd4eb456bcbd06f8$var$Zi(t1, e) {
    const n = $fd4eb456bcbd06f8$var$sn[e];
    if (void 0 === n) throw new Error("Can not resolve #include <" + e + ">");
    return $fd4eb456bcbd06f8$var$Ki(n);
}
const $fd4eb456bcbd06f8$var$Qi = /#pragma unroll_loop[\s]+?for \( int i \= (\d+)\; i < (\d+)\; i \+\+ \) \{([\s\S]+?)(?=\})\}/g, $fd4eb456bcbd06f8$var$tr = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function $fd4eb456bcbd06f8$var$er(t1) {
    return t1.replace($fd4eb456bcbd06f8$var$tr, $fd4eb456bcbd06f8$var$ir).replace($fd4eb456bcbd06f8$var$Qi, $fd4eb456bcbd06f8$var$nr);
}
function $fd4eb456bcbd06f8$var$nr(t1, e, n, i) {
    return console.warn("WebGLProgram: #pragma unroll_loop shader syntax is deprecated. Please use #pragma unroll_loop_start syntax instead."), $fd4eb456bcbd06f8$var$ir(t1, e, n, i);
}
function $fd4eb456bcbd06f8$var$ir(t1, e, n, i) {
    let r = "";
    for(let t1 = parseInt(e); t1 < parseInt(n); t1++)r += i.replace(/\[\s*i\s*\]/g, "[ " + t1 + " ]").replace(/UNROLLED_LOOP_INDEX/g, t1);
    return r;
}
function $fd4eb456bcbd06f8$var$rr(t1) {
    let e = "precision " + t1.precision + " float;\nprecision " + t1.precision + " int;";
    return "highp" === t1.precision ? e += "\n#define HIGH_PRECISION" : "mediump" === t1.precision ? e += "\n#define MEDIUM_PRECISION" : "lowp" === t1.precision && (e += "\n#define LOW_PRECISION"), e;
}
function $fd4eb456bcbd06f8$var$sr(t1, e, n, i) {
    const r = t1.getContext(), s = n.defines;
    let a = n.vertexShader, o = n.fragmentShader;
    const l = function(t1) {
        let e = "SHADOWMAP_TYPE_BASIC";
        return 1 === t1.shadowMapType ? e = "SHADOWMAP_TYPE_PCF" : 2 === t1.shadowMapType ? e = "SHADOWMAP_TYPE_PCF_SOFT" : 3 === t1.shadowMapType && (e = "SHADOWMAP_TYPE_VSM"), e;
    }(n), h = function(t1) {
        let e = "ENVMAP_TYPE_CUBE";
        if (t1.envMap) switch(t1.envMapMode){
            case 301:
            case 302:
                e = "ENVMAP_TYPE_CUBE";
                break;
            case 306:
                e = "ENVMAP_TYPE_CUBE_UV";
        }
        return e;
    }(n), c = function(t1) {
        let e = "ENVMAP_MODE_REFLECTION";
        t1.envMap && 302 === t1.envMapMode && (e = "ENVMAP_MODE_REFRACTION");
        return e;
    }(n), u = function(t1) {
        let e = "ENVMAP_BLENDING_NONE";
        if (t1.envMap) switch(t1.combine){
            case 0:
                e = "ENVMAP_BLENDING_MULTIPLY";
                break;
            case 1:
                e = "ENVMAP_BLENDING_MIX";
                break;
            case 2:
                e = "ENVMAP_BLENDING_ADD";
        }
        return e;
    }(n), d = function(t1) {
        const e = t1.envMapCubeUVHeight;
        if (null === e) return null;
        const n = Math.log2(e / 32 + 1) + 3, i = 1 / e;
        return {
            texelWidth: 1 / (3 * Math.max(Math.pow(2, n), 112)),
            texelHeight: i,
            maxMip: n
        };
    }(n), p = n.isWebGL2 ? "" : function(t1) {
        return [
            t1.extensionDerivatives || t1.envMapCubeUVHeight || t1.bumpMap || t1.tangentSpaceNormalMap || t1.clearcoatNormalMap || t1.flatShading || "physical" === t1.shaderID ? "#extension GL_OES_standard_derivatives : enable" : "",
            (t1.extensionFragDepth || t1.logarithmicDepthBuffer) && t1.rendererExtensionFragDepth ? "#extension GL_EXT_frag_depth : enable" : "",
            t1.extensionDrawBuffers && t1.rendererExtensionDrawBuffers ? "#extension GL_EXT_draw_buffers : require" : "",
            (t1.extensionShaderTextureLOD || t1.envMap || t1.transmission) && t1.rendererExtensionShaderTextureLod ? "#extension GL_EXT_shader_texture_lod : enable" : ""
        ].filter($fd4eb456bcbd06f8$var$Xi).join("\n");
    }(n), m = function(t1) {
        const e = [];
        for(const n in t1){
            const i = t1[n];
            !1 !== i && e.push("#define " + n + " " + i);
        }
        return e.join("\n");
    }(s), f = r.createProgram();
    let g, v, y = n.glslVersion ? "#version " + n.glslVersion + "\n" : "";
    n.isRawShaderMaterial ? (g = [
        m
    ].filter($fd4eb456bcbd06f8$var$Xi).join("\n"), g.length > 0 && (g += "\n"), v = [
        p,
        m
    ].filter($fd4eb456bcbd06f8$var$Xi).join("\n"), v.length > 0 && (v += "\n")) : (g = [
        $fd4eb456bcbd06f8$var$rr(n),
        "#define SHADER_NAME " + n.shaderName,
        m,
        n.instancing ? "#define USE_INSTANCING" : "",
        n.instancingColor ? "#define USE_INSTANCING_COLOR" : "",
        n.supportsVertexTextures ? "#define VERTEX_TEXTURES" : "",
        "#define MAX_BONES " + n.maxBones,
        n.useFog && n.fog ? "#define USE_FOG" : "",
        n.useFog && n.fogExp2 ? "#define FOG_EXP2" : "",
        n.map ? "#define USE_MAP" : "",
        n.envMap ? "#define USE_ENVMAP" : "",
        n.envMap ? "#define " + c : "",
        n.lightMap ? "#define USE_LIGHTMAP" : "",
        n.aoMap ? "#define USE_AOMAP" : "",
        n.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
        n.bumpMap ? "#define USE_BUMPMAP" : "",
        n.normalMap ? "#define USE_NORMALMAP" : "",
        n.normalMap && n.objectSpaceNormalMap ? "#define OBJECTSPACE_NORMALMAP" : "",
        n.normalMap && n.tangentSpaceNormalMap ? "#define TANGENTSPACE_NORMALMAP" : "",
        n.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
        n.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
        n.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
        n.displacementMap && n.supportsVertexTextures ? "#define USE_DISPLACEMENTMAP" : "",
        n.specularMap ? "#define USE_SPECULARMAP" : "",
        n.specularIntensityMap ? "#define USE_SPECULARINTENSITYMAP" : "",
        n.specularColorMap ? "#define USE_SPECULARCOLORMAP" : "",
        n.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
        n.metalnessMap ? "#define USE_METALNESSMAP" : "",
        n.alphaMap ? "#define USE_ALPHAMAP" : "",
        n.transmission ? "#define USE_TRANSMISSION" : "",
        n.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
        n.thicknessMap ? "#define USE_THICKNESSMAP" : "",
        n.sheenColorMap ? "#define USE_SHEENCOLORMAP" : "",
        n.sheenRoughnessMap ? "#define USE_SHEENROUGHNESSMAP" : "",
        n.vertexTangents ? "#define USE_TANGENT" : "",
        n.vertexColors ? "#define USE_COLOR" : "",
        n.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
        n.vertexUvs ? "#define USE_UV" : "",
        n.uvsVertexOnly ? "#define UVS_VERTEX_ONLY" : "",
        n.flatShading ? "#define FLAT_SHADED" : "",
        n.skinning ? "#define USE_SKINNING" : "",
        n.useVertexTexture ? "#define BONE_TEXTURE" : "",
        n.morphTargets ? "#define USE_MORPHTARGETS" : "",
        n.morphNormals && !1 === n.flatShading ? "#define USE_MORPHNORMALS" : "",
        n.morphColors && n.isWebGL2 ? "#define USE_MORPHCOLORS" : "",
        n.morphTargetsCount > 0 && n.isWebGL2 ? "#define MORPHTARGETS_TEXTURE" : "",
        n.morphTargetsCount > 0 && n.isWebGL2 ? "#define MORPHTARGETS_TEXTURE_STRIDE " + n.morphTextureStride : "",
        n.morphTargetsCount > 0 && n.isWebGL2 ? "#define MORPHTARGETS_COUNT " + n.morphTargetsCount : "",
        n.doubleSided ? "#define DOUBLE_SIDED" : "",
        n.flipSided ? "#define FLIP_SIDED" : "",
        n.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
        n.shadowMapEnabled ? "#define " + l : "",
        n.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "",
        n.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
        n.logarithmicDepthBuffer && n.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "",
        "uniform mat4 modelMatrix;",
        "uniform mat4 modelViewMatrix;",
        "uniform mat4 projectionMatrix;",
        "uniform mat4 viewMatrix;",
        "uniform mat3 normalMatrix;",
        "uniform vec3 cameraPosition;",
        "uniform bool isOrthographic;",
        "#ifdef USE_INSTANCING",
        "\tattribute mat4 instanceMatrix;",
        "#endif",
        "#ifdef USE_INSTANCING_COLOR",
        "\tattribute vec3 instanceColor;",
        "#endif",
        "attribute vec3 position;",
        "attribute vec3 normal;",
        "attribute vec2 uv;",
        "#ifdef USE_TANGENT",
        "\tattribute vec4 tangent;",
        "#endif",
        "#if defined( USE_COLOR_ALPHA )",
        "\tattribute vec4 color;",
        "#elif defined( USE_COLOR )",
        "\tattribute vec3 color;",
        "#endif",
        "#if ( defined( USE_MORPHTARGETS ) && ! defined( MORPHTARGETS_TEXTURE ) )",
        "\tattribute vec3 morphTarget0;",
        "\tattribute vec3 morphTarget1;",
        "\tattribute vec3 morphTarget2;",
        "\tattribute vec3 morphTarget3;",
        "\t#ifdef USE_MORPHNORMALS",
        "\t\tattribute vec3 morphNormal0;",
        "\t\tattribute vec3 morphNormal1;",
        "\t\tattribute vec3 morphNormal2;",
        "\t\tattribute vec3 morphNormal3;",
        "\t#else",
        "\t\tattribute vec3 morphTarget4;",
        "\t\tattribute vec3 morphTarget5;",
        "\t\tattribute vec3 morphTarget6;",
        "\t\tattribute vec3 morphTarget7;",
        "\t#endif",
        "#endif",
        "#ifdef USE_SKINNING",
        "\tattribute vec4 skinIndex;",
        "\tattribute vec4 skinWeight;",
        "#endif",
        "\n"
    ].filter($fd4eb456bcbd06f8$var$Xi).join("\n"), v = [
        p,
        $fd4eb456bcbd06f8$var$rr(n),
        "#define SHADER_NAME " + n.shaderName,
        m,
        n.useFog && n.fog ? "#define USE_FOG" : "",
        n.useFog && n.fogExp2 ? "#define FOG_EXP2" : "",
        n.map ? "#define USE_MAP" : "",
        n.matcap ? "#define USE_MATCAP" : "",
        n.envMap ? "#define USE_ENVMAP" : "",
        n.envMap ? "#define " + h : "",
        n.envMap ? "#define " + c : "",
        n.envMap ? "#define " + u : "",
        d ? "#define CUBEUV_TEXEL_WIDTH " + d.texelWidth : "",
        d ? "#define CUBEUV_TEXEL_HEIGHT " + d.texelHeight : "",
        d ? "#define CUBEUV_MAX_MIP " + d.maxMip + ".0" : "",
        n.lightMap ? "#define USE_LIGHTMAP" : "",
        n.aoMap ? "#define USE_AOMAP" : "",
        n.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
        n.bumpMap ? "#define USE_BUMPMAP" : "",
        n.normalMap ? "#define USE_NORMALMAP" : "",
        n.normalMap && n.objectSpaceNormalMap ? "#define OBJECTSPACE_NORMALMAP" : "",
        n.normalMap && n.tangentSpaceNormalMap ? "#define TANGENTSPACE_NORMALMAP" : "",
        n.clearcoat ? "#define USE_CLEARCOAT" : "",
        n.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
        n.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
        n.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
        n.specularMap ? "#define USE_SPECULARMAP" : "",
        n.specularIntensityMap ? "#define USE_SPECULARINTENSITYMAP" : "",
        n.specularColorMap ? "#define USE_SPECULARCOLORMAP" : "",
        n.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
        n.metalnessMap ? "#define USE_METALNESSMAP" : "",
        n.alphaMap ? "#define USE_ALPHAMAP" : "",
        n.alphaTest ? "#define USE_ALPHATEST" : "",
        n.sheen ? "#define USE_SHEEN" : "",
        n.sheenColorMap ? "#define USE_SHEENCOLORMAP" : "",
        n.sheenRoughnessMap ? "#define USE_SHEENROUGHNESSMAP" : "",
        n.transmission ? "#define USE_TRANSMISSION" : "",
        n.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
        n.thicknessMap ? "#define USE_THICKNESSMAP" : "",
        n.decodeVideoTexture ? "#define DECODE_VIDEO_TEXTURE" : "",
        n.vertexTangents ? "#define USE_TANGENT" : "",
        n.vertexColors || n.instancingColor ? "#define USE_COLOR" : "",
        n.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
        n.vertexUvs ? "#define USE_UV" : "",
        n.uvsVertexOnly ? "#define UVS_VERTEX_ONLY" : "",
        n.gradientMap ? "#define USE_GRADIENTMAP" : "",
        n.flatShading ? "#define FLAT_SHADED" : "",
        n.doubleSided ? "#define DOUBLE_SIDED" : "",
        n.flipSided ? "#define FLIP_SIDED" : "",
        n.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
        n.shadowMapEnabled ? "#define " + l : "",
        n.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "",
        n.physicallyCorrectLights ? "#define PHYSICALLY_CORRECT_LIGHTS" : "",
        n.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
        n.logarithmicDepthBuffer && n.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "",
        "uniform mat4 viewMatrix;",
        "uniform vec3 cameraPosition;",
        "uniform bool isOrthographic;",
        0 !== n.toneMapping ? "#define TONE_MAPPING" : "",
        0 !== n.toneMapping ? $fd4eb456bcbd06f8$var$sn.tonemapping_pars_fragment : "",
        0 !== n.toneMapping ? $fd4eb456bcbd06f8$var$qi("toneMapping", n.toneMapping) : "",
        n.dithering ? "#define DITHERING" : "",
        n.opaque ? "#define OPAQUE" : "",
        $fd4eb456bcbd06f8$var$sn.encodings_pars_fragment,
        $fd4eb456bcbd06f8$var$ji("linearToOutputTexel", n.outputEncoding),
        n.depthPacking ? "#define DEPTH_PACKING " + n.depthPacking : "",
        "\n"
    ].filter($fd4eb456bcbd06f8$var$Xi).join("\n")), a = $fd4eb456bcbd06f8$var$Ki(a), a = $fd4eb456bcbd06f8$var$$i(a, n), a = $fd4eb456bcbd06f8$var$Yi(a, n), o = $fd4eb456bcbd06f8$var$Ki(o), o = $fd4eb456bcbd06f8$var$$i(o, n), o = $fd4eb456bcbd06f8$var$Yi(o, n), a = $fd4eb456bcbd06f8$var$er(a), o = $fd4eb456bcbd06f8$var$er(o), n.isWebGL2 && !0 !== n.isRawShaderMaterial && (y = "#version 300 es\n", g = [
        "precision mediump sampler2DArray;",
        "#define attribute in",
        "#define varying out",
        "#define texture2D texture"
    ].join("\n") + "\n" + g, v = [
        "#define varying in",
        "300 es" === n.glslVersion ? "" : "layout(location = 0) out highp vec4 pc_fragColor;",
        "300 es" === n.glslVersion ? "" : "#define gl_FragColor pc_fragColor",
        "#define gl_FragDepthEXT gl_FragDepth",
        "#define texture2D texture",
        "#define textureCube texture",
        "#define texture2DProj textureProj",
        "#define texture2DLodEXT textureLod",
        "#define texture2DProjLodEXT textureProjLod",
        "#define textureCubeLodEXT textureLod",
        "#define texture2DGradEXT textureGrad",
        "#define texture2DProjGradEXT textureProjGrad",
        "#define textureCubeGradEXT textureGrad"
    ].join("\n") + "\n" + v);
    const x = y + v + o, b = $fd4eb456bcbd06f8$var$Vi(r, 35633, y + g + a), _ = $fd4eb456bcbd06f8$var$Vi(r, 35632, x);
    if (r.attachShader(f, b), r.attachShader(f, _), void 0 !== n.index0AttributeName ? r.bindAttribLocation(f, 0, n.index0AttributeName) : !0 === n.morphTargets && r.bindAttribLocation(f, 0, "position"), r.linkProgram(f), t1.debug.checkShaderErrors) {
        const t1 = r.getProgramInfoLog(f).trim(), e = r.getShaderInfoLog(b).trim(), n = r.getShaderInfoLog(_).trim();
        let i = !0, s = !0;
        if (!1 === r.getProgramParameter(f, 35714)) {
            i = !1;
            const e = $fd4eb456bcbd06f8$var$Wi(r, b, "vertex"), n = $fd4eb456bcbd06f8$var$Wi(r, _, "fragment");
            console.error("THREE.WebGLProgram: Shader Error " + r.getError() + " - VALIDATE_STATUS " + r.getProgramParameter(f, 35715) + "\n\nProgram Info Log: " + t1 + "\n" + e + "\n" + n);
        } else "" !== t1 ? console.warn("THREE.WebGLProgram: Program Info Log:", t1) : "" !== e && "" !== n || (s = !1);
        s && (this.diagnostics = {
            runnable: i,
            programLog: t1,
            vertexShader: {
                log: e,
                prefix: g
            },
            fragmentShader: {
                log: n,
                prefix: v
            }
        });
    }
    let w, M;
    return r.deleteShader(b), r.deleteShader(_), this.getUniforms = function() {
        return void 0 === w && (w = new $fd4eb456bcbd06f8$var$Hi(r, f)), w;
    }, this.getAttributes = function() {
        return void 0 === M && (M = function(t1, e) {
            const n = {}, i = t1.getProgramParameter(e, 35721);
            for(let r = 0; r < i; r++){
                const i = t1.getActiveAttrib(e, r), s = i.name;
                let a = 1;
                35674 === i.type && (a = 2), 35675 === i.type && (a = 3), 35676 === i.type && (a = 4), n[s] = {
                    type: i.type,
                    location: t1.getAttribLocation(e, s),
                    locationSize: a
                };
            }
            return n;
        }(r, f)), M;
    }, this.destroy = function() {
        i.releaseStatesOfProgram(this), r.deleteProgram(f), this.program = void 0;
    }, this.name = n.shaderName, this.id = $fd4eb456bcbd06f8$var$Gi++, this.cacheKey = e, this.usedTimes = 1, this.program = f, this.vertexShader = b, this.fragmentShader = _, this;
}
let $fd4eb456bcbd06f8$var$ar = 0;
class $fd4eb456bcbd06f8$var$or {
    constructor(){
        this.shaderCache = new Map, this.materialCache = new Map;
    }
    update(t1) {
        const e = t1.vertexShader, n = t1.fragmentShader, i = this._getShaderStage(e), r = this._getShaderStage(n), s = this._getShaderCacheForMaterial(t1);
        return !1 === s.has(i) && (s.add(i), i.usedTimes++), !1 === s.has(r) && (s.add(r), r.usedTimes++), this;
    }
    remove(t1) {
        const e = this.materialCache.get(t1);
        for (const t1 of e)t1.usedTimes--, 0 === t1.usedTimes && this.shaderCache.delete(t1.code);
        return this.materialCache.delete(t1), this;
    }
    getVertexShaderID(t1) {
        return this._getShaderStage(t1.vertexShader).id;
    }
    getFragmentShaderID(t1) {
        return this._getShaderStage(t1.fragmentShader).id;
    }
    dispose() {
        this.shaderCache.clear(), this.materialCache.clear();
    }
    _getShaderCacheForMaterial(t1) {
        const e = this.materialCache;
        return !1 === e.has(t1) && e.set(t1, new Set), e.get(t1);
    }
    _getShaderStage(t1) {
        const e = this.shaderCache;
        if (!1 === e.has(t1)) {
            const n = new $fd4eb456bcbd06f8$var$lr(t1);
            e.set(t1, n);
        }
        return e.get(t1);
    }
}
class $fd4eb456bcbd06f8$var$lr {
    constructor(t1){
        this.id = $fd4eb456bcbd06f8$var$ar++, this.code = t1, this.usedTimes = 0;
    }
}
function $fd4eb456bcbd06f8$var$hr(t1, e, n, i, r, s, a) {
    const o = new $fd4eb456bcbd06f8$var$Lt, l = new $fd4eb456bcbd06f8$var$or, h = [], c = r.isWebGL2, u = r.logarithmicDepthBuffer, d = r.floatVertexTextures, p = r.maxVertexUniforms, m = r.vertexTextures;
    let f = r.precision;
    const g = {
        MeshDepthMaterial: "depth",
        MeshDistanceMaterial: "distanceRGBA",
        MeshNormalMaterial: "normal",
        MeshBasicMaterial: "basic",
        MeshLambertMaterial: "lambert",
        MeshPhongMaterial: "phong",
        MeshToonMaterial: "toon",
        MeshStandardMaterial: "physical",
        MeshPhysicalMaterial: "physical",
        MeshMatcapMaterial: "matcap",
        LineBasicMaterial: "basic",
        LineDashedMaterial: "dashed",
        PointsMaterial: "points",
        ShadowMaterial: "shadow",
        SpriteMaterial: "sprite"
    };
    return {
        getParameters: function(s, o, h, v, y) {
            const x = v.fog, b = y.geometry, _ = s.isMeshStandardMaterial ? v.environment : null, w = (s.isMeshStandardMaterial ? n : e).get(s.envMap || _), M = w && 306 === w.mapping ? w.image.height : null, S = g[s.type], T = y.isSkinnedMesh ? function(t1) {
                const e = t1.skeleton.bones;
                if (d) return 1024;
                {
                    const t1 = p, n = Math.floor((t1 - 20) / 4), i = Math.min(n, e.length);
                    return i < e.length ? (console.warn("THREE.WebGLRenderer: Skeleton has " + e.length + " bones. This GPU supports " + i + "."), 0) : i;
                }
            }(y) : 0;
            null !== s.precision && (f = r.getMaxPrecision(s.precision), f !== s.precision && console.warn("THREE.WebGLProgram.getParameters:", s.precision, "not supported, using", f, "instead."));
            const E = b.morphAttributes.position || b.morphAttributes.normal || b.morphAttributes.color, A = void 0 !== E ? E.length : 0;
            let R, C, L, P, D = 0;
            if (void 0 !== b.morphAttributes.position && (D = 1), void 0 !== b.morphAttributes.normal && (D = 2), void 0 !== b.morphAttributes.color && (D = 3), S) {
                const t1 = $fd4eb456bcbd06f8$var$on[S];
                R = t1.vertexShader, C = t1.fragmentShader;
            } else R = s.vertexShader, C = s.fragmentShader, l.update(s), L = l.getVertexShaderID(s), P = l.getFragmentShaderID(s);
            const I = t1.getRenderTarget(), O = s.alphaTest > 0, N = s.clearcoat > 0;
            return {
                isWebGL2: c,
                shaderID: S,
                shaderName: s.type,
                vertexShader: R,
                fragmentShader: C,
                defines: s.defines,
                customVertexShaderID: L,
                customFragmentShaderID: P,
                isRawShaderMaterial: !0 === s.isRawShaderMaterial,
                glslVersion: s.glslVersion,
                precision: f,
                instancing: !0 === y.isInstancedMesh,
                instancingColor: !0 === y.isInstancedMesh && null !== y.instanceColor,
                supportsVertexTextures: m,
                outputEncoding: null === I ? t1.outputEncoding : !0 === I.isXRRenderTarget ? I.texture.encoding : 3e3,
                map: !!s.map,
                matcap: !!s.matcap,
                envMap: !!w,
                envMapMode: w && w.mapping,
                envMapCubeUVHeight: M,
                lightMap: !!s.lightMap,
                aoMap: !!s.aoMap,
                emissiveMap: !!s.emissiveMap,
                bumpMap: !!s.bumpMap,
                normalMap: !!s.normalMap,
                objectSpaceNormalMap: 1 === s.normalMapType,
                tangentSpaceNormalMap: 0 === s.normalMapType,
                decodeVideoTexture: !!s.map && !0 === s.map.isVideoTexture && 3001 === s.map.encoding,
                clearcoat: N,
                clearcoatMap: N && !!s.clearcoatMap,
                clearcoatRoughnessMap: N && !!s.clearcoatRoughnessMap,
                clearcoatNormalMap: N && !!s.clearcoatNormalMap,
                displacementMap: !!s.displacementMap,
                roughnessMap: !!s.roughnessMap,
                metalnessMap: !!s.metalnessMap,
                specularMap: !!s.specularMap,
                specularIntensityMap: !!s.specularIntensityMap,
                specularColorMap: !!s.specularColorMap,
                opaque: !1 === s.transparent && 1 === s.blending,
                alphaMap: !!s.alphaMap,
                alphaTest: O,
                gradientMap: !!s.gradientMap,
                sheen: s.sheen > 0,
                sheenColorMap: !!s.sheenColorMap,
                sheenRoughnessMap: !!s.sheenRoughnessMap,
                transmission: s.transmission > 0,
                transmissionMap: !!s.transmissionMap,
                thicknessMap: !!s.thicknessMap,
                combine: s.combine,
                vertexTangents: !!s.normalMap && !!b.attributes.tangent,
                vertexColors: s.vertexColors,
                vertexAlphas: !0 === s.vertexColors && !!b.attributes.color && 4 === b.attributes.color.itemSize,
                vertexUvs: !!(s.map || s.bumpMap || s.normalMap || s.specularMap || s.alphaMap || s.emissiveMap || s.roughnessMap || s.metalnessMap || s.clearcoatMap || s.clearcoatRoughnessMap || s.clearcoatNormalMap || s.displacementMap || s.transmissionMap || s.thicknessMap || s.specularIntensityMap || s.specularColorMap || s.sheenColorMap || s.sheenRoughnessMap),
                uvsVertexOnly: !(s.map || s.bumpMap || s.normalMap || s.specularMap || s.alphaMap || s.emissiveMap || s.roughnessMap || s.metalnessMap || s.clearcoatNormalMap || s.transmission > 0 || s.transmissionMap || s.thicknessMap || s.specularIntensityMap || s.specularColorMap || s.sheen > 0 || s.sheenColorMap || s.sheenRoughnessMap || !s.displacementMap),
                fog: !!x,
                useFog: s.fog,
                fogExp2: x && x.isFogExp2,
                flatShading: !!s.flatShading,
                sizeAttenuation: s.sizeAttenuation,
                logarithmicDepthBuffer: u,
                skinning: !0 === y.isSkinnedMesh && T > 0,
                maxBones: T,
                useVertexTexture: d,
                morphTargets: void 0 !== b.morphAttributes.position,
                morphNormals: void 0 !== b.morphAttributes.normal,
                morphColors: void 0 !== b.morphAttributes.color,
                morphTargetsCount: A,
                morphTextureStride: D,
                numDirLights: o.directional.length,
                numPointLights: o.point.length,
                numSpotLights: o.spot.length,
                numRectAreaLights: o.rectArea.length,
                numHemiLights: o.hemi.length,
                numDirLightShadows: o.directionalShadowMap.length,
                numPointLightShadows: o.pointShadowMap.length,
                numSpotLightShadows: o.spotShadowMap.length,
                numClippingPlanes: a.numPlanes,
                numClipIntersection: a.numIntersection,
                dithering: s.dithering,
                shadowMapEnabled: t1.shadowMap.enabled && h.length > 0,
                shadowMapType: t1.shadowMap.type,
                toneMapping: s.toneMapped ? t1.toneMapping : 0,
                physicallyCorrectLights: t1.physicallyCorrectLights,
                premultipliedAlpha: s.premultipliedAlpha,
                doubleSided: 2 === s.side,
                flipSided: 1 === s.side,
                depthPacking: void 0 !== s.depthPacking && s.depthPacking,
                index0AttributeName: s.index0AttributeName,
                extensionDerivatives: s.extensions && s.extensions.derivatives,
                extensionFragDepth: s.extensions && s.extensions.fragDepth,
                extensionDrawBuffers: s.extensions && s.extensions.drawBuffers,
                extensionShaderTextureLOD: s.extensions && s.extensions.shaderTextureLOD,
                rendererExtensionFragDepth: c || i.has("EXT_frag_depth"),
                rendererExtensionDrawBuffers: c || i.has("WEBGL_draw_buffers"),
                rendererExtensionShaderTextureLod: c || i.has("EXT_shader_texture_lod"),
                customProgramCacheKey: s.customProgramCacheKey()
            };
        },
        getProgramCacheKey: function(e) {
            const n = [];
            if (e.shaderID ? n.push(e.shaderID) : (n.push(e.customVertexShaderID), n.push(e.customFragmentShaderID)), void 0 !== e.defines) for(const t1 in e.defines)n.push(t1), n.push(e.defines[t1]);
            return !1 === e.isRawShaderMaterial && (!function(t1, e) {
                t1.push(e.precision), t1.push(e.outputEncoding), t1.push(e.envMapMode), t1.push(e.envMapCubeUVHeight), t1.push(e.combine), t1.push(e.vertexUvs), t1.push(e.fogExp2), t1.push(e.sizeAttenuation), t1.push(e.maxBones), t1.push(e.morphTargetsCount), t1.push(e.morphAttributeCount), t1.push(e.numDirLights), t1.push(e.numPointLights), t1.push(e.numSpotLights), t1.push(e.numHemiLights), t1.push(e.numRectAreaLights), t1.push(e.numDirLightShadows), t1.push(e.numPointLightShadows), t1.push(e.numSpotLightShadows), t1.push(e.shadowMapType), t1.push(e.toneMapping), t1.push(e.numClippingPlanes), t1.push(e.numClipIntersection);
            }(n, e), function(t1, e) {
                o.disableAll(), e.isWebGL2 && o.enable(0);
                e.supportsVertexTextures && o.enable(1);
                e.instancing && o.enable(2);
                e.instancingColor && o.enable(3);
                e.map && o.enable(4);
                e.matcap && o.enable(5);
                e.envMap && o.enable(6);
                e.lightMap && o.enable(7);
                e.aoMap && o.enable(8);
                e.emissiveMap && o.enable(9);
                e.bumpMap && o.enable(10);
                e.normalMap && o.enable(11);
                e.objectSpaceNormalMap && o.enable(12);
                e.tangentSpaceNormalMap && o.enable(13);
                e.clearcoat && o.enable(14);
                e.clearcoatMap && o.enable(15);
                e.clearcoatRoughnessMap && o.enable(16);
                e.clearcoatNormalMap && o.enable(17);
                e.displacementMap && o.enable(18);
                e.specularMap && o.enable(19);
                e.roughnessMap && o.enable(20);
                e.metalnessMap && o.enable(21);
                e.gradientMap && o.enable(22);
                e.alphaMap && o.enable(23);
                e.alphaTest && o.enable(24);
                e.vertexColors && o.enable(25);
                e.vertexAlphas && o.enable(26);
                e.vertexUvs && o.enable(27);
                e.vertexTangents && o.enable(28);
                e.uvsVertexOnly && o.enable(29);
                e.fog && o.enable(30);
                t1.push(o.mask), o.disableAll(), e.useFog && o.enable(0);
                e.flatShading && o.enable(1);
                e.logarithmicDepthBuffer && o.enable(2);
                e.skinning && o.enable(3);
                e.useVertexTexture && o.enable(4);
                e.morphTargets && o.enable(5);
                e.morphNormals && o.enable(6);
                e.morphColors && o.enable(7);
                e.premultipliedAlpha && o.enable(8);
                e.shadowMapEnabled && o.enable(9);
                e.physicallyCorrectLights && o.enable(10);
                e.doubleSided && o.enable(11);
                e.flipSided && o.enable(12);
                e.depthPacking && o.enable(13);
                e.dithering && o.enable(14);
                e.specularIntensityMap && o.enable(15);
                e.specularColorMap && o.enable(16);
                e.transmission && o.enable(17);
                e.transmissionMap && o.enable(18);
                e.thicknessMap && o.enable(19);
                e.sheen && o.enable(20);
                e.sheenColorMap && o.enable(21);
                e.sheenRoughnessMap && o.enable(22);
                e.decodeVideoTexture && o.enable(23);
                e.opaque && o.enable(24);
                t1.push(o.mask);
            }(n, e), n.push(t1.outputEncoding)), n.push(e.customProgramCacheKey), n.join();
        },
        getUniforms: function(t1) {
            const e = g[t1.type];
            let n;
            if (e) {
                const t1 = $fd4eb456bcbd06f8$var$on[e];
                n = $fd4eb456bcbd06f8$var$He.clone(t1.uniforms);
            } else n = t1.uniforms;
            return n;
        },
        acquireProgram: function(e, n) {
            let i;
            for(let t1 = 0, e = h.length; t1 < e; t1++){
                const e = h[t1];
                if (e.cacheKey === n) {
                    i = e, ++i.usedTimes;
                    break;
                }
            }
            return void 0 === i && (i = new $fd4eb456bcbd06f8$var$sr(t1, n, e, s), h.push(i)), i;
        },
        releaseProgram: function(t1) {
            if (0 == --t1.usedTimes) {
                const e = h.indexOf(t1);
                h[e] = h[h.length - 1], h.pop(), t1.destroy();
            }
        },
        releaseShaderCache: function(t1) {
            l.remove(t1);
        },
        programs: h,
        dispose: function() {
            l.dispose();
        }
    };
}
function $fd4eb456bcbd06f8$var$cr() {
    let t1 = new WeakMap;
    return {
        get: function(e) {
            let n = t1.get(e);
            return void 0 === n && (n = {}, t1.set(e, n)), n;
        },
        remove: function(e) {
            t1.delete(e);
        },
        update: function(e, n, i) {
            t1.get(e)[n] = i;
        },
        dispose: function() {
            t1 = new WeakMap;
        }
    };
}
function $fd4eb456bcbd06f8$var$ur(t1, e) {
    return t1.groupOrder !== e.groupOrder ? t1.groupOrder - e.groupOrder : t1.renderOrder !== e.renderOrder ? t1.renderOrder - e.renderOrder : t1.material.id !== e.material.id ? t1.material.id - e.material.id : t1.z !== e.z ? t1.z - e.z : t1.id - e.id;
}
function $fd4eb456bcbd06f8$var$dr(t1, e) {
    return t1.groupOrder !== e.groupOrder ? t1.groupOrder - e.groupOrder : t1.renderOrder !== e.renderOrder ? t1.renderOrder - e.renderOrder : t1.z !== e.z ? e.z - t1.z : t1.id - e.id;
}
function $fd4eb456bcbd06f8$var$pr() {
    const t1 = [];
    let e = 0;
    const n = [], i = [], r = [];
    function s(n, i, r, s, a, o) {
        let l = t1[e];
        return void 0 === l ? (l = {
            id: n.id,
            object: n,
            geometry: i,
            material: r,
            groupOrder: s,
            renderOrder: n.renderOrder,
            z: a,
            group: o
        }, t1[e] = l) : (l.id = n.id, l.object = n, l.geometry = i, l.material = r, l.groupOrder = s, l.renderOrder = n.renderOrder, l.z = a, l.group = o), e++, l;
    }
    return {
        opaque: n,
        transmissive: i,
        transparent: r,
        init: function() {
            e = 0, n.length = 0, i.length = 0, r.length = 0;
        },
        push: function(t1, e, a, o, l, h) {
            const c = s(t1, e, a, o, l, h);
            a.transmission > 0 ? i.push(c) : !0 === a.transparent ? r.push(c) : n.push(c);
        },
        unshift: function(t1, e, a, o, l, h) {
            const c = s(t1, e, a, o, l, h);
            a.transmission > 0 ? i.unshift(c) : !0 === a.transparent ? r.unshift(c) : n.unshift(c);
        },
        finish: function() {
            for(let n = e, i = t1.length; n < i; n++){
                const e = t1[n];
                if (null === e.id) break;
                e.id = null, e.object = null, e.geometry = null, e.material = null, e.group = null;
            }
        },
        sort: function(t1, e) {
            n.length > 1 && n.sort(t1 || $fd4eb456bcbd06f8$var$ur), i.length > 1 && i.sort(e || $fd4eb456bcbd06f8$var$dr), r.length > 1 && r.sort(e || $fd4eb456bcbd06f8$var$dr);
        }
    };
}
function $fd4eb456bcbd06f8$var$mr() {
    let t1 = new WeakMap;
    return {
        get: function(e, n) {
            let i;
            return !1 === t1.has(e) ? (i = new $fd4eb456bcbd06f8$var$pr, t1.set(e, [
                i
            ])) : n >= t1.get(e).length ? (i = new $fd4eb456bcbd06f8$var$pr, t1.get(e).push(i)) : i = t1.get(e)[n], i;
        },
        dispose: function() {
            t1 = new WeakMap;
        }
    };
}
function $fd4eb456bcbd06f8$var$fr() {
    const t1 = {};
    return {
        get: function(e) {
            if (void 0 !== t1[e.id]) return t1[e.id];
            let n;
            switch(e.type){
                case "DirectionalLight":
                    n = {
                        direction: new $fd4eb456bcbd06f8$var$V,
                        color: new $fd4eb456bcbd06f8$var$L
                    };
                    break;
                case "SpotLight":
                    n = {
                        position: new $fd4eb456bcbd06f8$var$V,
                        direction: new $fd4eb456bcbd06f8$var$V,
                        color: new $fd4eb456bcbd06f8$var$L,
                        distance: 0,
                        coneCos: 0,
                        penumbraCos: 0,
                        decay: 0
                    };
                    break;
                case "PointLight":
                    n = {
                        position: new $fd4eb456bcbd06f8$var$V,
                        color: new $fd4eb456bcbd06f8$var$L,
                        distance: 0,
                        decay: 0
                    };
                    break;
                case "HemisphereLight":
                    n = {
                        direction: new $fd4eb456bcbd06f8$var$V,
                        skyColor: new $fd4eb456bcbd06f8$var$L,
                        groundColor: new $fd4eb456bcbd06f8$var$L
                    };
                    break;
                case "RectAreaLight":
                    n = {
                        color: new $fd4eb456bcbd06f8$var$L,
                        position: new $fd4eb456bcbd06f8$var$V,
                        halfWidth: new $fd4eb456bcbd06f8$var$V,
                        halfHeight: new $fd4eb456bcbd06f8$var$V
                    };
            }
            return t1[e.id] = n, n;
        }
    };
}
let $fd4eb456bcbd06f8$var$gr = 0;
function $fd4eb456bcbd06f8$var$vr(t1, e) {
    return (e.castShadow ? 1 : 0) - (t1.castShadow ? 1 : 0);
}
function $fd4eb456bcbd06f8$var$yr(t1, e) {
    const n = new $fd4eb456bcbd06f8$var$fr, i = function() {
        const t1 = {};
        return {
            get: function(e) {
                if (void 0 !== t1[e.id]) return t1[e.id];
                let n;
                switch(e.type){
                    case "DirectionalLight":
                    case "SpotLight":
                        n = {
                            shadowBias: 0,
                            shadowNormalBias: 0,
                            shadowRadius: 1,
                            shadowMapSize: new $fd4eb456bcbd06f8$var$g
                        };
                        break;
                    case "PointLight":
                        n = {
                            shadowBias: 0,
                            shadowNormalBias: 0,
                            shadowRadius: 1,
                            shadowMapSize: new $fd4eb456bcbd06f8$var$g,
                            shadowCameraNear: 1,
                            shadowCameraFar: 1e3
                        };
                }
                return t1[e.id] = n, n;
            }
        };
    }(), r = {
        version: 0,
        hash: {
            directionalLength: -1,
            pointLength: -1,
            spotLength: -1,
            rectAreaLength: -1,
            hemiLength: -1,
            numDirectionalShadows: -1,
            numPointShadows: -1,
            numSpotShadows: -1
        },
        ambient: [
            0,
            0,
            0
        ],
        probe: [],
        directional: [],
        directionalShadow: [],
        directionalShadowMap: [],
        directionalShadowMatrix: [],
        spot: [],
        spotShadow: [],
        spotShadowMap: [],
        spotShadowMatrix: [],
        rectArea: [],
        rectAreaLTC1: null,
        rectAreaLTC2: null,
        point: [],
        pointShadow: [],
        pointShadowMap: [],
        pointShadowMatrix: [],
        hemi: []
    };
    for(let t1 = 0; t1 < 9; t1++)r.probe.push(new $fd4eb456bcbd06f8$var$V);
    const s = new $fd4eb456bcbd06f8$var$V, a = new $fd4eb456bcbd06f8$var$xt, o = new $fd4eb456bcbd06f8$var$xt;
    return {
        setup: function(s, a) {
            let o = 0, l = 0, h = 0;
            for(let t1 = 0; t1 < 9; t1++)r.probe[t1].set(0, 0, 0);
            let c = 0, u = 0, d = 0, p = 0, m = 0, f = 0, g = 0, v = 0;
            s.sort($fd4eb456bcbd06f8$var$vr);
            const y = !0 !== a ? Math.PI : 1;
            for(let t1 = 0, e = s.length; t1 < e; t1++){
                const e = s[t1], a = e.color, x = e.intensity, b = e.distance, _ = e.shadow && e.shadow.map ? e.shadow.map.texture : null;
                if (e.isAmbientLight) o += a.r * x * y, l += a.g * x * y, h += a.b * x * y;
                else if (e.isLightProbe) for(let t1 = 0; t1 < 9; t1++)r.probe[t1].addScaledVector(e.sh.coefficients[t1], x);
                else if (e.isDirectionalLight) {
                    const t1 = n.get(e);
                    if (t1.color.copy(e.color).multiplyScalar(e.intensity * y), e.castShadow) {
                        const t1 = e.shadow, n = i.get(e);
                        n.shadowBias = t1.bias, n.shadowNormalBias = t1.normalBias, n.shadowRadius = t1.radius, n.shadowMapSize = t1.mapSize, r.directionalShadow[c] = n, r.directionalShadowMap[c] = _, r.directionalShadowMatrix[c] = e.shadow.matrix, f++;
                    }
                    r.directional[c] = t1, c++;
                } else if (e.isSpotLight) {
                    const t1 = n.get(e);
                    if (t1.position.setFromMatrixPosition(e.matrixWorld), t1.color.copy(a).multiplyScalar(x * y), t1.distance = b, t1.coneCos = Math.cos(e.angle), t1.penumbraCos = Math.cos(e.angle * (1 - e.penumbra)), t1.decay = e.decay, e.castShadow) {
                        const t1 = e.shadow, n = i.get(e);
                        n.shadowBias = t1.bias, n.shadowNormalBias = t1.normalBias, n.shadowRadius = t1.radius, n.shadowMapSize = t1.mapSize, r.spotShadow[d] = n, r.spotShadowMap[d] = _, r.spotShadowMatrix[d] = e.shadow.matrix, v++;
                    }
                    r.spot[d] = t1, d++;
                } else if (e.isRectAreaLight) {
                    const t1 = n.get(e);
                    t1.color.copy(a).multiplyScalar(x), t1.halfWidth.set(.5 * e.width, 0, 0), t1.halfHeight.set(0, .5 * e.height, 0), r.rectArea[p] = t1, p++;
                } else if (e.isPointLight) {
                    const t1 = n.get(e);
                    if (t1.color.copy(e.color).multiplyScalar(e.intensity * y), t1.distance = e.distance, t1.decay = e.decay, e.castShadow) {
                        const t1 = e.shadow, n = i.get(e);
                        n.shadowBias = t1.bias, n.shadowNormalBias = t1.normalBias, n.shadowRadius = t1.radius, n.shadowMapSize = t1.mapSize, n.shadowCameraNear = t1.camera.near, n.shadowCameraFar = t1.camera.far, r.pointShadow[u] = n, r.pointShadowMap[u] = _, r.pointShadowMatrix[u] = e.shadow.matrix, g++;
                    }
                    r.point[u] = t1, u++;
                } else if (e.isHemisphereLight) {
                    const t1 = n.get(e);
                    t1.skyColor.copy(e.color).multiplyScalar(x * y), t1.groundColor.copy(e.groundColor).multiplyScalar(x * y), r.hemi[m] = t1, m++;
                }
            }
            p > 0 && (e.isWebGL2 || !0 === t1.has("OES_texture_float_linear") ? (r.rectAreaLTC1 = $fd4eb456bcbd06f8$var$an.LTC_FLOAT_1, r.rectAreaLTC2 = $fd4eb456bcbd06f8$var$an.LTC_FLOAT_2) : !0 === t1.has("OES_texture_half_float_linear") ? (r.rectAreaLTC1 = $fd4eb456bcbd06f8$var$an.LTC_HALF_1, r.rectAreaLTC2 = $fd4eb456bcbd06f8$var$an.LTC_HALF_2) : console.error("THREE.WebGLRenderer: Unable to use RectAreaLight. Missing WebGL extensions.")), r.ambient[0] = o, r.ambient[1] = l, r.ambient[2] = h;
            const x = r.hash;
            x.directionalLength === c && x.pointLength === u && x.spotLength === d && x.rectAreaLength === p && x.hemiLength === m && x.numDirectionalShadows === f && x.numPointShadows === g && x.numSpotShadows === v || (r.directional.length = c, r.spot.length = d, r.rectArea.length = p, r.point.length = u, r.hemi.length = m, r.directionalShadow.length = f, r.directionalShadowMap.length = f, r.pointShadow.length = g, r.pointShadowMap.length = g, r.spotShadow.length = v, r.spotShadowMap.length = v, r.directionalShadowMatrix.length = f, r.pointShadowMatrix.length = g, r.spotShadowMatrix.length = v, x.directionalLength = c, x.pointLength = u, x.spotLength = d, x.rectAreaLength = p, x.hemiLength = m, x.numDirectionalShadows = f, x.numPointShadows = g, x.numSpotShadows = v, r.version = $fd4eb456bcbd06f8$var$gr++);
        },
        setupView: function(t1, e) {
            let n = 0, i = 0, l = 0, h = 0, c = 0;
            const u = e.matrixWorldInverse;
            for(let e = 0, d = t1.length; e < d; e++){
                const d = t1[e];
                if (d.isDirectionalLight) {
                    const t1 = r.directional[n];
                    t1.direction.setFromMatrixPosition(d.matrixWorld), s.setFromMatrixPosition(d.target.matrixWorld), t1.direction.sub(s), t1.direction.transformDirection(u), n++;
                } else if (d.isSpotLight) {
                    const t1 = r.spot[l];
                    t1.position.setFromMatrixPosition(d.matrixWorld), t1.position.applyMatrix4(u), t1.direction.setFromMatrixPosition(d.matrixWorld), s.setFromMatrixPosition(d.target.matrixWorld), t1.direction.sub(s), t1.direction.transformDirection(u), l++;
                } else if (d.isRectAreaLight) {
                    const t1 = r.rectArea[h];
                    t1.position.setFromMatrixPosition(d.matrixWorld), t1.position.applyMatrix4(u), o.identity(), a.copy(d.matrixWorld), a.premultiply(u), o.extractRotation(a), t1.halfWidth.set(.5 * d.width, 0, 0), t1.halfHeight.set(0, .5 * d.height, 0), t1.halfWidth.applyMatrix4(o), t1.halfHeight.applyMatrix4(o), h++;
                } else if (d.isPointLight) {
                    const t1 = r.point[i];
                    t1.position.setFromMatrixPosition(d.matrixWorld), t1.position.applyMatrix4(u), i++;
                } else if (d.isHemisphereLight) {
                    const t1 = r.hemi[c];
                    t1.direction.setFromMatrixPosition(d.matrixWorld), t1.direction.transformDirection(u), t1.direction.normalize(), c++;
                }
            }
        },
        state: r
    };
}
function $fd4eb456bcbd06f8$var$xr(t1, e) {
    const n = new $fd4eb456bcbd06f8$var$yr(t1, e), i = [], r = [];
    return {
        init: function() {
            i.length = 0, r.length = 0;
        },
        state: {
            lightsArray: i,
            shadowsArray: r,
            lights: n
        },
        setupLights: function(t1) {
            n.setup(i, t1);
        },
        setupLightsView: function(t1) {
            n.setupView(i, t1);
        },
        pushLight: function(t1) {
            i.push(t1);
        },
        pushShadow: function(t1) {
            r.push(t1);
        }
    };
}
function $fd4eb456bcbd06f8$var$br(t1, e) {
    let n = new WeakMap;
    return {
        get: function(i, r = 0) {
            let s;
            return !1 === n.has(i) ? (s = new $fd4eb456bcbd06f8$var$xr(t1, e), n.set(i, [
                s
            ])) : r >= n.get(i).length ? (s = new $fd4eb456bcbd06f8$var$xr(t1, e), n.get(i).push(s)) : s = n.get(i)[r], s;
        },
        dispose: function() {
            n = new WeakMap;
        }
    };
}
class $fd4eb456bcbd06f8$var$_r extends $fd4eb456bcbd06f8$var$ie {
    constructor(t1){
        super(), this.type = "MeshDepthMaterial", this.depthPacking = 3200, this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.wireframe = !1, this.wireframeLinewidth = 1, this.fog = !1, this.setValues(t1);
    }
    copy(t1) {
        return super.copy(t1), this.depthPacking = t1.depthPacking, this.map = t1.map, this.alphaMap = t1.alphaMap, this.displacementMap = t1.displacementMap, this.displacementScale = t1.displacementScale, this.displacementBias = t1.displacementBias, this.wireframe = t1.wireframe, this.wireframeLinewidth = t1.wireframeLinewidth, this;
    }
}
$fd4eb456bcbd06f8$var$_r.prototype.isMeshDepthMaterial = !0;
class $fd4eb456bcbd06f8$var$wr extends $fd4eb456bcbd06f8$var$ie {
    constructor(t1){
        super(), this.type = "MeshDistanceMaterial", this.referencePosition = new $fd4eb456bcbd06f8$var$V, this.nearDistance = 1, this.farDistance = 1e3, this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.fog = !1, this.setValues(t1);
    }
    copy(t1) {
        return super.copy(t1), this.referencePosition.copy(t1.referencePosition), this.nearDistance = t1.nearDistance, this.farDistance = t1.farDistance, this.map = t1.map, this.alphaMap = t1.alphaMap, this.displacementMap = t1.displacementMap, this.displacementScale = t1.displacementScale, this.displacementBias = t1.displacementBias, this;
    }
}
$fd4eb456bcbd06f8$var$wr.prototype.isMeshDistanceMaterial = !0;
function $fd4eb456bcbd06f8$var$Mr(t1, e, n) {
    let i = new $fd4eb456bcbd06f8$var$tn;
    const r = new $fd4eb456bcbd06f8$var$g, s = new $fd4eb456bcbd06f8$var$g, a = new $fd4eb456bcbd06f8$var$U, o = new $fd4eb456bcbd06f8$var$_r({
        depthPacking: 3201
    }), l = new $fd4eb456bcbd06f8$var$wr, h = {}, c = n.maxTextureSize, u = {
        0: 1,
        1: 0,
        2: 2
    }, d = new $fd4eb456bcbd06f8$var$Ve({
        defines: {
            VSM_SAMPLES: 8
        },
        uniforms: {
            shadow_pass: {
                value: null
            },
            resolution: {
                value: new $fd4eb456bcbd06f8$var$g
            },
            radius: {
                value: 4
            }
        },
        vertexShader: "void main() {\n\tgl_Position = vec4( position, 1.0 );\n}",
        fragmentShader: "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\n#include <packing>\nvoid main() {\n\tconst float samples = float( VSM_SAMPLES );\n\tfloat mean = 0.0;\n\tfloat squared_mean = 0.0;\n\tfloat uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n\tfloat uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n\tfor ( float i = 0.0; i < samples; i ++ ) {\n\t\tfloat uvOffset = uvStart + i * uvStride;\n\t\t#ifdef HORIZONTAL_PASS\n\t\t\tvec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );\n\t\t\tmean += distribution.x;\n\t\t\tsquared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n\t\t#else\n\t\t\tfloat depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );\n\t\t\tmean += depth;\n\t\t\tsquared_mean += depth * depth;\n\t\t#endif\n\t}\n\tmean = mean / samples;\n\tsquared_mean = squared_mean / samples;\n\tfloat std_dev = sqrt( squared_mean - mean * mean );\n\tgl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}"
    }), p = d.clone();
    p.defines.HORIZONTAL_PASS = 1;
    const m = new $fd4eb456bcbd06f8$var$ye;
    m.setAttribute("position", new $fd4eb456bcbd06f8$var$oe(new Float32Array([
        -1,
        -1,
        .5,
        3,
        -1,
        .5,
        -1,
        3,
        .5
    ]), 3));
    const f = new $fd4eb456bcbd06f8$var$Fe(m, d), v = this;
    function y(n, i) {
        const r = e.update(f);
        d.defines.VSM_SAMPLES !== n.blurSamples && (d.defines.VSM_SAMPLES = n.blurSamples, p.defines.VSM_SAMPLES = n.blurSamples, d.needsUpdate = !0, p.needsUpdate = !0), d.uniforms.shadow_pass.value = n.map.texture, d.uniforms.resolution.value = n.mapSize, d.uniforms.radius.value = n.radius, t1.setRenderTarget(n.mapPass), t1.clear(), t1.renderBufferDirect(i, null, r, d, f, null), p.uniforms.shadow_pass.value = n.mapPass.texture, p.uniforms.resolution.value = n.mapSize, p.uniforms.radius.value = n.radius, t1.setRenderTarget(n.map), t1.clear(), t1.renderBufferDirect(i, null, r, p, f, null);
    }
    function x(e, n, i, r, s, a) {
        let c = null;
        const d = !0 === i.isPointLight ? e.customDistanceMaterial : e.customDepthMaterial;
        if (c = void 0 !== d ? d : !0 === i.isPointLight ? l : o, t1.localClippingEnabled && !0 === n.clipShadows && 0 !== n.clippingPlanes.length || n.displacementMap && 0 !== n.displacementScale || n.alphaMap && n.alphaTest > 0) {
            const t1 = c.uuid, e = n.uuid;
            let i = h[t1];
            void 0 === i && (i = {}, h[t1] = i);
            let r = i[e];
            void 0 === r && (r = c.clone(), i[e] = r), c = r;
        }
        return c.visible = n.visible, c.wireframe = n.wireframe, c.side = 3 === a ? null !== n.shadowSide ? n.shadowSide : n.side : null !== n.shadowSide ? n.shadowSide : u[n.side], c.alphaMap = n.alphaMap, c.alphaTest = n.alphaTest, c.clipShadows = n.clipShadows, c.clippingPlanes = n.clippingPlanes, c.clipIntersection = n.clipIntersection, c.displacementMap = n.displacementMap, c.displacementScale = n.displacementScale, c.displacementBias = n.displacementBias, c.wireframeLinewidth = n.wireframeLinewidth, c.linewidth = n.linewidth, !0 === i.isPointLight && !0 === c.isMeshDistanceMaterial && (c.referencePosition.setFromMatrixPosition(i.matrixWorld), c.nearDistance = r, c.farDistance = s), c;
    }
    function b(n, r, s, a, o) {
        if (!1 === n.visible) return;
        if (n.layers.test(r.layers) && (n.isMesh || n.isLine || n.isPoints) && (n.castShadow || n.receiveShadow && 3 === o) && (!n.frustumCulled || i.intersectsObject(n))) {
            n.modelViewMatrix.multiplyMatrices(s.matrixWorldInverse, n.matrixWorld);
            const i = e.update(n), r = n.material;
            if (Array.isArray(r)) {
                const e = i.groups;
                for(let l = 0, h = e.length; l < h; l++){
                    const h = e[l], c = r[h.materialIndex];
                    if (c && c.visible) {
                        const e = x(n, c, a, s.near, s.far, o);
                        t1.renderBufferDirect(s, null, i, e, n, h);
                    }
                }
            } else if (r.visible) {
                const e = x(n, r, a, s.near, s.far, o);
                t1.renderBufferDirect(s, null, i, e, n, null);
            }
        }
        const l = n.children;
        for(let t1 = 0, e = l.length; t1 < e; t1++)b(l[t1], r, s, a, o);
    }
    this.enabled = !1, this.autoUpdate = !0, this.needsUpdate = !1, this.type = 1, this.render = function(e, n, o) {
        if (!1 === v.enabled) return;
        if (!1 === v.autoUpdate && !1 === v.needsUpdate) return;
        if (0 === e.length) return;
        const l = t1.getRenderTarget(), h = t1.getActiveCubeFace(), u = t1.getActiveMipmapLevel(), d = t1.state;
        d.setBlending(0), d.buffers.color.setClear(1, 1, 1, 1), d.buffers.depth.setTest(!0), d.setScissorTest(!1);
        for(let l = 0, h = e.length; l < h; l++){
            const h = e[l], u = h.shadow;
            if (void 0 === u) {
                console.warn("THREE.WebGLShadowMap:", h, "has no shadow.");
                continue;
            }
            if (!1 === u.autoUpdate && !1 === u.needsUpdate) continue;
            r.copy(u.mapSize);
            const p = u.getFrameExtents();
            if (r.multiply(p), s.copy(u.mapSize), (r.x > c || r.y > c) && (r.x > c && (s.x = Math.floor(c / p.x), r.x = s.x * p.x, u.mapSize.x = s.x), r.y > c && (s.y = Math.floor(c / p.y), r.y = s.y * p.y, u.mapSize.y = s.y)), null !== u.map || u.isPointLightShadow || 3 !== this.type || (u.map = new $fd4eb456bcbd06f8$var$k(r.x, r.y), u.map.texture.name = h.name + ".shadowMap", u.mapPass = new $fd4eb456bcbd06f8$var$k(r.x, r.y), u.camera.updateProjectionMatrix()), null === u.map) {
                const t1 = {
                    minFilter: 1003,
                    magFilter: 1003,
                    format: 1023
                };
                u.map = new $fd4eb456bcbd06f8$var$k(r.x, r.y, t1), u.map.texture.name = h.name + ".shadowMap", u.camera.updateProjectionMatrix();
            }
            t1.setRenderTarget(u.map), t1.clear();
            const m = u.getViewportCount();
            for(let t1 = 0; t1 < m; t1++){
                const e = u.getViewport(t1);
                a.set(s.x * e.x, s.y * e.y, s.x * e.z, s.y * e.w), d.viewport(a), u.updateMatrices(h, t1), i = u.getFrustum(), b(n, o, u.camera, h, this.type);
            }
            u.isPointLightShadow || 3 !== this.type || y(u, o), u.needsUpdate = !1;
        }
        v.needsUpdate = !1, t1.setRenderTarget(l, h, u);
    };
}
function $fd4eb456bcbd06f8$var$Sr(t1, e, n) {
    const i = n.isWebGL2;
    const r = new function() {
        let e = !1;
        const n = new $fd4eb456bcbd06f8$var$U;
        let i = null;
        const r = new $fd4eb456bcbd06f8$var$U(0, 0, 0, 0);
        return {
            setMask: function(n) {
                i === n || e || (t1.colorMask(n, n, n, n), i = n);
            },
            setLocked: function(t1) {
                e = t1;
            },
            setClear: function(e, i, s, a, o) {
                !0 === o && (e *= a, i *= a, s *= a), n.set(e, i, s, a), !1 === r.equals(n) && (t1.clearColor(e, i, s, a), r.copy(n));
            },
            reset: function() {
                e = !1, i = null, r.set(-1, 0, 0, 0);
            }
        };
    }, s = new function() {
        let e = !1, n = null, i = null, r = null;
        return {
            setTest: function(t1) {
                t1 ? B(2929) : z(2929);
            },
            setMask: function(i) {
                n === i || e || (t1.depthMask(i), n = i);
            },
            setFunc: function(e) {
                if (i !== e) {
                    if (e) switch(e){
                        case 0:
                            t1.depthFunc(512);
                            break;
                        case 1:
                            t1.depthFunc(519);
                            break;
                        case 2:
                            t1.depthFunc(513);
                            break;
                        case 3:
                        default:
                            t1.depthFunc(515);
                            break;
                        case 4:
                            t1.depthFunc(514);
                            break;
                        case 5:
                            t1.depthFunc(518);
                            break;
                        case 6:
                            t1.depthFunc(516);
                            break;
                        case 7:
                            t1.depthFunc(517);
                    }
                    else t1.depthFunc(515);
                    i = e;
                }
            },
            setLocked: function(t1) {
                e = t1;
            },
            setClear: function(e) {
                r !== e && (t1.clearDepth(e), r = e);
            },
            reset: function() {
                e = !1, n = null, i = null, r = null;
            }
        };
    }, a = new function() {
        let e = !1, n = null, i = null, r = null, s = null, a = null, o = null, l = null, h = null;
        return {
            setTest: function(t1) {
                e || (t1 ? B(2960) : z(2960));
            },
            setMask: function(i) {
                n === i || e || (t1.stencilMask(i), n = i);
            },
            setFunc: function(e, n, a) {
                i === e && r === n && s === a || (t1.stencilFunc(e, n, a), i = e, r = n, s = a);
            },
            setOp: function(e, n, i) {
                a === e && o === n && l === i || (t1.stencilOp(e, n, i), a = e, o = n, l = i);
            },
            setLocked: function(t1) {
                e = t1;
            },
            setClear: function(e) {
                h !== e && (t1.clearStencil(e), h = e);
            },
            reset: function() {
                e = !1, n = null, i = null, r = null, s = null, a = null, o = null, l = null, h = null;
            }
        };
    };
    let o = {}, l = {}, h = new WeakMap, c = [], u = null, d = !1, p = null, m = null, f = null, g = null, v = null, y = null, x = null, b = !1, _ = null, w = null, M = null, S = null, T = null;
    const E = t1.getParameter(35661);
    let A = !1, R = 0;
    const C = t1.getParameter(7938);
    -1 !== C.indexOf("WebGL") ? (R = parseFloat(/^WebGL (\d)/.exec(C)[1]), A = R >= 1) : -1 !== C.indexOf("OpenGL ES") && (R = parseFloat(/^OpenGL ES (\d)/.exec(C)[1]), A = R >= 2);
    let L = null, P = {};
    const D = t1.getParameter(3088), I = t1.getParameter(2978), O = (new $fd4eb456bcbd06f8$var$U).fromArray(D), N = (new $fd4eb456bcbd06f8$var$U).fromArray(I);
    function F(e, n, i) {
        const r = new Uint8Array(4), s = t1.createTexture();
        t1.bindTexture(e, s), t1.texParameteri(e, 10241, 9728), t1.texParameteri(e, 10240, 9728);
        for(let e = 0; e < i; e++)t1.texImage2D(n + e, 0, 6408, 1, 1, 0, 6408, 5121, r);
        return s;
    }
    const k = {};
    function B(e) {
        !0 !== o[e] && (t1.enable(e), o[e] = !0);
    }
    function z(e) {
        !1 !== o[e] && (t1.disable(e), o[e] = !1);
    }
    k[3553] = F(3553, 3553, 1), k[34067] = F(34067, 34069, 6), r.setClear(0, 0, 0, 1), s.setClear(1), a.setClear(0), B(2929), s.setFunc(3), W(!1), j(1), B(2884), G(0);
    const H = {
        100: 32774,
        101: 32778,
        102: 32779
    };
    if (i) H[103] = 32775, H[104] = 32776;
    else {
        const t1 = e.get("EXT_blend_minmax");
        null !== t1 && (H[103] = t1.MIN_EXT, H[104] = t1.MAX_EXT);
    }
    const V = {
        200: 0,
        201: 1,
        202: 768,
        204: 770,
        210: 776,
        208: 774,
        206: 772,
        203: 769,
        205: 771,
        209: 775,
        207: 773
    };
    function G(e, n, i, r, s, a, o, l) {
        if (0 !== e) {
            if (!1 === d && (B(3042), d = !0), 5 === e) s = s || n, a = a || i, o = o || r, n === m && s === v || (t1.blendEquationSeparate(H[n], H[s]), m = n, v = s), i === f && r === g && a === y && o === x || (t1.blendFuncSeparate(V[i], V[r], V[a], V[o]), f = i, g = r, y = a, x = o), p = e, b = null;
            else if (e !== p || l !== b) {
                if (100 === m && 100 === v || (t1.blendEquation(32774), m = 100, v = 100), l) switch(e){
                    case 1:
                        t1.blendFuncSeparate(1, 771, 1, 771);
                        break;
                    case 2:
                        t1.blendFunc(1, 1);
                        break;
                    case 3:
                        t1.blendFuncSeparate(0, 769, 0, 1);
                        break;
                    case 4:
                        t1.blendFuncSeparate(0, 768, 0, 770);
                        break;
                    default:
                        console.error("THREE.WebGLState: Invalid blending: ", e);
                }
                else switch(e){
                    case 1:
                        t1.blendFuncSeparate(770, 771, 1, 771);
                        break;
                    case 2:
                        t1.blendFunc(770, 1);
                        break;
                    case 3:
                        t1.blendFuncSeparate(0, 769, 0, 1);
                        break;
                    case 4:
                        t1.blendFunc(0, 768);
                        break;
                    default:
                        console.error("THREE.WebGLState: Invalid blending: ", e);
                }
                f = null, g = null, y = null, x = null, p = e, b = l;
            }
        } else !0 === d && (z(3042), d = !1);
    }
    function W(e) {
        _ !== e && (e ? t1.frontFace(2304) : t1.frontFace(2305), _ = e);
    }
    function j(e) {
        0 !== e ? (B(2884), e !== w && (1 === e ? t1.cullFace(1029) : 2 === e ? t1.cullFace(1028) : t1.cullFace(1032))) : z(2884), w = e;
    }
    function q(e, n, i) {
        e ? (B(32823), S === n && T === i || (t1.polygonOffset(n, i), S = n, T = i)) : z(32823);
    }
    function X(e) {
        void 0 === e && (e = 33984 + E - 1), L !== e && (t1.activeTexture(e), L = e);
    }
    return {
        buffers: {
            color: r,
            depth: s,
            stencil: a
        },
        enable: B,
        disable: z,
        bindFramebuffer: function(e, n) {
            return l[e] !== n && (t1.bindFramebuffer(e, n), l[e] = n, i && (36009 === e && (l[36160] = n), 36160 === e && (l[36009] = n)), !0);
        },
        drawBuffers: function(i, r) {
            let s = c, a = !1;
            if (i) {
                if (s = h.get(r), void 0 === s && (s = [], h.set(r, s)), i.isWebGLMultipleRenderTargets) {
                    const t1 = i.texture;
                    if (s.length !== t1.length || 36064 !== s[0]) {
                        for(let e = 0, n = t1.length; e < n; e++)s[e] = 36064 + e;
                        s.length = t1.length, a = !0;
                    }
                } else 36064 !== s[0] && (s[0] = 36064, a = !0);
            } else 1029 !== s[0] && (s[0] = 1029, a = !0);
            a && (n.isWebGL2 ? t1.drawBuffers(s) : e.get("WEBGL_draw_buffers").drawBuffersWEBGL(s));
        },
        useProgram: function(e) {
            return u !== e && (t1.useProgram(e), u = e, !0);
        },
        setBlending: G,
        setMaterial: function(t1, e) {
            2 === t1.side ? z(2884) : B(2884);
            let n = 1 === t1.side;
            e && (n = !n), W(n), 1 === t1.blending && !1 === t1.transparent ? G(0) : G(t1.blending, t1.blendEquation, t1.blendSrc, t1.blendDst, t1.blendEquationAlpha, t1.blendSrcAlpha, t1.blendDstAlpha, t1.premultipliedAlpha), s.setFunc(t1.depthFunc), s.setTest(t1.depthTest), s.setMask(t1.depthWrite), r.setMask(t1.colorWrite);
            const i = t1.stencilWrite;
            a.setTest(i), i && (a.setMask(t1.stencilWriteMask), a.setFunc(t1.stencilFunc, t1.stencilRef, t1.stencilFuncMask), a.setOp(t1.stencilFail, t1.stencilZFail, t1.stencilZPass)), q(t1.polygonOffset, t1.polygonOffsetFactor, t1.polygonOffsetUnits), !0 === t1.alphaToCoverage ? B(32926) : z(32926);
        },
        setFlipSided: W,
        setCullFace: j,
        setLineWidth: function(e) {
            e !== M && (A && t1.lineWidth(e), M = e);
        },
        setPolygonOffset: q,
        setScissorTest: function(t1) {
            t1 ? B(3089) : z(3089);
        },
        activeTexture: X,
        bindTexture: function(e, n) {
            null === L && X();
            let i = P[L];
            void 0 === i && (i = {
                type: void 0,
                texture: void 0
            }, P[L] = i), i.type === e && i.texture === n || (t1.bindTexture(e, n || k[e]), i.type = e, i.texture = n);
        },
        unbindTexture: function() {
            const e = P[L];
            void 0 !== e && void 0 !== e.type && (t1.bindTexture(e.type, null), e.type = void 0, e.texture = void 0);
        },
        compressedTexImage2D: function() {
            try {
                t1.compressedTexImage2D.apply(t1, arguments);
            } catch (t1) {
                console.error("THREE.WebGLState:", t1);
            }
        },
        texImage2D: function() {
            try {
                t1.texImage2D.apply(t1, arguments);
            } catch (t1) {
                console.error("THREE.WebGLState:", t1);
            }
        },
        texImage3D: function() {
            try {
                t1.texImage3D.apply(t1, arguments);
            } catch (t1) {
                console.error("THREE.WebGLState:", t1);
            }
        },
        texStorage2D: function() {
            try {
                t1.texStorage2D.apply(t1, arguments);
            } catch (t1) {
                console.error("THREE.WebGLState:", t1);
            }
        },
        texStorage3D: function() {
            try {
                t1.texStorage3D.apply(t1, arguments);
            } catch (t1) {
                console.error("THREE.WebGLState:", t1);
            }
        },
        texSubImage2D: function() {
            try {
                t1.texSubImage2D.apply(t1, arguments);
            } catch (t1) {
                console.error("THREE.WebGLState:", t1);
            }
        },
        texSubImage3D: function() {
            try {
                t1.texSubImage3D.apply(t1, arguments);
            } catch (t1) {
                console.error("THREE.WebGLState:", t1);
            }
        },
        compressedTexSubImage2D: function() {
            try {
                t1.compressedTexSubImage2D.apply(t1, arguments);
            } catch (t1) {
                console.error("THREE.WebGLState:", t1);
            }
        },
        scissor: function(e) {
            !1 === O.equals(e) && (t1.scissor(e.x, e.y, e.z, e.w), O.copy(e));
        },
        viewport: function(e) {
            !1 === N.equals(e) && (t1.viewport(e.x, e.y, e.z, e.w), N.copy(e));
        },
        reset: function() {
            t1.disable(3042), t1.disable(2884), t1.disable(2929), t1.disable(32823), t1.disable(3089), t1.disable(2960), t1.disable(32926), t1.blendEquation(32774), t1.blendFunc(1, 0), t1.blendFuncSeparate(1, 0, 1, 0), t1.colorMask(!0, !0, !0, !0), t1.clearColor(0, 0, 0, 0), t1.depthMask(!0), t1.depthFunc(513), t1.clearDepth(1), t1.stencilMask(4294967295), t1.stencilFunc(519, 0, 4294967295), t1.stencilOp(7680, 7680, 7680), t1.clearStencil(0), t1.cullFace(1029), t1.frontFace(2305), t1.polygonOffset(0, 0), t1.activeTexture(33984), t1.bindFramebuffer(36160, null), !0 === i && (t1.bindFramebuffer(36009, null), t1.bindFramebuffer(36008, null)), t1.useProgram(null), t1.lineWidth(1), t1.scissor(0, 0, t1.canvas.width, t1.canvas.height), t1.viewport(0, 0, t1.canvas.width, t1.canvas.height), o = {}, L = null, P = {}, l = {}, h = new WeakMap, c = [], u = null, d = !1, p = null, m = null, f = null, g = null, v = null, y = null, x = null, b = !1, _ = null, w = null, M = null, S = null, T = null, O.set(0, 0, t1.canvas.width, t1.canvas.height), N.set(0, 0, t1.canvas.width, t1.canvas.height), r.reset(), s.reset(), a.reset();
        }
    };
}
function $fd4eb456bcbd06f8$var$Tr(t1, e, n, i, r, s, a) {
    const o = r.isWebGL2, l = r.maxTextures, h = r.maxCubemapSize, c = r.maxTextureSize, u = r.maxSamples, p = e.has("WEBGL_multisampled_render_to_texture") ? e.get("WEBGL_multisampled_render_to_texture") : null, f = /OculusBrowser/g.test(navigator.userAgent), g = new WeakMap;
    let v;
    const y = new WeakMap;
    let b = !1;
    try {
        b = "undefined" != typeof OffscreenCanvas && null !== new OffscreenCanvas(1, 1).getContext("2d");
    } catch (t1) {}
    function _(t1, e) {
        return b ? new OffscreenCanvas(t1, e) : $fd4eb456bcbd06f8$var$x("canvas");
    }
    function w(t1, e, n, i) {
        let r = 1;
        if ((t1.width > i || t1.height > i) && (r = i / Math.max(t1.width, t1.height)), r < 1 || !0 === e) {
            if ("undefined" != typeof HTMLImageElement && t1 instanceof HTMLImageElement || "undefined" != typeof HTMLCanvasElement && t1 instanceof HTMLCanvasElement || "undefined" != typeof ImageBitmap && t1 instanceof ImageBitmap) {
                const i = e ? $fd4eb456bcbd06f8$var$m : Math.floor, s = i(r * t1.width), a = i(r * t1.height);
                void 0 === v && (v = _(s, a));
                const o = n ? _(s, a) : v;
                o.width = s, o.height = a;
                return o.getContext("2d").drawImage(t1, 0, 0, s, a), console.warn("THREE.WebGLRenderer: Texture has been resized from (" + t1.width + "x" + t1.height + ") to (" + s + "x" + a + ")."), o;
            }
            return "data" in t1 && console.warn("THREE.WebGLRenderer: Image in DataTexture is too big (" + t1.width + "x" + t1.height + ")."), t1;
        }
        return t1;
    }
    function M(t1) {
        return $fd4eb456bcbd06f8$var$d(t1.width) && $fd4eb456bcbd06f8$var$d(t1.height);
    }
    function S(t1, e) {
        return t1.generateMipmaps && e && 1003 !== t1.minFilter && 1006 !== t1.minFilter;
    }
    function T(e) {
        t1.generateMipmap(e);
    }
    function E(n, i, r, s, a = !1) {
        if (!1 === o) return i;
        if (null !== n) {
            if (void 0 !== t1[n]) return t1[n];
            console.warn("THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format '" + n + "'");
        }
        let l = i;
        return 6403 === i && (5126 === r && (l = 33326), 5131 === r && (l = 33325), 5121 === r && (l = 33321)), 33319 === i && (5126 === r && (l = 33328), 5131 === r && (l = 33327), 5121 === r && (l = 33323)), 6408 === i && (5126 === r && (l = 34836), 5131 === r && (l = 34842), 5121 === r && (l = 3001 === s && !1 === a ? 35907 : 32856), 32819 === r && (l = 32854), 32820 === r && (l = 32855)), 33325 !== l && 33326 !== l && 33327 !== l && 33328 !== l && 34842 !== l && 34836 !== l || e.get("EXT_color_buffer_float"), l;
    }
    function A(t1, e, n) {
        return !0 === S(t1, n) || t1.isFramebufferTexture && 1003 !== t1.minFilter && 1006 !== t1.minFilter ? Math.log2(Math.max(e.width, e.height)) + 1 : void 0 !== t1.mipmaps && t1.mipmaps.length > 0 ? t1.mipmaps.length : t1.isCompressedTexture && Array.isArray(t1.image) ? e.mipmaps.length : 1;
    }
    function R(t1) {
        return 1003 === t1 || 1004 === t1 || 1005 === t1 ? 9728 : 9729;
    }
    function C(t1) {
        const e = t1.target;
        e.removeEventListener("dispose", C), function(t1) {
            const e = i.get(t1);
            if (void 0 === e.__webglInit) return;
            const n = t1.source, r = y.get(n);
            if (r) {
                const i = r[e.__cacheKey];
                i.usedTimes--, 0 === i.usedTimes && P(t1), 0 === Object.keys(r).length && y.delete(n);
            }
            i.remove(t1);
        }(e), e.isVideoTexture && g.delete(e);
    }
    function L(e) {
        const n = e.target;
        n.removeEventListener("dispose", L), function(e) {
            const n = e.texture, r = i.get(e), s = i.get(n);
            void 0 !== s.__webglTexture && (t1.deleteTexture(s.__webglTexture), a.memory.textures--);
            e.depthTexture && e.depthTexture.dispose();
            if (e.isWebGLCubeRenderTarget) for(let e = 0; e < 6; e++)t1.deleteFramebuffer(r.__webglFramebuffer[e]), r.__webglDepthbuffer && t1.deleteRenderbuffer(r.__webglDepthbuffer[e]);
            else t1.deleteFramebuffer(r.__webglFramebuffer), r.__webglDepthbuffer && t1.deleteRenderbuffer(r.__webglDepthbuffer), r.__webglMultisampledFramebuffer && t1.deleteFramebuffer(r.__webglMultisampledFramebuffer), r.__webglColorRenderbuffer && t1.deleteRenderbuffer(r.__webglColorRenderbuffer), r.__webglDepthRenderbuffer && t1.deleteRenderbuffer(r.__webglDepthRenderbuffer);
            if (e.isWebGLMultipleRenderTargets) for(let e = 0, r = n.length; e < r; e++){
                const r = i.get(n[e]);
                r.__webglTexture && (t1.deleteTexture(r.__webglTexture), a.memory.textures--), i.remove(n[e]);
            }
            i.remove(n), i.remove(e);
        }(n);
    }
    function P(e) {
        const n = i.get(e);
        t1.deleteTexture(n.__webglTexture);
        const r = e.source;
        delete y.get(r)[n.__cacheKey], a.memory.textures--;
    }
    let I = 0;
    function O(t1, e) {
        const r = i.get(t1);
        if (t1.isVideoTexture && function(t1) {
            const e = a.render.frame;
            g.get(t1) !== e && (g.set(t1, e), t1.update());
        }(t1), !1 === t1.isRenderTargetTexture && t1.version > 0 && r.__version !== t1.version) {
            const n = t1.image;
            if (null === n) console.warn("THREE.WebGLRenderer: Texture marked for update but no image data found.");
            else {
                if (!1 !== n.complete) return void B(r, t1, e);
                console.warn("THREE.WebGLRenderer: Texture marked for update but image is incomplete");
            }
        }
        n.activeTexture(33984 + e), n.bindTexture(3553, r.__webglTexture);
    }
    const N = {
        1e3: 10497,
        1001: 33071,
        1002: 33648
    }, F = {
        1003: 9728,
        1004: 9984,
        1005: 9986,
        1006: 9729,
        1007: 9985,
        1008: 9987
    };
    function U(n, s, a) {
        if (a ? (t1.texParameteri(n, 10242, N[s.wrapS]), t1.texParameteri(n, 10243, N[s.wrapT]), 32879 !== n && 35866 !== n || t1.texParameteri(n, 32882, N[s.wrapR]), t1.texParameteri(n, 10240, F[s.magFilter]), t1.texParameteri(n, 10241, F[s.minFilter])) : (t1.texParameteri(n, 10242, 33071), t1.texParameteri(n, 10243, 33071), 32879 !== n && 35866 !== n || t1.texParameteri(n, 32882, 33071), 1001 === s.wrapS && 1001 === s.wrapT || console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping."), t1.texParameteri(n, 10240, R(s.magFilter)), t1.texParameteri(n, 10241, R(s.minFilter)), 1003 !== s.minFilter && 1006 !== s.minFilter && console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.")), !0 === e.has("EXT_texture_filter_anisotropic")) {
            const a = e.get("EXT_texture_filter_anisotropic");
            if (1015 === s.type && !1 === e.has("OES_texture_float_linear")) return;
            if (!1 === o && 1016 === s.type && !1 === e.has("OES_texture_half_float_linear")) return;
            (s.anisotropy > 1 || i.get(s).__currentAnisotropy) && (t1.texParameterf(n, a.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(s.anisotropy, r.getMaxAnisotropy())), i.get(s).__currentAnisotropy = s.anisotropy);
        }
    }
    function k(e, n) {
        let i = !1;
        void 0 === e.__webglInit && (e.__webglInit = !0, n.addEventListener("dispose", C));
        const r = n.source;
        let s = y.get(r);
        void 0 === s && (s = {}, y.set(r, s));
        const o = function(t1) {
            const e = [];
            return e.push(t1.wrapS), e.push(t1.wrapT), e.push(t1.magFilter), e.push(t1.minFilter), e.push(t1.anisotropy), e.push(t1.internalFormat), e.push(t1.format), e.push(t1.type), e.push(t1.generateMipmaps), e.push(t1.premultiplyAlpha), e.push(t1.flipY), e.push(t1.unpackAlignment), e.push(t1.encoding), e.join();
        }(n);
        if (o !== e.__cacheKey) {
            void 0 === s[o] && (s[o] = {
                texture: t1.createTexture(),
                usedTimes: 0
            }, a.memory.textures++, i = !0), s[o].usedTimes++;
            const r = s[e.__cacheKey];
            void 0 !== r && (s[e.__cacheKey].usedTimes--, 0 === r.usedTimes && P(n)), e.__cacheKey = o, e.__webglTexture = s[o].texture;
        }
        return i;
    }
    function B(e, i, r) {
        let a = 3553;
        i.isDataArrayTexture && (a = 35866), i.isData3DTexture && (a = 32879);
        const l = k(e, i), h = i.source;
        if (n.activeTexture(33984 + r), n.bindTexture(a, e.__webglTexture), h.version !== h.__currentVersion || !0 === l) {
            t1.pixelStorei(37440, i.flipY), t1.pixelStorei(37441, i.premultiplyAlpha), t1.pixelStorei(3317, i.unpackAlignment), t1.pixelStorei(37443, 0);
            const r = function(t1) {
                return !o && (1001 !== t1.wrapS || 1001 !== t1.wrapT || 1003 !== t1.minFilter && 1006 !== t1.minFilter);
            }(i) && !1 === M(i.image);
            let l = w(i.image, r, !1, c);
            l = j(i, l);
            const u = M(l) || o, d = s.convert(i.format, i.encoding);
            let p, m = s.convert(i.type), f = E(i.internalFormat, d, m, i.encoding, i.isVideoTexture);
            U(a, i, u);
            const g = i.mipmaps, v = o && !0 !== i.isVideoTexture, y = void 0 === e.__version, x = A(i, l, u);
            if (i.isDepthTexture) f = 6402, o ? f = 1015 === i.type ? 36012 : 1014 === i.type ? 33190 : 1020 === i.type ? 35056 : 33189 : 1015 === i.type && console.error("WebGLRenderer: Floating point depth texture requires WebGL2."), 1026 === i.format && 6402 === f && 1012 !== i.type && 1014 !== i.type && (console.warn("THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture."), i.type = 1012, m = s.convert(i.type)), 1027 === i.format && 6402 === f && (f = 34041, 1020 !== i.type && (console.warn("THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture."), i.type = 1020, m = s.convert(i.type))), v && y ? n.texStorage2D(3553, 1, f, l.width, l.height) : n.texImage2D(3553, 0, f, l.width, l.height, 0, d, m, null);
            else if (i.isDataTexture) {
                if (g.length > 0 && u) {
                    v && y && n.texStorage2D(3553, x, f, g[0].width, g[0].height);
                    for(let t1 = 0, e = g.length; t1 < e; t1++)p = g[t1], v ? n.texSubImage2D(3553, t1, 0, 0, p.width, p.height, d, m, p.data) : n.texImage2D(3553, t1, f, p.width, p.height, 0, d, m, p.data);
                    i.generateMipmaps = !1;
                } else v ? (y && n.texStorage2D(3553, x, f, l.width, l.height), n.texSubImage2D(3553, 0, 0, 0, l.width, l.height, d, m, l.data)) : n.texImage2D(3553, 0, f, l.width, l.height, 0, d, m, l.data);
            } else if (i.isCompressedTexture) {
                v && y && n.texStorage2D(3553, x, f, g[0].width, g[0].height);
                for(let t1 = 0, e = g.length; t1 < e; t1++)p = g[t1], 1023 !== i.format ? null !== d ? v ? n.compressedTexSubImage2D(3553, t1, 0, 0, p.width, p.height, d, p.data) : n.compressedTexImage2D(3553, t1, f, p.width, p.height, 0, p.data) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()") : v ? n.texSubImage2D(3553, t1, 0, 0, p.width, p.height, d, m, p.data) : n.texImage2D(3553, t1, f, p.width, p.height, 0, d, m, p.data);
            } else if (i.isDataArrayTexture) v ? (y && n.texStorage3D(35866, x, f, l.width, l.height, l.depth), n.texSubImage3D(35866, 0, 0, 0, 0, l.width, l.height, l.depth, d, m, l.data)) : n.texImage3D(35866, 0, f, l.width, l.height, l.depth, 0, d, m, l.data);
            else if (i.isData3DTexture) v ? (y && n.texStorage3D(32879, x, f, l.width, l.height, l.depth), n.texSubImage3D(32879, 0, 0, 0, 0, l.width, l.height, l.depth, d, m, l.data)) : n.texImage3D(32879, 0, f, l.width, l.height, l.depth, 0, d, m, l.data);
            else if (i.isFramebufferTexture) v && y ? n.texStorage2D(3553, x, f, l.width, l.height) : n.texImage2D(3553, 0, f, l.width, l.height, 0, d, m, null);
            else if (g.length > 0 && u) {
                v && y && n.texStorage2D(3553, x, f, g[0].width, g[0].height);
                for(let t1 = 0, e = g.length; t1 < e; t1++)p = g[t1], v ? n.texSubImage2D(3553, t1, 0, 0, d, m, p) : n.texImage2D(3553, t1, f, d, m, p);
                i.generateMipmaps = !1;
            } else v ? (y && n.texStorage2D(3553, x, f, l.width, l.height), n.texSubImage2D(3553, 0, 0, 0, d, m, l)) : n.texImage2D(3553, 0, f, d, m, l);
            S(i, u) && T(a), h.__currentVersion = h.version, i.onUpdate && i.onUpdate(i);
        }
        e.__version = i.version;
    }
    function z(e, r, a, o, l) {
        const h = s.convert(a.format, a.encoding), c = s.convert(a.type), u = E(a.internalFormat, h, c, a.encoding);
        i.get(r).__hasExternalTextures || (32879 === l || 35866 === l ? n.texImage3D(l, 0, u, r.width, r.height, r.depth, 0, h, c, null) : n.texImage2D(l, 0, u, r.width, r.height, 0, h, c, null)), n.bindFramebuffer(36160, e), W(r) ? p.framebufferTexture2DMultisampleEXT(36160, o, l, i.get(a).__webglTexture, 0, G(r)) : t1.framebufferTexture2D(36160, o, l, i.get(a).__webglTexture, 0), n.bindFramebuffer(36160, null);
    }
    function H(e, n, i) {
        if (t1.bindRenderbuffer(36161, e), n.depthBuffer && !n.stencilBuffer) {
            let r = 33189;
            if (i || W(n)) {
                const e = n.depthTexture;
                e && e.isDepthTexture && (1015 === e.type ? r = 36012 : 1014 === e.type && (r = 33190));
                const i = G(n);
                W(n) ? p.renderbufferStorageMultisampleEXT(36161, i, r, n.width, n.height) : t1.renderbufferStorageMultisample(36161, i, r, n.width, n.height);
            } else t1.renderbufferStorage(36161, r, n.width, n.height);
            t1.framebufferRenderbuffer(36160, 36096, 36161, e);
        } else if (n.depthBuffer && n.stencilBuffer) {
            const r = G(n);
            i && !1 === W(n) ? t1.renderbufferStorageMultisample(36161, r, 35056, n.width, n.height) : W(n) ? p.renderbufferStorageMultisampleEXT(36161, r, 35056, n.width, n.height) : t1.renderbufferStorage(36161, 34041, n.width, n.height), t1.framebufferRenderbuffer(36160, 33306, 36161, e);
        } else {
            const e = !0 === n.isWebGLMultipleRenderTargets ? n.texture[0] : n.texture, r = s.convert(e.format, e.encoding), a = s.convert(e.type), o = E(e.internalFormat, r, a, e.encoding), l = G(n);
            i && !1 === W(n) ? t1.renderbufferStorageMultisample(36161, l, o, n.width, n.height) : W(n) ? p.renderbufferStorageMultisampleEXT(36161, l, o, n.width, n.height) : t1.renderbufferStorage(36161, o, n.width, n.height);
        }
        t1.bindRenderbuffer(36161, null);
    }
    function V(e) {
        const r = i.get(e), s = !0 === e.isWebGLCubeRenderTarget;
        if (e.depthTexture && !r.__autoAllocateDepthBuffer) {
            if (s) throw new Error("target.depthTexture not supported in Cube render targets");
            !function(e, r) {
                if (r && r.isWebGLCubeRenderTarget) throw new Error("Depth Texture with cube render targets is not supported");
                if (n.bindFramebuffer(36160, e), !r.depthTexture || !r.depthTexture.isDepthTexture) throw new Error("renderTarget.depthTexture must be an instance of THREE.DepthTexture");
                i.get(r.depthTexture).__webglTexture && r.depthTexture.image.width === r.width && r.depthTexture.image.height === r.height || (r.depthTexture.image.width = r.width, r.depthTexture.image.height = r.height, r.depthTexture.needsUpdate = !0), O(r.depthTexture, 0);
                const s = i.get(r.depthTexture).__webglTexture, a = G(r);
                if (1026 === r.depthTexture.format) W(r) ? p.framebufferTexture2DMultisampleEXT(36160, 36096, 3553, s, 0, a) : t1.framebufferTexture2D(36160, 36096, 3553, s, 0);
                else {
                    if (1027 !== r.depthTexture.format) throw new Error("Unknown depthTexture format");
                    W(r) ? p.framebufferTexture2DMultisampleEXT(36160, 33306, 3553, s, 0, a) : t1.framebufferTexture2D(36160, 33306, 3553, s, 0);
                }
            }(r.__webglFramebuffer, e);
        } else if (s) {
            r.__webglDepthbuffer = [];
            for(let i = 0; i < 6; i++)n.bindFramebuffer(36160, r.__webglFramebuffer[i]), r.__webglDepthbuffer[i] = t1.createRenderbuffer(), H(r.__webglDepthbuffer[i], e, !1);
        } else n.bindFramebuffer(36160, r.__webglFramebuffer), r.__webglDepthbuffer = t1.createRenderbuffer(), H(r.__webglDepthbuffer, e, !1);
        n.bindFramebuffer(36160, null);
    }
    function G(t1) {
        return Math.min(u, t1.samples);
    }
    function W(t1) {
        const n = i.get(t1);
        return o && t1.samples > 0 && !0 === e.has("WEBGL_multisampled_render_to_texture") && !1 !== n.__useRenderToTexture;
    }
    function j(t1, n) {
        const i = t1.encoding, r = t1.format, s = t1.type;
        return !0 === t1.isCompressedTexture || !0 === t1.isVideoTexture || 1035 === t1.format || 3e3 !== i && (3001 === i ? !1 === o ? !0 === e.has("EXT_sRGB") && 1023 === r ? (t1.format = 1035, t1.minFilter = 1006, t1.generateMipmaps = !1) : n = $fd4eb456bcbd06f8$var$D.sRGBToLinear(n) : 1023 === r && 1009 === s || console.warn("THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.") : console.error("THREE.WebGLTextures: Unsupported texture encoding:", i)), n;
    }
    this.allocateTextureUnit = function() {
        const t1 = I;
        return t1 >= l && console.warn("THREE.WebGLTextures: Trying to use " + t1 + " texture units while this GPU supports only " + l), I += 1, t1;
    }, this.resetTextureUnits = function() {
        I = 0;
    }, this.setTexture2D = O, this.setTexture2DArray = function(t1, e) {
        const r = i.get(t1);
        t1.version > 0 && r.__version !== t1.version ? B(r, t1, e) : (n.activeTexture(33984 + e), n.bindTexture(35866, r.__webglTexture));
    }, this.setTexture3D = function(t1, e) {
        const r = i.get(t1);
        t1.version > 0 && r.__version !== t1.version ? B(r, t1, e) : (n.activeTexture(33984 + e), n.bindTexture(32879, r.__webglTexture));
    }, this.setTextureCube = function(e, r) {
        const a = i.get(e);
        e.version > 0 && a.__version !== e.version ? function(e, i, r) {
            if (6 !== i.image.length) return;
            const a = k(e, i), l = i.source;
            if (n.activeTexture(33984 + r), n.bindTexture(34067, e.__webglTexture), l.version !== l.__currentVersion || !0 === a) {
                t1.pixelStorei(37440, i.flipY), t1.pixelStorei(37441, i.premultiplyAlpha), t1.pixelStorei(3317, i.unpackAlignment), t1.pixelStorei(37443, 0);
                const r = i.isCompressedTexture || i.image[0].isCompressedTexture, a = i.image[0] && i.image[0].isDataTexture, c = [];
                for(let t1 = 0; t1 < 6; t1++)c[t1] = r || a ? a ? i.image[t1].image : i.image[t1] : w(i.image[t1], !1, !0, h), c[t1] = j(i, c[t1]);
                const u = c[0], d = M(u) || o, p = s.convert(i.format, i.encoding), m = s.convert(i.type), f = E(i.internalFormat, p, m, i.encoding), g = o && !0 !== i.isVideoTexture, v = void 0 === e.__version;
                let y, x = A(i, u, d);
                if (U(34067, i, d), r) {
                    g && v && n.texStorage2D(34067, x, f, u.width, u.height);
                    for(let t1 = 0; t1 < 6; t1++){
                        y = c[t1].mipmaps;
                        for(let e = 0; e < y.length; e++){
                            const r = y[e];
                            1023 !== i.format ? null !== p ? g ? n.compressedTexSubImage2D(34069 + t1, e, 0, 0, r.width, r.height, p, r.data) : n.compressedTexImage2D(34069 + t1, e, f, r.width, r.height, 0, r.data) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()") : g ? n.texSubImage2D(34069 + t1, e, 0, 0, r.width, r.height, p, m, r.data) : n.texImage2D(34069 + t1, e, f, r.width, r.height, 0, p, m, r.data);
                        }
                    }
                } else {
                    y = i.mipmaps, g && v && (y.length > 0 && x++, n.texStorage2D(34067, x, f, c[0].width, c[0].height));
                    for(let t1 = 0; t1 < 6; t1++)if (a) {
                        g ? n.texSubImage2D(34069 + t1, 0, 0, 0, c[t1].width, c[t1].height, p, m, c[t1].data) : n.texImage2D(34069 + t1, 0, f, c[t1].width, c[t1].height, 0, p, m, c[t1].data);
                        for(let e = 0; e < y.length; e++){
                            const i = y[e].image[t1].image;
                            g ? n.texSubImage2D(34069 + t1, e + 1, 0, 0, i.width, i.height, p, m, i.data) : n.texImage2D(34069 + t1, e + 1, f, i.width, i.height, 0, p, m, i.data);
                        }
                    } else {
                        g ? n.texSubImage2D(34069 + t1, 0, 0, 0, p, m, c[t1]) : n.texImage2D(34069 + t1, 0, f, p, m, c[t1]);
                        for(let e = 0; e < y.length; e++){
                            const i = y[e];
                            g ? n.texSubImage2D(34069 + t1, e + 1, 0, 0, p, m, i.image[t1]) : n.texImage2D(34069 + t1, e + 1, f, p, m, i.image[t1]);
                        }
                    }
                }
                S(i, d) && T(34067), l.__currentVersion = l.version, i.onUpdate && i.onUpdate(i);
            }
            e.__version = i.version;
        }(a, e, r) : (n.activeTexture(33984 + r), n.bindTexture(34067, a.__webglTexture));
    }, this.rebindTextures = function(t1, e, n) {
        const r = i.get(t1);
        void 0 !== e && z(r.__webglFramebuffer, t1, t1.texture, 36064, 3553), void 0 !== n && V(t1);
    }, this.setupRenderTarget = function(e) {
        const l = e.texture, h = i.get(e), c = i.get(l);
        e.addEventListener("dispose", L), !0 !== e.isWebGLMultipleRenderTargets && (void 0 === c.__webglTexture && (c.__webglTexture = t1.createTexture()), c.__version = l.version, a.memory.textures++);
        const u = !0 === e.isWebGLCubeRenderTarget, d = !0 === e.isWebGLMultipleRenderTargets, p = M(e) || o;
        if (u) {
            h.__webglFramebuffer = [];
            for(let e = 0; e < 6; e++)h.__webglFramebuffer[e] = t1.createFramebuffer();
        } else if (h.__webglFramebuffer = t1.createFramebuffer(), d) {
            if (r.drawBuffers) {
                const n = e.texture;
                for(let e = 0, r = n.length; e < r; e++){
                    const r = i.get(n[e]);
                    void 0 === r.__webglTexture && (r.__webglTexture = t1.createTexture(), a.memory.textures++);
                }
            } else console.warn("THREE.WebGLRenderer: WebGLMultipleRenderTargets can only be used with WebGL2 or WEBGL_draw_buffers extension.");
        } else if (o && e.samples > 0 && !1 === W(e)) {
            h.__webglMultisampledFramebuffer = t1.createFramebuffer(), h.__webglColorRenderbuffer = t1.createRenderbuffer(), t1.bindRenderbuffer(36161, h.__webglColorRenderbuffer);
            const i = s.convert(l.format, l.encoding), r = s.convert(l.type), a = E(l.internalFormat, i, r, l.encoding), o = G(e);
            t1.renderbufferStorageMultisample(36161, o, a, e.width, e.height), n.bindFramebuffer(36160, h.__webglMultisampledFramebuffer), t1.framebufferRenderbuffer(36160, 36064, 36161, h.__webglColorRenderbuffer), t1.bindRenderbuffer(36161, null), e.depthBuffer && (h.__webglDepthRenderbuffer = t1.createRenderbuffer(), H(h.__webglDepthRenderbuffer, e, !0)), n.bindFramebuffer(36160, null);
        }
        if (u) {
            n.bindTexture(34067, c.__webglTexture), U(34067, l, p);
            for(let t1 = 0; t1 < 6; t1++)z(h.__webglFramebuffer[t1], e, l, 36064, 34069 + t1);
            S(l, p) && T(34067), n.unbindTexture();
        } else if (d) {
            const t1 = e.texture;
            for(let r = 0, s = t1.length; r < s; r++){
                const s = t1[r], a = i.get(s);
                n.bindTexture(3553, a.__webglTexture), U(3553, s, p), z(h.__webglFramebuffer, e, s, 36064 + r, 3553), S(s, p) && T(3553);
            }
            n.unbindTexture();
        } else {
            let t1 = 3553;
            (e.isWebGL3DRenderTarget || e.isWebGLArrayRenderTarget) && (o ? t1 = e.isWebGL3DRenderTarget ? 32879 : 35866 : console.error("THREE.WebGLTextures: THREE.Data3DTexture and THREE.DataArrayTexture only supported with WebGL2.")), n.bindTexture(t1, c.__webglTexture), U(t1, l, p), z(h.__webglFramebuffer, e, l, 36064, t1), S(l, p) && T(t1), n.unbindTexture();
        }
        e.depthBuffer && V(e);
    }, this.updateRenderTargetMipmap = function(t1) {
        const e = M(t1) || o, r = !0 === t1.isWebGLMultipleRenderTargets ? t1.texture : [
            t1.texture
        ];
        for(let s = 0, a = r.length; s < a; s++){
            const a = r[s];
            if (S(a, e)) {
                const e = t1.isWebGLCubeRenderTarget ? 34067 : 3553, r = i.get(a).__webglTexture;
                n.bindTexture(e, r), T(e), n.unbindTexture();
            }
        }
    }, this.updateMultisampleRenderTarget = function(e) {
        if (o && e.samples > 0 && !1 === W(e)) {
            const r = e.width, s = e.height;
            let a = 16384;
            const o = [
                36064
            ], l = e.stencilBuffer ? 33306 : 36096;
            e.depthBuffer && o.push(l);
            const h = i.get(e), c = void 0 !== h.__ignoreDepthValues && h.__ignoreDepthValues;
            !1 === c && (e.depthBuffer && (a |= 256), e.stencilBuffer && (a |= 1024)), n.bindFramebuffer(36008, h.__webglMultisampledFramebuffer), n.bindFramebuffer(36009, h.__webglFramebuffer), !0 === c && (t1.invalidateFramebuffer(36008, [
                l
            ]), t1.invalidateFramebuffer(36009, [
                l
            ])), t1.blitFramebuffer(0, 0, r, s, 0, 0, r, s, a, 9728), f && t1.invalidateFramebuffer(36008, o), n.bindFramebuffer(36008, null), n.bindFramebuffer(36009, h.__webglMultisampledFramebuffer);
        }
    }, this.setupDepthRenderbuffer = V, this.setupFrameBufferTexture = z, this.useMultisampledRTT = W;
}
function $fd4eb456bcbd06f8$var$Er(t1, e, n) {
    const i = n.isWebGL2;
    return {
        convert: function(t1, n = null) {
            let r;
            if (1009 === t1) return 5121;
            if (1017 === t1) return 32819;
            if (1018 === t1) return 32820;
            if (1010 === t1) return 5120;
            if (1011 === t1) return 5122;
            if (1012 === t1) return 5123;
            if (1013 === t1) return 5124;
            if (1014 === t1) return 5125;
            if (1015 === t1) return 5126;
            if (1016 === t1) return i ? 5131 : (r = e.get("OES_texture_half_float"), null !== r ? r.HALF_FLOAT_OES : null);
            if (1021 === t1) return 6406;
            if (1023 === t1) return 6408;
            if (1024 === t1) return 6409;
            if (1025 === t1) return 6410;
            if (1026 === t1) return 6402;
            if (1027 === t1) return 34041;
            if (1028 === t1) return 6403;
            if (1022 === t1) return console.warn("THREE.WebGLRenderer: THREE.RGBFormat has been removed. Use THREE.RGBAFormat instead. https://github.com/mrdoob/three.js/pull/23228"), 6408;
            if (1035 === t1) return r = e.get("EXT_sRGB"), null !== r ? r.SRGB_ALPHA_EXT : null;
            if (1029 === t1) return 36244;
            if (1030 === t1) return 33319;
            if (1031 === t1) return 33320;
            if (1033 === t1) return 36249;
            if (33776 === t1 || 33777 === t1 || 33778 === t1 || 33779 === t1) {
                if (3001 === n) {
                    if (r = e.get("WEBGL_compressed_texture_s3tc_srgb"), null === r) return null;
                    if (33776 === t1) return r.COMPRESSED_SRGB_S3TC_DXT1_EXT;
                    if (33777 === t1) return r.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
                    if (33778 === t1) return r.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
                    if (33779 === t1) return r.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
                } else {
                    if (r = e.get("WEBGL_compressed_texture_s3tc"), null === r) return null;
                    if (33776 === t1) return r.COMPRESSED_RGB_S3TC_DXT1_EXT;
                    if (33777 === t1) return r.COMPRESSED_RGBA_S3TC_DXT1_EXT;
                    if (33778 === t1) return r.COMPRESSED_RGBA_S3TC_DXT3_EXT;
                    if (33779 === t1) return r.COMPRESSED_RGBA_S3TC_DXT5_EXT;
                }
            }
            if (35840 === t1 || 35841 === t1 || 35842 === t1 || 35843 === t1) {
                if (r = e.get("WEBGL_compressed_texture_pvrtc"), null === r) return null;
                if (35840 === t1) return r.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
                if (35841 === t1) return r.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
                if (35842 === t1) return r.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
                if (35843 === t1) return r.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
            }
            if (36196 === t1) return r = e.get("WEBGL_compressed_texture_etc1"), null !== r ? r.COMPRESSED_RGB_ETC1_WEBGL : null;
            if (37492 === t1 || 37496 === t1) {
                if (r = e.get("WEBGL_compressed_texture_etc"), null === r) return null;
                if (37492 === t1) return 3001 === n ? r.COMPRESSED_SRGB8_ETC2 : r.COMPRESSED_RGB8_ETC2;
                if (37496 === t1) return 3001 === n ? r.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : r.COMPRESSED_RGBA8_ETC2_EAC;
            }
            if (37808 === t1 || 37809 === t1 || 37810 === t1 || 37811 === t1 || 37812 === t1 || 37813 === t1 || 37814 === t1 || 37815 === t1 || 37816 === t1 || 37817 === t1 || 37818 === t1 || 37819 === t1 || 37820 === t1 || 37821 === t1) {
                if (r = e.get("WEBGL_compressed_texture_astc"), null === r) return null;
                if (37808 === t1) return 3001 === n ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : r.COMPRESSED_RGBA_ASTC_4x4_KHR;
                if (37809 === t1) return 3001 === n ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : r.COMPRESSED_RGBA_ASTC_5x4_KHR;
                if (37810 === t1) return 3001 === n ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : r.COMPRESSED_RGBA_ASTC_5x5_KHR;
                if (37811 === t1) return 3001 === n ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : r.COMPRESSED_RGBA_ASTC_6x5_KHR;
                if (37812 === t1) return 3001 === n ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : r.COMPRESSED_RGBA_ASTC_6x6_KHR;
                if (37813 === t1) return 3001 === n ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : r.COMPRESSED_RGBA_ASTC_8x5_KHR;
                if (37814 === t1) return 3001 === n ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : r.COMPRESSED_RGBA_ASTC_8x6_KHR;
                if (37815 === t1) return 3001 === n ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : r.COMPRESSED_RGBA_ASTC_8x8_KHR;
                if (37816 === t1) return 3001 === n ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : r.COMPRESSED_RGBA_ASTC_10x5_KHR;
                if (37817 === t1) return 3001 === n ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : r.COMPRESSED_RGBA_ASTC_10x6_KHR;
                if (37818 === t1) return 3001 === n ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : r.COMPRESSED_RGBA_ASTC_10x8_KHR;
                if (37819 === t1) return 3001 === n ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : r.COMPRESSED_RGBA_ASTC_10x10_KHR;
                if (37820 === t1) return 3001 === n ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : r.COMPRESSED_RGBA_ASTC_12x10_KHR;
                if (37821 === t1) return 3001 === n ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : r.COMPRESSED_RGBA_ASTC_12x12_KHR;
            }
            if (36492 === t1) {
                if (r = e.get("EXT_texture_compression_bptc"), null === r) return null;
                if (36492 === t1) return 3001 === n ? r.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : r.COMPRESSED_RGBA_BPTC_UNORM_EXT;
            }
            return 1020 === t1 ? i ? 34042 : (r = e.get("WEBGL_depth_texture"), null !== r ? r.UNSIGNED_INT_24_8_WEBGL : null) : void 0;
        }
    };
}
class $fd4eb456bcbd06f8$var$Ar extends $fd4eb456bcbd06f8$var$We {
    constructor(t1 = []){
        super(), this.cameras = t1;
    }
}
$fd4eb456bcbd06f8$var$Ar.prototype.isArrayCamera = !0;
class $fd4eb456bcbd06f8$var$Rr extends $fd4eb456bcbd06f8$var$Wt {
    constructor(){
        super(), this.type = "Group";
    }
}
$fd4eb456bcbd06f8$var$Rr.prototype.isGroup = !0;
const $fd4eb456bcbd06f8$var$Cr = {
    type: "move"
};
class $fd4eb456bcbd06f8$var$Lr {
    constructor(){
        this._targetRay = null, this._grip = null, this._hand = null;
    }
    getHandSpace() {
        return null === this._hand && (this._hand = new $fd4eb456bcbd06f8$var$Rr, this._hand.matrixAutoUpdate = !1, this._hand.visible = !1, this._hand.joints = {}, this._hand.inputState = {
            pinching: !1
        }), this._hand;
    }
    getTargetRaySpace() {
        return null === this._targetRay && (this._targetRay = new $fd4eb456bcbd06f8$var$Rr, this._targetRay.matrixAutoUpdate = !1, this._targetRay.visible = !1, this._targetRay.hasLinearVelocity = !1, this._targetRay.linearVelocity = new $fd4eb456bcbd06f8$var$V, this._targetRay.hasAngularVelocity = !1, this._targetRay.angularVelocity = new $fd4eb456bcbd06f8$var$V), this._targetRay;
    }
    getGripSpace() {
        return null === this._grip && (this._grip = new $fd4eb456bcbd06f8$var$Rr, this._grip.matrixAutoUpdate = !1, this._grip.visible = !1, this._grip.hasLinearVelocity = !1, this._grip.linearVelocity = new $fd4eb456bcbd06f8$var$V, this._grip.hasAngularVelocity = !1, this._grip.angularVelocity = new $fd4eb456bcbd06f8$var$V), this._grip;
    }
    dispatchEvent(t1) {
        return null !== this._targetRay && this._targetRay.dispatchEvent(t1), null !== this._grip && this._grip.dispatchEvent(t1), null !== this._hand && this._hand.dispatchEvent(t1), this;
    }
    disconnect(t1) {
        return this.dispatchEvent({
            type: "disconnected",
            data: t1
        }), null !== this._targetRay && (this._targetRay.visible = !1), null !== this._grip && (this._grip.visible = !1), null !== this._hand && (this._hand.visible = !1), this;
    }
    update(t1, e, n) {
        let i = null, r = null, s = null;
        const a = this._targetRay, o = this._grip, l = this._hand;
        if (t1 && "visible-blurred" !== e.session.visibilityState) {
            if (null !== a && (i = e.getPose(t1.targetRaySpace, n), null !== i && (a.matrix.fromArray(i.transform.matrix), a.matrix.decompose(a.position, a.rotation, a.scale), i.linearVelocity ? (a.hasLinearVelocity = !0, a.linearVelocity.copy(i.linearVelocity)) : a.hasLinearVelocity = !1, i.angularVelocity ? (a.hasAngularVelocity = !0, a.angularVelocity.copy(i.angularVelocity)) : a.hasAngularVelocity = !1, this.dispatchEvent($fd4eb456bcbd06f8$var$Cr))), l && t1.hand) {
                s = !0;
                for (const i of t1.hand.values()){
                    const t1 = e.getJointPose(i, n);
                    if (void 0 === l.joints[i.jointName]) {
                        const t1 = new $fd4eb456bcbd06f8$var$Rr;
                        t1.matrixAutoUpdate = !1, t1.visible = !1, l.joints[i.jointName] = t1, l.add(t1);
                    }
                    const r = l.joints[i.jointName];
                    null !== t1 && (r.matrix.fromArray(t1.transform.matrix), r.matrix.decompose(r.position, r.rotation, r.scale), r.jointRadius = t1.radius), r.visible = null !== t1;
                }
                const i = l.joints["index-finger-tip"], r = l.joints["thumb-tip"], a = i.position.distanceTo(r.position), o = .02, h = .005;
                l.inputState.pinching && a > o + h ? (l.inputState.pinching = !1, this.dispatchEvent({
                    type: "pinchend",
                    handedness: t1.handedness,
                    target: this
                })) : !l.inputState.pinching && a <= o - h && (l.inputState.pinching = !0, this.dispatchEvent({
                    type: "pinchstart",
                    handedness: t1.handedness,
                    target: this
                }));
            } else null !== o && t1.gripSpace && (r = e.getPose(t1.gripSpace, n), null !== r && (o.matrix.fromArray(r.transform.matrix), o.matrix.decompose(o.position, o.rotation, o.scale), r.linearVelocity ? (o.hasLinearVelocity = !0, o.linearVelocity.copy(r.linearVelocity)) : o.hasLinearVelocity = !1, r.angularVelocity ? (o.hasAngularVelocity = !0, o.angularVelocity.copy(r.angularVelocity)) : o.hasAngularVelocity = !1));
        }
        return null !== a && (a.visible = null !== i), null !== o && (o.visible = null !== r), null !== l && (l.visible = null !== s), this;
    }
}
class $fd4eb456bcbd06f8$var$Pr extends $fd4eb456bcbd06f8$var$F {
    constructor(t1, e, n, i, r, s, a, o, l, h){
        if (1026 !== (h = void 0 !== h ? h : 1026) && 1027 !== h) throw new Error("DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
        void 0 === n && 1026 === h && (n = 1012), void 0 === n && 1027 === h && (n = 1020), super(null, i, r, s, a, o, h, n, l), this.image = {
            width: t1,
            height: e
        }, this.magFilter = void 0 !== a ? a : 1003, this.minFilter = void 0 !== o ? o : 1003, this.flipY = !1, this.generateMipmaps = !1;
    }
}
$fd4eb456bcbd06f8$var$Pr.prototype.isDepthTexture = !0;
class $fd4eb456bcbd06f8$var$Dr extends $fd4eb456bcbd06f8$var$i {
    constructor(t1, e){
        super();
        const n = this;
        let i = null, r = 1, s = null, a = "local-floor", o = null, l = null, h = null, c = null, u = null;
        const d = e.getContextAttributes();
        let p = null, m = null;
        const f = [], g = new Map, v = new $fd4eb456bcbd06f8$var$We;
        v.layers.enable(1), v.viewport = new $fd4eb456bcbd06f8$var$U;
        const y = new $fd4eb456bcbd06f8$var$We;
        y.layers.enable(2), y.viewport = new $fd4eb456bcbd06f8$var$U;
        const x = [
            v,
            y
        ], b = new $fd4eb456bcbd06f8$var$Ar;
        b.layers.enable(1), b.layers.enable(2);
        let _ = null, w = null;
        function M(t1) {
            const e = g.get(t1.inputSource);
            e && e.dispatchEvent({
                type: t1.type,
                data: t1.inputSource
            });
        }
        function S() {
            g.forEach(function(t1, e) {
                t1.disconnect(e);
            }), g.clear(), _ = null, w = null, t1.setRenderTarget(p), c = null, h = null, l = null, i = null, m = null, L.stop(), n.isPresenting = !1, n.dispatchEvent({
                type: "sessionend"
            });
        }
        function T(t1) {
            const e = i.inputSources;
            for(let t1 = 0; t1 < f.length; t1++)g.set(e[t1], f[t1]);
            for(let e = 0; e < t1.removed.length; e++){
                const n = t1.removed[e], i = g.get(n);
                i && (i.dispatchEvent({
                    type: "disconnected",
                    data: n
                }), g.delete(n));
            }
            for(let e = 0; e < t1.added.length; e++){
                const n = t1.added[e], i = g.get(n);
                i && i.dispatchEvent({
                    type: "connected",
                    data: n
                });
            }
        }
        this.cameraAutoUpdate = !0, this.enabled = !1, this.isPresenting = !1, this.getController = function(t1) {
            let e = f[t1];
            return void 0 === e && (e = new $fd4eb456bcbd06f8$var$Lr, f[t1] = e), e.getTargetRaySpace();
        }, this.getControllerGrip = function(t1) {
            let e = f[t1];
            return void 0 === e && (e = new $fd4eb456bcbd06f8$var$Lr, f[t1] = e), e.getGripSpace();
        }, this.getHand = function(t1) {
            let e = f[t1];
            return void 0 === e && (e = new $fd4eb456bcbd06f8$var$Lr, f[t1] = e), e.getHandSpace();
        }, this.setFramebufferScaleFactor = function(t1) {
            r = t1, !0 === n.isPresenting && console.warn("THREE.WebXRManager: Cannot change framebuffer scale while presenting.");
        }, this.setReferenceSpaceType = function(t1) {
            a = t1, !0 === n.isPresenting && console.warn("THREE.WebXRManager: Cannot change reference space type while presenting.");
        }, this.getReferenceSpace = function() {
            return s;
        }, this.getBaseLayer = function() {
            return null !== h ? h : c;
        }, this.getBinding = function() {
            return l;
        }, this.getFrame = function() {
            return u;
        }, this.getSession = function() {
            return i;
        }, this.setSession = async function(o) {
            if (i = o, null !== i) {
                if (p = t1.getRenderTarget(), i.addEventListener("select", M), i.addEventListener("selectstart", M), i.addEventListener("selectend", M), i.addEventListener("squeeze", M), i.addEventListener("squeezestart", M), i.addEventListener("squeezeend", M), i.addEventListener("end", S), i.addEventListener("inputsourceschange", T), !0 !== d.xrCompatible && await e.makeXRCompatible(), void 0 === i.renderState.layers || !1 === t1.capabilities.isWebGL2) {
                    const n = {
                        antialias: void 0 !== i.renderState.layers || d.antialias,
                        alpha: d.alpha,
                        depth: d.depth,
                        stencil: d.stencil,
                        framebufferScaleFactor: r
                    };
                    c = new XRWebGLLayer(i, e, n), i.updateRenderState({
                        baseLayer: c
                    }), m = new $fd4eb456bcbd06f8$var$k(c.framebufferWidth, c.framebufferHeight, {
                        format: 1023,
                        type: 1009,
                        encoding: t1.outputEncoding
                    });
                } else {
                    let n = null, s = null, a = null;
                    d.depth && (a = d.stencil ? 35056 : 33190, n = d.stencil ? 1027 : 1026, s = d.stencil ? 1020 : 1012);
                    const o = {
                        colorFormat: 3001 === t1.outputEncoding ? 35907 : 32856,
                        depthFormat: a,
                        scaleFactor: r
                    };
                    l = new XRWebGLBinding(i, e), h = l.createProjectionLayer(o), i.updateRenderState({
                        layers: [
                            h
                        ]
                    }), m = new $fd4eb456bcbd06f8$var$k(h.textureWidth, h.textureHeight, {
                        format: 1023,
                        type: 1009,
                        depthTexture: new $fd4eb456bcbd06f8$var$Pr(h.textureWidth, h.textureHeight, s, void 0, void 0, void 0, void 0, void 0, void 0, n),
                        stencilBuffer: d.stencil,
                        encoding: t1.outputEncoding,
                        samples: d.antialias ? 4 : 0
                    });
                    t1.properties.get(m).__ignoreDepthValues = h.ignoreDepthValues;
                }
                m.isXRRenderTarget = !0, this.setFoveation(1), s = await i.requestReferenceSpace(a), L.setContext(i), L.start(), n.isPresenting = !0, n.dispatchEvent({
                    type: "sessionstart"
                });
            }
        };
        const E = new $fd4eb456bcbd06f8$var$V, A = new $fd4eb456bcbd06f8$var$V;
        function R(t1, e) {
            null === e ? t1.matrixWorld.copy(t1.matrix) : t1.matrixWorld.multiplyMatrices(e.matrixWorld, t1.matrix), t1.matrixWorldInverse.copy(t1.matrixWorld).invert();
        }
        this.updateCamera = function(t1) {
            if (null === i) return;
            b.near = y.near = v.near = t1.near, b.far = y.far = v.far = t1.far, _ === b.near && w === b.far || (i.updateRenderState({
                depthNear: b.near,
                depthFar: b.far
            }), _ = b.near, w = b.far);
            const e = t1.parent, n = b.cameras;
            R(b, e);
            for(let t1 = 0; t1 < n.length; t1++)R(n[t1], e);
            b.matrixWorld.decompose(b.position, b.quaternion, b.scale), t1.position.copy(b.position), t1.quaternion.copy(b.quaternion), t1.scale.copy(b.scale), t1.matrix.copy(b.matrix), t1.matrixWorld.copy(b.matrixWorld);
            const r = t1.children;
            for(let t1 = 0, e = r.length; t1 < e; t1++)r[t1].updateMatrixWorld(!0);
            2 === n.length ? function(t1, e, n) {
                E.setFromMatrixPosition(e.matrixWorld), A.setFromMatrixPosition(n.matrixWorld);
                const i = E.distanceTo(A), r = e.projectionMatrix.elements, s = n.projectionMatrix.elements, a = r[14] / (r[10] - 1), o = r[14] / (r[10] + 1), l = (r[9] + 1) / r[5], h = (r[9] - 1) / r[5], c = (r[8] - 1) / r[0], u = (s[8] + 1) / s[0], d = a * c, p = a * u, m = i / (-c + u), f = m * -c;
                e.matrixWorld.decompose(t1.position, t1.quaternion, t1.scale), t1.translateX(f), t1.translateZ(m), t1.matrixWorld.compose(t1.position, t1.quaternion, t1.scale), t1.matrixWorldInverse.copy(t1.matrixWorld).invert();
                const g = a + m, v = o + m, y = d - f, x = p + (i - f), b = l * o / v * g, _ = h * o / v * g;
                t1.projectionMatrix.makePerspective(y, x, b, _, g, v);
            }(b, v, y) : b.projectionMatrix.copy(v.projectionMatrix);
        }, this.getCamera = function() {
            return b;
        }, this.getFoveation = function() {
            return null !== h ? h.fixedFoveation : null !== c ? c.fixedFoveation : void 0;
        }, this.setFoveation = function(t1) {
            null !== h && (h.fixedFoveation = t1), null !== c && void 0 !== c.fixedFoveation && (c.fixedFoveation = t1);
        };
        let C = null;
        const L = new $fd4eb456bcbd06f8$var$en;
        L.setAnimationLoop(function(e, n) {
            if (o = n.getViewerPose(s), u = n, null !== o) {
                const e = o.views;
                null !== c && (t1.setRenderTargetFramebuffer(m, c.framebuffer), t1.setRenderTarget(m));
                let n = !1;
                e.length !== b.cameras.length && (b.cameras.length = 0, n = !0);
                for(let i = 0; i < e.length; i++){
                    const r = e[i];
                    let s = null;
                    if (null !== c) s = c.getViewport(r);
                    else {
                        const e = l.getViewSubImage(h, r);
                        s = e.viewport, 0 === i && (t1.setRenderTargetTextures(m, e.colorTexture, h.ignoreDepthValues ? void 0 : e.depthStencilTexture), t1.setRenderTarget(m));
                    }
                    const a = x[i];
                    a.matrix.fromArray(r.transform.matrix), a.projectionMatrix.fromArray(r.projectionMatrix), a.viewport.set(s.x, s.y, s.width, s.height), 0 === i && b.matrix.copy(a.matrix), !0 === n && b.cameras.push(a);
                }
            }
            const r = i.inputSources;
            for(let t1 = 0; t1 < f.length; t1++){
                const e = f[t1], i = r[t1];
                e.update(i, n, s);
            }
            C && C(e, n), u = null;
        }), this.setAnimationLoop = function(t1) {
            C = t1;
        }, this.dispose = function() {};
    }
}
function $fd4eb456bcbd06f8$var$Ir(t1, e) {
    function n(n, i) {
        n.opacity.value = i.opacity, i.color && n.diffuse.value.copy(i.color), i.emissive && n.emissive.value.copy(i.emissive).multiplyScalar(i.emissiveIntensity), i.map && (n.map.value = i.map), i.alphaMap && (n.alphaMap.value = i.alphaMap), i.bumpMap && (n.bumpMap.value = i.bumpMap, n.bumpScale.value = i.bumpScale, 1 === i.side && (n.bumpScale.value *= -1)), i.displacementMap && (n.displacementMap.value = i.displacementMap, n.displacementScale.value = i.displacementScale, n.displacementBias.value = i.displacementBias), i.emissiveMap && (n.emissiveMap.value = i.emissiveMap), i.normalMap && (n.normalMap.value = i.normalMap, n.normalScale.value.copy(i.normalScale), 1 === i.side && n.normalScale.value.negate()), i.specularMap && (n.specularMap.value = i.specularMap), i.alphaTest > 0 && (n.alphaTest.value = i.alphaTest);
        const r = e.get(i).envMap;
        if (r && (n.envMap.value = r, n.flipEnvMap.value = r.isCubeTexture && !1 === r.isRenderTargetTexture ? -1 : 1, n.reflectivity.value = i.reflectivity, n.ior.value = i.ior, n.refractionRatio.value = i.refractionRatio), i.lightMap) {
            n.lightMap.value = i.lightMap;
            const e = !0 !== t1.physicallyCorrectLights ? Math.PI : 1;
            n.lightMapIntensity.value = i.lightMapIntensity * e;
        }
        let s, a;
        i.aoMap && (n.aoMap.value = i.aoMap, n.aoMapIntensity.value = i.aoMapIntensity), i.map ? s = i.map : i.specularMap ? s = i.specularMap : i.displacementMap ? s = i.displacementMap : i.normalMap ? s = i.normalMap : i.bumpMap ? s = i.bumpMap : i.roughnessMap ? s = i.roughnessMap : i.metalnessMap ? s = i.metalnessMap : i.alphaMap ? s = i.alphaMap : i.emissiveMap ? s = i.emissiveMap : i.clearcoatMap ? s = i.clearcoatMap : i.clearcoatNormalMap ? s = i.clearcoatNormalMap : i.clearcoatRoughnessMap ? s = i.clearcoatRoughnessMap : i.specularIntensityMap ? s = i.specularIntensityMap : i.specularColorMap ? s = i.specularColorMap : i.transmissionMap ? s = i.transmissionMap : i.thicknessMap ? s = i.thicknessMap : i.sheenColorMap ? s = i.sheenColorMap : i.sheenRoughnessMap && (s = i.sheenRoughnessMap), void 0 !== s && (s.isWebGLRenderTarget && (s = s.texture), !0 === s.matrixAutoUpdate && s.updateMatrix(), n.uvTransform.value.copy(s.matrix)), i.aoMap ? a = i.aoMap : i.lightMap && (a = i.lightMap), void 0 !== a && (a.isWebGLRenderTarget && (a = a.texture), !0 === a.matrixAutoUpdate && a.updateMatrix(), n.uv2Transform.value.copy(a.matrix));
    }
    return {
        refreshFogUniforms: function(t1, e) {
            t1.fogColor.value.copy(e.color), e.isFog ? (t1.fogNear.value = e.near, t1.fogFar.value = e.far) : e.isFogExp2 && (t1.fogDensity.value = e.density);
        },
        refreshMaterialUniforms: function(t1, i, r, s, a) {
            i.isMeshBasicMaterial || i.isMeshLambertMaterial ? n(t1, i) : i.isMeshToonMaterial ? (n(t1, i), function(t1, e) {
                e.gradientMap && (t1.gradientMap.value = e.gradientMap);
            }(t1, i)) : i.isMeshPhongMaterial ? (n(t1, i), function(t1, e) {
                t1.specular.value.copy(e.specular), t1.shininess.value = Math.max(e.shininess, 1e-4);
            }(t1, i)) : i.isMeshStandardMaterial ? (n(t1, i), function(t1, n) {
                t1.roughness.value = n.roughness, t1.metalness.value = n.metalness, n.roughnessMap && (t1.roughnessMap.value = n.roughnessMap);
                n.metalnessMap && (t1.metalnessMap.value = n.metalnessMap);
                e.get(n).envMap && (t1.envMapIntensity.value = n.envMapIntensity);
            }(t1, i), i.isMeshPhysicalMaterial && function(t1, e, n) {
                t1.ior.value = e.ior, e.sheen > 0 && (t1.sheenColor.value.copy(e.sheenColor).multiplyScalar(e.sheen), t1.sheenRoughness.value = e.sheenRoughness, e.sheenColorMap && (t1.sheenColorMap.value = e.sheenColorMap), e.sheenRoughnessMap && (t1.sheenRoughnessMap.value = e.sheenRoughnessMap));
                e.clearcoat > 0 && (t1.clearcoat.value = e.clearcoat, t1.clearcoatRoughness.value = e.clearcoatRoughness, e.clearcoatMap && (t1.clearcoatMap.value = e.clearcoatMap), e.clearcoatRoughnessMap && (t1.clearcoatRoughnessMap.value = e.clearcoatRoughnessMap), e.clearcoatNormalMap && (t1.clearcoatNormalScale.value.copy(e.clearcoatNormalScale), t1.clearcoatNormalMap.value = e.clearcoatNormalMap, 1 === e.side && t1.clearcoatNormalScale.value.negate()));
                e.transmission > 0 && (t1.transmission.value = e.transmission, t1.transmissionSamplerMap.value = n.texture, t1.transmissionSamplerSize.value.set(n.width, n.height), e.transmissionMap && (t1.transmissionMap.value = e.transmissionMap), t1.thickness.value = e.thickness, e.thicknessMap && (t1.thicknessMap.value = e.thicknessMap), t1.attenuationDistance.value = e.attenuationDistance, t1.attenuationColor.value.copy(e.attenuationColor));
                t1.specularIntensity.value = e.specularIntensity, t1.specularColor.value.copy(e.specularColor), e.specularIntensityMap && (t1.specularIntensityMap.value = e.specularIntensityMap);
                e.specularColorMap && (t1.specularColorMap.value = e.specularColorMap);
            }(t1, i, a)) : i.isMeshMatcapMaterial ? (n(t1, i), function(t1, e) {
                e.matcap && (t1.matcap.value = e.matcap);
            }(t1, i)) : i.isMeshDepthMaterial ? n(t1, i) : i.isMeshDistanceMaterial ? (n(t1, i), function(t1, e) {
                t1.referencePosition.value.copy(e.referencePosition), t1.nearDistance.value = e.nearDistance, t1.farDistance.value = e.farDistance;
            }(t1, i)) : i.isMeshNormalMaterial ? n(t1, i) : i.isLineBasicMaterial ? (function(t1, e) {
                t1.diffuse.value.copy(e.color), t1.opacity.value = e.opacity;
            }(t1, i), i.isLineDashedMaterial && function(t1, e) {
                t1.dashSize.value = e.dashSize, t1.totalSize.value = e.dashSize + e.gapSize, t1.scale.value = e.scale;
            }(t1, i)) : i.isPointsMaterial ? function(t1, e, n, i) {
                t1.diffuse.value.copy(e.color), t1.opacity.value = e.opacity, t1.size.value = e.size * n, t1.scale.value = .5 * i, e.map && (t1.map.value = e.map);
                e.alphaMap && (t1.alphaMap.value = e.alphaMap);
                e.alphaTest > 0 && (t1.alphaTest.value = e.alphaTest);
                let r;
                e.map ? r = e.map : e.alphaMap && (r = e.alphaMap);
                void 0 !== r && (!0 === r.matrixAutoUpdate && r.updateMatrix(), t1.uvTransform.value.copy(r.matrix));
            }(t1, i, r, s) : i.isSpriteMaterial ? function(t1, e) {
                t1.diffuse.value.copy(e.color), t1.opacity.value = e.opacity, t1.rotation.value = e.rotation, e.map && (t1.map.value = e.map);
                e.alphaMap && (t1.alphaMap.value = e.alphaMap);
                e.alphaTest > 0 && (t1.alphaTest.value = e.alphaTest);
                let n;
                e.map ? n = e.map : e.alphaMap && (n = e.alphaMap);
                void 0 !== n && (!0 === n.matrixAutoUpdate && n.updateMatrix(), t1.uvTransform.value.copy(n.matrix));
            }(t1, i) : i.isShadowMaterial ? (t1.color.value.copy(i.color), t1.opacity.value = i.opacity) : i.isShaderMaterial && (i.uniformsNeedUpdate = !1);
        }
    };
}
function $fd4eb456bcbd06f8$var$Or(t1 = {}) {
    const e = void 0 !== t1.canvas ? t1.canvas : function() {
        const t1 = $fd4eb456bcbd06f8$var$x("canvas");
        return t1.style.display = "block", t1;
    }(), n = void 0 !== t1.context ? t1.context : null, i = void 0 === t1.depth || t1.depth, r = void 0 === t1.stencil || t1.stencil, s = void 0 !== t1.antialias && t1.antialias, a = void 0 === t1.premultipliedAlpha || t1.premultipliedAlpha, o = void 0 !== t1.preserveDrawingBuffer && t1.preserveDrawingBuffer, l = void 0 !== t1.powerPreference ? t1.powerPreference : "default", h = void 0 !== t1.failIfMajorPerformanceCaveat && t1.failIfMajorPerformanceCaveat;
    let c;
    c = void 0 !== t1.context ? n.getContextAttributes().alpha : void 0 !== t1.alpha && t1.alpha;
    let u = null, d = null;
    const p = [], f = [];
    this.domElement = e, this.debug = {
        checkShaderErrors: !0
    }, this.autoClear = !0, this.autoClearColor = !0, this.autoClearDepth = !0, this.autoClearStencil = !0, this.sortObjects = !0, this.clippingPlanes = [], this.localClippingEnabled = !1, this.outputEncoding = 3e3, this.physicallyCorrectLights = !1, this.toneMapping = 0, this.toneMappingExposure = 1;
    const v = this;
    let y = !1, b = 0, _ = 0, w = null, M = -1, S = null;
    const T = new $fd4eb456bcbd06f8$var$U, E = new $fd4eb456bcbd06f8$var$U;
    let A = null, R = e.width, C = e.height, L = 1, P = null, D = null;
    const I = new $fd4eb456bcbd06f8$var$U(0, 0, R, C), O = new $fd4eb456bcbd06f8$var$U(0, 0, R, C);
    let N = !1;
    const F = new $fd4eb456bcbd06f8$var$tn;
    let B = !1, z = !1, H = null;
    const G = new $fd4eb456bcbd06f8$var$xt, W = new $fd4eb456bcbd06f8$var$g, j = new $fd4eb456bcbd06f8$var$V, q = {
        background: null,
        fog: null,
        environment: null,
        overrideMaterial: null,
        isScene: !0
    };
    function X() {
        return null === w ? L : 1;
    }
    let $, Y, J, K, Z, Q, tt, et, nt, it, rt, st, at, ot, lt, ht, ct, ut, dt, pt, mt, ft, gt, vt = n;
    function yt(t1, n) {
        for(let i = 0; i < t1.length; i++){
            const r = t1[i], s = e.getContext(r, n);
            if (null !== s) return s;
        }
        return null;
    }
    try {
        const t1 = {
            alpha: !0,
            depth: i,
            stencil: r,
            antialias: s,
            premultipliedAlpha: a,
            preserveDrawingBuffer: o,
            powerPreference: l,
            failIfMajorPerformanceCaveat: h
        };
        if ("setAttribute" in e && e.setAttribute("data-engine", "three.js r139"), e.addEventListener("webglcontextlost", wt, !1), e.addEventListener("webglcontextrestored", Mt, !1), null === vt) {
            const e = [
                "webgl2",
                "webgl",
                "experimental-webgl"
            ];
            if (!0 === v.isWebGL1Renderer && e.shift(), vt = yt(e, t1), null === vt) throw yt(e) ? new Error("Error creating WebGL context with your selected attributes.") : new Error("Error creating WebGL context.");
        }
        void 0 === vt.getShaderPrecisionFormat && (vt.getShaderPrecisionFormat = function() {
            return {
                rangeMin: 1,
                rangeMax: 1,
                precision: 1
            };
        });
    } catch (t1) {
        throw console.error("THREE.WebGLRenderer: " + t1.message), t1;
    }
    function bt() {
        $ = new $fd4eb456bcbd06f8$var$Cn(vt), Y = new $fd4eb456bcbd06f8$var$un(vt, $, t1), $.init(Y), ft = new $fd4eb456bcbd06f8$var$Er(vt, $, Y), J = new $fd4eb456bcbd06f8$var$Sr(vt, $, Y), K = new $fd4eb456bcbd06f8$var$Dn(vt), Z = new $fd4eb456bcbd06f8$var$cr, Q = new $fd4eb456bcbd06f8$var$Tr(vt, $, J, Z, Y, ft, K), tt = new $fd4eb456bcbd06f8$var$pn(v), et = new $fd4eb456bcbd06f8$var$Rn(v), nt = new $fd4eb456bcbd06f8$var$nn(vt, Y), gt = new $fd4eb456bcbd06f8$var$hn(vt, $, nt, Y), it = new $fd4eb456bcbd06f8$var$Ln(vt, nt, K, gt), rt = new $fd4eb456bcbd06f8$var$Un(vt, it, nt, K), dt = new $fd4eb456bcbd06f8$var$Fn(vt, Y, Q), ht = new $fd4eb456bcbd06f8$var$dn(Z), st = new $fd4eb456bcbd06f8$var$hr(v, tt, et, $, Y, gt, ht), at = new $fd4eb456bcbd06f8$var$Ir(v, Z), ot = new $fd4eb456bcbd06f8$var$mr, lt = new $fd4eb456bcbd06f8$var$br($, Y), ut = new $fd4eb456bcbd06f8$var$ln(v, tt, J, rt, c, a), ct = new $fd4eb456bcbd06f8$var$Mr(v, rt, Y), pt = new $fd4eb456bcbd06f8$var$cn(vt, $, K, Y), mt = new $fd4eb456bcbd06f8$var$Pn(vt, $, K, Y), K.programs = st.programs, v.capabilities = Y, v.extensions = $, v.properties = Z, v.renderLists = ot, v.shadowMap = ct, v.state = J, v.info = K;
    }
    bt();
    const _t = new $fd4eb456bcbd06f8$var$Dr(v, vt);
    function wt(t1) {
        t1.preventDefault(), console.log("THREE.WebGLRenderer: Context Lost."), y = !0;
    }
    function Mt() {
        console.log("THREE.WebGLRenderer: Context Restored."), y = !1;
        const t1 = K.autoReset, e = ct.enabled, n = ct.autoUpdate, i = ct.needsUpdate, r = ct.type;
        bt(), K.autoReset = t1, ct.enabled = e, ct.autoUpdate = n, ct.needsUpdate = i, ct.type = r;
    }
    function St(t1) {
        const e = t1.target;
        e.removeEventListener("dispose", St), function(t1) {
            (function(t1) {
                const e = Z.get(t1).programs;
                void 0 !== e && (e.forEach(function(t1) {
                    st.releaseProgram(t1);
                }), t1.isShaderMaterial && st.releaseShaderCache(t1));
            })(t1), Z.remove(t1);
        }(e);
    }
    this.xr = _t, this.getContext = function() {
        return vt;
    }, this.getContextAttributes = function() {
        return vt.getContextAttributes();
    }, this.forceContextLoss = function() {
        const t1 = $.get("WEBGL_lose_context");
        t1 && t1.loseContext();
    }, this.forceContextRestore = function() {
        const t1 = $.get("WEBGL_lose_context");
        t1 && t1.restoreContext();
    }, this.getPixelRatio = function() {
        return L;
    }, this.setPixelRatio = function(t1) {
        void 0 !== t1 && (L = t1, this.setSize(R, C, !1));
    }, this.getSize = function(t1) {
        return t1.set(R, C);
    }, this.setSize = function(t1, n, i) {
        _t.isPresenting ? console.warn("THREE.WebGLRenderer: Can't change size while VR device is presenting.") : (R = t1, C = n, e.width = Math.floor(t1 * L), e.height = Math.floor(n * L), !1 !== i && (e.style.width = t1 + "px", e.style.height = n + "px"), this.setViewport(0, 0, t1, n));
    }, this.getDrawingBufferSize = function(t1) {
        return t1.set(R * L, C * L).floor();
    }, this.setDrawingBufferSize = function(t1, n, i) {
        R = t1, C = n, L = i, e.width = Math.floor(t1 * i), e.height = Math.floor(n * i), this.setViewport(0, 0, t1, n);
    }, this.getCurrentViewport = function(t1) {
        return t1.copy(T);
    }, this.getViewport = function(t1) {
        return t1.copy(I);
    }, this.setViewport = function(t1, e, n, i) {
        t1.isVector4 ? I.set(t1.x, t1.y, t1.z, t1.w) : I.set(t1, e, n, i), J.viewport(T.copy(I).multiplyScalar(L).floor());
    }, this.getScissor = function(t1) {
        return t1.copy(O);
    }, this.setScissor = function(t1, e, n, i) {
        t1.isVector4 ? O.set(t1.x, t1.y, t1.z, t1.w) : O.set(t1, e, n, i), J.scissor(E.copy(O).multiplyScalar(L).floor());
    }, this.getScissorTest = function() {
        return N;
    }, this.setScissorTest = function(t1) {
        J.setScissorTest(N = t1);
    }, this.setOpaqueSort = function(t1) {
        P = t1;
    }, this.setTransparentSort = function(t1) {
        D = t1;
    }, this.getClearColor = function(t1) {
        return t1.copy(ut.getClearColor());
    }, this.setClearColor = function() {
        ut.setClearColor.apply(ut, arguments);
    }, this.getClearAlpha = function() {
        return ut.getClearAlpha();
    }, this.setClearAlpha = function() {
        ut.setClearAlpha.apply(ut, arguments);
    }, this.clear = function(t1 = !0, e = !0, n = !0) {
        let i = 0;
        t1 && (i |= 16384), e && (i |= 256), n && (i |= 1024), vt.clear(i);
    }, this.clearColor = function() {
        this.clear(!0, !1, !1);
    }, this.clearDepth = function() {
        this.clear(!1, !0, !1);
    }, this.clearStencil = function() {
        this.clear(!1, !1, !0);
    }, this.dispose = function() {
        e.removeEventListener("webglcontextlost", wt, !1), e.removeEventListener("webglcontextrestored", Mt, !1), ot.dispose(), lt.dispose(), Z.dispose(), tt.dispose(), et.dispose(), rt.dispose(), gt.dispose(), st.dispose(), _t.dispose(), _t.removeEventListener("sessionstart", Et), _t.removeEventListener("sessionend", At), H && (H.dispose(), H = null), Rt.stop();
    }, this.renderBufferDirect = function(t1, e, n, i, r, s) {
        null === e && (e = q);
        const a = r.isMesh && r.matrixWorld.determinant() < 0, o = function(t1, e, n, i, r) {
            !0 !== e.isScene && (e = q);
            Q.resetTextureUnits();
            const s = e.fog, a = i.isMeshStandardMaterial ? e.environment : null, o = null === w ? v.outputEncoding : !0 === w.isXRRenderTarget ? w.texture.encoding : 3e3, l = (i.isMeshStandardMaterial ? et : tt).get(i.envMap || a), h = !0 === i.vertexColors && !!n.attributes.color && 4 === n.attributes.color.itemSize, c = !!i.normalMap && !!n.attributes.tangent, u = !!n.morphAttributes.position, p = !!n.morphAttributes.normal, m = !!n.morphAttributes.color, f = i.toneMapped ? v.toneMapping : 0, g = n.morphAttributes.position || n.morphAttributes.normal || n.morphAttributes.color, y = void 0 !== g ? g.length : 0, x = Z.get(i), b = d.state.lights;
            if (!0 === B && (!0 === z || t1 !== S)) {
                const e = t1 === S && i.id === M;
                ht.setState(i, t1, e);
            }
            let _ = !1;
            i.version === x.__version ? x.needsLights && x.lightsStateVersion !== b.state.version || x.outputEncoding !== o || r.isInstancedMesh && !1 === x.instancing ? _ = !0 : r.isInstancedMesh || !0 !== x.instancing ? r.isSkinnedMesh && !1 === x.skinning ? _ = !0 : r.isSkinnedMesh || !0 !== x.skinning ? x.envMap !== l || i.fog && x.fog !== s ? _ = !0 : void 0 === x.numClippingPlanes || x.numClippingPlanes === ht.numPlanes && x.numIntersection === ht.numIntersection ? (x.vertexAlphas !== h || x.vertexTangents !== c || x.morphTargets !== u || x.morphNormals !== p || x.morphColors !== m || x.toneMapping !== f || !0 === Y.isWebGL2 && x.morphTargetsCount !== y) && (_ = !0) : _ = !0 : _ = !0 : _ = !0 : (_ = !0, x.__version = i.version);
            let T = x.currentProgram;
            !0 === _ && (T = It(i, e, r));
            let E = !1, A = !1, R = !1;
            const P = T.getUniforms(), D = x.uniforms;
            J.useProgram(T.program) && (E = !0, A = !0, R = !0);
            i.id !== M && (M = i.id, A = !0);
            if (E || S !== t1) {
                if (P.setValue(vt, "projectionMatrix", t1.projectionMatrix), Y.logarithmicDepthBuffer && P.setValue(vt, "logDepthBufFC", 2 / (Math.log(t1.far + 1) / Math.LN2)), S !== t1 && (S = t1, A = !0, R = !0), i.isShaderMaterial || i.isMeshPhongMaterial || i.isMeshToonMaterial || i.isMeshStandardMaterial || i.envMap) {
                    const e = P.map.cameraPosition;
                    void 0 !== e && e.setValue(vt, j.setFromMatrixPosition(t1.matrixWorld));
                }
                (i.isMeshPhongMaterial || i.isMeshToonMaterial || i.isMeshLambertMaterial || i.isMeshBasicMaterial || i.isMeshStandardMaterial || i.isShaderMaterial) && P.setValue(vt, "isOrthographic", !0 === t1.isOrthographicCamera), (i.isMeshPhongMaterial || i.isMeshToonMaterial || i.isMeshLambertMaterial || i.isMeshBasicMaterial || i.isMeshStandardMaterial || i.isShaderMaterial || i.isShadowMaterial || r.isSkinnedMesh) && P.setValue(vt, "viewMatrix", t1.matrixWorldInverse);
            }
            if (r.isSkinnedMesh) {
                P.setOptional(vt, r, "bindMatrix"), P.setOptional(vt, r, "bindMatrixInverse");
                const t1 = r.skeleton;
                t1 && (Y.floatVertexTextures ? (null === t1.boneTexture && t1.computeBoneTexture(), P.setValue(vt, "boneTexture", t1.boneTexture, Q), P.setValue(vt, "boneTextureSize", t1.boneTextureSize)) : P.setOptional(vt, t1, "boneMatrices"));
            }
            const I = n.morphAttributes;
            (void 0 !== I.position || void 0 !== I.normal || void 0 !== I.color && !0 === Y.isWebGL2) && dt.update(r, n, i, T);
            (A || x.receiveShadow !== r.receiveShadow) && (x.receiveShadow = r.receiveShadow, P.setValue(vt, "receiveShadow", r.receiveShadow));
            A && (P.setValue(vt, "toneMappingExposure", v.toneMappingExposure), x.needsLights && (N = R, (O = D).ambientLightColor.needsUpdate = N, O.lightProbe.needsUpdate = N, O.directionalLights.needsUpdate = N, O.directionalLightShadows.needsUpdate = N, O.pointLights.needsUpdate = N, O.pointLightShadows.needsUpdate = N, O.spotLights.needsUpdate = N, O.spotLightShadows.needsUpdate = N, O.rectAreaLights.needsUpdate = N, O.hemisphereLights.needsUpdate = N), s && i.fog && at.refreshFogUniforms(D, s), at.refreshMaterialUniforms(D, i, L, C, H), $fd4eb456bcbd06f8$var$Hi.upload(vt, x.uniformsList, D, Q));
            var O, N;
            i.isShaderMaterial && !0 === i.uniformsNeedUpdate && ($fd4eb456bcbd06f8$var$Hi.upload(vt, x.uniformsList, D, Q), i.uniformsNeedUpdate = !1);
            i.isSpriteMaterial && P.setValue(vt, "center", r.center);
            return P.setValue(vt, "modelViewMatrix", r.modelViewMatrix), P.setValue(vt, "normalMatrix", r.normalMatrix), P.setValue(vt, "modelMatrix", r.matrixWorld), T;
        }(t1, e, n, i, r);
        J.setMaterial(i, a);
        let l = n.index;
        const h = n.attributes.position;
        if (null === l) {
            if (void 0 === h || 0 === h.count) return;
        } else if (0 === l.count) return;
        let c, u = 1;
        !0 === i.wireframe && (l = it.getWireframeAttribute(n), u = 2), gt.setup(r, i, o, n, l);
        let p = pt;
        null !== l && (c = nt.get(l), p = mt, p.setIndex(c));
        const m = null !== l ? l.count : h.count, f = n.drawRange.start * u, g = n.drawRange.count * u, y = null !== s ? s.start * u : 0, x = null !== s ? s.count * u : 1 / 0, b = Math.max(f, y), _ = Math.min(m, f + g, y + x) - 1, T = Math.max(0, _ - b + 1);
        if (0 !== T) {
            if (r.isMesh) !0 === i.wireframe ? (J.setLineWidth(i.wireframeLinewidth * X()), p.setMode(1)) : p.setMode(4);
            else if (r.isLine) {
                let t1 = i.linewidth;
                void 0 === t1 && (t1 = 1), J.setLineWidth(t1 * X()), r.isLineSegments ? p.setMode(1) : r.isLineLoop ? p.setMode(2) : p.setMode(3);
            } else r.isPoints ? p.setMode(0) : r.isSprite && p.setMode(4);
            if (r.isInstancedMesh) p.renderInstances(b, T, r.count);
            else if (n.isInstancedBufferGeometry) {
                const t1 = Math.min(n.instanceCount, n._maxInstanceCount);
                p.renderInstances(b, T, t1);
            } else p.render(b, T);
        }
    }, this.compile = function(t1, e) {
        d = lt.get(t1), d.init(), f.push(d), t1.traverseVisible(function(t1) {
            t1.isLight && t1.layers.test(e.layers) && (d.pushLight(t1), t1.castShadow && d.pushShadow(t1));
        }), d.setupLights(v.physicallyCorrectLights), t1.traverse(function(e) {
            const n = e.material;
            if (n) {
                if (Array.isArray(n)) for(let i = 0; i < n.length; i++)It(n[i], t1, e);
                else It(n, t1, e);
            }
        }), f.pop(), d = null;
    };
    let Tt = null;
    function Et() {
        Rt.stop();
    }
    function At() {
        Rt.start();
    }
    const Rt = new $fd4eb456bcbd06f8$var$en;
    function Ct(t1, e, n, i) {
        if (!1 === t1.visible) return;
        if (t1.layers.test(e.layers)) {
            if (t1.isGroup) n = t1.renderOrder;
            else if (t1.isLOD) !0 === t1.autoUpdate && t1.update(e);
            else if (t1.isLight) d.pushLight(t1), t1.castShadow && d.pushShadow(t1);
            else if (t1.isSprite) {
                if (!t1.frustumCulled || F.intersectsSprite(t1)) {
                    i && j.setFromMatrixPosition(t1.matrixWorld).applyMatrix4(G);
                    const e = rt.update(t1), r = t1.material;
                    r.visible && u.push(t1, e, r, n, j.z, null);
                }
            } else if ((t1.isMesh || t1.isLine || t1.isPoints) && (t1.isSkinnedMesh && t1.skeleton.frame !== K.render.frame && (t1.skeleton.update(), t1.skeleton.frame = K.render.frame), !t1.frustumCulled || F.intersectsObject(t1))) {
                i && j.setFromMatrixPosition(t1.matrixWorld).applyMatrix4(G);
                const e = rt.update(t1), r = t1.material;
                if (Array.isArray(r)) {
                    const i = e.groups;
                    for(let s = 0, a = i.length; s < a; s++){
                        const a = i[s], o = r[a.materialIndex];
                        o && o.visible && u.push(t1, e, o, n, j.z, a);
                    }
                } else r.visible && u.push(t1, e, r, n, j.z, null);
            }
        }
        const r = t1.children;
        for(let t1 = 0, s = r.length; t1 < s; t1++)Ct(r[t1], e, n, i);
    }
    function Lt(t1, e, n, i) {
        const r = t1.opaque, a = t1.transmissive, o = t1.transparent;
        d.setupLightsView(n), a.length > 0 && function(t1, e, n) {
            const i = Y.isWebGL2;
            null === H && (H = new $fd4eb456bcbd06f8$var$k(1, 1, {
                generateMipmaps: !0,
                type: null !== ft.convert(1016) ? 1016 : 1009,
                minFilter: 1008,
                samples: i && !0 === s ? 4 : 0
            }));
            v.getDrawingBufferSize(W), i ? H.setSize(W.x, W.y) : H.setSize($fd4eb456bcbd06f8$var$m(W.x), $fd4eb456bcbd06f8$var$m(W.y));
            const r = v.getRenderTarget();
            v.setRenderTarget(H), v.clear();
            const a = v.toneMapping;
            v.toneMapping = 0, Pt(t1, e, n), v.toneMapping = a, Q.updateMultisampleRenderTarget(H), Q.updateRenderTargetMipmap(H), v.setRenderTarget(r);
        }(r, e, n), i && J.viewport(T.copy(i)), r.length > 0 && Pt(r, e, n), a.length > 0 && Pt(a, e, n), o.length > 0 && Pt(o, e, n), J.buffers.depth.setTest(!0), J.buffers.depth.setMask(!0), J.buffers.color.setMask(!0), J.setPolygonOffset(!1);
    }
    function Pt(t1, e, n) {
        const i = !0 === e.isScene ? e.overrideMaterial : null;
        for(let r = 0, s = t1.length; r < s; r++){
            const s = t1[r], a = s.object, o = s.geometry, l = null === i ? s.material : i, h = s.group;
            a.layers.test(n.layers) && Dt(a, e, n, o, l, h);
        }
    }
    function Dt(t1, e, n, i, r, s) {
        t1.onBeforeRender(v, e, n, i, r, s), t1.modelViewMatrix.multiplyMatrices(n.matrixWorldInverse, t1.matrixWorld), t1.normalMatrix.getNormalMatrix(t1.modelViewMatrix), r.onBeforeRender(v, e, n, i, t1, s), !0 === r.transparent && 2 === r.side ? (r.side = 1, r.needsUpdate = !0, v.renderBufferDirect(n, e, i, r, t1, s), r.side = 0, r.needsUpdate = !0, v.renderBufferDirect(n, e, i, r, t1, s), r.side = 2) : v.renderBufferDirect(n, e, i, r, t1, s), t1.onAfterRender(v, e, n, i, r, s);
    }
    function It(t1, e, n) {
        !0 !== e.isScene && (e = q);
        const i = Z.get(t1), r = d.state.lights, s = d.state.shadowsArray, a = r.state.version, o = st.getParameters(t1, r.state, s, e, n), l = st.getProgramCacheKey(o);
        let h = i.programs;
        i.environment = t1.isMeshStandardMaterial ? e.environment : null, i.fog = e.fog, i.envMap = (t1.isMeshStandardMaterial ? et : tt).get(t1.envMap || i.environment), void 0 === h && (t1.addEventListener("dispose", St), h = new Map, i.programs = h);
        let c = h.get(l);
        if (void 0 !== c) {
            if (i.currentProgram === c && i.lightsStateVersion === a) return Ot(t1, o), c;
        } else o.uniforms = st.getUniforms(t1), t1.onBuild(n, o, v), t1.onBeforeCompile(o, v), c = st.acquireProgram(o, l), h.set(l, c), i.uniforms = o.uniforms;
        const u = i.uniforms;
        (t1.isShaderMaterial || t1.isRawShaderMaterial) && !0 !== t1.clipping || (u.clippingPlanes = ht.uniform), Ot(t1, o), i.needsLights = function(t1) {
            return t1.isMeshLambertMaterial || t1.isMeshToonMaterial || t1.isMeshPhongMaterial || t1.isMeshStandardMaterial || t1.isShadowMaterial || t1.isShaderMaterial && !0 === t1.lights;
        }(t1), i.lightsStateVersion = a, i.needsLights && (u.ambientLightColor.value = r.state.ambient, u.lightProbe.value = r.state.probe, u.directionalLights.value = r.state.directional, u.directionalLightShadows.value = r.state.directionalShadow, u.spotLights.value = r.state.spot, u.spotLightShadows.value = r.state.spotShadow, u.rectAreaLights.value = r.state.rectArea, u.ltc_1.value = r.state.rectAreaLTC1, u.ltc_2.value = r.state.rectAreaLTC2, u.pointLights.value = r.state.point, u.pointLightShadows.value = r.state.pointShadow, u.hemisphereLights.value = r.state.hemi, u.directionalShadowMap.value = r.state.directionalShadowMap, u.directionalShadowMatrix.value = r.state.directionalShadowMatrix, u.spotShadowMap.value = r.state.spotShadowMap, u.spotShadowMatrix.value = r.state.spotShadowMatrix, u.pointShadowMap.value = r.state.pointShadowMap, u.pointShadowMatrix.value = r.state.pointShadowMatrix);
        const p = c.getUniforms(), m = $fd4eb456bcbd06f8$var$Hi.seqWithValue(p.seq, u);
        return i.currentProgram = c, i.uniformsList = m, c;
    }
    function Ot(t1, e) {
        const n = Z.get(t1);
        n.outputEncoding = e.outputEncoding, n.instancing = e.instancing, n.skinning = e.skinning, n.morphTargets = e.morphTargets, n.morphNormals = e.morphNormals, n.morphColors = e.morphColors, n.morphTargetsCount = e.morphTargetsCount, n.numClippingPlanes = e.numClippingPlanes, n.numIntersection = e.numClipIntersection, n.vertexAlphas = e.vertexAlphas, n.vertexTangents = e.vertexTangents, n.toneMapping = e.toneMapping;
    }
    Rt.setAnimationLoop(function(t1) {
        Tt && Tt(t1);
    }), "undefined" != typeof self && Rt.setContext(self), this.setAnimationLoop = function(t1) {
        Tt = t1, _t.setAnimationLoop(t1), null === t1 ? Rt.stop() : Rt.start();
    }, _t.addEventListener("sessionstart", Et), _t.addEventListener("sessionend", At), this.render = function(t1, e) {
        if (void 0 !== e && !0 !== e.isCamera) return void console.error("THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.");
        if (!0 === y) return;
        !0 === t1.autoUpdate && t1.updateMatrixWorld(), null === e.parent && e.updateMatrixWorld(), !0 === _t.enabled && !0 === _t.isPresenting && (!0 === _t.cameraAutoUpdate && _t.updateCamera(e), e = _t.getCamera()), !0 === t1.isScene && t1.onBeforeRender(v, t1, e, w), d = lt.get(t1, f.length), d.init(), f.push(d), G.multiplyMatrices(e.projectionMatrix, e.matrixWorldInverse), F.setFromProjectionMatrix(G), z = this.localClippingEnabled, B = ht.init(this.clippingPlanes, z, e), u = ot.get(t1, p.length), u.init(), p.push(u), Ct(t1, e, 0, v.sortObjects), u.finish(), !0 === v.sortObjects && u.sort(P, D), !0 === B && ht.beginShadows();
        const n = d.state.shadowsArray;
        if (ct.render(n, t1, e), !0 === B && ht.endShadows(), !0 === this.info.autoReset && this.info.reset(), ut.render(u, t1), d.setupLights(v.physicallyCorrectLights), e.isArrayCamera) {
            const n = e.cameras;
            for(let e = 0, i = n.length; e < i; e++){
                const i = n[e];
                Lt(u, t1, i, i.viewport);
            }
        } else Lt(u, t1, e);
        null !== w && (Q.updateMultisampleRenderTarget(w), Q.updateRenderTargetMipmap(w)), !0 === t1.isScene && t1.onAfterRender(v, t1, e), gt.resetDefaultState(), M = -1, S = null, f.pop(), d = f.length > 0 ? f[f.length - 1] : null, p.pop(), u = p.length > 0 ? p[p.length - 1] : null;
    }, this.getActiveCubeFace = function() {
        return b;
    }, this.getActiveMipmapLevel = function() {
        return _;
    }, this.getRenderTarget = function() {
        return w;
    }, this.setRenderTargetTextures = function(t1, e, n) {
        Z.get(t1.texture).__webglTexture = e, Z.get(t1.depthTexture).__webglTexture = n;
        const i = Z.get(t1);
        i.__hasExternalTextures = !0, i.__hasExternalTextures && (i.__autoAllocateDepthBuffer = void 0 === n, i.__autoAllocateDepthBuffer || !0 === $.has("WEBGL_multisampled_render_to_texture") && (console.warn("THREE.WebGLRenderer: Render-to-texture extension was disabled because an external texture was provided"), i.__useRenderToTexture = !1));
    }, this.setRenderTargetFramebuffer = function(t1, e) {
        const n = Z.get(t1);
        n.__webglFramebuffer = e, n.__useDefaultFramebuffer = void 0 === e;
    }, this.setRenderTarget = function(t1, e = 0, n = 0) {
        w = t1, b = e, _ = n;
        let i = !0;
        if (t1) {
            const e = Z.get(t1);
            void 0 !== e.__useDefaultFramebuffer ? (J.bindFramebuffer(36160, null), i = !1) : void 0 === e.__webglFramebuffer ? Q.setupRenderTarget(t1) : e.__hasExternalTextures && Q.rebindTextures(t1, Z.get(t1.texture).__webglTexture, Z.get(t1.depthTexture).__webglTexture);
        }
        let r = null, s = !1, a = !1;
        if (t1) {
            const n = t1.texture;
            (n.isData3DTexture || n.isDataArrayTexture) && (a = !0);
            const i = Z.get(t1).__webglFramebuffer;
            t1.isWebGLCubeRenderTarget ? (r = i[e], s = !0) : r = Y.isWebGL2 && t1.samples > 0 && !1 === Q.useMultisampledRTT(t1) ? Z.get(t1).__webglMultisampledFramebuffer : i, T.copy(t1.viewport), E.copy(t1.scissor), A = t1.scissorTest;
        } else T.copy(I).multiplyScalar(L).floor(), E.copy(O).multiplyScalar(L).floor(), A = N;
        if (J.bindFramebuffer(36160, r) && Y.drawBuffers && i && J.drawBuffers(t1, r), J.viewport(T), J.scissor(E), J.setScissorTest(A), s) {
            const i = Z.get(t1.texture);
            vt.framebufferTexture2D(36160, 36064, 34069 + e, i.__webglTexture, n);
        } else if (a) {
            const i = Z.get(t1.texture), r = e || 0;
            vt.framebufferTextureLayer(36160, 36064, i.__webglTexture, n || 0, r);
        }
        M = -1;
    }, this.readRenderTargetPixels = function(t1, e, n, i, r, s, a) {
        if (!t1 || !t1.isWebGLRenderTarget) return void console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
        let o = Z.get(t1).__webglFramebuffer;
        if (t1.isWebGLCubeRenderTarget && void 0 !== a && (o = o[a]), o) {
            J.bindFramebuffer(36160, o);
            try {
                const a = t1.texture, o = a.format, l = a.type;
                if (1023 !== o && ft.convert(o) !== vt.getParameter(35739)) return void console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.");
                const h = 1016 === l && ($.has("EXT_color_buffer_half_float") || Y.isWebGL2 && $.has("EXT_color_buffer_float"));
                if (!(1009 === l || ft.convert(l) === vt.getParameter(35738) || 1015 === l && (Y.isWebGL2 || $.has("OES_texture_float") || $.has("WEBGL_color_buffer_float")) || h)) return void console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.");
                e >= 0 && e <= t1.width - i && n >= 0 && n <= t1.height - r && vt.readPixels(e, n, i, r, ft.convert(o), ft.convert(l), s);
            } finally{
                const t1 = null !== w ? Z.get(w).__webglFramebuffer : null;
                J.bindFramebuffer(36160, t1);
            }
        }
    }, this.copyFramebufferToTexture = function(t1, e, n = 0) {
        if (!0 !== e.isFramebufferTexture) return void console.error("THREE.WebGLRenderer: copyFramebufferToTexture() can only be used with FramebufferTexture.");
        const i = Math.pow(2, -n), r = Math.floor(e.image.width * i), s = Math.floor(e.image.height * i);
        Q.setTexture2D(e, 0), vt.copyTexSubImage2D(3553, n, 0, 0, t1.x, t1.y, r, s), J.unbindTexture();
    }, this.copyTextureToTexture = function(t1, e, n, i = 0) {
        const r = e.image.width, s = e.image.height, a = ft.convert(n.format), o = ft.convert(n.type);
        Q.setTexture2D(n, 0), vt.pixelStorei(37440, n.flipY), vt.pixelStorei(37441, n.premultiplyAlpha), vt.pixelStorei(3317, n.unpackAlignment), e.isDataTexture ? vt.texSubImage2D(3553, i, t1.x, t1.y, r, s, a, o, e.image.data) : e.isCompressedTexture ? vt.compressedTexSubImage2D(3553, i, t1.x, t1.y, e.mipmaps[0].width, e.mipmaps[0].height, a, e.mipmaps[0].data) : vt.texSubImage2D(3553, i, t1.x, t1.y, a, o, e.image), 0 === i && n.generateMipmaps && vt.generateMipmap(3553), J.unbindTexture();
    }, this.copyTextureToTexture3D = function(t1, e, n, i, r = 0) {
        if (v.isWebGL1Renderer) return void console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: can only be used with WebGL2.");
        const s = t1.max.x - t1.min.x + 1, a = t1.max.y - t1.min.y + 1, o = t1.max.z - t1.min.z + 1, l = ft.convert(i.format), h = ft.convert(i.type);
        let c;
        if (i.isData3DTexture) Q.setTexture3D(i, 0), c = 32879;
        else {
            if (!i.isDataArrayTexture) return void console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: only supports THREE.DataTexture3D and THREE.DataTexture2DArray.");
            Q.setTexture2DArray(i, 0), c = 35866;
        }
        vt.pixelStorei(37440, i.flipY), vt.pixelStorei(37441, i.premultiplyAlpha), vt.pixelStorei(3317, i.unpackAlignment);
        const u = vt.getParameter(3314), d = vt.getParameter(32878), p = vt.getParameter(3316), m = vt.getParameter(3315), f = vt.getParameter(32877), g = n.isCompressedTexture ? n.mipmaps[0] : n.image;
        vt.pixelStorei(3314, g.width), vt.pixelStorei(32878, g.height), vt.pixelStorei(3316, t1.min.x), vt.pixelStorei(3315, t1.min.y), vt.pixelStorei(32877, t1.min.z), n.isDataTexture || n.isData3DTexture ? vt.texSubImage3D(c, r, e.x, e.y, e.z, s, a, o, l, h, g.data) : n.isCompressedTexture ? (console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: untested support for compressed srcTexture."), vt.compressedTexSubImage3D(c, r, e.x, e.y, e.z, s, a, o, l, g.data)) : vt.texSubImage3D(c, r, e.x, e.y, e.z, s, a, o, l, h, g), vt.pixelStorei(3314, u), vt.pixelStorei(32878, d), vt.pixelStorei(3316, p), vt.pixelStorei(3315, m), vt.pixelStorei(32877, f), 0 === r && i.generateMipmaps && vt.generateMipmap(c), J.unbindTexture();
    }, this.initTexture = function(t1) {
        Q.setTexture2D(t1, 0), J.unbindTexture();
    }, this.resetState = function() {
        b = 0, _ = 0, w = null, J.reset(), gt.reset();
    }, "undefined" != typeof __THREE_DEVTOOLS__ && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
        detail: this
    }));
}
$fd4eb456bcbd06f8$var$Or.prototype.isWebGLRenderer = !0;
(class extends $fd4eb456bcbd06f8$var$Or {
}).prototype.isWebGL1Renderer = !0;
class $fd4eb456bcbd06f8$var$Nr extends $fd4eb456bcbd06f8$var$Wt {
    constructor(){
        super(), this.type = "Scene", this.background = null, this.environment = null, this.fog = null, this.overrideMaterial = null, this.autoUpdate = !0, "undefined" != typeof __THREE_DEVTOOLS__ && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
            detail: this
        }));
    }
    copy(t1, e) {
        return super.copy(t1, e), null !== t1.background && (this.background = t1.background.clone()), null !== t1.environment && (this.environment = t1.environment.clone()), null !== t1.fog && (this.fog = t1.fog.clone()), null !== t1.overrideMaterial && (this.overrideMaterial = t1.overrideMaterial.clone()), this.autoUpdate = t1.autoUpdate, this.matrixAutoUpdate = t1.matrixAutoUpdate, this;
    }
    toJSON(t1) {
        const e = super.toJSON(t1);
        return null !== this.fog && (e.object.fog = this.fog.toJSON()), e;
    }
}
$fd4eb456bcbd06f8$var$Nr.prototype.isScene = !0;
class $fd4eb456bcbd06f8$var$Fr {
    constructor(t1, e){
        this.array = t1, this.stride = e, this.count = void 0 !== t1 ? t1.length / e : 0, this.usage = 35044, this.updateRange = {
            offset: 0,
            count: -1
        }, this.version = 0, this.uuid = $fd4eb456bcbd06f8$var$l();
    }
    onUploadCallback() {}
    set needsUpdate(t1) {
        !0 === t1 && this.version++;
    }
    setUsage(t1) {
        return this.usage = t1, this;
    }
    copy(t1) {
        return this.array = new t1.array.constructor(t1.array), this.count = t1.count, this.stride = t1.stride, this.usage = t1.usage, this;
    }
    copyAt(t1, e, n) {
        t1 *= this.stride, n *= e.stride;
        for(let i = 0, r = this.stride; i < r; i++)this.array[t1 + i] = e.array[n + i];
        return this;
    }
    set(t1, e = 0) {
        return this.array.set(t1, e), this;
    }
    clone(t1) {
        void 0 === t1.arrayBuffers && (t1.arrayBuffers = {}), void 0 === this.array.buffer._uuid && (this.array.buffer._uuid = $fd4eb456bcbd06f8$var$l()), void 0 === t1.arrayBuffers[this.array.buffer._uuid] && (t1.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer);
        const e = new this.array.constructor(t1.arrayBuffers[this.array.buffer._uuid]), n = new this.constructor(e, this.stride);
        return n.setUsage(this.usage), n;
    }
    onUpload(t1) {
        return this.onUploadCallback = t1, this;
    }
    toJSON(t1) {
        return void 0 === t1.arrayBuffers && (t1.arrayBuffers = {}), void 0 === this.array.buffer._uuid && (this.array.buffer._uuid = $fd4eb456bcbd06f8$var$l()), void 0 === t1.arrayBuffers[this.array.buffer._uuid] && (t1.arrayBuffers[this.array.buffer._uuid] = Array.prototype.slice.call(new Uint32Array(this.array.buffer))), {
            uuid: this.uuid,
            buffer: this.array.buffer._uuid,
            type: this.array.constructor.name,
            stride: this.stride
        };
    }
}
$fd4eb456bcbd06f8$var$Fr.prototype.isInterleavedBuffer = !0;
const $fd4eb456bcbd06f8$var$Ur = new $fd4eb456bcbd06f8$var$V;
class $fd4eb456bcbd06f8$var$kr {
    constructor(t1, e, n, i = !1){
        this.name = "", this.data = t1, this.itemSize = e, this.offset = n, this.normalized = !0 === i;
    }
    get count() {
        return this.data.count;
    }
    get array() {
        return this.data.array;
    }
    set needsUpdate(t1) {
        this.data.needsUpdate = t1;
    }
    applyMatrix4(t1) {
        for(let e = 0, n = this.data.count; e < n; e++)$fd4eb456bcbd06f8$var$Ur.fromBufferAttribute(this, e), $fd4eb456bcbd06f8$var$Ur.applyMatrix4(t1), this.setXYZ(e, $fd4eb456bcbd06f8$var$Ur.x, $fd4eb456bcbd06f8$var$Ur.y, $fd4eb456bcbd06f8$var$Ur.z);
        return this;
    }
    applyNormalMatrix(t1) {
        for(let e = 0, n = this.count; e < n; e++)$fd4eb456bcbd06f8$var$Ur.fromBufferAttribute(this, e), $fd4eb456bcbd06f8$var$Ur.applyNormalMatrix(t1), this.setXYZ(e, $fd4eb456bcbd06f8$var$Ur.x, $fd4eb456bcbd06f8$var$Ur.y, $fd4eb456bcbd06f8$var$Ur.z);
        return this;
    }
    transformDirection(t1) {
        for(let e = 0, n = this.count; e < n; e++)$fd4eb456bcbd06f8$var$Ur.fromBufferAttribute(this, e), $fd4eb456bcbd06f8$var$Ur.transformDirection(t1), this.setXYZ(e, $fd4eb456bcbd06f8$var$Ur.x, $fd4eb456bcbd06f8$var$Ur.y, $fd4eb456bcbd06f8$var$Ur.z);
        return this;
    }
    setX(t1, e) {
        return this.data.array[t1 * this.data.stride + this.offset] = e, this;
    }
    setY(t1, e) {
        return this.data.array[t1 * this.data.stride + this.offset + 1] = e, this;
    }
    setZ(t1, e) {
        return this.data.array[t1 * this.data.stride + this.offset + 2] = e, this;
    }
    setW(t1, e) {
        return this.data.array[t1 * this.data.stride + this.offset + 3] = e, this;
    }
    getX(t1) {
        return this.data.array[t1 * this.data.stride + this.offset];
    }
    getY(t1) {
        return this.data.array[t1 * this.data.stride + this.offset + 1];
    }
    getZ(t1) {
        return this.data.array[t1 * this.data.stride + this.offset + 2];
    }
    getW(t1) {
        return this.data.array[t1 * this.data.stride + this.offset + 3];
    }
    setXY(t1, e, n) {
        return t1 = t1 * this.data.stride + this.offset, this.data.array[t1 + 0] = e, this.data.array[t1 + 1] = n, this;
    }
    setXYZ(t1, e, n, i) {
        return t1 = t1 * this.data.stride + this.offset, this.data.array[t1 + 0] = e, this.data.array[t1 + 1] = n, this.data.array[t1 + 2] = i, this;
    }
    setXYZW(t1, e, n, i, r) {
        return t1 = t1 * this.data.stride + this.offset, this.data.array[t1 + 0] = e, this.data.array[t1 + 1] = n, this.data.array[t1 + 2] = i, this.data.array[t1 + 3] = r, this;
    }
    clone(t1) {
        if (void 0 === t1) {
            console.log("THREE.InterleavedBufferAttribute.clone(): Cloning an interlaved buffer attribute will deinterleave buffer data.");
            const t1 = [];
            for(let e = 0; e < this.count; e++){
                const n = e * this.data.stride + this.offset;
                for(let e = 0; e < this.itemSize; e++)t1.push(this.data.array[n + e]);
            }
            return new $fd4eb456bcbd06f8$var$oe(new this.array.constructor(t1), this.itemSize, this.normalized);
        }
        return void 0 === t1.interleavedBuffers && (t1.interleavedBuffers = {}), void 0 === t1.interleavedBuffers[this.data.uuid] && (t1.interleavedBuffers[this.data.uuid] = this.data.clone(t1)), new $fd4eb456bcbd06f8$var$kr(t1.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
    }
    toJSON(t1) {
        if (void 0 === t1) {
            console.log("THREE.InterleavedBufferAttribute.toJSON(): Serializing an interlaved buffer attribute will deinterleave buffer data.");
            const t1 = [];
            for(let e = 0; e < this.count; e++){
                const n = e * this.data.stride + this.offset;
                for(let e = 0; e < this.itemSize; e++)t1.push(this.data.array[n + e]);
            }
            return {
                itemSize: this.itemSize,
                type: this.array.constructor.name,
                array: t1,
                normalized: this.normalized
            };
        }
        return void 0 === t1.interleavedBuffers && (t1.interleavedBuffers = {}), void 0 === t1.interleavedBuffers[this.data.uuid] && (t1.interleavedBuffers[this.data.uuid] = this.data.toJSON(t1)), {
            isInterleavedBufferAttribute: !0,
            itemSize: this.itemSize,
            data: this.data.uuid,
            offset: this.offset,
            normalized: this.normalized
        };
    }
}
$fd4eb456bcbd06f8$var$kr.prototype.isInterleavedBufferAttribute = !0;
class $fd4eb456bcbd06f8$var$Br extends $fd4eb456bcbd06f8$var$ie {
    constructor(t1){
        super(), this.type = "SpriteMaterial", this.color = new $fd4eb456bcbd06f8$var$L(16777215), this.map = null, this.alphaMap = null, this.rotation = 0, this.sizeAttenuation = !0, this.transparent = !0, this.setValues(t1);
    }
    copy(t1) {
        return super.copy(t1), this.color.copy(t1.color), this.map = t1.map, this.alphaMap = t1.alphaMap, this.rotation = t1.rotation, this.sizeAttenuation = t1.sizeAttenuation, this;
    }
}
let $fd4eb456bcbd06f8$var$zr;
$fd4eb456bcbd06f8$var$Br.prototype.isSpriteMaterial = !0;
const $fd4eb456bcbd06f8$var$Hr = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$Vr = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$Gr = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$Wr = new $fd4eb456bcbd06f8$var$g, $fd4eb456bcbd06f8$var$jr = new $fd4eb456bcbd06f8$var$g, $fd4eb456bcbd06f8$var$qr = new $fd4eb456bcbd06f8$var$xt, $fd4eb456bcbd06f8$var$Xr = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$$r = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$Yr = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$Jr = new $fd4eb456bcbd06f8$var$g, $fd4eb456bcbd06f8$var$Kr = new $fd4eb456bcbd06f8$var$g, $fd4eb456bcbd06f8$var$Zr = new $fd4eb456bcbd06f8$var$g;
function $fd4eb456bcbd06f8$var$Qr(t1, e, n, i, r, s) {
    $fd4eb456bcbd06f8$var$Wr.subVectors(t1, n).addScalar(.5).multiply(i), void 0 !== r ? ($fd4eb456bcbd06f8$var$jr.x = s * $fd4eb456bcbd06f8$var$Wr.x - r * $fd4eb456bcbd06f8$var$Wr.y, $fd4eb456bcbd06f8$var$jr.y = r * $fd4eb456bcbd06f8$var$Wr.x + s * $fd4eb456bcbd06f8$var$Wr.y) : $fd4eb456bcbd06f8$var$jr.copy($fd4eb456bcbd06f8$var$Wr), t1.copy(e), t1.x += $fd4eb456bcbd06f8$var$jr.x, t1.y += $fd4eb456bcbd06f8$var$jr.y, t1.applyMatrix4($fd4eb456bcbd06f8$var$qr);
}
(class extends $fd4eb456bcbd06f8$var$Wt {
    constructor(t1){
        if (super(), this.type = "Sprite", void 0 === $fd4eb456bcbd06f8$var$zr) {
            $fd4eb456bcbd06f8$var$zr = new $fd4eb456bcbd06f8$var$ye;
            const t1 = new Float32Array([
                -0.5,
                -0.5,
                0,
                0,
                0,
                .5,
                -0.5,
                0,
                1,
                0,
                .5,
                .5,
                0,
                1,
                1,
                -0.5,
                .5,
                0,
                0,
                1
            ]), e = new $fd4eb456bcbd06f8$var$Fr(t1, 5);
            $fd4eb456bcbd06f8$var$zr.setIndex([
                0,
                1,
                2,
                0,
                2,
                3
            ]), $fd4eb456bcbd06f8$var$zr.setAttribute("position", new $fd4eb456bcbd06f8$var$kr(e, 3, 0, !1)), $fd4eb456bcbd06f8$var$zr.setAttribute("uv", new $fd4eb456bcbd06f8$var$kr(e, 2, 3, !1));
        }
        this.geometry = $fd4eb456bcbd06f8$var$zr, this.material = void 0 !== t1 ? t1 : new $fd4eb456bcbd06f8$var$Br, this.center = new $fd4eb456bcbd06f8$var$g(.5, .5);
    }
    raycast(t1, e) {
        null === t1.camera && console.error('THREE.Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.'), $fd4eb456bcbd06f8$var$Vr.setFromMatrixScale(this.matrixWorld), $fd4eb456bcbd06f8$var$qr.copy(t1.camera.matrixWorld), this.modelViewMatrix.multiplyMatrices(t1.camera.matrixWorldInverse, this.matrixWorld), $fd4eb456bcbd06f8$var$Gr.setFromMatrixPosition(this.modelViewMatrix), t1.camera.isPerspectiveCamera && !1 === this.material.sizeAttenuation && $fd4eb456bcbd06f8$var$Vr.multiplyScalar(-$fd4eb456bcbd06f8$var$Gr.z);
        const n = this.material.rotation;
        let i, r;
        0 !== n && (r = Math.cos(n), i = Math.sin(n));
        const s = this.center;
        $fd4eb456bcbd06f8$var$Qr($fd4eb456bcbd06f8$var$Xr.set(-0.5, -0.5, 0), $fd4eb456bcbd06f8$var$Gr, s, $fd4eb456bcbd06f8$var$Vr, i, r), $fd4eb456bcbd06f8$var$Qr($fd4eb456bcbd06f8$var$$r.set(.5, -0.5, 0), $fd4eb456bcbd06f8$var$Gr, s, $fd4eb456bcbd06f8$var$Vr, i, r), $fd4eb456bcbd06f8$var$Qr($fd4eb456bcbd06f8$var$Yr.set(.5, .5, 0), $fd4eb456bcbd06f8$var$Gr, s, $fd4eb456bcbd06f8$var$Vr, i, r), $fd4eb456bcbd06f8$var$Jr.set(0, 0), $fd4eb456bcbd06f8$var$Kr.set(1, 0), $fd4eb456bcbd06f8$var$Zr.set(1, 1);
        let a = t1.ray.intersectTriangle($fd4eb456bcbd06f8$var$Xr, $fd4eb456bcbd06f8$var$$r, $fd4eb456bcbd06f8$var$Yr, !1, $fd4eb456bcbd06f8$var$Hr);
        if (null === a && ($fd4eb456bcbd06f8$var$Qr($fd4eb456bcbd06f8$var$$r.set(-0.5, .5, 0), $fd4eb456bcbd06f8$var$Gr, s, $fd4eb456bcbd06f8$var$Vr, i, r), $fd4eb456bcbd06f8$var$Kr.set(0, 1), a = t1.ray.intersectTriangle($fd4eb456bcbd06f8$var$Xr, $fd4eb456bcbd06f8$var$Yr, $fd4eb456bcbd06f8$var$$r, !1, $fd4eb456bcbd06f8$var$Hr), null === a)) return;
        const o = t1.ray.origin.distanceTo($fd4eb456bcbd06f8$var$Hr);
        o < t1.near || o > t1.far || e.push({
            distance: o,
            point: $fd4eb456bcbd06f8$var$Hr.clone(),
            uv: $fd4eb456bcbd06f8$var$ee.getUV($fd4eb456bcbd06f8$var$Hr, $fd4eb456bcbd06f8$var$Xr, $fd4eb456bcbd06f8$var$$r, $fd4eb456bcbd06f8$var$Yr, $fd4eb456bcbd06f8$var$Jr, $fd4eb456bcbd06f8$var$Kr, $fd4eb456bcbd06f8$var$Zr, new $fd4eb456bcbd06f8$var$g),
            face: null,
            object: this
        });
    }
    copy(t1) {
        return super.copy(t1), void 0 !== t1.center && this.center.copy(t1.center), this.material = t1.material, this;
    }
}).prototype.isSprite = !0;
const $fd4eb456bcbd06f8$var$ts = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$es = new $fd4eb456bcbd06f8$var$U, $fd4eb456bcbd06f8$var$ns = new $fd4eb456bcbd06f8$var$U, $fd4eb456bcbd06f8$var$is = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$rs = new $fd4eb456bcbd06f8$var$xt;
class $fd4eb456bcbd06f8$var$ss extends $fd4eb456bcbd06f8$var$Fe {
    constructor(t1, e){
        super(t1, e), this.type = "SkinnedMesh", this.bindMode = "attached", this.bindMatrix = new $fd4eb456bcbd06f8$var$xt, this.bindMatrixInverse = new $fd4eb456bcbd06f8$var$xt;
    }
    copy(t1) {
        return super.copy(t1), this.bindMode = t1.bindMode, this.bindMatrix.copy(t1.bindMatrix), this.bindMatrixInverse.copy(t1.bindMatrixInverse), this.skeleton = t1.skeleton, this;
    }
    bind(t1, e) {
        this.skeleton = t1, void 0 === e && (this.updateMatrixWorld(!0), this.skeleton.calculateInverses(), e = this.matrixWorld), this.bindMatrix.copy(e), this.bindMatrixInverse.copy(e).invert();
    }
    pose() {
        this.skeleton.pose();
    }
    normalizeSkinWeights() {
        const t1 = new $fd4eb456bcbd06f8$var$U, e = this.geometry.attributes.skinWeight;
        for(let n = 0, i = e.count; n < i; n++){
            t1.fromBufferAttribute(e, n);
            const i = 1 / t1.manhattanLength();
            i !== 1 / 0 ? t1.multiplyScalar(i) : t1.set(1, 0, 0, 0), e.setXYZW(n, t1.x, t1.y, t1.z, t1.w);
        }
    }
    updateMatrixWorld(t1) {
        super.updateMatrixWorld(t1), "attached" === this.bindMode ? this.bindMatrixInverse.copy(this.matrixWorld).invert() : "detached" === this.bindMode ? this.bindMatrixInverse.copy(this.bindMatrix).invert() : console.warn("THREE.SkinnedMesh: Unrecognized bindMode: " + this.bindMode);
    }
    boneTransform(t1, e) {
        const n = this.skeleton, i = this.geometry;
        $fd4eb456bcbd06f8$var$es.fromBufferAttribute(i.attributes.skinIndex, t1), $fd4eb456bcbd06f8$var$ns.fromBufferAttribute(i.attributes.skinWeight, t1), $fd4eb456bcbd06f8$var$ts.copy(e).applyMatrix4(this.bindMatrix), e.set(0, 0, 0);
        for(let t1 = 0; t1 < 4; t1++){
            const i = $fd4eb456bcbd06f8$var$ns.getComponent(t1);
            if (0 !== i) {
                const r = $fd4eb456bcbd06f8$var$es.getComponent(t1);
                $fd4eb456bcbd06f8$var$rs.multiplyMatrices(n.bones[r].matrixWorld, n.boneInverses[r]), e.addScaledVector($fd4eb456bcbd06f8$var$is.copy($fd4eb456bcbd06f8$var$ts).applyMatrix4($fd4eb456bcbd06f8$var$rs), i);
            }
        }
        return e.applyMatrix4(this.bindMatrixInverse);
    }
}
$fd4eb456bcbd06f8$var$ss.prototype.isSkinnedMesh = !0;
class $fd4eb456bcbd06f8$var$as extends $fd4eb456bcbd06f8$var$Wt {
    constructor(){
        super(), this.type = "Bone";
    }
}
$fd4eb456bcbd06f8$var$as.prototype.isBone = !0;
class $fd4eb456bcbd06f8$var$os extends $fd4eb456bcbd06f8$var$F {
    constructor(t1 = null, e = 1, n = 1, i, r, s, a, o, l = 1003, h = 1003, c, u){
        super(null, s, a, o, l, h, i, r, c, u), this.image = {
            data: t1,
            width: e,
            height: n
        }, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
    }
}
$fd4eb456bcbd06f8$var$os.prototype.isDataTexture = !0;
const $fd4eb456bcbd06f8$var$ls = new $fd4eb456bcbd06f8$var$xt, $fd4eb456bcbd06f8$var$hs = new $fd4eb456bcbd06f8$var$xt;
class $fd4eb456bcbd06f8$var$cs {
    constructor(t1 = [], e = []){
        this.uuid = $fd4eb456bcbd06f8$var$l(), this.bones = t1.slice(0), this.boneInverses = e, this.boneMatrices = null, this.boneTexture = null, this.boneTextureSize = 0, this.frame = -1, this.init();
    }
    init() {
        const t1 = this.bones, e = this.boneInverses;
        if (this.boneMatrices = new Float32Array(16 * t1.length), 0 === e.length) this.calculateInverses();
        else if (t1.length !== e.length) {
            console.warn("THREE.Skeleton: Number of inverse bone matrices does not match amount of bones."), this.boneInverses = [];
            for(let t1 = 0, e = this.bones.length; t1 < e; t1++)this.boneInverses.push(new $fd4eb456bcbd06f8$var$xt);
        }
    }
    calculateInverses() {
        this.boneInverses.length = 0;
        for(let t1 = 0, e = this.bones.length; t1 < e; t1++){
            const e = new $fd4eb456bcbd06f8$var$xt;
            this.bones[t1] && e.copy(this.bones[t1].matrixWorld).invert(), this.boneInverses.push(e);
        }
    }
    pose() {
        for(let t1 = 0, e = this.bones.length; t1 < e; t1++){
            const e = this.bones[t1];
            e && e.matrixWorld.copy(this.boneInverses[t1]).invert();
        }
        for(let t1 = 0, e = this.bones.length; t1 < e; t1++){
            const e = this.bones[t1];
            e && (e.parent && e.parent.isBone ? (e.matrix.copy(e.parent.matrixWorld).invert(), e.matrix.multiply(e.matrixWorld)) : e.matrix.copy(e.matrixWorld), e.matrix.decompose(e.position, e.quaternion, e.scale));
        }
    }
    update() {
        const t1 = this.bones, e = this.boneInverses, n = this.boneMatrices, i = this.boneTexture;
        for(let i = 0, r = t1.length; i < r; i++){
            const r = t1[i] ? t1[i].matrixWorld : $fd4eb456bcbd06f8$var$hs;
            $fd4eb456bcbd06f8$var$ls.multiplyMatrices(r, e[i]), $fd4eb456bcbd06f8$var$ls.toArray(n, 16 * i);
        }
        null !== i && (i.needsUpdate = !0);
    }
    clone() {
        return new $fd4eb456bcbd06f8$var$cs(this.bones, this.boneInverses);
    }
    computeBoneTexture() {
        let t1 = Math.sqrt(4 * this.bones.length);
        t1 = $fd4eb456bcbd06f8$var$p(t1), t1 = Math.max(t1, 4);
        const e = new Float32Array(t1 * t1 * 4);
        e.set(this.boneMatrices);
        const n = new $fd4eb456bcbd06f8$var$os(e, t1, t1, 1023, 1015);
        return n.needsUpdate = !0, this.boneMatrices = e, this.boneTexture = n, this.boneTextureSize = t1, this;
    }
    getBoneByName(t1) {
        for(let e = 0, n = this.bones.length; e < n; e++){
            const n = this.bones[e];
            if (n.name === t1) return n;
        }
    }
    dispose() {
        null !== this.boneTexture && (this.boneTexture.dispose(), this.boneTexture = null);
    }
    fromJSON(t1, e) {
        this.uuid = t1.uuid;
        for(let n = 0, i = t1.bones.length; n < i; n++){
            const i = t1.bones[n];
            let r = e[i];
            void 0 === r && (console.warn("THREE.Skeleton: No bone found with UUID:", i), r = new $fd4eb456bcbd06f8$var$as), this.bones.push(r), this.boneInverses.push((new $fd4eb456bcbd06f8$var$xt).fromArray(t1.boneInverses[n]));
        }
        return this.init(), this;
    }
    toJSON() {
        const t1 = {
            metadata: {
                version: 4.5,
                type: "Skeleton",
                generator: "Skeleton.toJSON"
            },
            bones: [],
            boneInverses: []
        };
        t1.uuid = this.uuid;
        const e = this.bones, n = this.boneInverses;
        for(let i = 0, r = e.length; i < r; i++){
            const r = e[i];
            t1.bones.push(r.uuid);
            const s = n[i];
            t1.boneInverses.push(s.toArray());
        }
        return t1;
    }
}
class $fd4eb456bcbd06f8$var$us extends $fd4eb456bcbd06f8$var$oe {
    constructor(t1, e, n, i = 1){
        "number" == typeof n && (i = n, n = !1, console.error("THREE.InstancedBufferAttribute: The constructor now expects normalized as the third argument.")), super(t1, e, n), this.meshPerAttribute = i;
    }
    copy(t1) {
        return super.copy(t1), this.meshPerAttribute = t1.meshPerAttribute, this;
    }
    toJSON() {
        const t1 = super.toJSON();
        return t1.meshPerAttribute = this.meshPerAttribute, t1.isInstancedBufferAttribute = !0, t1;
    }
}
$fd4eb456bcbd06f8$var$us.prototype.isInstancedBufferAttribute = !0;
const $fd4eb456bcbd06f8$var$ds = new $fd4eb456bcbd06f8$var$xt, $fd4eb456bcbd06f8$var$ps = new $fd4eb456bcbd06f8$var$xt, $fd4eb456bcbd06f8$var$ms = [], $fd4eb456bcbd06f8$var$fs = new $fd4eb456bcbd06f8$var$Fe;
(class extends $fd4eb456bcbd06f8$var$Fe {
    constructor(t1, e, n){
        super(t1, e), this.instanceMatrix = new $fd4eb456bcbd06f8$var$us(new Float32Array(16 * n), 16), this.instanceColor = null, this.count = n, this.frustumCulled = !1;
    }
    copy(t1) {
        return super.copy(t1), this.instanceMatrix.copy(t1.instanceMatrix), null !== t1.instanceColor && (this.instanceColor = t1.instanceColor.clone()), this.count = t1.count, this;
    }
    getColorAt(t1, e) {
        e.fromArray(this.instanceColor.array, 3 * t1);
    }
    getMatrixAt(t1, e) {
        e.fromArray(this.instanceMatrix.array, 16 * t1);
    }
    raycast(t1, e) {
        const n = this.matrixWorld, i = this.count;
        if ($fd4eb456bcbd06f8$var$fs.geometry = this.geometry, $fd4eb456bcbd06f8$var$fs.material = this.material, void 0 !== $fd4eb456bcbd06f8$var$fs.material) for(let r = 0; r < i; r++){
            this.getMatrixAt(r, $fd4eb456bcbd06f8$var$ds), $fd4eb456bcbd06f8$var$ps.multiplyMatrices(n, $fd4eb456bcbd06f8$var$ds), $fd4eb456bcbd06f8$var$fs.matrixWorld = $fd4eb456bcbd06f8$var$ps, $fd4eb456bcbd06f8$var$fs.raycast(t1, $fd4eb456bcbd06f8$var$ms);
            for(let t1 = 0, n = $fd4eb456bcbd06f8$var$ms.length; t1 < n; t1++){
                const n = $fd4eb456bcbd06f8$var$ms[t1];
                n.instanceId = r, n.object = this, e.push(n);
            }
            $fd4eb456bcbd06f8$var$ms.length = 0;
        }
    }
    setColorAt(t1, e) {
        null === this.instanceColor && (this.instanceColor = new $fd4eb456bcbd06f8$var$us(new Float32Array(3 * this.instanceMatrix.count), 3)), e.toArray(this.instanceColor.array, 3 * t1);
    }
    setMatrixAt(t1, e) {
        e.toArray(this.instanceMatrix.array, 16 * t1);
    }
    updateMorphTargets() {}
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}).prototype.isInstancedMesh = !0;
class $fd4eb456bcbd06f8$var$gs extends $fd4eb456bcbd06f8$var$ie {
    constructor(t1){
        super(), this.type = "LineBasicMaterial", this.color = new $fd4eb456bcbd06f8$var$L(16777215), this.linewidth = 1, this.linecap = "round", this.linejoin = "round", this.setValues(t1);
    }
    copy(t1) {
        return super.copy(t1), this.color.copy(t1.color), this.linewidth = t1.linewidth, this.linecap = t1.linecap, this.linejoin = t1.linejoin, this;
    }
}
$fd4eb456bcbd06f8$var$gs.prototype.isLineBasicMaterial = !0;
const $fd4eb456bcbd06f8$var$vs = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$ys = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$xs = new $fd4eb456bcbd06f8$var$xt, $fd4eb456bcbd06f8$var$bs = new $fd4eb456bcbd06f8$var$yt, $fd4eb456bcbd06f8$var$_s = new $fd4eb456bcbd06f8$var$ct;
class $fd4eb456bcbd06f8$var$ws extends $fd4eb456bcbd06f8$var$Wt {
    constructor(t1 = new $fd4eb456bcbd06f8$var$ye, e = new $fd4eb456bcbd06f8$var$gs){
        super(), this.type = "Line", this.geometry = t1, this.material = e, this.updateMorphTargets();
    }
    copy(t1) {
        return super.copy(t1), this.material = t1.material, this.geometry = t1.geometry, this;
    }
    computeLineDistances() {
        const t1 = this.geometry;
        if (t1.isBufferGeometry) {
            if (null === t1.index) {
                const e = t1.attributes.position, n = [
                    0
                ];
                for(let t1 = 1, i = e.count; t1 < i; t1++)$fd4eb456bcbd06f8$var$vs.fromBufferAttribute(e, t1 - 1), $fd4eb456bcbd06f8$var$ys.fromBufferAttribute(e, t1), n[t1] = n[t1 - 1], n[t1] += $fd4eb456bcbd06f8$var$vs.distanceTo($fd4eb456bcbd06f8$var$ys);
                t1.setAttribute("lineDistance", new $fd4eb456bcbd06f8$var$ce(n, 1));
            } else console.warn("THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
        } else t1.isGeometry && console.error("THREE.Line.computeLineDistances() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
        return this;
    }
    raycast(t1, e) {
        const n = this.geometry, i = this.matrixWorld, r = t1.params.Line.threshold, s = n.drawRange;
        if (null === n.boundingSphere && n.computeBoundingSphere(), $fd4eb456bcbd06f8$var$_s.copy(n.boundingSphere), $fd4eb456bcbd06f8$var$_s.applyMatrix4(i), $fd4eb456bcbd06f8$var$_s.radius += r, !1 === t1.ray.intersectsSphere($fd4eb456bcbd06f8$var$_s)) return;
        $fd4eb456bcbd06f8$var$xs.copy(i).invert(), $fd4eb456bcbd06f8$var$bs.copy(t1.ray).applyMatrix4($fd4eb456bcbd06f8$var$xs);
        const a = r / ((this.scale.x + this.scale.y + this.scale.z) / 3), o = a * a, l = new $fd4eb456bcbd06f8$var$V, h = new $fd4eb456bcbd06f8$var$V, c = new $fd4eb456bcbd06f8$var$V, u = new $fd4eb456bcbd06f8$var$V, d = this.isLineSegments ? 2 : 1;
        if (n.isBufferGeometry) {
            const i = n.index, r = n.attributes.position;
            if (null !== i) for(let n = Math.max(0, s.start), a = Math.min(i.count, s.start + s.count) - 1; n < a; n += d){
                const s = i.getX(n), a = i.getX(n + 1);
                l.fromBufferAttribute(r, s), h.fromBufferAttribute(r, a);
                if ($fd4eb456bcbd06f8$var$bs.distanceSqToSegment(l, h, u, c) > o) continue;
                u.applyMatrix4(this.matrixWorld);
                const d = t1.ray.origin.distanceTo(u);
                d < t1.near || d > t1.far || e.push({
                    distance: d,
                    point: c.clone().applyMatrix4(this.matrixWorld),
                    index: n,
                    face: null,
                    faceIndex: null,
                    object: this
                });
            }
            else for(let n = Math.max(0, s.start), i = Math.min(r.count, s.start + s.count) - 1; n < i; n += d){
                l.fromBufferAttribute(r, n), h.fromBufferAttribute(r, n + 1);
                if ($fd4eb456bcbd06f8$var$bs.distanceSqToSegment(l, h, u, c) > o) continue;
                u.applyMatrix4(this.matrixWorld);
                const i = t1.ray.origin.distanceTo(u);
                i < t1.near || i > t1.far || e.push({
                    distance: i,
                    point: c.clone().applyMatrix4(this.matrixWorld),
                    index: n,
                    face: null,
                    faceIndex: null,
                    object: this
                });
            }
        } else n.isGeometry && console.error("THREE.Line.raycast() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
    }
    updateMorphTargets() {
        const t1 = this.geometry;
        if (t1.isBufferGeometry) {
            const e = t1.morphAttributes, n = Object.keys(e);
            if (n.length > 0) {
                const t1 = e[n[0]];
                if (void 0 !== t1) {
                    this.morphTargetInfluences = [], this.morphTargetDictionary = {};
                    for(let e = 0, n = t1.length; e < n; e++){
                        const n = t1[e].name || String(e);
                        this.morphTargetInfluences.push(0), this.morphTargetDictionary[n] = e;
                    }
                }
            }
        } else {
            const e = t1.morphTargets;
            void 0 !== e && e.length > 0 && console.error("THREE.Line.updateMorphTargets() does not support THREE.Geometry. Use THREE.BufferGeometry instead.");
        }
    }
}
$fd4eb456bcbd06f8$var$ws.prototype.isLine = !0;
const $fd4eb456bcbd06f8$var$Ms = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$Ss = new $fd4eb456bcbd06f8$var$V;
class $fd4eb456bcbd06f8$var$Ts extends $fd4eb456bcbd06f8$var$ws {
    constructor(t1, e){
        super(t1, e), this.type = "LineSegments";
    }
    computeLineDistances() {
        const t1 = this.geometry;
        if (t1.isBufferGeometry) {
            if (null === t1.index) {
                const e = t1.attributes.position, n = [];
                for(let t1 = 0, i = e.count; t1 < i; t1 += 2)$fd4eb456bcbd06f8$var$Ms.fromBufferAttribute(e, t1), $fd4eb456bcbd06f8$var$Ss.fromBufferAttribute(e, t1 + 1), n[t1] = 0 === t1 ? 0 : n[t1 - 1], n[t1 + 1] = n[t1] + $fd4eb456bcbd06f8$var$Ms.distanceTo($fd4eb456bcbd06f8$var$Ss);
                t1.setAttribute("lineDistance", new $fd4eb456bcbd06f8$var$ce(n, 1));
            } else console.warn("THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
        } else t1.isGeometry && console.error("THREE.LineSegments.computeLineDistances() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
        return this;
    }
}
$fd4eb456bcbd06f8$var$Ts.prototype.isLineSegments = !0;
class $fd4eb456bcbd06f8$var$Es extends $fd4eb456bcbd06f8$var$ws {
    constructor(t1, e){
        super(t1, e), this.type = "LineLoop";
    }
}
$fd4eb456bcbd06f8$var$Es.prototype.isLineLoop = !0;
class $fd4eb456bcbd06f8$var$As extends $fd4eb456bcbd06f8$var$ie {
    constructor(t1){
        super(), this.type = "PointsMaterial", this.color = new $fd4eb456bcbd06f8$var$L(16777215), this.map = null, this.alphaMap = null, this.size = 1, this.sizeAttenuation = !0, this.setValues(t1);
    }
    copy(t1) {
        return super.copy(t1), this.color.copy(t1.color), this.map = t1.map, this.alphaMap = t1.alphaMap, this.size = t1.size, this.sizeAttenuation = t1.sizeAttenuation, this;
    }
}
$fd4eb456bcbd06f8$var$As.prototype.isPointsMaterial = !0;
const $fd4eb456bcbd06f8$var$Rs = new $fd4eb456bcbd06f8$var$xt, $fd4eb456bcbd06f8$var$Cs = new $fd4eb456bcbd06f8$var$yt, $fd4eb456bcbd06f8$var$Ls = new $fd4eb456bcbd06f8$var$ct, $fd4eb456bcbd06f8$var$Ps = new $fd4eb456bcbd06f8$var$V;
class $fd4eb456bcbd06f8$var$Ds extends $fd4eb456bcbd06f8$var$Wt {
    constructor(t1 = new $fd4eb456bcbd06f8$var$ye, e = new $fd4eb456bcbd06f8$var$As){
        super(), this.type = "Points", this.geometry = t1, this.material = e, this.updateMorphTargets();
    }
    copy(t1) {
        return super.copy(t1), this.material = t1.material, this.geometry = t1.geometry, this;
    }
    raycast(t1, e) {
        const n = this.geometry, i = this.matrixWorld, r = t1.params.Points.threshold, s = n.drawRange;
        if (null === n.boundingSphere && n.computeBoundingSphere(), $fd4eb456bcbd06f8$var$Ls.copy(n.boundingSphere), $fd4eb456bcbd06f8$var$Ls.applyMatrix4(i), $fd4eb456bcbd06f8$var$Ls.radius += r, !1 === t1.ray.intersectsSphere($fd4eb456bcbd06f8$var$Ls)) return;
        $fd4eb456bcbd06f8$var$Rs.copy(i).invert(), $fd4eb456bcbd06f8$var$Cs.copy(t1.ray).applyMatrix4($fd4eb456bcbd06f8$var$Rs);
        const a = r / ((this.scale.x + this.scale.y + this.scale.z) / 3), o = a * a;
        if (n.isBufferGeometry) {
            const r = n.index, a = n.attributes.position;
            if (null !== r) for(let n = Math.max(0, s.start), l = Math.min(r.count, s.start + s.count); n < l; n++){
                const s = r.getX(n);
                $fd4eb456bcbd06f8$var$Ps.fromBufferAttribute(a, s), $fd4eb456bcbd06f8$var$Is($fd4eb456bcbd06f8$var$Ps, s, o, i, t1, e, this);
            }
            else for(let n = Math.max(0, s.start), r = Math.min(a.count, s.start + s.count); n < r; n++)$fd4eb456bcbd06f8$var$Ps.fromBufferAttribute(a, n), $fd4eb456bcbd06f8$var$Is($fd4eb456bcbd06f8$var$Ps, n, o, i, t1, e, this);
        } else console.error("THREE.Points.raycast() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
    }
    updateMorphTargets() {
        const t1 = this.geometry;
        if (t1.isBufferGeometry) {
            const e = t1.morphAttributes, n = Object.keys(e);
            if (n.length > 0) {
                const t1 = e[n[0]];
                if (void 0 !== t1) {
                    this.morphTargetInfluences = [], this.morphTargetDictionary = {};
                    for(let e = 0, n = t1.length; e < n; e++){
                        const n = t1[e].name || String(e);
                        this.morphTargetInfluences.push(0), this.morphTargetDictionary[n] = e;
                    }
                }
            }
        } else {
            const e = t1.morphTargets;
            void 0 !== e && e.length > 0 && console.error("THREE.Points.updateMorphTargets() does not support THREE.Geometry. Use THREE.BufferGeometry instead.");
        }
    }
}
function $fd4eb456bcbd06f8$var$Is(t1, e, n, i, r, s, a) {
    const o = $fd4eb456bcbd06f8$var$Cs.distanceSqToPoint(t1);
    if (o < n) {
        const n = new $fd4eb456bcbd06f8$var$V;
        $fd4eb456bcbd06f8$var$Cs.closestPointToPoint(t1, n), n.applyMatrix4(i);
        const l = r.ray.origin.distanceTo(n);
        if (l < r.near || l > r.far) return;
        s.push({
            distance: l,
            distanceToRay: Math.sqrt(o),
            point: n,
            index: e,
            face: null,
            object: a
        });
    }
}
$fd4eb456bcbd06f8$var$Ds.prototype.isPoints = !0;
(class extends $fd4eb456bcbd06f8$var$F {
    constructor(t1, e, n, i, r, s, a, o, l){
        super(t1, e, n, i, r, s, a, o, l), this.minFilter = void 0 !== s ? s : 1006, this.magFilter = void 0 !== r ? r : 1006, this.generateMipmaps = !1;
        const h = this;
        "requestVideoFrameCallback" in t1 && t1.requestVideoFrameCallback(function e() {
            h.needsUpdate = !0, t1.requestVideoFrameCallback(e);
        });
    }
    clone() {
        return new this.constructor(this.image).copy(this);
    }
    update() {
        const t1 = this.image;
        !1 === "requestVideoFrameCallback" in t1 && t1.readyState >= t1.HAVE_CURRENT_DATA && (this.needsUpdate = !0);
    }
}).prototype.isVideoTexture = !0;
(class extends $fd4eb456bcbd06f8$var$F {
    constructor(t1, e, n){
        super({
            width: t1,
            height: e
        }), this.format = n, this.magFilter = 1003, this.minFilter = 1003, this.generateMipmaps = !1, this.needsUpdate = !0;
    }
}).prototype.isFramebufferTexture = !0;
class $fd4eb456bcbd06f8$var$Os extends $fd4eb456bcbd06f8$var$F {
    constructor(t1, e, n, i, r, s, a, o, l, h, c, u){
        super(null, s, a, o, l, h, i, r, c, u), this.image = {
            width: e,
            height: n
        }, this.mipmaps = t1, this.flipY = !1, this.generateMipmaps = !1;
    }
}
$fd4eb456bcbd06f8$var$Os.prototype.isCompressedTexture = !0;
(class extends $fd4eb456bcbd06f8$var$F {
    constructor(t1, e, n, i, r, s, a, o, l){
        super(t1, e, n, i, r, s, a, o, l), this.needsUpdate = !0;
    }
}).prototype.isCanvasTexture = !0;
class $fd4eb456bcbd06f8$var$Ns {
    constructor(){
        this.type = "Curve", this.arcLengthDivisions = 200;
    }
    getPoint() {
        return console.warn("THREE.Curve: .getPoint() not implemented."), null;
    }
    getPointAt(t1, e) {
        const n = this.getUtoTmapping(t1);
        return this.getPoint(n, e);
    }
    getPoints(t1 = 5) {
        const e = [];
        for(let n = 0; n <= t1; n++)e.push(this.getPoint(n / t1));
        return e;
    }
    getSpacedPoints(t1 = 5) {
        const e = [];
        for(let n = 0; n <= t1; n++)e.push(this.getPointAt(n / t1));
        return e;
    }
    getLength() {
        const t1 = this.getLengths();
        return t1[t1.length - 1];
    }
    getLengths(t1 = this.arcLengthDivisions) {
        if (this.cacheArcLengths && this.cacheArcLengths.length === t1 + 1 && !this.needsUpdate) return this.cacheArcLengths;
        this.needsUpdate = !1;
        const e = [];
        let n, i = this.getPoint(0), r = 0;
        e.push(0);
        for(let s = 1; s <= t1; s++)n = this.getPoint(s / t1), r += n.distanceTo(i), e.push(r), i = n;
        return this.cacheArcLengths = e, e;
    }
    updateArcLengths() {
        this.needsUpdate = !0, this.getLengths();
    }
    getUtoTmapping(t1, e) {
        const n = this.getLengths();
        let i = 0;
        const r = n.length;
        let s;
        s = e || t1 * n[r - 1];
        let a, o = 0, l = r - 1;
        for(; o <= l;)if (i = Math.floor(o + (l - o) / 2), a = n[i] - s, a < 0) o = i + 1;
        else {
            if (!(a > 0)) {
                l = i;
                break;
            }
            l = i - 1;
        }
        if (i = l, n[i] === s) return i / (r - 1);
        const h = n[i];
        return (i + (s - h) / (n[i + 1] - h)) / (r - 1);
    }
    getTangent(t1, e) {
        const n = 1e-4;
        let i = t1 - n, r = t1 + n;
        i < 0 && (i = 0), r > 1 && (r = 1);
        const s = this.getPoint(i), a = this.getPoint(r), o = e || (s.isVector2 ? new $fd4eb456bcbd06f8$var$g : new $fd4eb456bcbd06f8$var$V);
        return o.copy(a).sub(s).normalize(), o;
    }
    getTangentAt(t1, e) {
        const n = this.getUtoTmapping(t1);
        return this.getTangent(n, e);
    }
    computeFrenetFrames(t1, e) {
        const n = new $fd4eb456bcbd06f8$var$V, i = [], r = [], s = [], a = new $fd4eb456bcbd06f8$var$V, o = new $fd4eb456bcbd06f8$var$xt;
        for(let e = 0; e <= t1; e++){
            const n = e / t1;
            i[e] = this.getTangentAt(n, new $fd4eb456bcbd06f8$var$V);
        }
        r[0] = new $fd4eb456bcbd06f8$var$V, s[0] = new $fd4eb456bcbd06f8$var$V;
        let l = Number.MAX_VALUE;
        const c = Math.abs(i[0].x), u = Math.abs(i[0].y), d = Math.abs(i[0].z);
        c <= l && (l = c, n.set(1, 0, 0)), u <= l && (l = u, n.set(0, 1, 0)), d <= l && n.set(0, 0, 1), a.crossVectors(i[0], n).normalize(), r[0].crossVectors(i[0], a), s[0].crossVectors(i[0], r[0]);
        for(let e = 1; e <= t1; e++){
            if (r[e] = r[e - 1].clone(), s[e] = s[e - 1].clone(), a.crossVectors(i[e - 1], i[e]), a.length() > Number.EPSILON) {
                a.normalize();
                const t1 = Math.acos($fd4eb456bcbd06f8$var$h(i[e - 1].dot(i[e]), -1, 1));
                r[e].applyMatrix4(o.makeRotationAxis(a, t1));
            }
            s[e].crossVectors(i[e], r[e]);
        }
        if (!0 === e) {
            let e = Math.acos($fd4eb456bcbd06f8$var$h(r[0].dot(r[t1]), -1, 1));
            e /= t1, i[0].dot(a.crossVectors(r[0], r[t1])) > 0 && (e = -e);
            for(let n = 1; n <= t1; n++)r[n].applyMatrix4(o.makeRotationAxis(i[n], e * n)), s[n].crossVectors(i[n], r[n]);
        }
        return {
            tangents: i,
            normals: r,
            binormals: s
        };
    }
    clone() {
        return (new this.constructor).copy(this);
    }
    copy(t1) {
        return this.arcLengthDivisions = t1.arcLengthDivisions, this;
    }
    toJSON() {
        const t1 = {
            metadata: {
                version: 4.5,
                type: "Curve",
                generator: "Curve.toJSON"
            }
        };
        return t1.arcLengthDivisions = this.arcLengthDivisions, t1.type = this.type, t1;
    }
    fromJSON(t1) {
        return this.arcLengthDivisions = t1.arcLengthDivisions, this;
    }
}
class $fd4eb456bcbd06f8$var$Fs extends $fd4eb456bcbd06f8$var$Ns {
    constructor(t1 = 0, e = 0, n = 1, i = 1, r = 0, s = 2 * Math.PI, a = !1, o = 0){
        super(), this.type = "EllipseCurve", this.aX = t1, this.aY = e, this.xRadius = n, this.yRadius = i, this.aStartAngle = r, this.aEndAngle = s, this.aClockwise = a, this.aRotation = o;
    }
    getPoint(t1, e) {
        const n = e || new $fd4eb456bcbd06f8$var$g, i = 2 * Math.PI;
        let r = this.aEndAngle - this.aStartAngle;
        const s = Math.abs(r) < Number.EPSILON;
        for(; r < 0;)r += i;
        for(; r > i;)r -= i;
        r < Number.EPSILON && (r = s ? 0 : i), !0 !== this.aClockwise || s || (r === i ? r = -i : r -= i);
        const a = this.aStartAngle + t1 * r;
        let o = this.aX + this.xRadius * Math.cos(a), l = this.aY + this.yRadius * Math.sin(a);
        if (0 !== this.aRotation) {
            const t1 = Math.cos(this.aRotation), e = Math.sin(this.aRotation), n = o - this.aX, i = l - this.aY;
            o = n * t1 - i * e + this.aX, l = n * e + i * t1 + this.aY;
        }
        return n.set(o, l);
    }
    copy(t1) {
        return super.copy(t1), this.aX = t1.aX, this.aY = t1.aY, this.xRadius = t1.xRadius, this.yRadius = t1.yRadius, this.aStartAngle = t1.aStartAngle, this.aEndAngle = t1.aEndAngle, this.aClockwise = t1.aClockwise, this.aRotation = t1.aRotation, this;
    }
    toJSON() {
        const t1 = super.toJSON();
        return t1.aX = this.aX, t1.aY = this.aY, t1.xRadius = this.xRadius, t1.yRadius = this.yRadius, t1.aStartAngle = this.aStartAngle, t1.aEndAngle = this.aEndAngle, t1.aClockwise = this.aClockwise, t1.aRotation = this.aRotation, t1;
    }
    fromJSON(t1) {
        return super.fromJSON(t1), this.aX = t1.aX, this.aY = t1.aY, this.xRadius = t1.xRadius, this.yRadius = t1.yRadius, this.aStartAngle = t1.aStartAngle, this.aEndAngle = t1.aEndAngle, this.aClockwise = t1.aClockwise, this.aRotation = t1.aRotation, this;
    }
}
$fd4eb456bcbd06f8$var$Fs.prototype.isEllipseCurve = !0;
class $fd4eb456bcbd06f8$var$Us extends $fd4eb456bcbd06f8$var$Fs {
    constructor(t1, e, n, i, r, s){
        super(t1, e, n, n, i, r, s), this.type = "ArcCurve";
    }
}
function $fd4eb456bcbd06f8$var$ks() {
    let t1 = 0, e = 0, n = 0, i = 0;
    function r(r, s, a, o) {
        t1 = r, e = a, n = -3 * r + 3 * s - 2 * a - o, i = 2 * r - 2 * s + a + o;
    }
    return {
        initCatmullRom: function(t1, e, n, i, s) {
            r(e, n, s * (n - t1), s * (i - e));
        },
        initNonuniformCatmullRom: function(t1, e, n, i, s, a, o) {
            let l = (e - t1) / s - (n - t1) / (s + a) + (n - e) / a, h = (n - e) / a - (i - e) / (a + o) + (i - n) / o;
            l *= a, h *= a, r(e, n, l, h);
        },
        calc: function(r) {
            const s = r * r;
            return t1 + e * r + n * s + i * (s * r);
        }
    };
}
$fd4eb456bcbd06f8$var$Us.prototype.isArcCurve = !0;
const $fd4eb456bcbd06f8$var$Bs = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$zs = new $fd4eb456bcbd06f8$var$ks, $fd4eb456bcbd06f8$var$Hs = new $fd4eb456bcbd06f8$var$ks, $fd4eb456bcbd06f8$var$Vs = new $fd4eb456bcbd06f8$var$ks;
class $fd4eb456bcbd06f8$var$Gs extends $fd4eb456bcbd06f8$var$Ns {
    constructor(t1 = [], e = !1, n = "centripetal", i = .5){
        super(), this.type = "CatmullRomCurve3", this.points = t1, this.closed = e, this.curveType = n, this.tension = i;
    }
    getPoint(t1, e = new $fd4eb456bcbd06f8$var$V) {
        const n = e, i = this.points, r = i.length, s = (r - (this.closed ? 0 : 1)) * t1;
        let a, o, l = Math.floor(s), h = s - l;
        this.closed ? l += l > 0 ? 0 : (Math.floor(Math.abs(l) / r) + 1) * r : 0 === h && l === r - 1 && (l = r - 2, h = 1), this.closed || l > 0 ? a = i[(l - 1) % r] : ($fd4eb456bcbd06f8$var$Bs.subVectors(i[0], i[1]).add(i[0]), a = $fd4eb456bcbd06f8$var$Bs);
        const c = i[l % r], u = i[(l + 1) % r];
        if (this.closed || l + 2 < r ? o = i[(l + 2) % r] : ($fd4eb456bcbd06f8$var$Bs.subVectors(i[r - 1], i[r - 2]).add(i[r - 1]), o = $fd4eb456bcbd06f8$var$Bs), "centripetal" === this.curveType || "chordal" === this.curveType) {
            const t1 = "chordal" === this.curveType ? .5 : .25;
            let e = Math.pow(a.distanceToSquared(c), t1), n = Math.pow(c.distanceToSquared(u), t1), i = Math.pow(u.distanceToSquared(o), t1);
            n < 1e-4 && (n = 1), e < 1e-4 && (e = n), i < 1e-4 && (i = n), $fd4eb456bcbd06f8$var$zs.initNonuniformCatmullRom(a.x, c.x, u.x, o.x, e, n, i), $fd4eb456bcbd06f8$var$Hs.initNonuniformCatmullRom(a.y, c.y, u.y, o.y, e, n, i), $fd4eb456bcbd06f8$var$Vs.initNonuniformCatmullRom(a.z, c.z, u.z, o.z, e, n, i);
        } else "catmullrom" === this.curveType && ($fd4eb456bcbd06f8$var$zs.initCatmullRom(a.x, c.x, u.x, o.x, this.tension), $fd4eb456bcbd06f8$var$Hs.initCatmullRom(a.y, c.y, u.y, o.y, this.tension), $fd4eb456bcbd06f8$var$Vs.initCatmullRom(a.z, c.z, u.z, o.z, this.tension));
        return n.set($fd4eb456bcbd06f8$var$zs.calc(h), $fd4eb456bcbd06f8$var$Hs.calc(h), $fd4eb456bcbd06f8$var$Vs.calc(h)), n;
    }
    copy(t1) {
        super.copy(t1), this.points = [];
        for(let e = 0, n = t1.points.length; e < n; e++){
            const n = t1.points[e];
            this.points.push(n.clone());
        }
        return this.closed = t1.closed, this.curveType = t1.curveType, this.tension = t1.tension, this;
    }
    toJSON() {
        const t1 = super.toJSON();
        t1.points = [];
        for(let e = 0, n = this.points.length; e < n; e++){
            const n = this.points[e];
            t1.points.push(n.toArray());
        }
        return t1.closed = this.closed, t1.curveType = this.curveType, t1.tension = this.tension, t1;
    }
    fromJSON(t1) {
        super.fromJSON(t1), this.points = [];
        for(let e = 0, n = t1.points.length; e < n; e++){
            const n = t1.points[e];
            this.points.push((new $fd4eb456bcbd06f8$var$V).fromArray(n));
        }
        return this.closed = t1.closed, this.curveType = t1.curveType, this.tension = t1.tension, this;
    }
}
function $fd4eb456bcbd06f8$var$Ws(t1, e, n, i, r) {
    const s = .5 * (i - e), a = .5 * (r - n), o = t1 * t1;
    return (2 * n - 2 * i + s + a) * (t1 * o) + (-3 * n + 3 * i - 2 * s - a) * o + s * t1 + n;
}
function $fd4eb456bcbd06f8$var$js(t1, e, n, i) {
    return function(t1, e) {
        const n = 1 - t1;
        return n * n * e;
    }(t1, e) + function(t1, e) {
        return 2 * (1 - t1) * t1 * e;
    }(t1, n) + function(t1, e) {
        return t1 * t1 * e;
    }(t1, i);
}
function $fd4eb456bcbd06f8$var$qs(t1, e, n, i, r) {
    return function(t1, e) {
        const n = 1 - t1;
        return n * n * n * e;
    }(t1, e) + function(t1, e) {
        const n = 1 - t1;
        return 3 * n * n * t1 * e;
    }(t1, n) + function(t1, e) {
        return 3 * (1 - t1) * t1 * t1 * e;
    }(t1, i) + function(t1, e) {
        return t1 * t1 * t1 * e;
    }(t1, r);
}
$fd4eb456bcbd06f8$var$Gs.prototype.isCatmullRomCurve3 = !0;
class $fd4eb456bcbd06f8$var$Xs extends $fd4eb456bcbd06f8$var$Ns {
    constructor(t1 = new $fd4eb456bcbd06f8$var$g, e = new $fd4eb456bcbd06f8$var$g, n = new $fd4eb456bcbd06f8$var$g, i = new $fd4eb456bcbd06f8$var$g){
        super(), this.type = "CubicBezierCurve", this.v0 = t1, this.v1 = e, this.v2 = n, this.v3 = i;
    }
    getPoint(t1, e = new $fd4eb456bcbd06f8$var$g) {
        const n = e, i = this.v0, r = this.v1, s = this.v2, a = this.v3;
        return n.set($fd4eb456bcbd06f8$var$qs(t1, i.x, r.x, s.x, a.x), $fd4eb456bcbd06f8$var$qs(t1, i.y, r.y, s.y, a.y)), n;
    }
    copy(t1) {
        return super.copy(t1), this.v0.copy(t1.v0), this.v1.copy(t1.v1), this.v2.copy(t1.v2), this.v3.copy(t1.v3), this;
    }
    toJSON() {
        const t1 = super.toJSON();
        return t1.v0 = this.v0.toArray(), t1.v1 = this.v1.toArray(), t1.v2 = this.v2.toArray(), t1.v3 = this.v3.toArray(), t1;
    }
    fromJSON(t1) {
        return super.fromJSON(t1), this.v0.fromArray(t1.v0), this.v1.fromArray(t1.v1), this.v2.fromArray(t1.v2), this.v3.fromArray(t1.v3), this;
    }
}
$fd4eb456bcbd06f8$var$Xs.prototype.isCubicBezierCurve = !0;
class $fd4eb456bcbd06f8$var$$s extends $fd4eb456bcbd06f8$var$Ns {
    constructor(t1 = new $fd4eb456bcbd06f8$var$V, e = new $fd4eb456bcbd06f8$var$V, n = new $fd4eb456bcbd06f8$var$V, i = new $fd4eb456bcbd06f8$var$V){
        super(), this.type = "CubicBezierCurve3", this.v0 = t1, this.v1 = e, this.v2 = n, this.v3 = i;
    }
    getPoint(t1, e = new $fd4eb456bcbd06f8$var$V) {
        const n = e, i = this.v0, r = this.v1, s = this.v2, a = this.v3;
        return n.set($fd4eb456bcbd06f8$var$qs(t1, i.x, r.x, s.x, a.x), $fd4eb456bcbd06f8$var$qs(t1, i.y, r.y, s.y, a.y), $fd4eb456bcbd06f8$var$qs(t1, i.z, r.z, s.z, a.z)), n;
    }
    copy(t1) {
        return super.copy(t1), this.v0.copy(t1.v0), this.v1.copy(t1.v1), this.v2.copy(t1.v2), this.v3.copy(t1.v3), this;
    }
    toJSON() {
        const t1 = super.toJSON();
        return t1.v0 = this.v0.toArray(), t1.v1 = this.v1.toArray(), t1.v2 = this.v2.toArray(), t1.v3 = this.v3.toArray(), t1;
    }
    fromJSON(t1) {
        return super.fromJSON(t1), this.v0.fromArray(t1.v0), this.v1.fromArray(t1.v1), this.v2.fromArray(t1.v2), this.v3.fromArray(t1.v3), this;
    }
}
$fd4eb456bcbd06f8$var$$s.prototype.isCubicBezierCurve3 = !0;
class $fd4eb456bcbd06f8$var$Ys extends $fd4eb456bcbd06f8$var$Ns {
    constructor(t1 = new $fd4eb456bcbd06f8$var$g, e = new $fd4eb456bcbd06f8$var$g){
        super(), this.type = "LineCurve", this.v1 = t1, this.v2 = e;
    }
    getPoint(t1, e = new $fd4eb456bcbd06f8$var$g) {
        const n = e;
        return 1 === t1 ? n.copy(this.v2) : (n.copy(this.v2).sub(this.v1), n.multiplyScalar(t1).add(this.v1)), n;
    }
    getPointAt(t1, e) {
        return this.getPoint(t1, e);
    }
    getTangent(t1, e) {
        const n = e || new $fd4eb456bcbd06f8$var$g;
        return n.copy(this.v2).sub(this.v1).normalize(), n;
    }
    copy(t1) {
        return super.copy(t1), this.v1.copy(t1.v1), this.v2.copy(t1.v2), this;
    }
    toJSON() {
        const t1 = super.toJSON();
        return t1.v1 = this.v1.toArray(), t1.v2 = this.v2.toArray(), t1;
    }
    fromJSON(t1) {
        return super.fromJSON(t1), this.v1.fromArray(t1.v1), this.v2.fromArray(t1.v2), this;
    }
}
$fd4eb456bcbd06f8$var$Ys.prototype.isLineCurve = !0;
class $fd4eb456bcbd06f8$var$Js extends $fd4eb456bcbd06f8$var$Ns {
    constructor(t1 = new $fd4eb456bcbd06f8$var$g, e = new $fd4eb456bcbd06f8$var$g, n = new $fd4eb456bcbd06f8$var$g){
        super(), this.type = "QuadraticBezierCurve", this.v0 = t1, this.v1 = e, this.v2 = n;
    }
    getPoint(t1, e = new $fd4eb456bcbd06f8$var$g) {
        const n = e, i = this.v0, r = this.v1, s = this.v2;
        return n.set($fd4eb456bcbd06f8$var$js(t1, i.x, r.x, s.x), $fd4eb456bcbd06f8$var$js(t1, i.y, r.y, s.y)), n;
    }
    copy(t1) {
        return super.copy(t1), this.v0.copy(t1.v0), this.v1.copy(t1.v1), this.v2.copy(t1.v2), this;
    }
    toJSON() {
        const t1 = super.toJSON();
        return t1.v0 = this.v0.toArray(), t1.v1 = this.v1.toArray(), t1.v2 = this.v2.toArray(), t1;
    }
    fromJSON(t1) {
        return super.fromJSON(t1), this.v0.fromArray(t1.v0), this.v1.fromArray(t1.v1), this.v2.fromArray(t1.v2), this;
    }
}
$fd4eb456bcbd06f8$var$Js.prototype.isQuadraticBezierCurve = !0;
class $fd4eb456bcbd06f8$var$Ks extends $fd4eb456bcbd06f8$var$Ns {
    constructor(t1 = new $fd4eb456bcbd06f8$var$V, e = new $fd4eb456bcbd06f8$var$V, n = new $fd4eb456bcbd06f8$var$V){
        super(), this.type = "QuadraticBezierCurve3", this.v0 = t1, this.v1 = e, this.v2 = n;
    }
    getPoint(t1, e = new $fd4eb456bcbd06f8$var$V) {
        const n = e, i = this.v0, r = this.v1, s = this.v2;
        return n.set($fd4eb456bcbd06f8$var$js(t1, i.x, r.x, s.x), $fd4eb456bcbd06f8$var$js(t1, i.y, r.y, s.y), $fd4eb456bcbd06f8$var$js(t1, i.z, r.z, s.z)), n;
    }
    copy(t1) {
        return super.copy(t1), this.v0.copy(t1.v0), this.v1.copy(t1.v1), this.v2.copy(t1.v2), this;
    }
    toJSON() {
        const t1 = super.toJSON();
        return t1.v0 = this.v0.toArray(), t1.v1 = this.v1.toArray(), t1.v2 = this.v2.toArray(), t1;
    }
    fromJSON(t1) {
        return super.fromJSON(t1), this.v0.fromArray(t1.v0), this.v1.fromArray(t1.v1), this.v2.fromArray(t1.v2), this;
    }
}
$fd4eb456bcbd06f8$var$Ks.prototype.isQuadraticBezierCurve3 = !0;
class $fd4eb456bcbd06f8$var$Zs extends $fd4eb456bcbd06f8$var$Ns {
    constructor(t1 = []){
        super(), this.type = "SplineCurve", this.points = t1;
    }
    getPoint(t1, e = new $fd4eb456bcbd06f8$var$g) {
        const n = e, i = this.points, r = (i.length - 1) * t1, s = Math.floor(r), a = r - s, o = i[0 === s ? s : s - 1], l = i[s], h = i[s > i.length - 2 ? i.length - 1 : s + 1], c = i[s > i.length - 3 ? i.length - 1 : s + 2];
        return n.set($fd4eb456bcbd06f8$var$Ws(a, o.x, l.x, h.x, c.x), $fd4eb456bcbd06f8$var$Ws(a, o.y, l.y, h.y, c.y)), n;
    }
    copy(t1) {
        super.copy(t1), this.points = [];
        for(let e = 0, n = t1.points.length; e < n; e++){
            const n = t1.points[e];
            this.points.push(n.clone());
        }
        return this;
    }
    toJSON() {
        const t1 = super.toJSON();
        t1.points = [];
        for(let e = 0, n = this.points.length; e < n; e++){
            const n = this.points[e];
            t1.points.push(n.toArray());
        }
        return t1;
    }
    fromJSON(t1) {
        super.fromJSON(t1), this.points = [];
        for(let e = 0, n = t1.points.length; e < n; e++){
            const n = t1.points[e];
            this.points.push((new $fd4eb456bcbd06f8$var$g).fromArray(n));
        }
        return this;
    }
}
$fd4eb456bcbd06f8$var$Zs.prototype.isSplineCurve = !0;
var $fd4eb456bcbd06f8$var$Qs = Object.freeze({
    __proto__: null,
    ArcCurve: $fd4eb456bcbd06f8$var$Us,
    CatmullRomCurve3: $fd4eb456bcbd06f8$var$Gs,
    CubicBezierCurve: $fd4eb456bcbd06f8$var$Xs,
    CubicBezierCurve3: $fd4eb456bcbd06f8$var$$s,
    EllipseCurve: $fd4eb456bcbd06f8$var$Fs,
    LineCurve: $fd4eb456bcbd06f8$var$Ys,
    LineCurve3: class extends $fd4eb456bcbd06f8$var$Ns {
        constructor(t1 = new $fd4eb456bcbd06f8$var$V, e = new $fd4eb456bcbd06f8$var$V){
            super(), this.type = "LineCurve3", this.isLineCurve3 = !0, this.v1 = t1, this.v2 = e;
        }
        getPoint(t1, e = new $fd4eb456bcbd06f8$var$V) {
            const n = e;
            return 1 === t1 ? n.copy(this.v2) : (n.copy(this.v2).sub(this.v1), n.multiplyScalar(t1).add(this.v1)), n;
        }
        getPointAt(t1, e) {
            return this.getPoint(t1, e);
        }
        copy(t1) {
            return super.copy(t1), this.v1.copy(t1.v1), this.v2.copy(t1.v2), this;
        }
        toJSON() {
            const t1 = super.toJSON();
            return t1.v1 = this.v1.toArray(), t1.v2 = this.v2.toArray(), t1;
        }
        fromJSON(t1) {
            return super.fromJSON(t1), this.v1.fromArray(t1.v1), this.v2.fromArray(t1.v2), this;
        }
    },
    QuadraticBezierCurve: $fd4eb456bcbd06f8$var$Js,
    QuadraticBezierCurve3: $fd4eb456bcbd06f8$var$Ks,
    SplineCurve: $fd4eb456bcbd06f8$var$Zs
});
class $fd4eb456bcbd06f8$var$ta extends $fd4eb456bcbd06f8$var$Ns {
    constructor(){
        super(), this.type = "CurvePath", this.curves = [], this.autoClose = !1;
    }
    add(t1) {
        this.curves.push(t1);
    }
    closePath() {
        const t1 = this.curves[0].getPoint(0), e = this.curves[this.curves.length - 1].getPoint(1);
        t1.equals(e) || this.curves.push(new $fd4eb456bcbd06f8$var$Ys(e, t1));
    }
    getPoint(t1, e) {
        const n = t1 * this.getLength(), i = this.getCurveLengths();
        let r = 0;
        for(; r < i.length;){
            if (i[r] >= n) {
                const t1 = i[r] - n, s = this.curves[r], a = s.getLength(), o = 0 === a ? 0 : 1 - t1 / a;
                return s.getPointAt(o, e);
            }
            r++;
        }
        return null;
    }
    getLength() {
        const t1 = this.getCurveLengths();
        return t1[t1.length - 1];
    }
    updateArcLengths() {
        this.needsUpdate = !0, this.cacheLengths = null, this.getCurveLengths();
    }
    getCurveLengths() {
        if (this.cacheLengths && this.cacheLengths.length === this.curves.length) return this.cacheLengths;
        const t1 = [];
        let e = 0;
        for(let n = 0, i = this.curves.length; n < i; n++)e += this.curves[n].getLength(), t1.push(e);
        return this.cacheLengths = t1, t1;
    }
    getSpacedPoints(t1 = 40) {
        const e = [];
        for(let n = 0; n <= t1; n++)e.push(this.getPoint(n / t1));
        return this.autoClose && e.push(e[0]), e;
    }
    getPoints(t1 = 12) {
        const e = [];
        let n;
        for(let i = 0, r = this.curves; i < r.length; i++){
            const s = r[i], a = s.isEllipseCurve ? 2 * t1 : s.isLineCurve || s.isLineCurve3 ? 1 : s.isSplineCurve ? t1 * s.points.length : t1, o = s.getPoints(a);
            for(let t1 = 0; t1 < o.length; t1++){
                const i = o[t1];
                n && n.equals(i) || (e.push(i), n = i);
            }
        }
        return this.autoClose && e.length > 1 && !e[e.length - 1].equals(e[0]) && e.push(e[0]), e;
    }
    copy(t1) {
        super.copy(t1), this.curves = [];
        for(let e = 0, n = t1.curves.length; e < n; e++){
            const n = t1.curves[e];
            this.curves.push(n.clone());
        }
        return this.autoClose = t1.autoClose, this;
    }
    toJSON() {
        const t1 = super.toJSON();
        t1.autoClose = this.autoClose, t1.curves = [];
        for(let e = 0, n = this.curves.length; e < n; e++){
            const n = this.curves[e];
            t1.curves.push(n.toJSON());
        }
        return t1;
    }
    fromJSON(t1) {
        super.fromJSON(t1), this.autoClose = t1.autoClose, this.curves = [];
        for(let e = 0, n = t1.curves.length; e < n; e++){
            const n = t1.curves[e];
            this.curves.push((new $fd4eb456bcbd06f8$var$Qs[n.type]).fromJSON(n));
        }
        return this;
    }
}
class $fd4eb456bcbd06f8$var$ea extends $fd4eb456bcbd06f8$var$ta {
    constructor(t1){
        super(), this.type = "Path", this.currentPoint = new $fd4eb456bcbd06f8$var$g, t1 && this.setFromPoints(t1);
    }
    setFromPoints(t1) {
        this.moveTo(t1[0].x, t1[0].y);
        for(let e = 1, n = t1.length; e < n; e++)this.lineTo(t1[e].x, t1[e].y);
        return this;
    }
    moveTo(t1, e) {
        return this.currentPoint.set(t1, e), this;
    }
    lineTo(t1, e) {
        const n = new $fd4eb456bcbd06f8$var$Ys(this.currentPoint.clone(), new $fd4eb456bcbd06f8$var$g(t1, e));
        return this.curves.push(n), this.currentPoint.set(t1, e), this;
    }
    quadraticCurveTo(t1, e, n, i) {
        const r = new $fd4eb456bcbd06f8$var$Js(this.currentPoint.clone(), new $fd4eb456bcbd06f8$var$g(t1, e), new $fd4eb456bcbd06f8$var$g(n, i));
        return this.curves.push(r), this.currentPoint.set(n, i), this;
    }
    bezierCurveTo(t1, e, n, i, r, s) {
        const a = new $fd4eb456bcbd06f8$var$Xs(this.currentPoint.clone(), new $fd4eb456bcbd06f8$var$g(t1, e), new $fd4eb456bcbd06f8$var$g(n, i), new $fd4eb456bcbd06f8$var$g(r, s));
        return this.curves.push(a), this.currentPoint.set(r, s), this;
    }
    splineThru(t1) {
        const e = [
            this.currentPoint.clone()
        ].concat(t1), n = new $fd4eb456bcbd06f8$var$Zs(e);
        return this.curves.push(n), this.currentPoint.copy(t1[t1.length - 1]), this;
    }
    arc(t1, e, n, i, r, s) {
        const a = this.currentPoint.x, o = this.currentPoint.y;
        return this.absarc(t1 + a, e + o, n, i, r, s), this;
    }
    absarc(t1, e, n, i, r, s) {
        return this.absellipse(t1, e, n, n, i, r, s), this;
    }
    ellipse(t1, e, n, i, r, s, a, o) {
        const l = this.currentPoint.x, h = this.currentPoint.y;
        return this.absellipse(t1 + l, e + h, n, i, r, s, a, o), this;
    }
    absellipse(t1, e, n, i, r, s, a, o) {
        const l = new $fd4eb456bcbd06f8$var$Fs(t1, e, n, i, r, s, a, o);
        if (this.curves.length > 0) {
            const t1 = l.getPoint(0);
            t1.equals(this.currentPoint) || this.lineTo(t1.x, t1.y);
        }
        this.curves.push(l);
        const h = l.getPoint(1);
        return this.currentPoint.copy(h), this;
    }
    copy(t1) {
        return super.copy(t1), this.currentPoint.copy(t1.currentPoint), this;
    }
    toJSON() {
        const t1 = super.toJSON();
        return t1.currentPoint = this.currentPoint.toArray(), t1;
    }
    fromJSON(t1) {
        return super.fromJSON(t1), this.currentPoint.fromArray(t1.currentPoint), this;
    }
}
new $fd4eb456bcbd06f8$var$V, new $fd4eb456bcbd06f8$var$V, new $fd4eb456bcbd06f8$var$V, new $fd4eb456bcbd06f8$var$ee;
class $fd4eb456bcbd06f8$var$na extends $fd4eb456bcbd06f8$var$ea {
    constructor(t1){
        super(t1), this.uuid = $fd4eb456bcbd06f8$var$l(), this.type = "Shape", this.holes = [];
    }
    getPointsHoles(t1) {
        const e = [];
        for(let n = 0, i = this.holes.length; n < i; n++)e[n] = this.holes[n].getPoints(t1);
        return e;
    }
    extractPoints(t1) {
        return {
            shape: this.getPoints(t1),
            holes: this.getPointsHoles(t1)
        };
    }
    copy(t1) {
        super.copy(t1), this.holes = [];
        for(let e = 0, n = t1.holes.length; e < n; e++){
            const n = t1.holes[e];
            this.holes.push(n.clone());
        }
        return this;
    }
    toJSON() {
        const t1 = super.toJSON();
        t1.uuid = this.uuid, t1.holes = [];
        for(let e = 0, n = this.holes.length; e < n; e++){
            const n = this.holes[e];
            t1.holes.push(n.toJSON());
        }
        return t1;
    }
    fromJSON(t1) {
        super.fromJSON(t1), this.uuid = t1.uuid, this.holes = [];
        for(let e = 0, n = t1.holes.length; e < n; e++){
            const n = t1.holes[e];
            this.holes.push((new $fd4eb456bcbd06f8$var$ea).fromJSON(n));
        }
        return this;
    }
}
const $fd4eb456bcbd06f8$var$ia = function(t1, e, n = 2) {
    const i = e && e.length, r = i ? e[0] * n : t1.length;
    let s = $fd4eb456bcbd06f8$var$ra(t1, 0, r, n, !0);
    const a = [];
    if (!s || s.next === s.prev) return a;
    let o, l, h, c, u, d, p;
    if (i && (s = function(t1, e, n, i) {
        const r = [];
        let s, a, o, l, h;
        for(s = 0, a = e.length; s < a; s++)o = e[s] * i, l = s < a - 1 ? e[s + 1] * i : t1.length, h = $fd4eb456bcbd06f8$var$ra(t1, o, l, i, !1), h === h.next && (h.steiner = !0), r.push($fd4eb456bcbd06f8$var$fa(h));
        for(r.sort($fd4eb456bcbd06f8$var$ua), s = 0; s < r.length; s++)$fd4eb456bcbd06f8$var$da(r[s], n), n = $fd4eb456bcbd06f8$var$sa(n, n.next);
        return n;
    }(t1, e, s, n)), t1.length > 80 * n) {
        o = h = t1[0], l = c = t1[1];
        for(let e = n; e < r; e += n)u = t1[e], d = t1[e + 1], u < o && (o = u), d < l && (l = d), u > h && (h = u), d > c && (c = d);
        p = Math.max(h - o, c - l), p = 0 !== p ? 1 / p : 0;
    }
    return $fd4eb456bcbd06f8$var$aa(s, a, n, o, l, p), a;
};
function $fd4eb456bcbd06f8$var$ra(t1, e, n, i, r) {
    let s, a;
    if (r === function(t1, e, n, i) {
        let r = 0;
        for(let s = e, a = n - i; s < n; s += i)r += (t1[a] - t1[s]) * (t1[s + 1] + t1[a + 1]), a = s;
        return r;
    }(t1, e, n, i) > 0) for(s = e; s < n; s += i)a = $fd4eb456bcbd06f8$var$Ta(s, t1[s], t1[s + 1], a);
    else for(s = n - i; s >= e; s -= i)a = $fd4eb456bcbd06f8$var$Ta(s, t1[s], t1[s + 1], a);
    return a && $fd4eb456bcbd06f8$var$xa(a, a.next) && ($fd4eb456bcbd06f8$var$Ea(a), a = a.next), a;
}
function $fd4eb456bcbd06f8$var$sa(t1, e) {
    if (!t1) return t1;
    e || (e = t1);
    let n, i = t1;
    do if (n = !1, i.steiner || !$fd4eb456bcbd06f8$var$xa(i, i.next) && 0 !== $fd4eb456bcbd06f8$var$ya(i.prev, i, i.next)) i = i.next;
    else {
        if ($fd4eb456bcbd06f8$var$Ea(i), i = e = i.prev, i === i.next) break;
        n = !0;
    }
    while (n || i !== e);
    return e;
}
function $fd4eb456bcbd06f8$var$aa(t1, e, n, i, r, s, a) {
    if (!t1) return;
    !a && s && function(t1, e, n, i) {
        let r = t1;
        do null === r.z && (r.z = $fd4eb456bcbd06f8$var$ma(r.x, r.y, e, n, i)), r.prevZ = r.prev, r.nextZ = r.next, r = r.next;
        while (r !== t1);
        r.prevZ.nextZ = null, r.prevZ = null, function(t1) {
            let e, n, i, r, s, a, o, l, h = 1;
            do {
                for(n = t1, t1 = null, s = null, a = 0; n;){
                    for(a++, i = n, o = 0, e = 0; e < h && (o++, i = i.nextZ, i); e++);
                    for(l = h; o > 0 || l > 0 && i;)0 !== o && (0 === l || !i || n.z <= i.z) ? (r = n, n = n.nextZ, o--) : (r = i, i = i.nextZ, l--), s ? s.nextZ = r : t1 = r, r.prevZ = s, s = r;
                    n = i;
                }
                s.nextZ = null, h *= 2;
            }while (a > 1);
        }(r);
    }(t1, i, r, s);
    let o, l, h = t1;
    for(; t1.prev !== t1.next;)if (o = t1.prev, l = t1.next, s ? $fd4eb456bcbd06f8$var$la(t1, i, r, s) : $fd4eb456bcbd06f8$var$oa(t1)) e.push(o.i / n), e.push(t1.i / n), e.push(l.i / n), $fd4eb456bcbd06f8$var$Ea(t1), t1 = l.next, h = l.next;
    else if ((t1 = l) === h) {
        a ? 1 === a ? $fd4eb456bcbd06f8$var$aa(t1 = $fd4eb456bcbd06f8$var$ha($fd4eb456bcbd06f8$var$sa(t1), e, n), e, n, i, r, s, 2) : 2 === a && $fd4eb456bcbd06f8$var$ca(t1, e, n, i, r, s) : $fd4eb456bcbd06f8$var$aa($fd4eb456bcbd06f8$var$sa(t1), e, n, i, r, s, 1);
        break;
    }
}
function $fd4eb456bcbd06f8$var$oa(t1) {
    const e = t1.prev, n = t1, i = t1.next;
    if ($fd4eb456bcbd06f8$var$ya(e, n, i) >= 0) return !1;
    let r = t1.next.next;
    for(; r !== t1.prev;){
        if ($fd4eb456bcbd06f8$var$ga(e.x, e.y, n.x, n.y, i.x, i.y, r.x, r.y) && $fd4eb456bcbd06f8$var$ya(r.prev, r, r.next) >= 0) return !1;
        r = r.next;
    }
    return !0;
}
function $fd4eb456bcbd06f8$var$la(t1, e, n, i) {
    const r = t1.prev, s = t1, a = t1.next;
    if ($fd4eb456bcbd06f8$var$ya(r, s, a) >= 0) return !1;
    const o = r.x < s.x ? r.x < a.x ? r.x : a.x : s.x < a.x ? s.x : a.x, l = r.y < s.y ? r.y < a.y ? r.y : a.y : s.y < a.y ? s.y : a.y, h = r.x > s.x ? r.x > a.x ? r.x : a.x : s.x > a.x ? s.x : a.x, c = r.y > s.y ? r.y > a.y ? r.y : a.y : s.y > a.y ? s.y : a.y, u = $fd4eb456bcbd06f8$var$ma(o, l, e, n, i), d = $fd4eb456bcbd06f8$var$ma(h, c, e, n, i);
    let p = t1.prevZ, m = t1.nextZ;
    for(; p && p.z >= u && m && m.z <= d;){
        if (p !== t1.prev && p !== t1.next && $fd4eb456bcbd06f8$var$ga(r.x, r.y, s.x, s.y, a.x, a.y, p.x, p.y) && $fd4eb456bcbd06f8$var$ya(p.prev, p, p.next) >= 0) return !1;
        if (p = p.prevZ, m !== t1.prev && m !== t1.next && $fd4eb456bcbd06f8$var$ga(r.x, r.y, s.x, s.y, a.x, a.y, m.x, m.y) && $fd4eb456bcbd06f8$var$ya(m.prev, m, m.next) >= 0) return !1;
        m = m.nextZ;
    }
    for(; p && p.z >= u;){
        if (p !== t1.prev && p !== t1.next && $fd4eb456bcbd06f8$var$ga(r.x, r.y, s.x, s.y, a.x, a.y, p.x, p.y) && $fd4eb456bcbd06f8$var$ya(p.prev, p, p.next) >= 0) return !1;
        p = p.prevZ;
    }
    for(; m && m.z <= d;){
        if (m !== t1.prev && m !== t1.next && $fd4eb456bcbd06f8$var$ga(r.x, r.y, s.x, s.y, a.x, a.y, m.x, m.y) && $fd4eb456bcbd06f8$var$ya(m.prev, m, m.next) >= 0) return !1;
        m = m.nextZ;
    }
    return !0;
}
function $fd4eb456bcbd06f8$var$ha(t1, e, n) {
    let i = t1;
    do {
        const r = i.prev, s = i.next.next;
        !$fd4eb456bcbd06f8$var$xa(r, s) && $fd4eb456bcbd06f8$var$ba(r, i, i.next, s) && $fd4eb456bcbd06f8$var$Ma(r, s) && $fd4eb456bcbd06f8$var$Ma(s, r) && (e.push(r.i / n), e.push(i.i / n), e.push(s.i / n), $fd4eb456bcbd06f8$var$Ea(i), $fd4eb456bcbd06f8$var$Ea(i.next), i = t1 = s), i = i.next;
    }while (i !== t1);
    return $fd4eb456bcbd06f8$var$sa(i);
}
function $fd4eb456bcbd06f8$var$ca(t1, e, n, i, r, s) {
    let a = t1;
    do {
        let t1 = a.next.next;
        for(; t1 !== a.prev;){
            if (a.i !== t1.i && $fd4eb456bcbd06f8$var$va(a, t1)) {
                let o = $fd4eb456bcbd06f8$var$Sa(a, t1);
                return a = $fd4eb456bcbd06f8$var$sa(a, a.next), o = $fd4eb456bcbd06f8$var$sa(o, o.next), $fd4eb456bcbd06f8$var$aa(a, e, n, i, r, s), void $fd4eb456bcbd06f8$var$aa(o, e, n, i, r, s);
            }
            t1 = t1.next;
        }
        a = a.next;
    }while (a !== t1);
}
function $fd4eb456bcbd06f8$var$ua(t1, e) {
    return t1.x - e.x;
}
function $fd4eb456bcbd06f8$var$da(t1, e) {
    if (e = function(t1, e) {
        let n = e;
        const i = t1.x, r = t1.y;
        let s, a = -1 / 0;
        do {
            if (r <= n.y && r >= n.next.y && n.next.y !== n.y) {
                const t1 = n.x + (r - n.y) * (n.next.x - n.x) / (n.next.y - n.y);
                if (t1 <= i && t1 > a) {
                    if (a = t1, t1 === i) {
                        if (r === n.y) return n;
                        if (r === n.next.y) return n.next;
                    }
                    s = n.x < n.next.x ? n : n.next;
                }
            }
            n = n.next;
        }while (n !== e);
        if (!s) return null;
        if (i === a) return s;
        const o = s, l = s.x, h = s.y;
        let c, u = 1 / 0;
        n = s;
        do i >= n.x && n.x >= l && i !== n.x && $fd4eb456bcbd06f8$var$ga(r < h ? i : a, r, l, h, r < h ? a : i, r, n.x, n.y) && (c = Math.abs(r - n.y) / (i - n.x), $fd4eb456bcbd06f8$var$Ma(n, t1) && (c < u || c === u && (n.x > s.x || n.x === s.x && $fd4eb456bcbd06f8$var$pa(s, n))) && (s = n, u = c)), n = n.next;
        while (n !== o);
        return s;
    }(t1, e), e) {
        const n = $fd4eb456bcbd06f8$var$Sa(e, t1);
        $fd4eb456bcbd06f8$var$sa(e, e.next), $fd4eb456bcbd06f8$var$sa(n, n.next);
    }
}
function $fd4eb456bcbd06f8$var$pa(t1, e) {
    return $fd4eb456bcbd06f8$var$ya(t1.prev, t1, e.prev) < 0 && $fd4eb456bcbd06f8$var$ya(e.next, t1, t1.next) < 0;
}
function $fd4eb456bcbd06f8$var$ma(t1, e, n, i, r) {
    return (t1 = 1431655765 & ((t1 = 858993459 & ((t1 = 252645135 & ((t1 = 16711935 & ((t1 = 32767 * (t1 - n) * r) | t1 << 8)) | t1 << 4)) | t1 << 2)) | t1 << 1)) | (e = 1431655765 & ((e = 858993459 & ((e = 252645135 & ((e = 16711935 & ((e = 32767 * (e - i) * r) | e << 8)) | e << 4)) | e << 2)) | e << 1)) << 1;
}
function $fd4eb456bcbd06f8$var$fa(t1) {
    let e = t1, n = t1;
    do (e.x < n.x || e.x === n.x && e.y < n.y) && (n = e), e = e.next;
    while (e !== t1);
    return n;
}
function $fd4eb456bcbd06f8$var$ga(t1, e, n, i, r, s, a, o) {
    return (r - a) * (e - o) - (t1 - a) * (s - o) >= 0 && (t1 - a) * (i - o) - (n - a) * (e - o) >= 0 && (n - a) * (s - o) - (r - a) * (i - o) >= 0;
}
function $fd4eb456bcbd06f8$var$va(t1, e) {
    return t1.next.i !== e.i && t1.prev.i !== e.i && !function(t1, e) {
        let n = t1;
        do {
            if (n.i !== t1.i && n.next.i !== t1.i && n.i !== e.i && n.next.i !== e.i && $fd4eb456bcbd06f8$var$ba(n, n.next, t1, e)) return !0;
            n = n.next;
        }while (n !== t1);
        return !1;
    }(t1, e) && ($fd4eb456bcbd06f8$var$Ma(t1, e) && $fd4eb456bcbd06f8$var$Ma(e, t1) && function(t1, e) {
        let n = t1, i = !1;
        const r = (t1.x + e.x) / 2, s = (t1.y + e.y) / 2;
        do n.y > s != n.next.y > s && n.next.y !== n.y && r < (n.next.x - n.x) * (s - n.y) / (n.next.y - n.y) + n.x && (i = !i), n = n.next;
        while (n !== t1);
        return i;
    }(t1, e) && ($fd4eb456bcbd06f8$var$ya(t1.prev, t1, e.prev) || $fd4eb456bcbd06f8$var$ya(t1, e.prev, e)) || $fd4eb456bcbd06f8$var$xa(t1, e) && $fd4eb456bcbd06f8$var$ya(t1.prev, t1, t1.next) > 0 && $fd4eb456bcbd06f8$var$ya(e.prev, e, e.next) > 0);
}
function $fd4eb456bcbd06f8$var$ya(t1, e, n) {
    return (e.y - t1.y) * (n.x - e.x) - (e.x - t1.x) * (n.y - e.y);
}
function $fd4eb456bcbd06f8$var$xa(t1, e) {
    return t1.x === e.x && t1.y === e.y;
}
function $fd4eb456bcbd06f8$var$ba(t1, e, n, i) {
    const r = $fd4eb456bcbd06f8$var$wa($fd4eb456bcbd06f8$var$ya(t1, e, n)), s = $fd4eb456bcbd06f8$var$wa($fd4eb456bcbd06f8$var$ya(t1, e, i)), a = $fd4eb456bcbd06f8$var$wa($fd4eb456bcbd06f8$var$ya(n, i, t1)), o = $fd4eb456bcbd06f8$var$wa($fd4eb456bcbd06f8$var$ya(n, i, e));
    return r !== s && a !== o || !(0 !== r || !$fd4eb456bcbd06f8$var$_a(t1, n, e)) || !(0 !== s || !$fd4eb456bcbd06f8$var$_a(t1, i, e)) || !(0 !== a || !$fd4eb456bcbd06f8$var$_a(n, t1, i)) || !(0 !== o || !$fd4eb456bcbd06f8$var$_a(n, e, i));
}
function $fd4eb456bcbd06f8$var$_a(t1, e, n) {
    return e.x <= Math.max(t1.x, n.x) && e.x >= Math.min(t1.x, n.x) && e.y <= Math.max(t1.y, n.y) && e.y >= Math.min(t1.y, n.y);
}
function $fd4eb456bcbd06f8$var$wa(t1) {
    return t1 > 0 ? 1 : t1 < 0 ? -1 : 0;
}
function $fd4eb456bcbd06f8$var$Ma(t1, e) {
    return $fd4eb456bcbd06f8$var$ya(t1.prev, t1, t1.next) < 0 ? $fd4eb456bcbd06f8$var$ya(t1, e, t1.next) >= 0 && $fd4eb456bcbd06f8$var$ya(t1, t1.prev, e) >= 0 : $fd4eb456bcbd06f8$var$ya(t1, e, t1.prev) < 0 || $fd4eb456bcbd06f8$var$ya(t1, t1.next, e) < 0;
}
function $fd4eb456bcbd06f8$var$Sa(t1, e) {
    const n = new $fd4eb456bcbd06f8$var$Aa(t1.i, t1.x, t1.y), i = new $fd4eb456bcbd06f8$var$Aa(e.i, e.x, e.y), r = t1.next, s = e.prev;
    return t1.next = e, e.prev = t1, n.next = r, r.prev = n, i.next = n, n.prev = i, s.next = i, i.prev = s, i;
}
function $fd4eb456bcbd06f8$var$Ta(t1, e, n, i) {
    const r = new $fd4eb456bcbd06f8$var$Aa(t1, e, n);
    return i ? (r.next = i.next, r.prev = i, i.next.prev = r, i.next = r) : (r.prev = r, r.next = r), r;
}
function $fd4eb456bcbd06f8$var$Ea(t1) {
    t1.next.prev = t1.prev, t1.prev.next = t1.next, t1.prevZ && (t1.prevZ.nextZ = t1.nextZ), t1.nextZ && (t1.nextZ.prevZ = t1.prevZ);
}
function $fd4eb456bcbd06f8$var$Aa(t1, e, n) {
    this.i = t1, this.x = e, this.y = n, this.prev = null, this.next = null, this.z = null, this.prevZ = null, this.nextZ = null, this.steiner = !1;
}
class $fd4eb456bcbd06f8$var$Ra {
    static area(t1) {
        const e = t1.length;
        let n = 0;
        for(let i = e - 1, r = 0; r < e; i = r++)n += t1[i].x * t1[r].y - t1[r].x * t1[i].y;
        return .5 * n;
    }
    static isClockWise(t1) {
        return $fd4eb456bcbd06f8$var$Ra.area(t1) < 0;
    }
    static triangulateShape(t1, e) {
        const n = [], i = [], r = [];
        $fd4eb456bcbd06f8$var$Ca(t1), $fd4eb456bcbd06f8$var$La(n, t1);
        let s = t1.length;
        e.forEach($fd4eb456bcbd06f8$var$Ca);
        for(let t1 = 0; t1 < e.length; t1++)i.push(s), s += e[t1].length, $fd4eb456bcbd06f8$var$La(n, e[t1]);
        const a = $fd4eb456bcbd06f8$var$ia(n, i);
        for(let t1 = 0; t1 < a.length; t1 += 3)r.push(a.slice(t1, t1 + 3));
        return r;
    }
}
function $fd4eb456bcbd06f8$var$Ca(t1) {
    const e = t1.length;
    e > 2 && t1[e - 1].equals(t1[0]) && t1.pop();
}
function $fd4eb456bcbd06f8$var$La(t1, e) {
    for(let n = 0; n < e.length; n++)t1.push(e[n].x), t1.push(e[n].y);
}
class $fd4eb456bcbd06f8$var$Pa extends $fd4eb456bcbd06f8$var$ye {
    constructor(t1 = new $fd4eb456bcbd06f8$var$na([
        new $fd4eb456bcbd06f8$var$g(.5, .5),
        new $fd4eb456bcbd06f8$var$g(-0.5, .5),
        new $fd4eb456bcbd06f8$var$g(-0.5, -0.5),
        new $fd4eb456bcbd06f8$var$g(.5, -0.5)
    ]), e = {}){
        super(), this.type = "ExtrudeGeometry", this.parameters = {
            shapes: t1,
            options: e
        }, t1 = Array.isArray(t1) ? t1 : [
            t1
        ];
        const n = this, i = [], r = [];
        for(let e = 0, n = t1.length; e < n; e++)s(t1[e]);
        function s(t1) {
            const s = [], a = void 0 !== e.curveSegments ? e.curveSegments : 12, o = void 0 !== e.steps ? e.steps : 1;
            let l = void 0 !== e.depth ? e.depth : 1, h = void 0 === e.bevelEnabled || e.bevelEnabled, c = void 0 !== e.bevelThickness ? e.bevelThickness : .2, u = void 0 !== e.bevelSize ? e.bevelSize : c - .1, d = void 0 !== e.bevelOffset ? e.bevelOffset : 0, p = void 0 !== e.bevelSegments ? e.bevelSegments : 3;
            const m = e.extrudePath, f = void 0 !== e.UVGenerator ? e.UVGenerator : $fd4eb456bcbd06f8$var$Da;
            void 0 !== e.amount && (console.warn("THREE.ExtrudeBufferGeometry: amount has been renamed to depth."), l = e.amount);
            let v, y, x, b, _, w = !1;
            m && (v = m.getSpacedPoints(o), w = !0, h = !1, y = m.computeFrenetFrames(o, !1), x = new $fd4eb456bcbd06f8$var$V, b = new $fd4eb456bcbd06f8$var$V, _ = new $fd4eb456bcbd06f8$var$V), h || (p = 0, c = 0, u = 0, d = 0);
            const M = t1.extractPoints(a);
            let S = M.shape;
            const T = M.holes;
            if (!$fd4eb456bcbd06f8$var$Ra.isClockWise(S)) {
                S = S.reverse();
                for(let t1 = 0, e = T.length; t1 < e; t1++){
                    const e = T[t1];
                    $fd4eb456bcbd06f8$var$Ra.isClockWise(e) && (T[t1] = e.reverse());
                }
            }
            const E = $fd4eb456bcbd06f8$var$Ra.triangulateShape(S, T), A = S;
            for(let t1 = 0, e = T.length; t1 < e; t1++){
                const e = T[t1];
                S = S.concat(e);
            }
            function R(t1, e, n) {
                return e || console.error("THREE.ExtrudeGeometry: vec does not exist"), e.clone().multiplyScalar(n).add(t1);
            }
            const C = S.length, L = E.length;
            function P(t1, e, n) {
                let i, r, s;
                const a = t1.x - e.x, o = t1.y - e.y, l = n.x - t1.x, h = n.y - t1.y, c = a * a + o * o, u = a * h - o * l;
                if (Math.abs(u) > Number.EPSILON) {
                    const u = Math.sqrt(c), d = Math.sqrt(l * l + h * h), p = e.x - o / u, m = e.y + a / u, f = ((n.x - h / d - p) * h - (n.y + l / d - m) * l) / (a * h - o * l);
                    i = p + a * f - t1.x, r = m + o * f - t1.y;
                    const v = i * i + r * r;
                    if (v <= 2) return new $fd4eb456bcbd06f8$var$g(i, r);
                    s = Math.sqrt(v / 2);
                } else {
                    let t1 = !1;
                    a > Number.EPSILON ? l > Number.EPSILON && (t1 = !0) : a < -Number.EPSILON ? l < -Number.EPSILON && (t1 = !0) : Math.sign(o) === Math.sign(h) && (t1 = !0), t1 ? (i = -o, r = a, s = Math.sqrt(c)) : (i = a, r = o, s = Math.sqrt(c / 2));
                }
                return new $fd4eb456bcbd06f8$var$g(i / s, r / s);
            }
            const D = [];
            for(let t1 = 0, e = A.length, n = e - 1, i = t1 + 1; t1 < e; t1++, n++, i++)n === e && (n = 0), i === e && (i = 0), D[t1] = P(A[t1], A[n], A[i]);
            const I = [];
            let O, N = D.concat();
            for(let t1 = 0, e = T.length; t1 < e; t1++){
                const e = T[t1];
                O = [];
                for(let t1 = 0, n = e.length, i = n - 1, r = t1 + 1; t1 < n; t1++, i++, r++)i === n && (i = 0), r === n && (r = 0), O[t1] = P(e[t1], e[i], e[r]);
                I.push(O), N = N.concat(O);
            }
            for(let t1 = 0; t1 < p; t1++){
                const e = t1 / p, n = c * Math.cos(e * Math.PI / 2), i = u * Math.sin(e * Math.PI / 2) + d;
                for(let t1 = 0, e = A.length; t1 < e; t1++){
                    const e = R(A[t1], D[t1], i);
                    k(e.x, e.y, -n);
                }
                for(let t1 = 0, e = T.length; t1 < e; t1++){
                    const e = T[t1];
                    O = I[t1];
                    for(let t1 = 0, r = e.length; t1 < r; t1++){
                        const r = R(e[t1], O[t1], i);
                        k(r.x, r.y, -n);
                    }
                }
            }
            const F = u + d;
            for(let t1 = 0; t1 < C; t1++){
                const e = h ? R(S[t1], N[t1], F) : S[t1];
                w ? (b.copy(y.normals[0]).multiplyScalar(e.x), x.copy(y.binormals[0]).multiplyScalar(e.y), _.copy(v[0]).add(b).add(x), k(_.x, _.y, _.z)) : k(e.x, e.y, 0);
            }
            for(let t1 = 1; t1 <= o; t1++)for(let e = 0; e < C; e++){
                const n = h ? R(S[e], N[e], F) : S[e];
                w ? (b.copy(y.normals[t1]).multiplyScalar(n.x), x.copy(y.binormals[t1]).multiplyScalar(n.y), _.copy(v[t1]).add(b).add(x), k(_.x, _.y, _.z)) : k(n.x, n.y, l / o * t1);
            }
            for(let t1 = p - 1; t1 >= 0; t1--){
                const e = t1 / p, n = c * Math.cos(e * Math.PI / 2), i = u * Math.sin(e * Math.PI / 2) + d;
                for(let t1 = 0, e = A.length; t1 < e; t1++){
                    const e = R(A[t1], D[t1], i);
                    k(e.x, e.y, l + n);
                }
                for(let t1 = 0, e = T.length; t1 < e; t1++){
                    const e = T[t1];
                    O = I[t1];
                    for(let t1 = 0, r = e.length; t1 < r; t1++){
                        const r = R(e[t1], O[t1], i);
                        w ? k(r.x, r.y + v[o - 1].y, v[o - 1].x + n) : k(r.x, r.y, l + n);
                    }
                }
            }
            function U(t1, e) {
                let n = t1.length;
                for(; --n >= 0;){
                    const i = n;
                    let r = n - 1;
                    r < 0 && (r = t1.length - 1);
                    for(let t1 = 0, n = o + 2 * p; t1 < n; t1++){
                        const n = C * t1, s = C * (t1 + 1);
                        z(e + i + n, e + r + n, e + r + s, e + i + s);
                    }
                }
            }
            function k(t1, e, n) {
                s.push(t1), s.push(e), s.push(n);
            }
            function B(t1, e, r) {
                H(t1), H(e), H(r);
                const s = i.length / 3, a = f.generateTopUV(n, i, s - 3, s - 2, s - 1);
                G(a[0]), G(a[1]), G(a[2]);
            }
            function z(t1, e, r, s) {
                H(t1), H(e), H(s), H(e), H(r), H(s);
                const a = i.length / 3, o = f.generateSideWallUV(n, i, a - 6, a - 3, a - 2, a - 1);
                G(o[0]), G(o[1]), G(o[3]), G(o[1]), G(o[2]), G(o[3]);
            }
            function H(t1) {
                i.push(s[3 * t1 + 0]), i.push(s[3 * t1 + 1]), i.push(s[3 * t1 + 2]);
            }
            function G(t1) {
                r.push(t1.x), r.push(t1.y);
            }
            !function() {
                const t1 = i.length / 3;
                if (h) {
                    let t1 = 0, e = C * t1;
                    for(let t1 = 0; t1 < L; t1++){
                        const n = E[t1];
                        B(n[2] + e, n[1] + e, n[0] + e);
                    }
                    t1 = o + 2 * p, e = C * t1;
                    for(let t1 = 0; t1 < L; t1++){
                        const n = E[t1];
                        B(n[0] + e, n[1] + e, n[2] + e);
                    }
                } else {
                    for(let t1 = 0; t1 < L; t1++){
                        const e = E[t1];
                        B(e[2], e[1], e[0]);
                    }
                    for(let t1 = 0; t1 < L; t1++){
                        const e = E[t1];
                        B(e[0] + C * o, e[1] + C * o, e[2] + C * o);
                    }
                }
                n.addGroup(t1, i.length / 3 - t1, 0);
            }(), function() {
                const t1 = i.length / 3;
                let e = 0;
                U(A, e), e += A.length;
                for(let t1 = 0, n = T.length; t1 < n; t1++){
                    const n = T[t1];
                    U(n, e), e += n.length;
                }
                n.addGroup(t1, i.length / 3 - t1, 1);
            }();
        }
        this.setAttribute("position", new $fd4eb456bcbd06f8$var$ce(i, 3)), this.setAttribute("uv", new $fd4eb456bcbd06f8$var$ce(r, 2)), this.computeVertexNormals();
    }
    toJSON() {
        const t1 = super.toJSON();
        return function(t1, e, n) {
            if (n.shapes = [], Array.isArray(t1)) for(let e = 0, i = t1.length; e < i; e++){
                const i = t1[e];
                n.shapes.push(i.uuid);
            }
            else n.shapes.push(t1.uuid);
            void 0 !== e.extrudePath && (n.options.extrudePath = e.extrudePath.toJSON());
            return n;
        }(this.parameters.shapes, this.parameters.options, t1);
    }
    static fromJSON(t1, e) {
        const n = [];
        for(let i = 0, r = t1.shapes.length; i < r; i++){
            const r = e[t1.shapes[i]];
            n.push(r);
        }
        const i = t1.options.extrudePath;
        return void 0 !== i && (t1.options.extrudePath = (new $fd4eb456bcbd06f8$var$Qs[i.type]).fromJSON(i)), new $fd4eb456bcbd06f8$var$Pa(n, t1.options);
    }
}
const $fd4eb456bcbd06f8$var$Da = {
    generateTopUV: function(t1, e, n, i, r) {
        const s = e[3 * n], a = e[3 * n + 1], o = e[3 * i], l = e[3 * i + 1], h = e[3 * r], c = e[3 * r + 1];
        return [
            new $fd4eb456bcbd06f8$var$g(s, a),
            new $fd4eb456bcbd06f8$var$g(o, l),
            new $fd4eb456bcbd06f8$var$g(h, c)
        ];
    },
    generateSideWallUV: function(t1, e, n, i, r, s) {
        const a = e[3 * n], o = e[3 * n + 1], l = e[3 * n + 2], h = e[3 * i], c = e[3 * i + 1], u = e[3 * i + 2], d = e[3 * r], p = e[3 * r + 1], m = e[3 * r + 2], f = e[3 * s], v = e[3 * s + 1], y = e[3 * s + 2];
        return Math.abs(o - c) < Math.abs(a - h) ? [
            new $fd4eb456bcbd06f8$var$g(a, 1 - l),
            new $fd4eb456bcbd06f8$var$g(h, 1 - u),
            new $fd4eb456bcbd06f8$var$g(d, 1 - m),
            new $fd4eb456bcbd06f8$var$g(f, 1 - y)
        ] : [
            new $fd4eb456bcbd06f8$var$g(o, 1 - l),
            new $fd4eb456bcbd06f8$var$g(c, 1 - u),
            new $fd4eb456bcbd06f8$var$g(p, 1 - m),
            new $fd4eb456bcbd06f8$var$g(v, 1 - y)
        ];
    }
};
class $fd4eb456bcbd06f8$var$Ia extends $fd4eb456bcbd06f8$var$ye {
    constructor(t1 = new $fd4eb456bcbd06f8$var$na([
        new $fd4eb456bcbd06f8$var$g(0, .5),
        new $fd4eb456bcbd06f8$var$g(-0.5, -0.5),
        new $fd4eb456bcbd06f8$var$g(.5, -0.5)
    ]), e = 12){
        super(), this.type = "ShapeGeometry", this.parameters = {
            shapes: t1,
            curveSegments: e
        };
        const n = [], i = [], r = [], s = [];
        let a = 0, o = 0;
        if (!1 === Array.isArray(t1)) l(t1);
        else for(let e = 0; e < t1.length; e++)l(t1[e]), this.addGroup(a, o, e), a += o, o = 0;
        function l(t1) {
            const a = i.length / 3, l = t1.extractPoints(e);
            let h = l.shape;
            const c = l.holes;
            !1 === $fd4eb456bcbd06f8$var$Ra.isClockWise(h) && (h = h.reverse());
            for(let t1 = 0, e = c.length; t1 < e; t1++){
                const e = c[t1];
                !0 === $fd4eb456bcbd06f8$var$Ra.isClockWise(e) && (c[t1] = e.reverse());
            }
            const u = $fd4eb456bcbd06f8$var$Ra.triangulateShape(h, c);
            for(let t1 = 0, e = c.length; t1 < e; t1++){
                const e = c[t1];
                h = h.concat(e);
            }
            for(let t1 = 0, e = h.length; t1 < e; t1++){
                const e = h[t1];
                i.push(e.x, e.y, 0), r.push(0, 0, 1), s.push(e.x, e.y);
            }
            for(let t1 = 0, e = u.length; t1 < e; t1++){
                const e = u[t1], i = e[0] + a, r = e[1] + a, s = e[2] + a;
                n.push(i, r, s), o += 3;
            }
        }
        this.setIndex(n), this.setAttribute("position", new $fd4eb456bcbd06f8$var$ce(i, 3)), this.setAttribute("normal", new $fd4eb456bcbd06f8$var$ce(r, 3)), this.setAttribute("uv", new $fd4eb456bcbd06f8$var$ce(s, 2));
    }
    toJSON() {
        const t1 = super.toJSON();
        return function(t1, e) {
            if (e.shapes = [], Array.isArray(t1)) for(let n = 0, i = t1.length; n < i; n++){
                const i = t1[n];
                e.shapes.push(i.uuid);
            }
            else e.shapes.push(t1.uuid);
            return e;
        }(this.parameters.shapes, t1);
    }
    static fromJSON(t1, e) {
        const n = [];
        for(let i = 0, r = t1.shapes.length; i < r; i++){
            const r = e[t1.shapes[i]];
            n.push(r);
        }
        return new $fd4eb456bcbd06f8$var$Ia(n, t1.curveSegments);
    }
}
class $fd4eb456bcbd06f8$var$Oa extends $fd4eb456bcbd06f8$var$ie {
    constructor(t1){
        super(), this.type = "ShadowMaterial", this.color = new $fd4eb456bcbd06f8$var$L(0), this.transparent = !0, this.setValues(t1);
    }
    copy(t1) {
        return super.copy(t1), this.color.copy(t1.color), this;
    }
}
$fd4eb456bcbd06f8$var$Oa.prototype.isShadowMaterial = !0;
class $fd4eb456bcbd06f8$var$Na extends $fd4eb456bcbd06f8$var$Ve {
    constructor(t1){
        super(t1), this.type = "RawShaderMaterial";
    }
}
$fd4eb456bcbd06f8$var$Na.prototype.isRawShaderMaterial = !0;
class $fd4eb456bcbd06f8$var$Fa extends $fd4eb456bcbd06f8$var$ie {
    constructor(t1){
        super(), this.defines = {
            STANDARD: ""
        }, this.type = "MeshStandardMaterial", this.color = new $fd4eb456bcbd06f8$var$L(16777215), this.roughness = 1, this.metalness = 0, this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new $fd4eb456bcbd06f8$var$L(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = 0, this.normalScale = new $fd4eb456bcbd06f8$var$g(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.roughnessMap = null, this.metalnessMap = null, this.alphaMap = null, this.envMap = null, this.envMapIntensity = 1, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.flatShading = !1, this.setValues(t1);
    }
    copy(t1) {
        return super.copy(t1), this.defines = {
            STANDARD: ""
        }, this.color.copy(t1.color), this.roughness = t1.roughness, this.metalness = t1.metalness, this.map = t1.map, this.lightMap = t1.lightMap, this.lightMapIntensity = t1.lightMapIntensity, this.aoMap = t1.aoMap, this.aoMapIntensity = t1.aoMapIntensity, this.emissive.copy(t1.emissive), this.emissiveMap = t1.emissiveMap, this.emissiveIntensity = t1.emissiveIntensity, this.bumpMap = t1.bumpMap, this.bumpScale = t1.bumpScale, this.normalMap = t1.normalMap, this.normalMapType = t1.normalMapType, this.normalScale.copy(t1.normalScale), this.displacementMap = t1.displacementMap, this.displacementScale = t1.displacementScale, this.displacementBias = t1.displacementBias, this.roughnessMap = t1.roughnessMap, this.metalnessMap = t1.metalnessMap, this.alphaMap = t1.alphaMap, this.envMap = t1.envMap, this.envMapIntensity = t1.envMapIntensity, this.wireframe = t1.wireframe, this.wireframeLinewidth = t1.wireframeLinewidth, this.wireframeLinecap = t1.wireframeLinecap, this.wireframeLinejoin = t1.wireframeLinejoin, this.flatShading = t1.flatShading, this;
    }
}
$fd4eb456bcbd06f8$var$Fa.prototype.isMeshStandardMaterial = !0;
class $fd4eb456bcbd06f8$var$Ua extends $fd4eb456bcbd06f8$var$Fa {
    constructor(t1){
        super(), this.defines = {
            STANDARD: "",
            PHYSICAL: ""
        }, this.type = "MeshPhysicalMaterial", this.clearcoatMap = null, this.clearcoatRoughness = 0, this.clearcoatRoughnessMap = null, this.clearcoatNormalScale = new $fd4eb456bcbd06f8$var$g(1, 1), this.clearcoatNormalMap = null, this.ior = 1.5, Object.defineProperty(this, "reflectivity", {
            get: function() {
                return $fd4eb456bcbd06f8$var$h(2.5 * (this.ior - 1) / (this.ior + 1), 0, 1);
            },
            set: function(t1) {
                this.ior = (1 + .4 * t1) / (1 - .4 * t1);
            }
        }), this.sheenColor = new $fd4eb456bcbd06f8$var$L(0), this.sheenColorMap = null, this.sheenRoughness = 1, this.sheenRoughnessMap = null, this.transmissionMap = null, this.thickness = 0, this.thicknessMap = null, this.attenuationDistance = 0, this.attenuationColor = new $fd4eb456bcbd06f8$var$L(1, 1, 1), this.specularIntensity = 1, this.specularIntensityMap = null, this.specularColor = new $fd4eb456bcbd06f8$var$L(1, 1, 1), this.specularColorMap = null, this._sheen = 0, this._clearcoat = 0, this._transmission = 0, this.setValues(t1);
    }
    get sheen() {
        return this._sheen;
    }
    set sheen(t1) {
        this._sheen > 0 != t1 > 0 && this.version++, this._sheen = t1;
    }
    get clearcoat() {
        return this._clearcoat;
    }
    set clearcoat(t1) {
        this._clearcoat > 0 != t1 > 0 && this.version++, this._clearcoat = t1;
    }
    get transmission() {
        return this._transmission;
    }
    set transmission(t1) {
        this._transmission > 0 != t1 > 0 && this.version++, this._transmission = t1;
    }
    copy(t1) {
        return super.copy(t1), this.defines = {
            STANDARD: "",
            PHYSICAL: ""
        }, this.clearcoat = t1.clearcoat, this.clearcoatMap = t1.clearcoatMap, this.clearcoatRoughness = t1.clearcoatRoughness, this.clearcoatRoughnessMap = t1.clearcoatRoughnessMap, this.clearcoatNormalMap = t1.clearcoatNormalMap, this.clearcoatNormalScale.copy(t1.clearcoatNormalScale), this.ior = t1.ior, this.sheen = t1.sheen, this.sheenColor.copy(t1.sheenColor), this.sheenColorMap = t1.sheenColorMap, this.sheenRoughness = t1.sheenRoughness, this.sheenRoughnessMap = t1.sheenRoughnessMap, this.transmission = t1.transmission, this.transmissionMap = t1.transmissionMap, this.thickness = t1.thickness, this.thicknessMap = t1.thicknessMap, this.attenuationDistance = t1.attenuationDistance, this.attenuationColor.copy(t1.attenuationColor), this.specularIntensity = t1.specularIntensity, this.specularIntensityMap = t1.specularIntensityMap, this.specularColor.copy(t1.specularColor), this.specularColorMap = t1.specularColorMap, this;
    }
}
$fd4eb456bcbd06f8$var$Ua.prototype.isMeshPhysicalMaterial = !0;
class $fd4eb456bcbd06f8$var$ka extends $fd4eb456bcbd06f8$var$ie {
    constructor(t1){
        super(), this.type = "MeshPhongMaterial", this.color = new $fd4eb456bcbd06f8$var$L(16777215), this.specular = new $fd4eb456bcbd06f8$var$L(1118481), this.shininess = 30, this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new $fd4eb456bcbd06f8$var$L(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = 0, this.normalScale = new $fd4eb456bcbd06f8$var$g(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.combine = 0, this.reflectivity = 1, this.refractionRatio = .98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.flatShading = !1, this.setValues(t1);
    }
    copy(t1) {
        return super.copy(t1), this.color.copy(t1.color), this.specular.copy(t1.specular), this.shininess = t1.shininess, this.map = t1.map, this.lightMap = t1.lightMap, this.lightMapIntensity = t1.lightMapIntensity, this.aoMap = t1.aoMap, this.aoMapIntensity = t1.aoMapIntensity, this.emissive.copy(t1.emissive), this.emissiveMap = t1.emissiveMap, this.emissiveIntensity = t1.emissiveIntensity, this.bumpMap = t1.bumpMap, this.bumpScale = t1.bumpScale, this.normalMap = t1.normalMap, this.normalMapType = t1.normalMapType, this.normalScale.copy(t1.normalScale), this.displacementMap = t1.displacementMap, this.displacementScale = t1.displacementScale, this.displacementBias = t1.displacementBias, this.specularMap = t1.specularMap, this.alphaMap = t1.alphaMap, this.envMap = t1.envMap, this.combine = t1.combine, this.reflectivity = t1.reflectivity, this.refractionRatio = t1.refractionRatio, this.wireframe = t1.wireframe, this.wireframeLinewidth = t1.wireframeLinewidth, this.wireframeLinecap = t1.wireframeLinecap, this.wireframeLinejoin = t1.wireframeLinejoin, this.flatShading = t1.flatShading, this;
    }
}
$fd4eb456bcbd06f8$var$ka.prototype.isMeshPhongMaterial = !0;
class $fd4eb456bcbd06f8$var$Ba extends $fd4eb456bcbd06f8$var$ie {
    constructor(t1){
        super(), this.defines = {
            TOON: ""
        }, this.type = "MeshToonMaterial", this.color = new $fd4eb456bcbd06f8$var$L(16777215), this.map = null, this.gradientMap = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new $fd4eb456bcbd06f8$var$L(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = 0, this.normalScale = new $fd4eb456bcbd06f8$var$g(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.alphaMap = null, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.setValues(t1);
    }
    copy(t1) {
        return super.copy(t1), this.color.copy(t1.color), this.map = t1.map, this.gradientMap = t1.gradientMap, this.lightMap = t1.lightMap, this.lightMapIntensity = t1.lightMapIntensity, this.aoMap = t1.aoMap, this.aoMapIntensity = t1.aoMapIntensity, this.emissive.copy(t1.emissive), this.emissiveMap = t1.emissiveMap, this.emissiveIntensity = t1.emissiveIntensity, this.bumpMap = t1.bumpMap, this.bumpScale = t1.bumpScale, this.normalMap = t1.normalMap, this.normalMapType = t1.normalMapType, this.normalScale.copy(t1.normalScale), this.displacementMap = t1.displacementMap, this.displacementScale = t1.displacementScale, this.displacementBias = t1.displacementBias, this.alphaMap = t1.alphaMap, this.wireframe = t1.wireframe, this.wireframeLinewidth = t1.wireframeLinewidth, this.wireframeLinecap = t1.wireframeLinecap, this.wireframeLinejoin = t1.wireframeLinejoin, this;
    }
}
$fd4eb456bcbd06f8$var$Ba.prototype.isMeshToonMaterial = !0;
class $fd4eb456bcbd06f8$var$za extends $fd4eb456bcbd06f8$var$ie {
    constructor(t1){
        super(), this.type = "MeshNormalMaterial", this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = 0, this.normalScale = new $fd4eb456bcbd06f8$var$g(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.wireframe = !1, this.wireframeLinewidth = 1, this.fog = !1, this.flatShading = !1, this.setValues(t1);
    }
    copy(t1) {
        return super.copy(t1), this.bumpMap = t1.bumpMap, this.bumpScale = t1.bumpScale, this.normalMap = t1.normalMap, this.normalMapType = t1.normalMapType, this.normalScale.copy(t1.normalScale), this.displacementMap = t1.displacementMap, this.displacementScale = t1.displacementScale, this.displacementBias = t1.displacementBias, this.wireframe = t1.wireframe, this.wireframeLinewidth = t1.wireframeLinewidth, this.flatShading = t1.flatShading, this;
    }
}
$fd4eb456bcbd06f8$var$za.prototype.isMeshNormalMaterial = !0;
class $fd4eb456bcbd06f8$var$Ha extends $fd4eb456bcbd06f8$var$ie {
    constructor(t1){
        super(), this.type = "MeshLambertMaterial", this.color = new $fd4eb456bcbd06f8$var$L(16777215), this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new $fd4eb456bcbd06f8$var$L(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.combine = 0, this.reflectivity = 1, this.refractionRatio = .98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.setValues(t1);
    }
    copy(t1) {
        return super.copy(t1), this.color.copy(t1.color), this.map = t1.map, this.lightMap = t1.lightMap, this.lightMapIntensity = t1.lightMapIntensity, this.aoMap = t1.aoMap, this.aoMapIntensity = t1.aoMapIntensity, this.emissive.copy(t1.emissive), this.emissiveMap = t1.emissiveMap, this.emissiveIntensity = t1.emissiveIntensity, this.specularMap = t1.specularMap, this.alphaMap = t1.alphaMap, this.envMap = t1.envMap, this.combine = t1.combine, this.reflectivity = t1.reflectivity, this.refractionRatio = t1.refractionRatio, this.wireframe = t1.wireframe, this.wireframeLinewidth = t1.wireframeLinewidth, this.wireframeLinecap = t1.wireframeLinecap, this.wireframeLinejoin = t1.wireframeLinejoin, this;
    }
}
$fd4eb456bcbd06f8$var$Ha.prototype.isMeshLambertMaterial = !0;
class $fd4eb456bcbd06f8$var$Va extends $fd4eb456bcbd06f8$var$ie {
    constructor(t1){
        super(), this.defines = {
            MATCAP: ""
        }, this.type = "MeshMatcapMaterial", this.color = new $fd4eb456bcbd06f8$var$L(16777215), this.matcap = null, this.map = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = 0, this.normalScale = new $fd4eb456bcbd06f8$var$g(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.alphaMap = null, this.flatShading = !1, this.setValues(t1);
    }
    copy(t1) {
        return super.copy(t1), this.defines = {
            MATCAP: ""
        }, this.color.copy(t1.color), this.matcap = t1.matcap, this.map = t1.map, this.bumpMap = t1.bumpMap, this.bumpScale = t1.bumpScale, this.normalMap = t1.normalMap, this.normalMapType = t1.normalMapType, this.normalScale.copy(t1.normalScale), this.displacementMap = t1.displacementMap, this.displacementScale = t1.displacementScale, this.displacementBias = t1.displacementBias, this.alphaMap = t1.alphaMap, this.flatShading = t1.flatShading, this;
    }
}
$fd4eb456bcbd06f8$var$Va.prototype.isMeshMatcapMaterial = !0;
class $fd4eb456bcbd06f8$var$Ga extends $fd4eb456bcbd06f8$var$gs {
    constructor(t1){
        super(), this.type = "LineDashedMaterial", this.scale = 1, this.dashSize = 3, this.gapSize = 1, this.setValues(t1);
    }
    copy(t1) {
        return super.copy(t1), this.scale = t1.scale, this.dashSize = t1.dashSize, this.gapSize = t1.gapSize, this;
    }
}
$fd4eb456bcbd06f8$var$Ga.prototype.isLineDashedMaterial = !0;
const $fd4eb456bcbd06f8$var$Wa = {
    ShadowMaterial: $fd4eb456bcbd06f8$var$Oa,
    SpriteMaterial: $fd4eb456bcbd06f8$var$Br,
    RawShaderMaterial: $fd4eb456bcbd06f8$var$Na,
    ShaderMaterial: $fd4eb456bcbd06f8$var$Ve,
    PointsMaterial: $fd4eb456bcbd06f8$var$As,
    MeshPhysicalMaterial: $fd4eb456bcbd06f8$var$Ua,
    MeshStandardMaterial: $fd4eb456bcbd06f8$var$Fa,
    MeshPhongMaterial: $fd4eb456bcbd06f8$var$ka,
    MeshToonMaterial: $fd4eb456bcbd06f8$var$Ba,
    MeshNormalMaterial: $fd4eb456bcbd06f8$var$za,
    MeshLambertMaterial: $fd4eb456bcbd06f8$var$Ha,
    MeshDepthMaterial: $fd4eb456bcbd06f8$var$_r,
    MeshDistanceMaterial: $fd4eb456bcbd06f8$var$wr,
    MeshBasicMaterial: $fd4eb456bcbd06f8$var$re,
    MeshMatcapMaterial: $fd4eb456bcbd06f8$var$Va,
    LineDashedMaterial: $fd4eb456bcbd06f8$var$Ga,
    LineBasicMaterial: $fd4eb456bcbd06f8$var$gs,
    Material: $fd4eb456bcbd06f8$var$ie
};
$fd4eb456bcbd06f8$var$ie.fromType = function(t1) {
    return new $fd4eb456bcbd06f8$var$Wa[t1];
};
const $fd4eb456bcbd06f8$var$ja = {
    arraySlice: function(t1, e, n) {
        return $fd4eb456bcbd06f8$var$ja.isTypedArray(t1) ? new t1.constructor(t1.subarray(e, void 0 !== n ? n : t1.length)) : t1.slice(e, n);
    },
    convertArray: function(t1, e, n) {
        return !t1 || !n && t1.constructor === e ? t1 : "number" == typeof e.BYTES_PER_ELEMENT ? new e(t1) : Array.prototype.slice.call(t1);
    },
    isTypedArray: function(t1) {
        return ArrayBuffer.isView(t1) && !(t1 instanceof DataView);
    },
    getKeyframeOrder: function(t1) {
        const e = t1.length, n = new Array(e);
        for(let t1 = 0; t1 !== e; ++t1)n[t1] = t1;
        return n.sort(function(e, n) {
            return t1[e] - t1[n];
        }), n;
    },
    sortedArray: function(t1, e, n) {
        const i = t1.length, r = new t1.constructor(i);
        for(let s = 0, a = 0; a !== i; ++s){
            const i = n[s] * e;
            for(let n = 0; n !== e; ++n)r[a++] = t1[i + n];
        }
        return r;
    },
    flattenJSON: function(t1, e, n, i) {
        let r = 1, s = t1[0];
        for(; void 0 !== s && void 0 === s[i];)s = t1[r++];
        if (void 0 === s) return;
        let a = s[i];
        if (void 0 !== a) {
            if (Array.isArray(a)) do a = s[i], void 0 !== a && (e.push(s.time), n.push.apply(n, a)), s = t1[r++];
            while (void 0 !== s);
            else if (void 0 !== a.toArray) do a = s[i], void 0 !== a && (e.push(s.time), a.toArray(n, n.length)), s = t1[r++];
            while (void 0 !== s);
            else do a = s[i], void 0 !== a && (e.push(s.time), n.push(a)), s = t1[r++];
            while (void 0 !== s);
        }
    },
    subclip: function(t1, e, n, i, r = 30) {
        const s = t1.clone();
        s.name = e;
        const a = [];
        for(let t1 = 0; t1 < s.tracks.length; ++t1){
            const e = s.tracks[t1], o = e.getValueSize(), l = [], h = [];
            for(let t1 = 0; t1 < e.times.length; ++t1){
                const s = e.times[t1] * r;
                if (!(s < n || s >= i)) {
                    l.push(e.times[t1]);
                    for(let n = 0; n < o; ++n)h.push(e.values[t1 * o + n]);
                }
            }
            0 !== l.length && (e.times = $fd4eb456bcbd06f8$var$ja.convertArray(l, e.times.constructor), e.values = $fd4eb456bcbd06f8$var$ja.convertArray(h, e.values.constructor), a.push(e));
        }
        s.tracks = a;
        let o = 1 / 0;
        for(let t1 = 0; t1 < s.tracks.length; ++t1)o > s.tracks[t1].times[0] && (o = s.tracks[t1].times[0]);
        for(let t1 = 0; t1 < s.tracks.length; ++t1)s.tracks[t1].shift(-1 * o);
        return s.resetDuration(), s;
    },
    makeClipAdditive: function(t1, e = 0, n = t1, i = 30) {
        i <= 0 && (i = 30);
        const r = n.tracks.length, s = e / i;
        for(let e = 0; e < r; ++e){
            const i = n.tracks[e], r = i.ValueTypeName;
            if ("bool" === r || "string" === r) continue;
            const a = t1.tracks.find(function(t1) {
                return t1.name === i.name && t1.ValueTypeName === r;
            });
            if (void 0 === a) continue;
            let o = 0;
            const l = i.getValueSize();
            i.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline && (o = l / 3);
            let h = 0;
            const c = a.getValueSize();
            a.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline && (h = c / 3);
            const u = i.times.length - 1;
            let d;
            if (s <= i.times[0]) {
                const t1 = o, e = l - o;
                d = $fd4eb456bcbd06f8$var$ja.arraySlice(i.values, t1, e);
            } else if (s >= i.times[u]) {
                const t1 = u * l + o, e = t1 + l - o;
                d = $fd4eb456bcbd06f8$var$ja.arraySlice(i.values, t1, e);
            } else {
                const t1 = i.createInterpolant(), e = o, n = l - o;
                t1.evaluate(s), d = $fd4eb456bcbd06f8$var$ja.arraySlice(t1.resultBuffer, e, n);
            }
            if ("quaternion" === r) (new $fd4eb456bcbd06f8$var$H).fromArray(d).normalize().conjugate().toArray(d);
            const p = a.times.length;
            for(let t1 = 0; t1 < p; ++t1){
                const e = t1 * c + h;
                if ("quaternion" === r) $fd4eb456bcbd06f8$var$H.multiplyQuaternionsFlat(a.values, e, d, 0, a.values, e);
                else {
                    const t1 = c - 2 * h;
                    for(let n = 0; n < t1; ++n)a.values[e + n] -= d[n];
                }
            }
        }
        return t1.blendMode = 2501, t1;
    }
};
class $fd4eb456bcbd06f8$var$qa {
    constructor(t1, e, n, i){
        this.parameterPositions = t1, this._cachedIndex = 0, this.resultBuffer = void 0 !== i ? i : new e.constructor(n), this.sampleValues = e, this.valueSize = n, this.settings = null, this.DefaultSettings_ = {};
    }
    evaluate(t1) {
        const e = this.parameterPositions;
        let n = this._cachedIndex, i = e[n], r = e[n - 1];
        t: {
            e: {
                let s;
                n: {
                    i: if (!(t1 < i)) {
                        for(let s = n + 2;;){
                            if (void 0 === i) {
                                if (t1 < r) break i;
                                return n = e.length, this._cachedIndex = n, this.afterEnd_(n - 1, t1, r);
                            }
                            if (n === s) break;
                            if (r = i, i = e[++n], t1 < i) break e;
                        }
                        s = e.length;
                        break n;
                    }
                    if (t1 >= r) break t;
                    {
                        const a = e[1];
                        t1 < a && (n = 2, r = a);
                        for(let s = n - 2;;){
                            if (void 0 === r) return this._cachedIndex = 0, this.beforeStart_(0, t1, i);
                            if (n === s) break;
                            if (i = r, r = e[--n - 1], t1 >= r) break e;
                        }
                        s = n, n = 0;
                    }
                }
                for(; n < s;){
                    const i = n + s >>> 1;
                    t1 < e[i] ? s = i : n = i + 1;
                }
                if (i = e[n], r = e[n - 1], void 0 === r) return this._cachedIndex = 0, this.beforeStart_(0, t1, i);
                if (void 0 === i) return n = e.length, this._cachedIndex = n, this.afterEnd_(n - 1, r, t1);
            }
            this._cachedIndex = n, this.intervalChanged_(n, r, i);
        }
        return this.interpolate_(n, r, t1, i);
    }
    getSettings_() {
        return this.settings || this.DefaultSettings_;
    }
    copySampleValue_(t1) {
        const e = this.resultBuffer, n = this.sampleValues, i = this.valueSize, r = t1 * i;
        for(let t1 = 0; t1 !== i; ++t1)e[t1] = n[r + t1];
        return e;
    }
    interpolate_() {
        throw new Error("call to abstract method");
    }
    intervalChanged_() {}
}
$fd4eb456bcbd06f8$var$qa.prototype.beforeStart_ = $fd4eb456bcbd06f8$var$qa.prototype.copySampleValue_, $fd4eb456bcbd06f8$var$qa.prototype.afterEnd_ = $fd4eb456bcbd06f8$var$qa.prototype.copySampleValue_;
class $fd4eb456bcbd06f8$var$Xa extends $fd4eb456bcbd06f8$var$qa {
    constructor(t1, e, n, i){
        super(t1, e, n, i), this._weightPrev = -0, this._offsetPrev = -0, this._weightNext = -0, this._offsetNext = -0, this.DefaultSettings_ = {
            endingStart: 2400,
            endingEnd: 2400
        };
    }
    intervalChanged_(t1, e, n) {
        const i = this.parameterPositions;
        let r = t1 - 2, s = t1 + 1, a = i[r], o = i[s];
        if (void 0 === a) switch(this.getSettings_().endingStart){
            case 2401:
                r = t1, a = 2 * e - n;
                break;
            case 2402:
                r = i.length - 2, a = e + i[r] - i[r + 1];
                break;
            default:
                r = t1, a = n;
        }
        if (void 0 === o) switch(this.getSettings_().endingEnd){
            case 2401:
                s = t1, o = 2 * n - e;
                break;
            case 2402:
                s = 1, o = n + i[1] - i[0];
                break;
            default:
                s = t1 - 1, o = e;
        }
        const l = .5 * (n - e), h = this.valueSize;
        this._weightPrev = l / (e - a), this._weightNext = l / (o - n), this._offsetPrev = r * h, this._offsetNext = s * h;
    }
    interpolate_(t1, e, n, i) {
        const r = this.resultBuffer, s = this.sampleValues, a = this.valueSize, o = t1 * a, l = o - a, h = this._offsetPrev, c = this._offsetNext, u = this._weightPrev, d = this._weightNext, p = (n - e) / (i - e), m = p * p, f = m * p, g = -u * f + 2 * u * m - u * p, v = (1 + u) * f + (-1.5 - 2 * u) * m + (-0.5 + u) * p + 1, y = (-1 - d) * f + (1.5 + d) * m + .5 * p, x = d * f - d * m;
        for(let t1 = 0; t1 !== a; ++t1)r[t1] = g * s[h + t1] + v * s[l + t1] + y * s[o + t1] + x * s[c + t1];
        return r;
    }
}
class $fd4eb456bcbd06f8$var$$a extends $fd4eb456bcbd06f8$var$qa {
    constructor(t1, e, n, i){
        super(t1, e, n, i);
    }
    interpolate_(t1, e, n, i) {
        const r = this.resultBuffer, s = this.sampleValues, a = this.valueSize, o = t1 * a, l = o - a, h = (n - e) / (i - e), c = 1 - h;
        for(let t1 = 0; t1 !== a; ++t1)r[t1] = s[l + t1] * c + s[o + t1] * h;
        return r;
    }
}
class $fd4eb456bcbd06f8$var$Ya extends $fd4eb456bcbd06f8$var$qa {
    constructor(t1, e, n, i){
        super(t1, e, n, i);
    }
    interpolate_(t1) {
        return this.copySampleValue_(t1 - 1);
    }
}
class $fd4eb456bcbd06f8$var$Ja {
    constructor(t1, e, n, i){
        if (void 0 === t1) throw new Error("THREE.KeyframeTrack: track name is undefined");
        if (void 0 === e || 0 === e.length) throw new Error("THREE.KeyframeTrack: no keyframes in track named " + t1);
        this.name = t1, this.times = $fd4eb456bcbd06f8$var$ja.convertArray(e, this.TimeBufferType), this.values = $fd4eb456bcbd06f8$var$ja.convertArray(n, this.ValueBufferType), this.setInterpolation(i || this.DefaultInterpolation);
    }
    static toJSON(t1) {
        const e = t1.constructor;
        let n;
        if (e.toJSON !== this.toJSON) n = e.toJSON(t1);
        else {
            n = {
                name: t1.name,
                times: $fd4eb456bcbd06f8$var$ja.convertArray(t1.times, Array),
                values: $fd4eb456bcbd06f8$var$ja.convertArray(t1.values, Array)
            };
            const e = t1.getInterpolation();
            e !== t1.DefaultInterpolation && (n.interpolation = e);
        }
        return n.type = t1.ValueTypeName, n;
    }
    InterpolantFactoryMethodDiscrete(t1) {
        return new $fd4eb456bcbd06f8$var$Ya(this.times, this.values, this.getValueSize(), t1);
    }
    InterpolantFactoryMethodLinear(t1) {
        return new $fd4eb456bcbd06f8$var$$a(this.times, this.values, this.getValueSize(), t1);
    }
    InterpolantFactoryMethodSmooth(t1) {
        return new $fd4eb456bcbd06f8$var$Xa(this.times, this.values, this.getValueSize(), t1);
    }
    setInterpolation(t1) {
        let e;
        switch(t1){
            case 2300:
                e = this.InterpolantFactoryMethodDiscrete;
                break;
            case 2301:
                e = this.InterpolantFactoryMethodLinear;
                break;
            case 2302:
                e = this.InterpolantFactoryMethodSmooth;
        }
        if (void 0 === e) {
            const e = "unsupported interpolation for " + this.ValueTypeName + " keyframe track named " + this.name;
            if (void 0 === this.createInterpolant) {
                if (t1 === this.DefaultInterpolation) throw new Error(e);
                this.setInterpolation(this.DefaultInterpolation);
            }
            return console.warn("THREE.KeyframeTrack:", e), this;
        }
        return this.createInterpolant = e, this;
    }
    getInterpolation() {
        switch(this.createInterpolant){
            case this.InterpolantFactoryMethodDiscrete:
                return 2300;
            case this.InterpolantFactoryMethodLinear:
                return 2301;
            case this.InterpolantFactoryMethodSmooth:
                return 2302;
        }
    }
    getValueSize() {
        return this.values.length / this.times.length;
    }
    shift(t1) {
        if (0 !== t1) {
            const e = this.times;
            for(let n = 0, i = e.length; n !== i; ++n)e[n] += t1;
        }
        return this;
    }
    scale(t1) {
        if (1 !== t1) {
            const e = this.times;
            for(let n = 0, i = e.length; n !== i; ++n)e[n] *= t1;
        }
        return this;
    }
    trim(t1, e) {
        const n = this.times, i = n.length;
        let r = 0, s = i - 1;
        for(; r !== i && n[r] < t1;)++r;
        for(; -1 !== s && n[s] > e;)--s;
        if (++s, 0 !== r || s !== i) {
            r >= s && (s = Math.max(s, 1), r = s - 1);
            const t1 = this.getValueSize();
            this.times = $fd4eb456bcbd06f8$var$ja.arraySlice(n, r, s), this.values = $fd4eb456bcbd06f8$var$ja.arraySlice(this.values, r * t1, s * t1);
        }
        return this;
    }
    validate() {
        let t1 = !0;
        const e = this.getValueSize();
        e - Math.floor(e) != 0 && (console.error("THREE.KeyframeTrack: Invalid value size in track.", this), t1 = !1);
        const n = this.times, i = this.values, r = n.length;
        0 === r && (console.error("THREE.KeyframeTrack: Track is empty.", this), t1 = !1);
        let s = null;
        for(let e = 0; e !== r; e++){
            const i = n[e];
            if ("number" == typeof i && isNaN(i)) {
                console.error("THREE.KeyframeTrack: Time is not a valid number.", this, e, i), t1 = !1;
                break;
            }
            if (null !== s && s > i) {
                console.error("THREE.KeyframeTrack: Out of order keys.", this, e, i, s), t1 = !1;
                break;
            }
            s = i;
        }
        if (void 0 !== i && $fd4eb456bcbd06f8$var$ja.isTypedArray(i)) for(let e = 0, n = i.length; e !== n; ++e){
            const n = i[e];
            if (isNaN(n)) {
                console.error("THREE.KeyframeTrack: Value is not a valid number.", this, e, n), t1 = !1;
                break;
            }
        }
        return t1;
    }
    optimize() {
        const t1 = $fd4eb456bcbd06f8$var$ja.arraySlice(this.times), e = $fd4eb456bcbd06f8$var$ja.arraySlice(this.values), n = this.getValueSize(), i = 2302 === this.getInterpolation(), r = t1.length - 1;
        let s = 1;
        for(let a = 1; a < r; ++a){
            let r = !1;
            const o = t1[a];
            if (o !== t1[a + 1] && (1 !== a || o !== t1[0])) {
                if (i) r = !0;
                else {
                    const t1 = a * n, i = t1 - n, s = t1 + n;
                    for(let a = 0; a !== n; ++a){
                        const n = e[t1 + a];
                        if (n !== e[i + a] || n !== e[s + a]) {
                            r = !0;
                            break;
                        }
                    }
                }
            }
            if (r) {
                if (a !== s) {
                    t1[s] = t1[a];
                    const i = a * n, r = s * n;
                    for(let t1 = 0; t1 !== n; ++t1)e[r + t1] = e[i + t1];
                }
                ++s;
            }
        }
        if (r > 0) {
            t1[s] = t1[r];
            for(let t1 = r * n, i = s * n, a = 0; a !== n; ++a)e[i + a] = e[t1 + a];
            ++s;
        }
        return s !== t1.length ? (this.times = $fd4eb456bcbd06f8$var$ja.arraySlice(t1, 0, s), this.values = $fd4eb456bcbd06f8$var$ja.arraySlice(e, 0, s * n)) : (this.times = t1, this.values = e), this;
    }
    clone() {
        const t1 = $fd4eb456bcbd06f8$var$ja.arraySlice(this.times, 0), e = $fd4eb456bcbd06f8$var$ja.arraySlice(this.values, 0), n = new this.constructor(this.name, t1, e);
        return n.createInterpolant = this.createInterpolant, n;
    }
}
$fd4eb456bcbd06f8$var$Ja.prototype.TimeBufferType = Float32Array, $fd4eb456bcbd06f8$var$Ja.prototype.ValueBufferType = Float32Array, $fd4eb456bcbd06f8$var$Ja.prototype.DefaultInterpolation = 2301;
class $fd4eb456bcbd06f8$var$Ka extends $fd4eb456bcbd06f8$var$Ja {
}
$fd4eb456bcbd06f8$var$Ka.prototype.ValueTypeName = "bool", $fd4eb456bcbd06f8$var$Ka.prototype.ValueBufferType = Array, $fd4eb456bcbd06f8$var$Ka.prototype.DefaultInterpolation = 2300, $fd4eb456bcbd06f8$var$Ka.prototype.InterpolantFactoryMethodLinear = void 0, $fd4eb456bcbd06f8$var$Ka.prototype.InterpolantFactoryMethodSmooth = void 0;
class $fd4eb456bcbd06f8$var$Za extends $fd4eb456bcbd06f8$var$Ja {
}
$fd4eb456bcbd06f8$var$Za.prototype.ValueTypeName = "color";
class $fd4eb456bcbd06f8$var$Qa extends $fd4eb456bcbd06f8$var$Ja {
}
$fd4eb456bcbd06f8$var$Qa.prototype.ValueTypeName = "number";
class $fd4eb456bcbd06f8$var$to extends $fd4eb456bcbd06f8$var$qa {
    constructor(t1, e, n, i){
        super(t1, e, n, i);
    }
    interpolate_(t1, e, n, i) {
        const r = this.resultBuffer, s = this.sampleValues, a = this.valueSize, o = (n - e) / (i - e);
        let l = t1 * a;
        for(let t1 = l + a; l !== t1; l += 4)$fd4eb456bcbd06f8$var$H.slerpFlat(r, 0, s, l - a, s, l, o);
        return r;
    }
}
class $fd4eb456bcbd06f8$var$eo extends $fd4eb456bcbd06f8$var$Ja {
    InterpolantFactoryMethodLinear(t1) {
        return new $fd4eb456bcbd06f8$var$to(this.times, this.values, this.getValueSize(), t1);
    }
}
$fd4eb456bcbd06f8$var$eo.prototype.ValueTypeName = "quaternion", $fd4eb456bcbd06f8$var$eo.prototype.DefaultInterpolation = 2301, $fd4eb456bcbd06f8$var$eo.prototype.InterpolantFactoryMethodSmooth = void 0;
class $fd4eb456bcbd06f8$var$no extends $fd4eb456bcbd06f8$var$Ja {
}
$fd4eb456bcbd06f8$var$no.prototype.ValueTypeName = "string", $fd4eb456bcbd06f8$var$no.prototype.ValueBufferType = Array, $fd4eb456bcbd06f8$var$no.prototype.DefaultInterpolation = 2300, $fd4eb456bcbd06f8$var$no.prototype.InterpolantFactoryMethodLinear = void 0, $fd4eb456bcbd06f8$var$no.prototype.InterpolantFactoryMethodSmooth = void 0;
class $fd4eb456bcbd06f8$var$io extends $fd4eb456bcbd06f8$var$Ja {
}
$fd4eb456bcbd06f8$var$io.prototype.ValueTypeName = "vector";
class $fd4eb456bcbd06f8$var$ro {
    constructor(t1, e = -1, n, i = 2500){
        this.name = t1, this.tracks = n, this.duration = e, this.blendMode = i, this.uuid = $fd4eb456bcbd06f8$var$l(), this.duration < 0 && this.resetDuration();
    }
    static parse(t1) {
        const e = [], n = t1.tracks, i = 1 / (t1.fps || 1);
        for(let t1 = 0, r = n.length; t1 !== r; ++t1)e.push($fd4eb456bcbd06f8$var$so(n[t1]).scale(i));
        const r = new this(t1.name, t1.duration, e, t1.blendMode);
        return r.uuid = t1.uuid, r;
    }
    static toJSON(t1) {
        const e = [], n = t1.tracks, i = {
            name: t1.name,
            duration: t1.duration,
            tracks: e,
            uuid: t1.uuid,
            blendMode: t1.blendMode
        };
        for(let t1 = 0, i = n.length; t1 !== i; ++t1)e.push($fd4eb456bcbd06f8$var$Ja.toJSON(n[t1]));
        return i;
    }
    static CreateFromMorphTargetSequence(t1, e, n, i) {
        const r = e.length, s = [];
        for(let t1 = 0; t1 < r; t1++){
            let a = [], o = [];
            a.push((t1 + r - 1) % r, t1, (t1 + 1) % r), o.push(0, 1, 0);
            const l = $fd4eb456bcbd06f8$var$ja.getKeyframeOrder(a);
            a = $fd4eb456bcbd06f8$var$ja.sortedArray(a, 1, l), o = $fd4eb456bcbd06f8$var$ja.sortedArray(o, 1, l), i || 0 !== a[0] || (a.push(r), o.push(o[0])), s.push(new $fd4eb456bcbd06f8$var$Qa(".morphTargetInfluences[" + e[t1].name + "]", a, o).scale(1 / n));
        }
        return new this(t1, -1, s);
    }
    static findByName(t1, e) {
        let n = t1;
        if (!Array.isArray(t1)) {
            const e = t1;
            n = e.geometry && e.geometry.animations || e.animations;
        }
        for(let t1 = 0; t1 < n.length; t1++)if (n[t1].name === e) return n[t1];
        return null;
    }
    static CreateClipsFromMorphTargetSequences(t1, e, n) {
        const i = {}, r = /^([\w-]*?)([\d]+)$/;
        for(let e = 0, n = t1.length; e < n; e++){
            const n = t1[e], s = n.name.match(r);
            if (s && s.length > 1) {
                const t1 = s[1];
                let e = i[t1];
                e || (i[t1] = e = []), e.push(n);
            }
        }
        const s = [];
        for(const t1 in i)s.push(this.CreateFromMorphTargetSequence(t1, i[t1], e, n));
        return s;
    }
    static parseAnimation(t1, e) {
        if (!t1) return console.error("THREE.AnimationClip: No animation in JSONLoader data."), null;
        const n = function(t1, e, n, i, r) {
            if (0 !== n.length) {
                const s = [], a = [];
                $fd4eb456bcbd06f8$var$ja.flattenJSON(n, s, a, i), 0 !== s.length && r.push(new t1(e, s, a));
            }
        }, i = [], r = t1.name || "default", s = t1.fps || 30, a = t1.blendMode;
        let o = t1.length || -1;
        const l = t1.hierarchy || [];
        for(let t1 = 0; t1 < l.length; t1++){
            const r = l[t1].keys;
            if (r && 0 !== r.length) {
                if (r[0].morphTargets) {
                    const t1 = {};
                    let e;
                    for(e = 0; e < r.length; e++)if (r[e].morphTargets) for(let n = 0; n < r[e].morphTargets.length; n++)t1[r[e].morphTargets[n]] = -1;
                    for(const n in t1){
                        const t1 = [], s = [];
                        for(let i = 0; i !== r[e].morphTargets.length; ++i){
                            const i = r[e];
                            t1.push(i.time), s.push(i.morphTarget === n ? 1 : 0);
                        }
                        i.push(new $fd4eb456bcbd06f8$var$Qa(".morphTargetInfluence[" + n + "]", t1, s));
                    }
                    o = t1.length * s;
                } else {
                    const s = ".bones[" + e[t1].name + "]";
                    n($fd4eb456bcbd06f8$var$io, s + ".position", r, "pos", i), n($fd4eb456bcbd06f8$var$eo, s + ".quaternion", r, "rot", i), n($fd4eb456bcbd06f8$var$io, s + ".scale", r, "scl", i);
                }
            }
        }
        if (0 === i.length) return null;
        return new this(r, o, i, a);
    }
    resetDuration() {
        let t1 = 0;
        for(let e = 0, n = this.tracks.length; e !== n; ++e){
            const n = this.tracks[e];
            t1 = Math.max(t1, n.times[n.times.length - 1]);
        }
        return this.duration = t1, this;
    }
    trim() {
        for(let t1 = 0; t1 < this.tracks.length; t1++)this.tracks[t1].trim(0, this.duration);
        return this;
    }
    validate() {
        let t1 = !0;
        for(let e = 0; e < this.tracks.length; e++)t1 = t1 && this.tracks[e].validate();
        return t1;
    }
    optimize() {
        for(let t1 = 0; t1 < this.tracks.length; t1++)this.tracks[t1].optimize();
        return this;
    }
    clone() {
        const t1 = [];
        for(let e = 0; e < this.tracks.length; e++)t1.push(this.tracks[e].clone());
        return new this.constructor(this.name, this.duration, t1, this.blendMode);
    }
    toJSON() {
        return this.constructor.toJSON(this);
    }
}
function $fd4eb456bcbd06f8$var$so(t1) {
    if (void 0 === t1.type) throw new Error("THREE.KeyframeTrack: track type undefined, can not parse");
    const e = function(t1) {
        switch(t1.toLowerCase()){
            case "scalar":
            case "double":
            case "float":
            case "number":
            case "integer":
                return $fd4eb456bcbd06f8$var$Qa;
            case "vector":
            case "vector2":
            case "vector3":
            case "vector4":
                return $fd4eb456bcbd06f8$var$io;
            case "color":
                return $fd4eb456bcbd06f8$var$Za;
            case "quaternion":
                return $fd4eb456bcbd06f8$var$eo;
            case "bool":
            case "boolean":
                return $fd4eb456bcbd06f8$var$Ka;
            case "string":
                return $fd4eb456bcbd06f8$var$no;
        }
        throw new Error("THREE.KeyframeTrack: Unsupported typeName: " + t1);
    }(t1.type);
    if (void 0 === t1.times) {
        const e = [], n = [];
        $fd4eb456bcbd06f8$var$ja.flattenJSON(t1.keys, e, n, "value"), t1.times = e, t1.values = n;
    }
    return void 0 !== e.parse ? e.parse(t1) : new e(t1.name, t1.times, t1.values, t1.interpolation);
}
const $fd4eb456bcbd06f8$var$ao = {
    enabled: !1,
    files: {},
    add: function(t1, e) {
        !1 !== this.enabled && (this.files[t1] = e);
    },
    get: function(t1) {
        if (!1 !== this.enabled) return this.files[t1];
    },
    remove: function(t1) {
        delete this.files[t1];
    },
    clear: function() {
        this.files = {};
    }
};
const $fd4eb456bcbd06f8$var$oo = new class {
    constructor(t1, e, n){
        const i = this;
        let r, s = !1, a = 0, o = 0;
        const l = [];
        this.onStart = void 0, this.onLoad = t1, this.onProgress = e, this.onError = n, this.itemStart = function(t1) {
            o++, !1 === s && void 0 !== i.onStart && i.onStart(t1, a, o), s = !0;
        }, this.itemEnd = function(t1) {
            a++, void 0 !== i.onProgress && i.onProgress(t1, a, o), a === o && (s = !1, void 0 !== i.onLoad && i.onLoad());
        }, this.itemError = function(t1) {
            void 0 !== i.onError && i.onError(t1);
        }, this.resolveURL = function(t1) {
            return r ? r(t1) : t1;
        }, this.setURLModifier = function(t1) {
            return r = t1, this;
        }, this.addHandler = function(t1, e) {
            return l.push(t1, e), this;
        }, this.removeHandler = function(t1) {
            const e = l.indexOf(t1);
            return -1 !== e && l.splice(e, 2), this;
        }, this.getHandler = function(t1) {
            for(let e = 0, n = l.length; e < n; e += 2){
                const n = l[e], i = l[e + 1];
                if (n.global && (n.lastIndex = 0), n.test(t1)) return i;
            }
            return null;
        };
    }
};
class $fd4eb456bcbd06f8$var$lo {
    constructor(t1){
        this.manager = void 0 !== t1 ? t1 : $fd4eb456bcbd06f8$var$oo, this.crossOrigin = "anonymous", this.withCredentials = !1, this.path = "", this.resourcePath = "", this.requestHeader = {};
    }
    load() {}
    loadAsync(t1, e) {
        const n = this;
        return new Promise(function(i, r) {
            n.load(t1, i, e, r);
        });
    }
    parse() {}
    setCrossOrigin(t1) {
        return this.crossOrigin = t1, this;
    }
    setWithCredentials(t1) {
        return this.withCredentials = t1, this;
    }
    setPath(t1) {
        return this.path = t1, this;
    }
    setResourcePath(t1) {
        return this.resourcePath = t1, this;
    }
    setRequestHeader(t1) {
        return this.requestHeader = t1, this;
    }
}
const $fd4eb456bcbd06f8$var$ho = {};
class $fd4eb456bcbd06f8$var$co extends $fd4eb456bcbd06f8$var$lo {
    constructor(t1){
        super(t1);
    }
    load(t1, e, n, i) {
        void 0 === t1 && (t1 = ""), void 0 !== this.path && (t1 = this.path + t1), t1 = this.manager.resolveURL(t1);
        const r = $fd4eb456bcbd06f8$var$ao.get(t1);
        if (void 0 !== r) return this.manager.itemStart(t1), setTimeout(()=>{
            e && e(r), this.manager.itemEnd(t1);
        }, 0), r;
        if (void 0 !== $fd4eb456bcbd06f8$var$ho[t1]) return void $fd4eb456bcbd06f8$var$ho[t1].push({
            onLoad: e,
            onProgress: n,
            onError: i
        });
        $fd4eb456bcbd06f8$var$ho[t1] = [], $fd4eb456bcbd06f8$var$ho[t1].push({
            onLoad: e,
            onProgress: n,
            onError: i
        });
        const s = new Request(t1, {
            headers: new Headers(this.requestHeader),
            credentials: this.withCredentials ? "include" : "same-origin"
        }), a = this.mimeType, o = this.responseType;
        fetch(s).then((e)=>{
            if (200 === e.status || 0 === e.status) {
                if (0 === e.status && console.warn("THREE.FileLoader: HTTP Status 0 received."), "undefined" == typeof ReadableStream || void 0 === e.body || void 0 === e.body.getReader) return e;
                const n = $fd4eb456bcbd06f8$var$ho[t1], i = e.body.getReader(), r = e.headers.get("Content-Length"), s = r ? parseInt(r) : 0, a = 0 !== s;
                let o = 0;
                const l = new ReadableStream({
                    start (t1) {
                        !function e() {
                            i.read().then(({ done: i, value: r })=>{
                                if (i) t1.close();
                                else {
                                    o += r.byteLength;
                                    const i = new ProgressEvent("progress", {
                                        lengthComputable: a,
                                        loaded: o,
                                        total: s
                                    });
                                    for(let t1 = 0, e = n.length; t1 < e; t1++){
                                        const e = n[t1];
                                        e.onProgress && e.onProgress(i);
                                    }
                                    t1.enqueue(r), e();
                                }
                            });
                        }();
                    }
                });
                return new Response(l);
            }
            throw Error(`fetch for "${e.url}" responded with ${e.status}: ${e.statusText}`);
        }).then((t1)=>{
            switch(o){
                case "arraybuffer":
                    return t1.arrayBuffer();
                case "blob":
                    return t1.blob();
                case "document":
                    return t1.text().then((t1)=>(new DOMParser).parseFromString(t1, a));
                case "json":
                    return t1.json();
                default:
                    if (void 0 === a) return t1.text();
                    {
                        const e = /charset="?([^;"\s]*)"?/i.exec(a), n = e && e[1] ? e[1].toLowerCase() : void 0, i = new TextDecoder(n);
                        return t1.arrayBuffer().then((t1)=>i.decode(t1));
                    }
            }
        }).then((e)=>{
            $fd4eb456bcbd06f8$var$ao.add(t1, e);
            const n = $fd4eb456bcbd06f8$var$ho[t1];
            delete $fd4eb456bcbd06f8$var$ho[t1];
            for(let t1 = 0, i = n.length; t1 < i; t1++){
                const i = n[t1];
                i.onLoad && i.onLoad(e);
            }
        }).catch((e)=>{
            const n = $fd4eb456bcbd06f8$var$ho[t1];
            if (void 0 === n) throw this.manager.itemError(t1), e;
            delete $fd4eb456bcbd06f8$var$ho[t1];
            for(let t1 = 0, i = n.length; t1 < i; t1++){
                const i = n[t1];
                i.onError && i.onError(e);
            }
            this.manager.itemError(t1);
        }).finally(()=>{
            this.manager.itemEnd(t1);
        }), this.manager.itemStart(t1);
    }
    setResponseType(t1) {
        return this.responseType = t1, this;
    }
    setMimeType(t1) {
        return this.mimeType = t1, this;
    }
}
class $fd4eb456bcbd06f8$var$uo extends $fd4eb456bcbd06f8$var$lo {
    constructor(t1){
        super(t1);
    }
    load(t1, e, n, i) {
        void 0 !== this.path && (t1 = this.path + t1), t1 = this.manager.resolveURL(t1);
        const r = this, s = $fd4eb456bcbd06f8$var$ao.get(t1);
        if (void 0 !== s) return r.manager.itemStart(t1), setTimeout(function() {
            e && e(s), r.manager.itemEnd(t1);
        }, 0), s;
        const a = $fd4eb456bcbd06f8$var$x("img");
        function o() {
            h(), $fd4eb456bcbd06f8$var$ao.add(t1, this), e && e(this), r.manager.itemEnd(t1);
        }
        function l(e) {
            h(), i && i(e), r.manager.itemError(t1), r.manager.itemEnd(t1);
        }
        function h() {
            a.removeEventListener("load", o, !1), a.removeEventListener("error", l, !1);
        }
        return a.addEventListener("load", o, !1), a.addEventListener("error", l, !1), "data:" !== t1.slice(0, 5) && void 0 !== this.crossOrigin && (a.crossOrigin = this.crossOrigin), r.manager.itemStart(t1), a.src = t1, a;
    }
}
class $fd4eb456bcbd06f8$var$po extends $fd4eb456bcbd06f8$var$lo {
    constructor(t1){
        super(t1);
    }
    load(t1, e, n, i) {
        const r = new $fd4eb456bcbd06f8$var$qe, s = new $fd4eb456bcbd06f8$var$uo(this.manager);
        s.setCrossOrigin(this.crossOrigin), s.setPath(this.path);
        let a = 0;
        function o(n) {
            s.load(t1[n], function(t1) {
                r.images[n] = t1, a++, 6 === a && (r.needsUpdate = !0, e && e(r));
            }, void 0, i);
        }
        for(let e = 0; e < t1.length; ++e)o(e);
        return r;
    }
}
class $fd4eb456bcbd06f8$var$mo extends $fd4eb456bcbd06f8$var$lo {
    constructor(t1){
        super(t1);
    }
    load(t1, e, n, i) {
        const r = this, s = new $fd4eb456bcbd06f8$var$os, a = new $fd4eb456bcbd06f8$var$co(this.manager);
        return a.setResponseType("arraybuffer"), a.setRequestHeader(this.requestHeader), a.setPath(this.path), a.setWithCredentials(r.withCredentials), a.load(t1, function(t1) {
            const n = r.parse(t1);
            n && (void 0 !== n.image ? s.image = n.image : void 0 !== n.data && (s.image.width = n.width, s.image.height = n.height, s.image.data = n.data), s.wrapS = void 0 !== n.wrapS ? n.wrapS : 1001, s.wrapT = void 0 !== n.wrapT ? n.wrapT : 1001, s.magFilter = void 0 !== n.magFilter ? n.magFilter : 1006, s.minFilter = void 0 !== n.minFilter ? n.minFilter : 1006, s.anisotropy = void 0 !== n.anisotropy ? n.anisotropy : 1, void 0 !== n.encoding && (s.encoding = n.encoding), void 0 !== n.flipY && (s.flipY = n.flipY), void 0 !== n.format && (s.format = n.format), void 0 !== n.type && (s.type = n.type), void 0 !== n.mipmaps && (s.mipmaps = n.mipmaps, s.minFilter = 1008), 1 === n.mipmapCount && (s.minFilter = 1006), void 0 !== n.generateMipmaps && (s.generateMipmaps = n.generateMipmaps), s.needsUpdate = !0, e && e(s, n));
        }, n, i), s;
    }
}
class $fd4eb456bcbd06f8$var$fo extends $fd4eb456bcbd06f8$var$lo {
    constructor(t1){
        super(t1);
    }
    load(t1, e, n, i) {
        const r = new $fd4eb456bcbd06f8$var$F, s = new $fd4eb456bcbd06f8$var$uo(this.manager);
        return s.setCrossOrigin(this.crossOrigin), s.setPath(this.path), s.load(t1, function(t1) {
            r.image = t1, r.needsUpdate = !0, void 0 !== e && e(r);
        }, n, i), r;
    }
}
class $fd4eb456bcbd06f8$var$go extends $fd4eb456bcbd06f8$var$Wt {
    constructor(t1, e = 1){
        super(), this.type = "Light", this.color = new $fd4eb456bcbd06f8$var$L(t1), this.intensity = e;
    }
    dispose() {}
    copy(t1) {
        return super.copy(t1), this.color.copy(t1.color), this.intensity = t1.intensity, this;
    }
    toJSON(t1) {
        const e = super.toJSON(t1);
        return e.object.color = this.color.getHex(), e.object.intensity = this.intensity, void 0 !== this.groundColor && (e.object.groundColor = this.groundColor.getHex()), void 0 !== this.distance && (e.object.distance = this.distance), void 0 !== this.angle && (e.object.angle = this.angle), void 0 !== this.decay && (e.object.decay = this.decay), void 0 !== this.penumbra && (e.object.penumbra = this.penumbra), void 0 !== this.shadow && (e.object.shadow = this.shadow.toJSON()), e;
    }
}
$fd4eb456bcbd06f8$var$go.prototype.isLight = !0;
(class extends $fd4eb456bcbd06f8$var$go {
    constructor(t1, e, n){
        super(t1, n), this.type = "HemisphereLight", this.position.copy($fd4eb456bcbd06f8$var$Wt.DefaultUp), this.updateMatrix(), this.groundColor = new $fd4eb456bcbd06f8$var$L(e);
    }
    copy(t1) {
        return $fd4eb456bcbd06f8$var$go.prototype.copy.call(this, t1), this.groundColor.copy(t1.groundColor), this;
    }
}).prototype.isHemisphereLight = !0;
const $fd4eb456bcbd06f8$var$vo = new $fd4eb456bcbd06f8$var$xt, $fd4eb456bcbd06f8$var$yo = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$xo = new $fd4eb456bcbd06f8$var$V;
class $fd4eb456bcbd06f8$var$bo {
    constructor(t1){
        this.camera = t1, this.bias = 0, this.normalBias = 0, this.radius = 1, this.blurSamples = 8, this.mapSize = new $fd4eb456bcbd06f8$var$g(512, 512), this.map = null, this.mapPass = null, this.matrix = new $fd4eb456bcbd06f8$var$xt, this.autoUpdate = !0, this.needsUpdate = !1, this._frustum = new $fd4eb456bcbd06f8$var$tn, this._frameExtents = new $fd4eb456bcbd06f8$var$g(1, 1), this._viewportCount = 1, this._viewports = [
            new $fd4eb456bcbd06f8$var$U(0, 0, 1, 1)
        ];
    }
    getViewportCount() {
        return this._viewportCount;
    }
    getFrustum() {
        return this._frustum;
    }
    updateMatrices(t1) {
        const e = this.camera, n = this.matrix;
        $fd4eb456bcbd06f8$var$yo.setFromMatrixPosition(t1.matrixWorld), e.position.copy($fd4eb456bcbd06f8$var$yo), $fd4eb456bcbd06f8$var$xo.setFromMatrixPosition(t1.target.matrixWorld), e.lookAt($fd4eb456bcbd06f8$var$xo), e.updateMatrixWorld(), $fd4eb456bcbd06f8$var$vo.multiplyMatrices(e.projectionMatrix, e.matrixWorldInverse), this._frustum.setFromProjectionMatrix($fd4eb456bcbd06f8$var$vo), n.set(.5, 0, 0, .5, 0, .5, 0, .5, 0, 0, .5, .5, 0, 0, 0, 1), n.multiply(e.projectionMatrix), n.multiply(e.matrixWorldInverse);
    }
    getViewport(t1) {
        return this._viewports[t1];
    }
    getFrameExtents() {
        return this._frameExtents;
    }
    dispose() {
        this.map && this.map.dispose(), this.mapPass && this.mapPass.dispose();
    }
    copy(t1) {
        return this.camera = t1.camera.clone(), this.bias = t1.bias, this.radius = t1.radius, this.mapSize.copy(t1.mapSize), this;
    }
    clone() {
        return (new this.constructor).copy(this);
    }
    toJSON() {
        const t1 = {};
        return 0 !== this.bias && (t1.bias = this.bias), 0 !== this.normalBias && (t1.normalBias = this.normalBias), 1 !== this.radius && (t1.radius = this.radius), 512 === this.mapSize.x && 512 === this.mapSize.y || (t1.mapSize = this.mapSize.toArray()), t1.camera = this.camera.toJSON(!1).object, delete t1.camera.matrix, t1;
    }
}
class $fd4eb456bcbd06f8$var$_o extends $fd4eb456bcbd06f8$var$bo {
    constructor(){
        super(new $fd4eb456bcbd06f8$var$We(50, 1, .5, 500)), this.focus = 1;
    }
    updateMatrices(t1) {
        const e = this.camera, n = 2 * $fd4eb456bcbd06f8$var$o * t1.angle * this.focus, i = this.mapSize.width / this.mapSize.height, r = t1.distance || e.far;
        n === e.fov && i === e.aspect && r === e.far || (e.fov = n, e.aspect = i, e.far = r, e.updateProjectionMatrix()), super.updateMatrices(t1);
    }
    copy(t1) {
        return super.copy(t1), this.focus = t1.focus, this;
    }
}
$fd4eb456bcbd06f8$var$_o.prototype.isSpotLightShadow = !0;
class $fd4eb456bcbd06f8$var$wo extends $fd4eb456bcbd06f8$var$go {
    constructor(t1, e, n = 0, i = Math.PI / 3, r = 0, s = 1){
        super(t1, e), this.type = "SpotLight", this.position.copy($fd4eb456bcbd06f8$var$Wt.DefaultUp), this.updateMatrix(), this.target = new $fd4eb456bcbd06f8$var$Wt, this.distance = n, this.angle = i, this.penumbra = r, this.decay = s, this.shadow = new $fd4eb456bcbd06f8$var$_o;
    }
    get power() {
        return this.intensity * Math.PI;
    }
    set power(t1) {
        this.intensity = t1 / Math.PI;
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(t1) {
        return super.copy(t1), this.distance = t1.distance, this.angle = t1.angle, this.penumbra = t1.penumbra, this.decay = t1.decay, this.target = t1.target.clone(), this.shadow = t1.shadow.clone(), this;
    }
}
$fd4eb456bcbd06f8$var$wo.prototype.isSpotLight = !0;
const $fd4eb456bcbd06f8$var$Mo = new $fd4eb456bcbd06f8$var$xt, $fd4eb456bcbd06f8$var$So = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$To = new $fd4eb456bcbd06f8$var$V;
class $fd4eb456bcbd06f8$var$Eo extends $fd4eb456bcbd06f8$var$bo {
    constructor(){
        super(new $fd4eb456bcbd06f8$var$We(90, 1, .5, 500)), this._frameExtents = new $fd4eb456bcbd06f8$var$g(4, 2), this._viewportCount = 6, this._viewports = [
            new $fd4eb456bcbd06f8$var$U(2, 1, 1, 1),
            new $fd4eb456bcbd06f8$var$U(0, 1, 1, 1),
            new $fd4eb456bcbd06f8$var$U(3, 1, 1, 1),
            new $fd4eb456bcbd06f8$var$U(1, 1, 1, 1),
            new $fd4eb456bcbd06f8$var$U(3, 0, 1, 1),
            new $fd4eb456bcbd06f8$var$U(1, 0, 1, 1)
        ], this._cubeDirections = [
            new $fd4eb456bcbd06f8$var$V(1, 0, 0),
            new $fd4eb456bcbd06f8$var$V(-1, 0, 0),
            new $fd4eb456bcbd06f8$var$V(0, 0, 1),
            new $fd4eb456bcbd06f8$var$V(0, 0, -1),
            new $fd4eb456bcbd06f8$var$V(0, 1, 0),
            new $fd4eb456bcbd06f8$var$V(0, -1, 0)
        ], this._cubeUps = [
            new $fd4eb456bcbd06f8$var$V(0, 1, 0),
            new $fd4eb456bcbd06f8$var$V(0, 1, 0),
            new $fd4eb456bcbd06f8$var$V(0, 1, 0),
            new $fd4eb456bcbd06f8$var$V(0, 1, 0),
            new $fd4eb456bcbd06f8$var$V(0, 0, 1),
            new $fd4eb456bcbd06f8$var$V(0, 0, -1)
        ];
    }
    updateMatrices(t1, e = 0) {
        const n = this.camera, i = this.matrix, r = t1.distance || n.far;
        r !== n.far && (n.far = r, n.updateProjectionMatrix()), $fd4eb456bcbd06f8$var$So.setFromMatrixPosition(t1.matrixWorld), n.position.copy($fd4eb456bcbd06f8$var$So), $fd4eb456bcbd06f8$var$To.copy(n.position), $fd4eb456bcbd06f8$var$To.add(this._cubeDirections[e]), n.up.copy(this._cubeUps[e]), n.lookAt($fd4eb456bcbd06f8$var$To), n.updateMatrixWorld(), i.makeTranslation(-$fd4eb456bcbd06f8$var$So.x, -$fd4eb456bcbd06f8$var$So.y, -$fd4eb456bcbd06f8$var$So.z), $fd4eb456bcbd06f8$var$Mo.multiplyMatrices(n.projectionMatrix, n.matrixWorldInverse), this._frustum.setFromProjectionMatrix($fd4eb456bcbd06f8$var$Mo);
    }
}
$fd4eb456bcbd06f8$var$Eo.prototype.isPointLightShadow = !0;
class $fd4eb456bcbd06f8$var$Ao extends $fd4eb456bcbd06f8$var$go {
    constructor(t1, e, n = 0, i = 1){
        super(t1, e), this.type = "PointLight", this.distance = n, this.decay = i, this.shadow = new $fd4eb456bcbd06f8$var$Eo;
    }
    get power() {
        return 4 * this.intensity * Math.PI;
    }
    set power(t1) {
        this.intensity = t1 / (4 * Math.PI);
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(t1) {
        return super.copy(t1), this.distance = t1.distance, this.decay = t1.decay, this.shadow = t1.shadow.clone(), this;
    }
}
$fd4eb456bcbd06f8$var$Ao.prototype.isPointLight = !0;
class $fd4eb456bcbd06f8$var$Ro extends $fd4eb456bcbd06f8$var$bo {
    constructor(){
        super(new $fd4eb456bcbd06f8$var$mn(-5, 5, 5, -5, .5, 500));
    }
}
$fd4eb456bcbd06f8$var$Ro.prototype.isDirectionalLightShadow = !0;
class $fd4eb456bcbd06f8$var$Co extends $fd4eb456bcbd06f8$var$go {
    constructor(t1, e){
        super(t1, e), this.type = "DirectionalLight", this.position.copy($fd4eb456bcbd06f8$var$Wt.DefaultUp), this.updateMatrix(), this.target = new $fd4eb456bcbd06f8$var$Wt, this.shadow = new $fd4eb456bcbd06f8$var$Ro;
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(t1) {
        return super.copy(t1), this.target = t1.target.clone(), this.shadow = t1.shadow.clone(), this;
    }
}
$fd4eb456bcbd06f8$var$Co.prototype.isDirectionalLight = !0;
(class extends $fd4eb456bcbd06f8$var$go {
    constructor(t1, e){
        super(t1, e), this.type = "AmbientLight";
    }
}).prototype.isAmbientLight = !0;
(class extends $fd4eb456bcbd06f8$var$go {
    constructor(t1, e, n = 10, i = 10){
        super(t1, e), this.type = "RectAreaLight", this.width = n, this.height = i;
    }
    get power() {
        return this.intensity * this.width * this.height * Math.PI;
    }
    set power(t1) {
        this.intensity = t1 / (this.width * this.height * Math.PI);
    }
    copy(t1) {
        return super.copy(t1), this.width = t1.width, this.height = t1.height, this;
    }
    toJSON(t1) {
        const e = super.toJSON(t1);
        return e.object.width = this.width, e.object.height = this.height, e;
    }
}).prototype.isRectAreaLight = !0;
class $fd4eb456bcbd06f8$var$Lo {
    constructor(){
        this.coefficients = [];
        for(let t1 = 0; t1 < 9; t1++)this.coefficients.push(new $fd4eb456bcbd06f8$var$V);
    }
    set(t1) {
        for(let e = 0; e < 9; e++)this.coefficients[e].copy(t1[e]);
        return this;
    }
    zero() {
        for(let t1 = 0; t1 < 9; t1++)this.coefficients[t1].set(0, 0, 0);
        return this;
    }
    getAt(t1, e) {
        const n = t1.x, i = t1.y, r = t1.z, s = this.coefficients;
        return e.copy(s[0]).multiplyScalar(.282095), e.addScaledVector(s[1], .488603 * i), e.addScaledVector(s[2], .488603 * r), e.addScaledVector(s[3], .488603 * n), e.addScaledVector(s[4], n * i * 1.092548), e.addScaledVector(s[5], i * r * 1.092548), e.addScaledVector(s[6], .315392 * (3 * r * r - 1)), e.addScaledVector(s[7], n * r * 1.092548), e.addScaledVector(s[8], .546274 * (n * n - i * i)), e;
    }
    getIrradianceAt(t1, e) {
        const n = t1.x, i = t1.y, r = t1.z, s = this.coefficients;
        return e.copy(s[0]).multiplyScalar(.886227), e.addScaledVector(s[1], 1.023328 * i), e.addScaledVector(s[2], 1.023328 * r), e.addScaledVector(s[3], 1.023328 * n), e.addScaledVector(s[4], .858086 * n * i), e.addScaledVector(s[5], .858086 * i * r), e.addScaledVector(s[6], .743125 * r * r - .247708), e.addScaledVector(s[7], .858086 * n * r), e.addScaledVector(s[8], .429043 * (n * n - i * i)), e;
    }
    add(t1) {
        for(let e = 0; e < 9; e++)this.coefficients[e].add(t1.coefficients[e]);
        return this;
    }
    addScaledSH(t1, e) {
        for(let n = 0; n < 9; n++)this.coefficients[n].addScaledVector(t1.coefficients[n], e);
        return this;
    }
    scale(t1) {
        for(let e = 0; e < 9; e++)this.coefficients[e].multiplyScalar(t1);
        return this;
    }
    lerp(t1, e) {
        for(let n = 0; n < 9; n++)this.coefficients[n].lerp(t1.coefficients[n], e);
        return this;
    }
    equals(t1) {
        for(let e = 0; e < 9; e++)if (!this.coefficients[e].equals(t1.coefficients[e])) return !1;
        return !0;
    }
    copy(t1) {
        return this.set(t1.coefficients);
    }
    clone() {
        return (new this.constructor).copy(this);
    }
    fromArray(t1, e = 0) {
        const n = this.coefficients;
        for(let i = 0; i < 9; i++)n[i].fromArray(t1, e + 3 * i);
        return this;
    }
    toArray(t1 = [], e = 0) {
        const n = this.coefficients;
        for(let i = 0; i < 9; i++)n[i].toArray(t1, e + 3 * i);
        return t1;
    }
    static getBasisAt(t1, e) {
        const n = t1.x, i = t1.y, r = t1.z;
        e[0] = .282095, e[1] = .488603 * i, e[2] = .488603 * r, e[3] = .488603 * n, e[4] = 1.092548 * n * i, e[5] = 1.092548 * i * r, e[6] = .315392 * (3 * r * r - 1), e[7] = 1.092548 * n * r, e[8] = .546274 * (n * n - i * i);
    }
}
$fd4eb456bcbd06f8$var$Lo.prototype.isSphericalHarmonics3 = !0;
class $fd4eb456bcbd06f8$var$Po extends $fd4eb456bcbd06f8$var$go {
    constructor(t1 = new $fd4eb456bcbd06f8$var$Lo, e = 1){
        super(void 0, e), this.sh = t1;
    }
    copy(t1) {
        return super.copy(t1), this.sh.copy(t1.sh), this;
    }
    fromJSON(t1) {
        return this.intensity = t1.intensity, this.sh.fromArray(t1.sh), this;
    }
    toJSON(t1) {
        const e = super.toJSON(t1);
        return e.object.sh = this.sh.toArray(), e;
    }
}
$fd4eb456bcbd06f8$var$Po.prototype.isLightProbe = !0;
class $fd4eb456bcbd06f8$var$Do {
    static decodeText(t1) {
        if ("undefined" != typeof TextDecoder) return (new TextDecoder).decode(t1);
        let e = "";
        for(let n = 0, i = t1.length; n < i; n++)e += String.fromCharCode(t1[n]);
        try {
            return decodeURIComponent(escape(e));
        } catch (t1) {
            return e;
        }
    }
    static extractUrlBase(t1) {
        const e = t1.lastIndexOf("/");
        return -1 === e ? "./" : t1.slice(0, e + 1);
    }
    static resolveURL(t1, e) {
        return "string" != typeof t1 || "" === t1 ? "" : (/^https?:\/\//i.test(e) && /^\//.test(t1) && (e = e.replace(/(^https?:\/\/[^\/]+).*/i, "$1")), /^(https?:)?\/\//i.test(t1) || /^data:.*,.*$/i.test(t1) || /^blob:.*$/i.test(t1) ? t1 : e + t1);
    }
}
(class extends $fd4eb456bcbd06f8$var$ye {
    constructor(){
        super(), this.type = "InstancedBufferGeometry", this.instanceCount = 1 / 0;
    }
    copy(t1) {
        return super.copy(t1), this.instanceCount = t1.instanceCount, this;
    }
    clone() {
        return (new this.constructor).copy(this);
    }
    toJSON() {
        const t1 = super.toJSON(this);
        return t1.instanceCount = this.instanceCount, t1.isInstancedBufferGeometry = !0, t1;
    }
}).prototype.isInstancedBufferGeometry = !0;
class $fd4eb456bcbd06f8$var$Io extends $fd4eb456bcbd06f8$var$lo {
    constructor(t1){
        super(t1), "undefined" == typeof createImageBitmap && console.warn("THREE.ImageBitmapLoader: createImageBitmap() not supported."), "undefined" == typeof fetch && console.warn("THREE.ImageBitmapLoader: fetch() not supported."), this.options = {
            premultiplyAlpha: "none"
        };
    }
    setOptions(t1) {
        return this.options = t1, this;
    }
    load(t1, e, n, i) {
        void 0 === t1 && (t1 = ""), void 0 !== this.path && (t1 = this.path + t1), t1 = this.manager.resolveURL(t1);
        const r = this, s = $fd4eb456bcbd06f8$var$ao.get(t1);
        if (void 0 !== s) return r.manager.itemStart(t1), setTimeout(function() {
            e && e(s), r.manager.itemEnd(t1);
        }, 0), s;
        const a = {};
        a.credentials = "anonymous" === this.crossOrigin ? "same-origin" : "include", a.headers = this.requestHeader, fetch(t1, a).then(function(t1) {
            return t1.blob();
        }).then(function(t1) {
            return createImageBitmap(t1, Object.assign(r.options, {
                colorSpaceConversion: "none"
            }));
        }).then(function(n) {
            $fd4eb456bcbd06f8$var$ao.add(t1, n), e && e(n), r.manager.itemEnd(t1);
        }).catch(function(e) {
            i && i(e), r.manager.itemError(t1), r.manager.itemEnd(t1);
        }), r.manager.itemStart(t1);
    }
}
let $fd4eb456bcbd06f8$var$Oo;
$fd4eb456bcbd06f8$var$Io.prototype.isImageBitmapLoader = !0;
const $fd4eb456bcbd06f8$var$No = function() {
    return void 0 === $fd4eb456bcbd06f8$var$Oo && ($fd4eb456bcbd06f8$var$Oo = new (window.AudioContext || window.webkitAudioContext)), $fd4eb456bcbd06f8$var$Oo;
};
class $fd4eb456bcbd06f8$var$Fo extends $fd4eb456bcbd06f8$var$lo {
    constructor(t1){
        super(t1);
    }
    load(t1, e, n, i) {
        const r = this, s = new $fd4eb456bcbd06f8$var$co(this.manager);
        s.setResponseType("arraybuffer"), s.setPath(this.path), s.setRequestHeader(this.requestHeader), s.setWithCredentials(this.withCredentials), s.load(t1, function(n) {
            try {
                const t1 = n.slice(0);
                $fd4eb456bcbd06f8$var$No().decodeAudioData(t1, function(t1) {
                    e(t1);
                });
            } catch (e) {
                i ? i(e) : console.error(e), r.manager.itemError(t1);
            }
        }, n, i);
    }
}
(class extends $fd4eb456bcbd06f8$var$Po {
    constructor(t1, e, n = 1){
        super(void 0, n);
        const i = (new $fd4eb456bcbd06f8$var$L).set(t1), r = (new $fd4eb456bcbd06f8$var$L).set(e), s = new $fd4eb456bcbd06f8$var$V(i.r, i.g, i.b), a = new $fd4eb456bcbd06f8$var$V(r.r, r.g, r.b), o = Math.sqrt(Math.PI), l = o * Math.sqrt(.75);
        this.sh.coefficients[0].copy(s).add(a).multiplyScalar(o), this.sh.coefficients[1].copy(s).sub(a).multiplyScalar(l);
    }
}).prototype.isHemisphereLightProbe = !0;
(class extends $fd4eb456bcbd06f8$var$Po {
    constructor(t1, e = 1){
        super(void 0, e);
        const n = (new $fd4eb456bcbd06f8$var$L).set(t1);
        this.sh.coefficients[0].set(n.r, n.g, n.b).multiplyScalar(2 * Math.sqrt(Math.PI));
    }
}).prototype.isAmbientLightProbe = !0;
class $fd4eb456bcbd06f8$var$Uo {
    constructor(t1, e, n){
        let i, r, s;
        switch(this.binding = t1, this.valueSize = n, e){
            case "quaternion":
                i = this._slerp, r = this._slerpAdditive, s = this._setAdditiveIdentityQuaternion, this.buffer = new Float64Array(6 * n), this._workIndex = 5;
                break;
            case "string":
            case "bool":
                i = this._select, r = this._select, s = this._setAdditiveIdentityOther, this.buffer = new Array(5 * n);
                break;
            default:
                i = this._lerp, r = this._lerpAdditive, s = this._setAdditiveIdentityNumeric, this.buffer = new Float64Array(5 * n);
        }
        this._mixBufferRegion = i, this._mixBufferRegionAdditive = r, this._setIdentity = s, this._origIndex = 3, this._addIndex = 4, this.cumulativeWeight = 0, this.cumulativeWeightAdditive = 0, this.useCount = 0, this.referenceCount = 0;
    }
    accumulate(t1, e) {
        const n = this.buffer, i = this.valueSize, r = t1 * i + i;
        let s = this.cumulativeWeight;
        if (0 === s) {
            for(let t1 = 0; t1 !== i; ++t1)n[r + t1] = n[t1];
            s = e;
        } else {
            s += e;
            const t1 = e / s;
            this._mixBufferRegion(n, r, 0, t1, i);
        }
        this.cumulativeWeight = s;
    }
    accumulateAdditive(t1) {
        const e = this.buffer, n = this.valueSize, i = n * this._addIndex;
        0 === this.cumulativeWeightAdditive && this._setIdentity(), this._mixBufferRegionAdditive(e, i, 0, t1, n), this.cumulativeWeightAdditive += t1;
    }
    apply(t1) {
        const e = this.valueSize, n = this.buffer, i = t1 * e + e, r = this.cumulativeWeight, s = this.cumulativeWeightAdditive, a = this.binding;
        if (this.cumulativeWeight = 0, this.cumulativeWeightAdditive = 0, r < 1) {
            const t1 = e * this._origIndex;
            this._mixBufferRegion(n, i, t1, 1 - r, e);
        }
        s > 0 && this._mixBufferRegionAdditive(n, i, this._addIndex * e, 1, e);
        for(let t1 = e, r = e + e; t1 !== r; ++t1)if (n[t1] !== n[t1 + e]) {
            a.setValue(n, i);
            break;
        }
    }
    saveOriginalState() {
        const t1 = this.binding, e = this.buffer, n = this.valueSize, i = n * this._origIndex;
        t1.getValue(e, i);
        for(let t1 = n, r = i; t1 !== r; ++t1)e[t1] = e[i + t1 % n];
        this._setIdentity(), this.cumulativeWeight = 0, this.cumulativeWeightAdditive = 0;
    }
    restoreOriginalState() {
        const t1 = 3 * this.valueSize;
        this.binding.setValue(this.buffer, t1);
    }
    _setAdditiveIdentityNumeric() {
        const t1 = this._addIndex * this.valueSize, e = t1 + this.valueSize;
        for(let n = t1; n < e; n++)this.buffer[n] = 0;
    }
    _setAdditiveIdentityQuaternion() {
        this._setAdditiveIdentityNumeric(), this.buffer[this._addIndex * this.valueSize + 3] = 1;
    }
    _setAdditiveIdentityOther() {
        const t1 = this._origIndex * this.valueSize, e = this._addIndex * this.valueSize;
        for(let n = 0; n < this.valueSize; n++)this.buffer[e + n] = this.buffer[t1 + n];
    }
    _select(t1, e, n, i, r) {
        if (i >= .5) for(let i = 0; i !== r; ++i)t1[e + i] = t1[n + i];
    }
    _slerp(t1, e, n, i) {
        $fd4eb456bcbd06f8$var$H.slerpFlat(t1, e, t1, e, t1, n, i);
    }
    _slerpAdditive(t1, e, n, i, r) {
        const s = this._workIndex * r;
        $fd4eb456bcbd06f8$var$H.multiplyQuaternionsFlat(t1, s, t1, e, t1, n), $fd4eb456bcbd06f8$var$H.slerpFlat(t1, e, t1, e, t1, s, i);
    }
    _lerp(t1, e, n, i, r) {
        const s = 1 - i;
        for(let a = 0; a !== r; ++a){
            const r = e + a;
            t1[r] = t1[r] * s + t1[n + a] * i;
        }
    }
    _lerpAdditive(t1, e, n, i, r) {
        for(let s = 0; s !== r; ++s){
            const r = e + s;
            t1[r] = t1[r] + t1[n + s] * i;
        }
    }
}
const $fd4eb456bcbd06f8$var$ko = new RegExp("[\\[\\]\\.:\\/]", "g"), $fd4eb456bcbd06f8$var$Bo = "[^" + "\\[\\]\\.:\\/".replace("\\.", "") + "]", $fd4eb456bcbd06f8$var$zo = /((?:WC+[\/:])*)/.source.replace("WC", "[^\\[\\]\\.:\\/]"), $fd4eb456bcbd06f8$var$Ho = /(WCOD+)?/.source.replace("WCOD", $fd4eb456bcbd06f8$var$Bo), $fd4eb456bcbd06f8$var$Vo = /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace("WC", "[^\\[\\]\\.:\\/]"), $fd4eb456bcbd06f8$var$Go = /\.(WC+)(?:\[(.+)\])?/.source.replace("WC", "[^\\[\\]\\.:\\/]"), $fd4eb456bcbd06f8$var$Wo = new RegExp("^" + $fd4eb456bcbd06f8$var$zo + $fd4eb456bcbd06f8$var$Ho + $fd4eb456bcbd06f8$var$Vo + $fd4eb456bcbd06f8$var$Go + "$"), $fd4eb456bcbd06f8$var$jo = [
    "material",
    "materials",
    "bones"
];
class $fd4eb456bcbd06f8$var$qo {
    constructor(t1, e, n){
        this.path = e, this.parsedPath = n || $fd4eb456bcbd06f8$var$qo.parseTrackName(e), this.node = $fd4eb456bcbd06f8$var$qo.findNode(t1, this.parsedPath.nodeName) || t1, this.rootNode = t1, this.getValue = this._getValue_unbound, this.setValue = this._setValue_unbound;
    }
    static create(t1, e, n) {
        return t1 && t1.isAnimationObjectGroup ? new $fd4eb456bcbd06f8$var$qo.Composite(t1, e, n) : new $fd4eb456bcbd06f8$var$qo(t1, e, n);
    }
    static sanitizeNodeName(t1) {
        return t1.replace(/\s/g, "_").replace($fd4eb456bcbd06f8$var$ko, "");
    }
    static parseTrackName(t1) {
        const e = $fd4eb456bcbd06f8$var$Wo.exec(t1);
        if (null === e) throw new Error("PropertyBinding: Cannot parse trackName: " + t1);
        const n = {
            nodeName: e[2],
            objectName: e[3],
            objectIndex: e[4],
            propertyName: e[5],
            propertyIndex: e[6]
        }, i = n.nodeName && n.nodeName.lastIndexOf(".");
        if (void 0 !== i && -1 !== i) {
            const t1 = n.nodeName.substring(i + 1);
            -1 !== $fd4eb456bcbd06f8$var$jo.indexOf(t1) && (n.nodeName = n.nodeName.substring(0, i), n.objectName = t1);
        }
        if (null === n.propertyName || 0 === n.propertyName.length) throw new Error("PropertyBinding: can not parse propertyName from trackName: " + t1);
        return n;
    }
    static findNode(t1, e) {
        if (void 0 === e || "" === e || "." === e || -1 === e || e === t1.name || e === t1.uuid) return t1;
        if (t1.skeleton) {
            const n = t1.skeleton.getBoneByName(e);
            if (void 0 !== n) return n;
        }
        if (t1.children) {
            const n = function(t1) {
                for(let i = 0; i < t1.length; i++){
                    const r = t1[i];
                    if (r.name === e || r.uuid === e) return r;
                    const s = n(r.children);
                    if (s) return s;
                }
                return null;
            }, i = n(t1.children);
            if (i) return i;
        }
        return null;
    }
    _getValue_unavailable() {}
    _setValue_unavailable() {}
    _getValue_direct(t1, e) {
        t1[e] = this.targetObject[this.propertyName];
    }
    _getValue_array(t1, e) {
        const n = this.resolvedProperty;
        for(let i = 0, r = n.length; i !== r; ++i)t1[e++] = n[i];
    }
    _getValue_arrayElement(t1, e) {
        t1[e] = this.resolvedProperty[this.propertyIndex];
    }
    _getValue_toArray(t1, e) {
        this.resolvedProperty.toArray(t1, e);
    }
    _setValue_direct(t1, e) {
        this.targetObject[this.propertyName] = t1[e];
    }
    _setValue_direct_setNeedsUpdate(t1, e) {
        this.targetObject[this.propertyName] = t1[e], this.targetObject.needsUpdate = !0;
    }
    _setValue_direct_setMatrixWorldNeedsUpdate(t1, e) {
        this.targetObject[this.propertyName] = t1[e], this.targetObject.matrixWorldNeedsUpdate = !0;
    }
    _setValue_array(t1, e) {
        const n = this.resolvedProperty;
        for(let i = 0, r = n.length; i !== r; ++i)n[i] = t1[e++];
    }
    _setValue_array_setNeedsUpdate(t1, e) {
        const n = this.resolvedProperty;
        for(let i = 0, r = n.length; i !== r; ++i)n[i] = t1[e++];
        this.targetObject.needsUpdate = !0;
    }
    _setValue_array_setMatrixWorldNeedsUpdate(t1, e) {
        const n = this.resolvedProperty;
        for(let i = 0, r = n.length; i !== r; ++i)n[i] = t1[e++];
        this.targetObject.matrixWorldNeedsUpdate = !0;
    }
    _setValue_arrayElement(t1, e) {
        this.resolvedProperty[this.propertyIndex] = t1[e];
    }
    _setValue_arrayElement_setNeedsUpdate(t1, e) {
        this.resolvedProperty[this.propertyIndex] = t1[e], this.targetObject.needsUpdate = !0;
    }
    _setValue_arrayElement_setMatrixWorldNeedsUpdate(t1, e) {
        this.resolvedProperty[this.propertyIndex] = t1[e], this.targetObject.matrixWorldNeedsUpdate = !0;
    }
    _setValue_fromArray(t1, e) {
        this.resolvedProperty.fromArray(t1, e);
    }
    _setValue_fromArray_setNeedsUpdate(t1, e) {
        this.resolvedProperty.fromArray(t1, e), this.targetObject.needsUpdate = !0;
    }
    _setValue_fromArray_setMatrixWorldNeedsUpdate(t1, e) {
        this.resolvedProperty.fromArray(t1, e), this.targetObject.matrixWorldNeedsUpdate = !0;
    }
    _getValue_unbound(t1, e) {
        this.bind(), this.getValue(t1, e);
    }
    _setValue_unbound(t1, e) {
        this.bind(), this.setValue(t1, e);
    }
    bind() {
        let t1 = this.node;
        const e = this.parsedPath, n = e.objectName, i = e.propertyName;
        let r = e.propertyIndex;
        if (t1 || (t1 = $fd4eb456bcbd06f8$var$qo.findNode(this.rootNode, e.nodeName) || this.rootNode, this.node = t1), this.getValue = this._getValue_unavailable, this.setValue = this._setValue_unavailable, !t1) return void console.error("THREE.PropertyBinding: Trying to update node for track: " + this.path + " but it wasn't found.");
        if (n) {
            let i = e.objectIndex;
            switch(n){
                case "materials":
                    if (!t1.material) return void console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
                    if (!t1.material.materials) return void console.error("THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.", this);
                    t1 = t1.material.materials;
                    break;
                case "bones":
                    if (!t1.skeleton) return void console.error("THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.", this);
                    t1 = t1.skeleton.bones;
                    for(let e = 0; e < t1.length; e++)if (t1[e].name === i) {
                        i = e;
                        break;
                    }
                    break;
                default:
                    if (void 0 === t1[n]) return void console.error("THREE.PropertyBinding: Can not bind to objectName of node undefined.", this);
                    t1 = t1[n];
            }
            if (void 0 !== i) {
                if (void 0 === t1[i]) return void console.error("THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.", this, t1);
                t1 = t1[i];
            }
        }
        const s = t1[i];
        if (void 0 === s) {
            const n = e.nodeName;
            return void console.error("THREE.PropertyBinding: Trying to update property for track: " + n + "." + i + " but it wasn't found.", t1);
        }
        let a = this.Versioning.None;
        this.targetObject = t1, void 0 !== t1.needsUpdate ? a = this.Versioning.NeedsUpdate : void 0 !== t1.matrixWorldNeedsUpdate && (a = this.Versioning.MatrixWorldNeedsUpdate);
        let o = this.BindingType.Direct;
        if (void 0 !== r) {
            if ("morphTargetInfluences" === i) {
                if (!t1.geometry) return void console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.", this);
                if (!t1.geometry.isBufferGeometry) return void console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences on THREE.Geometry. Use THREE.BufferGeometry instead.", this);
                if (!t1.geometry.morphAttributes) return void console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.", this);
                void 0 !== t1.morphTargetDictionary[r] && (r = t1.morphTargetDictionary[r]);
            }
            o = this.BindingType.ArrayElement, this.resolvedProperty = s, this.propertyIndex = r;
        } else void 0 !== s.fromArray && void 0 !== s.toArray ? (o = this.BindingType.HasFromToArray, this.resolvedProperty = s) : Array.isArray(s) ? (o = this.BindingType.EntireArray, this.resolvedProperty = s) : this.propertyName = i;
        this.getValue = this.GetterByBindingType[o], this.setValue = this.SetterByBindingTypeAndVersioning[o][a];
    }
    unbind() {
        this.node = null, this.getValue = this._getValue_unbound, this.setValue = this._setValue_unbound;
    }
}
$fd4eb456bcbd06f8$var$qo.Composite = class {
    constructor(t1, e, n){
        const i = n || $fd4eb456bcbd06f8$var$qo.parseTrackName(e);
        this._targetGroup = t1, this._bindings = t1.subscribe_(e, i);
    }
    getValue(t1, e) {
        this.bind();
        const n = this._targetGroup.nCachedObjects_, i = this._bindings[n];
        void 0 !== i && i.getValue(t1, e);
    }
    setValue(t1, e) {
        const n = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, r = n.length; i !== r; ++i)n[i].setValue(t1, e);
    }
    bind() {
        const t1 = this._bindings;
        for(let e = this._targetGroup.nCachedObjects_, n = t1.length; e !== n; ++e)t1[e].bind();
    }
    unbind() {
        const t1 = this._bindings;
        for(let e = this._targetGroup.nCachedObjects_, n = t1.length; e !== n; ++e)t1[e].unbind();
    }
}, $fd4eb456bcbd06f8$var$qo.prototype.BindingType = {
    Direct: 0,
    EntireArray: 1,
    ArrayElement: 2,
    HasFromToArray: 3
}, $fd4eb456bcbd06f8$var$qo.prototype.Versioning = {
    None: 0,
    NeedsUpdate: 1,
    MatrixWorldNeedsUpdate: 2
}, $fd4eb456bcbd06f8$var$qo.prototype.GetterByBindingType = [
    $fd4eb456bcbd06f8$var$qo.prototype._getValue_direct,
    $fd4eb456bcbd06f8$var$qo.prototype._getValue_array,
    $fd4eb456bcbd06f8$var$qo.prototype._getValue_arrayElement,
    $fd4eb456bcbd06f8$var$qo.prototype._getValue_toArray
], $fd4eb456bcbd06f8$var$qo.prototype.SetterByBindingTypeAndVersioning = [
    [
        $fd4eb456bcbd06f8$var$qo.prototype._setValue_direct,
        $fd4eb456bcbd06f8$var$qo.prototype._setValue_direct_setNeedsUpdate,
        $fd4eb456bcbd06f8$var$qo.prototype._setValue_direct_setMatrixWorldNeedsUpdate
    ],
    [
        $fd4eb456bcbd06f8$var$qo.prototype._setValue_array,
        $fd4eb456bcbd06f8$var$qo.prototype._setValue_array_setNeedsUpdate,
        $fd4eb456bcbd06f8$var$qo.prototype._setValue_array_setMatrixWorldNeedsUpdate
    ],
    [
        $fd4eb456bcbd06f8$var$qo.prototype._setValue_arrayElement,
        $fd4eb456bcbd06f8$var$qo.prototype._setValue_arrayElement_setNeedsUpdate,
        $fd4eb456bcbd06f8$var$qo.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
    ],
    [
        $fd4eb456bcbd06f8$var$qo.prototype._setValue_fromArray,
        $fd4eb456bcbd06f8$var$qo.prototype._setValue_fromArray_setNeedsUpdate,
        $fd4eb456bcbd06f8$var$qo.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
    ]
];
class $fd4eb456bcbd06f8$var$Xo {
    constructor(t1, e, n = null, i = e.blendMode){
        this._mixer = t1, this._clip = e, this._localRoot = n, this.blendMode = i;
        const r = e.tracks, s = r.length, a = new Array(s), o = {
            endingStart: 2400,
            endingEnd: 2400
        };
        for(let t1 = 0; t1 !== s; ++t1){
            const e = r[t1].createInterpolant(null);
            a[t1] = e, e.settings = o;
        }
        this._interpolantSettings = o, this._interpolants = a, this._propertyBindings = new Array(s), this._cacheIndex = null, this._byClipCacheIndex = null, this._timeScaleInterpolant = null, this._weightInterpolant = null, this.loop = 2201, this._loopCount = -1, this._startTime = null, this.time = 0, this.timeScale = 1, this._effectiveTimeScale = 1, this.weight = 1, this._effectiveWeight = 1, this.repetitions = 1 / 0, this.paused = !1, this.enabled = !0, this.clampWhenFinished = !1, this.zeroSlopeAtStart = !0, this.zeroSlopeAtEnd = !0;
    }
    play() {
        return this._mixer._activateAction(this), this;
    }
    stop() {
        return this._mixer._deactivateAction(this), this.reset();
    }
    reset() {
        return this.paused = !1, this.enabled = !0, this.time = 0, this._loopCount = -1, this._startTime = null, this.stopFading().stopWarping();
    }
    isRunning() {
        return this.enabled && !this.paused && 0 !== this.timeScale && null === this._startTime && this._mixer._isActiveAction(this);
    }
    isScheduled() {
        return this._mixer._isActiveAction(this);
    }
    startAt(t1) {
        return this._startTime = t1, this;
    }
    setLoop(t1, e) {
        return this.loop = t1, this.repetitions = e, this;
    }
    setEffectiveWeight(t1) {
        return this.weight = t1, this._effectiveWeight = this.enabled ? t1 : 0, this.stopFading();
    }
    getEffectiveWeight() {
        return this._effectiveWeight;
    }
    fadeIn(t1) {
        return this._scheduleFading(t1, 0, 1);
    }
    fadeOut(t1) {
        return this._scheduleFading(t1, 1, 0);
    }
    crossFadeFrom(t1, e, n) {
        if (t1.fadeOut(e), this.fadeIn(e), n) {
            const n = this._clip.duration, i = t1._clip.duration, r = i / n, s = n / i;
            t1.warp(1, r, e), this.warp(s, 1, e);
        }
        return this;
    }
    crossFadeTo(t1, e, n) {
        return t1.crossFadeFrom(this, e, n);
    }
    stopFading() {
        const t1 = this._weightInterpolant;
        return null !== t1 && (this._weightInterpolant = null, this._mixer._takeBackControlInterpolant(t1)), this;
    }
    setEffectiveTimeScale(t1) {
        return this.timeScale = t1, this._effectiveTimeScale = this.paused ? 0 : t1, this.stopWarping();
    }
    getEffectiveTimeScale() {
        return this._effectiveTimeScale;
    }
    setDuration(t1) {
        return this.timeScale = this._clip.duration / t1, this.stopWarping();
    }
    syncWith(t1) {
        return this.time = t1.time, this.timeScale = t1.timeScale, this.stopWarping();
    }
    halt(t1) {
        return this.warp(this._effectiveTimeScale, 0, t1);
    }
    warp(t1, e, n) {
        const i = this._mixer, r = i.time, s = this.timeScale;
        let a = this._timeScaleInterpolant;
        null === a && (a = i._lendControlInterpolant(), this._timeScaleInterpolant = a);
        const o = a.parameterPositions, l = a.sampleValues;
        return o[0] = r, o[1] = r + n, l[0] = t1 / s, l[1] = e / s, this;
    }
    stopWarping() {
        const t1 = this._timeScaleInterpolant;
        return null !== t1 && (this._timeScaleInterpolant = null, this._mixer._takeBackControlInterpolant(t1)), this;
    }
    getMixer() {
        return this._mixer;
    }
    getClip() {
        return this._clip;
    }
    getRoot() {
        return this._localRoot || this._mixer._root;
    }
    _update(t1, e, n, i) {
        if (!this.enabled) return void this._updateWeight(t1);
        const r = this._startTime;
        if (null !== r) {
            const i = (t1 - r) * n;
            if (i < 0 || 0 === n) return;
            this._startTime = null, e = n * i;
        }
        e *= this._updateTimeScale(t1);
        const s = this._updateTime(e), a = this._updateWeight(t1);
        if (a > 0) {
            const t1 = this._interpolants, e = this._propertyBindings;
            if (2501 === this.blendMode) for(let n = 0, i = t1.length; n !== i; ++n)t1[n].evaluate(s), e[n].accumulateAdditive(a);
            else for(let n = 0, r = t1.length; n !== r; ++n)t1[n].evaluate(s), e[n].accumulate(i, a);
        }
    }
    _updateWeight(t1) {
        let e = 0;
        if (this.enabled) {
            e = this.weight;
            const n = this._weightInterpolant;
            if (null !== n) {
                const i = n.evaluate(t1)[0];
                e *= i, t1 > n.parameterPositions[1] && (this.stopFading(), 0 === i && (this.enabled = !1));
            }
        }
        return this._effectiveWeight = e, e;
    }
    _updateTimeScale(t1) {
        let e = 0;
        if (!this.paused) {
            e = this.timeScale;
            const n = this._timeScaleInterpolant;
            if (null !== n) e *= n.evaluate(t1)[0], t1 > n.parameterPositions[1] && (this.stopWarping(), 0 === e ? this.paused = !0 : this.timeScale = e);
        }
        return this._effectiveTimeScale = e, e;
    }
    _updateTime(t1) {
        const e = this._clip.duration, n = this.loop;
        let i = this.time + t1, r = this._loopCount;
        const s = 2202 === n;
        if (0 === t1) return -1 === r ? i : s && 1 == (1 & r) ? e - i : i;
        if (2200 === n) {
            -1 === r && (this._loopCount = 0, this._setEndings(!0, !0, !1));
            t: {
                if (i >= e) i = e;
                else {
                    if (!(i < 0)) {
                        this.time = i;
                        break t;
                    }
                    i = 0;
                }
                this.clampWhenFinished ? this.paused = !0 : this.enabled = !1, this.time = i, this._mixer.dispatchEvent({
                    type: "finished",
                    action: this,
                    direction: t1 < 0 ? -1 : 1
                });
            }
        } else {
            if (-1 === r && (t1 >= 0 ? (r = 0, this._setEndings(!0, 0 === this.repetitions, s)) : this._setEndings(0 === this.repetitions, !0, s)), i >= e || i < 0) {
                const n = Math.floor(i / e);
                i -= e * n, r += Math.abs(n);
                const a = this.repetitions - r;
                if (a <= 0) this.clampWhenFinished ? this.paused = !0 : this.enabled = !1, i = t1 > 0 ? e : 0, this.time = i, this._mixer.dispatchEvent({
                    type: "finished",
                    action: this,
                    direction: t1 > 0 ? 1 : -1
                });
                else {
                    if (1 === a) {
                        const e = t1 < 0;
                        this._setEndings(e, !e, s);
                    } else this._setEndings(!1, !1, s);
                    this._loopCount = r, this.time = i, this._mixer.dispatchEvent({
                        type: "loop",
                        action: this,
                        loopDelta: n
                    });
                }
            } else this.time = i;
            if (s && 1 == (1 & r)) return e - i;
        }
        return i;
    }
    _setEndings(t1, e, n) {
        const i = this._interpolantSettings;
        n ? (i.endingStart = 2401, i.endingEnd = 2401) : (i.endingStart = t1 ? this.zeroSlopeAtStart ? 2401 : 2400 : 2402, i.endingEnd = e ? this.zeroSlopeAtEnd ? 2401 : 2400 : 2402);
    }
    _scheduleFading(t1, e, n) {
        const i = this._mixer, r = i.time;
        let s = this._weightInterpolant;
        null === s && (s = i._lendControlInterpolant(), this._weightInterpolant = s);
        const a = s.parameterPositions, o = s.sampleValues;
        return a[0] = r, o[0] = e, a[1] = r + t1, o[1] = n, this;
    }
}
class $fd4eb456bcbd06f8$var$$o extends $fd4eb456bcbd06f8$var$i {
    constructor(t1){
        super(), this._root = t1, this._initMemoryManager(), this._accuIndex = 0, this.time = 0, this.timeScale = 1;
    }
    _bindAction(t1, e) {
        const n = t1._localRoot || this._root, i = t1._clip.tracks, r = i.length, s = t1._propertyBindings, a = t1._interpolants, o = n.uuid, l = this._bindingsByRootAndName;
        let h = l[o];
        void 0 === h && (h = {}, l[o] = h);
        for(let t1 = 0; t1 !== r; ++t1){
            const r = i[t1], l = r.name;
            let c = h[l];
            if (void 0 !== c) ++c.referenceCount, s[t1] = c;
            else {
                if (c = s[t1], void 0 !== c) {
                    null === c._cacheIndex && (++c.referenceCount, this._addInactiveBinding(c, o, l));
                    continue;
                }
                const i = e && e._propertyBindings[t1].binding.parsedPath;
                c = new $fd4eb456bcbd06f8$var$Uo($fd4eb456bcbd06f8$var$qo.create(n, l, i), r.ValueTypeName, r.getValueSize()), ++c.referenceCount, this._addInactiveBinding(c, o, l), s[t1] = c;
            }
            a[t1].resultBuffer = c.buffer;
        }
    }
    _activateAction(t1) {
        if (!this._isActiveAction(t1)) {
            if (null === t1._cacheIndex) {
                const e = (t1._localRoot || this._root).uuid, n = t1._clip.uuid, i = this._actionsByClip[n];
                this._bindAction(t1, i && i.knownActions[0]), this._addInactiveAction(t1, n, e);
            }
            const e = t1._propertyBindings;
            for(let t1 = 0, n = e.length; t1 !== n; ++t1){
                const n = e[t1];
                0 == n.useCount++ && (this._lendBinding(n), n.saveOriginalState());
            }
            this._lendAction(t1);
        }
    }
    _deactivateAction(t1) {
        if (this._isActiveAction(t1)) {
            const e = t1._propertyBindings;
            for(let t1 = 0, n = e.length; t1 !== n; ++t1){
                const n = e[t1];
                0 == --n.useCount && (n.restoreOriginalState(), this._takeBackBinding(n));
            }
            this._takeBackAction(t1);
        }
    }
    _initMemoryManager() {
        this._actions = [], this._nActiveActions = 0, this._actionsByClip = {}, this._bindings = [], this._nActiveBindings = 0, this._bindingsByRootAndName = {}, this._controlInterpolants = [], this._nActiveControlInterpolants = 0;
        const t1 = this;
        this.stats = {
            actions: {
                get total () {
                    return t1._actions.length;
                },
                get inUse () {
                    return t1._nActiveActions;
                }
            },
            bindings: {
                get total () {
                    return t1._bindings.length;
                },
                get inUse () {
                    return t1._nActiveBindings;
                }
            },
            controlInterpolants: {
                get total () {
                    return t1._controlInterpolants.length;
                },
                get inUse () {
                    return t1._nActiveControlInterpolants;
                }
            }
        };
    }
    _isActiveAction(t1) {
        const e = t1._cacheIndex;
        return null !== e && e < this._nActiveActions;
    }
    _addInactiveAction(t1, e, n) {
        const i = this._actions, r = this._actionsByClip;
        let s = r[e];
        if (void 0 === s) s = {
            knownActions: [
                t1
            ],
            actionByRoot: {}
        }, t1._byClipCacheIndex = 0, r[e] = s;
        else {
            const e = s.knownActions;
            t1._byClipCacheIndex = e.length, e.push(t1);
        }
        t1._cacheIndex = i.length, i.push(t1), s.actionByRoot[n] = t1;
    }
    _removeInactiveAction(t1) {
        const e = this._actions, n = e[e.length - 1], i = t1._cacheIndex;
        n._cacheIndex = i, e[i] = n, e.pop(), t1._cacheIndex = null;
        const r = t1._clip.uuid, s = this._actionsByClip, a = s[r], o = a.knownActions, l = o[o.length - 1], h = t1._byClipCacheIndex;
        l._byClipCacheIndex = h, o[h] = l, o.pop(), t1._byClipCacheIndex = null;
        delete a.actionByRoot[(t1._localRoot || this._root).uuid], 0 === o.length && delete s[r], this._removeInactiveBindingsForAction(t1);
    }
    _removeInactiveBindingsForAction(t1) {
        const e = t1._propertyBindings;
        for(let t1 = 0, n = e.length; t1 !== n; ++t1){
            const n = e[t1];
            0 == --n.referenceCount && this._removeInactiveBinding(n);
        }
    }
    _lendAction(t1) {
        const e = this._actions, n = t1._cacheIndex, i = this._nActiveActions++, r = e[i];
        t1._cacheIndex = i, e[i] = t1, r._cacheIndex = n, e[n] = r;
    }
    _takeBackAction(t1) {
        const e = this._actions, n = t1._cacheIndex, i = --this._nActiveActions, r = e[i];
        t1._cacheIndex = i, e[i] = t1, r._cacheIndex = n, e[n] = r;
    }
    _addInactiveBinding(t1, e, n) {
        const i = this._bindingsByRootAndName, r = this._bindings;
        let s = i[e];
        void 0 === s && (s = {}, i[e] = s), s[n] = t1, t1._cacheIndex = r.length, r.push(t1);
    }
    _removeInactiveBinding(t1) {
        const e = this._bindings, n = t1.binding, i = n.rootNode.uuid, r = n.path, s = this._bindingsByRootAndName, a = s[i], o = e[e.length - 1], l = t1._cacheIndex;
        o._cacheIndex = l, e[l] = o, e.pop(), delete a[r], 0 === Object.keys(a).length && delete s[i];
    }
    _lendBinding(t1) {
        const e = this._bindings, n = t1._cacheIndex, i = this._nActiveBindings++, r = e[i];
        t1._cacheIndex = i, e[i] = t1, r._cacheIndex = n, e[n] = r;
    }
    _takeBackBinding(t1) {
        const e = this._bindings, n = t1._cacheIndex, i = --this._nActiveBindings, r = e[i];
        t1._cacheIndex = i, e[i] = t1, r._cacheIndex = n, e[n] = r;
    }
    _lendControlInterpolant() {
        const t1 = this._controlInterpolants, e = this._nActiveControlInterpolants++;
        let n = t1[e];
        return void 0 === n && (n = new $fd4eb456bcbd06f8$var$$a(new Float32Array(2), new Float32Array(2), 1, this._controlInterpolantsResultBuffer), n.__cacheIndex = e, t1[e] = n), n;
    }
    _takeBackControlInterpolant(t1) {
        const e = this._controlInterpolants, n = t1.__cacheIndex, i = --this._nActiveControlInterpolants, r = e[i];
        t1.__cacheIndex = i, e[i] = t1, r.__cacheIndex = n, e[n] = r;
    }
    clipAction(t1, e, n) {
        const i = e || this._root, r = i.uuid;
        let s = "string" == typeof t1 ? $fd4eb456bcbd06f8$var$ro.findByName(i, t1) : t1;
        const a = null !== s ? s.uuid : t1, o = this._actionsByClip[a];
        let l = null;
        if (void 0 === n && (n = null !== s ? s.blendMode : 2500), void 0 !== o) {
            const t1 = o.actionByRoot[r];
            if (void 0 !== t1 && t1.blendMode === n) return t1;
            l = o.knownActions[0], null === s && (s = l._clip);
        }
        if (null === s) return null;
        const h = new $fd4eb456bcbd06f8$var$Xo(this, s, e, n);
        return this._bindAction(h, l), this._addInactiveAction(h, a, r), h;
    }
    existingAction(t1, e) {
        const n = e || this._root, i = n.uuid, r = "string" == typeof t1 ? $fd4eb456bcbd06f8$var$ro.findByName(n, t1) : t1, s = r ? r.uuid : t1, a = this._actionsByClip[s];
        return void 0 !== a && a.actionByRoot[i] || null;
    }
    stopAllAction() {
        const t1 = this._actions;
        for(let e = this._nActiveActions - 1; e >= 0; --e)t1[e].stop();
        return this;
    }
    update(t1) {
        t1 *= this.timeScale;
        const e = this._actions, n = this._nActiveActions, i = this.time += t1, r = Math.sign(t1), s = this._accuIndex ^= 1;
        for(let a = 0; a !== n; ++a)e[a]._update(i, t1, r, s);
        const a = this._bindings, o = this._nActiveBindings;
        for(let t1 = 0; t1 !== o; ++t1)a[t1].apply(s);
        return this;
    }
    setTime(t1) {
        this.time = 0;
        for(let t1 = 0; t1 < this._actions.length; t1++)this._actions[t1].time = 0;
        return this.update(t1);
    }
    getRoot() {
        return this._root;
    }
    uncacheClip(t1) {
        const e = this._actions, n = t1.uuid, i = this._actionsByClip, r = i[n];
        if (void 0 !== r) {
            const t1 = r.knownActions;
            for(let n = 0, i = t1.length; n !== i; ++n){
                const i = t1[n];
                this._deactivateAction(i);
                const r = i._cacheIndex, s = e[e.length - 1];
                i._cacheIndex = null, i._byClipCacheIndex = null, s._cacheIndex = r, e[r] = s, e.pop(), this._removeInactiveBindingsForAction(i);
            }
            delete i[n];
        }
    }
    uncacheRoot(t1) {
        const e = t1.uuid, n = this._actionsByClip;
        for(const t1 in n){
            const i = n[t1].actionByRoot[e];
            void 0 !== i && (this._deactivateAction(i), this._removeInactiveAction(i));
        }
        const i = this._bindingsByRootAndName[e];
        if (void 0 !== i) for(const t1 in i){
            const e = i[t1];
            e.restoreOriginalState(), this._removeInactiveBinding(e);
        }
    }
    uncacheAction(t1, e) {
        const n = this.existingAction(t1, e);
        null !== n && (this._deactivateAction(n), this._removeInactiveAction(n));
    }
}
$fd4eb456bcbd06f8$var$$o.prototype._controlInterpolantsResultBuffer = new Float32Array(1);
(class extends $fd4eb456bcbd06f8$var$Fr {
    constructor(t1, e, n = 1){
        super(t1, e), this.meshPerAttribute = n;
    }
    copy(t1) {
        return super.copy(t1), this.meshPerAttribute = t1.meshPerAttribute, this;
    }
    clone(t1) {
        const e = super.clone(t1);
        return e.meshPerAttribute = this.meshPerAttribute, e;
    }
    toJSON(t1) {
        const e = super.toJSON(t1);
        return e.isInstancedInterleavedBuffer = !0, e.meshPerAttribute = this.meshPerAttribute, e;
    }
}).prototype.isInstancedInterleavedBuffer = !0;
function $fd4eb456bcbd06f8$var$Yo(t1, e) {
    return t1.distance - e.distance;
}
function $fd4eb456bcbd06f8$var$Jo(t1, e, n, i) {
    if (t1.layers.test(e.layers) && t1.raycast(e, n), !0 === i) {
        const i = t1.children;
        for(let t1 = 0, r = i.length; t1 < r; t1++)$fd4eb456bcbd06f8$var$Jo(i[t1], e, n, !0);
    }
}
class $fd4eb456bcbd06f8$var$Ko {
    constructor(t1 = 1, e = 0, n = 0){
        return this.radius = t1, this.phi = e, this.theta = n, this;
    }
    set(t1, e, n) {
        return this.radius = t1, this.phi = e, this.theta = n, this;
    }
    copy(t1) {
        return this.radius = t1.radius, this.phi = t1.phi, this.theta = t1.theta, this;
    }
    makeSafe() {
        const t1 = 1e-6;
        return this.phi = Math.max(t1, Math.min(Math.PI - t1, this.phi)), this;
    }
    setFromVector3(t1) {
        return this.setFromCartesianCoords(t1.x, t1.y, t1.z);
    }
    setFromCartesianCoords(t1, e, n) {
        return this.radius = Math.sqrt(t1 * t1 + e * e + n * n), 0 === this.radius ? (this.theta = 0, this.phi = 0) : (this.theta = Math.atan2(t1, n), this.phi = Math.acos($fd4eb456bcbd06f8$var$h(e / this.radius, -1, 1))), this;
    }
    clone() {
        return (new this.constructor).copy(this);
    }
}
const $fd4eb456bcbd06f8$var$Zo = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$Qo = new $fd4eb456bcbd06f8$var$xt, $fd4eb456bcbd06f8$var$tl = new $fd4eb456bcbd06f8$var$xt;
function $fd4eb456bcbd06f8$var$el(t1) {
    const e = [];
    !0 === t1.isBone && e.push(t1);
    for(let n = 0; n < t1.children.length; n++)e.push.apply(e, $fd4eb456bcbd06f8$var$el(t1.children[n]));
    return e;
}
class $fd4eb456bcbd06f8$var$nl {
    static toHalfFloat(t1) {
        Math.abs(t1) > 65504 && console.warn("THREE.DataUtils.toHalfFloat(): Value out of range."), t1 = $fd4eb456bcbd06f8$var$h(t1, -65504, 65504), $fd4eb456bcbd06f8$var$rl[0] = t1;
        const e = $fd4eb456bcbd06f8$var$sl[0], n = e >> 23 & 511;
        return $fd4eb456bcbd06f8$var$al[n] + ((8388607 & e) >> $fd4eb456bcbd06f8$var$ol[n]);
    }
    static fromHalfFloat(t1) {
        const e = t1 >> 10;
        return $fd4eb456bcbd06f8$var$sl[0] = $fd4eb456bcbd06f8$var$ll[$fd4eb456bcbd06f8$var$cl[e] + (1023 & t1)] + $fd4eb456bcbd06f8$var$hl[e], $fd4eb456bcbd06f8$var$rl[0];
    }
}
const $fd4eb456bcbd06f8$var$il = new ArrayBuffer(4), $fd4eb456bcbd06f8$var$rl = new Float32Array($fd4eb456bcbd06f8$var$il), $fd4eb456bcbd06f8$var$sl = new Uint32Array($fd4eb456bcbd06f8$var$il), $fd4eb456bcbd06f8$var$al = new Uint32Array(512), $fd4eb456bcbd06f8$var$ol = new Uint32Array(512);
for(let t1 = 0; t1 < 256; ++t1){
    const e = t1 - 127;
    e < -27 ? ($fd4eb456bcbd06f8$var$al[t1] = 0, $fd4eb456bcbd06f8$var$al[256 | t1] = 32768, $fd4eb456bcbd06f8$var$ol[t1] = 24, $fd4eb456bcbd06f8$var$ol[256 | t1] = 24) : e < -14 ? ($fd4eb456bcbd06f8$var$al[t1] = 1024 >> -e - 14, $fd4eb456bcbd06f8$var$al[256 | t1] = 1024 >> -e - 14 | 32768, $fd4eb456bcbd06f8$var$ol[t1] = -e - 1, $fd4eb456bcbd06f8$var$ol[256 | t1] = -e - 1) : e <= 15 ? ($fd4eb456bcbd06f8$var$al[t1] = e + 15 << 10, $fd4eb456bcbd06f8$var$al[256 | t1] = e + 15 << 10 | 32768, $fd4eb456bcbd06f8$var$ol[t1] = 13, $fd4eb456bcbd06f8$var$ol[256 | t1] = 13) : e < 128 ? ($fd4eb456bcbd06f8$var$al[t1] = 31744, $fd4eb456bcbd06f8$var$al[256 | t1] = 64512, $fd4eb456bcbd06f8$var$ol[t1] = 24, $fd4eb456bcbd06f8$var$ol[256 | t1] = 24) : ($fd4eb456bcbd06f8$var$al[t1] = 31744, $fd4eb456bcbd06f8$var$al[256 | t1] = 64512, $fd4eb456bcbd06f8$var$ol[t1] = 13, $fd4eb456bcbd06f8$var$ol[256 | t1] = 13);
}
const $fd4eb456bcbd06f8$var$ll = new Uint32Array(2048), $fd4eb456bcbd06f8$var$hl = new Uint32Array(64), $fd4eb456bcbd06f8$var$cl = new Uint32Array(64);
for(let t1 = 1; t1 < 1024; ++t1){
    let e = t1 << 13, n = 0;
    for(; 0 == (8388608 & e);)e <<= 1, n -= 8388608;
    e &= -8388609, n += 947912704, $fd4eb456bcbd06f8$var$ll[t1] = e | n;
}
for(let t1 = 1024; t1 < 2048; ++t1)$fd4eb456bcbd06f8$var$ll[t1] = 939524096 + (t1 - 1024 << 13);
for(let t1 = 1; t1 < 31; ++t1)$fd4eb456bcbd06f8$var$hl[t1] = t1 << 23;
$fd4eb456bcbd06f8$var$hl[31] = 1199570944, $fd4eb456bcbd06f8$var$hl[32] = 2147483648;
for(let t1 = 33; t1 < 63; ++t1)$fd4eb456bcbd06f8$var$hl[t1] = 2147483648 + (t1 - 32 << 23);
$fd4eb456bcbd06f8$var$hl[63] = 3347054592;
for(let t1 = 1; t1 < 64; ++t1)32 !== t1 && ($fd4eb456bcbd06f8$var$cl[t1] = 1024);
$fd4eb456bcbd06f8$var$Ns.create = function(t1, e) {
    return console.log("THREE.Curve.create() has been deprecated"), t1.prototype = Object.create($fd4eb456bcbd06f8$var$Ns.prototype), t1.prototype.constructor = t1, t1.prototype.getPoint = e, t1;
}, $fd4eb456bcbd06f8$var$ea.prototype.fromPoints = function(t1) {
    return console.warn("THREE.Path: .fromPoints() has been renamed to .setFromPoints()."), this.setFromPoints(t1);
}, (class extends $fd4eb456bcbd06f8$var$Ts {
    constructor(t1 = 10, e = 10, n = 4473924, i = 8947848){
        n = new $fd4eb456bcbd06f8$var$L(n), i = new $fd4eb456bcbd06f8$var$L(i);
        const r = e / 2, s = t1 / e, a = t1 / 2, o = [], l = [];
        for(let t1 = 0, h = 0, c = -a; t1 <= e; t1++, c += s){
            o.push(-a, 0, c, a, 0, c), o.push(c, 0, -a, c, 0, a);
            const e = t1 === r ? n : i;
            e.toArray(l, h), h += 3, e.toArray(l, h), h += 3, e.toArray(l, h), h += 3, e.toArray(l, h), h += 3;
        }
        const h = new $fd4eb456bcbd06f8$var$ye;
        h.setAttribute("position", new $fd4eb456bcbd06f8$var$ce(o, 3)), h.setAttribute("color", new $fd4eb456bcbd06f8$var$ce(l, 3));
        super(h, new $fd4eb456bcbd06f8$var$gs({
            vertexColors: !0,
            toneMapped: !1
        })), this.type = "GridHelper";
    }
}).prototype.setColors = function() {
    console.error("THREE.GridHelper: setColors() has been deprecated, pass them in the constructor instead.");
}, (class extends $fd4eb456bcbd06f8$var$Ts {
    constructor(t1){
        const e = $fd4eb456bcbd06f8$var$el(t1), n = new $fd4eb456bcbd06f8$var$ye, i = [], r = [], s = new $fd4eb456bcbd06f8$var$L(0, 0, 1), a = new $fd4eb456bcbd06f8$var$L(0, 1, 0);
        for(let t1 = 0; t1 < e.length; t1++){
            const n = e[t1];
            n.parent && n.parent.isBone && (i.push(0, 0, 0), i.push(0, 0, 0), r.push(s.r, s.g, s.b), r.push(a.r, a.g, a.b));
        }
        n.setAttribute("position", new $fd4eb456bcbd06f8$var$ce(i, 3)), n.setAttribute("color", new $fd4eb456bcbd06f8$var$ce(r, 3));
        super(n, new $fd4eb456bcbd06f8$var$gs({
            vertexColors: !0,
            depthTest: !1,
            depthWrite: !1,
            toneMapped: !1,
            transparent: !0
        })), this.type = "SkeletonHelper", this.isSkeletonHelper = !0, this.root = t1, this.bones = e, this.matrix = t1.matrixWorld, this.matrixAutoUpdate = !1;
    }
    updateMatrixWorld(t1) {
        const e = this.bones, n = this.geometry, i = n.getAttribute("position");
        $fd4eb456bcbd06f8$var$tl.copy(this.root.matrixWorld).invert();
        for(let t1 = 0, n = 0; t1 < e.length; t1++){
            const r = e[t1];
            r.parent && r.parent.isBone && ($fd4eb456bcbd06f8$var$Qo.multiplyMatrices($fd4eb456bcbd06f8$var$tl, r.matrixWorld), $fd4eb456bcbd06f8$var$Zo.setFromMatrixPosition($fd4eb456bcbd06f8$var$Qo), i.setXYZ(n, $fd4eb456bcbd06f8$var$Zo.x, $fd4eb456bcbd06f8$var$Zo.y, $fd4eb456bcbd06f8$var$Zo.z), $fd4eb456bcbd06f8$var$Qo.multiplyMatrices($fd4eb456bcbd06f8$var$tl, r.parent.matrixWorld), $fd4eb456bcbd06f8$var$Zo.setFromMatrixPosition($fd4eb456bcbd06f8$var$Qo), i.setXYZ(n + 1, $fd4eb456bcbd06f8$var$Zo.x, $fd4eb456bcbd06f8$var$Zo.y, $fd4eb456bcbd06f8$var$Zo.z), n += 2);
        }
        n.getAttribute("position").needsUpdate = !0, super.updateMatrixWorld(t1);
    }
}).prototype.update = function() {
    console.error("THREE.SkeletonHelper: update() no longer needs to be called.");
}, $fd4eb456bcbd06f8$var$lo.prototype.extractUrlBase = function(t1) {
    return console.warn("THREE.Loader: .extractUrlBase() has been deprecated. Use THREE.LoaderUtils.extractUrlBase() instead."), $fd4eb456bcbd06f8$var$Do.extractUrlBase(t1);
}, $fd4eb456bcbd06f8$var$lo.Handlers = {
    add: function() {
        console.error("THREE.Loader: Handlers.add() has been removed. Use LoadingManager.addHandler() instead.");
    },
    get: function() {
        console.error("THREE.Loader: Handlers.get() has been removed. Use LoadingManager.getHandler() instead.");
    }
}, $fd4eb456bcbd06f8$var$j.prototype.center = function(t1) {
    return console.warn("THREE.Box3: .center() has been renamed to .getCenter()."), this.getCenter(t1);
}, $fd4eb456bcbd06f8$var$j.prototype.empty = function() {
    return console.warn("THREE.Box3: .empty() has been renamed to .isEmpty()."), this.isEmpty();
}, $fd4eb456bcbd06f8$var$j.prototype.isIntersectionBox = function(t1) {
    return console.warn("THREE.Box3: .isIntersectionBox() has been renamed to .intersectsBox()."), this.intersectsBox(t1);
}, $fd4eb456bcbd06f8$var$j.prototype.isIntersectionSphere = function(t1) {
    return console.warn("THREE.Box3: .isIntersectionSphere() has been renamed to .intersectsSphere()."), this.intersectsSphere(t1);
}, $fd4eb456bcbd06f8$var$j.prototype.size = function(t1) {
    return console.warn("THREE.Box3: .size() has been renamed to .getSize()."), this.getSize(t1);
}, $fd4eb456bcbd06f8$var$Ct.prototype.toVector3 = function() {
    console.error("THREE.Euler: .toVector3() has been removed. Use Vector3.setFromEuler() instead");
}, $fd4eb456bcbd06f8$var$ct.prototype.empty = function() {
    return console.warn("THREE.Sphere: .empty() has been renamed to .isEmpty()."), this.isEmpty();
}, $fd4eb456bcbd06f8$var$tn.prototype.setFromMatrix = function(t1) {
    return console.warn("THREE.Frustum: .setFromMatrix() has been renamed to .setFromProjectionMatrix()."), this.setFromProjectionMatrix(t1);
}, $fd4eb456bcbd06f8$var$v.prototype.flattenToArrayOffset = function(t1, e) {
    return console.warn("THREE.Matrix3: .flattenToArrayOffset() has been deprecated. Use .toArray() instead."), this.toArray(t1, e);
}, $fd4eb456bcbd06f8$var$v.prototype.multiplyVector3 = function(t1) {
    return console.warn("THREE.Matrix3: .multiplyVector3() has been removed. Use vector.applyMatrix3( matrix ) instead."), t1.applyMatrix3(this);
}, $fd4eb456bcbd06f8$var$v.prototype.multiplyVector3Array = function() {
    console.error("THREE.Matrix3: .multiplyVector3Array() has been removed.");
}, $fd4eb456bcbd06f8$var$v.prototype.applyToBufferAttribute = function(t1) {
    return console.warn("THREE.Matrix3: .applyToBufferAttribute() has been removed. Use attribute.applyMatrix3( matrix ) instead."), t1.applyMatrix3(this);
}, $fd4eb456bcbd06f8$var$v.prototype.applyToVector3Array = function() {
    console.error("THREE.Matrix3: .applyToVector3Array() has been removed.");
}, $fd4eb456bcbd06f8$var$v.prototype.getInverse = function(t1) {
    return console.warn("THREE.Matrix3: .getInverse() has been removed. Use matrixInv.copy( matrix ).invert(); instead."), this.copy(t1).invert();
}, $fd4eb456bcbd06f8$var$xt.prototype.extractPosition = function(t1) {
    return console.warn("THREE.Matrix4: .extractPosition() has been renamed to .copyPosition()."), this.copyPosition(t1);
}, $fd4eb456bcbd06f8$var$xt.prototype.flattenToArrayOffset = function(t1, e) {
    return console.warn("THREE.Matrix4: .flattenToArrayOffset() has been deprecated. Use .toArray() instead."), this.toArray(t1, e);
}, $fd4eb456bcbd06f8$var$xt.prototype.getPosition = function() {
    return console.warn("THREE.Matrix4: .getPosition() has been removed. Use Vector3.setFromMatrixPosition( matrix ) instead."), (new $fd4eb456bcbd06f8$var$V).setFromMatrixColumn(this, 3);
}, $fd4eb456bcbd06f8$var$xt.prototype.setRotationFromQuaternion = function(t1) {
    return console.warn("THREE.Matrix4: .setRotationFromQuaternion() has been renamed to .makeRotationFromQuaternion()."), this.makeRotationFromQuaternion(t1);
}, $fd4eb456bcbd06f8$var$xt.prototype.multiplyToArray = function() {
    console.warn("THREE.Matrix4: .multiplyToArray() has been removed.");
}, $fd4eb456bcbd06f8$var$xt.prototype.multiplyVector3 = function(t1) {
    return console.warn("THREE.Matrix4: .multiplyVector3() has been removed. Use vector.applyMatrix4( matrix ) instead."), t1.applyMatrix4(this);
}, $fd4eb456bcbd06f8$var$xt.prototype.multiplyVector4 = function(t1) {
    return console.warn("THREE.Matrix4: .multiplyVector4() has been removed. Use vector.applyMatrix4( matrix ) instead."), t1.applyMatrix4(this);
}, $fd4eb456bcbd06f8$var$xt.prototype.multiplyVector3Array = function() {
    console.error("THREE.Matrix4: .multiplyVector3Array() has been removed.");
}, $fd4eb456bcbd06f8$var$xt.prototype.rotateAxis = function(t1) {
    console.warn("THREE.Matrix4: .rotateAxis() has been removed. Use Vector3.transformDirection( matrix ) instead."), t1.transformDirection(this);
}, $fd4eb456bcbd06f8$var$xt.prototype.crossVector = function(t1) {
    return console.warn("THREE.Matrix4: .crossVector() has been removed. Use vector.applyMatrix4( matrix ) instead."), t1.applyMatrix4(this);
}, $fd4eb456bcbd06f8$var$xt.prototype.translate = function() {
    console.error("THREE.Matrix4: .translate() has been removed.");
}, $fd4eb456bcbd06f8$var$xt.prototype.rotateX = function() {
    console.error("THREE.Matrix4: .rotateX() has been removed.");
}, $fd4eb456bcbd06f8$var$xt.prototype.rotateY = function() {
    console.error("THREE.Matrix4: .rotateY() has been removed.");
}, $fd4eb456bcbd06f8$var$xt.prototype.rotateZ = function() {
    console.error("THREE.Matrix4: .rotateZ() has been removed.");
}, $fd4eb456bcbd06f8$var$xt.prototype.rotateByAxis = function() {
    console.error("THREE.Matrix4: .rotateByAxis() has been removed.");
}, $fd4eb456bcbd06f8$var$xt.prototype.applyToBufferAttribute = function(t1) {
    return console.warn("THREE.Matrix4: .applyToBufferAttribute() has been removed. Use attribute.applyMatrix4( matrix ) instead."), t1.applyMatrix4(this);
}, $fd4eb456bcbd06f8$var$xt.prototype.applyToVector3Array = function() {
    console.error("THREE.Matrix4: .applyToVector3Array() has been removed.");
}, $fd4eb456bcbd06f8$var$xt.prototype.makeFrustum = function(t1, e, n, i, r, s) {
    return console.warn("THREE.Matrix4: .makeFrustum() has been removed. Use .makePerspective( left, right, top, bottom, near, far ) instead."), this.makePerspective(t1, e, i, n, r, s);
}, $fd4eb456bcbd06f8$var$xt.prototype.getInverse = function(t1) {
    return console.warn("THREE.Matrix4: .getInverse() has been removed. Use matrixInv.copy( matrix ).invert(); instead."), this.copy(t1).invert();
}, $fd4eb456bcbd06f8$var$Ke.prototype.isIntersectionLine = function(t1) {
    return console.warn("THREE.Plane: .isIntersectionLine() has been renamed to .intersectsLine()."), this.intersectsLine(t1);
}, $fd4eb456bcbd06f8$var$H.prototype.multiplyVector3 = function(t1) {
    return console.warn("THREE.Quaternion: .multiplyVector3() has been removed. Use is now vector.applyQuaternion( quaternion ) instead."), t1.applyQuaternion(this);
}, $fd4eb456bcbd06f8$var$H.prototype.inverse = function() {
    return console.warn("THREE.Quaternion: .inverse() has been renamed to invert()."), this.invert();
}, $fd4eb456bcbd06f8$var$yt.prototype.isIntersectionBox = function(t1) {
    return console.warn("THREE.Ray: .isIntersectionBox() has been renamed to .intersectsBox()."), this.intersectsBox(t1);
}, $fd4eb456bcbd06f8$var$yt.prototype.isIntersectionPlane = function(t1) {
    return console.warn("THREE.Ray: .isIntersectionPlane() has been renamed to .intersectsPlane()."), this.intersectsPlane(t1);
}, $fd4eb456bcbd06f8$var$yt.prototype.isIntersectionSphere = function(t1) {
    return console.warn("THREE.Ray: .isIntersectionSphere() has been renamed to .intersectsSphere()."), this.intersectsSphere(t1);
}, $fd4eb456bcbd06f8$var$ee.prototype.area = function() {
    return console.warn("THREE.Triangle: .area() has been renamed to .getArea()."), this.getArea();
}, $fd4eb456bcbd06f8$var$ee.prototype.barycoordFromPoint = function(t1, e) {
    return console.warn("THREE.Triangle: .barycoordFromPoint() has been renamed to .getBarycoord()."), this.getBarycoord(t1, e);
}, $fd4eb456bcbd06f8$var$ee.prototype.midpoint = function(t1) {
    return console.warn("THREE.Triangle: .midpoint() has been renamed to .getMidpoint()."), this.getMidpoint(t1);
}, $fd4eb456bcbd06f8$var$ee.prototypenormal = function(t1) {
    return console.warn("THREE.Triangle: .normal() has been renamed to .getNormal()."), this.getNormal(t1);
}, $fd4eb456bcbd06f8$var$ee.prototype.plane = function(t1) {
    return console.warn("THREE.Triangle: .plane() has been renamed to .getPlane()."), this.getPlane(t1);
}, $fd4eb456bcbd06f8$var$ee.barycoordFromPoint = function(t1, e, n, i, r) {
    return console.warn("THREE.Triangle: .barycoordFromPoint() has been renamed to .getBarycoord()."), $fd4eb456bcbd06f8$var$ee.getBarycoord(t1, e, n, i, r);
}, $fd4eb456bcbd06f8$var$ee.normal = function(t1, e, n, i) {
    return console.warn("THREE.Triangle: .normal() has been renamed to .getNormal()."), $fd4eb456bcbd06f8$var$ee.getNormal(t1, e, n, i);
}, $fd4eb456bcbd06f8$var$na.prototype.extractAllPoints = function(t1) {
    return console.warn("THREE.Shape: .extractAllPoints() has been removed. Use .extractPoints() instead."), this.extractPoints(t1);
}, $fd4eb456bcbd06f8$var$na.prototype.extrude = function(t1) {
    return console.warn("THREE.Shape: .extrude() has been removed. Use ExtrudeGeometry() instead."), new $fd4eb456bcbd06f8$var$Pa(this, t1);
}, $fd4eb456bcbd06f8$var$na.prototype.makeGeometry = function(t1) {
    return console.warn("THREE.Shape: .makeGeometry() has been removed. Use ShapeGeometry() instead."), new $fd4eb456bcbd06f8$var$Ia(this, t1);
}, $fd4eb456bcbd06f8$var$g.prototype.fromAttribute = function(t1, e, n) {
    return console.warn("THREE.Vector2: .fromAttribute() has been renamed to .fromBufferAttribute()."), this.fromBufferAttribute(t1, e, n);
}, $fd4eb456bcbd06f8$var$g.prototype.distanceToManhattan = function(t1) {
    return console.warn("THREE.Vector2: .distanceToManhattan() has been renamed to .manhattanDistanceTo()."), this.manhattanDistanceTo(t1);
}, $fd4eb456bcbd06f8$var$g.prototype.lengthManhattan = function() {
    return console.warn("THREE.Vector2: .lengthManhattan() has been renamed to .manhattanLength()."), this.manhattanLength();
}, $fd4eb456bcbd06f8$var$V.prototype.setEulerFromRotationMatrix = function() {
    console.error("THREE.Vector3: .setEulerFromRotationMatrix() has been removed. Use Euler.setFromRotationMatrix() instead.");
}, $fd4eb456bcbd06f8$var$V.prototype.setEulerFromQuaternion = function() {
    console.error("THREE.Vector3: .setEulerFromQuaternion() has been removed. Use Euler.setFromQuaternion() instead.");
}, $fd4eb456bcbd06f8$var$V.prototype.getPositionFromMatrix = function(t1) {
    return console.warn("THREE.Vector3: .getPositionFromMatrix() has been renamed to .setFromMatrixPosition()."), this.setFromMatrixPosition(t1);
}, $fd4eb456bcbd06f8$var$V.prototype.getScaleFromMatrix = function(t1) {
    return console.warn("THREE.Vector3: .getScaleFromMatrix() has been renamed to .setFromMatrixScale()."), this.setFromMatrixScale(t1);
}, $fd4eb456bcbd06f8$var$V.prototype.getColumnFromMatrix = function(t1, e) {
    return console.warn("THREE.Vector3: .getColumnFromMatrix() has been renamed to .setFromMatrixColumn()."), this.setFromMatrixColumn(e, t1);
}, $fd4eb456bcbd06f8$var$V.prototype.applyProjection = function(t1) {
    return console.warn("THREE.Vector3: .applyProjection() has been removed. Use .applyMatrix4( m ) instead."), this.applyMatrix4(t1);
}, $fd4eb456bcbd06f8$var$V.prototype.fromAttribute = function(t1, e, n) {
    return console.warn("THREE.Vector3: .fromAttribute() has been renamed to .fromBufferAttribute()."), this.fromBufferAttribute(t1, e, n);
}, $fd4eb456bcbd06f8$var$V.prototype.distanceToManhattan = function(t1) {
    return console.warn("THREE.Vector3: .distanceToManhattan() has been renamed to .manhattanDistanceTo()."), this.manhattanDistanceTo(t1);
}, $fd4eb456bcbd06f8$var$V.prototype.lengthManhattan = function() {
    return console.warn("THREE.Vector3: .lengthManhattan() has been renamed to .manhattanLength()."), this.manhattanLength();
}, $fd4eb456bcbd06f8$var$U.prototype.fromAttribute = function(t1, e, n) {
    return console.warn("THREE.Vector4: .fromAttribute() has been renamed to .fromBufferAttribute()."), this.fromBufferAttribute(t1, e, n);
}, $fd4eb456bcbd06f8$var$U.prototype.lengthManhattan = function() {
    return console.warn("THREE.Vector4: .lengthManhattan() has been renamed to .manhattanLength()."), this.manhattanLength();
}, $fd4eb456bcbd06f8$var$Wt.prototype.getChildByName = function(t1) {
    return console.warn("THREE.Object3D: .getChildByName() has been renamed to .getObjectByName()."), this.getObjectByName(t1);
}, $fd4eb456bcbd06f8$var$Wt.prototype.renderDepth = function() {
    console.warn("THREE.Object3D: .renderDepth has been removed. Use .renderOrder, instead.");
}, $fd4eb456bcbd06f8$var$Wt.prototype.translate = function(t1, e) {
    return console.warn("THREE.Object3D: .translate() has been removed. Use .translateOnAxis( axis, distance ) instead."), this.translateOnAxis(e, t1);
}, $fd4eb456bcbd06f8$var$Wt.prototype.getWorldRotation = function() {
    console.error("THREE.Object3D: .getWorldRotation() has been removed. Use THREE.Object3D.getWorldQuaternion( target ) instead.");
}, $fd4eb456bcbd06f8$var$Wt.prototype.applyMatrix = function(t1) {
    return console.warn("THREE.Object3D: .applyMatrix() has been renamed to .applyMatrix4()."), this.applyMatrix4(t1);
}, Object.defineProperties($fd4eb456bcbd06f8$var$Wt.prototype, {
    eulerOrder: {
        get: function() {
            return console.warn("THREE.Object3D: .eulerOrder is now .rotation.order."), this.rotation.order;
        },
        set: function(t1) {
            console.warn("THREE.Object3D: .eulerOrder is now .rotation.order."), this.rotation.order = t1;
        }
    },
    useQuaternion: {
        get: function() {
            console.warn("THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default.");
        },
        set: function() {
            console.warn("THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default.");
        }
    }
}), $fd4eb456bcbd06f8$var$Fe.prototype.setDrawMode = function() {
    console.error("THREE.Mesh: .setDrawMode() has been removed. The renderer now always assumes THREE.TrianglesDrawMode. Transform your geometry via BufferGeometryUtils.toTrianglesDrawMode() if necessary.");
}, Object.defineProperties($fd4eb456bcbd06f8$var$Fe.prototype, {
    drawMode: {
        get: function() {
            return console.error("THREE.Mesh: .drawMode has been removed. The renderer now always assumes THREE.TrianglesDrawMode."), 0;
        },
        set: function() {
            console.error("THREE.Mesh: .drawMode has been removed. The renderer now always assumes THREE.TrianglesDrawMode. Transform your geometry via BufferGeometryUtils.toTrianglesDrawMode() if necessary.");
        }
    }
}), $fd4eb456bcbd06f8$var$ss.prototype.initBones = function() {
    console.error("THREE.SkinnedMesh: initBones() has been removed.");
}, $fd4eb456bcbd06f8$var$We.prototype.setLens = function(t1, e) {
    console.warn("THREE.PerspectiveCamera.setLens is deprecated. Use .setFocalLength and .filmGauge for a photographic setup."), void 0 !== e && (this.filmGauge = e), this.setFocalLength(t1);
}, Object.defineProperties($fd4eb456bcbd06f8$var$go.prototype, {
    onlyShadow: {
        set: function() {
            console.warn("THREE.Light: .onlyShadow has been removed.");
        }
    },
    shadowCameraFov: {
        set: function(t1) {
            console.warn("THREE.Light: .shadowCameraFov is now .shadow.camera.fov."), this.shadow.camera.fov = t1;
        }
    },
    shadowCameraLeft: {
        set: function(t1) {
            console.warn("THREE.Light: .shadowCameraLeft is now .shadow.camera.left."), this.shadow.camera.left = t1;
        }
    },
    shadowCameraRight: {
        set: function(t1) {
            console.warn("THREE.Light: .shadowCameraRight is now .shadow.camera.right."), this.shadow.camera.right = t1;
        }
    },
    shadowCameraTop: {
        set: function(t1) {
            console.warn("THREE.Light: .shadowCameraTop is now .shadow.camera.top."), this.shadow.camera.top = t1;
        }
    },
    shadowCameraBottom: {
        set: function(t1) {
            console.warn("THREE.Light: .shadowCameraBottom is now .shadow.camera.bottom."), this.shadow.camera.bottom = t1;
        }
    },
    shadowCameraNear: {
        set: function(t1) {
            console.warn("THREE.Light: .shadowCameraNear is now .shadow.camera.near."), this.shadow.camera.near = t1;
        }
    },
    shadowCameraFar: {
        set: function(t1) {
            console.warn("THREE.Light: .shadowCameraFar is now .shadow.camera.far."), this.shadow.camera.far = t1;
        }
    },
    shadowCameraVisible: {
        set: function() {
            console.warn("THREE.Light: .shadowCameraVisible has been removed. Use new THREE.CameraHelper( light.shadow.camera ) instead.");
        }
    },
    shadowBias: {
        set: function(t1) {
            console.warn("THREE.Light: .shadowBias is now .shadow.bias."), this.shadow.bias = t1;
        }
    },
    shadowDarkness: {
        set: function() {
            console.warn("THREE.Light: .shadowDarkness has been removed.");
        }
    },
    shadowMapWidth: {
        set: function(t1) {
            console.warn("THREE.Light: .shadowMapWidth is now .shadow.mapSize.width."), this.shadow.mapSize.width = t1;
        }
    },
    shadowMapHeight: {
        set: function(t1) {
            console.warn("THREE.Light: .shadowMapHeight is now .shadow.mapSize.height."), this.shadow.mapSize.height = t1;
        }
    }
}), Object.defineProperties($fd4eb456bcbd06f8$var$oe.prototype, {
    length: {
        get: function() {
            return console.warn("THREE.BufferAttribute: .length has been deprecated. Use .count instead."), this.array.length;
        }
    },
    dynamic: {
        get: function() {
            return console.warn("THREE.BufferAttribute: .dynamic has been deprecated. Use .usage instead."), 35048 === this.usage;
        },
        set: function() {
            console.warn("THREE.BufferAttribute: .dynamic has been deprecated. Use .usage instead."), this.setUsage(35048);
        }
    }
}), $fd4eb456bcbd06f8$var$oe.prototype.setDynamic = function(t1) {
    return console.warn("THREE.BufferAttribute: .setDynamic() has been deprecated. Use .setUsage() instead."), this.setUsage(!0 === t1 ? 35048 : 35044), this;
}, $fd4eb456bcbd06f8$var$oe.prototype.copyIndicesArray = function() {
    console.error("THREE.BufferAttribute: .copyIndicesArray() has been removed.");
}, $fd4eb456bcbd06f8$var$oe.prototype.setArray = function() {
    console.error("THREE.BufferAttribute: .setArray has been removed. Use BufferGeometry .setAttribute to replace/resize attribute buffers");
}, $fd4eb456bcbd06f8$var$ye.prototype.addIndex = function(t1) {
    console.warn("THREE.BufferGeometry: .addIndex() has been renamed to .setIndex()."), this.setIndex(t1);
}, $fd4eb456bcbd06f8$var$ye.prototype.addAttribute = function(t1, e) {
    return console.warn("THREE.BufferGeometry: .addAttribute() has been renamed to .setAttribute()."), e && e.isBufferAttribute || e && e.isInterleavedBufferAttribute ? "index" === t1 ? (console.warn("THREE.BufferGeometry.addAttribute: Use .setIndex() for index attribute."), this.setIndex(e), this) : this.setAttribute(t1, e) : (console.warn("THREE.BufferGeometry: .addAttribute() now expects ( name, attribute )."), this.setAttribute(t1, new $fd4eb456bcbd06f8$var$oe(arguments[1], arguments[2])));
}, $fd4eb456bcbd06f8$var$ye.prototype.addDrawCall = function(t1, e, n) {
    void 0 !== n && console.warn("THREE.BufferGeometry: .addDrawCall() no longer supports indexOffset."), console.warn("THREE.BufferGeometry: .addDrawCall() is now .addGroup()."), this.addGroup(t1, e);
}, $fd4eb456bcbd06f8$var$ye.prototype.clearDrawCalls = function() {
    console.warn("THREE.BufferGeometry: .clearDrawCalls() is now .clearGroups()."), this.clearGroups();
}, $fd4eb456bcbd06f8$var$ye.prototype.computeOffsets = function() {
    console.warn("THREE.BufferGeometry: .computeOffsets() has been removed.");
}, $fd4eb456bcbd06f8$var$ye.prototype.removeAttribute = function(t1) {
    return console.warn("THREE.BufferGeometry: .removeAttribute() has been renamed to .deleteAttribute()."), this.deleteAttribute(t1);
}, $fd4eb456bcbd06f8$var$ye.prototype.applyMatrix = function(t1) {
    return console.warn("THREE.BufferGeometry: .applyMatrix() has been renamed to .applyMatrix4()."), this.applyMatrix4(t1);
}, Object.defineProperties($fd4eb456bcbd06f8$var$ye.prototype, {
    drawcalls: {
        get: function() {
            return console.error("THREE.BufferGeometry: .drawcalls has been renamed to .groups."), this.groups;
        }
    },
    offsets: {
        get: function() {
            return console.warn("THREE.BufferGeometry: .offsets has been renamed to .groups."), this.groups;
        }
    }
}), $fd4eb456bcbd06f8$var$Fr.prototype.setDynamic = function(t1) {
    return console.warn("THREE.InterleavedBuffer: .setDynamic() has been deprecated. Use .setUsage() instead."), this.setUsage(!0 === t1 ? 35048 : 35044), this;
}, $fd4eb456bcbd06f8$var$Fr.prototype.setArray = function() {
    console.error("THREE.InterleavedBuffer: .setArray has been removed. Use BufferGeometry .setAttribute to replace/resize attribute buffers");
}, $fd4eb456bcbd06f8$var$Pa.prototype.getArrays = function() {
    console.error("THREE.ExtrudeGeometry: .getArrays() has been removed.");
}, $fd4eb456bcbd06f8$var$Pa.prototype.addShapeList = function() {
    console.error("THREE.ExtrudeGeometry: .addShapeList() has been removed.");
}, $fd4eb456bcbd06f8$var$Pa.prototype.addShape = function() {
    console.error("THREE.ExtrudeGeometry: .addShape() has been removed.");
}, $fd4eb456bcbd06f8$var$Nr.prototype.dispose = function() {
    console.error("THREE.Scene: .dispose() has been removed.");
}, Object.defineProperties($fd4eb456bcbd06f8$var$ie.prototype, {
    wrapAround: {
        get: function() {
            console.warn("THREE.Material: .wrapAround has been removed.");
        },
        set: function() {
            console.warn("THREE.Material: .wrapAround has been removed.");
        }
    },
    overdraw: {
        get: function() {
            console.warn("THREE.Material: .overdraw has been removed.");
        },
        set: function() {
            console.warn("THREE.Material: .overdraw has been removed.");
        }
    },
    wrapRGB: {
        get: function() {
            return console.warn("THREE.Material: .wrapRGB has been removed."), new $fd4eb456bcbd06f8$var$L;
        }
    },
    shading: {
        get: function() {
            console.error("THREE." + this.type + ": .shading has been removed. Use the boolean .flatShading instead.");
        },
        set: function(t1) {
            console.warn("THREE." + this.type + ": .shading has been removed. Use the boolean .flatShading instead."), this.flatShading = 1 === t1;
        }
    },
    stencilMask: {
        get: function() {
            return console.warn("THREE." + this.type + ": .stencilMask has been removed. Use .stencilFuncMask instead."), this.stencilFuncMask;
        },
        set: function(t1) {
            console.warn("THREE." + this.type + ": .stencilMask has been removed. Use .stencilFuncMask instead."), this.stencilFuncMask = t1;
        }
    },
    vertexTangents: {
        get: function() {
            console.warn("THREE." + this.type + ": .vertexTangents has been removed.");
        },
        set: function() {
            console.warn("THREE." + this.type + ": .vertexTangents has been removed.");
        }
    }
}), Object.defineProperties($fd4eb456bcbd06f8$var$Ve.prototype, {
    derivatives: {
        get: function() {
            return console.warn("THREE.ShaderMaterial: .derivatives has been moved to .extensions.derivatives."), this.extensions.derivatives;
        },
        set: function(t1) {
            console.warn("THREE. ShaderMaterial: .derivatives has been moved to .extensions.derivatives."), this.extensions.derivatives = t1;
        }
    }
}), $fd4eb456bcbd06f8$var$Or.prototype.clearTarget = function(t1, e, n, i) {
    console.warn("THREE.WebGLRenderer: .clearTarget() has been deprecated. Use .setRenderTarget() and .clear() instead."), this.setRenderTarget(t1), this.clear(e, n, i);
}, $fd4eb456bcbd06f8$var$Or.prototype.animate = function(t1) {
    console.warn("THREE.WebGLRenderer: .animate() is now .setAnimationLoop()."), this.setAnimationLoop(t1);
}, $fd4eb456bcbd06f8$var$Or.prototype.getCurrentRenderTarget = function() {
    return console.warn("THREE.WebGLRenderer: .getCurrentRenderTarget() is now .getRenderTarget()."), this.getRenderTarget();
}, $fd4eb456bcbd06f8$var$Or.prototype.getMaxAnisotropy = function() {
    return console.warn("THREE.WebGLRenderer: .getMaxAnisotropy() is now .capabilities.getMaxAnisotropy()."), this.capabilities.getMaxAnisotropy();
}, $fd4eb456bcbd06f8$var$Or.prototype.getPrecision = function() {
    return console.warn("THREE.WebGLRenderer: .getPrecision() is now .capabilities.precision."), this.capabilities.precision;
}, $fd4eb456bcbd06f8$var$Or.prototype.resetGLState = function() {
    return console.warn("THREE.WebGLRenderer: .resetGLState() is now .state.reset()."), this.state.reset();
}, $fd4eb456bcbd06f8$var$Or.prototype.supportsFloatTextures = function() {
    return console.warn("THREE.WebGLRenderer: .supportsFloatTextures() is now .extensions.get( 'OES_texture_float' )."), this.extensions.get("OES_texture_float");
}, $fd4eb456bcbd06f8$var$Or.prototype.supportsHalfFloatTextures = function() {
    return console.warn("THREE.WebGLRenderer: .supportsHalfFloatTextures() is now .extensions.get( 'OES_texture_half_float' )."), this.extensions.get("OES_texture_half_float");
}, $fd4eb456bcbd06f8$var$Or.prototype.supportsStandardDerivatives = function() {
    return console.warn("THREE.WebGLRenderer: .supportsStandardDerivatives() is now .extensions.get( 'OES_standard_derivatives' )."), this.extensions.get("OES_standard_derivatives");
}, $fd4eb456bcbd06f8$var$Or.prototype.supportsCompressedTextureS3TC = function() {
    return console.warn("THREE.WebGLRenderer: .supportsCompressedTextureS3TC() is now .extensions.get( 'WEBGL_compressed_texture_s3tc' )."), this.extensions.get("WEBGL_compressed_texture_s3tc");
}, $fd4eb456bcbd06f8$var$Or.prototype.supportsCompressedTexturePVRTC = function() {
    return console.warn("THREE.WebGLRenderer: .supportsCompressedTexturePVRTC() is now .extensions.get( 'WEBGL_compressed_texture_pvrtc' )."), this.extensions.get("WEBGL_compressed_texture_pvrtc");
}, $fd4eb456bcbd06f8$var$Or.prototype.supportsBlendMinMax = function() {
    return console.warn("THREE.WebGLRenderer: .supportsBlendMinMax() is now .extensions.get( 'EXT_blend_minmax' )."), this.extensions.get("EXT_blend_minmax");
}, $fd4eb456bcbd06f8$var$Or.prototype.supportsVertexTextures = function() {
    return console.warn("THREE.WebGLRenderer: .supportsVertexTextures() is now .capabilities.vertexTextures."), this.capabilities.vertexTextures;
}, $fd4eb456bcbd06f8$var$Or.prototype.supportsInstancedArrays = function() {
    return console.warn("THREE.WebGLRenderer: .supportsInstancedArrays() is now .extensions.get( 'ANGLE_instanced_arrays' )."), this.extensions.get("ANGLE_instanced_arrays");
}, $fd4eb456bcbd06f8$var$Or.prototype.enableScissorTest = function(t1) {
    console.warn("THREE.WebGLRenderer: .enableScissorTest() is now .setScissorTest()."), this.setScissorTest(t1);
}, $fd4eb456bcbd06f8$var$Or.prototype.initMaterial = function() {
    console.warn("THREE.WebGLRenderer: .initMaterial() has been removed.");
}, $fd4eb456bcbd06f8$var$Or.prototype.addPrePlugin = function() {
    console.warn("THREE.WebGLRenderer: .addPrePlugin() has been removed.");
}, $fd4eb456bcbd06f8$var$Or.prototype.addPostPlugin = function() {
    console.warn("THREE.WebGLRenderer: .addPostPlugin() has been removed.");
}, $fd4eb456bcbd06f8$var$Or.prototype.updateShadowMap = function() {
    console.warn("THREE.WebGLRenderer: .updateShadowMap() has been removed.");
}, $fd4eb456bcbd06f8$var$Or.prototype.setFaceCulling = function() {
    console.warn("THREE.WebGLRenderer: .setFaceCulling() has been removed.");
}, $fd4eb456bcbd06f8$var$Or.prototype.allocTextureUnit = function() {
    console.warn("THREE.WebGLRenderer: .allocTextureUnit() has been removed.");
}, $fd4eb456bcbd06f8$var$Or.prototype.setTexture = function() {
    console.warn("THREE.WebGLRenderer: .setTexture() has been removed.");
}, $fd4eb456bcbd06f8$var$Or.prototype.setTexture2D = function() {
    console.warn("THREE.WebGLRenderer: .setTexture2D() has been removed.");
}, $fd4eb456bcbd06f8$var$Or.prototype.setTextureCube = function() {
    console.warn("THREE.WebGLRenderer: .setTextureCube() has been removed.");
}, $fd4eb456bcbd06f8$var$Or.prototype.getActiveMipMapLevel = function() {
    return console.warn("THREE.WebGLRenderer: .getActiveMipMapLevel() is now .getActiveMipmapLevel()."), this.getActiveMipmapLevel();
}, Object.defineProperties($fd4eb456bcbd06f8$var$Or.prototype, {
    shadowMapEnabled: {
        get: function() {
            return this.shadowMap.enabled;
        },
        set: function(t1) {
            console.warn("THREE.WebGLRenderer: .shadowMapEnabled is now .shadowMap.enabled."), this.shadowMap.enabled = t1;
        }
    },
    shadowMapType: {
        get: function() {
            return this.shadowMap.type;
        },
        set: function(t1) {
            console.warn("THREE.WebGLRenderer: .shadowMapType is now .shadowMap.type."), this.shadowMap.type = t1;
        }
    },
    shadowMapCullFace: {
        get: function() {
            console.warn("THREE.WebGLRenderer: .shadowMapCullFace has been removed. Set Material.shadowSide instead.");
        },
        set: function() {
            console.warn("THREE.WebGLRenderer: .shadowMapCullFace has been removed. Set Material.shadowSide instead.");
        }
    },
    context: {
        get: function() {
            return console.warn("THREE.WebGLRenderer: .context has been removed. Use .getContext() instead."), this.getContext();
        }
    },
    vr: {
        get: function() {
            return console.warn("THREE.WebGLRenderer: .vr has been renamed to .xr"), this.xr;
        }
    },
    gammaInput: {
        get: function() {
            return console.warn("THREE.WebGLRenderer: .gammaInput has been removed. Set the encoding for textures via Texture.encoding instead."), !1;
        },
        set: function() {
            console.warn("THREE.WebGLRenderer: .gammaInput has been removed. Set the encoding for textures via Texture.encoding instead.");
        }
    },
    gammaOutput: {
        get: function() {
            return console.warn("THREE.WebGLRenderer: .gammaOutput has been removed. Set WebGLRenderer.outputEncoding instead."), !1;
        },
        set: function(t1) {
            console.warn("THREE.WebGLRenderer: .gammaOutput has been removed. Set WebGLRenderer.outputEncoding instead."), this.outputEncoding = !0 === t1 ? 3001 : 3e3;
        }
    },
    toneMappingWhitePoint: {
        get: function() {
            return console.warn("THREE.WebGLRenderer: .toneMappingWhitePoint has been removed."), 1;
        },
        set: function() {
            console.warn("THREE.WebGLRenderer: .toneMappingWhitePoint has been removed.");
        }
    },
    gammaFactor: {
        get: function() {
            return console.warn("THREE.WebGLRenderer: .gammaFactor has been removed."), 2;
        },
        set: function() {
            console.warn("THREE.WebGLRenderer: .gammaFactor has been removed.");
        }
    }
}), Object.defineProperties($fd4eb456bcbd06f8$var$Mr.prototype, {
    cullFace: {
        get: function() {
            console.warn("THREE.WebGLRenderer: .shadowMap.cullFace has been removed. Set Material.shadowSide instead.");
        },
        set: function() {
            console.warn("THREE.WebGLRenderer: .shadowMap.cullFace has been removed. Set Material.shadowSide instead.");
        }
    },
    renderReverseSided: {
        get: function() {
            console.warn("THREE.WebGLRenderer: .shadowMap.renderReverseSided has been removed. Set Material.shadowSide instead.");
        },
        set: function() {
            console.warn("THREE.WebGLRenderer: .shadowMap.renderReverseSided has been removed. Set Material.shadowSide instead.");
        }
    },
    renderSingleSided: {
        get: function() {
            console.warn("THREE.WebGLRenderer: .shadowMap.renderSingleSided has been removed. Set Material.shadowSide instead.");
        },
        set: function() {
            console.warn("THREE.WebGLRenderer: .shadowMap.renderSingleSided has been removed. Set Material.shadowSide instead.");
        }
    }
}), Object.defineProperties($fd4eb456bcbd06f8$var$k.prototype, {
    wrapS: {
        get: function() {
            return console.warn("THREE.WebGLRenderTarget: .wrapS is now .texture.wrapS."), this.texture.wrapS;
        },
        set: function(t1) {
            console.warn("THREE.WebGLRenderTarget: .wrapS is now .texture.wrapS."), this.texture.wrapS = t1;
        }
    },
    wrapT: {
        get: function() {
            return console.warn("THREE.WebGLRenderTarget: .wrapT is now .texture.wrapT."), this.texture.wrapT;
        },
        set: function(t1) {
            console.warn("THREE.WebGLRenderTarget: .wrapT is now .texture.wrapT."), this.texture.wrapT = t1;
        }
    },
    magFilter: {
        get: function() {
            return console.warn("THREE.WebGLRenderTarget: .magFilter is now .texture.magFilter."), this.texture.magFilter;
        },
        set: function(t1) {
            console.warn("THREE.WebGLRenderTarget: .magFilter is now .texture.magFilter."), this.texture.magFilter = t1;
        }
    },
    minFilter: {
        get: function() {
            return console.warn("THREE.WebGLRenderTarget: .minFilter is now .texture.minFilter."), this.texture.minFilter;
        },
        set: function(t1) {
            console.warn("THREE.WebGLRenderTarget: .minFilter is now .texture.minFilter."), this.texture.minFilter = t1;
        }
    },
    anisotropy: {
        get: function() {
            return console.warn("THREE.WebGLRenderTarget: .anisotropy is now .texture.anisotropy."), this.texture.anisotropy;
        },
        set: function(t1) {
            console.warn("THREE.WebGLRenderTarget: .anisotropy is now .texture.anisotropy."), this.texture.anisotropy = t1;
        }
    },
    offset: {
        get: function() {
            return console.warn("THREE.WebGLRenderTarget: .offset is now .texture.offset."), this.texture.offset;
        },
        set: function(t1) {
            console.warn("THREE.WebGLRenderTarget: .offset is now .texture.offset."), this.texture.offset = t1;
        }
    },
    repeat: {
        get: function() {
            return console.warn("THREE.WebGLRenderTarget: .repeat is now .texture.repeat."), this.texture.repeat;
        },
        set: function(t1) {
            console.warn("THREE.WebGLRenderTarget: .repeat is now .texture.repeat."), this.texture.repeat = t1;
        }
    },
    format: {
        get: function() {
            return console.warn("THREE.WebGLRenderTarget: .format is now .texture.format."), this.texture.format;
        },
        set: function(t1) {
            console.warn("THREE.WebGLRenderTarget: .format is now .texture.format."), this.texture.format = t1;
        }
    },
    type: {
        get: function() {
            return console.warn("THREE.WebGLRenderTarget: .type is now .texture.type."), this.texture.type;
        },
        set: function(t1) {
            console.warn("THREE.WebGLRenderTarget: .type is now .texture.type."), this.texture.type = t1;
        }
    },
    generateMipmaps: {
        get: function() {
            return console.warn("THREE.WebGLRenderTarget: .generateMipmaps is now .texture.generateMipmaps."), this.texture.generateMipmaps;
        },
        set: function(t1) {
            console.warn("THREE.WebGLRenderTarget: .generateMipmaps is now .texture.generateMipmaps."), this.texture.generateMipmaps = t1;
        }
    }
}), (class extends $fd4eb456bcbd06f8$var$Wt {
    constructor(t1){
        super(), this.type = "Audio", this.listener = t1, this.context = t1.context, this.gain = this.context.createGain(), this.gain.connect(t1.getInput()), this.autoplay = !1, this.buffer = null, this.detune = 0, this.loop = !1, this.loopStart = 0, this.loopEnd = 0, this.offset = 0, this.duration = void 0, this.playbackRate = 1, this.isPlaying = !1, this.hasPlaybackControl = !0, this.source = null, this.sourceType = "empty", this._startedAt = 0, this._progress = 0, this._connected = !1, this.filters = [];
    }
    getOutput() {
        return this.gain;
    }
    setNodeSource(t1) {
        return this.hasPlaybackControl = !1, this.sourceType = "audioNode", this.source = t1, this.connect(), this;
    }
    setMediaElementSource(t1) {
        return this.hasPlaybackControl = !1, this.sourceType = "mediaNode", this.source = this.context.createMediaElementSource(t1), this.connect(), this;
    }
    setMediaStreamSource(t1) {
        return this.hasPlaybackControl = !1, this.sourceType = "mediaStreamNode", this.source = this.context.createMediaStreamSource(t1), this.connect(), this;
    }
    setBuffer(t1) {
        return this.buffer = t1, this.sourceType = "buffer", this.autoplay && this.play(), this;
    }
    play(t1 = 0) {
        if (!0 === this.isPlaying) return void console.warn("THREE.Audio: Audio is already playing.");
        if (!1 === this.hasPlaybackControl) return void console.warn("THREE.Audio: this Audio has no playback control.");
        this._startedAt = this.context.currentTime + t1;
        const e = this.context.createBufferSource();
        return e.buffer = this.buffer, e.loop = this.loop, e.loopStart = this.loopStart, e.loopEnd = this.loopEnd, e.onended = this.onEnded.bind(this), e.start(this._startedAt, this._progress + this.offset, this.duration), this.isPlaying = !0, this.source = e, this.setDetune(this.detune), this.setPlaybackRate(this.playbackRate), this.connect();
    }
    pause() {
        if (!1 !== this.hasPlaybackControl) return !0 === this.isPlaying && (this._progress += Math.max(this.context.currentTime - this._startedAt, 0) * this.playbackRate, !0 === this.loop && (this._progress = this._progress % (this.duration || this.buffer.duration)), this.source.stop(), this.source.onended = null, this.isPlaying = !1), this;
        console.warn("THREE.Audio: this Audio has no playback control.");
    }
    stop() {
        if (!1 !== this.hasPlaybackControl) return this._progress = 0, this.source.stop(), this.source.onended = null, this.isPlaying = !1, this;
        console.warn("THREE.Audio: this Audio has no playback control.");
    }
    connect() {
        if (this.filters.length > 0) {
            this.source.connect(this.filters[0]);
            for(let t1 = 1, e = this.filters.length; t1 < e; t1++)this.filters[t1 - 1].connect(this.filters[t1]);
            this.filters[this.filters.length - 1].connect(this.getOutput());
        } else this.source.connect(this.getOutput());
        return this._connected = !0, this;
    }
    disconnect() {
        if (this.filters.length > 0) {
            this.source.disconnect(this.filters[0]);
            for(let t1 = 1, e = this.filters.length; t1 < e; t1++)this.filters[t1 - 1].disconnect(this.filters[t1]);
            this.filters[this.filters.length - 1].disconnect(this.getOutput());
        } else this.source.disconnect(this.getOutput());
        return this._connected = !1, this;
    }
    getFilters() {
        return this.filters;
    }
    setFilters(t1) {
        return t1 || (t1 = []), !0 === this._connected ? (this.disconnect(), this.filters = t1.slice(), this.connect()) : this.filters = t1.slice(), this;
    }
    setDetune(t1) {
        if (this.detune = t1, void 0 !== this.source.detune) return !0 === this.isPlaying && this.source.detune.setTargetAtTime(this.detune, this.context.currentTime, .01), this;
    }
    getDetune() {
        return this.detune;
    }
    getFilter() {
        return this.getFilters()[0];
    }
    setFilter(t1) {
        return this.setFilters(t1 ? [
            t1
        ] : []);
    }
    setPlaybackRate(t1) {
        if (!1 !== this.hasPlaybackControl) return this.playbackRate = t1, !0 === this.isPlaying && this.source.playbackRate.setTargetAtTime(this.playbackRate, this.context.currentTime, .01), this;
        console.warn("THREE.Audio: this Audio has no playback control.");
    }
    getPlaybackRate() {
        return this.playbackRate;
    }
    onEnded() {
        this.isPlaying = !1;
    }
    getLoop() {
        return !1 === this.hasPlaybackControl ? (console.warn("THREE.Audio: this Audio has no playback control."), !1) : this.loop;
    }
    setLoop(t1) {
        if (!1 !== this.hasPlaybackControl) return this.loop = t1, !0 === this.isPlaying && (this.source.loop = this.loop), this;
        console.warn("THREE.Audio: this Audio has no playback control.");
    }
    setLoopStart(t1) {
        return this.loopStart = t1, this;
    }
    setLoopEnd(t1) {
        return this.loopEnd = t1, this;
    }
    getVolume() {
        return this.gain.gain.value;
    }
    setVolume(t1) {
        return this.gain.gain.setTargetAtTime(t1, this.context.currentTime, .01), this;
    }
}).prototype.load = function(t1) {
    console.warn("THREE.Audio: .load has been deprecated. Use THREE.AudioLoader instead.");
    const e = this;
    return (new $fd4eb456bcbd06f8$var$Fo).load(t1, function(t1) {
        e.setBuffer(t1);
    }), this;
}, $fd4eb456bcbd06f8$var$je.prototype.updateCubeMap = function(t1, e) {
    return console.warn("THREE.CubeCamera: .updateCubeMap() is now .update()."), this.update(t1, e);
}, $fd4eb456bcbd06f8$var$je.prototype.clear = function(t1, e, n, i) {
    return console.warn("THREE.CubeCamera: .clear() is now .renderTarget.clear()."), this.renderTarget.clear(t1, e, n, i);
}, $fd4eb456bcbd06f8$var$D.crossOrigin = void 0, $fd4eb456bcbd06f8$var$D.loadTexture = function(t1, e, n, i) {
    console.warn("THREE.ImageUtils.loadTexture has been deprecated. Use THREE.TextureLoader() instead.");
    const r = new $fd4eb456bcbd06f8$var$fo;
    r.setCrossOrigin(this.crossOrigin);
    const s = r.load(t1, n, void 0, i);
    return e && (s.mapping = e), s;
}, $fd4eb456bcbd06f8$var$D.loadTextureCube = function(t1, e, n, i) {
    console.warn("THREE.ImageUtils.loadTextureCube has been deprecated. Use THREE.CubeTextureLoader() instead.");
    const r = new $fd4eb456bcbd06f8$var$po;
    r.setCrossOrigin(this.crossOrigin);
    const s = r.load(t1, n, void 0, i);
    return e && (s.mapping = e), s;
}, $fd4eb456bcbd06f8$var$D.loadCompressedTexture = function() {
    console.error("THREE.ImageUtils.loadCompressedTexture has been removed. Use THREE.DDSLoader instead.");
}, $fd4eb456bcbd06f8$var$D.loadCompressedTextureCube = function() {
    console.error("THREE.ImageUtils.loadCompressedTextureCube has been removed. Use THREE.DDSLoader instead.");
}, "undefined" != typeof __THREE_DEVTOOLS__ && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", {
    detail: {
        revision: "139"
    }
})), "undefined" != typeof window && (window.__THREE__ ? console.warn("WARNING: Multiple instances of Three.js being imported.") : window.__THREE__ = "139");
const $fd4eb456bcbd06f8$var$ul = window.ShadowRoot && (void 0 === window.ShadyCSS || window.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $fd4eb456bcbd06f8$var$dl = Symbol(), $fd4eb456bcbd06f8$var$pl = new Map;
class $fd4eb456bcbd06f8$var$ml {
    constructor(t1, e){
        if (this._$cssResult$ = !0, e !== $fd4eb456bcbd06f8$var$dl) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t1;
    }
    get styleSheet() {
        let t1 = $fd4eb456bcbd06f8$var$pl.get(this.cssText);
        return $fd4eb456bcbd06f8$var$ul && void 0 === t1 && ($fd4eb456bcbd06f8$var$pl.set(this.cssText, t1 = new CSSStyleSheet), t1.replaceSync(this.cssText)), t1;
    }
    toString() {
        return this.cssText;
    }
}
const $fd4eb456bcbd06f8$var$fl = $fd4eb456bcbd06f8$var$ul ? (t1)=>t1 : (t1)=>t1 instanceof CSSStyleSheet ? ((t1)=>{
        let e = "";
        for (const n of t1.cssRules)e += n.cssText;
        return ((t1)=>new $fd4eb456bcbd06f8$var$ml("string" == typeof t1 ? t1 : t1 + "", $fd4eb456bcbd06f8$var$dl))(e);
    })(t1) : t1;
var $fd4eb456bcbd06f8$var$gl;
const $fd4eb456bcbd06f8$var$vl = window.trustedTypes, $fd4eb456bcbd06f8$var$yl = $fd4eb456bcbd06f8$var$vl ? $fd4eb456bcbd06f8$var$vl.emptyScript : "", $fd4eb456bcbd06f8$var$xl = window.reactiveElementPolyfillSupport, $fd4eb456bcbd06f8$var$bl = {
    toAttribute (t1, e) {
        switch(e){
            case Boolean:
                t1 = t1 ? $fd4eb456bcbd06f8$var$yl : null;
                break;
            case Object:
            case Array:
                t1 = null == t1 ? t1 : JSON.stringify(t1);
        }
        return t1;
    },
    fromAttribute (t1, e) {
        let n = t1;
        switch(e){
            case Boolean:
                n = null !== t1;
                break;
            case Number:
                n = null === t1 ? null : Number(t1);
                break;
            case Object:
            case Array:
                try {
                    n = JSON.parse(t1);
                } catch (t1) {
                    n = null;
                }
        }
        return n;
    }
}, $fd4eb456bcbd06f8$var$_l = (t1, e)=>e !== t1 && (e == e || t1 == t1), $fd4eb456bcbd06f8$var$wl = {
    attribute: !0,
    type: String,
    converter: $fd4eb456bcbd06f8$var$bl,
    reflect: !1,
    hasChanged: $fd4eb456bcbd06f8$var$_l
};
class $fd4eb456bcbd06f8$var$Ml extends HTMLElement {
    constructor(){
        super(), this._$Et = new Map, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Ei = null, this.o();
    }
    static addInitializer(t1) {
        var e;
        null !== (e = this.l) && void 0 !== e || (this.l = []), this.l.push(t1);
    }
    static get observedAttributes() {
        this.finalize();
        const t1 = [];
        return this.elementProperties.forEach((e, n)=>{
            const i = this._$Eh(n, e);
            void 0 !== i && (this._$Eu.set(i, n), t1.push(i));
        }), t1;
    }
    static createProperty(t1, e = $fd4eb456bcbd06f8$var$wl) {
        if (e.state && (e.attribute = !1), this.finalize(), this.elementProperties.set(t1, e), !e.noAccessor && !this.prototype.hasOwnProperty(t1)) {
            const n = "symbol" == typeof t1 ? Symbol() : "__" + t1, i = this.getPropertyDescriptor(t1, n, e);
            void 0 !== i && Object.defineProperty(this.prototype, t1, i);
        }
    }
    static getPropertyDescriptor(t1, e, n) {
        return {
            get () {
                return this[e];
            },
            set (i) {
                const r = this[t1];
                this[e] = i, this.requestUpdate(t1, r, n);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t1) {
        return this.elementProperties.get(t1) || $fd4eb456bcbd06f8$var$wl;
    }
    static finalize() {
        if (this.hasOwnProperty("finalized")) return !1;
        this.finalized = !0;
        const t1 = Object.getPrototypeOf(this);
        if (t1.finalize(), this.elementProperties = new Map(t1.elementProperties), this._$Eu = new Map, this.hasOwnProperty("properties")) {
            const t1 = this.properties, e = [
                ...Object.getOwnPropertyNames(t1),
                ...Object.getOwnPropertySymbols(t1)
            ];
            for (const n of e)this.createProperty(n, t1[n]);
        }
        return this.elementStyles = this.finalizeStyles(this.styles), !0;
    }
    static finalizeStyles(t1) {
        const e = [];
        if (Array.isArray(t1)) {
            const n = new Set(t1.flat(1 / 0).reverse());
            for (const t1 of n)e.unshift($fd4eb456bcbd06f8$var$fl(t1));
        } else void 0 !== t1 && e.push($fd4eb456bcbd06f8$var$fl(t1));
        return e;
    }
    static _$Eh(t1, e) {
        const n = e.attribute;
        return !1 === n ? void 0 : "string" == typeof n ? n : "string" == typeof t1 ? t1.toLowerCase() : void 0;
    }
    o() {
        var t1;
        this._$Ep = new Promise((t1)=>this.enableUpdating = t1), this._$AL = new Map, this._$Em(), this.requestUpdate(), null === (t1 = this.constructor.l) || void 0 === t1 || t1.forEach((t1)=>t1(this));
    }
    addController(t1) {
        var e, n;
        (null !== (e = this._$Eg) && void 0 !== e ? e : this._$Eg = []).push(t1), void 0 !== this.renderRoot && this.isConnected && (null === (n = t1.hostConnected) || void 0 === n || n.call(t1));
    }
    removeController(t1) {
        var e;
        null === (e = this._$Eg) || void 0 === e || e.splice(this._$Eg.indexOf(t1) >>> 0, 1);
    }
    _$Em() {
        this.constructor.elementProperties.forEach((t1, e)=>{
            this.hasOwnProperty(e) && (this._$Et.set(e, this[e]), delete this[e]);
        });
    }
    createRenderRoot() {
        var t1;
        const e = null !== (t1 = this.shadowRoot) && void 0 !== t1 ? t1 : this.attachShadow(this.constructor.shadowRootOptions);
        return ((t1, e)=>{
            $fd4eb456bcbd06f8$var$ul ? t1.adoptedStyleSheets = e.map((t1)=>t1 instanceof CSSStyleSheet ? t1 : t1.styleSheet) : e.forEach((e)=>{
                const n = document.createElement("style"), i = window.litNonce;
                void 0 !== i && n.setAttribute("nonce", i), n.textContent = e.cssText, t1.appendChild(n);
            });
        })(e, this.constructor.elementStyles), e;
    }
    connectedCallback() {
        var t1;
        void 0 === this.renderRoot && (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), null === (t1 = this._$Eg) || void 0 === t1 || t1.forEach((t1)=>{
            var e;
            return null === (e = t1.hostConnected) || void 0 === e ? void 0 : e.call(t1);
        });
    }
    enableUpdating(t1) {}
    disconnectedCallback() {
        var t1;
        null === (t1 = this._$Eg) || void 0 === t1 || t1.forEach((t1)=>{
            var e;
            return null === (e = t1.hostDisconnected) || void 0 === e ? void 0 : e.call(t1);
        });
    }
    attributeChangedCallback(t1, e, n) {
        this._$AK(t1, n);
    }
    _$ES(t1, e, n = $fd4eb456bcbd06f8$var$wl) {
        var i, r;
        const s = this.constructor._$Eh(t1, n);
        if (void 0 !== s && !0 === n.reflect) {
            const a = (null !== (r = null === (i = n.converter) || void 0 === i ? void 0 : i.toAttribute) && void 0 !== r ? r : $fd4eb456bcbd06f8$var$bl.toAttribute)(e, n.type);
            this._$Ei = t1, null == a ? this.removeAttribute(s) : this.setAttribute(s, a), this._$Ei = null;
        }
    }
    _$AK(t1, e) {
        var n, i, r;
        const s = this.constructor, a = s._$Eu.get(t1);
        if (void 0 !== a && this._$Ei !== a) {
            const t1 = s.getPropertyOptions(a), o = t1.converter, l = null !== (r = null !== (i = null === (n = o) || void 0 === n ? void 0 : n.fromAttribute) && void 0 !== i ? i : "function" == typeof o ? o : null) && void 0 !== r ? r : $fd4eb456bcbd06f8$var$bl.fromAttribute;
            this._$Ei = a, this[a] = l(e, t1.type), this._$Ei = null;
        }
    }
    requestUpdate(t1, e, n) {
        let i = !0;
        void 0 !== t1 && (((n = n || this.constructor.getPropertyOptions(t1)).hasChanged || $fd4eb456bcbd06f8$var$_l)(this[t1], e) ? (this._$AL.has(t1) || this._$AL.set(t1, e), !0 === n.reflect && this._$Ei !== t1 && (void 0 === this._$EC && (this._$EC = new Map), this._$EC.set(t1, n))) : i = !1), !this.isUpdatePending && i && (this._$Ep = this._$E_());
    }
    async _$E_() {
        this.isUpdatePending = !0;
        try {
            await this._$Ep;
        } catch (t1) {
            Promise.reject(t1);
        }
        const t1 = this.scheduleUpdate();
        return null != t1 && await t1, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        var t1;
        if (!this.isUpdatePending) return;
        this.hasUpdated, this._$Et && (this._$Et.forEach((t1, e)=>this[e] = t1), this._$Et = void 0);
        let e = !1;
        const n = this._$AL;
        try {
            e = this.shouldUpdate(n), e ? (this.willUpdate(n), null === (t1 = this._$Eg) || void 0 === t1 || t1.forEach((t1)=>{
                var e;
                return null === (e = t1.hostUpdate) || void 0 === e ? void 0 : e.call(t1);
            }), this.update(n)) : this._$EU();
        } catch (t1) {
            throw e = !1, this._$EU(), t1;
        }
        e && this._$AE(n);
    }
    willUpdate(t1) {}
    _$AE(t1) {
        var e;
        null === (e = this._$Eg) || void 0 === e || e.forEach((t1)=>{
            var e;
            return null === (e = t1.hostUpdated) || void 0 === e ? void 0 : e.call(t1);
        }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t1)), this.updated(t1);
    }
    _$EU() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$Ep;
    }
    shouldUpdate(t1) {
        return !0;
    }
    update(t1) {
        void 0 !== this._$EC && (this._$EC.forEach((t1, e)=>this._$ES(e, this[e], t1)), this._$EC = void 0), this._$EU();
    }
    updated(t1) {}
    firstUpdated(t1) {}
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $fd4eb456bcbd06f8$var$Sl;
$fd4eb456bcbd06f8$var$Ml.finalized = !0, $fd4eb456bcbd06f8$var$Ml.elementProperties = new Map, $fd4eb456bcbd06f8$var$Ml.elementStyles = [], $fd4eb456bcbd06f8$var$Ml.shadowRootOptions = {
    mode: "open"
}, null == $fd4eb456bcbd06f8$var$xl || $fd4eb456bcbd06f8$var$xl({
    ReactiveElement: $fd4eb456bcbd06f8$var$Ml
}), (null !== ($fd4eb456bcbd06f8$var$gl = globalThis.reactiveElementVersions) && void 0 !== $fd4eb456bcbd06f8$var$gl ? $fd4eb456bcbd06f8$var$gl : globalThis.reactiveElementVersions = []).push("1.3.2");
const $fd4eb456bcbd06f8$var$Tl = globalThis.trustedTypes, $fd4eb456bcbd06f8$var$El = $fd4eb456bcbd06f8$var$Tl ? $fd4eb456bcbd06f8$var$Tl.createPolicy("lit-html", {
    createHTML: (t1)=>t1
}) : void 0, $fd4eb456bcbd06f8$var$Al = `lit$${(Math.random() + "").slice(9)}$`, $fd4eb456bcbd06f8$var$Rl = "?" + $fd4eb456bcbd06f8$var$Al, $fd4eb456bcbd06f8$var$Cl = `<${$fd4eb456bcbd06f8$var$Rl}>`, $fd4eb456bcbd06f8$var$Ll = document, $fd4eb456bcbd06f8$var$Pl = (t1 = "")=>$fd4eb456bcbd06f8$var$Ll.createComment(t1), $fd4eb456bcbd06f8$var$Dl = (t1)=>null === t1 || "object" != typeof t1 && "function" != typeof t1, $fd4eb456bcbd06f8$var$Il = Array.isArray, $fd4eb456bcbd06f8$var$Ol = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $fd4eb456bcbd06f8$var$Nl = /-->/g, $fd4eb456bcbd06f8$var$Fl = />/g, $fd4eb456bcbd06f8$var$Ul = />|[ 	\n\r](?:([^\s"'>=/]+)([ 	\n\r]*=[ 	\n\r]*(?:[^ 	\n\r"'`<>=]|("|')|))|$)/g, $fd4eb456bcbd06f8$var$kl = /'/g, $fd4eb456bcbd06f8$var$Bl = /"/g, $fd4eb456bcbd06f8$var$zl = /^(?:script|style|textarea|title)$/i, $fd4eb456bcbd06f8$var$Hl = ((t1)=>(e, ...n)=>({
            _$litType$: t1,
            strings: e,
            values: n
        }))(1), $fd4eb456bcbd06f8$var$Vl = Symbol.for("lit-noChange"), $fd4eb456bcbd06f8$var$Gl = Symbol.for("lit-nothing"), $fd4eb456bcbd06f8$var$Wl = new WeakMap, $fd4eb456bcbd06f8$var$jl = (t1, e, n)=>{
    var i, r;
    const s = null !== (i = null == n ? void 0 : n.renderBefore) && void 0 !== i ? i : e;
    let a = s._$litPart$;
    if (void 0 === a) {
        const t1 = null !== (r = null == n ? void 0 : n.renderBefore) && void 0 !== r ? r : null;
        s._$litPart$ = a = new $fd4eb456bcbd06f8$var$Kl(e.insertBefore($fd4eb456bcbd06f8$var$Pl(), t1), t1, void 0, null != n ? n : {});
    }
    return a._$AI(t1), a;
}, $fd4eb456bcbd06f8$var$ql = $fd4eb456bcbd06f8$var$Ll.createTreeWalker($fd4eb456bcbd06f8$var$Ll, 129, null, !1), $fd4eb456bcbd06f8$var$Xl = (t1, e)=>{
    const n = t1.length - 1, i = [];
    let r, s = 2 === e ? "<svg>" : "", a = $fd4eb456bcbd06f8$var$Ol;
    for(let e = 0; e < n; e++){
        const n = t1[e];
        let o, l, h = -1, c = 0;
        for(; c < n.length && (a.lastIndex = c, l = a.exec(n), null !== l);)c = a.lastIndex, a === $fd4eb456bcbd06f8$var$Ol ? "!--" === l[1] ? a = $fd4eb456bcbd06f8$var$Nl : void 0 !== l[1] ? a = $fd4eb456bcbd06f8$var$Fl : void 0 !== l[2] ? ($fd4eb456bcbd06f8$var$zl.test(l[2]) && (r = RegExp("</" + l[2], "g")), a = $fd4eb456bcbd06f8$var$Ul) : void 0 !== l[3] && (a = $fd4eb456bcbd06f8$var$Ul) : a === $fd4eb456bcbd06f8$var$Ul ? ">" === l[0] ? (a = null != r ? r : $fd4eb456bcbd06f8$var$Ol, h = -1) : void 0 === l[1] ? h = -2 : (h = a.lastIndex - l[2].length, o = l[1], a = void 0 === l[3] ? $fd4eb456bcbd06f8$var$Ul : '"' === l[3] ? $fd4eb456bcbd06f8$var$Bl : $fd4eb456bcbd06f8$var$kl) : a === $fd4eb456bcbd06f8$var$Bl || a === $fd4eb456bcbd06f8$var$kl ? a = $fd4eb456bcbd06f8$var$Ul : a === $fd4eb456bcbd06f8$var$Nl || a === $fd4eb456bcbd06f8$var$Fl ? a = $fd4eb456bcbd06f8$var$Ol : (a = $fd4eb456bcbd06f8$var$Ul, r = void 0);
        const u = a === $fd4eb456bcbd06f8$var$Ul && t1[e + 1].startsWith("/>") ? " " : "";
        s += a === $fd4eb456bcbd06f8$var$Ol ? n + $fd4eb456bcbd06f8$var$Cl : h >= 0 ? (i.push(o), n.slice(0, h) + "$lit$" + n.slice(h) + $fd4eb456bcbd06f8$var$Al + u) : n + $fd4eb456bcbd06f8$var$Al + (-2 === h ? (i.push(void 0), e) : u);
    }
    const o = s + (t1[n] || "<?>") + (2 === e ? "</svg>" : "");
    if (!Array.isArray(t1) || !t1.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return [
        void 0 !== $fd4eb456bcbd06f8$var$El ? $fd4eb456bcbd06f8$var$El.createHTML(o) : o,
        i
    ];
};
class $fd4eb456bcbd06f8$var$$l {
    constructor({ strings: t1, _$litType$: e }, n){
        let i;
        this.parts = [];
        let r = 0, s = 0;
        const a = t1.length - 1, o = this.parts, [l, h] = $fd4eb456bcbd06f8$var$Xl(t1, e);
        if (this.el = $fd4eb456bcbd06f8$var$$l.createElement(l, n), $fd4eb456bcbd06f8$var$ql.currentNode = this.el.content, 2 === e) {
            const t1 = this.el.content, e = t1.firstChild;
            e.remove(), t1.append(...e.childNodes);
        }
        for(; null !== (i = $fd4eb456bcbd06f8$var$ql.nextNode()) && o.length < a;){
            if (1 === i.nodeType) {
                if (i.hasAttributes()) {
                    const t1 = [];
                    for (const e of i.getAttributeNames())if (e.endsWith("$lit$") || e.startsWith($fd4eb456bcbd06f8$var$Al)) {
                        const n = h[s++];
                        if (t1.push(e), void 0 !== n) {
                            const t1 = i.getAttribute(n.toLowerCase() + "$lit$").split($fd4eb456bcbd06f8$var$Al), e = /([.?@])?(.*)/.exec(n);
                            o.push({
                                type: 1,
                                index: r,
                                name: e[2],
                                strings: t1,
                                ctor: "." === e[1] ? $fd4eb456bcbd06f8$var$Ql : "?" === e[1] ? $fd4eb456bcbd06f8$var$eh : "@" === e[1] ? $fd4eb456bcbd06f8$var$nh : $fd4eb456bcbd06f8$var$Zl
                            });
                        } else o.push({
                            type: 6,
                            index: r
                        });
                    }
                    for (const e of t1)i.removeAttribute(e);
                }
                if ($fd4eb456bcbd06f8$var$zl.test(i.tagName)) {
                    const t1 = i.textContent.split($fd4eb456bcbd06f8$var$Al), e = t1.length - 1;
                    if (e > 0) {
                        i.textContent = $fd4eb456bcbd06f8$var$Tl ? $fd4eb456bcbd06f8$var$Tl.emptyScript : "";
                        for(let n = 0; n < e; n++)i.append(t1[n], $fd4eb456bcbd06f8$var$Pl()), $fd4eb456bcbd06f8$var$ql.nextNode(), o.push({
                            type: 2,
                            index: ++r
                        });
                        i.append(t1[e], $fd4eb456bcbd06f8$var$Pl());
                    }
                }
            } else if (8 === i.nodeType) {
                if (i.data === $fd4eb456bcbd06f8$var$Rl) o.push({
                    type: 2,
                    index: r
                });
                else {
                    let t1 = -1;
                    for(; -1 !== (t1 = i.data.indexOf($fd4eb456bcbd06f8$var$Al, t1 + 1));)o.push({
                        type: 7,
                        index: r
                    }), t1 += $fd4eb456bcbd06f8$var$Al.length - 1;
                }
            }
            r++;
        }
    }
    static createElement(t1, e) {
        const n = $fd4eb456bcbd06f8$var$Ll.createElement("template");
        return n.innerHTML = t1, n;
    }
}
function $fd4eb456bcbd06f8$var$Yl(t1, e, n = t1, i) {
    var r, s, a, o;
    if (e === $fd4eb456bcbd06f8$var$Vl) return e;
    let l = void 0 !== i ? null === (r = n._$Cl) || void 0 === r ? void 0 : r[i] : n._$Cu;
    const h = $fd4eb456bcbd06f8$var$Dl(e) ? void 0 : e._$litDirective$;
    return (null == l ? void 0 : l.constructor) !== h && (null === (s = null == l ? void 0 : l._$AO) || void 0 === s || s.call(l, !1), void 0 === h ? l = void 0 : (l = new h(t1), l._$AT(t1, n, i)), void 0 !== i ? (null !== (a = (o = n)._$Cl) && void 0 !== a ? a : o._$Cl = [])[i] = l : n._$Cu = l), void 0 !== l && (e = $fd4eb456bcbd06f8$var$Yl(t1, l._$AS(t1, e.values), l, i)), e;
}
class $fd4eb456bcbd06f8$var$Jl {
    constructor(t1, e){
        this.v = [], this._$AN = void 0, this._$AD = t1, this._$AM = e;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    p(t1) {
        var e;
        const { el: { content: n }, parts: i } = this._$AD, r = (null !== (e = null == t1 ? void 0 : t1.creationScope) && void 0 !== e ? e : $fd4eb456bcbd06f8$var$Ll).importNode(n, !0);
        $fd4eb456bcbd06f8$var$ql.currentNode = r;
        let s = $fd4eb456bcbd06f8$var$ql.nextNode(), a = 0, o = 0, l = i[0];
        for(; void 0 !== l;){
            if (a === l.index) {
                let e;
                2 === l.type ? e = new $fd4eb456bcbd06f8$var$Kl(s, s.nextSibling, this, t1) : 1 === l.type ? e = new l.ctor(s, l.name, l.strings, this, t1) : 6 === l.type && (e = new $fd4eb456bcbd06f8$var$ih(s, this, t1)), this.v.push(e), l = i[++o];
            }
            a !== (null == l ? void 0 : l.index) && (s = $fd4eb456bcbd06f8$var$ql.nextNode(), a++);
        }
        return r;
    }
    m(t1) {
        let e = 0;
        for (const n of this.v)void 0 !== n && (void 0 !== n.strings ? (n._$AI(t1, n, e), e += n.strings.length - 2) : n._$AI(t1[e])), e++;
    }
}
class $fd4eb456bcbd06f8$var$Kl {
    constructor(t1, e, n, i){
        var r;
        this.type = 2, this._$AH = $fd4eb456bcbd06f8$var$Gl, this._$AN = void 0, this._$AA = t1, this._$AB = e, this._$AM = n, this.options = i, this._$Cg = null === (r = null == i ? void 0 : i.isConnected) || void 0 === r || r;
    }
    get _$AU() {
        var t1, e;
        return null !== (e = null === (t1 = this._$AM) || void 0 === t1 ? void 0 : t1._$AU) && void 0 !== e ? e : this._$Cg;
    }
    get parentNode() {
        let t1 = this._$AA.parentNode;
        const e = this._$AM;
        return void 0 !== e && 11 === t1.nodeType && (t1 = e.parentNode), t1;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t1, e = this) {
        t1 = $fd4eb456bcbd06f8$var$Yl(this, t1, e), $fd4eb456bcbd06f8$var$Dl(t1) ? t1 === $fd4eb456bcbd06f8$var$Gl || null == t1 || "" === t1 ? (this._$AH !== $fd4eb456bcbd06f8$var$Gl && this._$AR(), this._$AH = $fd4eb456bcbd06f8$var$Gl) : t1 !== this._$AH && t1 !== $fd4eb456bcbd06f8$var$Vl && this.$(t1) : void 0 !== t1._$litType$ ? this.T(t1) : void 0 !== t1.nodeType ? this.k(t1) : ((t1)=>{
            var e;
            return $fd4eb456bcbd06f8$var$Il(t1) || "function" == typeof (null === (e = t1) || void 0 === e ? void 0 : e[Symbol.iterator]);
        })(t1) ? this.S(t1) : this.$(t1);
    }
    M(t1, e = this._$AB) {
        return this._$AA.parentNode.insertBefore(t1, e);
    }
    k(t1) {
        this._$AH !== t1 && (this._$AR(), this._$AH = this.M(t1));
    }
    $(t1) {
        this._$AH !== $fd4eb456bcbd06f8$var$Gl && $fd4eb456bcbd06f8$var$Dl(this._$AH) ? this._$AA.nextSibling.data = t1 : this.k($fd4eb456bcbd06f8$var$Ll.createTextNode(t1)), this._$AH = t1;
    }
    T(t1) {
        var e;
        const { values: n, _$litType$: i } = t1, r = "number" == typeof i ? this._$AC(t1) : (void 0 === i.el && (i.el = $fd4eb456bcbd06f8$var$$l.createElement(i.h, this.options)), i);
        if ((null === (e = this._$AH) || void 0 === e ? void 0 : e._$AD) === r) this._$AH.m(n);
        else {
            const t1 = new $fd4eb456bcbd06f8$var$Jl(r, this), e = t1.p(this.options);
            t1.m(n), this.k(e), this._$AH = t1;
        }
    }
    _$AC(t1) {
        let e = $fd4eb456bcbd06f8$var$Wl.get(t1.strings);
        return void 0 === e && $fd4eb456bcbd06f8$var$Wl.set(t1.strings, e = new $fd4eb456bcbd06f8$var$$l(t1)), e;
    }
    S(t1) {
        $fd4eb456bcbd06f8$var$Il(this._$AH) || (this._$AH = [], this._$AR());
        const e = this._$AH;
        let n, i = 0;
        for (const r of t1)i === e.length ? e.push(n = new $fd4eb456bcbd06f8$var$Kl(this.M($fd4eb456bcbd06f8$var$Pl()), this.M($fd4eb456bcbd06f8$var$Pl()), this, this.options)) : n = e[i], n._$AI(r), i++;
        i < e.length && (this._$AR(n && n._$AB.nextSibling, i), e.length = i);
    }
    _$AR(t1 = this._$AA.nextSibling, e) {
        var n;
        for(null === (n = this._$AP) || void 0 === n || n.call(this, !1, !0, e); t1 && t1 !== this._$AB;){
            const e = t1.nextSibling;
            t1.remove(), t1 = e;
        }
    }
    setConnected(t1) {
        var e;
        void 0 === this._$AM && (this._$Cg = t1, null === (e = this._$AP) || void 0 === e || e.call(this, t1));
    }
}
class $fd4eb456bcbd06f8$var$Zl {
    constructor(t1, e, n, i, r){
        this.type = 1, this._$AH = $fd4eb456bcbd06f8$var$Gl, this._$AN = void 0, this.element = t1, this.name = e, this._$AM = i, this.options = r, n.length > 2 || "" !== n[0] || "" !== n[1] ? (this._$AH = Array(n.length - 1).fill(new String), this.strings = n) : this._$AH = $fd4eb456bcbd06f8$var$Gl;
    }
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t1, e = this, n, i) {
        const r = this.strings;
        let s = !1;
        if (void 0 === r) t1 = $fd4eb456bcbd06f8$var$Yl(this, t1, e, 0), s = !$fd4eb456bcbd06f8$var$Dl(t1) || t1 !== this._$AH && t1 !== $fd4eb456bcbd06f8$var$Vl, s && (this._$AH = t1);
        else {
            const i = t1;
            let a, o;
            for(t1 = r[0], a = 0; a < r.length - 1; a++)o = $fd4eb456bcbd06f8$var$Yl(this, i[n + a], e, a), o === $fd4eb456bcbd06f8$var$Vl && (o = this._$AH[a]), s || (s = !$fd4eb456bcbd06f8$var$Dl(o) || o !== this._$AH[a]), o === $fd4eb456bcbd06f8$var$Gl ? t1 = $fd4eb456bcbd06f8$var$Gl : t1 !== $fd4eb456bcbd06f8$var$Gl && (t1 += (null != o ? o : "") + r[a + 1]), this._$AH[a] = o;
        }
        s && !i && this.C(t1);
    }
    C(t1) {
        t1 === $fd4eb456bcbd06f8$var$Gl ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, null != t1 ? t1 : "");
    }
}
class $fd4eb456bcbd06f8$var$Ql extends $fd4eb456bcbd06f8$var$Zl {
    constructor(){
        super(...arguments), this.type = 3;
    }
    C(t1) {
        this.element[this.name] = t1 === $fd4eb456bcbd06f8$var$Gl ? void 0 : t1;
    }
}
const $fd4eb456bcbd06f8$var$th = $fd4eb456bcbd06f8$var$Tl ? $fd4eb456bcbd06f8$var$Tl.emptyScript : "";
class $fd4eb456bcbd06f8$var$eh extends $fd4eb456bcbd06f8$var$Zl {
    constructor(){
        super(...arguments), this.type = 4;
    }
    C(t1) {
        t1 && t1 !== $fd4eb456bcbd06f8$var$Gl ? this.element.setAttribute(this.name, $fd4eb456bcbd06f8$var$th) : this.element.removeAttribute(this.name);
    }
}
class $fd4eb456bcbd06f8$var$nh extends $fd4eb456bcbd06f8$var$Zl {
    constructor(t1, e, n, i, r){
        super(t1, e, n, i, r), this.type = 5;
    }
    _$AI(t1, e = this) {
        var n;
        if ((t1 = null !== (n = $fd4eb456bcbd06f8$var$Yl(this, t1, e, 0)) && void 0 !== n ? n : $fd4eb456bcbd06f8$var$Gl) === $fd4eb456bcbd06f8$var$Vl) return;
        const i = this._$AH, r = t1 === $fd4eb456bcbd06f8$var$Gl && i !== $fd4eb456bcbd06f8$var$Gl || t1.capture !== i.capture || t1.once !== i.once || t1.passive !== i.passive, s = t1 !== $fd4eb456bcbd06f8$var$Gl && (i === $fd4eb456bcbd06f8$var$Gl || r);
        r && this.element.removeEventListener(this.name, this, i), s && this.element.addEventListener(this.name, this, t1), this._$AH = t1;
    }
    handleEvent(t1) {
        var e, n;
        "function" == typeof this._$AH ? this._$AH.call(null !== (n = null === (e = this.options) || void 0 === e ? void 0 : e.host) && void 0 !== n ? n : this.element, t1) : this._$AH.handleEvent(t1);
    }
}
class $fd4eb456bcbd06f8$var$ih {
    constructor(t1, e, n){
        this.element = t1, this.type = 6, this._$AN = void 0, this._$AM = e, this.options = n;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t1) {
        $fd4eb456bcbd06f8$var$Yl(this, t1);
    }
}
const $fd4eb456bcbd06f8$var$rh = window.litHtmlPolyfillSupport;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $fd4eb456bcbd06f8$var$sh, $fd4eb456bcbd06f8$var$ah;
null == $fd4eb456bcbd06f8$var$rh || $fd4eb456bcbd06f8$var$rh($fd4eb456bcbd06f8$var$$l, $fd4eb456bcbd06f8$var$Kl), (null !== ($fd4eb456bcbd06f8$var$Sl = globalThis.litHtmlVersions) && void 0 !== $fd4eb456bcbd06f8$var$Sl ? $fd4eb456bcbd06f8$var$Sl : globalThis.litHtmlVersions = []).push("2.2.3");
class $fd4eb456bcbd06f8$var$oh extends $fd4eb456bcbd06f8$var$Ml {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Dt = void 0;
    }
    createRenderRoot() {
        var t1, e;
        const n = super.createRenderRoot();
        return null !== (t1 = (e = this.renderOptions).renderBefore) && void 0 !== t1 || (e.renderBefore = n.firstChild), n;
    }
    update(t1) {
        const e = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t1), this._$Dt = $fd4eb456bcbd06f8$var$jl(e, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        var t1;
        super.connectedCallback(), null === (t1 = this._$Dt) || void 0 === t1 || t1.setConnected(!0);
    }
    disconnectedCallback() {
        var t1;
        super.disconnectedCallback(), null === (t1 = this._$Dt) || void 0 === t1 || t1.setConnected(!1);
    }
    render() {
        return $fd4eb456bcbd06f8$var$Vl;
    }
}
$fd4eb456bcbd06f8$var$oh.finalized = !0, $fd4eb456bcbd06f8$var$oh._$litElement$ = !0, null === ($fd4eb456bcbd06f8$var$sh = globalThis.litElementHydrateSupport) || void 0 === $fd4eb456bcbd06f8$var$sh || $fd4eb456bcbd06f8$var$sh.call(globalThis, {
    LitElement: $fd4eb456bcbd06f8$var$oh
});
const $fd4eb456bcbd06f8$var$lh = globalThis.litElementPolyfillSupport;
null == $fd4eb456bcbd06f8$var$lh || $fd4eb456bcbd06f8$var$lh({
    LitElement: $fd4eb456bcbd06f8$var$oh
}), (null !== ($fd4eb456bcbd06f8$var$ah = globalThis.litElementVersions) && void 0 !== $fd4eb456bcbd06f8$var$ah ? $fd4eb456bcbd06f8$var$ah : globalThis.litElementVersions = []).push("3.2.0");
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fd4eb456bcbd06f8$var$hh = null != navigator.xr && null != self.XRSession && null != navigator.xr.isSessionSupported, $fd4eb456bcbd06f8$var$ch = $fd4eb456bcbd06f8$var$hh && self.XRSession.prototype.requestHitTestSource, $fd4eb456bcbd06f8$var$uh = null != self.ResizeObserver, $fd4eb456bcbd06f8$var$dh = null != self.IntersectionObserver, $fd4eb456bcbd06f8$var$ph = $fd4eb456bcbd06f8$var$ch;
(()=>{
    const t1 = navigator.userAgent || navigator.vendor || self.opera;
    let e = !1;
    (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(t1) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(t1.substr(0, 4))) && (e = !0);
})(), /\bCrOS\b/.test(navigator.userAgent);
const $fd4eb456bcbd06f8$var$mh = /android/i.test(navigator.userAgent), $fd4eb456bcbd06f8$var$fh = /iPad|iPhone|iPod/.test(navigator.userAgent) && !self.MSStream || "MacIntel" === navigator.platform && navigator.maxTouchPoints > 1, $fd4eb456bcbd06f8$var$gh = (()=>{
    const t1 = document.createElement("a");
    return Boolean(t1.relList && t1.relList.supports && t1.relList.supports("ar"));
})();
/Safari\//.test(navigator.userAgent);
const $fd4eb456bcbd06f8$var$vh = /firefox/i.test(navigator.userAgent), $fd4eb456bcbd06f8$var$yh = /OculusBrowser/.test(navigator.userAgent);
$fd4eb456bcbd06f8$var$fh && /CriOS\//.test(navigator.userAgent);
const $fd4eb456bcbd06f8$var$xh = $fd4eb456bcbd06f8$var$mh && !$fd4eb456bcbd06f8$var$vh && !$fd4eb456bcbd06f8$var$yh;
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fd4eb456bcbd06f8$var$bh = $fd4eb456bcbd06f8$var$Hl`
<style>
:host {
  display: block;
  position: relative;
  contain: strict;
  width: 300px;
  height: 150px;
}

/* NOTE: This ruleset is our integration surface area with the
 * :focus-visible polyfill.
 *
 * @see https://github.com/WICG/focus-visible/pull/196 */
:host([data-js-focus-visible]:focus:not(.focus-visible)),
:host([data-js-focus-visible]) :focus:not(.focus-visible) {
  outline: none;
}

.container {
  position: relative;
}

.userInput {
  width: 100%;
  height: 100%;
  display: block;
  position: relative;
  overflow: hidden;
}

canvas {
  position: absolute;
  display: none;
  pointer-events: none;
  /* NOTE(cdata): Chrome 76 and below apparently have a bug
   * that causes our canvas not to display pixels unless it is
   * on its own render layer
   * @see https://github.com/google/model-viewer/pull/755#issuecomment-536597893
   */
  transform: translateZ(0);
}

canvas.show {
  display: block;
}

/* Adapted from HTML5 Boilerplate
 *
 * @see https://github.com/h5bp/html5-boilerplate/blob/ceb4620c78fc82e13534fc44202a3f168754873f/dist/css/main.css#L122-L133 */
.screen-reader-only {
  border: 0;
  left: 0;
  top: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
  pointer-events: none;
}

.slot {
  position: absolute;
  pointer-events: none;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.slot > * {
  pointer-events: initial;
}

.annotation-wrapper ::slotted(*) {
  opacity: var(--max-hotspot-opacity, 1);
  transition: opacity 0.3s;
}

.pointer-tumbling .annotation-wrapper ::slotted(*) {
  pointer-events: none;
}

.annotation-wrapper ::slotted(*) {
  pointer-events: initial;
}

.annotation-wrapper.hide ::slotted(*) {
  opacity: var(--min-hotspot-opacity, 0.25);
}

.slot.poster {
  opacity: 0;
  transition: opacity 0.3s 0.3s;
  background-color: inherit;
}

.slot.poster.show {
  opacity: 1;
  transition: none;
}

.slot.poster.quick {
  transition: none;
}

.slot.poster > * {
  pointer-events: initial;
}

.slot.poster:not(.show) > * {
  pointer-events: none;
}

#default-poster {
  width: 100%;
  height: 100%;
  /* The default poster is a <button> so we need to set display
   * to prevent it from being affected by text-align: */
  display: block;
  position: absolute;
  border: none;
  padding: 0;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-color: var(--poster-color, #fff);
  background-image: var(--poster-image, none);
}

#default-progress-bar {
  display: block;
  position: relative;
  width: 100%;
  height: 100%;
  pointer-events: none;
  overflow: hidden;
}

#default-progress-bar > .mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: var(--progress-mask, #fff);
  transition: opacity 0.3s;
  opacity: 0.2;
}

#default-progress-bar > .bar {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: var(--progress-bar-height, 5px);
  background-color: var(--progress-bar-color, rgba(0, 0, 0, 0.4));
  transition: transform 0.09s;
  transform-origin: top left;
  transform: scaleX(0);
  overflow: hidden;
}

#default-progress-bar > .bar.hide {
  transition: opacity 0.3s 1s;
  opacity: 0;
}

.centered {
  align-items: center;
  justify-content: center;
}

.cover {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.slot.interaction-prompt {
  display: var(--interaction-prompt-display, flex);
  overflow: hidden;
  opacity: 0;
  will-change: opacity;
  transition: opacity 0.3s;
}

.slot.interaction-prompt.visible {
  opacity: 1;
}

.animated-container {
  will-change: transform, opacity;
  opacity: 0;
  transition: opacity 0.3s;
}

.slot.interaction-prompt > * {
  pointer-events: none;
}

.slot.ar-button {
  -moz-user-select: none;
  -webkit-tap-highlight-color: transparent;
  user-select: none;

  display: var(--ar-button-display, block);
}

.slot.ar-button:not(.enabled) {
  display: none;
}

.fab {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 40px;
  height: 40px;
  cursor: pointer;
  background-color: #fff;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.15);
  border-radius: 100px;
}

.fab > * {
  opacity: 0.87;
}

#default-ar-button {
  position: absolute;
  bottom: 16px;
  right: 16px;
  transform: scale(var(--ar-button-scale, 1));
  transform-origin: bottom right;
}

.slot.pan-target {
  display: block;
  position: absolute;
  width: 0;
  height: 0;
  left: 50%;
  top: 50%;
  transform: translate3d(-50%, -50%, 0);
  background-color: transparent;
  opacity: 0;
  transition: opacity 0.3s;
}

#default-pan-target {
  width: 6px;
  height: 6px;
  border-radius: 6px;
  border: 1px solid white;
  box-shadow: 0px 0px 2px 1px rgba(0, 0, 0, 0.8);
}

.slot.default {
  pointer-events: none;
}

.slot.progress-bar {
  pointer-events: none;
}

.slot.exit-webxr-ar-button {
  pointer-events: none;
}

.slot.exit-webxr-ar-button:not(.enabled) {
  display: none;
}

#default-exit-webxr-ar-button {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 16px;
  right: 16px;
  width: 40px;
  height: 40px;
  box-sizing: border-box;
}

#default-exit-webxr-ar-button > svg {
  fill: #fff;
}
</style>
<div class="container">
  <div class="userInput" tabindex="0" role="img"
      aria-label="3D model">
      <div class="slot canvas">
        <slot name="canvas">
          <canvas></canvas>
        </slot>
      </div>

  </div>

  <!-- NOTE(cdata): We need to wrap slots because browsers without ShadowDOM
        will have their <slot> elements removed by ShadyCSS -->
  <div class="slot poster">
    <slot name="poster">
      <button type="button" id="default-poster" aria-hidden="true" aria-label="Loading 3D model"></button>
    </slot>
  </div>

  <div class="slot ar-button">
    <slot name="ar-button">
      <a id="default-ar-button" part="default-ar-button" class="fab"
          tabindex="2"
          aria-label="View in your space">
        ${$fd4eb456bcbd06f8$var$Hl`
<svg version="1.1" id="view_x5F_in_x5F_AR_x5F_icon"
	 xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="24px" height="24px"
	 viewBox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve">
<rect id="Bounding_Box" x="0" y="0" fill="none" width="24" height="24"/>
<g id="Art_layer">
	<path d="M3,4c0-0.55,0.45-1,1-1h2V1H4C2.35,1,1,2.35,1,4v2h2V4z"/>
	<path d="M20,3c0.55,0,1,0.45,1,1v2h2V4c0-1.65-1.35-3-3-3h-2v2H20z"/>
	<path d="M4,21c-0.55,0-1-0.45-1-1v-2H1v2c0,1.65,1.35,3,3,3h2v-2H4z"/>
	<path d="M20,21c0.55,0,1-0.45,1-1v-2h2v2c0,1.65-1.35,3-3,3h-2v-2H20z"/>
	<g>
		<path d="M18.25,7.6l-5.5-3.18c-0.46-0.27-1.04-0.27-1.5,0L5.75,7.6C5.29,7.87,5,8.36,5,8.9v6.35c0,0.54,0.29,1.03,0.75,1.3
			l5.5,3.18c0.46,0.27,1.04,0.27,1.5,0l5.5-3.18c0.46-0.27,0.75-0.76,0.75-1.3V8.9C19,8.36,18.71,7.87,18.25,7.6z M7,14.96v-4.62
			l4,2.32v4.61L7,14.96z M12,10.93L8,8.61l4-2.31l4,2.31L12,10.93z M13,17.27v-4.61l4-2.32v4.62L13,17.27z"/>
	</g>
</g>
</svg>`}
      </a>
    </slot>
  </div>

  <div class="slot pan-target">
    <slot name="pan-target">
      <div id="default-pan-target">
      </div>
    </slot>
  </div>

  <div class="slot interaction-prompt cover centered">
    <div id="prompt" class="animated-container">
      <slot name="interaction-prompt" aria-hidden="true">
        ${$fd4eb456bcbd06f8$var$Hl`
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="25" height="36">
    <defs>
        <path id="A" d="M.001.232h24.997V36H.001z" />
    </defs>
    <g transform="translate(-11 -4)" fill="none" fill-rule="evenodd">
        <path fill-opacity="0" fill="#fff" d="M0 0h44v44H0z" />
        <g transform="translate(11 3)">
            <path d="M8.733 11.165c.04-1.108.766-2.027 1.743-2.307a2.54 2.54 0 0 1 .628-.089c.16 0 .314.017.463.044 1.088.2 1.9 1.092 1.9 2.16v8.88h1.26c2.943-1.39 5-4.45 5-8.025a9.01 9.01 0 0 0-1.9-5.56l-.43-.5c-.765-.838-1.683-1.522-2.712-2-1.057-.49-2.226-.77-3.46-.77s-2.4.278-3.46.77c-1.03.478-1.947 1.162-2.71 2l-.43.5a9.01 9.01 0 0 0-1.9 5.56 9.04 9.04 0 0 0 .094 1.305c.03.21.088.41.13.617l.136.624c.083.286.196.56.305.832l.124.333a8.78 8.78 0 0 0 .509.953l.065.122a8.69 8.69 0 0 0 3.521 3.191l1.11.537v-9.178z" fill-opacity=".5" fill="#e4e4e4" />
            <path d="M22.94 26.218l-2.76 7.74c-.172.485-.676.8-1.253.8H12.24c-1.606 0-3.092-.68-3.98-1.82-1.592-2.048-3.647-3.822-6.11-5.27-.095-.055-.15-.137-.152-.23-.004-.1.046-.196.193-.297.56-.393 1.234-.6 1.926-.6a3.43 3.43 0 0 1 .691.069l4.922.994V10.972c0-.663.615-1.203 1.37-1.203s1.373.54 1.373 1.203v9.882h2.953c.273 0 .533.073.757.21l6.257 3.874c.027.017.045.042.07.06.41.296.586.77.426 1.22M4.1 16.614c-.024-.04-.042-.083-.065-.122a8.69 8.69 0 0 1-.509-.953c-.048-.107-.08-.223-.124-.333l-.305-.832c-.058-.202-.09-.416-.136-.624l-.13-.617a9.03 9.03 0 0 1-.094-1.305c0-2.107.714-4.04 1.9-5.56l.43-.5c.764-.84 1.682-1.523 2.71-2 1.058-.49 2.226-.77 3.46-.77s2.402.28 3.46.77c1.03.477 1.947 1.16 2.712 2l.428.5a9 9 0 0 1 1.901 5.559c0 3.577-2.056 6.636-5 8.026h-1.26v-8.882c0-1.067-.822-1.96-1.9-2.16-.15-.028-.304-.044-.463-.044-.22 0-.427.037-.628.09-.977.28-1.703 1.198-1.743 2.306v9.178l-1.11-.537C6.18 19.098 4.96 18 4.1 16.614M22.97 24.09l-6.256-3.874c-.102-.063-.218-.098-.33-.144 2.683-1.8 4.354-4.855 4.354-8.243 0-.486-.037-.964-.104-1.43a9.97 9.97 0 0 0-1.57-4.128l-.295-.408-.066-.092a10.05 10.05 0 0 0-.949-1.078c-.342-.334-.708-.643-1.094-.922-1.155-.834-2.492-1.412-3.94-1.65l-.732-.088-.748-.03a9.29 9.29 0 0 0-1.482.119c-1.447.238-2.786.816-3.94 1.65a9.33 9.33 0 0 0-.813.686 9.59 9.59 0 0 0-.845.877l-.385.437-.36.5-.288.468-.418.778-.04.09c-.593 1.28-.93 2.71-.93 4.222 0 3.832 2.182 7.342 5.56 8.938l1.437.68v4.946L5 25.64a4.44 4.44 0 0 0-.888-.086c-.017 0-.034.003-.05.003-.252.004-.503.033-.75.08a5.08 5.08 0 0 0-.237.056c-.193.046-.382.107-.568.18-.075.03-.15.057-.225.1-.25.114-.494.244-.723.405a1.31 1.31 0 0 0-.566 1.122 1.28 1.28 0 0 0 .645 1.051C4 29.925 5.96 31.614 7.473 33.563a5.06 5.06 0 0 0 .434.491c1.086 1.082 2.656 1.713 4.326 1.715h6.697c.748-.001 1.43-.333 1.858-.872.142-.18.256-.38.336-.602l2.757-7.74c.094-.26.13-.53.112-.794s-.088-.52-.203-.76a2.19 2.19 0 0 0-.821-.91" fill-opacity=".6" fill="#000" />
            <path d="M22.444 24.94l-6.257-3.874a1.45 1.45 0 0 0-.757-.211h-2.953v-9.88c0-.663-.616-1.203-1.373-1.203s-1.37.54-1.37 1.203v16.643l-4.922-.994a3.44 3.44 0 0 0-.692-.069 3.35 3.35 0 0 0-1.925.598c-.147.102-.198.198-.194.298.004.094.058.176.153.23 2.462 1.448 4.517 3.22 6.11 5.27.887 1.14 2.373 1.82 3.98 1.82h6.686c.577 0 1.08-.326 1.253-.8l2.76-7.74c.16-.448-.017-.923-.426-1.22-.025-.02-.043-.043-.07-.06z" fill="#fff" />
            <g transform="translate(0 .769)">
                <mask id="B" fill="#fff">
                    <use xlink:href="#A" />
                </mask>
                <path d="M23.993 24.992a1.96 1.96 0 0 1-.111.794l-2.758 7.74c-.08.22-.194.423-.336.602-.427.54-1.11.87-1.857.872h-6.698c-1.67-.002-3.24-.633-4.326-1.715-.154-.154-.3-.318-.434-.49C5.96 30.846 4 29.157 1.646 27.773c-.385-.225-.626-.618-.645-1.05a1.31 1.31 0 0 1 .566-1.122 4.56 4.56 0 0 1 .723-.405l.225-.1a4.3 4.3 0 0 1 .568-.18l.237-.056c.248-.046.5-.075.75-.08.018 0 .034-.003.05-.003.303-.001.597.027.89.086l3.722.752V20.68l-1.436-.68c-3.377-1.596-5.56-5.106-5.56-8.938 0-1.51.336-2.94.93-4.222.015-.03.025-.06.04-.09.127-.267.268-.525.418-.778.093-.16.186-.316.288-.468.063-.095.133-.186.2-.277L3.773 5c.118-.155.26-.29.385-.437.266-.3.544-.604.845-.877a9.33 9.33 0 0 1 .813-.686C6.97 2.167 8.31 1.59 9.757 1.35a9.27 9.27 0 0 1 1.481-.119 8.82 8.82 0 0 1 .748.031c.247.02.49.05.733.088 1.448.238 2.786.816 3.94 1.65.387.28.752.588 1.094.922a9.94 9.94 0 0 1 .949 1.078l.066.092c.102.133.203.268.295.408a9.97 9.97 0 0 1 1.571 4.128c.066.467.103.945.103 1.43 0 3.388-1.67 6.453-4.353 8.243.11.046.227.08.33.144l6.256 3.874c.37.23.645.55.82.9.115.24.185.498.203.76m.697-1.195c-.265-.55-.677-1.007-1.194-1.326l-5.323-3.297c2.255-2.037 3.564-4.97 3.564-8.114 0-2.19-.637-4.304-1.84-6.114-.126-.188-.26-.37-.4-.552-.645-.848-1.402-1.6-2.252-2.204C15.472.91 13.393.232 11.238.232A10.21 10.21 0 0 0 5.23 2.19c-.848.614-1.606 1.356-2.253 2.205-.136.18-.272.363-.398.55C1.374 6.756.737 8.87.737 11.06c0 4.218 2.407 8.08 6.133 9.842l.863.41v3.092l-2.525-.51c-.356-.07-.717-.106-1.076-.106a5.45 5.45 0 0 0-3.14.996c-.653.46-1.022 1.202-.99 1.983a2.28 2.28 0 0 0 1.138 1.872c2.24 1.318 4.106 2.923 5.543 4.772 1.26 1.62 3.333 2.59 5.55 2.592h6.698c1.42-.001 2.68-.86 3.134-2.138l2.76-7.74c.272-.757.224-1.584-.134-2.325" fill-opacity=".05" fill="#000" mask="url(#B)" />
            </g>
        </g>
    </g>
</svg>`}
      </slot>
    </div>
  </div>

  <div id="finger0" class="animated-container cover">
    <slot name="finger0" aria-hidden="true">
    </slot>
  </div>
  <div id="finger1" class="animated-container cover">
    <slot name="finger1" aria-hidden="true">
    </slot>
  </div>

  <div class="slot default">
    <slot></slot>

    <div class="slot progress-bar">
      <slot name="progress-bar">
        <div id="default-progress-bar" aria-hidden="true">
          <div class="mask" part="default-progress-mask"></div>
          <div class="bar" part="default-progress-bar"></div>
        </div>
      </slot>
    </div>

    <div class="slot exit-webxr-ar-button">
      <slot name="exit-webxr-ar-button">
        <a id="default-exit-webxr-ar-button" part="default-exit-webxr-ar-button"
            tabindex="3"
            aria-label="Exit AR"
            aria-hidden="true">
          ${$fd4eb456bcbd06f8$var$Hl`
<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="#000000">
    <!-- NOTE(cdata): This SVG filter is a stop-gap until we can implement
         support for dynamic re-coloring of UI components -->
    <defs>
      <filter id="drop-shadow" x="-100%" y="-100%" width="300%" height="300%">
        <feGaussianBlur in="SourceAlpha" stdDeviation="1"/>
        <feOffset dx="0" dy="0" result="offsetblur"/>
        <feFlood flood-color="#000000"/>
        <feComposite in2="offsetblur" operator="in"/>
        <feMerge>
          <feMergeNode/>
          <feMergeNode in="SourceGraphic"/>
        </feMerge>
      </filter>
    </defs>
    <path filter="url(#drop-shadow)" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
    <path d="M0 0h24v24H0z" fill="none"/>
</svg>`}
        </a>
      </slot>
    </div>
  </div>
</div>
<div class="screen-reader-only" role="region" aria-label="Live announcements">
  <span id="status" role="status"></span>
</div>`, $fd4eb456bcbd06f8$var$_h = new WeakMap;
function $fd4eb456bcbd06f8$var$wh() {
    let t1, e;
    function n(t1, e, n, i, r, s) {
        const a = s.num_components(), o = n.num_points() * a, l = o * r.BYTES_PER_ELEMENT, h = function(t1, e) {
            switch(e){
                case Float32Array:
                    return t1.DT_FLOAT32;
                case Int8Array:
                    return t1.DT_INT8;
                case Int16Array:
                    return t1.DT_INT16;
                case Int32Array:
                    return t1.DT_INT32;
                case Uint8Array:
                    return t1.DT_UINT8;
                case Uint16Array:
                    return t1.DT_UINT16;
                case Uint32Array:
                    return t1.DT_UINT32;
            }
        }(t1, r), c = t1._malloc(l);
        e.GetAttributeDataArrayForAllPoints(n, s, h, l, c);
        const u = new r(t1.HEAPF32.buffer, c, o).slice();
        return t1._free(c), {
            name: i,
            array: u,
            itemSize: a
        };
    }
    onmessage = function(i) {
        const r = i.data;
        switch(r.type){
            case "init":
                t1 = r.decoderConfig, e = new Promise(function(e) {
                    t1.onModuleLoaded = function(t1) {
                        e({
                            draco: t1
                        });
                    }, DracoDecoderModule(t1);
                });
                break;
            case "decode":
                const i1 = r.buffer, s = r.taskConfig;
                e.then((t1)=>{
                    const e = t1.draco, a = new e.Decoder, o = new e.DecoderBuffer;
                    o.Init(new Int8Array(i1), i1.byteLength);
                    try {
                        const t1 = function(t1, e, i, r) {
                            const s = r.attributeIDs, a = r.attributeTypes;
                            let o, l;
                            const h = e.GetEncodedGeometryType(i);
                            if (h === t1.TRIANGULAR_MESH) o = new t1.Mesh, l = e.DecodeBufferToMesh(i, o);
                            else {
                                if (h !== t1.POINT_CLOUD) throw new Error("THREE.DRACOLoader: Unexpected geometry type.");
                                o = new t1.PointCloud, l = e.DecodeBufferToPointCloud(i, o);
                            }
                            if (!l.ok() || 0 === o.ptr) throw new Error("THREE.DRACOLoader: Decoding failed: " + l.error_msg());
                            const c = {
                                index: null,
                                attributes: []
                            };
                            for(const i in s){
                                const l = self[a[i]];
                                let h, u;
                                if (r.useUniqueIDs) u = s[i], h = e.GetAttributeByUniqueId(o, u);
                                else {
                                    if (u = e.GetAttributeId(o, t1[s[i]]), -1 === u) continue;
                                    h = e.GetAttribute(o, u);
                                }
                                c.attributes.push(n(t1, e, o, i, l, h));
                            }
                            h === t1.TRIANGULAR_MESH && (c.index = function(t1, e, n) {
                                const i = 3 * n.num_faces(), r = 4 * i, s = t1._malloc(r);
                                e.GetTrianglesUInt32Array(n, r, s);
                                const a = new Uint32Array(t1.HEAPF32.buffer, s, i).slice();
                                return t1._free(s), {
                                    array: a,
                                    itemSize: 1
                                };
                            }(t1, e, o));
                            return t1.destroy(o), c;
                        }(e, a, o, s), i = t1.attributes.map((t1)=>t1.array.buffer);
                        t1.index && i.push(t1.index.array.buffer), self.postMessage({
                            type: "decode",
                            id: r.id,
                            geometry: t1
                        }, i);
                    } catch (t1) {
                        console.error(t1), self.postMessage({
                            type: "error",
                            id: r.id,
                            error: t1.message
                        });
                    } finally{
                        e.destroy(o), e.destroy(a);
                    }
                });
        }
    };
}
class $fd4eb456bcbd06f8$var$Mh extends $fd4eb456bcbd06f8$var$lo {
    constructor(t1){
        super(t1), this.dracoLoader = null, this.ktx2Loader = null, this.meshoptDecoder = null, this.pluginCallbacks = [], this.register(function(t1) {
            return new $fd4eb456bcbd06f8$var$Rh(t1);
        }), this.register(function(t1) {
            return new $fd4eb456bcbd06f8$var$Oh(t1);
        }), this.register(function(t1) {
            return new $fd4eb456bcbd06f8$var$Nh(t1);
        }), this.register(function(t1) {
            return new $fd4eb456bcbd06f8$var$Ch(t1);
        }), this.register(function(t1) {
            return new $fd4eb456bcbd06f8$var$Lh(t1);
        }), this.register(function(t1) {
            return new $fd4eb456bcbd06f8$var$Ph(t1);
        }), this.register(function(t1) {
            return new $fd4eb456bcbd06f8$var$Dh(t1);
        }), this.register(function(t1) {
            return new $fd4eb456bcbd06f8$var$Ih(t1);
        }), this.register(function(t1) {
            return new $fd4eb456bcbd06f8$var$Eh(t1);
        }), this.register(function(t1) {
            return new $fd4eb456bcbd06f8$var$Fh(t1);
        });
    }
    load(t1, e, n, i) {
        const r = this;
        let s;
        s = "" !== this.resourcePath ? this.resourcePath : "" !== this.path ? this.path : $fd4eb456bcbd06f8$var$Do.extractUrlBase(t1), this.manager.itemStart(t1);
        const a = function(e) {
            i ? i(e) : console.error(e), r.manager.itemError(t1), r.manager.itemEnd(t1);
        }, o = new $fd4eb456bcbd06f8$var$co(this.manager);
        o.setPath(this.path), o.setResponseType("arraybuffer"), o.setRequestHeader(this.requestHeader), o.setWithCredentials(this.withCredentials), o.load(t1, function(n) {
            try {
                r.parse(n, s, function(n) {
                    e(n), r.manager.itemEnd(t1);
                }, a);
            } catch (t1) {
                a(t1);
            }
        }, n, a);
    }
    setDRACOLoader(t1) {
        return this.dracoLoader = t1, this;
    }
    setDDSLoader() {
        throw new Error('THREE.GLTFLoader: "MSFT_texture_dds" no longer supported. Please update to "KHR_texture_basisu".');
    }
    setKTX2Loader(t1) {
        return this.ktx2Loader = t1, this;
    }
    setMeshoptDecoder(t1) {
        return this.meshoptDecoder = t1, this;
    }
    register(t1) {
        return -1 === this.pluginCallbacks.indexOf(t1) && this.pluginCallbacks.push(t1), this;
    }
    unregister(t1) {
        return -1 !== this.pluginCallbacks.indexOf(t1) && this.pluginCallbacks.splice(this.pluginCallbacks.indexOf(t1), 1), this;
    }
    parse(t1, e, n, i) {
        let r;
        const s = {}, a = {};
        if ("string" == typeof t1) r = t1;
        else if ($fd4eb456bcbd06f8$var$Do.decodeText(new Uint8Array(t1, 0, 4)) === $fd4eb456bcbd06f8$var$Uh) {
            try {
                s[$fd4eb456bcbd06f8$var$Th.KHR_BINARY_GLTF] = new $fd4eb456bcbd06f8$var$zh(t1);
            } catch (t1) {
                return void (i && i(t1));
            }
            r = s[$fd4eb456bcbd06f8$var$Th.KHR_BINARY_GLTF].content;
        } else r = $fd4eb456bcbd06f8$var$Do.decodeText(new Uint8Array(t1));
        const o = JSON.parse(r);
        if (void 0 === o.asset || o.asset.version[0] < 2) return void (i && i(new Error("THREE.GLTFLoader: Unsupported asset. glTF versions >=2.0 are supported.")));
        const l = new $fd4eb456bcbd06f8$var$xc(o, {
            path: e || this.resourcePath || "",
            crossOrigin: this.crossOrigin,
            requestHeader: this.requestHeader,
            manager: this.manager,
            ktx2Loader: this.ktx2Loader,
            meshoptDecoder: this.meshoptDecoder
        });
        l.fileLoader.setRequestHeader(this.requestHeader);
        for(let t1 = 0; t1 < this.pluginCallbacks.length; t1++){
            const e = this.pluginCallbacks[t1](l);
            a[e.name] = e, s[e.name] = !0;
        }
        if (o.extensionsUsed) for(let t1 = 0; t1 < o.extensionsUsed.length; ++t1){
            const e = o.extensionsUsed[t1], n = o.extensionsRequired || [];
            switch(e){
                case $fd4eb456bcbd06f8$var$Th.KHR_MATERIALS_UNLIT:
                    s[e] = new $fd4eb456bcbd06f8$var$Ah;
                    break;
                case $fd4eb456bcbd06f8$var$Th.KHR_MATERIALS_PBR_SPECULAR_GLOSSINESS:
                    s[e] = new $fd4eb456bcbd06f8$var$Wh;
                    break;
                case $fd4eb456bcbd06f8$var$Th.KHR_DRACO_MESH_COMPRESSION:
                    s[e] = new $fd4eb456bcbd06f8$var$Hh(o, this.dracoLoader);
                    break;
                case $fd4eb456bcbd06f8$var$Th.KHR_TEXTURE_TRANSFORM:
                    s[e] = new $fd4eb456bcbd06f8$var$Vh;
                    break;
                case $fd4eb456bcbd06f8$var$Th.KHR_MESH_QUANTIZATION:
                    s[e] = new $fd4eb456bcbd06f8$var$jh;
                    break;
                default:
                    n.indexOf(e) >= 0 && void 0 === a[e] && console.warn('THREE.GLTFLoader: Unknown extension "' + e + '".');
            }
        }
        l.setExtensions(s), l.setPlugins(a), l.parse(n, i);
    }
    parseAsync(t1, e) {
        const n = this;
        return new Promise(function(i, r) {
            n.parse(t1, e, i, r);
        });
    }
}
function $fd4eb456bcbd06f8$var$Sh() {
    let t1 = {};
    return {
        get: function(e) {
            return t1[e];
        },
        add: function(e, n) {
            t1[e] = n;
        },
        remove: function(e) {
            delete t1[e];
        },
        removeAll: function() {
            t1 = {};
        }
    };
}
const $fd4eb456bcbd06f8$var$Th = {
    KHR_BINARY_GLTF: "KHR_binary_glTF",
    KHR_DRACO_MESH_COMPRESSION: "KHR_draco_mesh_compression",
    KHR_LIGHTS_PUNCTUAL: "KHR_lights_punctual",
    KHR_MATERIALS_CLEARCOAT: "KHR_materials_clearcoat",
    KHR_MATERIALS_IOR: "KHR_materials_ior",
    KHR_MATERIALS_PBR_SPECULAR_GLOSSINESS: "KHR_materials_pbrSpecularGlossiness",
    KHR_MATERIALS_SHEEN: "KHR_materials_sheen",
    KHR_MATERIALS_SPECULAR: "KHR_materials_specular",
    KHR_MATERIALS_TRANSMISSION: "KHR_materials_transmission",
    KHR_MATERIALS_UNLIT: "KHR_materials_unlit",
    KHR_MATERIALS_VOLUME: "KHR_materials_volume",
    KHR_TEXTURE_BASISU: "KHR_texture_basisu",
    KHR_TEXTURE_TRANSFORM: "KHR_texture_transform",
    KHR_MESH_QUANTIZATION: "KHR_mesh_quantization",
    EXT_TEXTURE_WEBP: "EXT_texture_webp",
    EXT_MESHOPT_COMPRESSION: "EXT_meshopt_compression"
};
class $fd4eb456bcbd06f8$var$Eh {
    constructor(t1){
        this.parser = t1, this.name = $fd4eb456bcbd06f8$var$Th.KHR_LIGHTS_PUNCTUAL, this.cache = {
            refs: {},
            uses: {}
        };
    }
    _markDefs() {
        const t1 = this.parser, e = this.parser.json.nodes || [];
        for(let n = 0, i = e.length; n < i; n++){
            const i = e[n];
            i.extensions && i.extensions[this.name] && void 0 !== i.extensions[this.name].light && t1._addNodeRef(this.cache, i.extensions[this.name].light);
        }
    }
    _loadLight(t1) {
        const e = this.parser, n = "light:" + t1;
        let i = e.cache.get(n);
        if (i) return i;
        const r = e.json, s = ((r.extensions && r.extensions[this.name] || {}).lights || [])[t1];
        let a;
        const o = new $fd4eb456bcbd06f8$var$L(16777215);
        void 0 !== s.color && o.fromArray(s.color);
        const l = void 0 !== s.range ? s.range : 0;
        switch(s.type){
            case "directional":
                a = new $fd4eb456bcbd06f8$var$Co(o), a.target.position.set(0, 0, -1), a.add(a.target);
                break;
            case "point":
                a = new $fd4eb456bcbd06f8$var$Ao(o), a.distance = l;
                break;
            case "spot":
                a = new $fd4eb456bcbd06f8$var$wo(o), a.distance = l, s.spot = s.spot || {}, s.spot.innerConeAngle = void 0 !== s.spot.innerConeAngle ? s.spot.innerConeAngle : 0, s.spot.outerConeAngle = void 0 !== s.spot.outerConeAngle ? s.spot.outerConeAngle : Math.PI / 4, a.angle = s.spot.outerConeAngle, a.penumbra = 1 - s.spot.innerConeAngle / s.spot.outerConeAngle, a.target.position.set(0, 0, -1), a.add(a.target);
                break;
            default:
                throw new Error("THREE.GLTFLoader: Unexpected light type: " + s.type);
        }
        return a.position.set(0, 0, 0), a.decay = 2, void 0 !== s.intensity && (a.intensity = s.intensity), a.name = e.createUniqueName(s.name || "light_" + t1), i = Promise.resolve(a), e.cache.add(n, i), i;
    }
    createNodeAttachment(t1) {
        const e = this, n = this.parser, i = n.json.nodes[t1], r = (i.extensions && i.extensions[this.name] || {}).light;
        return void 0 === r ? null : this._loadLight(r).then(function(t1) {
            return n._getNodeRef(e.cache, r, t1);
        });
    }
}
class $fd4eb456bcbd06f8$var$Ah {
    constructor(){
        this.name = $fd4eb456bcbd06f8$var$Th.KHR_MATERIALS_UNLIT;
    }
    getMaterialType() {
        return $fd4eb456bcbd06f8$var$re;
    }
    extendParams(t1, e, n) {
        const i = [];
        t1.color = new $fd4eb456bcbd06f8$var$L(1, 1, 1), t1.opacity = 1;
        const r = e.pbrMetallicRoughness;
        if (r) {
            if (Array.isArray(r.baseColorFactor)) {
                const e = r.baseColorFactor;
                t1.color.fromArray(e), t1.opacity = e[3];
            }
            void 0 !== r.baseColorTexture && i.push(n.assignTexture(t1, "map", r.baseColorTexture, 3001));
        }
        return Promise.all(i);
    }
}
class $fd4eb456bcbd06f8$var$Rh {
    constructor(t1){
        this.parser = t1, this.name = $fd4eb456bcbd06f8$var$Th.KHR_MATERIALS_CLEARCOAT;
    }
    getMaterialType(t1) {
        const e = this.parser.json.materials[t1];
        return e.extensions && e.extensions[this.name] ? $fd4eb456bcbd06f8$var$Ua : null;
    }
    extendMaterialParams(t1, e) {
        const n = this.parser, i = n.json.materials[t1];
        if (!i.extensions || !i.extensions[this.name]) return Promise.resolve();
        const r = [], s = i.extensions[this.name];
        if (void 0 !== s.clearcoatFactor && (e.clearcoat = s.clearcoatFactor), void 0 !== s.clearcoatTexture && r.push(n.assignTexture(e, "clearcoatMap", s.clearcoatTexture)), void 0 !== s.clearcoatRoughnessFactor && (e.clearcoatRoughness = s.clearcoatRoughnessFactor), void 0 !== s.clearcoatRoughnessTexture && r.push(n.assignTexture(e, "clearcoatRoughnessMap", s.clearcoatRoughnessTexture)), void 0 !== s.clearcoatNormalTexture && (r.push(n.assignTexture(e, "clearcoatNormalMap", s.clearcoatNormalTexture)), void 0 !== s.clearcoatNormalTexture.scale)) {
            const t1 = s.clearcoatNormalTexture.scale;
            e.clearcoatNormalScale = new $fd4eb456bcbd06f8$var$g(t1, t1);
        }
        return Promise.all(r);
    }
}
class $fd4eb456bcbd06f8$var$Ch {
    constructor(t1){
        this.parser = t1, this.name = $fd4eb456bcbd06f8$var$Th.KHR_MATERIALS_SHEEN;
    }
    getMaterialType(t1) {
        const e = this.parser.json.materials[t1];
        return e.extensions && e.extensions[this.name] ? $fd4eb456bcbd06f8$var$Ua : null;
    }
    extendMaterialParams(t1, e) {
        const n = this.parser, i = n.json.materials[t1];
        if (!i.extensions || !i.extensions[this.name]) return Promise.resolve();
        const r = [];
        e.sheenColor = new $fd4eb456bcbd06f8$var$L(0, 0, 0), e.sheenRoughness = 0, e.sheen = 1;
        const s = i.extensions[this.name];
        return void 0 !== s.sheenColorFactor && e.sheenColor.fromArray(s.sheenColorFactor), void 0 !== s.sheenRoughnessFactor && (e.sheenRoughness = s.sheenRoughnessFactor), void 0 !== s.sheenColorTexture && r.push(n.assignTexture(e, "sheenColorMap", s.sheenColorTexture, 3001)), void 0 !== s.sheenRoughnessTexture && r.push(n.assignTexture(e, "sheenRoughnessMap", s.sheenRoughnessTexture)), Promise.all(r);
    }
}
class $fd4eb456bcbd06f8$var$Lh {
    constructor(t1){
        this.parser = t1, this.name = $fd4eb456bcbd06f8$var$Th.KHR_MATERIALS_TRANSMISSION;
    }
    getMaterialType(t1) {
        const e = this.parser.json.materials[t1];
        return e.extensions && e.extensions[this.name] ? $fd4eb456bcbd06f8$var$Ua : null;
    }
    extendMaterialParams(t1, e) {
        const n = this.parser, i = n.json.materials[t1];
        if (!i.extensions || !i.extensions[this.name]) return Promise.resolve();
        const r = [], s = i.extensions[this.name];
        return void 0 !== s.transmissionFactor && (e.transmission = s.transmissionFactor), void 0 !== s.transmissionTexture && r.push(n.assignTexture(e, "transmissionMap", s.transmissionTexture)), Promise.all(r);
    }
}
class $fd4eb456bcbd06f8$var$Ph {
    constructor(t1){
        this.parser = t1, this.name = $fd4eb456bcbd06f8$var$Th.KHR_MATERIALS_VOLUME;
    }
    getMaterialType(t1) {
        const e = this.parser.json.materials[t1];
        return e.extensions && e.extensions[this.name] ? $fd4eb456bcbd06f8$var$Ua : null;
    }
    extendMaterialParams(t1, e) {
        const n = this.parser, i = n.json.materials[t1];
        if (!i.extensions || !i.extensions[this.name]) return Promise.resolve();
        const r = [], s = i.extensions[this.name];
        e.thickness = void 0 !== s.thicknessFactor ? s.thicknessFactor : 0, void 0 !== s.thicknessTexture && r.push(n.assignTexture(e, "thicknessMap", s.thicknessTexture)), e.attenuationDistance = s.attenuationDistance || 0;
        const a = s.attenuationColor || [
            1,
            1,
            1
        ];
        return e.attenuationColor = new $fd4eb456bcbd06f8$var$L(a[0], a[1], a[2]), Promise.all(r);
    }
}
class $fd4eb456bcbd06f8$var$Dh {
    constructor(t1){
        this.parser = t1, this.name = $fd4eb456bcbd06f8$var$Th.KHR_MATERIALS_IOR;
    }
    getMaterialType(t1) {
        const e = this.parser.json.materials[t1];
        return e.extensions && e.extensions[this.name] ? $fd4eb456bcbd06f8$var$Ua : null;
    }
    extendMaterialParams(t1, e) {
        const n = this.parser.json.materials[t1];
        if (!n.extensions || !n.extensions[this.name]) return Promise.resolve();
        const i = n.extensions[this.name];
        return e.ior = void 0 !== i.ior ? i.ior : 1.5, Promise.resolve();
    }
}
class $fd4eb456bcbd06f8$var$Ih {
    constructor(t1){
        this.parser = t1, this.name = $fd4eb456bcbd06f8$var$Th.KHR_MATERIALS_SPECULAR;
    }
    getMaterialType(t1) {
        const e = this.parser.json.materials[t1];
        return e.extensions && e.extensions[this.name] ? $fd4eb456bcbd06f8$var$Ua : null;
    }
    extendMaterialParams(t1, e) {
        const n = this.parser, i = n.json.materials[t1];
        if (!i.extensions || !i.extensions[this.name]) return Promise.resolve();
        const r = [], s = i.extensions[this.name];
        e.specularIntensity = void 0 !== s.specularFactor ? s.specularFactor : 1, void 0 !== s.specularTexture && r.push(n.assignTexture(e, "specularIntensityMap", s.specularTexture));
        const a = s.specularColorFactor || [
            1,
            1,
            1
        ];
        return e.specularColor = new $fd4eb456bcbd06f8$var$L(a[0], a[1], a[2]), void 0 !== s.specularColorTexture && r.push(n.assignTexture(e, "specularColorMap", s.specularColorTexture, 3001)), Promise.all(r);
    }
}
class $fd4eb456bcbd06f8$var$Oh {
    constructor(t1){
        this.parser = t1, this.name = $fd4eb456bcbd06f8$var$Th.KHR_TEXTURE_BASISU;
    }
    loadTexture(t1) {
        const e = this.parser, n = e.json, i = n.textures[t1];
        if (!i.extensions || !i.extensions[this.name]) return null;
        const r = i.extensions[this.name], s = e.options.ktx2Loader;
        if (!s) {
            if (n.extensionsRequired && n.extensionsRequired.indexOf(this.name) >= 0) throw new Error("THREE.GLTFLoader: setKTX2Loader must be called before loading KTX2 textures");
            return null;
        }
        return e.loadTextureImage(t1, r.source, s);
    }
}
class $fd4eb456bcbd06f8$var$Nh {
    constructor(t1){
        this.parser = t1, this.name = $fd4eb456bcbd06f8$var$Th.EXT_TEXTURE_WEBP, this.isSupported = null;
    }
    loadTexture(t1) {
        const e = this.name, n = this.parser, i = n.json, r = i.textures[t1];
        if (!r.extensions || !r.extensions[e]) return null;
        const s = r.extensions[e], a = i.images[s.source];
        let o = n.textureLoader;
        if (a.uri) {
            const t1 = n.options.manager.getHandler(a.uri);
            null !== t1 && (o = t1);
        }
        return this.detectSupport().then(function(r) {
            if (r) return n.loadTextureImage(t1, s.source, o);
            if (i.extensionsRequired && i.extensionsRequired.indexOf(e) >= 0) throw new Error("THREE.GLTFLoader: WebP required by asset but unsupported.");
            return n.loadTexture(t1);
        });
    }
    detectSupport() {
        return this.isSupported || (this.isSupported = new Promise(function(t1) {
            const e = new Image;
            e.src = "data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA", e.onload = e.onerror = function() {
                t1(1 === e.height);
            };
        })), this.isSupported;
    }
}
class $fd4eb456bcbd06f8$var$Fh {
    constructor(t1){
        this.name = $fd4eb456bcbd06f8$var$Th.EXT_MESHOPT_COMPRESSION, this.parser = t1;
    }
    loadBufferView(t1) {
        const e = this.parser.json, n = e.bufferViews[t1];
        if (n.extensions && n.extensions[this.name]) {
            const t1 = n.extensions[this.name], i = this.parser.getDependency("buffer", t1.buffer), r = this.parser.options.meshoptDecoder;
            if (!r || !r.supported) {
                if (e.extensionsRequired && e.extensionsRequired.indexOf(this.name) >= 0) throw new Error("THREE.GLTFLoader: setMeshoptDecoder must be called before loading compressed files");
                return null;
            }
            return Promise.all([
                i,
                r.ready
            ]).then(function(e) {
                const n = t1.byteOffset || 0, i = t1.byteLength || 0, s = t1.count, a = t1.byteStride, o = new ArrayBuffer(s * a), l = new Uint8Array(e[0], n, i);
                return r.decodeGltfBuffer(new Uint8Array(o), s, a, l, t1.mode, t1.filter), o;
            });
        }
        return null;
    }
}
const $fd4eb456bcbd06f8$var$Uh = "glTF", $fd4eb456bcbd06f8$var$kh = 1313821514, $fd4eb456bcbd06f8$var$Bh = 5130562;
class $fd4eb456bcbd06f8$var$zh {
    constructor(t1){
        this.name = $fd4eb456bcbd06f8$var$Th.KHR_BINARY_GLTF, this.content = null, this.body = null;
        const e = new DataView(t1, 0, 12);
        if (this.header = {
            magic: $fd4eb456bcbd06f8$var$Do.decodeText(new Uint8Array(t1.slice(0, 4))),
            version: e.getUint32(4, !0),
            length: e.getUint32(8, !0)
        }, this.header.magic !== $fd4eb456bcbd06f8$var$Uh) throw new Error("THREE.GLTFLoader: Unsupported glTF-Binary header.");
        if (this.header.version < 2) throw new Error("THREE.GLTFLoader: Legacy binary file detected.");
        const n = this.header.length - 12, i = new DataView(t1, 12);
        let r = 0;
        for(; r < n;){
            const e = i.getUint32(r, !0);
            r += 4;
            const n = i.getUint32(r, !0);
            if (r += 4, n === $fd4eb456bcbd06f8$var$kh) {
                const n = new Uint8Array(t1, 12 + r, e);
                this.content = $fd4eb456bcbd06f8$var$Do.decodeText(n);
            } else if (n === $fd4eb456bcbd06f8$var$Bh) {
                const n = 12 + r;
                this.body = t1.slice(n, n + e);
            }
            r += e;
        }
        if (null === this.content) throw new Error("THREE.GLTFLoader: JSON content not found.");
    }
}
class $fd4eb456bcbd06f8$var$Hh {
    constructor(t1, e){
        if (!e) throw new Error("THREE.GLTFLoader: No DRACOLoader instance provided.");
        this.name = $fd4eb456bcbd06f8$var$Th.KHR_DRACO_MESH_COMPRESSION, this.json = t1, this.dracoLoader = e, this.dracoLoader.preload();
    }
    decodePrimitive(t1, e) {
        const n = this.json, i = this.dracoLoader, r = t1.extensions[this.name].bufferView, s = t1.extensions[this.name].attributes, a = {}, o = {}, l = {};
        for(const t1 in s){
            const e = $fd4eb456bcbd06f8$var$ac[t1] || t1.toLowerCase();
            a[e] = s[t1];
        }
        for(const e in t1.attributes){
            const i = $fd4eb456bcbd06f8$var$ac[e] || e.toLowerCase();
            if (void 0 !== s[e]) {
                const r = n.accessors[t1.attributes[e]], s = $fd4eb456bcbd06f8$var$nc[r.componentType];
                l[i] = s, o[i] = !0 === r.normalized;
            }
        }
        return e.getDependency("bufferView", r).then(function(t1) {
            return new Promise(function(e) {
                i.decodeDracoFile(t1, function(t1) {
                    for(const e in t1.attributes){
                        const n = t1.attributes[e], i = o[e];
                        void 0 !== i && (n.normalized = i);
                    }
                    e(t1);
                }, a, l);
            });
        });
    }
}
class $fd4eb456bcbd06f8$var$Vh {
    constructor(){
        this.name = $fd4eb456bcbd06f8$var$Th.KHR_TEXTURE_TRANSFORM;
    }
    extendTexture(t1, e) {
        return void 0 !== e.texCoord && console.warn('THREE.GLTFLoader: Custom UV sets in "' + this.name + '" extension not yet supported.'), void 0 === e.offset && void 0 === e.rotation && void 0 === e.scale || (t1 = t1.clone(), void 0 !== e.offset && t1.offset.fromArray(e.offset), void 0 !== e.rotation && (t1.rotation = e.rotation), void 0 !== e.scale && t1.repeat.fromArray(e.scale), t1.needsUpdate = !0), t1;
    }
}
class $fd4eb456bcbd06f8$var$Gh extends $fd4eb456bcbd06f8$var$Fa {
    constructor(t1){
        super(), this.isGLTFSpecularGlossinessMaterial = !0;
        const e = [
            "#ifdef USE_SPECULARMAP",
            "\tuniform sampler2D specularMap;",
            "#endif"
        ].join("\n"), n = [
            "#ifdef USE_GLOSSINESSMAP",
            "\tuniform sampler2D glossinessMap;",
            "#endif"
        ].join("\n"), i = [
            "vec3 specularFactor = specular;",
            "#ifdef USE_SPECULARMAP",
            "\tvec4 texelSpecular = texture2D( specularMap, vUv );",
            "\t// reads channel RGB, compatible with a glTF Specular-Glossiness (RGBA) texture",
            "\tspecularFactor *= texelSpecular.rgb;",
            "#endif"
        ].join("\n"), r = [
            "float glossinessFactor = glossiness;",
            "#ifdef USE_GLOSSINESSMAP",
            "\tvec4 texelGlossiness = texture2D( glossinessMap, vUv );",
            "\t// reads channel A, compatible with a glTF Specular-Glossiness (RGBA) texture",
            "\tglossinessFactor *= texelGlossiness.a;",
            "#endif"
        ].join("\n"), s = [
            "PhysicalMaterial material;",
            "material.diffuseColor = diffuseColor.rgb * ( 1. - max( specularFactor.r, max( specularFactor.g, specularFactor.b ) ) );",
            "vec3 dxy = max( abs( dFdx( geometryNormal ) ), abs( dFdy( geometryNormal ) ) );",
            "float geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );",
            "material.roughness = max( 1.0 - glossinessFactor, 0.0525 ); // 0.0525 corresponds to the base mip of a 256 cubemap.",
            "material.roughness += geometryRoughness;",
            "material.roughness = min( material.roughness, 1.0 );",
            "material.specularColor = specularFactor;"
        ].join("\n"), a = {
            specular: {
                value: (new $fd4eb456bcbd06f8$var$L).setHex(16777215)
            },
            glossiness: {
                value: 1
            },
            specularMap: {
                value: null
            },
            glossinessMap: {
                value: null
            }
        };
        this._extraUniforms = a, this.onBeforeCompile = function(t1) {
            for(const e in a)t1.uniforms[e] = a[e];
            t1.fragmentShader = t1.fragmentShader.replace("uniform float roughness;", "uniform vec3 specular;").replace("uniform float metalness;", "uniform float glossiness;").replace("#include <roughnessmap_pars_fragment>", e).replace("#include <metalnessmap_pars_fragment>", n).replace("#include <roughnessmap_fragment>", i).replace("#include <metalnessmap_fragment>", r).replace("#include <lights_physical_fragment>", s);
        }, Object.defineProperties(this, {
            specular: {
                get: function() {
                    return a.specular.value;
                },
                set: function(t1) {
                    a.specular.value = t1;
                }
            },
            specularMap: {
                get: function() {
                    return a.specularMap.value;
                },
                set: function(t1) {
                    a.specularMap.value = t1, t1 ? this.defines.USE_SPECULARMAP = "" : delete this.defines.USE_SPECULARMAP;
                }
            },
            glossiness: {
                get: function() {
                    return a.glossiness.value;
                },
                set: function(t1) {
                    a.glossiness.value = t1;
                }
            },
            glossinessMap: {
                get: function() {
                    return a.glossinessMap.value;
                },
                set: function(t1) {
                    a.glossinessMap.value = t1, t1 ? (this.defines.USE_GLOSSINESSMAP = "", this.defines.USE_UV = "") : (delete this.defines.USE_GLOSSINESSMAP, delete this.defines.USE_UV);
                }
            }
        }), delete this.metalness, delete this.roughness, delete this.metalnessMap, delete this.roughnessMap, this.setValues(t1);
    }
    copy(t1) {
        return super.copy(t1), this.specularMap = t1.specularMap, this.specular.copy(t1.specular), this.glossinessMap = t1.glossinessMap, this.glossiness = t1.glossiness, delete this.metalness, delete this.roughness, delete this.metalnessMap, delete this.roughnessMap, this;
    }
}
class $fd4eb456bcbd06f8$var$Wh {
    constructor(){
        this.name = $fd4eb456bcbd06f8$var$Th.KHR_MATERIALS_PBR_SPECULAR_GLOSSINESS, this.specularGlossinessParams = [
            "color",
            "map",
            "lightMap",
            "lightMapIntensity",
            "aoMap",
            "aoMapIntensity",
            "emissive",
            "emissiveIntensity",
            "emissiveMap",
            "bumpMap",
            "bumpScale",
            "normalMap",
            "normalMapType",
            "displacementMap",
            "displacementScale",
            "displacementBias",
            "specularMap",
            "specular",
            "glossinessMap",
            "glossiness",
            "alphaMap",
            "envMap",
            "envMapIntensity"
        ];
    }
    getMaterialType() {
        return $fd4eb456bcbd06f8$var$Gh;
    }
    extendParams(t1, e, n) {
        const i = e.extensions[this.name];
        t1.color = new $fd4eb456bcbd06f8$var$L(1, 1, 1), t1.opacity = 1;
        const r = [];
        if (Array.isArray(i.diffuseFactor)) {
            const e = i.diffuseFactor;
            t1.color.fromArray(e), t1.opacity = e[3];
        }
        if (void 0 !== i.diffuseTexture && r.push(n.assignTexture(t1, "map", i.diffuseTexture, 3001)), t1.emissive = new $fd4eb456bcbd06f8$var$L(0, 0, 0), t1.glossiness = void 0 !== i.glossinessFactor ? i.glossinessFactor : 1, t1.specular = new $fd4eb456bcbd06f8$var$L(1, 1, 1), Array.isArray(i.specularFactor) && t1.specular.fromArray(i.specularFactor), void 0 !== i.specularGlossinessTexture) {
            const e = i.specularGlossinessTexture;
            r.push(n.assignTexture(t1, "glossinessMap", e)), r.push(n.assignTexture(t1, "specularMap", e, 3001));
        }
        return Promise.all(r);
    }
    createMaterial(t1) {
        const e = new $fd4eb456bcbd06f8$var$Gh(t1);
        return e.fog = !0, e.color = t1.color, e.map = void 0 === t1.map ? null : t1.map, e.lightMap = null, e.lightMapIntensity = 1, e.aoMap = void 0 === t1.aoMap ? null : t1.aoMap, e.aoMapIntensity = 1, e.emissive = t1.emissive, e.emissiveIntensity = 1, e.emissiveMap = void 0 === t1.emissiveMap ? null : t1.emissiveMap, e.bumpMap = void 0 === t1.bumpMap ? null : t1.bumpMap, e.bumpScale = 1, e.normalMap = void 0 === t1.normalMap ? null : t1.normalMap, e.normalMapType = 0, t1.normalScale && (e.normalScale = t1.normalScale), e.displacementMap = null, e.displacementScale = 1, e.displacementBias = 0, e.specularMap = void 0 === t1.specularMap ? null : t1.specularMap, e.specular = t1.specular, e.glossinessMap = void 0 === t1.glossinessMap ? null : t1.glossinessMap, e.glossiness = t1.glossiness, e.alphaMap = null, e.envMap = void 0 === t1.envMap ? null : t1.envMap, e.envMapIntensity = 1, e;
    }
}
class $fd4eb456bcbd06f8$var$jh {
    constructor(){
        this.name = $fd4eb456bcbd06f8$var$Th.KHR_MESH_QUANTIZATION;
    }
}
class $fd4eb456bcbd06f8$var$qh extends $fd4eb456bcbd06f8$var$qa {
    constructor(t1, e, n, i){
        super(t1, e, n, i);
    }
    copySampleValue_(t1) {
        const e = this.resultBuffer, n = this.sampleValues, i = this.valueSize, r = t1 * i * 3 + i;
        for(let t1 = 0; t1 !== i; t1++)e[t1] = n[r + t1];
        return e;
    }
}
$fd4eb456bcbd06f8$var$qh.prototype.beforeStart_ = $fd4eb456bcbd06f8$var$qh.prototype.copySampleValue_, $fd4eb456bcbd06f8$var$qh.prototype.afterEnd_ = $fd4eb456bcbd06f8$var$qh.prototype.copySampleValue_, $fd4eb456bcbd06f8$var$qh.prototype.interpolate_ = function(t1, e, n, i) {
    const r = this.resultBuffer, s = this.sampleValues, a = this.valueSize, o = 2 * a, l = 3 * a, h = i - e, c = (n - e) / h, u = c * c, d = u * c, p = t1 * l, m = p - l, f = -2 * d + 3 * u, g = d - u, v = 1 - f, y = g - u + c;
    for(let t1 = 0; t1 !== a; t1++){
        const e = s[m + t1 + a], n = s[m + t1 + o] * h, i = s[p + t1 + a], l = s[p + t1] * h;
        r[t1] = v * e + y * n + f * i + g * l;
    }
    return r;
};
const $fd4eb456bcbd06f8$var$Xh = new $fd4eb456bcbd06f8$var$H;
class $fd4eb456bcbd06f8$var$$h extends $fd4eb456bcbd06f8$var$qh {
    interpolate_(t1, e, n, i) {
        const r = super.interpolate_(t1, e, n, i);
        return $fd4eb456bcbd06f8$var$Xh.fromArray(r).normalize().toArray(r), r;
    }
}
const $fd4eb456bcbd06f8$var$Yh = 0, $fd4eb456bcbd06f8$var$Jh = 1, $fd4eb456bcbd06f8$var$Kh = 2, $fd4eb456bcbd06f8$var$Zh = 3, $fd4eb456bcbd06f8$var$Qh = 4, $fd4eb456bcbd06f8$var$tc = 5, $fd4eb456bcbd06f8$var$ec = 6, $fd4eb456bcbd06f8$var$nc = {
    5120: Int8Array,
    5121: Uint8Array,
    5122: Int16Array,
    5123: Uint16Array,
    5125: Uint32Array,
    5126: Float32Array
}, $fd4eb456bcbd06f8$var$ic = {
    9728: 1003,
    9729: 1006,
    9984: 1004,
    9985: 1007,
    9986: 1005,
    9987: 1008
}, $fd4eb456bcbd06f8$var$rc = {
    33071: 1001,
    33648: 1002,
    10497: 1e3
}, $fd4eb456bcbd06f8$var$sc = {
    SCALAR: 1,
    VEC2: 2,
    VEC3: 3,
    VEC4: 4,
    MAT2: 4,
    MAT3: 9,
    MAT4: 16
}, $fd4eb456bcbd06f8$var$ac = {
    POSITION: "position",
    NORMAL: "normal",
    TANGENT: "tangent",
    TEXCOORD_0: "uv",
    TEXCOORD_1: "uv2",
    COLOR_0: "color",
    WEIGHTS_0: "skinWeight",
    JOINTS_0: "skinIndex"
}, $fd4eb456bcbd06f8$var$oc = {
    scale: "scale",
    translation: "position",
    rotation: "quaternion",
    weights: "morphTargetInfluences"
}, $fd4eb456bcbd06f8$var$lc = {
    CUBICSPLINE: void 0,
    LINEAR: 2301,
    STEP: 2300
}, $fd4eb456bcbd06f8$var$hc = "OPAQUE", $fd4eb456bcbd06f8$var$cc = "MASK", $fd4eb456bcbd06f8$var$uc = "BLEND";
function $fd4eb456bcbd06f8$var$dc(t1) {
    return void 0 === t1.DefaultMaterial && (t1.DefaultMaterial = new $fd4eb456bcbd06f8$var$Fa({
        color: 16777215,
        emissive: 0,
        metalness: 1,
        roughness: 1,
        transparent: !1,
        depthTest: !0,
        side: 0
    })), t1.DefaultMaterial;
}
function $fd4eb456bcbd06f8$var$pc(t1, e, n) {
    for(const i in n.extensions)void 0 === t1[i] && (e.userData.gltfExtensions = e.userData.gltfExtensions || {}, e.userData.gltfExtensions[i] = n.extensions[i]);
}
function $fd4eb456bcbd06f8$var$mc(t1, e) {
    void 0 !== e.extras && ("object" == typeof e.extras ? Object.assign(t1.userData, e.extras) : console.warn("THREE.GLTFLoader: Ignoring primitive type .extras, " + e.extras));
}
function $fd4eb456bcbd06f8$var$fc(t1, e) {
    if (t1.updateMorphTargets(), void 0 !== e.weights) for(let n = 0, i = e.weights.length; n < i; n++)t1.morphTargetInfluences[n] = e.weights[n];
    if (e.extras && Array.isArray(e.extras.targetNames)) {
        const n = e.extras.targetNames;
        if (t1.morphTargetInfluences.length === n.length) {
            t1.morphTargetDictionary = {};
            for(let e = 0, i = n.length; e < i; e++)t1.morphTargetDictionary[n[e]] = e;
        } else console.warn("THREE.GLTFLoader: Invalid extras.targetNames length. Ignoring names.");
    }
}
function $fd4eb456bcbd06f8$var$gc(t1) {
    const e = t1.extensions && t1.extensions[$fd4eb456bcbd06f8$var$Th.KHR_DRACO_MESH_COMPRESSION];
    let n;
    return n = e ? "draco:" + e.bufferView + ":" + e.indices + ":" + $fd4eb456bcbd06f8$var$vc(e.attributes) : t1.indices + ":" + $fd4eb456bcbd06f8$var$vc(t1.attributes) + ":" + t1.mode, n;
}
function $fd4eb456bcbd06f8$var$vc(t1) {
    let e = "";
    const n = Object.keys(t1).sort();
    for(let i = 0, r = n.length; i < r; i++)e += n[i] + ":" + t1[n[i]] + ";";
    return e;
}
function $fd4eb456bcbd06f8$var$yc(t1) {
    switch(t1){
        case Int8Array:
            return 1 / 127;
        case Uint8Array:
            return 1 / 255;
        case Int16Array:
            return 1 / 32767;
        case Uint16Array:
            return 1 / 65535;
        default:
            throw new Error("THREE.GLTFLoader: Unsupported normalized accessor component type.");
    }
}
class $fd4eb456bcbd06f8$var$xc {
    constructor(t1 = {}, e = {}){
        this.json = t1, this.extensions = {}, this.plugins = {}, this.options = e, this.cache = new $fd4eb456bcbd06f8$var$Sh, this.associations = new Map, this.primitiveCache = {}, this.meshCache = {
            refs: {},
            uses: {}
        }, this.cameraCache = {
            refs: {},
            uses: {}
        }, this.lightCache = {
            refs: {},
            uses: {}
        }, this.sourceCache = {}, this.textureCache = {}, this.nodeNamesUsed = {}, "undefined" != typeof createImageBitmap && !1 === /^((?!chrome|android).)*safari/i.test(navigator.userAgent) ? this.textureLoader = new $fd4eb456bcbd06f8$var$Io(this.options.manager) : this.textureLoader = new $fd4eb456bcbd06f8$var$fo(this.options.manager), this.textureLoader.setCrossOrigin(this.options.crossOrigin), this.textureLoader.setRequestHeader(this.options.requestHeader), this.fileLoader = new $fd4eb456bcbd06f8$var$co(this.options.manager), this.fileLoader.setResponseType("arraybuffer"), "use-credentials" === this.options.crossOrigin && this.fileLoader.setWithCredentials(!0);
    }
    setExtensions(t1) {
        this.extensions = t1;
    }
    setPlugins(t1) {
        this.plugins = t1;
    }
    parse(t1, e) {
        const n = this, i = this.json, r = this.extensions;
        this.cache.removeAll(), this._invokeAll(function(t1) {
            return t1._markDefs && t1._markDefs();
        }), Promise.all(this._invokeAll(function(t1) {
            return t1.beforeRoot && t1.beforeRoot();
        })).then(function() {
            return Promise.all([
                n.getDependencies("scene"),
                n.getDependencies("animation"),
                n.getDependencies("camera")
            ]);
        }).then(function(e) {
            const s = {
                scene: e[0][i.scene || 0],
                scenes: e[0],
                animations: e[1],
                cameras: e[2],
                asset: i.asset,
                parser: n,
                userData: {}
            };
            $fd4eb456bcbd06f8$var$pc(r, s, i), $fd4eb456bcbd06f8$var$mc(s, i), Promise.all(n._invokeAll(function(t1) {
                return t1.afterRoot && t1.afterRoot(s);
            })).then(function() {
                t1(s);
            });
        }).catch(e);
    }
    _markDefs() {
        const t1 = this.json.nodes || [], e = this.json.skins || [], n = this.json.meshes || [];
        for(let n = 0, i = e.length; n < i; n++){
            const i = e[n].joints;
            for(let e = 0, n = i.length; e < n; e++)t1[i[e]].isBone = !0;
        }
        for(let e = 0, i = t1.length; e < i; e++){
            const i = t1[e];
            void 0 !== i.mesh && (this._addNodeRef(this.meshCache, i.mesh), void 0 !== i.skin && (n[i.mesh].isSkinnedMesh = !0)), void 0 !== i.camera && this._addNodeRef(this.cameraCache, i.camera);
        }
    }
    _addNodeRef(t1, e) {
        void 0 !== e && (void 0 === t1.refs[e] && (t1.refs[e] = t1.uses[e] = 0), t1.refs[e]++);
    }
    _getNodeRef(t1, e, n) {
        if (t1.refs[e] <= 1) return n;
        const i = n.clone(), r = (t1, e)=>{
            const n = this.associations.get(t1);
            null != n && this.associations.set(e, n);
            for (const [n, i] of t1.children.entries())r(i, e.children[n]);
        };
        return r(n, i), i.name += "_instance_" + t1.uses[e]++, i;
    }
    _invokeOne(t1) {
        const e = Object.values(this.plugins);
        e.push(this);
        for(let n = 0; n < e.length; n++){
            const i = t1(e[n]);
            if (i) return i;
        }
        return null;
    }
    _invokeAll(t1) {
        const e = Object.values(this.plugins);
        e.unshift(this);
        const n = [];
        for(let i = 0; i < e.length; i++){
            const r = t1(e[i]);
            r && n.push(r);
        }
        return n;
    }
    getDependency(t1, e) {
        const n = t1 + ":" + e;
        let i = this.cache.get(n);
        if (!i) {
            switch(t1){
                case "scene":
                    i = this.loadScene(e);
                    break;
                case "node":
                    i = this.loadNode(e);
                    break;
                case "mesh":
                    i = this._invokeOne(function(t1) {
                        return t1.loadMesh && t1.loadMesh(e);
                    });
                    break;
                case "accessor":
                    i = this.loadAccessor(e);
                    break;
                case "bufferView":
                    i = this._invokeOne(function(t1) {
                        return t1.loadBufferView && t1.loadBufferView(e);
                    });
                    break;
                case "buffer":
                    i = this.loadBuffer(e);
                    break;
                case "material":
                    i = this._invokeOne(function(t1) {
                        return t1.loadMaterial && t1.loadMaterial(e);
                    });
                    break;
                case "texture":
                    i = this._invokeOne(function(t1) {
                        return t1.loadTexture && t1.loadTexture(e);
                    });
                    break;
                case "skin":
                    i = this.loadSkin(e);
                    break;
                case "animation":
                    i = this.loadAnimation(e);
                    break;
                case "camera":
                    i = this.loadCamera(e);
                    break;
                default:
                    throw new Error("Unknown type: " + t1);
            }
            this.cache.add(n, i);
        }
        return i;
    }
    getDependencies(t1) {
        let e = this.cache.get(t1);
        if (!e) {
            const n = this, i = this.json[t1 + ("mesh" === t1 ? "es" : "s")] || [];
            e = Promise.all(i.map(function(e, i) {
                return n.getDependency(t1, i);
            })), this.cache.add(t1, e);
        }
        return e;
    }
    loadBuffer(t1) {
        const e = this.json.buffers[t1], n = this.fileLoader;
        if (e.type && "arraybuffer" !== e.type) throw new Error("THREE.GLTFLoader: " + e.type + " buffer type is not supported.");
        if (void 0 === e.uri && 0 === t1) return Promise.resolve(this.extensions[$fd4eb456bcbd06f8$var$Th.KHR_BINARY_GLTF].body);
        const i = this.options;
        return new Promise(function(t1, r) {
            n.load($fd4eb456bcbd06f8$var$Do.resolveURL(e.uri, i.path), t1, void 0, function() {
                r(new Error('THREE.GLTFLoader: Failed to load buffer "' + e.uri + '".'));
            });
        });
    }
    loadBufferView(t1) {
        const e = this.json.bufferViews[t1];
        return this.getDependency("buffer", e.buffer).then(function(t1) {
            const n = e.byteLength || 0, i = e.byteOffset || 0;
            return t1.slice(i, i + n);
        });
    }
    loadAccessor(t1) {
        const e = this, n = this.json, i = this.json.accessors[t1];
        if (void 0 === i.bufferView && void 0 === i.sparse) return Promise.resolve(null);
        const r = [];
        return void 0 !== i.bufferView ? r.push(this.getDependency("bufferView", i.bufferView)) : r.push(null), void 0 !== i.sparse && (r.push(this.getDependency("bufferView", i.sparse.indices.bufferView)), r.push(this.getDependency("bufferView", i.sparse.values.bufferView))), Promise.all(r).then(function(t1) {
            const r = t1[0], s = $fd4eb456bcbd06f8$var$sc[i.type], a = $fd4eb456bcbd06f8$var$nc[i.componentType], o = a.BYTES_PER_ELEMENT, l = o * s, h = i.byteOffset || 0, c = void 0 !== i.bufferView ? n.bufferViews[i.bufferView].byteStride : void 0, u = !0 === i.normalized;
            let d, p;
            if (c && c !== l) {
                const t1 = Math.floor(h / c), n = "InterleavedBuffer:" + i.bufferView + ":" + i.componentType + ":" + t1 + ":" + i.count;
                let l = e.cache.get(n);
                l || (d = new a(r, t1 * c, i.count * c / o), l = new $fd4eb456bcbd06f8$var$Fr(d, c / o), e.cache.add(n, l)), p = new $fd4eb456bcbd06f8$var$kr(l, s, h % c / o, u);
            } else d = null === r ? new a(i.count * s) : new a(r, h, i.count * s), p = new $fd4eb456bcbd06f8$var$oe(d, s, u);
            if (void 0 !== i.sparse) {
                const e = $fd4eb456bcbd06f8$var$sc.SCALAR, n = $fd4eb456bcbd06f8$var$nc[i.sparse.indices.componentType], o = i.sparse.indices.byteOffset || 0, l = i.sparse.values.byteOffset || 0, h = new n(t1[1], o, i.sparse.count * e), c = new a(t1[2], l, i.sparse.count * s);
                null !== r && (p = new $fd4eb456bcbd06f8$var$oe(p.array.slice(), p.itemSize, p.normalized));
                for(let t1 = 0, e = h.length; t1 < e; t1++){
                    const e = h[t1];
                    if (p.setX(e, c[t1 * s]), s >= 2 && p.setY(e, c[t1 * s + 1]), s >= 3 && p.setZ(e, c[t1 * s + 2]), s >= 4 && p.setW(e, c[t1 * s + 3]), s >= 5) throw new Error("THREE.GLTFLoader: Unsupported itemSize in sparse BufferAttribute.");
                }
            }
            return p;
        });
    }
    loadTexture(t1) {
        const e = this.json, n = this.options, i = e.textures[t1].source, r = e.images[i];
        let s = this.textureLoader;
        if (r.uri) {
            const t1 = n.manager.getHandler(r.uri);
            null !== t1 && (s = t1);
        }
        return this.loadTextureImage(t1, i, s);
    }
    loadTextureImage(t1, e, n) {
        const i = this, r = this.json, s = r.textures[t1], a = r.images[e], o = (a.uri || a.bufferView) + ":" + s.sampler;
        if (this.textureCache[o]) return this.textureCache[o];
        const l = this.loadImageSource(e, n).then(function(e) {
            e.flipY = !1, s.name && (e.name = s.name);
            const n = (r.samplers || {})[s.sampler] || {};
            return e.magFilter = $fd4eb456bcbd06f8$var$ic[n.magFilter] || 1006, e.minFilter = $fd4eb456bcbd06f8$var$ic[n.minFilter] || 1008, e.wrapS = $fd4eb456bcbd06f8$var$rc[n.wrapS] || 1e3, e.wrapT = $fd4eb456bcbd06f8$var$rc[n.wrapT] || 1e3, i.associations.set(e, {
                textures: t1
            }), e;
        }).catch(function() {
            return null;
        });
        return this.textureCache[o] = l, l;
    }
    loadImageSource(t1, e) {
        const n = this, i = this.json, r = this.options;
        if (void 0 !== this.sourceCache[t1]) return this.sourceCache[t1].then((t1)=>t1.clone());
        const s = i.images[t1], a = self.URL || self.webkitURL;
        let o = s.uri || "", l = !1;
        if (void 0 !== s.bufferView) o = n.getDependency("bufferView", s.bufferView).then(function(t1) {
            l = !0;
            const e = new Blob([
                t1
            ], {
                type: s.mimeType
            });
            return o = a.createObjectURL(e), o;
        });
        else if (void 0 === s.uri) throw new Error("THREE.GLTFLoader: Image " + t1 + " is missing URI and bufferView");
        const h = Promise.resolve(o).then(function(t1) {
            return new Promise(function(n, i) {
                let s = n;
                !0 === e.isImageBitmapLoader && (s = function(t1) {
                    const e = new $fd4eb456bcbd06f8$var$F(t1);
                    e.needsUpdate = !0, n(e);
                }), e.load($fd4eb456bcbd06f8$var$Do.resolveURL(t1, r.path), s, void 0, i);
            });
        }).then(function(t1) {
            var e;
            return !0 === l && a.revokeObjectURL(o), t1.userData.mimeType = s.mimeType || ((e = s.uri).search(/\.jpe?g($|\?)/i) > 0 || 0 === e.search(/^data\:image\/jpeg/) ? "image/jpeg" : e.search(/\.webp($|\?)/i) > 0 || 0 === e.search(/^data\:image\/webp/) ? "image/webp" : "image/png"), t1;
        }).catch(function(t1) {
            throw console.error("THREE.GLTFLoader: Couldn't load texture", o), t1;
        });
        return this.sourceCache[t1] = h, h;
    }
    assignTexture(t1, e, n, i) {
        const r = this;
        return this.getDependency("texture", n.index).then(function(s) {
            if (void 0 === n.texCoord || 0 == n.texCoord || "aoMap" === e && 1 == n.texCoord || console.warn("THREE.GLTFLoader: Custom UV set " + n.texCoord + " for texture " + e + " not yet supported."), r.extensions[$fd4eb456bcbd06f8$var$Th.KHR_TEXTURE_TRANSFORM]) {
                const t1 = void 0 !== n.extensions ? n.extensions[$fd4eb456bcbd06f8$var$Th.KHR_TEXTURE_TRANSFORM] : void 0;
                if (t1) {
                    const e = r.associations.get(s);
                    s = r.extensions[$fd4eb456bcbd06f8$var$Th.KHR_TEXTURE_TRANSFORM].extendTexture(s, t1), r.associations.set(s, e);
                }
            }
            return void 0 !== i && (s.encoding = i), t1[e] = s, s;
        });
    }
    assignFinalMaterial(t1) {
        const e = t1.geometry;
        let n = t1.material;
        const i = void 0 === e.attributes.tangent, r = void 0 !== e.attributes.color, s = void 0 === e.attributes.normal;
        if (t1.isPoints) {
            const t1 = "PointsMaterial:" + n.uuid;
            let e = this.cache.get(t1);
            e || (e = new $fd4eb456bcbd06f8$var$As, $fd4eb456bcbd06f8$var$ie.prototype.copy.call(e, n), e.color.copy(n.color), e.map = n.map, e.sizeAttenuation = !1, this.cache.add(t1, e)), n = e;
        } else if (t1.isLine) {
            const t1 = "LineBasicMaterial:" + n.uuid;
            let e = this.cache.get(t1);
            e || (e = new $fd4eb456bcbd06f8$var$gs, $fd4eb456bcbd06f8$var$ie.prototype.copy.call(e, n), e.color.copy(n.color), this.cache.add(t1, e)), n = e;
        }
        if (i || r || s) {
            let t1 = "ClonedMaterial:" + n.uuid + ":";
            n.isGLTFSpecularGlossinessMaterial && (t1 += "specular-glossiness:"), i && (t1 += "derivative-tangents:"), r && (t1 += "vertex-colors:"), s && (t1 += "flat-shading:");
            let e = this.cache.get(t1);
            e || (e = n.clone(), r && (e.vertexColors = !0), s && (e.flatShading = !0), i && (e.normalScale && (e.normalScale.y *= -1), e.clearcoatNormalScale && (e.clearcoatNormalScale.y *= -1)), this.cache.add(t1, e), this.associations.set(e, this.associations.get(n))), n = e;
        }
        n.aoMap && void 0 === e.attributes.uv2 && void 0 !== e.attributes.uv && e.setAttribute("uv2", e.attributes.uv), t1.material = n;
    }
    getMaterialType() {
        return $fd4eb456bcbd06f8$var$Fa;
    }
    loadMaterial(t1) {
        const e = this, n = this.json, i = this.extensions, r = n.materials[t1];
        let s;
        const a = {}, o = r.extensions || {}, l = [];
        if (o[$fd4eb456bcbd06f8$var$Th.KHR_MATERIALS_PBR_SPECULAR_GLOSSINESS]) {
            const t1 = i[$fd4eb456bcbd06f8$var$Th.KHR_MATERIALS_PBR_SPECULAR_GLOSSINESS];
            s = t1.getMaterialType(), l.push(t1.extendParams(a, r, e));
        } else if (o[$fd4eb456bcbd06f8$var$Th.KHR_MATERIALS_UNLIT]) {
            const t1 = i[$fd4eb456bcbd06f8$var$Th.KHR_MATERIALS_UNLIT];
            s = t1.getMaterialType(), l.push(t1.extendParams(a, r, e));
        } else {
            const n = r.pbrMetallicRoughness || {};
            if (a.color = new $fd4eb456bcbd06f8$var$L(1, 1, 1), a.opacity = 1, Array.isArray(n.baseColorFactor)) {
                const t1 = n.baseColorFactor;
                a.color.fromArray(t1), a.opacity = t1[3];
            }
            void 0 !== n.baseColorTexture && l.push(e.assignTexture(a, "map", n.baseColorTexture, 3001)), a.metalness = void 0 !== n.metallicFactor ? n.metallicFactor : 1, a.roughness = void 0 !== n.roughnessFactor ? n.roughnessFactor : 1, void 0 !== n.metallicRoughnessTexture && (l.push(e.assignTexture(a, "metalnessMap", n.metallicRoughnessTexture)), l.push(e.assignTexture(a, "roughnessMap", n.metallicRoughnessTexture))), s = this._invokeOne(function(e) {
                return e.getMaterialType && e.getMaterialType(t1);
            }), l.push(Promise.all(this._invokeAll(function(e) {
                return e.extendMaterialParams && e.extendMaterialParams(t1, a);
            })));
        }
        !0 === r.doubleSided && (a.side = 2);
        const h = r.alphaMode || $fd4eb456bcbd06f8$var$hc;
        if (h === $fd4eb456bcbd06f8$var$uc ? (a.transparent = !0, a.depthWrite = !1) : (a.transparent = !1, h === $fd4eb456bcbd06f8$var$cc && (a.alphaTest = void 0 !== r.alphaCutoff ? r.alphaCutoff : .5)), void 0 !== r.normalTexture && s !== $fd4eb456bcbd06f8$var$re && (l.push(e.assignTexture(a, "normalMap", r.normalTexture)), a.normalScale = new $fd4eb456bcbd06f8$var$g(1, 1), void 0 !== r.normalTexture.scale)) {
            const t1 = r.normalTexture.scale;
            a.normalScale.set(t1, t1);
        }
        return void 0 !== r.occlusionTexture && s !== $fd4eb456bcbd06f8$var$re && (l.push(e.assignTexture(a, "aoMap", r.occlusionTexture)), void 0 !== r.occlusionTexture.strength && (a.aoMapIntensity = r.occlusionTexture.strength)), void 0 !== r.emissiveFactor && s !== $fd4eb456bcbd06f8$var$re && (a.emissive = (new $fd4eb456bcbd06f8$var$L).fromArray(r.emissiveFactor)), void 0 !== r.emissiveTexture && s !== $fd4eb456bcbd06f8$var$re && l.push(e.assignTexture(a, "emissiveMap", r.emissiveTexture, 3001)), Promise.all(l).then(function() {
            let n;
            return n = s === $fd4eb456bcbd06f8$var$Gh ? i[$fd4eb456bcbd06f8$var$Th.KHR_MATERIALS_PBR_SPECULAR_GLOSSINESS].createMaterial(a) : new s(a), r.name && (n.name = r.name), $fd4eb456bcbd06f8$var$mc(n, r), e.associations.set(n, {
                materials: t1
            }), r.extensions && $fd4eb456bcbd06f8$var$pc(i, n, r), n;
        });
    }
    createUniqueName(t1) {
        const e = $fd4eb456bcbd06f8$var$qo.sanitizeNodeName(t1 || "");
        let n = e;
        for(let t1 = 1; this.nodeNamesUsed[n]; ++t1)n = e + "_" + t1;
        return this.nodeNamesUsed[n] = !0, n;
    }
    loadGeometries(t1) {
        const e = this, n = this.extensions, i = this.primitiveCache;
        function r(t1) {
            return n[$fd4eb456bcbd06f8$var$Th.KHR_DRACO_MESH_COMPRESSION].decodePrimitive(t1, e).then(function(n) {
                return $fd4eb456bcbd06f8$var$_c(n, t1, e);
            });
        }
        const s = [];
        for(let n = 0, a = t1.length; n < a; n++){
            const a = t1[n], o = $fd4eb456bcbd06f8$var$gc(a), l = i[o];
            if (l) s.push(l.promise);
            else {
                let t1;
                t1 = a.extensions && a.extensions[$fd4eb456bcbd06f8$var$Th.KHR_DRACO_MESH_COMPRESSION] ? r(a) : $fd4eb456bcbd06f8$var$_c(new $fd4eb456bcbd06f8$var$ye, a, e), i[o] = {
                    primitive: a,
                    promise: t1
                }, s.push(t1);
            }
        }
        return Promise.all(s);
    }
    loadMesh(t1) {
        const e = this, n = this.json, i = this.extensions, r = n.meshes[t1], s = r.primitives, a = [];
        for(let t1 = 0, e = s.length; t1 < e; t1++){
            const e = void 0 === s[t1].material ? $fd4eb456bcbd06f8$var$dc(this.cache) : this.getDependency("material", s[t1].material);
            a.push(e);
        }
        return a.push(e.loadGeometries(s)), Promise.all(a).then(function(n) {
            const a = n.slice(0, n.length - 1), o = n[n.length - 1], l = [];
            for(let n = 0, h = o.length; n < h; n++){
                const h = o[n], c = s[n];
                let u;
                const d = a[n];
                if (c.mode === $fd4eb456bcbd06f8$var$Qh || c.mode === $fd4eb456bcbd06f8$var$tc || c.mode === $fd4eb456bcbd06f8$var$ec || void 0 === c.mode) u = !0 === r.isSkinnedMesh ? new $fd4eb456bcbd06f8$var$ss(h, d) : new $fd4eb456bcbd06f8$var$Fe(h, d), !0 !== u.isSkinnedMesh || u.geometry.attributes.skinWeight.normalized || u.normalizeSkinWeights(), c.mode === $fd4eb456bcbd06f8$var$tc ? u.geometry = $fd4eb456bcbd06f8$var$wc(u.geometry, 1) : c.mode === $fd4eb456bcbd06f8$var$ec && (u.geometry = $fd4eb456bcbd06f8$var$wc(u.geometry, 2));
                else if (c.mode === $fd4eb456bcbd06f8$var$Jh) u = new $fd4eb456bcbd06f8$var$Ts(h, d);
                else if (c.mode === $fd4eb456bcbd06f8$var$Zh) u = new $fd4eb456bcbd06f8$var$ws(h, d);
                else if (c.mode === $fd4eb456bcbd06f8$var$Kh) u = new $fd4eb456bcbd06f8$var$Es(h, d);
                else {
                    if (c.mode !== $fd4eb456bcbd06f8$var$Yh) throw new Error("THREE.GLTFLoader: Primitive mode unsupported: " + c.mode);
                    u = new $fd4eb456bcbd06f8$var$Ds(h, d);
                }
                Object.keys(u.geometry.morphAttributes).length > 0 && $fd4eb456bcbd06f8$var$fc(u, r), u.name = e.createUniqueName(r.name || "mesh_" + t1), $fd4eb456bcbd06f8$var$mc(u, r), c.extensions && $fd4eb456bcbd06f8$var$pc(i, u, c), e.assignFinalMaterial(u), l.push(u);
            }
            for(let n = 0, i = l.length; n < i; n++)e.associations.set(l[n], {
                meshes: t1,
                primitives: n
            });
            if (1 === l.length) return l[0];
            const h = new $fd4eb456bcbd06f8$var$Rr;
            e.associations.set(h, {
                meshes: t1
            });
            for(let t1 = 0, e = l.length; t1 < e; t1++)h.add(l[t1]);
            return h;
        });
    }
    loadCamera(t1) {
        let e;
        const n = this.json.cameras[t1], i = n[n.type];
        if (i) return "perspective" === n.type ? e = new $fd4eb456bcbd06f8$var$We($fd4eb456bcbd06f8$var$f.radToDeg(i.yfov), i.aspectRatio || 1, i.znear || 1, i.zfar || 2e6) : "orthographic" === n.type && (e = new $fd4eb456bcbd06f8$var$mn(-i.xmag, i.xmag, i.ymag, -i.ymag, i.znear, i.zfar)), n.name && (e.name = this.createUniqueName(n.name)), $fd4eb456bcbd06f8$var$mc(e, n), Promise.resolve(e);
        console.warn("THREE.GLTFLoader: Missing camera parameters.");
    }
    loadSkin(t1) {
        const e = this.json.skins[t1], n = {
            joints: e.joints
        };
        return void 0 === e.inverseBindMatrices ? Promise.resolve(n) : this.getDependency("accessor", e.inverseBindMatrices).then(function(t1) {
            return n.inverseBindMatrices = t1, n;
        });
    }
    loadAnimation(t1) {
        const e = this.json.animations[t1], n = [], i = [], r = [], s = [], a = [];
        for(let t1 = 0, o = e.channels.length; t1 < o; t1++){
            const o = e.channels[t1], l = e.samplers[o.sampler], h = o.target, c = void 0 !== h.node ? h.node : h.id, u = void 0 !== e.parameters ? e.parameters[l.input] : l.input, d = void 0 !== e.parameters ? e.parameters[l.output] : l.output;
            n.push(this.getDependency("node", c)), i.push(this.getDependency("accessor", u)), r.push(this.getDependency("accessor", d)), s.push(l), a.push(h);
        }
        return Promise.all([
            Promise.all(n),
            Promise.all(i),
            Promise.all(r),
            Promise.all(s),
            Promise.all(a)
        ]).then(function(n) {
            const i = n[0], r = n[1], s = n[2], a = n[3], o = n[4], l = [];
            for(let t1 = 0, e = i.length; t1 < e; t1++){
                const e = i[t1], n = r[t1], h = s[t1], c = a[t1], u = o[t1];
                if (void 0 === e) continue;
                let d;
                switch(e.updateMatrix(), e.matrixAutoUpdate = !0, $fd4eb456bcbd06f8$var$oc[u.path]){
                    case $fd4eb456bcbd06f8$var$oc.weights:
                        d = $fd4eb456bcbd06f8$var$Qa;
                        break;
                    case $fd4eb456bcbd06f8$var$oc.rotation:
                        d = $fd4eb456bcbd06f8$var$eo;
                        break;
                    default:
                        d = $fd4eb456bcbd06f8$var$io;
                }
                const p = e.name ? e.name : e.uuid, m = void 0 !== c.interpolation ? $fd4eb456bcbd06f8$var$lc[c.interpolation] : 2301, f = [];
                $fd4eb456bcbd06f8$var$oc[u.path] === $fd4eb456bcbd06f8$var$oc.weights ? e.traverse(function(t1) {
                    t1.morphTargetInfluences && f.push(t1.name ? t1.name : t1.uuid);
                }) : f.push(p);
                let g = h.array;
                if (h.normalized) {
                    const t1 = $fd4eb456bcbd06f8$var$yc(g.constructor), e = new Float32Array(g.length);
                    for(let n = 0, i = g.length; n < i; n++)e[n] = g[n] * t1;
                    g = e;
                }
                for(let t1 = 0, e = f.length; t1 < e; t1++){
                    const e = new d(f[t1] + "." + $fd4eb456bcbd06f8$var$oc[u.path], n.array, g, m);
                    "CUBICSPLINE" === c.interpolation && (e.createInterpolant = function(t1) {
                        return new (this instanceof $fd4eb456bcbd06f8$var$eo ? $fd4eb456bcbd06f8$var$$h : $fd4eb456bcbd06f8$var$qh)(this.times, this.values, this.getValueSize() / 3, t1);
                    }, e.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline = !0), l.push(e);
                }
            }
            const h = e.name ? e.name : "animation_" + t1;
            return new $fd4eb456bcbd06f8$var$ro(h, void 0, l);
        });
    }
    createNodeMesh(t1) {
        const e = this.json, n = this, i = e.nodes[t1];
        return void 0 === i.mesh ? null : n.getDependency("mesh", i.mesh).then(function(t1) {
            const e = n._getNodeRef(n.meshCache, i.mesh, t1);
            return void 0 !== i.weights && e.traverse(function(t1) {
                if (t1.isMesh) for(let e = 0, n = i.weights.length; e < n; e++)t1.morphTargetInfluences[e] = i.weights[e];
            }), e;
        });
    }
    loadNode(t1) {
        const e = this.json, n = this.extensions, i = this, r = e.nodes[t1], s = r.name ? i.createUniqueName(r.name) : "";
        return (function() {
            const e = [], n = i._invokeOne(function(e) {
                return e.createNodeMesh && e.createNodeMesh(t1);
            });
            return n && e.push(n), void 0 !== r.camera && e.push(i.getDependency("camera", r.camera).then(function(t1) {
                return i._getNodeRef(i.cameraCache, r.camera, t1);
            })), i._invokeAll(function(e) {
                return e.createNodeAttachment && e.createNodeAttachment(t1);
            }).forEach(function(t1) {
                e.push(t1);
            }), Promise.all(e);
        })().then(function(e) {
            let a;
            if (a = !0 === r.isBone ? new $fd4eb456bcbd06f8$var$as : e.length > 1 ? new $fd4eb456bcbd06f8$var$Rr : 1 === e.length ? e[0] : new $fd4eb456bcbd06f8$var$Wt, a !== e[0]) for(let t1 = 0, n = e.length; t1 < n; t1++)a.add(e[t1]);
            if (r.name && (a.userData.name = r.name, a.name = s), $fd4eb456bcbd06f8$var$mc(a, r), r.extensions && $fd4eb456bcbd06f8$var$pc(n, a, r), void 0 !== r.matrix) {
                const t1 = new $fd4eb456bcbd06f8$var$xt;
                t1.fromArray(r.matrix), a.applyMatrix4(t1);
            } else void 0 !== r.translation && a.position.fromArray(r.translation), void 0 !== r.rotation && a.quaternion.fromArray(r.rotation), void 0 !== r.scale && a.scale.fromArray(r.scale);
            return i.associations.has(a) || i.associations.set(a, {}), i.associations.get(a).nodes = t1, a;
        });
    }
    loadScene(t1) {
        const e = this.json, n = this.extensions, i = this.json.scenes[t1], r = this, s = new $fd4eb456bcbd06f8$var$Rr;
        i.name && (s.name = r.createUniqueName(i.name)), $fd4eb456bcbd06f8$var$mc(s, i), i.extensions && $fd4eb456bcbd06f8$var$pc(n, s, i);
        const a = i.nodes || [], o = [];
        for(let t1 = 0, n = a.length; t1 < n; t1++)o.push($fd4eb456bcbd06f8$var$bc(a[t1], s, e, r));
        return Promise.all(o).then(function() {
            return r.associations = ((t1)=>{
                const e = new Map;
                for (const [t1, n] of r.associations)(t1 instanceof $fd4eb456bcbd06f8$var$ie || t1 instanceof $fd4eb456bcbd06f8$var$F) && e.set(t1, n);
                return t1.traverse((t1)=>{
                    const n = r.associations.get(t1);
                    null != n && e.set(t1, n);
                }), e;
            })(s), s;
        });
    }
}
function $fd4eb456bcbd06f8$var$bc(t1, e, n, i) {
    const r = n.nodes[t1];
    return i.getDependency("node", t1).then(function(t1) {
        if (void 0 === r.skin) return t1;
        let e;
        return i.getDependency("skin", r.skin).then(function(t1) {
            e = t1;
            const n = [];
            for(let t1 = 0, r = e.joints.length; t1 < r; t1++)n.push(i.getDependency("node", e.joints[t1]));
            return Promise.all(n);
        }).then(function(n) {
            return t1.traverse(function(t1) {
                if (!t1.isMesh) return;
                const i = [], r = [];
                for(let t1 = 0, s = n.length; t1 < s; t1++){
                    const s = n[t1];
                    if (s) {
                        i.push(s);
                        const n = new $fd4eb456bcbd06f8$var$xt;
                        void 0 !== e.inverseBindMatrices && n.fromArray(e.inverseBindMatrices.array, 16 * t1), r.push(n);
                    } else console.warn('THREE.GLTFLoader: Joint "%s" could not be found.', e.joints[t1]);
                }
                t1.bind(new $fd4eb456bcbd06f8$var$cs(i, r), t1.matrixWorld);
            }), t1;
        });
    }).then(function(t1) {
        e.add(t1);
        const s = [];
        if (r.children) {
            const e = r.children;
            for(let r = 0, a = e.length; r < a; r++){
                const a = e[r];
                s.push($fd4eb456bcbd06f8$var$bc(a, t1, n, i));
            }
        }
        return Promise.all(s);
    });
}
function $fd4eb456bcbd06f8$var$_c(t1, e, n) {
    const i = e.attributes, r = [];
    function s(e, i) {
        return n.getDependency("accessor", e).then(function(e) {
            t1.setAttribute(i, e);
        });
    }
    for(const e in i){
        const n = $fd4eb456bcbd06f8$var$ac[e] || e.toLowerCase();
        n in t1.attributes || r.push(s(i[e], n));
    }
    if (void 0 !== e.indices && !t1.index) {
        const i = n.getDependency("accessor", e.indices).then(function(e) {
            t1.setIndex(e);
        });
        r.push(i);
    }
    return $fd4eb456bcbd06f8$var$mc(t1, e), function(t1, e, n) {
        const i = e.attributes, r = new $fd4eb456bcbd06f8$var$j;
        if (void 0 === i.POSITION) return;
        {
            const t1 = n.json.accessors[i.POSITION], e = t1.min, s = t1.max;
            if (void 0 === e || void 0 === s) return void console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");
            if (r.set(new $fd4eb456bcbd06f8$var$V(e[0], e[1], e[2]), new $fd4eb456bcbd06f8$var$V(s[0], s[1], s[2])), t1.normalized) {
                const e = $fd4eb456bcbd06f8$var$yc($fd4eb456bcbd06f8$var$nc[t1.componentType]);
                r.min.multiplyScalar(e), r.max.multiplyScalar(e);
            }
        }
        const s = e.targets;
        if (void 0 !== s) {
            const t1 = new $fd4eb456bcbd06f8$var$V, e = new $fd4eb456bcbd06f8$var$V;
            for(let i = 0, r = s.length; i < r; i++){
                const r = s[i];
                if (void 0 !== r.POSITION) {
                    const i = n.json.accessors[r.POSITION], s = i.min, a = i.max;
                    if (void 0 !== s && void 0 !== a) {
                        if (e.setX(Math.max(Math.abs(s[0]), Math.abs(a[0]))), e.setY(Math.max(Math.abs(s[1]), Math.abs(a[1]))), e.setZ(Math.max(Math.abs(s[2]), Math.abs(a[2]))), i.normalized) {
                            const t1 = $fd4eb456bcbd06f8$var$yc($fd4eb456bcbd06f8$var$nc[i.componentType]);
                            e.multiplyScalar(t1);
                        }
                        t1.max(e);
                    } else console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");
                }
            }
            r.expandByVector(t1);
        }
        t1.boundingBox = r;
        const a = new $fd4eb456bcbd06f8$var$ct;
        r.getCenter(a.center), a.radius = r.min.distanceTo(r.max) / 2, t1.boundingSphere = a;
    }(t1, e, n), Promise.all(r).then(function() {
        return void 0 !== e.targets ? function(t1, e, n) {
            let i = !1, r = !1, s = !1;
            for(let t1 = 0, n = e.length; t1 < n; t1++){
                const n = e[t1];
                if (void 0 !== n.POSITION && (i = !0), void 0 !== n.NORMAL && (r = !0), void 0 !== n.COLOR_0 && (s = !0), i && r && s) break;
            }
            if (!i && !r && !s) return Promise.resolve(t1);
            const a = [], o = [], l = [];
            for(let h = 0, c = e.length; h < c; h++){
                const c = e[h];
                if (i) {
                    const e = void 0 !== c.POSITION ? n.getDependency("accessor", c.POSITION) : t1.attributes.position;
                    a.push(e);
                }
                if (r) {
                    const e = void 0 !== c.NORMAL ? n.getDependency("accessor", c.NORMAL) : t1.attributes.normal;
                    o.push(e);
                }
                if (s) {
                    const e = void 0 !== c.COLOR_0 ? n.getDependency("accessor", c.COLOR_0) : t1.attributes.color;
                    l.push(e);
                }
            }
            return Promise.all([
                Promise.all(a),
                Promise.all(o),
                Promise.all(l)
            ]).then(function(e) {
                const n = e[0], a = e[1], o = e[2];
                return i && (t1.morphAttributes.position = n), r && (t1.morphAttributes.normal = a), s && (t1.morphAttributes.color = o), t1.morphTargetsRelative = !0, t1;
            });
        }(t1, e.targets, n) : t1;
    });
}
function $fd4eb456bcbd06f8$var$wc(t1, e) {
    let n = t1.getIndex();
    if (null === n) {
        const e = [], i = t1.getAttribute("position");
        if (void 0 === i) return console.error("THREE.GLTFLoader.toTrianglesDrawMode(): Undefined position attribute. Processing not possible."), t1;
        for(let t1 = 0; t1 < i.count; t1++)e.push(t1);
        t1.setIndex(e), n = t1.getIndex();
    }
    const i = n.count - 2, r = [];
    if (2 === e) for(let t1 = 1; t1 <= i; t1++)r.push(n.getX(0)), r.push(n.getX(t1)), r.push(n.getX(t1 + 1));
    else for(let t1 = 0; t1 < i; t1++)t1 % 2 == 0 ? (r.push(n.getX(t1)), r.push(n.getX(t1 + 1)), r.push(n.getX(t1 + 2))) : (r.push(n.getX(t1 + 2)), r.push(n.getX(t1 + 1)), r.push(n.getX(t1)));
    r.length / 3 !== i && console.error("THREE.GLTFLoader.toTrianglesDrawMode(): Unable to generate correct amount of triangles.");
    const s = t1.clone();
    return s.setIndex(r), s;
}
class $fd4eb456bcbd06f8$var$Mc {
    constructor(t1 = 4){
        this.pool = t1, this.queue = [], this.workers = [], this.workersResolve = [], this.workerStatus = 0;
    }
    _initWorker(t1) {
        if (!this.workers[t1]) {
            const e = this.workerCreator();
            e.addEventListener("message", this._onMessage.bind(this, t1)), this.workers[t1] = e;
        }
    }
    _getIdleWorker() {
        for(let t1 = 0; t1 < this.pool; t1++)if (!(this.workerStatus & 1 << t1)) return t1;
        return -1;
    }
    _onMessage(t1, e) {
        const n = this.workersResolve[t1];
        if (n && n(e), this.queue.length) {
            const { resolve: e, msg: n, transfer: i } = this.queue.shift();
            this.workersResolve[t1] = e, this.workers[t1].postMessage(n, i);
        } else this.workerStatus ^= 1 << t1;
    }
    setWorkerCreator(t1) {
        this.workerCreator = t1;
    }
    setWorkerLimit(t1) {
        this.pool = t1;
    }
    postMessage(t1, e) {
        return new Promise((n)=>{
            const i = this._getIdleWorker();
            -1 !== i ? (this._initWorker(i), this.workerStatus |= 1 << i, this.workersResolve[i] = n, this.workers[i].postMessage(t1, e)) : this.queue.push({
                resolve: n,
                msg: t1,
                transfer: e
            });
        });
    }
    dispose() {
        this.workers.forEach((t1)=>t1.terminate()), this.workersResolve.length = 0, this.workers.length = 0, this.queue.length = 0, this.workerStatus = 0;
    }
}
const $fd4eb456bcbd06f8$var$Sc = new WeakMap;
let $fd4eb456bcbd06f8$var$Tc = 0;
class $fd4eb456bcbd06f8$var$Ec extends $fd4eb456bcbd06f8$var$lo {
    constructor(t1){
        super(t1), this.transcoderPath = "", this.transcoderBinary = null, this.transcoderPending = null, this.workerPool = new $fd4eb456bcbd06f8$var$Mc, this.workerSourceURL = "", this.workerConfig = null, "undefined" != typeof MSC_TRANSCODER && console.warn('THREE.KTX2Loader: Please update to latest "basis_transcoder". "msc_basis_transcoder" is no longer supported in three.js r125+.');
    }
    setTranscoderPath(t1) {
        return this.transcoderPath = t1, this;
    }
    setWorkerLimit(t1) {
        return this.workerPool.setWorkerLimit(t1), this;
    }
    detectSupport(t1) {
        return this.workerConfig = {
            astcSupported: t1.extensions.has("WEBGL_compressed_texture_astc"),
            etc1Supported: t1.extensions.has("WEBGL_compressed_texture_etc1"),
            etc2Supported: t1.extensions.has("WEBGL_compressed_texture_etc"),
            dxtSupported: t1.extensions.has("WEBGL_compressed_texture_s3tc"),
            bptcSupported: t1.extensions.has("EXT_texture_compression_bptc"),
            pvrtcSupported: t1.extensions.has("WEBGL_compressed_texture_pvrtc") || t1.extensions.has("WEBKIT_WEBGL_compressed_texture_pvrtc")
        }, t1.capabilities.isWebGL2 && (this.workerConfig.etc1Supported = !1), this;
    }
    init() {
        if (!this.transcoderPending) {
            const t1 = new $fd4eb456bcbd06f8$var$co(this.manager);
            t1.setPath(this.transcoderPath), t1.setWithCredentials(this.withCredentials);
            const e = t1.loadAsync("basis_transcoder.js"), n = new $fd4eb456bcbd06f8$var$co(this.manager);
            n.setPath(this.transcoderPath), n.setResponseType("arraybuffer"), n.setWithCredentials(this.withCredentials);
            const i = n.loadAsync("basis_transcoder.wasm");
            this.transcoderPending = Promise.all([
                e,
                i
            ]).then(([t1, e])=>{
                const n = $fd4eb456bcbd06f8$var$Ec.BasisWorker.toString(), i = [
                    "/* constants */",
                    "let _EngineFormat = " + JSON.stringify($fd4eb456bcbd06f8$var$Ec.EngineFormat),
                    "let _TranscoderFormat = " + JSON.stringify($fd4eb456bcbd06f8$var$Ec.TranscoderFormat),
                    "let _BasisFormat = " + JSON.stringify($fd4eb456bcbd06f8$var$Ec.BasisFormat),
                    "/* basis_transcoder.js */",
                    t1,
                    "/* worker */",
                    n.substring(n.indexOf("{") + 1, n.lastIndexOf("}"))
                ].join("\n");
                this.workerSourceURL = URL.createObjectURL(new Blob([
                    i
                ])), this.transcoderBinary = e, this.workerPool.setWorkerCreator(()=>{
                    const t1 = new Worker(this.workerSourceURL), e = this.transcoderBinary.slice(0);
                    return t1.postMessage({
                        type: "init",
                        config: this.workerConfig,
                        transcoderBinary: e
                    }, [
                        e
                    ]), t1;
                });
            }), $fd4eb456bcbd06f8$var$Tc > 0 && console.warn("THREE.KTX2Loader: Multiple active KTX2 loaders may cause performance issues. Use a single KTX2Loader instance, or call .dispose() on old instances."), $fd4eb456bcbd06f8$var$Tc++;
        }
        return this.transcoderPending;
    }
    load(t1, e, n, i) {
        if (null === this.workerConfig) throw new Error("THREE.KTX2Loader: Missing initialization with `.detectSupport( renderer )`.");
        const r = new $fd4eb456bcbd06f8$var$co(this.manager);
        r.setResponseType("arraybuffer"), r.setWithCredentials(this.withCredentials);
        const s = new $fd4eb456bcbd06f8$var$Os;
        return r.load(t1, (t1)=>{
            if ($fd4eb456bcbd06f8$var$Sc.has(t1)) return $fd4eb456bcbd06f8$var$Sc.get(t1).promise.then(e).catch(i);
            this._createTexture([
                t1
            ]).then(function(t1) {
                s.copy(t1), s.needsUpdate = !0, e && e(s);
            }).catch(i);
        }, n, i), s;
    }
    _createTextureFrom(t1) {
        const { mipmaps: e, width: n, height: i, format: r, type: s, error: a, dfdTransferFn: o, dfdFlags: l } = t1;
        if ("error" === s) return Promise.reject(a);
        const h = new $fd4eb456bcbd06f8$var$Os(e, n, i, r, 1009);
        return h.minFilter = 1 === e.length ? 1006 : 1008, h.magFilter = 1006, h.generateMipmaps = !1, h.needsUpdate = !0, h.encoding = 2 === o ? 3001 : 3e3, h.premultiplyAlpha = !!(1 & l), h;
    }
    _createTexture(t1, e = {}) {
        const n = e, i = this.init().then(()=>this.workerPool.postMessage({
                type: "transcode",
                buffers: t1,
                taskConfig: n
            }, t1)).then((t1)=>this._createTextureFrom(t1.data));
        return $fd4eb456bcbd06f8$var$Sc.set(t1[0], {
            promise: i
        }), i;
    }
    dispose() {
        return this.workerPool.dispose(), this.workerSourceURL && URL.revokeObjectURL(this.workerSourceURL), $fd4eb456bcbd06f8$var$Tc--, this;
    }
}
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $fd4eb456bcbd06f8$var$Ac, $fd4eb456bcbd06f8$var$Rc;
$fd4eb456bcbd06f8$var$Ec.BasisFormat = {
    ETC1S: 0,
    UASTC_4x4: 1
}, $fd4eb456bcbd06f8$var$Ec.TranscoderFormat = {
    ETC1: 0,
    ETC2: 1,
    BC1: 2,
    BC3: 3,
    BC4: 4,
    BC5: 5,
    BC7_M6_OPAQUE_ONLY: 6,
    BC7_M5: 7,
    PVRTC1_4_RGB: 8,
    PVRTC1_4_RGBA: 9,
    ASTC_4x4: 10,
    ATC_RGB: 11,
    ATC_RGBA_INTERPOLATED_ALPHA: 12,
    RGBA32: 13,
    RGB565: 14,
    BGR565: 15,
    RGBA4444: 16
}, $fd4eb456bcbd06f8$var$Ec.EngineFormat = {
    RGBAFormat: 1023,
    RGBA_ASTC_4x4_Format: 37808,
    RGBA_BPTC_Format: 36492,
    RGBA_ETC2_EAC_Format: 37496,
    RGBA_PVRTC_4BPPV1_Format: 35842,
    RGBA_S3TC_DXT5_Format: 33779,
    RGB_ETC1_Format: 36196,
    RGB_ETC2_Format: 37492,
    RGB_PVRTC_4BPPV1_Format: 35840,
    RGB_S3TC_DXT1_Format: 33776
}, $fd4eb456bcbd06f8$var$Ec.BasisWorker = function() {
    let t1, e, n;
    const i = _EngineFormat, r = _TranscoderFormat, s = _BasisFormat;
    self.addEventListener("message", function(a) {
        const c = a.data;
        switch(c.type){
            case "init":
                t1 = c.config, u = c.transcoderBinary, e = new Promise((t1)=>{
                    n = {
                        wasmBinary: u,
                        onRuntimeInitialized: t1
                    }, BASIS(n);
                }).then(()=>{
                    n.initializeBasis(), void 0 === n.KTX2File && console.warn("THREE.KTX2Loader: Please update Basis Universal transcoder.");
                });
                break;
            case "transcode":
                e.then(()=>{
                    try {
                        const { width: e, height: a, hasAlpha: u, mipmaps: d, format: p, dfdTransferFn: m, dfdFlags: f } = function(e) {
                            const a = new n.KTX2File(new Uint8Array(e));
                            function c() {
                                a.close(), a.delete();
                            }
                            if (!a.isValid()) throw c(), new Error("THREE.KTX2Loader:\tInvalid or unsupported .ktx2 file");
                            const u = a.isUASTC() ? s.UASTC_4x4 : s.ETC1S, d = a.getWidth(), p = a.getHeight(), m = a.getLevels(), f = a.getHasAlpha(), g = a.getDFDTransferFunc(), v = a.getDFDFlags(), { transcoderFormat: y, engineFormat: x } = function(e, n, a, c) {
                                let u, d;
                                const p = e === s.ETC1S ? o : l;
                                for(let i = 0; i < p.length; i++){
                                    const r = p[i];
                                    if (t1[r.if] && r.basisFormat.includes(e) && !(c && r.transcoderFormat.length < 2) && (!r.needsPowerOfTwo || h(n) && h(a))) return u = r.transcoderFormat[c ? 1 : 0], d = r.engineFormat[c ? 1 : 0], {
                                        transcoderFormat: u,
                                        engineFormat: d
                                    };
                                }
                                return console.warn("THREE.KTX2Loader: No suitable compressed texture format found. Decoding to RGBA32."), u = r.RGBA32, d = i.RGBAFormat, {
                                    transcoderFormat: u,
                                    engineFormat: d
                                };
                            }(u, d, p, f);
                            if (!d || !p || !m) throw c(), new Error("THREE.KTX2Loader:\tInvalid texture");
                            if (!a.startTranscoding()) throw c(), new Error("THREE.KTX2Loader: .startTranscoding failed");
                            const b = [];
                            for(let t1 = 0; t1 < m; t1++){
                                const e = a.getImageLevelInfo(t1, 0, 0), n = e.origWidth, i = e.origHeight, r = new Uint8Array(a.getImageTranscodedSizeInBytes(t1, 0, 0, y));
                                if (!a.transcodeImage(r, t1, 0, 0, y, 0, -1, -1)) throw c(), new Error("THREE.KTX2Loader: .transcodeImage failed.");
                                b.push({
                                    data: r,
                                    width: n,
                                    height: i
                                });
                            }
                            return c(), {
                                width: d,
                                height: p,
                                hasAlpha: f,
                                mipmaps: b,
                                format: x,
                                dfdTransferFn: g,
                                dfdFlags: v
                            };
                        }(c.buffers[0]), g = [];
                        for(let t1 = 0; t1 < d.length; ++t1)g.push(d[t1].data.buffer);
                        self.postMessage({
                            type: "transcode",
                            id: c.id,
                            width: e,
                            height: a,
                            hasAlpha: u,
                            mipmaps: d,
                            format: p,
                            dfdTransferFn: m,
                            dfdFlags: f
                        }, g);
                    } catch (t1) {
                        console.error(t1), self.postMessage({
                            type: "error",
                            id: c.id,
                            error: t1.message
                        });
                    }
                });
        }
        var u;
    });
    const a = [
        {
            if: "astcSupported",
            basisFormat: [
                s.UASTC_4x4
            ],
            transcoderFormat: [
                r.ASTC_4x4,
                r.ASTC_4x4
            ],
            engineFormat: [
                i.RGBA_ASTC_4x4_Format,
                i.RGBA_ASTC_4x4_Format
            ],
            priorityETC1S: 1 / 0,
            priorityUASTC: 1,
            needsPowerOfTwo: !1
        },
        {
            if: "bptcSupported",
            basisFormat: [
                s.ETC1S,
                s.UASTC_4x4
            ],
            transcoderFormat: [
                r.BC7_M5,
                r.BC7_M5
            ],
            engineFormat: [
                i.RGBA_BPTC_Format,
                i.RGBA_BPTC_Format
            ],
            priorityETC1S: 3,
            priorityUASTC: 2,
            needsPowerOfTwo: !1
        },
        {
            if: "dxtSupported",
            basisFormat: [
                s.ETC1S,
                s.UASTC_4x4
            ],
            transcoderFormat: [
                r.BC1,
                r.BC3
            ],
            engineFormat: [
                i.RGB_S3TC_DXT1_Format,
                i.RGBA_S3TC_DXT5_Format
            ],
            priorityETC1S: 4,
            priorityUASTC: 5,
            needsPowerOfTwo: !1
        },
        {
            if: "etc2Supported",
            basisFormat: [
                s.ETC1S,
                s.UASTC_4x4
            ],
            transcoderFormat: [
                r.ETC1,
                r.ETC2
            ],
            engineFormat: [
                i.RGB_ETC2_Format,
                i.RGBA_ETC2_EAC_Format
            ],
            priorityETC1S: 1,
            priorityUASTC: 3,
            needsPowerOfTwo: !1
        },
        {
            if: "etc1Supported",
            basisFormat: [
                s.ETC1S,
                s.UASTC_4x4
            ],
            transcoderFormat: [
                r.ETC1
            ],
            engineFormat: [
                i.RGB_ETC1_Format
            ],
            priorityETC1S: 2,
            priorityUASTC: 4,
            needsPowerOfTwo: !1
        },
        {
            if: "pvrtcSupported",
            basisFormat: [
                s.ETC1S,
                s.UASTC_4x4
            ],
            transcoderFormat: [
                r.PVRTC1_4_RGB,
                r.PVRTC1_4_RGBA
            ],
            engineFormat: [
                i.RGB_PVRTC_4BPPV1_Format,
                i.RGBA_PVRTC_4BPPV1_Format
            ],
            priorityETC1S: 5,
            priorityUASTC: 6,
            needsPowerOfTwo: !0
        }
    ], o = a.sort(function(t1, e) {
        return t1.priorityETC1S - e.priorityETC1S;
    }), l = a.sort(function(t1, e) {
        return t1.priorityUASTC - e.priorityUASTC;
    });
    function h(t1) {
        return t1 <= 2 || 0 == (t1 & t1 - 1) && 0 !== t1;
    }
};
const $fd4eb456bcbd06f8$var$Cc = Symbol("retainerCount"), $fd4eb456bcbd06f8$var$Lc = Symbol("recentlyUsed"), $fd4eb456bcbd06f8$var$Pc = Symbol("evict"), $fd4eb456bcbd06f8$var$Dc = Symbol("evictionThreshold"), $fd4eb456bcbd06f8$var$Ic = Symbol("cache");
class $fd4eb456bcbd06f8$var$Oc {
    constructor(t1, e = 5){
        this[$fd4eb456bcbd06f8$var$Ac] = new Map, this[$fd4eb456bcbd06f8$var$Rc] = [], this[$fd4eb456bcbd06f8$var$Ic] = t1, this[$fd4eb456bcbd06f8$var$Dc] = e;
    }
    set evictionThreshold(t1) {
        this[$fd4eb456bcbd06f8$var$Dc] = t1, this[$fd4eb456bcbd06f8$var$Pc]();
    }
    get evictionThreshold() {
        return this[$fd4eb456bcbd06f8$var$Dc];
    }
    get cache() {
        return this[$fd4eb456bcbd06f8$var$Ic];
    }
    retainerCount(t1) {
        return this[$fd4eb456bcbd06f8$var$Cc].get(t1) || 0;
    }
    reset() {
        this[$fd4eb456bcbd06f8$var$Cc].clear(), this[$fd4eb456bcbd06f8$var$Lc] = [];
    }
    retain(t1) {
        this[$fd4eb456bcbd06f8$var$Cc].has(t1) || this[$fd4eb456bcbd06f8$var$Cc].set(t1, 0), this[$fd4eb456bcbd06f8$var$Cc].set(t1, this[$fd4eb456bcbd06f8$var$Cc].get(t1) + 1);
        const e = this[$fd4eb456bcbd06f8$var$Lc].indexOf(t1);
        -1 !== e && this[$fd4eb456bcbd06f8$var$Lc].splice(e, 1), this[$fd4eb456bcbd06f8$var$Lc].unshift(t1), this[$fd4eb456bcbd06f8$var$Pc]();
    }
    release(t1) {
        this[$fd4eb456bcbd06f8$var$Cc].has(t1) && this[$fd4eb456bcbd06f8$var$Cc].set(t1, Math.max(this[$fd4eb456bcbd06f8$var$Cc].get(t1) - 1, 0)), this[$fd4eb456bcbd06f8$var$Pc]();
    }
    [($fd4eb456bcbd06f8$var$Ac = $fd4eb456bcbd06f8$var$Cc, $fd4eb456bcbd06f8$var$Rc = $fd4eb456bcbd06f8$var$Lc, $fd4eb456bcbd06f8$var$Pc)]() {
        if (!(this[$fd4eb456bcbd06f8$var$Lc].length < this[$fd4eb456bcbd06f8$var$Dc])) for(let t1 = this[$fd4eb456bcbd06f8$var$Lc].length - 1; t1 >= this[$fd4eb456bcbd06f8$var$Dc]; --t1){
            const e = this[$fd4eb456bcbd06f8$var$Lc][t1];
            0 === this[$fd4eb456bcbd06f8$var$Cc].get(e) && (this[$fd4eb456bcbd06f8$var$Ic].delete(e), this[$fd4eb456bcbd06f8$var$Lc].splice(t1, 1));
        }
    }
}
/* @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fd4eb456bcbd06f8$var$Nc = (t1)=>{
    const e = new Map;
    for (const n of t1.mappings)for (const t1 of n.variants)e.set(t1, {
        material: null,
        gltfMaterialIndex: n.material
    });
    return e;
};
class $fd4eb456bcbd06f8$var$Fc {
    constructor(t1){
        this.parser = t1, this.name = "KHR_materials_variants";
    }
    afterRoot(t1) {
        const e = this.parser, n = e.json;
        if (void 0 === n.extensions || void 0 === n.extensions[this.name]) return null;
        const i = ((t1)=>{
            const e = [], n = new Set;
            for (const i of t1){
                let t1 = i, r = 0;
                for(; n.has(t1);)t1 = i + "." + ++r;
                n.add(t1), e.push(t1);
            }
            return e;
        })((n.extensions[this.name].variants || []).map((t1)=>t1.name));
        for (const i of t1.scenes)i.traverse((t1)=>{
            const i = t1;
            if (!i.isMesh) return;
            const r = e.associations.get(i);
            if (null == r || null == r.meshes || null == r.primitives) return;
            const s = n.meshes[r.meshes].primitives[r.primitives].extensions;
            s && s[this.name] && (i.userData.variantMaterials = $fd4eb456bcbd06f8$var$Nc(s[this.name]));
        });
        return t1.userData.variants = i, Promise.resolve();
    }
}
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $fd4eb456bcbd06f8$var$Uc, $fd4eb456bcbd06f8$var$kc;
const $fd4eb456bcbd06f8$var$Bc = new Map, $fd4eb456bcbd06f8$var$zc = new Map;
let $fd4eb456bcbd06f8$var$Hc;
const $fd4eb456bcbd06f8$var$Vc = new class extends $fd4eb456bcbd06f8$var$lo {
    constructor(t1){
        super(t1), this.decoderPath = "", this.decoderConfig = {}, this.decoderBinary = null, this.decoderPending = null, this.workerLimit = 4, this.workerPool = [], this.workerNextTaskID = 1, this.workerSourceURL = "", this.defaultAttributeIDs = {
            position: "POSITION",
            normal: "NORMAL",
            color: "COLOR",
            uv: "TEX_COORD"
        }, this.defaultAttributeTypes = {
            position: "Float32Array",
            normal: "Float32Array",
            color: "Float32Array",
            uv: "Float32Array"
        };
    }
    setDecoderPath(t1) {
        return this.decoderPath = t1, this;
    }
    setDecoderConfig(t1) {
        return this.decoderConfig = t1, this;
    }
    setWorkerLimit(t1) {
        return this.workerLimit = t1, this;
    }
    load(t1, e, n, i) {
        const r = new $fd4eb456bcbd06f8$var$co(this.manager);
        r.setPath(this.path), r.setResponseType("arraybuffer"), r.setRequestHeader(this.requestHeader), r.setWithCredentials(this.withCredentials), r.load(t1, (t1)=>{
            const n = {
                attributeIDs: this.defaultAttributeIDs,
                attributeTypes: this.defaultAttributeTypes,
                useUniqueIDs: !1
            };
            this.decodeGeometry(t1, n).then(e).catch(i);
        }, n, i);
    }
    decodeDracoFile(t1, e, n, i) {
        const r = {
            attributeIDs: n || this.defaultAttributeIDs,
            attributeTypes: i || this.defaultAttributeTypes,
            useUniqueIDs: !!n
        };
        this.decodeGeometry(t1, r).then(e);
    }
    decodeGeometry(t1, e) {
        for(const t1 in e.attributeTypes){
            const n = e.attributeTypes[t1];
            void 0 !== n.BYTES_PER_ELEMENT && (e.attributeTypes[t1] = n.name);
        }
        const n = JSON.stringify(e);
        if ($fd4eb456bcbd06f8$var$_h.has(t1)) {
            const e = $fd4eb456bcbd06f8$var$_h.get(t1);
            if (e.key === n) return e.promise;
            if (0 === t1.byteLength) throw new Error("THREE.DRACOLoader: Unable to re-decode a buffer with different settings. Buffer has already been transferred.");
        }
        let i;
        const r = this.workerNextTaskID++, s = t1.byteLength, a = this._getWorker(r, s).then((n)=>(i = n, new Promise((n, s)=>{
                i._callbacks[r] = {
                    resolve: n,
                    reject: s
                }, i.postMessage({
                    type: "decode",
                    id: r,
                    taskConfig: e,
                    buffer: t1
                }, [
                    t1
                ]);
            }))).then((t1)=>this._createGeometry(t1.geometry));
        return a.catch(()=>!0).then(()=>{
            i && r && this._releaseTask(i, r);
        }), $fd4eb456bcbd06f8$var$_h.set(t1, {
            key: n,
            promise: a
        }), a;
    }
    _createGeometry(t1) {
        const e = new $fd4eb456bcbd06f8$var$ye;
        t1.index && e.setIndex(new $fd4eb456bcbd06f8$var$oe(t1.index.array, 1));
        for(let n = 0; n < t1.attributes.length; n++){
            const i = t1.attributes[n], r = i.name, s = i.array, a = i.itemSize;
            e.setAttribute(r, new $fd4eb456bcbd06f8$var$oe(s, a));
        }
        return e;
    }
    _loadLibrary(t1, e) {
        const n = new $fd4eb456bcbd06f8$var$co(this.manager);
        return n.setPath(this.decoderPath), n.setResponseType(e), n.setWithCredentials(this.withCredentials), new Promise((e, i)=>{
            n.load(t1, e, void 0, i);
        });
    }
    preload() {
        return this._initDecoder(), this;
    }
    _initDecoder() {
        if (this.decoderPending) return this.decoderPending;
        const t1 = "object" != typeof WebAssembly || "js" === this.decoderConfig.type, e = [];
        return t1 ? e.push(this._loadLibrary("draco_decoder.js", "text")) : (e.push(this._loadLibrary("draco_wasm_wrapper.js", "text")), e.push(this._loadLibrary("draco_decoder.wasm", "arraybuffer"))), this.decoderPending = Promise.all(e).then((e)=>{
            const n = e[0];
            t1 || (this.decoderConfig.wasmBinary = e[1]);
            const i = $fd4eb456bcbd06f8$var$wh.toString(), r = [
                "/* draco decoder */",
                n,
                "",
                "/* worker */",
                i.substring(i.indexOf("{") + 1, i.lastIndexOf("}"))
            ].join("\n");
            this.workerSourceURL = URL.createObjectURL(new Blob([
                r
            ]));
        }), this.decoderPending;
    }
    _getWorker(t1, e) {
        return this._initDecoder().then(()=>{
            if (this.workerPool.length < this.workerLimit) {
                const t1 = new Worker(this.workerSourceURL);
                t1._callbacks = {}, t1._taskCosts = {}, t1._taskLoad = 0, t1.postMessage({
                    type: "init",
                    decoderConfig: this.decoderConfig
                }), t1.onmessage = function(e) {
                    const n = e.data;
                    switch(n.type){
                        case "decode":
                            t1._callbacks[n.id].resolve(n);
                            break;
                        case "error":
                            t1._callbacks[n.id].reject(n);
                            break;
                        default:
                            console.error('THREE.DRACOLoader: Unexpected message, "' + n.type + '"');
                    }
                }, this.workerPool.push(t1);
            } else this.workerPool.sort(function(t1, e) {
                return t1._taskLoad > e._taskLoad ? -1 : 1;
            });
            const n = this.workerPool[this.workerPool.length - 1];
            return n._taskCosts[t1] = e, n._taskLoad += e, n;
        });
    }
    _releaseTask(t1, e) {
        t1._taskLoad -= t1._taskCosts[e], delete t1._callbacks[e], delete t1._taskCosts[e];
    }
    debug() {
        console.log("Task load: ", this.workerPool.map((t1)=>t1._taskLoad));
    }
    dispose() {
        for(let t1 = 0; t1 < this.workerPool.length; ++t1)this.workerPool[t1].terminate();
        return this.workerPool.length = 0, this;
    }
};
let $fd4eb456bcbd06f8$var$Gc;
const $fd4eb456bcbd06f8$var$Wc = new $fd4eb456bcbd06f8$var$Ec;
let $fd4eb456bcbd06f8$var$jc, $fd4eb456bcbd06f8$var$qc;
const $fd4eb456bcbd06f8$var$Xc = Symbol("loader"), $fd4eb456bcbd06f8$var$$c = Symbol("evictionPolicy"), $fd4eb456bcbd06f8$var$Yc = Symbol("GLTFInstance");
class $fd4eb456bcbd06f8$var$Jc extends $fd4eb456bcbd06f8$var$i {
    constructor(t1){
        super(), this[$fd4eb456bcbd06f8$var$kc] = (new $fd4eb456bcbd06f8$var$Mh).register((t1)=>new $fd4eb456bcbd06f8$var$Fc(t1)), this[$fd4eb456bcbd06f8$var$Yc] = t1, this[$fd4eb456bcbd06f8$var$Xc].setDRACOLoader($fd4eb456bcbd06f8$var$Vc), this[$fd4eb456bcbd06f8$var$Xc].setKTX2Loader($fd4eb456bcbd06f8$var$Wc);
    }
    static setDRACODecoderLocation(t1) {
        $fd4eb456bcbd06f8$var$Hc = t1, $fd4eb456bcbd06f8$var$Vc.setDecoderPath(t1);
    }
    static getDRACODecoderLocation() {
        return $fd4eb456bcbd06f8$var$Hc;
    }
    static setKTX2TranscoderLocation(t1) {
        $fd4eb456bcbd06f8$var$Gc = t1, $fd4eb456bcbd06f8$var$Wc.setTranscoderPath(t1);
    }
    static getKTX2TranscoderLocation() {
        return $fd4eb456bcbd06f8$var$Gc;
    }
    static setMeshoptDecoderLocation(t1) {
        var e;
        $fd4eb456bcbd06f8$var$jc !== t1 && ($fd4eb456bcbd06f8$var$jc = t1, $fd4eb456bcbd06f8$var$qc = (e = t1, new Promise((t1, n)=>{
            const i = document.createElement("script");
            document.body.appendChild(i), i.onload = t1, i.onerror = n, i.async = !0, i.src = e;
        })).then(()=>MeshoptDecoder.ready).then(()=>MeshoptDecoder));
    }
    static getMeshoptDecoderLocation() {
        return $fd4eb456bcbd06f8$var$jc;
    }
    static initializeKTX2Loader(t1) {
        $fd4eb456bcbd06f8$var$Wc.detectSupport(t1);
    }
    static get cache() {
        return $fd4eb456bcbd06f8$var$Bc;
    }
    static clearCache() {
        $fd4eb456bcbd06f8$var$Bc.forEach((t1, e)=>{
            this.delete(e);
        }), this[$fd4eb456bcbd06f8$var$$c].reset();
    }
    static has(t1) {
        return $fd4eb456bcbd06f8$var$Bc.has(t1);
    }
    static async delete(t1) {
        if (!this.has(t1)) return;
        const e = $fd4eb456bcbd06f8$var$Bc.get(t1);
        $fd4eb456bcbd06f8$var$zc.delete(t1), $fd4eb456bcbd06f8$var$Bc.delete(t1);
        (await e).dispose();
    }
    static hasFinishedLoading(t1) {
        return !!$fd4eb456bcbd06f8$var$zc.get(t1);
    }
    get [($fd4eb456bcbd06f8$var$Uc = $fd4eb456bcbd06f8$var$$c, $fd4eb456bcbd06f8$var$kc = $fd4eb456bcbd06f8$var$Xc, $fd4eb456bcbd06f8$var$$c)]() {
        return this.constructor[$fd4eb456bcbd06f8$var$$c];
    }
    async preload(t1, e, n = ()=>{}) {
        if (this[$fd4eb456bcbd06f8$var$Xc].setWithCredentials($fd4eb456bcbd06f8$var$Jc.withCredentials), this.dispatchEvent({
            type: "preload",
            element: e,
            src: t1
        }), !$fd4eb456bcbd06f8$var$Bc.has(t1)) {
            null != $fd4eb456bcbd06f8$var$qc && this[$fd4eb456bcbd06f8$var$Xc].setMeshoptDecoder(await $fd4eb456bcbd06f8$var$qc);
            const e = ((t1, e, n = ()=>{})=>{
                const i = (t1)=>{
                    const e = t1.loaded / t1.total;
                    n(Math.max(0, Math.min(1, isFinite(e) ? e : 1)));
                };
                return new Promise((n, r)=>{
                    e.load(t1, n, i, r);
                });
            })(t1, this[$fd4eb456bcbd06f8$var$Xc], (t1)=>{
                n(.8 * t1);
            }), i = this[$fd4eb456bcbd06f8$var$Yc], r = e.then((t1)=>i.prepare(t1)).then((t1)=>(n(.9), new i(t1))).catch((t1)=>(console.error(t1), new i));
            $fd4eb456bcbd06f8$var$Bc.set(t1, r);
        }
        await $fd4eb456bcbd06f8$var$Bc.get(t1), $fd4eb456bcbd06f8$var$zc.set(t1, !0), n && n(1);
    }
    async load(t1, e, n = ()=>{}) {
        await this.preload(t1, e, n);
        const i = await $fd4eb456bcbd06f8$var$Bc.get(t1), r = await i.clone();
        return this[$fd4eb456bcbd06f8$var$$c].retain(t1), r.dispose = ()=>{
            this[$fd4eb456bcbd06f8$var$$c].release(t1);
        }, r;
    }
}
$fd4eb456bcbd06f8$var$Jc[$fd4eb456bcbd06f8$var$Uc] = new $fd4eb456bcbd06f8$var$Oc($fd4eb456bcbd06f8$var$Jc);
class $fd4eb456bcbd06f8$var$Kc extends $fd4eb456bcbd06f8$var$Wt {
    constructor(t1 = document.createElement("div")){
        super(), this.element = t1, this.element.style.position = "absolute", this.element.style.userSelect = "none", this.element.setAttribute("draggable", !1), this.addEventListener("removed", function() {
            this.traverse(function(t1) {
                t1.element instanceof Element && null !== t1.element.parentNode && t1.element.parentNode.removeChild(t1.element);
            });
        });
    }
    copy(t1, e) {
        return super.copy(t1, e), this.element = t1.element.cloneNode(!0), this;
    }
}
$fd4eb456bcbd06f8$var$Kc.prototype.isCSS2DObject = !0;
const $fd4eb456bcbd06f8$var$Zc = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$Qc = new $fd4eb456bcbd06f8$var$xt, $fd4eb456bcbd06f8$var$tu = new $fd4eb456bcbd06f8$var$xt, $fd4eb456bcbd06f8$var$eu = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$nu = new $fd4eb456bcbd06f8$var$V;
class $fd4eb456bcbd06f8$var$iu {
    constructor(t1 = {}){
        const e = this;
        let n, i, r, s;
        const a = {
            objects: new WeakMap
        }, o = void 0 !== t1.element ? t1.element : document.createElement("div");
        function l(t1, n, i) {
            if (t1.isCSS2DObject) {
                $fd4eb456bcbd06f8$var$Zc.setFromMatrixPosition(t1.matrixWorld), $fd4eb456bcbd06f8$var$Zc.applyMatrix4($fd4eb456bcbd06f8$var$tu);
                const l = !0 === t1.visible && $fd4eb456bcbd06f8$var$Zc.z >= -1 && $fd4eb456bcbd06f8$var$Zc.z <= 1 && !0 === t1.layers.test(i.layers);
                if (t1.element.style.display = !0 === l ? "" : "none", !0 === l) {
                    t1.onBeforeRender(e, n, i);
                    const a = t1.element;
                    /apple/i.test(navigator.vendor) ? a.style.transform = "translate(-50%,-50%) translate(" + Math.round($fd4eb456bcbd06f8$var$Zc.x * r + r) + "px," + Math.round(-$fd4eb456bcbd06f8$var$Zc.y * s + s) + "px)" : a.style.transform = "translate(-50%,-50%) translate(" + ($fd4eb456bcbd06f8$var$Zc.x * r + r) + "px," + (-$fd4eb456bcbd06f8$var$Zc.y * s + s) + "px)", a.parentNode !== o && o.appendChild(a), t1.onAfterRender(e, n, i);
                }
                const c = {
                    distanceToCameraSquared: h(i, t1)
                };
                a.objects.set(t1, c);
            }
            for(let e = 0, r = t1.children.length; e < r; e++)l(t1.children[e], n, i);
        }
        function h(t1, e) {
            return $fd4eb456bcbd06f8$var$eu.setFromMatrixPosition(t1.matrixWorld), $fd4eb456bcbd06f8$var$nu.setFromMatrixPosition(e.matrixWorld), $fd4eb456bcbd06f8$var$eu.distanceToSquared($fd4eb456bcbd06f8$var$nu);
        }
        o.style.overflow = "hidden", this.domElement = o, this.getSize = function() {
            return {
                width: n,
                height: i
            };
        }, this.render = function(t1, e) {
            !0 === t1.autoUpdate && t1.updateMatrixWorld(), null === e.parent && e.updateMatrixWorld(), $fd4eb456bcbd06f8$var$Qc.copy(e.matrixWorldInverse), $fd4eb456bcbd06f8$var$tu.multiplyMatrices(e.projectionMatrix, $fd4eb456bcbd06f8$var$Qc), l(t1, t1, e), function(t1) {
                const e = (function(t1) {
                    const e = [];
                    return t1.traverse(function(t1) {
                        t1.isCSS2DObject && e.push(t1);
                    }), e;
                })(t1).sort(function(t1, e) {
                    if (t1.renderOrder !== e.renderOrder) return e.renderOrder - t1.renderOrder;
                    return a.objects.get(t1).distanceToCameraSquared - a.objects.get(e).distanceToCameraSquared;
                }), n = e.length;
                for(let t1 = 0, i = e.length; t1 < i; t1++)e[t1].element.style.zIndex = n - t1;
            }(t1);
        }, this.setSize = function(t1, e) {
            n = t1, i = e, r = n / 2, s = i / 2, o.style.width = t1 + "px", o.style.height = e + "px";
        };
    }
}
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fd4eb456bcbd06f8$var$ru = (t1)=>t1 && "null" !== t1 ? $fd4eb456bcbd06f8$var$au(t1) : null, $fd4eb456bcbd06f8$var$su = ()=>{
    if ($fd4eb456bcbd06f8$var$ph) return;
    const t1 = [];
    throw $fd4eb456bcbd06f8$var$hh || t1.push("WebXR Device API"), $fd4eb456bcbd06f8$var$ch || t1.push("WebXR Hit Test API"), new Error(`The following APIs are required for AR, but are missing in this browser: ${t1.join(", ")}`);
}, $fd4eb456bcbd06f8$var$au = (t1)=>new URL(t1, window.location.toString()).toString(), $fd4eb456bcbd06f8$var$ou = (t1, e)=>{
    let n = null;
    return (...i)=>{
        null != n && self.clearTimeout(n), n = self.setTimeout(()=>{
            n = null, t1(...i);
        }, e);
    };
}, $fd4eb456bcbd06f8$var$lu = (t1, e, n)=>Math.max(e, Math.min(n, t1)), $fd4eb456bcbd06f8$var$hu = (()=>{
    const t1 = (()=>{
        var t1;
        if (null === (t1 = document.documentElement.getAttribute("itemtype")) || void 0 === t1 ? void 0 : t1.includes("schema.org/SearchResultsPage")) return !0;
        const e = null != document.head ? Array.from(document.head.querySelectorAll("meta")) : [];
        for (const t1 of e)if ("viewport" === t1.name) return !0;
        return !1;
    })();
    return t1 || console.warn('No <meta name="viewport"> detected; <model-viewer> will cap pixel density at 1.'), ()=>t1 ? window.devicePixelRatio : 1;
})(), $fd4eb456bcbd06f8$var$cu = (()=>{
    const t1 = new RegExp("[?&]model-viewer-debug-mode(&|$)");
    return ()=>self.ModelViewerElement && self.ModelViewerElement.debugMode || self.location && self.location.search && self.location.search.match(t1);
})(), $fd4eb456bcbd06f8$var$uu = (t1 = 0)=>new Promise((e)=>setTimeout(e, t1));
class $fd4eb456bcbd06f8$var$du {
    constructor(t1 = 50){
        this.velocity = 0, this.naturalFrequency = 0, this.setDecayTime(t1);
    }
    setDecayTime(t1) {
        this.naturalFrequency = 1 / Math.max(.001, t1);
    }
    update(t1, e, n, i) {
        const r = 2e-4 * this.naturalFrequency;
        if (null == t1 || 0 === i) return e;
        if (t1 === e && 0 === this.velocity) return e;
        if (n < 0) return t1;
        const s = t1 - e, a = this.velocity + this.naturalFrequency * s, o = s + n * a, l = Math.exp(-this.naturalFrequency * n), h = (a - this.naturalFrequency * o) * l, c = -this.naturalFrequency * (h + a * l);
        return Math.abs(h) < r * Math.abs(i) && c * s >= 0 ? (this.velocity = 0, e) : (this.velocity = h, e + o * l);
    }
}
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fd4eb456bcbd06f8$var$pu = (t1, e)=>({
        type: "number",
        number: t1,
        unit: e
    }), $fd4eb456bcbd06f8$var$mu = (()=>{
    const t1 = {};
    return (e)=>{
        const n = e;
        if (n in t1) return t1[n];
        const i = [];
        let r = 0;
        for(; e;){
            if (++r > 1e3) {
                e = "";
                break;
            }
            const t1 = $fd4eb456bcbd06f8$var$fu(e), n = t1.nodes[0];
            if (null == n || 0 === n.terms.length) break;
            i.push(n), e = t1.remainingInput;
        }
        return t1[n] = i;
    };
})(), $fd4eb456bcbd06f8$var$fu = (()=>{
    const t1 = /^(\-\-|[a-z\u0240-\uffff])/i, e = /^([\*\+\/]|[\-]\s)/i, n = /^[\),]/;
    return (i)=>{
        const r = [];
        for(; i.length && (i = i.trim(), !n.test(i));)if ("(" === i[0]) {
            const { nodes: t1, remainingInput: e } = $fd4eb456bcbd06f8$var$xu(i);
            i = e, r.push({
                type: "function",
                name: {
                    type: "ident",
                    value: "calc"
                },
                arguments: t1
            });
        } else if (t1.test(i)) {
            const t1 = $fd4eb456bcbd06f8$var$gu(i), e = t1.nodes[0];
            if ("(" === (i = t1.remainingInput)[0]) {
                const { nodes: t1, remainingInput: n } = $fd4eb456bcbd06f8$var$xu(i);
                r.push({
                    type: "function",
                    name: e,
                    arguments: t1
                }), i = n;
            } else r.push(e);
        } else if (e.test(i)) r.push({
            type: "operator",
            value: i[0]
        }), i = i.slice(1);
        else {
            const { nodes: t1, remainingInput: e } = "#" === i[0] ? $fd4eb456bcbd06f8$var$yu(i) : $fd4eb456bcbd06f8$var$vu(i);
            if (0 === t1.length) break;
            r.push(t1[0]), i = e;
        }
        return {
            nodes: [
                {
                    type: "expression",
                    terms: r
                }
            ],
            remainingInput: i
        };
    };
})(), $fd4eb456bcbd06f8$var$gu = (()=>{
    const t1 = /[^a-z0-9_\-\u0240-\uffff]/i;
    return (e)=>{
        const n = e.match(t1);
        return {
            nodes: [
                {
                    type: "ident",
                    value: null == n ? e : e.substr(0, n.index)
                }
            ],
            remainingInput: null == n ? "" : e.substr(n.index)
        };
    };
})(), $fd4eb456bcbd06f8$var$vu = (()=>{
    const t1 = /[\+\-]?(\d+[\.]\d+|\d+|[\.]\d+)([eE][\+\-]?\d+)?/, e = /^[a-z%]+/i, n = /^(m|mm|cm|rad|deg|[%])$/;
    return (i)=>{
        const r = i.match(t1), s = null == r ? "0" : r[0], a = (i = null == s ? i : i.slice(s.length)).match(e);
        let o = null != a && "" !== a[0] ? a[0] : null;
        const l = null == a ? i : i.slice(o.length);
        return null == o || n.test(o) || (o = null), {
            nodes: [
                {
                    type: "number",
                    number: parseFloat(s) || 0,
                    unit: o
                }
            ],
            remainingInput: l
        };
    };
})(), $fd4eb456bcbd06f8$var$yu = (()=>{
    const t1 = /^[a-f0-9]*/i;
    return (e)=>{
        const n = (e = e.slice(1).trim()).match(t1);
        return {
            nodes: null == n ? [] : [
                {
                    type: "hex",
                    value: n[0]
                }
            ],
            remainingInput: null == n ? e : e.slice(n[0].length)
        };
    };
})(), $fd4eb456bcbd06f8$var$xu = (t1)=>{
    const e = [];
    for(t1 = t1.slice(1).trim(); t1.length;){
        const n = $fd4eb456bcbd06f8$var$fu(t1);
        if (e.push(n.nodes[0]), "," === (t1 = n.remainingInput.trim())[0]) t1 = t1.slice(1).trim();
        else if (")" === t1[0]) {
            t1 = t1.slice(1);
            break;
        }
    }
    return {
        nodes: e,
        remainingInput: t1
    };
}, $fd4eb456bcbd06f8$var$bu = Symbol("visitedTypes");
class $fd4eb456bcbd06f8$var$_u {
    constructor(t1){
        this[$fd4eb456bcbd06f8$var$bu] = t1;
    }
    walk(t1, e) {
        const n = t1.slice();
        for(; n.length;){
            const t1 = n.shift();
            switch(this[$fd4eb456bcbd06f8$var$bu].indexOf(t1.type) > -1 && e(t1), t1.type){
                case "expression":
                    n.unshift(...t1.terms);
                    break;
                case "function":
                    n.unshift(t1.name, ...t1.arguments);
            }
        }
    }
}
const $fd4eb456bcbd06f8$var$wu = Object.freeze({
    type: "number",
    number: 0,
    unit: null
}), $fd4eb456bcbd06f8$var$Mu = (t1, e = 0)=>{
    let { number: n, unit: i } = t1;
    if (isFinite(n)) {
        if ("rad" === t1.unit || null == t1.unit) return t1;
    } else n = e, i = "rad";
    return {
        type: "number",
        number: ("deg" === i && null != n ? n : 0) * Math.PI / 180,
        unit: "rad"
    };
}, $fd4eb456bcbd06f8$var$Su = (t1, e = 0)=>{
    let n, { number: i, unit: r } = t1;
    if (isFinite(i)) {
        if ("m" === t1.unit) return t1;
    } else i = e, r = "m";
    switch(r){
        default:
            n = 1;
            break;
        case "cm":
            n = .01;
            break;
        case "mm":
            n = .001;
    }
    return {
        type: "number",
        number: n * i,
        unit: "m"
    };
}, $fd4eb456bcbd06f8$var$Tu = (()=>{
    const t1 = (t1)=>t1, e = {
        rad: t1,
        deg: $fd4eb456bcbd06f8$var$Mu,
        m: t1,
        mm: $fd4eb456bcbd06f8$var$Su,
        cm: $fd4eb456bcbd06f8$var$Su
    };
    return (t1, n = $fd4eb456bcbd06f8$var$wu)=>{
        isFinite(t1.number) || (t1.number = n.number, t1.unit = n.unit);
        const { unit: i } = t1;
        if (null == i) return t1;
        const r = e[i];
        return null == r ? n : r(t1);
    };
})();
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /* @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $fd4eb456bcbd06f8$var$Eu extends $fd4eb456bcbd06f8$var$Kc {
    constructor(t1){
        super(document.createElement("div")), this.normal = new $fd4eb456bcbd06f8$var$V(0, 1, 0), this.initialized = !1, this.referenceCount = 1, this.pivot = document.createElement("div"), this.slot = document.createElement("slot"), this.element.classList.add("annotation-wrapper"), this.slot.name = t1.name, this.element.appendChild(this.pivot), this.pivot.appendChild(this.slot), this.updatePosition(t1.position), this.updateNormal(t1.normal);
    }
    get facingCamera() {
        return !this.element.classList.contains("hide");
    }
    show() {
        this.facingCamera && this.initialized || this.updateVisibility(!0);
    }
    hide() {
        !this.facingCamera && this.initialized || this.updateVisibility(!1);
    }
    increment() {
        this.referenceCount++;
    }
    decrement() {
        return this.referenceCount > 0 && --this.referenceCount, 0 === this.referenceCount;
    }
    updatePosition(t1) {
        if (null == t1) return;
        const e = $fd4eb456bcbd06f8$var$mu(t1)[0].terms;
        for(let t1 = 0; t1 < 3; ++t1)this.position.setComponent(t1, $fd4eb456bcbd06f8$var$Tu(e[t1]).number);
        this.updateMatrixWorld();
    }
    updateNormal(t1) {
        if (null == t1) return;
        const e = $fd4eb456bcbd06f8$var$mu(t1)[0].terms;
        for(let t1 = 0; t1 < 3; ++t1)this.normal.setComponent(t1, $fd4eb456bcbd06f8$var$Tu(e[t1]).number);
    }
    orient(t1) {
        this.pivot.style.transform = `rotate(${t1}rad)`;
    }
    updateVisibility(t1) {
        t1 ? this.element.classList.remove("hide") : this.element.classList.add("hide"), this.slot.assignedNodes().forEach((e)=>{
            if (e.nodeType !== Node.ELEMENT_NODE) return;
            const n = e, i = n.dataset.visibilityAttribute;
            if (null != i) {
                const e = `data-${i}`;
                t1 ? n.setAttribute(e, "") : n.removeAttribute(e);
            }
            n.dispatchEvent(new CustomEvent("hotspot-visibility", {
                detail: {
                    visible: t1
                }
            }));
        }), this.initialized = !0;
    }
}
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fd4eb456bcbd06f8$var$Au = (t1, e, n)=>{
    let i = n;
    const r = new $fd4eb456bcbd06f8$var$V;
    return t1.traverseVisible((t1)=>{
        let n, s;
        t1.updateWorldMatrix(!1, !1);
        const a = t1.geometry;
        if (void 0 !== a) {
            if (a.isGeometry) {
                const o = a.vertices;
                for(n = 0, s = o.length; n < s; n++)r.copy(o[n]), t1.isSkinnedMesh ? t1.boneTransform(n, r) : r.applyMatrix4(t1.matrixWorld), i = e(i, r);
            } else if (a.isBufferGeometry) {
                const { position: o } = a.attributes;
                if (void 0 !== o) {
                    const a = ((t1)=>{
                        if (!t1.normalized) return 1;
                        const e = t1.array;
                        return e instanceof Int8Array ? 1 / 127 : e instanceof Uint8Array ? 1 / 255 : e instanceof Int16Array ? 1 / 32767 : e instanceof Uint16Array ? 1 / 65535 : 1;
                    })(o);
                    for(n = 0, s = o.count; n < s; n++)r.fromBufferAttribute(o, n), r.multiplyScalar(a), t1.isSkinnedMesh ? t1.boneTransform(n, r) : r.applyMatrix4(t1.matrixWorld), i = e(i, r);
                }
            }
        }
    }), i;
}, $fd4eb456bcbd06f8$var$Ru = {
    uniforms: {
        tDiffuse: {
            value: null
        },
        h: {
            value: 1 / 512
        }
    },
    vertexShader: "\n\n\t\tvarying vec2 vUv;\n\n\t\tvoid main() {\n\n\t\t\tvUv = uv;\n\t\t\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n\n\t\t}",
    fragmentShader: "\n\n\t\tuniform sampler2D tDiffuse;\n\t\tuniform float h;\n\n\t\tvarying vec2 vUv;\n\n\t\tvoid main() {\n\n\t\t\tvec4 sum = vec4( 0.0 );\n\n\t\t\tsum += texture2D( tDiffuse, vec2( vUv.x - 4.0 * h, vUv.y ) ) * 0.051;\n\t\t\tsum += texture2D( tDiffuse, vec2( vUv.x - 3.0 * h, vUv.y ) ) * 0.0918;\n\t\t\tsum += texture2D( tDiffuse, vec2( vUv.x - 2.0 * h, vUv.y ) ) * 0.12245;\n\t\t\tsum += texture2D( tDiffuse, vec2( vUv.x - 1.0 * h, vUv.y ) ) * 0.1531;\n\t\t\tsum += texture2D( tDiffuse, vec2( vUv.x, vUv.y ) ) * 0.1633;\n\t\t\tsum += texture2D( tDiffuse, vec2( vUv.x + 1.0 * h, vUv.y ) ) * 0.1531;\n\t\t\tsum += texture2D( tDiffuse, vec2( vUv.x + 2.0 * h, vUv.y ) ) * 0.12245;\n\t\t\tsum += texture2D( tDiffuse, vec2( vUv.x + 3.0 * h, vUv.y ) ) * 0.0918;\n\t\t\tsum += texture2D( tDiffuse, vec2( vUv.x + 4.0 * h, vUv.y ) ) * 0.051;\n\n\t\t\tgl_FragColor = sum;\n\n\t\t}"
}, $fd4eb456bcbd06f8$var$Cu = {
    uniforms: {
        tDiffuse: {
            value: null
        },
        v: {
            value: 1 / 512
        }
    },
    vertexShader: "\n\n\t\tvarying vec2 vUv;\n\n\t\tvoid main() {\n\n\t\t\tvUv = uv;\n\t\t\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n\n\t\t}",
    fragmentShader: "\n\n\t\tuniform sampler2D tDiffuse;\n\t\tuniform float v;\n\n\t\tvarying vec2 vUv;\n\n\t\tvoid main() {\n\n\t\t\tvec4 sum = vec4( 0.0 );\n\n\t\t\tsum += texture2D( tDiffuse, vec2( vUv.x, vUv.y - 4.0 * v ) ) * 0.051;\n\t\t\tsum += texture2D( tDiffuse, vec2( vUv.x, vUv.y - 3.0 * v ) ) * 0.0918;\n\t\t\tsum += texture2D( tDiffuse, vec2( vUv.x, vUv.y - 2.0 * v ) ) * 0.12245;\n\t\t\tsum += texture2D( tDiffuse, vec2( vUv.x, vUv.y - 1.0 * v ) ) * 0.1531;\n\t\t\tsum += texture2D( tDiffuse, vec2( vUv.x, vUv.y ) ) * 0.1633;\n\t\t\tsum += texture2D( tDiffuse, vec2( vUv.x, vUv.y + 1.0 * v ) ) * 0.1531;\n\t\t\tsum += texture2D( tDiffuse, vec2( vUv.x, vUv.y + 2.0 * v ) ) * 0.12245;\n\t\t\tsum += texture2D( tDiffuse, vec2( vUv.x, vUv.y + 3.0 * v ) ) * 0.0918;\n\t\t\tsum += texture2D( tDiffuse, vec2( vUv.x, vUv.y + 4.0 * v ) ) * 0.051;\n\n\t\t\tgl_FragColor = sum;\n\n\t\t}"
}, $fd4eb456bcbd06f8$var$Lu = [];
for(let t1 = 0; t1 < 256; t1++)$fd4eb456bcbd06f8$var$Lu[t1] = (t1 < 16 ? "0" : "") + t1.toString(16);
function $fd4eb456bcbd06f8$var$Pu(t1, e, n) {
    return (1 - n) * t1 + n * e;
}
/* @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $fd4eb456bcbd06f8$var$Du extends $fd4eb456bcbd06f8$var$Wt {
    constructor(t1, e, n){
        super(), this.camera = new $fd4eb456bcbd06f8$var$mn, this.renderTarget = null, this.renderTargetBlur = null, this.depthMaterial = new $fd4eb456bcbd06f8$var$_r, this.horizontalBlurMaterial = new $fd4eb456bcbd06f8$var$Ve($fd4eb456bcbd06f8$var$Ru), this.verticalBlurMaterial = new $fd4eb456bcbd06f8$var$Ve($fd4eb456bcbd06f8$var$Cu), this.intensity = 0, this.softness = 1, this.boundingBox = new $fd4eb456bcbd06f8$var$j, this.size = new $fd4eb456bcbd06f8$var$V, this.maxDimension = 0, this.isAnimated = !1, this.needsUpdate = !1;
        const { camera: i } = this;
        i.rotation.x = Math.PI / 2, i.left = -0.5, i.right = .5, i.bottom = -0.5, i.top = .5, this.add(i);
        const r = new $fd4eb456bcbd06f8$var$rn, s = new $fd4eb456bcbd06f8$var$re({
            opacity: 1,
            transparent: !0,
            side: 1
        });
        this.floor = new $fd4eb456bcbd06f8$var$Fe(r, s), this.floor.userData.shadow = !0, i.add(this.floor), this.blurPlane = new $fd4eb456bcbd06f8$var$Fe(r), this.blurPlane.visible = !1, i.add(this.blurPlane), t1.target.add(this), this.depthMaterial.onBeforeCompile = function(t1) {
            t1.fragmentShader = t1.fragmentShader.replace("gl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );", "gl_FragColor = vec4( vec3( 0.0 ), ( 1.0 - fragCoordZ ) * opacity );");
        }, this.horizontalBlurMaterial.depthTest = !1, this.verticalBlurMaterial.depthTest = !1, this.setScene(t1, e, n);
    }
    setScene(t1, e, n) {
        const { boundingBox: i, size: r, rotation: s, position: a } = this;
        if (this.isAnimated = t1.animationNames.length > 0, this.boundingBox.copy(t1.boundingBox), this.size.copy(t1.size), this.maxDimension = Math.max(r.x, r.y, r.z) * (this.isAnimated ? 2 : 1), this.boundingBox.getCenter(a), "back" === n) {
            const { min: t1, max: e } = i;
            [t1.y, t1.z] = [
                t1.z,
                t1.y
            ], [e.y, e.z] = [
                e.z,
                e.y
            ], [r.y, r.z] = [
                r.z,
                r.y
            ], s.x = Math.PI / 2, s.y = Math.PI;
        } else s.x = 0, s.y = 0;
        if (this.isAnimated) {
            const t1 = i.min.y, e = i.max.y;
            r.y = this.maxDimension, i.expandByVector(r.subScalar(this.maxDimension).multiplyScalar(-0.5)), i.min.y = t1, i.max.y = e, r.set(this.maxDimension, e - t1, this.maxDimension);
        }
        "bottom" === n ? a.y = i.min.y : a.z = i.min.y, this.setSoftness(e);
    }
    setSoftness(t1) {
        this.softness = t1;
        const { size: e, camera: n } = this, i = this.isAnimated ? 2 : 1, r = i * Math.pow(2, 9 - 3 * t1);
        this.setMapSize(r);
        const s = e.y / 2, a = e.y * i;
        n.near = 0, n.far = $fd4eb456bcbd06f8$var$Pu(a, s, t1), this.depthMaterial.opacity = 1 / t1, n.updateProjectionMatrix(), this.setIntensity(this.intensity), this.setOffset(0);
    }
    setMapSize(t1) {
        const { size: e } = this;
        this.isAnimated && (t1 *= 2);
        const n = Math.floor(e.x > e.z ? t1 : t1 * e.x / e.z), i = Math.floor(e.x > e.z ? t1 * e.z / e.x : t1), r = 10 + n, s = 10 + i;
        if (null == this.renderTarget || this.renderTarget.width === r && this.renderTarget.height === s || (this.renderTarget.dispose(), this.renderTarget = null, this.renderTargetBlur.dispose(), this.renderTargetBlur = null), null == this.renderTarget) {
            const t1 = {
                format: 1023
            };
            this.renderTarget = new $fd4eb456bcbd06f8$var$k(r, s, t1), this.renderTargetBlur = new $fd4eb456bcbd06f8$var$k(r, s, t1), this.floor.material.map = this.renderTarget.texture;
        }
        this.camera.scale.set(e.x * (1 + 10 / n), e.z * (1 + 10 / i), 1), this.needsUpdate = !0;
    }
    setIntensity(t1) {
        this.intensity = t1, t1 > 0 ? (this.visible = !0, this.floor.visible = !0, this.floor.material.opacity = t1 * $fd4eb456bcbd06f8$var$Pu(.3, 1, this.softness * this.softness)) : (this.visible = !1, this.floor.visible = !1);
    }
    getIntensity() {
        return this.intensity;
    }
    setOffset(t1) {
        this.floor.position.z = -t1 + .001 * this.maxDimension;
    }
    render(t1, e) {
        e.overrideMaterial = this.depthMaterial;
        const n = t1.getClearAlpha();
        t1.setClearAlpha(0), this.floor.visible = !1;
        const i = t1.xr.enabled;
        t1.xr.enabled = !1;
        const r = t1.getRenderTarget();
        t1.setRenderTarget(this.renderTarget), t1.render(e, this.camera), e.overrideMaterial = null, this.floor.visible = !0, this.blurShadow(t1), t1.xr.enabled = i, t1.setRenderTarget(r), t1.setClearAlpha(n);
    }
    blurShadow(t1) {
        const { camera: e, horizontalBlurMaterial: n, verticalBlurMaterial: i, renderTarget: r, renderTargetBlur: s, blurPlane: a } = this;
        a.visible = !0, a.material = n, n.uniforms.h.value = 1 / this.renderTarget.width, n.uniforms.tDiffuse.value = this.renderTarget.texture, t1.setRenderTarget(s), t1.render(a, e), a.material = i, i.uniforms.v.value = 1 / this.renderTarget.height, i.uniforms.tDiffuse.value = this.renderTargetBlur.texture, t1.setRenderTarget(r), t1.render(a, e), a.visible = !1;
    }
}
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fd4eb456bcbd06f8$var$Iu = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$Ou = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$Nu = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$Fu = new class {
    constructor(t1, e, n = 0, i = 1 / 0){
        this.ray = new $fd4eb456bcbd06f8$var$yt(t1, e), this.near = n, this.far = i, this.camera = null, this.layers = new $fd4eb456bcbd06f8$var$Lt, this.params = {
            Mesh: {},
            Line: {
                threshold: 1
            },
            LOD: {},
            Points: {
                threshold: 1
            },
            Sprite: {}
        };
    }
    set(t1, e) {
        this.ray.set(t1, e);
    }
    setFromCamera(t1, e) {
        e.isPerspectiveCamera ? (this.ray.origin.setFromMatrixPosition(e.matrixWorld), this.ray.direction.set(t1.x, t1.y, .5).unproject(e).sub(this.ray.origin).normalize(), this.camera = e) : e.isOrthographicCamera ? (this.ray.origin.set(t1.x, t1.y, (e.near + e.far) / (e.near - e.far)).unproject(e), this.ray.direction.set(0, 0, -1).transformDirection(e.matrixWorld), this.camera = e) : console.error("THREE.Raycaster: Unsupported camera type: " + e.type);
    }
    intersectObject(t1, e = !0, n = []) {
        return $fd4eb456bcbd06f8$var$Jo(t1, this, n, e), n.sort($fd4eb456bcbd06f8$var$Yo), n;
    }
    intersectObjects(t1, e = !0, n = []) {
        for(let i = 0, r = t1.length; i < r; i++)$fd4eb456bcbd06f8$var$Jo(t1[i], this, n, e);
        return n.sort($fd4eb456bcbd06f8$var$Yo), n;
    }
}, $fd4eb456bcbd06f8$var$Uu = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$ku = new $fd4eb456bcbd06f8$var$g;
class $fd4eb456bcbd06f8$var$Bu extends $fd4eb456bcbd06f8$var$Nr {
    constructor({ canvas: t1, element: e, width: n, height: i }){
        super(), this.context = null, this.annotationRenderer = new $fd4eb456bcbd06f8$var$iu, this.schemaElement = document.createElement("script"), this.width = 1, this.height = 1, this.aspect = 1, this.renderCount = 0, this.externalRenderer = null, this.camera = new $fd4eb456bcbd06f8$var$We(45, 1, .1, 100), this.xrCamera = null, this.url = null, this.target = new $fd4eb456bcbd06f8$var$Wt, this.modelContainer = new $fd4eb456bcbd06f8$var$Wt, this.animationNames = [], this.boundingBox = new $fd4eb456bcbd06f8$var$j, this.boundingSphere = new $fd4eb456bcbd06f8$var$ct, this.size = new $fd4eb456bcbd06f8$var$V, this.idealAspect = 0, this.framedFoVDeg = 0, this.shadow = null, this.shadowIntensity = 0, this.shadowSoftness = 1, this.bakedShadows = new Set, this.exposure = 1, this.canScale = !0, this.tightBounds = !1, this.isDirty = !1, this.goalTarget = new $fd4eb456bcbd06f8$var$V, this.targetDamperX = new $fd4eb456bcbd06f8$var$du, this.targetDamperY = new $fd4eb456bcbd06f8$var$du, this.targetDamperZ = new $fd4eb456bcbd06f8$var$du, this._currentGLTF = null, this.cancelPendingSourceChange = null, this.animationsByName = new Map, this.currentAnimationAction = null, this.name = "ModelScene", this.element = e, this.canvas = t1, this.camera = new $fd4eb456bcbd06f8$var$We(45, 1, .1, 100), this.camera.name = "MainCamera", this.add(this.target), this.setSize(n, i), this.target.name = "Target", this.modelContainer.name = "ModelContainer", this.target.add(this.modelContainer), this.mixer = new $fd4eb456bcbd06f8$var$$o(this.modelContainer);
        const { domElement: r } = this.annotationRenderer, { style: s } = r;
        s.display = "none", s.pointerEvents = "none", s.position = "absolute", s.top = "0", this.element.shadowRoot.querySelector(".default").appendChild(r), this.schemaElement.setAttribute("type", "application/ld+json");
    }
    createContext() {
        this.context = this.canvas.getContext("2d");
    }
    getCamera() {
        return null != this.xrCamera ? this.xrCamera : this.camera;
    }
    queueRender() {
        this.isDirty = !0;
    }
    shouldRender() {
        return this.isDirty;
    }
    hasRendered() {
        this.isDirty = !1;
    }
    async setObject(t1) {
        this.reset(), this.modelContainer.add(t1), await this.setupScene();
    }
    async setSource(t1, e = ()=>{}) {
        if (!t1 || t1 === this.url) return void e(1);
        if (this.reset(), this.url = t1, null != this.externalRenderer) {
            const t1 = await this.externalRenderer.load(e);
            return this.boundingSphere.radius = t1.framedRadius, this.idealAspect = t1.fieldOfViewAspect, void this.dispatchEvent({
                type: "model-load",
                url: this.url
            });
        }
        let n;
        null != this.cancelPendingSourceChange && (this.cancelPendingSourceChange(), this.cancelPendingSourceChange = null);
        try {
            n = await new Promise(async (n, i)=>{
                this.cancelPendingSourceChange = ()=>i();
                try {
                    n(await this.element[$fd4eb456bcbd06f8$var$Ep].loader.load(t1, this.element, e));
                } catch (t1) {
                    i(t1);
                }
            });
        } catch (t1) {
            if (null == t1) return;
            throw t1;
        }
        this.reset(), this.url = t1, this._currentGLTF = n, null != n && this.modelContainer.add(n.scene);
        const { animations: i } = n, r = new Map, s = [];
        for (const t1 of i)r.set(t1.name, t1), s.push(t1.name);
        this.animations = i, this.animationsByName = r, this.animationNames = s, await this.setupScene();
    }
    async setupScene() {
        this.updateBoundingBox(), await this.updateFraming(), this.updateShadow(), this.setShadowIntensity(this.shadowIntensity), this.dispatchEvent({
            type: "model-load",
            url: this.url
        });
    }
    reset() {
        this.url = null, this.queueRender(), null != this.shadow && this.shadow.setIntensity(0), this.bakedShadows.clear();
        const t1 = this._currentGLTF;
        if (null != t1) {
            for (const t1 of this.modelContainer.children)this.modelContainer.remove(t1);
            t1.dispose(), this._currentGLTF = null;
        }
        null != this.currentAnimationAction && (this.currentAnimationAction.stop(), this.currentAnimationAction = null), this.mixer.stopAllAction(), this.mixer.uncacheRoot(this);
    }
    get currentGLTF() {
        return this._currentGLTF;
    }
    setSize(t1, e) {
        if (this.width !== t1 || this.height !== e) {
            if (this.width = Math.max(t1, 1), this.height = Math.max(e, 1), this.annotationRenderer.setSize(t1, e), this.aspect = this.width / this.height, null != this.externalRenderer) {
                const n = $fd4eb456bcbd06f8$var$hu();
                this.externalRenderer.resize(t1 * n, e * n);
            }
            this.queueRender();
        }
    }
    markBakedShadow(t1) {
        t1.userData.shadow = !0, this.bakedShadows.add(t1);
    }
    unmarkBakedShadow(t1) {
        t1.userData.shadow = !1, t1.visible = !0, this.bakedShadows.delete(t1), this.boundingBox.expandByObject(t1);
    }
    findBakedShadows(t1) {
        const e = new $fd4eb456bcbd06f8$var$j;
        t1.traverse((t1)=>{
            const n = t1;
            if (!n.isMesh) return;
            if (!n.material.transparent) return;
            e.setFromObject(n);
            const i = e.getSize($fd4eb456bcbd06f8$var$Uu), r = Math.min(i.x, i.y, i.z);
            Math.max(i.x, i.y, i.z) < 100 * r || this.markBakedShadow(n);
        });
    }
    checkBakedShadows() {
        const { min: t1, max: e } = this.boundingBox, n = new $fd4eb456bcbd06f8$var$j;
        this.boundingBox.getSize(this.size);
        for (const i of this.bakedShadows)n.setFromObject(i), n.min.y < t1.y + this.size.y / 100 && n.min.x <= t1.x && n.max.x >= e.x && n.min.z <= t1.z && n.max.z >= e.z || n.min.z < t1.z + this.size.z / 100 && n.min.x <= t1.x && n.max.x >= e.x && n.min.y <= t1.y && n.max.y >= e.y || this.unmarkBakedShadow(i);
    }
    updateBoundingBox() {
        if (this.target.remove(this.modelContainer), this.findBakedShadows(this.modelContainer), !0 === this.tightBounds) {
            const t1 = (t1, e)=>t1.expandByPoint(e);
            this.setBakedShadowVisibility(!1), this.boundingBox = $fd4eb456bcbd06f8$var$Au(this.modelContainer, t1, new $fd4eb456bcbd06f8$var$j), this.boundingBox.isEmpty() && (this.setBakedShadowVisibility(!0), this.bakedShadows.forEach((t1)=>this.unmarkBakedShadow(t1)), this.boundingBox = $fd4eb456bcbd06f8$var$Au(this.modelContainer, t1, new $fd4eb456bcbd06f8$var$j)), this.checkBakedShadows(), this.setBakedShadowVisibility();
        } else this.boundingBox.setFromObject(this.modelContainer);
        this.boundingBox.getSize(this.size), this.target.add(this.modelContainer);
    }
    async updateFraming() {
        this.target.remove(this.modelContainer), this.setBakedShadowVisibility(!1);
        const { center: t1 } = this.boundingSphere;
        !0 === this.tightBounds ? (this.element.requestUpdate("cameraTarget"), await this.element.updateComplete, t1.copy(this.getTarget())) : this.boundingBox.getCenter(t1);
        this.boundingSphere.radius = Math.sqrt($fd4eb456bcbd06f8$var$Au(this.modelContainer, (e, n)=>Math.max(e, t1.distanceToSquared(n)), 0));
        this.idealAspect = $fd4eb456bcbd06f8$var$Au(this.modelContainer, (e, n)=>{
            n.sub(t1);
            const i = Math.sqrt(n.x * n.x + n.z * n.z);
            return Math.max(e, i / (this.idealCameraDistance() - Math.abs(n.y)));
        }, 0) / Math.tan(this.framedFoVDeg / 2 * Math.PI / 180), this.setBakedShadowVisibility(), this.target.add(this.modelContainer);
    }
    setBakedShadowVisibility(t1 = this.shadowIntensity <= 0) {
        for (const e of this.bakedShadows)e.visible = t1;
    }
    idealCameraDistance() {
        const t1 = this.framedFoVDeg / 2 * Math.PI / 180;
        return this.boundingSphere.radius / Math.sin(t1);
    }
    adjustedFoV(t1) {
        const e = Math.tan(t1 / 2 * Math.PI / 180) * Math.max(1, this.idealAspect / this.aspect);
        return 2 * Math.atan(e) * 180 / Math.PI;
    }
    getNDC(t1, e) {
        if (null != this.xrCamera) $fd4eb456bcbd06f8$var$ku.set(t1 / window.screen.width, e / window.screen.height);
        else {
            const n = this.element.getBoundingClientRect();
            $fd4eb456bcbd06f8$var$ku.set((t1 - n.x) / this.width, (e - n.y) / this.height);
        }
        return $fd4eb456bcbd06f8$var$ku.multiplyScalar(2).subScalar(1), $fd4eb456bcbd06f8$var$ku.y *= -1, $fd4eb456bcbd06f8$var$ku;
    }
    getSize() {
        return {
            width: this.width,
            height: this.height
        };
    }
    setTarget(t1, e, n) {
        this.goalTarget.set(-t1, -e, -n);
    }
    setTargetDamperDecayTime(t1) {
        this.targetDamperX.setDecayTime(t1), this.targetDamperY.setDecayTime(t1), this.targetDamperZ.setDecayTime(t1);
    }
    getTarget() {
        return $fd4eb456bcbd06f8$var$Uu.copy(this.goalTarget).multiplyScalar(-1);
    }
    jumpToGoal() {
        this.updateTarget(1e4);
    }
    updateTarget(t1) {
        const e = this.goalTarget, n = this.target.position;
        if (e.equals(n)) return !1;
        {
            const i = this.boundingSphere.radius / 10;
            let { x: r, y: s, z: a } = n;
            return r = this.targetDamperX.update(r, e.x, t1, i), s = this.targetDamperY.update(s, e.y, t1, i), a = this.targetDamperZ.update(a, e.z, t1, i), this.target.position.set(r, s, a), this.target.updateMatrixWorld(), this.queueRender(), !0;
        }
    }
    pointTowards(t1, e) {
        const { x: n, z: i } = this.position;
        this.yaw = Math.atan2(t1 - n, e - i);
    }
    set yaw(t1) {
        this.rotation.y = t1, this.queueRender();
    }
    get yaw() {
        return this.rotation.y;
    }
    set animationTime(t1) {
        this.mixer.setTime(t1), this.queueShadowRender();
    }
    get animationTime() {
        if (null != this.currentAnimationAction) {
            const t1 = Math.max(this.currentAnimationAction._loopCount, 0);
            return 2202 === this.currentAnimationAction.loop && 1 == (1 & t1) ? this.duration - this.currentAnimationAction.time : this.currentAnimationAction.time;
        }
        return 0;
    }
    set animationTimeScale(t1) {
        this.mixer.timeScale = t1;
    }
    get animationTimeScale() {
        return this.mixer.timeScale;
    }
    get duration() {
        return null != this.currentAnimationAction && this.currentAnimationAction.getClip() ? this.currentAnimationAction.getClip().duration : 0;
    }
    get hasActiveAnimation() {
        return null != this.currentAnimationAction;
    }
    playAnimation(t1 = null, e = 0, n = 2201, i = 1 / 0) {
        if (null == this._currentGLTF) return;
        const { animations: r } = this;
        if (null == r || 0 === r.length) return void console.warn("Cannot play animation (model does not have any animations)");
        let s = null;
        if (null != t1 && (s = this.animationsByName.get(t1), null == s)) {
            const e = parseInt(t1);
            !isNaN(e) && e >= 0 && e < r.length && (s = r[e]);
        }
        null == s && (s = r[0]);
        try {
            const { currentAnimationAction: t1 } = this, r = this.mixer.clipAction(s, this);
            this.currentAnimationAction = r, this.element.paused ? this.mixer.stopAllAction() : (r.paused = !1, null != t1 && r !== t1 ? r.crossFadeFrom(t1, e, !1) : this.animationTimeScale > 0 && this.animationTime == this.duration && (this.animationTime = 0)), r.setLoop(n, i), r.enabled = !0, r.clampWhenFinished = !0, r.play();
        } catch (t1) {
            console.error(t1);
        }
    }
    stopAnimation() {
        this.currentAnimationAction = null, this.mixer.stopAllAction();
    }
    updateAnimation(t1) {
        this.mixer.update(t1), this.queueShadowRender();
    }
    subscribeMixerEvent(t1, e) {
        this.mixer.addEventListener(t1, e);
    }
    updateShadow() {
        const t1 = this.shadow;
        if (null != t1) {
            const e = "wall" === this.element.arPlacement ? "back" : "bottom";
            t1.setScene(this, this.shadowSoftness, e), t1.needsUpdate = !0;
        }
    }
    renderShadow(t1) {
        const e = this.shadow;
        null != e && 1 == e.needsUpdate && (e.render(t1, this), e.needsUpdate = !1);
    }
    queueShadowRender() {
        null != this.shadow && (this.shadow.needsUpdate = !0);
    }
    setShadowIntensity(t1) {
        if (this.shadowIntensity = t1, null != this._currentGLTF && (this.setBakedShadowVisibility(), !(t1 <= 0 && null == this.shadow))) {
            if (null == this.shadow) {
                const t1 = "wall" === this.element.arPlacement ? "back" : "bottom";
                this.shadow = new $fd4eb456bcbd06f8$var$Du(this, this.shadowSoftness, t1);
            }
            this.shadow.setIntensity(t1);
        }
    }
    setShadowSoftness(t1) {
        this.shadowSoftness = t1;
        const e = this.shadow;
        null != e && e.setSoftness(t1);
    }
    setShadowOffset(t1) {
        const e = this.shadow;
        null != e && e.setOffset(t1);
    }
    get raycaster() {
        return $fd4eb456bcbd06f8$var$Fu;
    }
    positionAndNormalFromPoint(t1, e = this) {
        this.raycaster.setFromCamera(t1, this.getCamera());
        const n = this.raycaster.intersectObject(e, !0).find((t1)=>!t1.object.userData.shadow);
        return null == n || null == n.face ? null : null == n.uv ? {
            position: n.point,
            normal: n.face.normal,
            uv: null
        } : (n.face.normal.applyNormalMatrix((new $fd4eb456bcbd06f8$var$v).getNormalMatrix(n.object.matrixWorld)), {
            position: n.point,
            normal: n.face.normal,
            uv: n.uv
        });
    }
    addHotspot(t1) {
        this.target.add(t1), this.annotationRenderer.domElement.appendChild(t1.element);
    }
    removeHotspot(t1) {
        this.target.remove(t1);
    }
    forHotspots(t1) {
        const { children: e } = this.target;
        for(let n = 0, i = e.length; n < i; n++){
            const i = e[n];
            i instanceof $fd4eb456bcbd06f8$var$Eu && t1(i);
        }
    }
    updateHotspots(t1) {
        this.forHotspots((e)=>{
            $fd4eb456bcbd06f8$var$Iu.copy(t1), $fd4eb456bcbd06f8$var$Ou.setFromMatrixPosition(e.matrixWorld), $fd4eb456bcbd06f8$var$Iu.sub($fd4eb456bcbd06f8$var$Ou), $fd4eb456bcbd06f8$var$Nu.copy(e.normal).transformDirection(this.target.matrixWorld), $fd4eb456bcbd06f8$var$Iu.dot($fd4eb456bcbd06f8$var$Nu) < 0 ? e.hide() : e.show();
        });
    }
    orientHotspots(t1) {
        this.forHotspots((e)=>{
            e.orient(t1);
        });
    }
    setHotspotsVisibility(t1) {
        this.forHotspots((e)=>{
            e.visible = t1;
        });
    }
    updateSchema(t1) {
        var e;
        const { schemaElement: n, element: i } = this, { alt: r, poster: s, iosSrc: a } = i;
        if (null != t1) {
            const i = [
                {
                    "@type": "MediaObject",
                    contentUrl: t1,
                    encodingFormat: "gltf" === (null === (e = t1.split(".").pop()) || void 0 === e ? void 0 : e.toLowerCase()) ? "model/gltf+json" : "model/gltf-binary"
                }
            ];
            a && i.push({
                "@type": "MediaObject",
                contentUrl: a,
                encodingFormat: "model/vnd.usdz+zip"
            });
            const o = {
                "@context": "http://schema.org/",
                "@type": "3DModel",
                image: null != s ? s : void 0,
                name: null != r ? r : void 0,
                encoding: i
            };
            n.textContent = JSON.stringify(o), document.head.appendChild(n);
        } else null != n.parentElement && n.parentElement.removeChild(n);
    }
}
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $fd4eb456bcbd06f8$var$zu = function(t1, e, n, i) {
    for(var r, s = arguments.length, a = s < 3 ? e : null === i ? i = Object.getOwnPropertyDescriptor(e, n) : i, o = t1.length - 1; o >= 0; o--)(r = t1[o]) && (a = (s < 3 ? r(a) : s > 3 ? r(e, n, a) : r(e, n)) || a);
    return s > 3 && a && Object.defineProperty(e, n, a), a;
};
const $fd4eb456bcbd06f8$var$Hu = Symbol("currentEnvironmentMap"), $fd4eb456bcbd06f8$var$Vu = Symbol("applyEnvironmentMap"), $fd4eb456bcbd06f8$var$Gu = Symbol("updateEnvironment"), $fd4eb456bcbd06f8$var$Wu = Symbol("cancelEnvironmentUpdate"), $fd4eb456bcbd06f8$var$ju = Symbol("onPreload");
class $fd4eb456bcbd06f8$var$qu {
    constructor(t1, e, n, i, r){
        this.xrLight = t1, this.renderer = e, this.lightProbe = n, this.xrWebGLBinding = null, this.estimationStartCallback = r, this.frameCallback = this.onXRFrame.bind(this);
        const s = e.xr.getSession();
        if (i && "XRWebGLBinding" in window) {
            const n = new $fd4eb456bcbd06f8$var$Xe(16);
            t1.environment = n.texture;
            const i = e.getContext();
            switch(s.preferredReflectionFormat){
                case "srgba8":
                    i.getExtension("EXT_sRGB");
                    break;
                case "rgba16f":
                    i.getExtension("OES_texture_half_float");
            }
            this.xrWebGLBinding = new XRWebGLBinding(s, i), this.lightProbe.addEventListener("reflectionchange", ()=>{
                this.updateReflection();
            });
        }
        s.requestAnimationFrame(this.frameCallback);
    }
    updateReflection() {
        const t1 = this.renderer.properties.get(this.xrLight.environment);
        if (t1) {
            const e = this.xrWebGLBinding.getReflectionCubeMap(this.lightProbe);
            e && (t1.__webglTexture = e, this.xrLight.environment.needsPMREMUpdate = !0);
        }
    }
    onXRFrame(t1, e) {
        if (!this.xrLight) return;
        e.session.requestAnimationFrame(this.frameCallback);
        const n = e.getLightEstimate(this.lightProbe);
        if (n) {
            this.xrLight.lightProbe.sh.fromArray(n.sphericalHarmonicsCoefficients), this.xrLight.lightProbe.intensity = 1;
            const t1 = Math.max(1, Math.max(n.primaryLightIntensity.x, Math.max(n.primaryLightIntensity.y, n.primaryLightIntensity.z)));
            this.xrLight.directionalLight.color.setRGB(n.primaryLightIntensity.x / t1, n.primaryLightIntensity.y / t1, n.primaryLightIntensity.z / t1), this.xrLight.directionalLight.intensity = t1, this.xrLight.directionalLight.position.copy(n.primaryLightDirection), this.estimationStartCallback && (this.estimationStartCallback(), this.estimationStartCallback = null);
        }
    }
    dispose() {
        this.xrLight = null, this.renderer = null, this.lightProbe = null, this.xrWebGLBinding = null;
    }
}
class $fd4eb456bcbd06f8$var$Xu extends $fd4eb456bcbd06f8$var$Rr {
    constructor(t1, e = !0){
        super(), this.lightProbe = new $fd4eb456bcbd06f8$var$Po, this.lightProbe.intensity = 0, this.add(this.lightProbe), this.directionalLight = new $fd4eb456bcbd06f8$var$Co, this.directionalLight.intensity = 0, this.add(this.directionalLight), this.environment = null;
        let n = null, i = !1;
        t1.xr.addEventListener("sessionstart", ()=>{
            const r = t1.xr.getSession();
            "requestLightProbe" in r && r.requestLightProbe({
                reflectionFormat: r.preferredReflectionFormat
            }).then((r)=>{
                n = new $fd4eb456bcbd06f8$var$qu(this, t1, r, e, ()=>{
                    i = !0, this.dispatchEvent({
                        type: "estimationstart"
                    });
                });
            });
        }), t1.xr.addEventListener("sessionend", ()=>{
            n && (n.dispose(), n = null), i && this.dispatchEvent({
                type: "estimationend"
            });
        }), this.dispose = ()=>{
            n && (n.dispose(), n = null), this.remove(this.lightProbe), this.lightProbe = null, this.remove(this.directionalLight), this.directionalLight = null, this.environment = null;
        };
    }
}
/* @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fd4eb456bcbd06f8$var$$u = Math.PI / 24, $fd4eb456bcbd06f8$var$Yu = new $fd4eb456bcbd06f8$var$g, $fd4eb456bcbd06f8$var$Ju = (t1, e, n)=>{
    let i = e > 0 ? n > 0 ? 0 : -Math.PI / 2 : n > 0 ? Math.PI / 2 : Math.PI;
    for(let r = 0; r <= 12; ++r)t1.push(e + .17 * Math.cos(i), n + .17 * Math.sin(i), 0, e + .2 * Math.cos(i), n + .2 * Math.sin(i), 0), i += $fd4eb456bcbd06f8$var$$u;
};
class $fd4eb456bcbd06f8$var$Ku extends $fd4eb456bcbd06f8$var$Fe {
    constructor(t1, e){
        const n = new $fd4eb456bcbd06f8$var$ye, i = [], r = [], { size: s, boundingBox: a } = t1, o = s.x / 2, l = ("back" === e ? s.y : s.z) / 2;
        $fd4eb456bcbd06f8$var$Ju(r, o, l), $fd4eb456bcbd06f8$var$Ju(r, -o, l), $fd4eb456bcbd06f8$var$Ju(r, -o, -l), $fd4eb456bcbd06f8$var$Ju(r, o, -l);
        const h = r.length / 3;
        for(let t1 = 0; t1 < h - 2; t1 += 2)i.push(t1, t1 + 1, t1 + 3, t1, t1 + 3, t1 + 2);
        const c = h - 2;
        i.push(c, c + 1, 1, c, 1, 0), n.setAttribute("position", new $fd4eb456bcbd06f8$var$ce(r, 3)), n.setIndex(i), super(n), this.side = e;
        const u = this.material;
        switch(u.side = 0, u.transparent = !0, u.opacity = 0, this.goalOpacity = 0, this.opacityDamper = new $fd4eb456bcbd06f8$var$du, this.hitPlane = new $fd4eb456bcbd06f8$var$Fe(new $fd4eb456bcbd06f8$var$rn(2 * (o + .2), 2 * (l + .2))), this.hitPlane.visible = !1, this.add(this.hitPlane), a.getCenter(this.position), e){
            case "bottom":
                this.rotateX(-Math.PI / 2), this.shadowHeight = a.min.y, this.position.y = this.shadowHeight;
                break;
            case "back":
                this.shadowHeight = a.min.z, this.position.z = this.shadowHeight;
        }
        t1.target.add(this), this.offsetHeight = 0;
    }
    getHit(t1, e, n) {
        $fd4eb456bcbd06f8$var$Yu.set(e, -n), this.hitPlane.visible = !0;
        const i = t1.positionAndNormalFromPoint($fd4eb456bcbd06f8$var$Yu, this.hitPlane);
        return this.hitPlane.visible = !1, null == i ? null : i.position;
    }
    getExpandedHit(t1, e, n) {
        this.hitPlane.scale.set(1e3, 1e3, 1e3);
        const i = this.getHit(t1, e, n);
        return this.hitPlane.scale.set(1, 1, 1), i;
    }
    set offsetHeight(t1) {
        t1 -= .001, "back" === this.side ? this.position.z = this.shadowHeight + t1 : this.position.y = this.shadowHeight + t1;
    }
    get offsetHeight() {
        return "back" === this.side ? this.position.z - this.shadowHeight : this.position.y - this.shadowHeight;
    }
    set show(t1) {
        this.goalOpacity = t1 ? .75 : 0;
    }
    updateOpacity(t1) {
        const e = this.material;
        e.opacity = this.opacityDamper.update(e.opacity, this.goalOpacity, t1, 1), this.visible = e.opacity > 0;
    }
    dispose() {
        var t1;
        const { geometry: e, material: n } = this.hitPlane;
        e.dispose(), n.dispose(), this.geometry.dispose(), this.material.dispose(), null === (t1 = this.parent) || void 0 === t1 || t1.remove(this);
    }
}
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fd4eb456bcbd06f8$var$Zu = "not-presenting", $fd4eb456bcbd06f8$var$Qu = "session-started", $fd4eb456bcbd06f8$var$td = "object-placed", $fd4eb456bcbd06f8$var$ed = "failed", $fd4eb456bcbd06f8$var$nd = "tracking", $fd4eb456bcbd06f8$var$id = "not-tracking", $fd4eb456bcbd06f8$var$rd = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$sd = new $fd4eb456bcbd06f8$var$xt, $fd4eb456bcbd06f8$var$ad = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$od = new $fd4eb456bcbd06f8$var$We(45, 1, .1, 100);
class $fd4eb456bcbd06f8$var$ld extends $fd4eb456bcbd06f8$var$i {
    constructor(t1){
        super(), this.renderer = t1, this.currentSession = null, this.placeOnWall = !1, this.placementBox = null, this.lastTick = null, this.turntableRotation = null, this.oldShadowIntensity = null, this.oldBackground = null, this.oldEnvironment = null, this.frame = null, this.initialHitSource = null, this.transientHitTestSource = null, this.inputSource = null, this._presentedScene = null, this.resolveCleanup = null, this.exitWebXRButtonContainer = null, this.overlay = null, this.xrLight = null, this.tracking = !0, this.frames = 0, this.initialized = !1, this.oldTarget = new $fd4eb456bcbd06f8$var$V, this.placementComplete = !1, this.isTranslating = !1, this.isRotating = !1, this.isTwoFingering = !1, this.lastDragPosition = new $fd4eb456bcbd06f8$var$V, this.firstRatio = 0, this.lastAngle = 0, this.goalPosition = new $fd4eb456bcbd06f8$var$V, this.goalYaw = 0, this.goalScale = 1, this.xDamper = new $fd4eb456bcbd06f8$var$du, this.yDamper = new $fd4eb456bcbd06f8$var$du, this.zDamper = new $fd4eb456bcbd06f8$var$du, this.yawDamper = new $fd4eb456bcbd06f8$var$du, this.scaleDamper = new $fd4eb456bcbd06f8$var$du, this.onExitWebXRButtonContainerClick = ()=>this.stopPresenting(), this.onUpdateScene = ()=>{
            null != this.placementBox && this.isPresenting && (this.placementBox.dispose(), this.placementBox = new $fd4eb456bcbd06f8$var$Ku(this.presentedScene, this.placeOnWall ? "back" : "bottom"));
        }, this.onSelectStart = (t1)=>{
            const e = this.transientHitTestSource;
            if (null == e) return;
            const n = this.frame.getHitTestResultsForTransientInput(e), i = this.presentedScene, r = this.placementBox;
            if (1 === n.length) {
                this.inputSource = t1.inputSource;
                const { axes: e } = this.inputSource.gamepad, n = r.getHit(this.presentedScene, e[0], e[1]);
                r.show = !0, null != n ? (this.isTranslating = !0, this.lastDragPosition.copy(n)) : !1 === this.placeOnWall && (this.isRotating = !0, this.lastAngle = 1.5 * e[0]);
            } else if (2 === n.length) {
                r.show = !0, this.isTwoFingering = !0;
                const { separation: t1 } = this.fingerPolar(n);
                this.firstRatio = t1 / i.scale.x;
            }
        }, this.onSelectEnd = ()=>{
            this.isTranslating = !1, this.isRotating = !1, this.isTwoFingering = !1, this.inputSource = null, this.goalPosition.y += this.placementBox.offsetHeight * this.presentedScene.scale.x, this.placementBox.show = !1;
        }, this.threeRenderer = t1.threeRenderer, this.threeRenderer.xr.enabled = !0;
    }
    async resolveARSession() {
        $fd4eb456bcbd06f8$var$su();
        const t1 = await navigator.xr.requestSession("immersive-ar", {
            requiredFeatures: [
                "hit-test"
            ],
            optionalFeatures: [
                "dom-overlay",
                "light-estimation"
            ],
            domOverlay: {
                root: this.overlay
            }
        });
        return this.threeRenderer.xr.setReferenceSpaceType("local"), await this.threeRenderer.xr.setSession(t1), this.threeRenderer.xr.cameraAutoUpdate = !1, t1;
    }
    get presentedScene() {
        return this._presentedScene;
    }
    async supportsPresentation() {
        try {
            return $fd4eb456bcbd06f8$var$su(), await navigator.xr.isSessionSupported("immersive-ar");
        } catch (t1) {
            return console.warn("Request to present in WebXR denied:"), console.warn(t1), console.warn("Falling back to next ar-mode"), !1;
        }
    }
    async present(t1, e = !1) {
        this.isPresenting && console.warn("Cannot present while a model is already presenting");
        let n = new Promise((t1, e)=>{
            requestAnimationFrame(()=>t1());
        });
        t1.setHotspotsVisibility(!1), t1.queueRender(), await n, this._presentedScene = t1, this.overlay = t1.element.shadowRoot.querySelector("div.default"), !0 === e && (this.xrLight = new $fd4eb456bcbd06f8$var$Xu(this.threeRenderer), this.xrLight.addEventListener("estimationstart", ()=>{
            if (!this.isPresenting || null == this.xrLight) return;
            const t1 = this.presentedScene;
            t1.add(this.xrLight), this.oldEnvironment = t1.environment, t1.environment = this.xrLight.environment;
        }));
        const i = await this.resolveARSession();
        i.addEventListener("end", ()=>{
            this.postSessionCleanup();
        }, {
            once: !0
        });
        const r = t1.element.shadowRoot.querySelector(".slot.exit-webxr-ar-button");
        r.classList.add("enabled"), r.addEventListener("click", this.onExitWebXRButtonContainerClick), this.exitWebXRButtonContainer = r;
        const s = await i.requestReferenceSpace("viewer");
        this.tracking = !0, this.frames = 0, this.initialized = !1, this.turntableRotation = t1.yaw, this.goalYaw = t1.yaw, this.goalScale = 1, this.oldBackground = t1.background, t1.background = null, this.oldShadowIntensity = t1.shadowIntensity, t1.setShadowIntensity(.01), this.oldTarget.copy(t1.getTarget()), t1.addEventListener("model-load", this.onUpdateScene);
        const a = 20 * Math.PI / 180, o = !0 === this.placeOnWall ? void 0 : new XRRay(new DOMPoint(0, 0, 0), {
            x: 0,
            y: -Math.sin(a),
            z: -Math.cos(a)
        });
        i.requestHitTestSource({
            space: s,
            offsetRay: o
        }).then((t1)=>{
            this.initialHitSource = t1;
        }), this.currentSession = i, this.placementBox = new $fd4eb456bcbd06f8$var$Ku(t1, this.placeOnWall ? "back" : "bottom"), this.placementComplete = !1, this.lastTick = performance.now(), this.dispatchEvent({
            type: "status",
            status: $fd4eb456bcbd06f8$var$Qu
        });
    }
    async stopPresenting() {
        if (!this.isPresenting) return;
        const t1 = new Promise((t1)=>{
            this.resolveCleanup = t1;
        });
        try {
            await this.currentSession.end(), await t1;
        } catch (t1) {
            console.warn("Error while trying to end WebXR AR session"), console.warn(t1), this.postSessionCleanup();
        }
    }
    get isPresenting() {
        return null != this.presentedScene;
    }
    get target() {
        return this.oldTarget;
    }
    updateTarget() {
        const t1 = this.presentedScene;
        if (null != t1) {
            const e = t1.getTarget();
            this.oldTarget.copy(e), this.placeOnWall ? e.z = t1.boundingBox.min.z : e.y = t1.boundingBox.min.y, t1.setTarget(e.x, e.y, e.z);
        }
    }
    postSessionCleanup() {
        const t1 = this.currentSession;
        null != t1 && (t1.removeEventListener("selectstart", this.onSelectStart), t1.removeEventListener("selectend", this.onSelectEnd), this.currentSession = null);
        const e = this.presentedScene;
        if (null != e) {
            const { element: t1 } = e;
            null != this.xrLight && (e.remove(this.xrLight), null != this.oldEnvironment && (e.environment = this.oldEnvironment, this.oldEnvironment = null), this.xrLight.dispose(), this.xrLight = null), e.position.set(0, 0, 0), e.scale.set(1, 1, 1), e.setShadowOffset(0);
            const n = this.turntableRotation;
            null != n && (e.yaw = n);
            const i = this.oldShadowIntensity;
            null != i && e.setShadowIntensity(i);
            const r = this.oldBackground;
            null != r && (e.background = r);
            const s = this.oldTarget;
            e.setTarget(s.x, s.y, s.z), e.xrCamera = null, e.removeEventListener("model-load", this.onUpdateScene), e.orientHotspots(0), t1.requestUpdate("cameraTarget"), t1.requestUpdate("maxCameraOrbit"), t1[$fd4eb456bcbd06f8$var$Tp](t1.getBoundingClientRect());
        }
        this.renderer.height = 0;
        const n = this.exitWebXRButtonContainer;
        null != n && (n.classList.remove("enabled"), n.removeEventListener("click", this.onExitWebXRButtonContainerClick), this.exitWebXRButtonContainer = null);
        const i = this.transientHitTestSource;
        null != i && (i.cancel(), this.transientHitTestSource = null);
        const r = this.initialHitSource;
        null != r && (r.cancel(), this.initialHitSource = null), null != this.placementBox && (this.placementBox.dispose(), this.placementBox = null), this.lastTick = null, this.turntableRotation = null, this.oldShadowIntensity = null, this.oldBackground = null, this._presentedScene = null, this.frame = null, this.inputSource = null, this.overlay = null, null != this.resolveCleanup && this.resolveCleanup(), this.dispatchEvent({
            type: "status",
            status: $fd4eb456bcbd06f8$var$Zu
        });
    }
    updateView(t1) {
        const e = this.presentedScene, n = this.threeRenderer.xr;
        n.updateCamera($fd4eb456bcbd06f8$var$od), e.xrCamera = n.getCamera();
        const { elements: i } = e.getCamera().matrixWorld;
        if (e.orientHotspots(Math.atan2(i[1], i[5])), this.initialized || (this.placeInitially(), this.initialized = !0), t1.requestViewportScale && t1.recommendedViewportScale) {
            const e = t1.recommendedViewportScale;
            t1.requestViewportScale(Math.max(e, .25));
        }
        const r = this.currentSession.renderState.baseLayer.getViewport(t1);
        this.threeRenderer.setViewport(r.x, r.y, r.width, r.height);
    }
    placeInitially() {
        const t1 = this.presentedScene, { position: e, element: n } = t1, i = t1.getCamera(), { width: r, height: s } = this.overlay.getBoundingClientRect();
        t1.setSize(r, s), i.projectionMatrixInverse.copy(i.projectionMatrix).invert();
        const { theta: a, radius: o } = n.getCameraOrbit(), l = i.getWorldDirection($fd4eb456bcbd06f8$var$rd);
        t1.yaw = Math.atan2(-l.x, -l.z) - a, this.goalYaw = t1.yaw, e.copy(i.position).add(l.multiplyScalar(o)), this.updateTarget();
        const h = t1.getTarget();
        e.add(h).sub(this.oldTarget), this.goalPosition.copy(e), t1.setHotspotsVisibility(!0);
        const { session: c } = this.frame;
        c.addEventListener("selectstart", this.onSelectStart), c.addEventListener("selectend", this.onSelectEnd), c.requestHitTestSourceForTransientInput({
            profile: "generic-touchscreen"
        }).then((t1)=>{
            this.transientHitTestSource = t1;
        });
    }
    getTouchLocation() {
        const { axes: t1 } = this.inputSource.gamepad;
        let e = this.placementBox.getExpandedHit(this.presentedScene, t1[0], t1[1]);
        return null != e && ($fd4eb456bcbd06f8$var$rd.copy(e).sub(this.presentedScene.getCamera().position), $fd4eb456bcbd06f8$var$rd.length() > 10) ? null : e;
    }
    getHitPoint(t1) {
        const e = this.threeRenderer.xr.getReferenceSpace(), n = t1.getPose(e);
        if (null == n) return null;
        const i = $fd4eb456bcbd06f8$var$sd.fromArray(n.transform.matrix);
        return !0 === this.placeOnWall && (this.goalYaw = Math.atan2(i.elements[4], i.elements[6])), i.elements[5] > .75 !== this.placeOnWall ? $fd4eb456bcbd06f8$var$ad.setFromMatrixPosition(i) : null;
    }
    moveToFloor(t1) {
        const e = this.initialHitSource;
        if (null == e) return;
        const n = t1.getHitTestResults(e);
        if (0 == n.length) return;
        const i = n[0], r = this.getHitPoint(i);
        null != r && (this.placementBox.show = !0, this.isTranslating || (this.placeOnWall ? this.goalPosition.copy(r) : this.goalPosition.y = r.y), e.cancel(), this.initialHitSource = null, this.dispatchEvent({
            type: "status",
            status: $fd4eb456bcbd06f8$var$td
        }));
    }
    fingerPolar(t1) {
        const e = t1[0].inputSource.gamepad.axes, n = t1[1].inputSource.gamepad.axes, i = n[0] - e[0], r = n[1] - e[1], s = Math.atan2(r, i);
        let a = this.lastAngle - s;
        return a > Math.PI ? a -= 2 * Math.PI : a < -Math.PI && (a += 2 * Math.PI), this.lastAngle = s, {
            separation: Math.sqrt(i * i + r * r),
            deltaYaw: a
        };
    }
    processInput(t1) {
        const e = this.transientHitTestSource;
        if (null == e) return;
        if (!this.isTranslating && !this.isTwoFingering && !this.isRotating) return;
        const n = t1.getHitTestResultsForTransientInput(e), i = this.presentedScene, r = i.scale.x;
        if (this.isTwoFingering) {
            if (n.length < 2) this.isTwoFingering = !1;
            else {
                const { separation: t1, deltaYaw: e } = this.fingerPolar(n);
                if (!1 === this.placeOnWall && (this.goalYaw += e), i.canScale) {
                    const e = t1 / this.firstRatio;
                    this.goalScale = e < 1.3 && e > .7692307692307692 ? 1 : e;
                }
            }
        } else if (2 !== n.length) {
            if (this.isRotating) {
                const t1 = 1.5 * this.inputSource.gamepad.axes[0];
                this.goalYaw += t1 - this.lastAngle, this.lastAngle = t1;
            } else this.isTranslating && n.forEach((t1)=>{
                if (t1.inputSource !== this.inputSource) return;
                let e = null;
                if (t1.results.length > 0 && (e = this.getHitPoint(t1.results[0])), null == e && (e = this.getTouchLocation()), null != e) {
                    if (this.goalPosition.sub(this.lastDragPosition), !1 === this.placeOnWall) {
                        const t1 = e.y - this.lastDragPosition.y;
                        if (t1 < 0) {
                            this.placementBox.offsetHeight = t1 / r, this.presentedScene.setShadowOffset(t1);
                            const n = $fd4eb456bcbd06f8$var$rd.copy(i.getCamera().position), s = -t1 / (n.y - e.y);
                            n.multiplyScalar(s), e.multiplyScalar(1 - s).add(n);
                        }
                    }
                    this.goalPosition.add(e), this.lastDragPosition.copy(e);
                }
            });
        } else {
            this.isTranslating = !1, this.isRotating = !1, this.isTwoFingering = !0;
            const { separation: t1 } = this.fingerPolar(n);
            this.firstRatio = t1 / r;
        }
    }
    moveScene(t1) {
        const e = this.presentedScene, { position: n, yaw: i } = e, r = e.boundingSphere.radius, s = this.goalPosition, a = e.scale.x, o = this.placementBox;
        if (!s.equals(n) || this.goalScale !== a) {
            let { x: i, y: l, z: h } = n;
            i = this.xDamper.update(i, s.x, t1, r), l = this.yDamper.update(l, s.y, t1, r), h = this.zDamper.update(h, s.z, t1, r), n.set(i, l, h);
            const c = this.scaleDamper.update(a, this.goalScale, t1, 1);
            if (e.scale.set(c, c, c), !this.isTranslating) {
                const t1 = s.y - l;
                this.placementComplete && !1 === this.placeOnWall ? (o.offsetHeight = t1 / c, e.setShadowOffset(t1)) : 0 === t1 && (this.placementComplete = !0, o.show = !1, e.setShadowIntensity(.8));
            }
        }
        o.updateOpacity(t1), e.updateTarget(t1), e.yaw = this.yawDamper.update(i, this.goalYaw, t1, Math.PI);
    }
    onWebXRFrame(t1, e) {
        this.frame = e, ++this.frames;
        const n = this.threeRenderer.xr.getReferenceSpace(), i = e.getViewerPose(n);
        null == i && !0 === this.tracking && this.frames > 30 && (this.tracking = !1, this.dispatchEvent({
            type: "tracking",
            status: $fd4eb456bcbd06f8$var$id
        }));
        const r = this.presentedScene;
        if (null == i || null == r || !r.element[$fd4eb456bcbd06f8$var$Pp]()) return void this.threeRenderer.clear();
        !1 === this.tracking && (this.tracking = !0, this.dispatchEvent({
            type: "tracking",
            status: $fd4eb456bcbd06f8$var$nd
        }));
        let s = !0;
        for (const n of i.views){
            if (this.updateView(n), s) {
                this.moveToFloor(e), this.processInput(e);
                const n = t1 - this.lastTick;
                this.moveScene(n), this.renderer.preRender(r, t1, n), this.lastTick = t1, r.renderShadow(this.threeRenderer);
            }
            this.threeRenderer.render(r, r.getCamera()), s = !1;
        }
    }
}
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $fd4eb456bcbd06f8$var$hd {
    constructor(t1){
        t1.threeRenderer.debug = {
            checkShaderErrors: !0
        }, Promise.resolve().then(()=>{
            self.dispatchEvent(new CustomEvent("model-viewer-renderer-debug", {
                detail: {
                    renderer: t1,
                    THREE: {
                        ShaderMaterial: $fd4eb456bcbd06f8$var$Ve,
                        Texture: $fd4eb456bcbd06f8$var$F,
                        Mesh: $fd4eb456bcbd06f8$var$Fe,
                        Scene: $fd4eb456bcbd06f8$var$Nr,
                        PlaneBufferGeometry: $fd4eb456bcbd06f8$var$rn,
                        OrthographicCamera: $fd4eb456bcbd06f8$var$mn,
                        WebGLRenderTarget: $fd4eb456bcbd06f8$var$k
                    }
                }
            }));
        });
    }
    addScene(t1) {
        self.dispatchEvent(new CustomEvent("model-viewer-scene-added-debug", {
            detail: {
                scene: t1
            }
        }));
    }
    removeScene(t1) {
        self.dispatchEvent(new CustomEvent("model-viewer-scene-removed-debug", {
            detail: {
                scene: t1
            }
        }));
    }
}
function $fd4eb456bcbd06f8$var$cd(t1) {
    const e = new Map, n = new Map, i = t1.clone();
    return $fd4eb456bcbd06f8$var$ud(t1, i, function(t1, i) {
        e.set(i, t1), n.set(t1, i);
    }), i.traverse(function(t1) {
        if (!t1.isSkinnedMesh) return;
        const i = t1, r = e.get(t1), s = r.skeleton.bones;
        i.skeleton = r.skeleton.clone(), i.bindMatrix.copy(r.bindMatrix), i.skeleton.bones = s.map(function(t1) {
            return n.get(t1);
        }), i.bind(i.skeleton, i.bindMatrix);
    }), i;
}
function $fd4eb456bcbd06f8$var$ud(t1, e, n) {
    n(t1, e);
    for(let i = 0; i < t1.children.length; i++)$fd4eb456bcbd06f8$var$ud(t1.children[i], e.children[i], n);
}
/* @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fd4eb456bcbd06f8$var$dd = Symbol("prepared"), $fd4eb456bcbd06f8$var$pd = Symbol("prepare"), $fd4eb456bcbd06f8$var$md = Symbol("preparedGLTF"), $fd4eb456bcbd06f8$var$fd = Symbol("clone");
class $fd4eb456bcbd06f8$var$gd {
    constructor(t1){
        this[$fd4eb456bcbd06f8$var$md] = t1;
    }
    static prepare(t1) {
        if (null == t1.scene) throw new Error("Model does not have a scene");
        if (t1[$fd4eb456bcbd06f8$var$dd]) return t1;
        const e = this[$fd4eb456bcbd06f8$var$pd](t1);
        return e[$fd4eb456bcbd06f8$var$dd] = !0, e;
    }
    static [$fd4eb456bcbd06f8$var$pd](t1) {
        const { scene: e } = t1, n = [
            e
        ];
        return Object.assign(Object.assign({}, t1), {
            scene: e,
            scenes: n
        });
    }
    get parser() {
        return this[$fd4eb456bcbd06f8$var$md].parser;
    }
    get animations() {
        return this[$fd4eb456bcbd06f8$var$md].animations;
    }
    get scene() {
        return this[$fd4eb456bcbd06f8$var$md].scene;
    }
    get scenes() {
        return this[$fd4eb456bcbd06f8$var$md].scenes;
    }
    get cameras() {
        return this[$fd4eb456bcbd06f8$var$md].cameras;
    }
    get asset() {
        return this[$fd4eb456bcbd06f8$var$md].asset;
    }
    get userData() {
        return this[$fd4eb456bcbd06f8$var$md].userData;
    }
    clone() {
        return new this.constructor(this[$fd4eb456bcbd06f8$var$fd]());
    }
    dispose() {
        this.scenes.forEach((t1)=>{
            t1.traverse((t1)=>{
                if (!t1.isMesh) return;
                const e = t1;
                (Array.isArray(e.material) ? e.material : [
                    e.material
                ]).forEach((t1)=>{
                    for(const e in t1){
                        const n = t1[e];
                        if (n instanceof $fd4eb456bcbd06f8$var$F) {
                            const t1 = n.source.data;
                            t1 instanceof ImageBitmap && t1.close(), n.dispose();
                        }
                    }
                    t1.dispose();
                }), e.geometry.dispose();
            });
        });
    }
    [$fd4eb456bcbd06f8$var$fd]() {
        const t1 = this[$fd4eb456bcbd06f8$var$md], e = $fd4eb456bcbd06f8$var$cd(this.scene);
        $fd4eb456bcbd06f8$var$vd(e, this.scene);
        const n = [
            e
        ], i = t1.userData ? Object.assign({}, t1.userData) : {};
        return Object.assign(Object.assign({}, t1), {
            scene: e,
            scenes: n,
            userData: i
        });
    }
}
const $fd4eb456bcbd06f8$var$vd = (t1, e)=>{
    $fd4eb456bcbd06f8$var$yd(t1, e, (t1, e)=>{
        void 0 !== e.userData.variantMaterials && (t1.userData.variantMaterials = new Map(e.userData.variantMaterials)), void 0 !== e.userData.variantData && (t1.userData.variantData = e.userData.variantData), void 0 !== e.userData.originalMaterial && (t1.userData.originalMaterial = e.userData.originalMaterial);
    });
}, $fd4eb456bcbd06f8$var$yd = (t1, e, n)=>{
    n(t1, e);
    for(let i = 0; i < t1.children.length; i++)$fd4eb456bcbd06f8$var$yd(t1.children[i], e.children[i], n);
}, $fd4eb456bcbd06f8$var$xd = Symbol("threeGLTF"), $fd4eb456bcbd06f8$var$bd = Symbol("gltf"), $fd4eb456bcbd06f8$var$_d = Symbol("gltfElementMap"), $fd4eb456bcbd06f8$var$wd = Symbol("threeObjectMap"), $fd4eb456bcbd06f8$var$Md = Symbol("parallelTraverseThreeScene"), $fd4eb456bcbd06f8$var$Sd = Symbol("correlateOriginalThreeGLTF"), $fd4eb456bcbd06f8$var$Td = Symbol("correlateCloneThreeGLTF");
class $fd4eb456bcbd06f8$var$Ed {
    constructor(t1, e, n, i){
        this[$fd4eb456bcbd06f8$var$xd] = t1, this[$fd4eb456bcbd06f8$var$bd] = e, this[$fd4eb456bcbd06f8$var$_d] = i, this[$fd4eb456bcbd06f8$var$wd] = n;
    }
    static from(t1, e) {
        return null != e ? this[$fd4eb456bcbd06f8$var$Td](t1, e) : this[$fd4eb456bcbd06f8$var$Sd](t1);
    }
    static [$fd4eb456bcbd06f8$var$Sd](t1) {
        const e = t1.parser.json, n = t1.parser.associations, i = new Map, r = {
            name: "Default"
        }, s = {
            type: "materials",
            index: -1
        };
        for (const t1 of n.keys())t1 instanceof $fd4eb456bcbd06f8$var$ie && null == n.get(t1) && (s.index < 0 && (null == e.materials && (e.materials = []), s.index = e.materials.length, e.materials.push(r)), t1.name = r.name, n.set(t1, {
            materials: s.index
        }));
        for (const [t1, r] of n){
            if (r) {
                const e = t1;
                e.userData = e.userData || {}, e.userData.associations = r;
            }
            for(const n in r)if (null != n && "primitives" !== n) {
                const s = n, a = (e[s] || [])[r[s]];
                if (null == a) continue;
                let o = i.get(a);
                null == o && (o = new Set, i.set(a, o)), o.add(t1);
            }
        }
        return new $fd4eb456bcbd06f8$var$Ed(t1, e, n, i);
    }
    static [$fd4eb456bcbd06f8$var$Td](t1, e) {
        const n = e.threeGLTF, i = e.gltf, r = JSON.parse(JSON.stringify(i)), s = new Map, a = new Map;
        for(let i = 0; i < n.scenes.length; i++)this[$fd4eb456bcbd06f8$var$Md](n.scenes[i], t1.scenes[i], (t1, n)=>{
            const i = e.threeObjectMap.get(t1);
            if (null != i) {
                for(const t1 in i)if (null != t1 && "primitives" !== t1) {
                    const e = t1, o = i[e], l = r[e][o], h = s.get(n) || {};
                    h[e] = o, s.set(n, h);
                    const c = a.get(l) || new Set;
                    c.add(n), a.set(l, c);
                }
            }
        });
        return new $fd4eb456bcbd06f8$var$Ed(t1, r, s, a);
    }
    static [$fd4eb456bcbd06f8$var$Md](t1, e, n) {
        const i = (t1, e)=>{
            if (n(t1, e), t1.isObject3D) {
                if (t1.isMesh) {
                    if (Array.isArray(t1.material)) for(let n = 0; n < t1.material.length; ++n)i(t1.material[n], e.material[n]);
                    else i(t1.material, e.material);
                }
                for(let n = 0; n < t1.children.length; ++n)i(t1.children[n], e.children[n]);
            }
        };
        i(t1, e);
    }
    get threeGLTF() {
        return this[$fd4eb456bcbd06f8$var$xd];
    }
    get gltf() {
        return this[$fd4eb456bcbd06f8$var$bd];
    }
    get gltfElementMap() {
        return this[$fd4eb456bcbd06f8$var$_d];
    }
    get threeObjectMap() {
        return this[$fd4eb456bcbd06f8$var$wd];
    }
}
/* @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fd4eb456bcbd06f8$var$Ad = Symbol("correlatedSceneGraph");
class $fd4eb456bcbd06f8$var$Rd extends $fd4eb456bcbd06f8$var$gd {
    static [$fd4eb456bcbd06f8$var$pd](t1) {
        const e = super[$fd4eb456bcbd06f8$var$pd](t1);
        null == e[$fd4eb456bcbd06f8$var$Ad] && (e[$fd4eb456bcbd06f8$var$Ad] = $fd4eb456bcbd06f8$var$Ed.from(e));
        const { scene: n } = e, i = new $fd4eb456bcbd06f8$var$ct(void 0, 1 / 0);
        return n.traverse((t1)=>{
            t1.renderOrder = 1e3, t1.frustumCulled = !1, t1.name || (t1.name = t1.uuid);
            const n = t1;
            if (n.isMesh) {
                const { geometry: t1 } = n;
                n.castShadow = !0, n.isSkinnedMesh && (t1.boundingSphere = i, t1.boundingBox = null);
                const r = n.material;
                if (!0 === r.isMeshBasicMaterial && (r.toneMapped = !1), r.shadowSide = 0, r.aoMap) {
                    const { gltf: n, threeObjectMap: i } = e[$fd4eb456bcbd06f8$var$Ad], s = i.get(r);
                    if (null != n.materials && null != s && null != s.materials) {
                        const e = n.materials[s.materials];
                        e.occlusionTexture && 0 === e.occlusionTexture.texCoord && null != t1.attributes.uv && t1.setAttribute("uv2", t1.attributes.uv);
                    }
                }
            }
        }), e;
    }
    get correlatedSceneGraph() {
        return this[$fd4eb456bcbd06f8$var$md][$fd4eb456bcbd06f8$var$Ad];
    }
    [$fd4eb456bcbd06f8$var$fd]() {
        const t1 = super[$fd4eb456bcbd06f8$var$fd](), e = new Map;
        return t1.scene.traverse((t1)=>{
            if (t1.isMesh) {
                const n = t1, i = n.material;
                if (null != i) {
                    if (e.has(i.uuid)) return void (n.material = e.get(i.uuid));
                    n.material = i.clone(), e.set(i.uuid, n.material);
                }
            }
        }), t1[$fd4eb456bcbd06f8$var$Ad] = $fd4eb456bcbd06f8$var$Ed.from(t1, this.correlatedSceneGraph), t1;
    }
}
/* @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $fd4eb456bcbd06f8$var$Cd extends $fd4eb456bcbd06f8$var$Nr {
    constructor(){
        super(), this.position.y = -3.5;
        const t1 = new $fd4eb456bcbd06f8$var$ke;
        t1.deleteAttribute("uv");
        const e = new $fd4eb456bcbd06f8$var$Fa({
            metalness: 0,
            side: 1
        }), n = new $fd4eb456bcbd06f8$var$Fa({
            metalness: 0
        }), i = new $fd4eb456bcbd06f8$var$Ao(16777215, 500, 28, 2);
        i.position.set(.418, 16.199, .3), this.add(i);
        const r = new $fd4eb456bcbd06f8$var$Fe(t1, e);
        r.position.set(-0.757, 13.219, .717), r.scale.set(31.713, 28.305, 28.591), this.add(r);
        const s = new $fd4eb456bcbd06f8$var$Fe(t1, n);
        s.position.set(-10.906, 2.009, 1.846), s.rotation.set(0, -0.195, 0), s.scale.set(2.328, 7.905, 4.651), this.add(s);
        const a = new $fd4eb456bcbd06f8$var$Fe(t1, n);
        a.position.set(-5.607, -0.754, -0.758), a.rotation.set(0, .994, 0), a.scale.set(1.97, 1.534, 3.955), this.add(a);
        const o = new $fd4eb456bcbd06f8$var$Fe(t1, n);
        o.position.set(6.167, .857, 7.803), o.rotation.set(0, .561, 0), o.scale.set(3.927, 6.285, 3.687), this.add(o);
        const l = new $fd4eb456bcbd06f8$var$Fe(t1, n);
        l.position.set(-2.017, .018, 6.124), l.rotation.set(0, .333, 0), l.scale.set(2.002, 4.566, 2.064), this.add(l);
        const h = new $fd4eb456bcbd06f8$var$Fe(t1, n);
        h.position.set(2.291, -0.756, -2.621), h.rotation.set(0, -0.286, 0), h.scale.set(1.546, 1.552, 1.496), this.add(h);
        const c = new $fd4eb456bcbd06f8$var$Fe(t1, n);
        c.position.set(-2.193, -0.369, -5.547), c.rotation.set(0, .516, 0), c.scale.set(3.875, 3.487, 2.986), this.add(c);
        const u = new $fd4eb456bcbd06f8$var$Fe(t1, this.createAreaLightMaterial(50));
        u.position.set(-16.116, 14.37, 8.208), u.scale.set(.1, 2.428, 2.739), this.add(u);
        const d = new $fd4eb456bcbd06f8$var$Fe(t1, this.createAreaLightMaterial(50));
        d.position.set(-16.109, 18.021, -8.207), d.scale.set(.1, 2.425, 2.751), this.add(d);
        const p = new $fd4eb456bcbd06f8$var$Fe(t1, this.createAreaLightMaterial(17));
        p.position.set(14.904, 12.198, -1.832), p.scale.set(.15, 4.265, 6.331), this.add(p);
        const m = new $fd4eb456bcbd06f8$var$Fe(t1, this.createAreaLightMaterial(43));
        m.position.set(-0.462, 8.89, 14.52), m.scale.set(4.38, 5.441, .088), this.add(m);
        const f = new $fd4eb456bcbd06f8$var$Fe(t1, this.createAreaLightMaterial(20));
        f.position.set(3.235, 11.486, -12.541), f.scale.set(2.5, 2, .1), this.add(f);
        const g = new $fd4eb456bcbd06f8$var$Fe(t1, this.createAreaLightMaterial(100));
        g.position.set(0, 20, 0), g.scale.set(1, .1, 1), this.add(g);
    }
    createAreaLightMaterial(t1) {
        const e = new $fd4eb456bcbd06f8$var$re;
        return e.color.setScalar(t1), e;
    }
}
/* @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $fd4eb456bcbd06f8$var$Ld extends $fd4eb456bcbd06f8$var$Nr {
    constructor(){
        super(), this.position.y = -3.5;
        const t1 = new $fd4eb456bcbd06f8$var$ke;
        t1.deleteAttribute("uv");
        const e = new $fd4eb456bcbd06f8$var$Fa({
            metalness: 0,
            side: 1
        }), n = new $fd4eb456bcbd06f8$var$Fa({
            metalness: 0
        }), i = new $fd4eb456bcbd06f8$var$Ao(16777215, 400, 28, 2);
        i.position.set(.5, 14, .5), this.add(i);
        const r = new $fd4eb456bcbd06f8$var$Fe(t1, e);
        r.position.set(0, 13.2, 0), r.scale.set(31.5, 28.5, 31.5), this.add(r);
        const s = new $fd4eb456bcbd06f8$var$Fe(t1, n);
        s.position.set(-10.906, -1, 1.846), s.rotation.set(0, -0.195, 0), s.scale.set(2.328, 7.905, 4.651), this.add(s);
        const a = new $fd4eb456bcbd06f8$var$Fe(t1, n);
        a.position.set(-5.607, -0.754, -0.758), a.rotation.set(0, .994, 0), a.scale.set(1.97, 1.534, 3.955), this.add(a);
        const o = new $fd4eb456bcbd06f8$var$Fe(t1, n);
        o.position.set(6.167, -0.16, 7.803), o.rotation.set(0, .561, 0), o.scale.set(3.927, 6.285, 3.687), this.add(o);
        const l = new $fd4eb456bcbd06f8$var$Fe(t1, n);
        l.position.set(-2.017, .018, 6.124), l.rotation.set(0, .333, 0), l.scale.set(2.002, 4.566, 2.064), this.add(l);
        const h = new $fd4eb456bcbd06f8$var$Fe(t1, n);
        h.position.set(2.291, -0.756, -2.621), h.rotation.set(0, -0.286, 0), h.scale.set(1.546, 1.552, 1.496), this.add(h);
        const c = new $fd4eb456bcbd06f8$var$Fe(t1, n);
        c.position.set(-2.193, -0.369, -5.547), c.rotation.set(0, .516, 0), c.scale.set(3.875, 3.487, 2.986), this.add(c);
        const u = new $fd4eb456bcbd06f8$var$Fe(t1, this.createAreaLightMaterial(80));
        u.position.set(-14, 10, 8), u.scale.set(.1, 2.5, 2.5), this.add(u);
        const d = new $fd4eb456bcbd06f8$var$Fe(t1, this.createAreaLightMaterial(80));
        d.position.set(-14, 14, -4), d.scale.set(.1, 2.5, 2.5), this.add(d);
        const p = new $fd4eb456bcbd06f8$var$Fe(t1, this.createAreaLightMaterial(23));
        p.position.set(14, 12, 0), p.scale.set(.1, 5, 5), this.add(p);
        const m = new $fd4eb456bcbd06f8$var$Fe(t1, this.createAreaLightMaterial(16));
        m.position.set(0, 9, 14), m.scale.set(5, 5, .1), this.add(m);
        const f = new $fd4eb456bcbd06f8$var$Fe(t1, this.createAreaLightMaterial(80));
        f.position.set(7, 8, -14), f.scale.set(2.5, 2.5, .1), this.add(f);
        const g = new $fd4eb456bcbd06f8$var$Fe(t1, this.createAreaLightMaterial(80));
        g.position.set(-7, 16, -14), g.scale.set(2.5, 2.5, .1), this.add(g);
        const v = new $fd4eb456bcbd06f8$var$Fe(t1, this.createAreaLightMaterial(1));
        v.position.set(0, 20, 0), v.scale.set(.1, .1, .1), this.add(v);
    }
    createAreaLightMaterial(t1) {
        const e = new $fd4eb456bcbd06f8$var$re;
        return e.color.setScalar(t1), e;
    }
}
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fd4eb456bcbd06f8$var$Pd = /\.hdr(\.js)?$/, $fd4eb456bcbd06f8$var$Dd = new $fd4eb456bcbd06f8$var$fo, $fd4eb456bcbd06f8$var$Id = new class extends $fd4eb456bcbd06f8$var$mo {
    constructor(t1){
        super(t1), this.type = 1016;
    }
    parse(t1) {
        const e = function(t1, e) {
            switch(t1){
                case 1:
                    console.error("THREE.RGBELoader Read Error: " + (e || ""));
                    break;
                case 2:
                    console.error("THREE.RGBELoader Write Error: " + (e || ""));
                    break;
                case 3:
                    console.error("THREE.RGBELoader Bad File Format: " + (e || ""));
                    break;
                default:
                    console.error("THREE.RGBELoader: Error: " + (e || ""));
            }
            return -1;
        }, n = function(t1, e, n) {
            e = e || 1024;
            let i = t1.pos, r = -1, s = 0, a = "", o = String.fromCharCode.apply(null, new Uint16Array(t1.subarray(i, i + 128)));
            for(; 0 > (r = o.indexOf("\n")) && s < e && i < t1.byteLength;)a += o, s += o.length, i += 128, o += String.fromCharCode.apply(null, new Uint16Array(t1.subarray(i, i + 128)));
            return -1 < r && (!1 !== n && (t1.pos += s + r + 1), a + o.slice(0, r));
        }, i = function(t1, e, n, i) {
            const r = t1[e + 3], s = Math.pow(2, r - 128) / 255;
            n[i + 0] = t1[e + 0] * s, n[i + 1] = t1[e + 1] * s, n[i + 2] = t1[e + 2] * s, n[i + 3] = 1;
        }, r = function(t1, e, n, i) {
            const r = t1[e + 3], s = Math.pow(2, r - 128) / 255;
            n[i + 0] = $fd4eb456bcbd06f8$var$nl.toHalfFloat(Math.min(t1[e + 0] * s, 65504)), n[i + 1] = $fd4eb456bcbd06f8$var$nl.toHalfFloat(Math.min(t1[e + 1] * s, 65504)), n[i + 2] = $fd4eb456bcbd06f8$var$nl.toHalfFloat(Math.min(t1[e + 2] * s, 65504)), n[i + 3] = $fd4eb456bcbd06f8$var$nl.toHalfFloat(1);
        }, s = new Uint8Array(t1);
        s.pos = 0;
        const a = function(t1) {
            const i = /^\s*GAMMA\s*=\s*(\d+(\.\d+)?)\s*$/, r = /^\s*EXPOSURE\s*=\s*(\d+(\.\d+)?)\s*$/, s = /^\s*FORMAT=(\S+)\s*$/, a = /^\s*\-Y\s+(\d+)\s+\+X\s+(\d+)\s*$/, o = {
                valid: 0,
                string: "",
                comments: "",
                programtype: "RGBE",
                format: "",
                gamma: 1,
                exposure: 1,
                width: 0,
                height: 0
            };
            let l, h;
            if (t1.pos >= t1.byteLength || !(l = n(t1))) return e(1, "no header found");
            if (!(h = l.match(/^#\?(\S+)/))) return e(3, "bad initial token");
            for(o.valid |= 1, o.programtype = h[1], o.string += l + "\n"; l = n(t1), !1 !== l;)if (o.string += l + "\n", "#" !== l.charAt(0)) {
                if ((h = l.match(i)) && (o.gamma = parseFloat(h[1])), (h = l.match(r)) && (o.exposure = parseFloat(h[1])), (h = l.match(s)) && (o.valid |= 2, o.format = h[1]), (h = l.match(a)) && (o.valid |= 4, o.height = parseInt(h[1], 10), o.width = parseInt(h[2], 10)), 2 & o.valid && 4 & o.valid) break;
            } else o.comments += l + "\n";
            return 2 & o.valid ? 4 & o.valid ? o : e(3, "missing image size specifier") : e(3, "missing format specifier");
        }(s);
        if (-1 !== a) {
            const t1 = a.width, n = a.height, o = function(t1, n, i) {
                const r = n;
                if (r < 8 || r > 32767 || 2 !== t1[0] || 2 !== t1[1] || 128 & t1[2]) return new Uint8Array(t1);
                if (r !== (t1[2] << 8 | t1[3])) return e(3, "wrong scanline width");
                const s = new Uint8Array(4 * n * i);
                if (!s.length) return e(4, "unable to allocate buffer space");
                let a = 0, o = 0;
                const l = 4 * r, h = new Uint8Array(4), c = new Uint8Array(l);
                let u = i;
                for(; u > 0 && o < t1.byteLength;){
                    if (o + 4 > t1.byteLength) return e(1);
                    if (h[0] = t1[o++], h[1] = t1[o++], h[2] = t1[o++], h[3] = t1[o++], 2 != h[0] || 2 != h[1] || (h[2] << 8 | h[3]) != r) return e(3, "bad rgbe scanline format");
                    let n, i = 0;
                    for(; i < l && o < t1.byteLength;){
                        n = t1[o++];
                        const r = n > 128;
                        if (r && (n -= 128), 0 === n || i + n > l) return e(3, "bad scanline data");
                        if (r) {
                            const e = t1[o++];
                            for(let t1 = 0; t1 < n; t1++)c[i++] = e;
                        } else c.set(t1.subarray(o, o + n), i), i += n, o += n;
                    }
                    const d = r;
                    for(let t1 = 0; t1 < d; t1++){
                        let e = 0;
                        s[a] = c[t1 + e], e += r, s[a + 1] = c[t1 + e], e += r, s[a + 2] = c[t1 + e], e += r, s[a + 3] = c[t1 + e], a += 4;
                    }
                    u--;
                }
                return s;
            }(s.subarray(s.pos), t1, n);
            if (-1 !== o) {
                let e, s, l, h;
                switch(this.type){
                    case 1015:
                        h = o.length / 4;
                        const t2 = new Float32Array(4 * h);
                        for(let e = 0; e < h; e++)i(o, 4 * e, t2, 4 * e);
                        e = t2, l = 1015;
                        break;
                    case 1016:
                        h = o.length / 4;
                        const n1 = new Uint16Array(4 * h);
                        for(let t1 = 0; t1 < h; t1++)r(o, 4 * t1, n1, 4 * t1);
                        e = n1, l = 1016;
                        break;
                    default:
                        console.error("THREE.RGBELoader: unsupported type: ", this.type);
                }
                return {
                    width: t1,
                    height: n,
                    data: e,
                    header: a.string,
                    gamma: a.gamma,
                    exposure: a.exposure,
                    format: s,
                    type: l
                };
            }
        }
        return null;
    }
    setDataType(t1) {
        return this.type = t1, this;
    }
    load(t1, e, n, i) {
        return super.load(t1, function(t1, n) {
            switch(t1.type){
                case 1015:
                case 1016:
                    t1.encoding = 3e3, t1.minFilter = 1006, t1.magFilter = 1006, t1.generateMipmaps = !1, t1.flipY = !0;
            }
            e && e(t1, n);
        }, n, i);
    }
};
$fd4eb456bcbd06f8$var$Id.setDataType(1016);
class $fd4eb456bcbd06f8$var$Od extends $fd4eb456bcbd06f8$var$i {
    constructor(t1){
        super(), this.threeRenderer = t1, this.generatedEnvironmentMap = null, this.generatedEnvironmentMapAlt = null, this.skyboxCache = new Map, this.blurMaterial = null, this.blurScene = null;
    }
    async load(t1, e = ()=>{}) {
        try {
            const n = $fd4eb456bcbd06f8$var$Pd.test(t1), i = n ? $fd4eb456bcbd06f8$var$Id : $fd4eb456bcbd06f8$var$Dd, r = await new Promise((n, r)=>i.load(t1, n, (t1)=>{
                    e(t1.loaded / t1.total * .9);
                }, r));
            return e(1), r.name = t1, r.mapping = 303, n || (r.encoding = 3001), r;
        } finally{
            e && e(1);
        }
    }
    async generateEnvironmentMapAndSkybox(t1 = null, e = null, n = {}) {
        const { progressTracker: i } = n, r = "neutral" === e;
        !0 === r && (e = null), e = $fd4eb456bcbd06f8$var$ru(e);
        let s, a = Promise.resolve(null);
        t1 && (a = this.loadEquirectFromUrl(t1, i)), s = e ? this.loadEquirectFromUrl(e, i) : t1 ? this.loadEquirectFromUrl(t1, i) : !0 === r ? this.loadGeneratedEnvironmentMapAlt() : this.loadGeneratedEnvironmentMap();
        let [o, l] = await Promise.all([
            s,
            a
        ]);
        if (null == o) throw new Error("Failed to load environment map.");
        return {
            environmentMap: o,
            skybox: l
        };
    }
    async loadEquirectFromUrl(t1, e) {
        if (!this.skyboxCache.has(t1)) {
            const n = e ? e.beginActivity() : ()=>{}, i = this.load(t1, n);
            this.skyboxCache.set(t1, i);
        }
        return this.skyboxCache.get(t1);
    }
    async GenerateEnvironmentMap(t1, e) {
        await $fd4eb456bcbd06f8$var$uu();
        const n = this.threeRenderer, i = new $fd4eb456bcbd06f8$var$Xe(256, {
            generateMipmaps: !1,
            type: 1016,
            format: 1023,
            encoding: 3e3,
            depthBuffer: !0
        }), r = new $fd4eb456bcbd06f8$var$je(.1, 100, i), s = r.renderTarget.texture;
        s.name = e;
        const a = n.outputEncoding, o = n.toneMapping;
        return n.toneMapping = 0, n.outputEncoding = 3e3, r.update(n, t1), this.blurCubemap(i, .04), n.toneMapping = o, n.outputEncoding = a, s;
    }
    async loadGeneratedEnvironmentMap() {
        return null == this.generatedEnvironmentMap && (this.generatedEnvironmentMap = this.GenerateEnvironmentMap(new $fd4eb456bcbd06f8$var$Cd, "default")), this.generatedEnvironmentMap;
    }
    async loadGeneratedEnvironmentMapAlt() {
        return null == this.generatedEnvironmentMapAlt && (this.generatedEnvironmentMapAlt = this.GenerateEnvironmentMap(new $fd4eb456bcbd06f8$var$Ld, "neutral")), this.generatedEnvironmentMapAlt;
    }
    blurCubemap(t1, e) {
        if (null == this.blurMaterial) {
            this.blurMaterial = this.getBlurShader(20);
            const t1 = new $fd4eb456bcbd06f8$var$ke, e = new $fd4eb456bcbd06f8$var$Fe(t1, this.blurMaterial);
            this.blurScene = new $fd4eb456bcbd06f8$var$Nr, this.blurScene.add(e);
        }
        const n = t1.clone();
        this.halfblur(t1, n, e, "latitudinal"), this.halfblur(n, t1, e, "longitudinal");
    }
    halfblur(t1, e, n, i) {
        const r = t1.width, s = isFinite(n) ? Math.PI / (2 * r) : 2 * Math.PI / 39, a = n / s, o = isFinite(n) ? 1 + Math.floor(3 * a) : 20;
        o > 20 && console.warn(`sigmaRadians, ${n}, is too large and will clip, as it requested ${o} samples when the maximum is set to 20`);
        const l = [];
        let h = 0;
        for(let t1 = 0; t1 < 20; ++t1){
            const e = t1 / a, n = Math.exp(-e * e / 2);
            l.push(n), 0 == t1 ? h += n : t1 < o && (h += 2 * n);
        }
        for(let t1 = 0; t1 < l.length; t1++)l[t1] = l[t1] / h;
        const c = this.blurMaterial.uniforms;
        c.envMap.value = t1.texture, c.samples.value = o, c.weights.value = l, c.latitudinal.value = "latitudinal" === i, c.dTheta.value = s;
        new $fd4eb456bcbd06f8$var$je(.1, 100, e).update(this.threeRenderer, this.blurScene);
    }
    getBlurShader(t1) {
        const e = new Float32Array(t1), n = new $fd4eb456bcbd06f8$var$V(0, 1, 0);
        return new $fd4eb456bcbd06f8$var$Ve({
            name: "SphericalGaussianBlur",
            defines: {
                n: t1
            },
            uniforms: {
                envMap: {
                    value: null
                },
                samples: {
                    value: 1
                },
                weights: {
                    value: e
                },
                latitudinal: {
                    value: !1
                },
                dTheta: {
                    value: 0
                },
                poleAxis: {
                    value: n
                }
            },
            vertexShader: "\n      \n      varying vec3 vOutputDirection;\n  \n      void main() {\n  \n        vOutputDirection = vec3( position );\n        gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n  \n      }\n    ",
            fragmentShader: "\n        varying vec3 vOutputDirection;\n  \n        uniform samplerCube envMap;\n        uniform int samples;\n        uniform float weights[ n ];\n        uniform bool latitudinal;\n        uniform float dTheta;\n        uniform vec3 poleAxis;\n  \n        vec3 getSample( float theta, vec3 axis ) {\n  \n          float cosTheta = cos( theta );\n          // Rodrigues' axis-angle rotation\n          vec3 sampleDirection = vOutputDirection * cosTheta\n            + cross( axis, vOutputDirection ) * sin( theta )\n            + axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );\n  \n          return vec3( textureCube( envMap, sampleDirection ) );\n  \n        }\n  \n        void main() {\n  \n          vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );\n  \n          if ( all( equal( axis, vec3( 0.0 ) ) ) ) {\n  \n            axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );\n  \n          }\n  \n          axis = normalize( axis );\n  \n          gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n          gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );\n  \n          for ( int i = 1; i < n; i++ ) {\n  \n            if ( i >= samples ) {\n  \n              break;\n  \n            }\n  \n            float theta = dTheta * float( i );\n            gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );\n            gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );\n  \n          }\n        }\n      ",
            blending: 0,
            depthTest: !1,
            depthWrite: !1,
            side: 1
        });
    }
    async dispose() {
        for (const [, t1] of this.skyboxCache)(await t1).dispose();
        null != this.generatedEnvironmentMap && ((await this.generatedEnvironmentMap).dispose(), this.generatedEnvironmentMap = null), null != this.generatedEnvironmentMapAlt && ((await this.generatedEnvironmentMapAlt).dispose(), this.generatedEnvironmentMapAlt = null), null != this.blurMaterial && this.blurMaterial.dispose();
    }
}
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fd4eb456bcbd06f8$var$Nd = [
    1,
    .79,
    .62,
    .5,
    .4,
    .31,
    .25
];
class $fd4eb456bcbd06f8$var$Fd extends $fd4eb456bcbd06f8$var$i {
    constructor(t1){
        super(), this.loader = new $fd4eb456bcbd06f8$var$Jc($fd4eb456bcbd06f8$var$Rd), this.width = 0, this.height = 0, this.dpr = 1, this.debugger = null, this.scenes = new Set, this.multipleScenesVisible = !1, this.scaleStep = 0, this.lastStep = 3, this.avgFrameDuration = 22, this.onWebGLContextLost = (t1)=>{
            this.dispatchEvent({
                type: "contextlost",
                sourceEvent: t1
            });
        }, this.onWebGLContextRestored = ()=>{
            var t1;
            null === (t1 = this.textureUtils) || void 0 === t1 || t1.dispose(), this.textureUtils = new $fd4eb456bcbd06f8$var$Od(this.threeRenderer);
            for (const t1 of this.scenes)t1.element[$fd4eb456bcbd06f8$var$Gu]();
        }, this.dpr = $fd4eb456bcbd06f8$var$hu(), this.canvas3D = document.createElement("canvas"), this.canvas3D.id = "webgl-canvas";
        try {
            this.threeRenderer = new $fd4eb456bcbd06f8$var$Or({
                canvas: this.canvas3D,
                alpha: !0,
                antialias: !0,
                powerPreference: t1.powerPreference,
                preserveDrawingBuffer: !0
            }), this.threeRenderer.autoClear = !0, this.threeRenderer.outputEncoding = 3001, this.threeRenderer.physicallyCorrectLights = !0, this.threeRenderer.setPixelRatio(1), this.debugger = t1.debug ? new $fd4eb456bcbd06f8$var$hd(this) : null, this.threeRenderer.debug = {
                checkShaderErrors: !!this.debugger
            }, this.threeRenderer.toneMapping = 4;
        } catch (t1) {
            console.warn(t1);
        }
        this.arRenderer = new $fd4eb456bcbd06f8$var$ld(this), this.textureUtils = this.canRender ? new $fd4eb456bcbd06f8$var$Od(this.threeRenderer) : null, $fd4eb456bcbd06f8$var$Jc.initializeKTX2Loader(this.threeRenderer), this.canvas3D.addEventListener("webglcontextlost", this.onWebGLContextLost), this.canvas3D.addEventListener("webglcontextrestored", this.onWebGLContextRestored), this.updateRendererSize(), this.lastTick = performance.now(), this.avgFrameDuration = 0;
    }
    static get singleton() {
        return this._singleton;
    }
    static resetSingleton() {
        const t1 = this._singleton.dispose();
        for (const e of t1)e.disconnectedCallback();
        this._singleton = new $fd4eb456bcbd06f8$var$Fd({
            powerPreference: (self.ModelViewerElement || {}).powerPreference || "high-performance",
            debug: $fd4eb456bcbd06f8$var$cu()
        });
        for (const e of t1)e.connectedCallback();
    }
    get canRender() {
        return null != this.threeRenderer;
    }
    get scaleFactor() {
        return $fd4eb456bcbd06f8$var$Nd[this.scaleStep];
    }
    set minScale(t1) {
        let e = 1;
        for(; e < $fd4eb456bcbd06f8$var$Nd.length && !($fd4eb456bcbd06f8$var$Nd[e] < t1);)++e;
        this.lastStep = e - 1;
    }
    updateRendererSize() {
        const t1 = $fd4eb456bcbd06f8$var$hu();
        if (t1 !== this.dpr) for (const t1 of this.scenes){
            const { element: e } = t1;
            e[$fd4eb456bcbd06f8$var$op](e.getBoundingClientRect());
        }
        let e = 0, n = 0;
        for (const t1 of this.scenes)e = Math.max(e, t1.width), n = Math.max(n, t1.height);
        if (e === this.width && n === this.height && t1 === this.dpr) return;
        this.width = e, this.height = n, this.dpr = t1, this.canRender && this.threeRenderer.setSize(e * t1, n * t1, !1);
        const i = this.scaleFactor, r = e / i, s = n / i;
        this.canvas3D.style.width = `${r}px`, this.canvas3D.style.height = `${s}px`;
        for (const i of this.scenes){
            const { canvas: a } = i;
            a.width = Math.round(e * t1), a.height = Math.round(n * t1), a.style.width = `${r}px`, a.style.height = `${s}px`, i.queueRender();
        }
    }
    updateRendererScale() {
        const t1 = this.scaleStep;
        if (this.avgFrameDuration > 26 ? ++this.scaleStep : this.avgFrameDuration < 18 && this.scaleStep > 0 && --this.scaleStep, this.scaleStep = Math.min(this.scaleStep, this.lastStep), t1 == this.scaleStep) return;
        const e = this.scaleFactor;
        this.avgFrameDuration = 22;
        const n = this.width / e, i = this.height / e;
        this.canvas3D.style.width = `${n}px`, this.canvas3D.style.height = `${i}px`;
        for (const t1 of this.scenes){
            const { style: e } = t1.canvas;
            e.width = `${n}px`, e.height = `${i}px`, t1.queueRender(), this.dispatchRenderScale(t1);
        }
    }
    dispatchRenderScale(t1) {
        const e = this.scaleFactor, n = this.dpr * e, i = e < 1 ? "GPU throttling" : this.dpr !== window.devicePixelRatio ? "No meta viewport tag" : "";
        t1.element.dispatchEvent(new CustomEvent("render-scale", {
            detail: {
                reportedDpr: window.devicePixelRatio,
                renderedDpr: n,
                minimumDpr: this.dpr * $fd4eb456bcbd06f8$var$Nd[this.lastStep],
                pixelWidth: Math.ceil(t1.width * n),
                pixelHeight: Math.ceil(t1.height * n),
                reason: i
            }
        }));
    }
    registerScene(t1) {
        this.scenes.add(t1);
        const { canvas: e } = t1, n = this.scaleFactor;
        e.width = Math.round(this.width * this.dpr), e.height = Math.round(this.height * this.dpr), e.style.width = this.width / n + "px", e.style.height = this.height / n + "px", this.multipleScenesVisible && e.classList.add("show"), t1.queueRender(), this.dispatchRenderScale(t1), this.canRender && this.scenes.size > 0 && this.threeRenderer.setAnimationLoop((t1, e)=>this.render(t1, e)), null != this.debugger && this.debugger.addScene(t1);
    }
    unregisterScene(t1) {
        this.scenes.delete(t1), this.canRender && 0 === this.scenes.size && this.threeRenderer.setAnimationLoop(null), null != this.debugger && this.debugger.removeScene(t1);
    }
    displayCanvas(t1) {
        return this.multipleScenesVisible ? t1.element[$fd4eb456bcbd06f8$var$bp] : this.canvas3D;
    }
    selectCanvas() {
        let t1 = 0, e = null;
        for (const n of this.scenes){
            const { element: i } = n;
            i.modelIsVisible && null == n.externalRenderer && (++t1, e = n.canvas);
        }
        if (null == e) return;
        const n = t1 > 1, { canvas3D: i } = this;
        if (n !== this.multipleScenesVisible || !n && i.parentElement !== e.parentElement) {
            this.multipleScenesVisible = n, n && i.classList.remove("show");
            for (const t1 of this.scenes){
                if (null != t1.externalRenderer) continue;
                const r = t1.element[$fd4eb456bcbd06f8$var$bp];
                n ? (r.classList.add("show"), t1.queueRender()) : t1.canvas === e && (t1.canvas.parentElement.appendChild(i), i.classList.add("show"), r.classList.remove("show"), t1.queueRender());
            }
        }
    }
    orderedScenes() {
        const t1 = [];
        for (const e of [
            !1,
            !0
        ])for (const n of this.scenes)n.element.modelIsVisible === e && t1.push(n);
        return t1;
    }
    get isPresenting() {
        return this.arRenderer.isPresenting;
    }
    preRender(t1, e, n) {
        const { element: i, exposure: r } = t1;
        i[$fd4eb456bcbd06f8$var$Mp](e, n);
        const s = "number" == typeof r && !self.isNaN(r);
        this.threeRenderer.toneMappingExposure = s ? r : 1;
    }
    render(t1, e) {
        if (null != e) return void this.arRenderer.onWebXRFrame(t1, e);
        const n = t1 - this.lastTick;
        if (this.lastTick = t1, !this.canRender || this.isPresenting) return;
        this.avgFrameDuration += $fd4eb456bcbd06f8$var$lu(.2 * (n - this.avgFrameDuration), -2, 2), this.selectCanvas(), this.updateRendererSize(), this.updateRendererScale();
        const { dpr: i, scaleFactor: r } = this;
        for (const e of this.orderedScenes()){
            const { element: s } = e;
            if (!s.modelIsVisible && e.renderCount > 0) continue;
            if (this.preRender(e, t1, n), !e.shouldRender()) continue;
            if (null != e.externalRenderer) {
                const t1 = e.getCamera();
                t1.updateMatrix();
                const { matrix: n, projectionMatrix: i } = t1, r = n.elements.slice(), s = e.getTarget();
                r[12] += s.x, r[13] += s.y, r[14] += s.z, e.externalRenderer.render({
                    viewMatrix: r,
                    projectionMatrix: i.elements
                });
                continue;
            }
            if (!s.modelIsVisible && !this.multipleScenesVisible) for (const t1 of this.scenes)t1.element.modelIsVisible && t1.queueRender();
            const a = Math.min(Math.ceil(e.width * r * i), this.canvas3D.width), o = Math.min(Math.ceil(e.height * r * i), this.canvas3D.height);
            if (e.renderShadow(this.threeRenderer), this.threeRenderer.setRenderTarget(null), this.threeRenderer.setViewport(0, Math.floor(this.height * i) - o, a, o), this.threeRenderer.render(e, e.camera), this.multipleScenesVisible) {
                null == e.context && e.createContext();
                const t1 = e.context;
                t1.clearRect(0, 0, a, o), t1.drawImage(this.canvas3D, 0, 0, a, o, 0, 0, a, o);
            }
            e.hasRendered(), s.loaded && ++e.renderCount;
        }
    }
    dispose() {
        null != this.textureUtils && this.textureUtils.dispose(), null != this.threeRenderer && this.threeRenderer.dispose(), this.textureUtils = null, this.threeRenderer = null;
        const t1 = [];
        for (const e of this.scenes)t1.push(e.element);
        return this.canvas3D.removeEventListener("webglcontextlost", this.onWebGLContextLost), this.canvas3D.removeEventListener("webglcontextrestored", this.onWebGLContextRestored), t1;
    }
}
$fd4eb456bcbd06f8$var$Fd._singleton = new $fd4eb456bcbd06f8$var$Fd({
    powerPreference: (self.ModelViewerElement || {}).powerPreference || "high-performance",
    debug: $fd4eb456bcbd06f8$var$cu()
});
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $fd4eb456bcbd06f8$var$Ud extends EventTarget {
    constructor(){
        super(...arguments), this.ongoingActivities = new Set, this.totalProgress = 0;
    }
    get ongoingActivityCount() {
        return this.ongoingActivities.size;
    }
    beginActivity() {
        const t1 = {
            progress: 0,
            completed: !1
        };
        return this.ongoingActivities.add(t1), 1 === this.ongoingActivityCount && this.announceTotalProgress(t1, 0), (e)=>{
            let n;
            return n = Math.max($fd4eb456bcbd06f8$var$lu(e, 0, 1), t1.progress), n !== t1.progress && this.announceTotalProgress(t1, n), t1.progress;
        };
    }
    announceTotalProgress(t1, e) {
        let n = 0, i = 0;
        1 == e && (t1.completed = !0);
        for (const t1 of this.ongoingActivities){
            const { progress: e } = t1;
            n += 1 - e, !0 === t1.completed && i++;
        }
        const r = t1.progress;
        t1.progress = e, this.totalProgress += (e - r) * (1 - this.totalProgress) / n;
        const s = i === this.ongoingActivityCount ? 1 : this.totalProgress;
        this.dispatchEvent(new CustomEvent("progress", {
            detail: {
                totalProgress: s
            }
        })), i === this.ongoingActivityCount && (this.totalProgress = 0, this.ongoingActivities.clear());
    }
}
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $fd4eb456bcbd06f8$var$kd, $fd4eb456bcbd06f8$var$Bd, $fd4eb456bcbd06f8$var$zd, $fd4eb456bcbd06f8$var$Hd, $fd4eb456bcbd06f8$var$Vd, $fd4eb456bcbd06f8$var$Gd, $fd4eb456bcbd06f8$var$Wd, $fd4eb456bcbd06f8$var$jd, $fd4eb456bcbd06f8$var$qd, $fd4eb456bcbd06f8$var$Xd, $fd4eb456bcbd06f8$var$$d, $fd4eb456bcbd06f8$var$Yd, $fd4eb456bcbd06f8$var$Jd = function(t1, e, n, i) {
    for(var r, s = arguments.length, a = s < 3 ? e : null === i ? i = Object.getOwnPropertyDescriptor(e, n) : i, o = t1.length - 1; o >= 0; o--)(r = t1[o]) && (a = (s < 3 ? r(a) : s > 3 ? r(e, n, a) : r(e, n)) || a);
    return s > 3 && a && Object.defineProperty(e, n, a), a;
};
const $fd4eb456bcbd06f8$var$Kd = document.createElement("canvas"), $fd4eb456bcbd06f8$var$Zd = Symbol("fallbackResizeHandler"), $fd4eb456bcbd06f8$var$Qd = Symbol("defaultAriaLabel"), $fd4eb456bcbd06f8$var$tp = Symbol("resizeObserver"), $fd4eb456bcbd06f8$var$ep = Symbol("clearModelTimeout"), $fd4eb456bcbd06f8$var$np = Symbol("onContextLost"), $fd4eb456bcbd06f8$var$ip = Symbol("loaded"), $fd4eb456bcbd06f8$var$rp = Symbol("status"), $fd4eb456bcbd06f8$var$sp = Symbol("onFocus"), $fd4eb456bcbd06f8$var$ap = Symbol("onBlur"), $fd4eb456bcbd06f8$var$op = Symbol("updateSize"), $fd4eb456bcbd06f8$var$lp = Symbol("intersectionObserver"), $fd4eb456bcbd06f8$var$hp = Symbol("isElementInViewport"), $fd4eb456bcbd06f8$var$cp = Symbol("announceModelVisibility"), $fd4eb456bcbd06f8$var$up = Symbol("ariaLabel"), $fd4eb456bcbd06f8$var$dp = Symbol("altDefaulted"), $fd4eb456bcbd06f8$var$pp = Symbol("statusElement"), $fd4eb456bcbd06f8$var$mp = Symbol("updateStatus"), $fd4eb456bcbd06f8$var$fp = Symbol("loadedTime"), $fd4eb456bcbd06f8$var$gp = Symbol("updateSource"), $fd4eb456bcbd06f8$var$vp = Symbol("markLoaded"), $fd4eb456bcbd06f8$var$yp = Symbol("container"), $fd4eb456bcbd06f8$var$xp = Symbol("input"), $fd4eb456bcbd06f8$var$bp = Symbol("canvas"), $fd4eb456bcbd06f8$var$_p = Symbol("scene"), $fd4eb456bcbd06f8$var$wp = Symbol("needsRender"), $fd4eb456bcbd06f8$var$Mp = Symbol("tick"), $fd4eb456bcbd06f8$var$Sp = Symbol("onModelLoad"), $fd4eb456bcbd06f8$var$Tp = Symbol("onResize"), $fd4eb456bcbd06f8$var$Ep = Symbol("renderer"), $fd4eb456bcbd06f8$var$Ap = Symbol("progressTracker"), $fd4eb456bcbd06f8$var$Rp = Symbol("getLoaded"), $fd4eb456bcbd06f8$var$Cp = Symbol("getModelIsVisible"), $fd4eb456bcbd06f8$var$Lp = Symbol("shouldAttemptPreload"), $fd4eb456bcbd06f8$var$Pp = Symbol("sceneIsReady"), $fd4eb456bcbd06f8$var$Dp = Symbol("hasTransitioned"), $fd4eb456bcbd06f8$var$Ip = (t1)=>({
        x: t1.x,
        y: t1.y,
        z: t1.z,
        toString () {
            return `${this.x}m ${this.y}m ${this.z}m`;
        }
    }), $fd4eb456bcbd06f8$var$Op = (t1)=>({
        u: t1.x,
        v: t1.y,
        toString () {
            return `${this.u} ${this.v}`;
        }
    });
class $fd4eb456bcbd06f8$var$Np extends $fd4eb456bcbd06f8$var$Ml {
    constructor(){
        super(), this.alt = null, this.src = null, this.withCredentials = !1, this[$fd4eb456bcbd06f8$var$kd] = !1, this[$fd4eb456bcbd06f8$var$Bd] = !1, this[$fd4eb456bcbd06f8$var$zd] = 0, this[$fd4eb456bcbd06f8$var$Hd] = null, this[$fd4eb456bcbd06f8$var$Vd] = $fd4eb456bcbd06f8$var$ou(()=>{
            const t1 = this.getBoundingClientRect();
            this[$fd4eb456bcbd06f8$var$op](t1);
        }, 50), this[$fd4eb456bcbd06f8$var$Gd] = $fd4eb456bcbd06f8$var$ou((t1)=>{
            const e = this.modelIsVisible;
            e !== t1 && this.dispatchEvent(new CustomEvent("model-visibility", {
                detail: {
                    visible: e
                }
            }));
        }, 0), this[$fd4eb456bcbd06f8$var$Wd] = null, this[$fd4eb456bcbd06f8$var$jd] = null, this[$fd4eb456bcbd06f8$var$qd] = new $fd4eb456bcbd06f8$var$Ud, this[$fd4eb456bcbd06f8$var$Xd] = ()=>{
            this[$fd4eb456bcbd06f8$var$pp].textContent = this[$fd4eb456bcbd06f8$var$rp];
        }, this[$fd4eb456bcbd06f8$var$$d] = ()=>{
            this[$fd4eb456bcbd06f8$var$pp].textContent = "";
        }, this[$fd4eb456bcbd06f8$var$Yd] = (t1)=>{
            this.dispatchEvent(new CustomEvent("error", {
                detail: {
                    type: "webglcontextlost",
                    sourceError: t1.sourceEvent
                }
            }));
        }, this.attachShadow({
            mode: "open"
        });
        const t1 = this.shadowRoot;
        let e, n;
        if (((t1)=>{
            $fd4eb456bcbd06f8$var$jl($fd4eb456bcbd06f8$var$bh, t1);
        })(t1), this[$fd4eb456bcbd06f8$var$yp] = t1.querySelector(".container"), this[$fd4eb456bcbd06f8$var$xp] = t1.querySelector(".userInput"), this[$fd4eb456bcbd06f8$var$bp] = t1.querySelector("canvas"), this[$fd4eb456bcbd06f8$var$pp] = t1.querySelector("#status"), this[$fd4eb456bcbd06f8$var$Qd] = this[$fd4eb456bcbd06f8$var$xp].getAttribute("aria-label"), this.isConnected) {
            const t1 = this.getBoundingClientRect();
            e = t1.width, n = t1.height;
        } else e = 300, n = 150;
        this[$fd4eb456bcbd06f8$var$_p] = new $fd4eb456bcbd06f8$var$Bu({
            canvas: this[$fd4eb456bcbd06f8$var$bp],
            element: this,
            width: e,
            height: n
        }), this[$fd4eb456bcbd06f8$var$_p].addEventListener("model-load", async (t1)=>{
            this[$fd4eb456bcbd06f8$var$vp](), this[$fd4eb456bcbd06f8$var$Sp](), await $fd4eb456bcbd06f8$var$uu(), this.dispatchEvent(new CustomEvent("load", {
                detail: {
                    url: t1.url
                }
            }));
        }), Promise.resolve().then(()=>{
            this[$fd4eb456bcbd06f8$var$op](this.getBoundingClientRect());
        }), $fd4eb456bcbd06f8$var$uh && (this[$fd4eb456bcbd06f8$var$tp] = new ResizeObserver((t1)=>{
            if (!this[$fd4eb456bcbd06f8$var$Ep].isPresenting) for (let e of t1)e.target === this && this[$fd4eb456bcbd06f8$var$op](e.contentRect);
        })), $fd4eb456bcbd06f8$var$dh ? this[$fd4eb456bcbd06f8$var$lp] = new IntersectionObserver((t1)=>{
            for (let e of t1)if (e.target === this) {
                const t1 = this.modelIsVisible;
                this[$fd4eb456bcbd06f8$var$hp] = e.isIntersecting, this[$fd4eb456bcbd06f8$var$cp](t1), this[$fd4eb456bcbd06f8$var$hp] && !this[$fd4eb456bcbd06f8$var$Pp]() && this[$fd4eb456bcbd06f8$var$gp]();
            }
        }, {
            root: null,
            rootMargin: "0px",
            threshold: 0
        }) : this[$fd4eb456bcbd06f8$var$hp] = !0;
    }
    static get is() {
        return "model-viewer";
    }
    static set modelCacheSize(t1) {
        $fd4eb456bcbd06f8$var$Jc[$fd4eb456bcbd06f8$var$$c].evictionThreshold = t1;
    }
    static get modelCacheSize() {
        return $fd4eb456bcbd06f8$var$Jc[$fd4eb456bcbd06f8$var$$c].evictionThreshold;
    }
    static set minimumRenderScale(t1) {
        t1 > 1 && console.warn("<model-viewer> minimumRenderScale has been clamped to a maximum value of 1."), t1 <= 0 && console.warn("<model-viewer> minimumRenderScale has been clamped to a minimum value of 0.25."), $fd4eb456bcbd06f8$var$Fd.singleton.minScale = t1;
    }
    static get minimumRenderScale() {
        return $fd4eb456bcbd06f8$var$Fd.singleton.minScale;
    }
    get loaded() {
        return this[$fd4eb456bcbd06f8$var$Rp]();
    }
    get [($fd4eb456bcbd06f8$var$kd = $fd4eb456bcbd06f8$var$hp, $fd4eb456bcbd06f8$var$Bd = $fd4eb456bcbd06f8$var$ip, $fd4eb456bcbd06f8$var$zd = $fd4eb456bcbd06f8$var$fp, $fd4eb456bcbd06f8$var$Hd = $fd4eb456bcbd06f8$var$ep, $fd4eb456bcbd06f8$var$Vd = $fd4eb456bcbd06f8$var$Zd, $fd4eb456bcbd06f8$var$Gd = $fd4eb456bcbd06f8$var$cp, $fd4eb456bcbd06f8$var$Wd = $fd4eb456bcbd06f8$var$tp, $fd4eb456bcbd06f8$var$jd = $fd4eb456bcbd06f8$var$lp, $fd4eb456bcbd06f8$var$qd = $fd4eb456bcbd06f8$var$Ap, $fd4eb456bcbd06f8$var$Ep)]() {
        return $fd4eb456bcbd06f8$var$Fd.singleton;
    }
    get modelIsVisible() {
        return this[$fd4eb456bcbd06f8$var$Cp]();
    }
    connectedCallback() {
        super.connectedCallback && super.connectedCallback(), $fd4eb456bcbd06f8$var$uh ? this[$fd4eb456bcbd06f8$var$tp].observe(this) : self.addEventListener("resize", this[$fd4eb456bcbd06f8$var$Zd]), $fd4eb456bcbd06f8$var$dh && this[$fd4eb456bcbd06f8$var$lp].observe(this), this.addEventListener("focus", this[$fd4eb456bcbd06f8$var$sp]), this.addEventListener("blur", this[$fd4eb456bcbd06f8$var$ap]);
        const t1 = this[$fd4eb456bcbd06f8$var$Ep];
        t1.addEventListener("contextlost", this[$fd4eb456bcbd06f8$var$np]), t1.registerScene(this[$fd4eb456bcbd06f8$var$_p]), null != this[$fd4eb456bcbd06f8$var$ep] && (self.clearTimeout(this[$fd4eb456bcbd06f8$var$ep]), this[$fd4eb456bcbd06f8$var$ep] = null, this.requestUpdate("src", null));
    }
    disconnectedCallback() {
        super.disconnectedCallback && super.disconnectedCallback(), $fd4eb456bcbd06f8$var$uh ? this[$fd4eb456bcbd06f8$var$tp].unobserve(this) : self.removeEventListener("resize", this[$fd4eb456bcbd06f8$var$Zd]), $fd4eb456bcbd06f8$var$dh && this[$fd4eb456bcbd06f8$var$lp].unobserve(this), this.removeEventListener("focus", this[$fd4eb456bcbd06f8$var$sp]), this.removeEventListener("blur", this[$fd4eb456bcbd06f8$var$ap]);
        const t1 = this[$fd4eb456bcbd06f8$var$Ep];
        t1.removeEventListener("contextlost", this[$fd4eb456bcbd06f8$var$np]), t1.unregisterScene(this[$fd4eb456bcbd06f8$var$_p]), this[$fd4eb456bcbd06f8$var$ep] = self.setTimeout(()=>{
            this[$fd4eb456bcbd06f8$var$_p].reset();
        }, 1e3);
    }
    updated(t1) {
        super.updated(t1), t1.has("src") && (null == this.src ? (this[$fd4eb456bcbd06f8$var$ip] = !1, this[$fd4eb456bcbd06f8$var$fp] = 0, this[$fd4eb456bcbd06f8$var$_p].reset()) : this.src !== this[$fd4eb456bcbd06f8$var$_p].url && (this[$fd4eb456bcbd06f8$var$ip] = !1, this[$fd4eb456bcbd06f8$var$fp] = 0, this[$fd4eb456bcbd06f8$var$gp]())), t1.has("alt") && this[$fd4eb456bcbd06f8$var$xp].setAttribute("aria-label", this[$fd4eb456bcbd06f8$var$up]), t1.has("withCredentials") && ($fd4eb456bcbd06f8$var$Jc.withCredentials = this.withCredentials);
    }
    toDataURL(t1, e) {
        return this[$fd4eb456bcbd06f8$var$Ep].displayCanvas(this[$fd4eb456bcbd06f8$var$_p]).toDataURL(t1, e);
    }
    async toBlob(t1) {
        const e = t1 ? t1.mimeType : void 0, n = t1 ? t1.qualityArgument : void 0, i = t1 ? t1.idealAspect : void 0, { width: r, height: s, idealAspect: a, aspect: o } = this[$fd4eb456bcbd06f8$var$_p], { dpr: l, scaleFactor: h } = this[$fd4eb456bcbd06f8$var$Ep];
        let c = r * h * l, u = s * h * l, d = 0, p = 0;
        if (!0 === i) {
            if (a > o) {
                const t1 = u;
                u = Math.round(c / a), p = (t1 - u) / 2;
            } else {
                const t1 = c;
                c = Math.round(u * a), d = (t1 - c) / 2;
            }
        }
        $fd4eb456bcbd06f8$var$Kd.width = c, $fd4eb456bcbd06f8$var$Kd.height = u;
        try {
            return new Promise(async (t1, i)=>($fd4eb456bcbd06f8$var$Kd.getContext("2d").drawImage(this[$fd4eb456bcbd06f8$var$Ep].displayCanvas(this[$fd4eb456bcbd06f8$var$_p]), d, p, c, u, 0, 0, c, u), !$fd4eb456bcbd06f8$var$Kd.msToBlob || e && "image/png" !== e ? $fd4eb456bcbd06f8$var$Kd.toBlob ? void $fd4eb456bcbd06f8$var$Kd.toBlob((e)=>{
                    if (!e) return i(new Error("Unable to retrieve canvas blob"));
                    t1(e);
                }, e, n) : t1(await (async (t1)=>new Promise((e, n)=>{
                        const i = t1.match(/data:(.*);/);
                        if (!i) return n(new Error(`${t1} is not a valid data Url`));
                        const r = i[1], s = t1.replace(/data:image\/\w+;base64,/, ""), a = atob(s), o = [];
                        for(let t1 = 0; t1 < a.length; t1 += 512){
                            const e = a.slice(t1, t1 + 512), n = new Array(e.length);
                            for(let t1 = 0; t1 < e.length; t1++)n[t1] = e.charCodeAt(t1);
                            const i = new Uint8Array(n);
                            o.push(i);
                        }
                        e(new Blob(o, {
                            type: r
                        }));
                    }))($fd4eb456bcbd06f8$var$Kd.toDataURL(e, n))) : t1($fd4eb456bcbd06f8$var$Kd.msToBlob())));
        } finally{
            this[$fd4eb456bcbd06f8$var$op]({
                width: r,
                height: s
            });
        }
    }
    registerRenderer(t1) {
        this[$fd4eb456bcbd06f8$var$_p].externalRenderer = t1;
    }
    unregisterRenderer() {
        this[$fd4eb456bcbd06f8$var$_p].externalRenderer = null;
    }
    get [$fd4eb456bcbd06f8$var$up]() {
        return this[$fd4eb456bcbd06f8$var$dp];
    }
    get [$fd4eb456bcbd06f8$var$dp]() {
        return null == this.alt || "null" === this.alt ? this[$fd4eb456bcbd06f8$var$Qd] : this.alt;
    }
    [$fd4eb456bcbd06f8$var$Rp]() {
        return this[$fd4eb456bcbd06f8$var$ip];
    }
    [$fd4eb456bcbd06f8$var$Cp]() {
        return this.loaded && this[$fd4eb456bcbd06f8$var$hp];
    }
    [$fd4eb456bcbd06f8$var$Dp]() {
        return this.modelIsVisible;
    }
    [$fd4eb456bcbd06f8$var$Lp]() {
        return !!this.src && this[$fd4eb456bcbd06f8$var$hp];
    }
    [$fd4eb456bcbd06f8$var$Pp]() {
        return this[$fd4eb456bcbd06f8$var$ip];
    }
    [$fd4eb456bcbd06f8$var$op]({ width: t1, height: e }) {
        this[$fd4eb456bcbd06f8$var$yp].style.width = `${t1}px`, this[$fd4eb456bcbd06f8$var$yp].style.height = `${e}px`, this[$fd4eb456bcbd06f8$var$Tp]({
            width: parseFloat(t1),
            height: parseFloat(e)
        });
    }
    [$fd4eb456bcbd06f8$var$Mp](t1, e) {}
    [$fd4eb456bcbd06f8$var$vp]() {
        this[$fd4eb456bcbd06f8$var$ip] || (this[$fd4eb456bcbd06f8$var$ip] = !0, this[$fd4eb456bcbd06f8$var$fp] = performance.now());
    }
    [$fd4eb456bcbd06f8$var$wp]() {
        this[$fd4eb456bcbd06f8$var$_p].queueRender();
    }
    [$fd4eb456bcbd06f8$var$Sp]() {}
    [$fd4eb456bcbd06f8$var$mp](t1) {
        this[$fd4eb456bcbd06f8$var$rp] = t1;
        const e = this.getRootNode();
        null != e && e.activeElement === this && this[$fd4eb456bcbd06f8$var$pp].textContent != t1 && (this[$fd4eb456bcbd06f8$var$pp].textContent = t1);
    }
    [($fd4eb456bcbd06f8$var$Xd = $fd4eb456bcbd06f8$var$sp, $fd4eb456bcbd06f8$var$$d = $fd4eb456bcbd06f8$var$ap, $fd4eb456bcbd06f8$var$Tp)](t1) {
        this[$fd4eb456bcbd06f8$var$_p].setSize(t1.width, t1.height);
    }
    async [($fd4eb456bcbd06f8$var$Yd = $fd4eb456bcbd06f8$var$np, $fd4eb456bcbd06f8$var$gp)]() {
        if (this.loaded || !this[$fd4eb456bcbd06f8$var$Lp]()) return;
        const t1 = this[$fd4eb456bcbd06f8$var$Ap].beginActivity(), e = this.src;
        try {
            await this[$fd4eb456bcbd06f8$var$_p].setSource(e, (e)=>t1(.95 * e));
            const n = {
                url: e
            };
            this.dispatchEvent(new CustomEvent("preload", {
                detail: n
            }));
        } catch (t1) {
            this.dispatchEvent(new CustomEvent("error", {
                detail: t1
            }));
        } finally{
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    t1(1);
                });
            });
        }
    }
}
$fd4eb456bcbd06f8$var$Jd([
    $fd4eb456bcbd06f8$var$e({
        type: String
    })
], $fd4eb456bcbd06f8$var$Np.prototype, "alt", void 0), $fd4eb456bcbd06f8$var$Jd([
    $fd4eb456bcbd06f8$var$e({
        type: String
    })
], $fd4eb456bcbd06f8$var$Np.prototype, "src", void 0), $fd4eb456bcbd06f8$var$Jd([
    $fd4eb456bcbd06f8$var$e({
        type: Boolean,
        attribute: "with-credentials"
    })
], $fd4eb456bcbd06f8$var$Np.prototype, "withCredentials", void 0);
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $fd4eb456bcbd06f8$var$Fp = function(t1, e, n, i) {
    for(var r, s = arguments.length, a = s < 3 ? e : null === i ? i = Object.getOwnPropertyDescriptor(e, n) : i, o = t1.length - 1; o >= 0; o--)(r = t1[o]) && (a = (s < 3 ? r(a) : s > 3 ? r(e, n, a) : r(e, n)) || a);
    return s > 3 && a && Object.defineProperty(e, n, a), a;
};
const $fd4eb456bcbd06f8$var$Up = Symbol("changeAnimation"), $fd4eb456bcbd06f8$var$kp = Symbol("paused"), $fd4eb456bcbd06f8$var$Bp = {
    repetitions: 1 / 0,
    pingpong: !1
}, $fd4eb456bcbd06f8$var$zp = Symbol("hotspotMap"), $fd4eb456bcbd06f8$var$Hp = Symbol("mutationCallback"), $fd4eb456bcbd06f8$var$Vp = Symbol("observer"), $fd4eb456bcbd06f8$var$Gp = Symbol("addHotspot"), $fd4eb456bcbd06f8$var$Wp = Symbol("removeHotspot"), $fd4eb456bcbd06f8$var$jp = new $fd4eb456bcbd06f8$var$xt, $fd4eb456bcbd06f8$var$qp = new $fd4eb456bcbd06f8$var$v;
/*!
fflate - fast JavaScript compression/decompression
<https://101arrowz.github.io/fflate>
Licensed under MIT. https://github.com/101arrowz/fflate/blob/master/LICENSE
version 0.6.9
*/ var $fd4eb456bcbd06f8$var$Xp = function(t1) {
    return URL.createObjectURL(new Blob([
        t1
    ], {
        type: "text/javascript"
    }));
};
try {
    URL.revokeObjectURL($fd4eb456bcbd06f8$var$Xp(""));
} catch (Al) {
    $fd4eb456bcbd06f8$var$Xp = function(t1) {
        return "data:application/javascript;charset=UTF-8," + encodeURI(t1);
    };
}
var $fd4eb456bcbd06f8$var$$p = Uint8Array, $fd4eb456bcbd06f8$var$Yp = Uint16Array, $fd4eb456bcbd06f8$var$Jp = Uint32Array, $fd4eb456bcbd06f8$var$Kp = new $fd4eb456bcbd06f8$var$$p([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    0,
    0,
    0
]), $fd4eb456bcbd06f8$var$Zp = new $fd4eb456bcbd06f8$var$$p([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    0,
    0
]), $fd4eb456bcbd06f8$var$Qp = new $fd4eb456bcbd06f8$var$$p([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]), $fd4eb456bcbd06f8$var$tm = function(t1, e) {
    for(var n = new $fd4eb456bcbd06f8$var$Yp(31), i = 0; i < 31; ++i)n[i] = e += 1 << t1[i - 1];
    var r = new $fd4eb456bcbd06f8$var$Jp(n[30]);
    for(i = 1; i < 30; ++i)for(var s = n[i]; s < n[i + 1]; ++s)r[s] = s - n[i] << 5 | i;
    return [
        n,
        r
    ];
}, $fd4eb456bcbd06f8$var$em = $fd4eb456bcbd06f8$var$tm($fd4eb456bcbd06f8$var$Kp, 2), $fd4eb456bcbd06f8$var$nm = $fd4eb456bcbd06f8$var$em[0], $fd4eb456bcbd06f8$var$im = $fd4eb456bcbd06f8$var$em[1];
$fd4eb456bcbd06f8$var$nm[28] = 258, $fd4eb456bcbd06f8$var$im[258] = 28;
for(var $fd4eb456bcbd06f8$var$rm = $fd4eb456bcbd06f8$var$tm($fd4eb456bcbd06f8$var$Zp, 0)[1], $fd4eb456bcbd06f8$var$sm = new $fd4eb456bcbd06f8$var$Yp(32768), $fd4eb456bcbd06f8$var$am = 0; $fd4eb456bcbd06f8$var$am < 32768; ++$fd4eb456bcbd06f8$var$am){
    var $fd4eb456bcbd06f8$var$om = (43690 & $fd4eb456bcbd06f8$var$am) >>> 1 | (21845 & $fd4eb456bcbd06f8$var$am) << 1;
    $fd4eb456bcbd06f8$var$om = (61680 & ($fd4eb456bcbd06f8$var$om = (52428 & $fd4eb456bcbd06f8$var$om) >>> 2 | (13107 & $fd4eb456bcbd06f8$var$om) << 2)) >>> 4 | (3855 & $fd4eb456bcbd06f8$var$om) << 4, $fd4eb456bcbd06f8$var$sm[$fd4eb456bcbd06f8$var$am] = ((65280 & $fd4eb456bcbd06f8$var$om) >>> 8 | (255 & $fd4eb456bcbd06f8$var$om) << 8) >>> 1;
}
var $fd4eb456bcbd06f8$var$lm = function(t1, e, n) {
    for(var i = t1.length, r = 0, s = new $fd4eb456bcbd06f8$var$Yp(e); r < i; ++r)++s[t1[r] - 1];
    var a, o = new $fd4eb456bcbd06f8$var$Yp(e);
    for(r = 0; r < e; ++r)o[r] = o[r - 1] + s[r - 1] << 1;
    if (n) {
        a = new $fd4eb456bcbd06f8$var$Yp(1 << e);
        var l = 15 - e;
        for(r = 0; r < i; ++r)if (t1[r]) for(var h = r << 4 | t1[r], c = e - t1[r], u = o[t1[r] - 1]++ << c, d = u | (1 << c) - 1; u <= d; ++u)a[$fd4eb456bcbd06f8$var$sm[u] >>> l] = h;
    } else for(a = new $fd4eb456bcbd06f8$var$Yp(i), r = 0; r < i; ++r)t1[r] && (a[r] = $fd4eb456bcbd06f8$var$sm[o[t1[r] - 1]++] >>> 15 - t1[r]);
    return a;
}, $fd4eb456bcbd06f8$var$hm = new $fd4eb456bcbd06f8$var$$p(288);
for($fd4eb456bcbd06f8$var$am = 0; $fd4eb456bcbd06f8$var$am < 144; ++$fd4eb456bcbd06f8$var$am)$fd4eb456bcbd06f8$var$hm[$fd4eb456bcbd06f8$var$am] = 8;
for($fd4eb456bcbd06f8$var$am = 144; $fd4eb456bcbd06f8$var$am < 256; ++$fd4eb456bcbd06f8$var$am)$fd4eb456bcbd06f8$var$hm[$fd4eb456bcbd06f8$var$am] = 9;
for($fd4eb456bcbd06f8$var$am = 256; $fd4eb456bcbd06f8$var$am < 280; ++$fd4eb456bcbd06f8$var$am)$fd4eb456bcbd06f8$var$hm[$fd4eb456bcbd06f8$var$am] = 7;
for($fd4eb456bcbd06f8$var$am = 280; $fd4eb456bcbd06f8$var$am < 288; ++$fd4eb456bcbd06f8$var$am)$fd4eb456bcbd06f8$var$hm[$fd4eb456bcbd06f8$var$am] = 8;
var $fd4eb456bcbd06f8$var$cm = new $fd4eb456bcbd06f8$var$$p(32);
for($fd4eb456bcbd06f8$var$am = 0; $fd4eb456bcbd06f8$var$am < 32; ++$fd4eb456bcbd06f8$var$am)$fd4eb456bcbd06f8$var$cm[$fd4eb456bcbd06f8$var$am] = 5;
var $fd4eb456bcbd06f8$var$um = $fd4eb456bcbd06f8$var$lm($fd4eb456bcbd06f8$var$hm, 9, 0), $fd4eb456bcbd06f8$var$dm = $fd4eb456bcbd06f8$var$lm($fd4eb456bcbd06f8$var$cm, 5, 0), $fd4eb456bcbd06f8$var$pm = function(t1) {
    return (t1 / 8 | 0) + (7 & t1 && 1);
}, $fd4eb456bcbd06f8$var$mm = function(t1, e, n) {
    (null == e || e < 0) && (e = 0), (null == n || n > t1.length) && (n = t1.length);
    var i = new (t1 instanceof $fd4eb456bcbd06f8$var$Yp ? $fd4eb456bcbd06f8$var$Yp : t1 instanceof $fd4eb456bcbd06f8$var$Jp ? $fd4eb456bcbd06f8$var$Jp : $fd4eb456bcbd06f8$var$$p)(n - e);
    return i.set(t1.subarray(e, n)), i;
}, $fd4eb456bcbd06f8$var$fm = function(t1, e, n) {
    n <<= 7 & e;
    var i = e / 8 | 0;
    t1[i] |= n, t1[i + 1] |= n >>> 8;
}, $fd4eb456bcbd06f8$var$gm = function(t1, e, n) {
    n <<= 7 & e;
    var i = e / 8 | 0;
    t1[i] |= n, t1[i + 1] |= n >>> 8, t1[i + 2] |= n >>> 16;
}, $fd4eb456bcbd06f8$var$vm = function(t1, e) {
    for(var n = [], i = 0; i < t1.length; ++i)t1[i] && n.push({
        s: i,
        f: t1[i]
    });
    var r = n.length, s = n.slice();
    if (!r) return [
        $fd4eb456bcbd06f8$var$Sm,
        0
    ];
    if (1 == r) {
        var a = new $fd4eb456bcbd06f8$var$$p(n[0].s + 1);
        return a[n[0].s] = 1, [
            a,
            1
        ];
    }
    n.sort(function(t1, e) {
        return t1.f - e.f;
    }), n.push({
        s: -1,
        f: 25001
    });
    var o = n[0], l = n[1], h = 0, c = 1, u = 2;
    for(n[0] = {
        s: -1,
        f: o.f + l.f,
        l: o,
        r: l
    }; c != r - 1;)o = n[n[h].f < n[u].f ? h++ : u++], l = n[h != c && n[h].f < n[u].f ? h++ : u++], n[c++] = {
        s: -1,
        f: o.f + l.f,
        l: o,
        r: l
    };
    var d = s[0].s;
    for(i = 1; i < r; ++i)s[i].s > d && (d = s[i].s);
    var p = new $fd4eb456bcbd06f8$var$Yp(d + 1), m = $fd4eb456bcbd06f8$var$ym(n[c - 1], p, 0);
    if (m > e) {
        i = 0;
        var f = 0, g = m - e, v = 1 << g;
        for(s.sort(function(t1, e) {
            return p[e.s] - p[t1.s] || t1.f - e.f;
        }); i < r; ++i){
            var y = s[i].s;
            if (!(p[y] > e)) break;
            f += v - (1 << m - p[y]), p[y] = e;
        }
        for(f >>>= g; f > 0;){
            var x = s[i].s;
            p[x] < e ? f -= 1 << e - p[x]++ - 1 : ++i;
        }
        for(; i >= 0 && f; --i){
            var b = s[i].s;
            p[b] == e && (--p[b], ++f);
        }
        m = e;
    }
    return [
        new $fd4eb456bcbd06f8$var$$p(p),
        m
    ];
}, $fd4eb456bcbd06f8$var$ym = function(t1, e, n) {
    return -1 == t1.s ? Math.max($fd4eb456bcbd06f8$var$ym(t1.l, e, n + 1), $fd4eb456bcbd06f8$var$ym(t1.r, e, n + 1)) : e[t1.s] = n;
}, $fd4eb456bcbd06f8$var$xm = function(t1) {
    for(var e = t1.length; e && !t1[--e];);
    for(var n = new $fd4eb456bcbd06f8$var$Yp(++e), i = 0, r = t1[0], s = 1, a = function(t1) {
        n[i++] = t1;
    }, o = 1; o <= e; ++o)if (t1[o] == r && o != e) ++s;
    else {
        if (!r && s > 2) {
            for(; s > 138; s -= 138)a(32754);
            s > 2 && (a(s > 10 ? s - 11 << 5 | 28690 : s - 3 << 5 | 12305), s = 0);
        } else if (s > 3) {
            for(a(r), --s; s > 6; s -= 6)a(8304);
            s > 2 && (a(s - 3 << 5 | 8208), s = 0);
        }
        for(; s--;)a(r);
        s = 1, r = t1[o];
    }
    return [
        n.subarray(0, i),
        e
    ];
}, $fd4eb456bcbd06f8$var$bm = function(t1, e) {
    for(var n = 0, i = 0; i < e.length; ++i)n += t1[i] * e[i];
    return n;
}, $fd4eb456bcbd06f8$var$_m = function(t1, e, n) {
    var i = n.length, r = $fd4eb456bcbd06f8$var$pm(e + 2);
    t1[r] = 255 & i, t1[r + 1] = i >>> 8, t1[r + 2] = 255 ^ t1[r], t1[r + 3] = 255 ^ t1[r + 1];
    for(var s = 0; s < i; ++s)t1[r + s + 4] = n[s];
    return 8 * (r + 4 + i);
}, $fd4eb456bcbd06f8$var$wm = function(t1, e, n, i, r, s, a, o, l, h, c) {
    $fd4eb456bcbd06f8$var$fm(e, c++, n), ++r[256];
    for(var u = $fd4eb456bcbd06f8$var$vm(r, 15), d = u[0], p = u[1], m = $fd4eb456bcbd06f8$var$vm(s, 15), f = m[0], g = m[1], v = $fd4eb456bcbd06f8$var$xm(d), y = v[0], x = v[1], b = $fd4eb456bcbd06f8$var$xm(f), _ = b[0], w = b[1], M = new $fd4eb456bcbd06f8$var$Yp(19), S = 0; S < y.length; ++S)M[31 & y[S]]++;
    for(S = 0; S < _.length; ++S)M[31 & _[S]]++;
    for(var T = $fd4eb456bcbd06f8$var$vm(M, 7), E = T[0], A = T[1], R = 19; R > 4 && !E[$fd4eb456bcbd06f8$var$Qp[R - 1]]; --R);
    var C, L, P, D, I = h + 5 << 3, O = $fd4eb456bcbd06f8$var$bm(r, $fd4eb456bcbd06f8$var$hm) + $fd4eb456bcbd06f8$var$bm(s, $fd4eb456bcbd06f8$var$cm) + a, N = $fd4eb456bcbd06f8$var$bm(r, d) + $fd4eb456bcbd06f8$var$bm(s, f) + a + 14 + 3 * R + $fd4eb456bcbd06f8$var$bm(M, E) + (2 * M[16] + 3 * M[17] + 7 * M[18]);
    if (I <= O && I <= N) return $fd4eb456bcbd06f8$var$_m(e, c, t1.subarray(l, l + h));
    if ($fd4eb456bcbd06f8$var$fm(e, c, 1 + (N < O)), c += 2, N < O) {
        C = $fd4eb456bcbd06f8$var$lm(d, p, 0), L = d, P = $fd4eb456bcbd06f8$var$lm(f, g, 0), D = f;
        var F = $fd4eb456bcbd06f8$var$lm(E, A, 0);
        $fd4eb456bcbd06f8$var$fm(e, c, x - 257), $fd4eb456bcbd06f8$var$fm(e, c + 5, w - 1), $fd4eb456bcbd06f8$var$fm(e, c + 10, R - 4), c += 14;
        for(S = 0; S < R; ++S)$fd4eb456bcbd06f8$var$fm(e, c + 3 * S, E[$fd4eb456bcbd06f8$var$Qp[S]]);
        c += 3 * R;
        for(var U = [
            y,
            _
        ], k = 0; k < 2; ++k){
            var B = U[k];
            for(S = 0; S < B.length; ++S){
                var z = 31 & B[S];
                $fd4eb456bcbd06f8$var$fm(e, c, F[z]), c += E[z], z > 15 && ($fd4eb456bcbd06f8$var$fm(e, c, B[S] >>> 5 & 127), c += B[S] >>> 12);
            }
        }
    } else C = $fd4eb456bcbd06f8$var$um, L = $fd4eb456bcbd06f8$var$hm, P = $fd4eb456bcbd06f8$var$dm, D = $fd4eb456bcbd06f8$var$cm;
    for(S = 0; S < o; ++S)if (i[S] > 255) {
        z = i[S] >>> 18 & 31;
        $fd4eb456bcbd06f8$var$gm(e, c, C[z + 257]), c += L[z + 257], z > 7 && ($fd4eb456bcbd06f8$var$fm(e, c, i[S] >>> 23 & 31), c += $fd4eb456bcbd06f8$var$Kp[z]);
        var H = 31 & i[S];
        $fd4eb456bcbd06f8$var$gm(e, c, P[H]), c += D[H], H > 3 && ($fd4eb456bcbd06f8$var$gm(e, c, i[S] >>> 5 & 8191), c += $fd4eb456bcbd06f8$var$Zp[H]);
    } else $fd4eb456bcbd06f8$var$gm(e, c, C[i[S]]), c += L[i[S]];
    return $fd4eb456bcbd06f8$var$gm(e, c, C[256]), c + L[256];
}, $fd4eb456bcbd06f8$var$Mm = new $fd4eb456bcbd06f8$var$Jp([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]), $fd4eb456bcbd06f8$var$Sm = new $fd4eb456bcbd06f8$var$$p(0), $fd4eb456bcbd06f8$var$Tm = function() {
    for(var t1 = new $fd4eb456bcbd06f8$var$Jp(256), e = 0; e < 256; ++e){
        for(var n = e, i = 9; --i;)n = (1 & n && 3988292384) ^ n >>> 1;
        t1[e] = n;
    }
    return t1;
}(), $fd4eb456bcbd06f8$var$Em = function() {
    var t1 = -1;
    return {
        p: function(e) {
            for(var n = t1, i = 0; i < e.length; ++i)n = $fd4eb456bcbd06f8$var$Tm[255 & n ^ e[i]] ^ n >>> 8;
            t1 = n;
        },
        d: function() {
            return ~t1;
        }
    };
}, $fd4eb456bcbd06f8$var$Am = function(t1, e, n, i, r) {
    return function(t1, e, n, i, r, s) {
        var a = t1.length, o = new $fd4eb456bcbd06f8$var$$p(i + a + 5 * (1 + Math.ceil(a / 7e3)) + r), l = o.subarray(i, o.length - r), h = 0;
        if (!e || a < 8) for(var c = 0; c <= a; c += 65535){
            var u = c + 65535;
            u < a ? h = $fd4eb456bcbd06f8$var$_m(l, h, t1.subarray(c, u)) : (l[c] = s, h = $fd4eb456bcbd06f8$var$_m(l, h, t1.subarray(c, a)));
        }
        else {
            for(var d = $fd4eb456bcbd06f8$var$Mm[e - 1], p = d >>> 13, m = 8191 & d, f = (1 << n) - 1, g = new $fd4eb456bcbd06f8$var$Yp(32768), v = new $fd4eb456bcbd06f8$var$Yp(f + 1), y = Math.ceil(n / 3), x = 2 * y, b = function(e) {
                return (t1[e] ^ t1[e + 1] << y ^ t1[e + 2] << x) & f;
            }, _ = new $fd4eb456bcbd06f8$var$Jp(25e3), w = new $fd4eb456bcbd06f8$var$Yp(288), M = new $fd4eb456bcbd06f8$var$Yp(32), S = 0, T = 0, E = (c = 0, 0), A = 0, R = 0; c < a; ++c){
                var C = b(c), L = 32767 & c, P = v[C];
                if (g[L] = P, v[C] = L, A <= c) {
                    var D = a - c;
                    if ((S > 7e3 || E > 24576) && D > 423) {
                        h = $fd4eb456bcbd06f8$var$wm(t1, l, 0, _, w, M, T, E, R, c - R, h), E = S = T = 0, R = c;
                        for(var I = 0; I < 286; ++I)w[I] = 0;
                        for(I = 0; I < 30; ++I)M[I] = 0;
                    }
                    var O = 2, N = 0, F = m, U = L - P & 32767;
                    if (D > 2 && C == b(c - U)) for(var k = Math.min(p, D) - 1, B = Math.min(32767, c), z = Math.min(258, D); U <= B && --F && L != P;){
                        if (t1[c + O] == t1[c + O - U]) {
                            for(var H = 0; H < z && t1[c + H] == t1[c + H - U]; ++H);
                            if (H > O) {
                                if (O = H, N = U, H > k) break;
                                var V = Math.min(U, H - 2), G = 0;
                                for(I = 0; I < V; ++I){
                                    var W = c - U + I + 32768 & 32767, j = W - g[W] + 32768 & 32767;
                                    j > G && (G = j, P = W);
                                }
                            }
                        }
                        U += (L = P) - (P = g[L]) + 32768 & 32767;
                    }
                    if (N) {
                        _[E++] = 268435456 | $fd4eb456bcbd06f8$var$im[O] << 18 | $fd4eb456bcbd06f8$var$rm[N];
                        var q = 31 & $fd4eb456bcbd06f8$var$im[O], X = 31 & $fd4eb456bcbd06f8$var$rm[N];
                        T += $fd4eb456bcbd06f8$var$Kp[q] + $fd4eb456bcbd06f8$var$Zp[X], ++w[257 + q], ++M[X], A = c + O, ++S;
                    } else _[E++] = t1[c], ++w[t1[c]];
                }
            }
            h = $fd4eb456bcbd06f8$var$wm(t1, l, s, _, w, M, T, E, R, c - R, h), !s && 7 & h && (h = $fd4eb456bcbd06f8$var$_m(l, h + 1, $fd4eb456bcbd06f8$var$Sm));
        }
        return $fd4eb456bcbd06f8$var$mm(o, 0, i + $fd4eb456bcbd06f8$var$pm(h) + r);
    }(t1, null == e.level ? 6 : e.level, null == e.mem ? Math.ceil(1.5 * Math.max(8, Math.min(13, Math.log(t1.length)))) : 12 + e.mem, n, i, !r);
}, $fd4eb456bcbd06f8$var$Rm = function(t1, e) {
    var n = {};
    for(var i in t1)n[i] = t1[i];
    for(var i in e)n[i] = e[i];
    return n;
}, $fd4eb456bcbd06f8$var$Cm = function(t1, e, n) {
    for(; n; ++e)t1[e] = n, n >>>= 8;
};
function $fd4eb456bcbd06f8$var$Lm(t1, e) {
    return $fd4eb456bcbd06f8$var$Am(t1, e || {}, 0, 0);
}
var $fd4eb456bcbd06f8$var$Pm = function(t1, e, n, i) {
    for(var r in t1){
        var s = t1[r], a = e + r;
        s instanceof $fd4eb456bcbd06f8$var$$p ? n[a] = [
            s,
            i
        ] : Array.isArray(s) ? n[a] = [
            s[0],
            $fd4eb456bcbd06f8$var$Rm(i, s[1])
        ] : $fd4eb456bcbd06f8$var$Pm(s, a + "/", n, i);
    }
}, $fd4eb456bcbd06f8$var$Dm = "undefined" != typeof TextEncoder && new TextEncoder, $fd4eb456bcbd06f8$var$Im = "undefined" != typeof TextDecoder && new TextDecoder;
try {
    $fd4eb456bcbd06f8$var$Im.decode($fd4eb456bcbd06f8$var$Sm, {
        stream: !0
    });
} catch (Al) {}
function $fd4eb456bcbd06f8$var$Om(t1, e) {
    if (e) {
        for(var n = new $fd4eb456bcbd06f8$var$$p(t1.length), i = 0; i < t1.length; ++i)n[i] = t1.charCodeAt(i);
        return n;
    }
    if ($fd4eb456bcbd06f8$var$Dm) return $fd4eb456bcbd06f8$var$Dm.encode(t1);
    var r = t1.length, s = new $fd4eb456bcbd06f8$var$$p(t1.length + (t1.length >> 1)), a = 0, o = function(t1) {
        s[a++] = t1;
    };
    for(i = 0; i < r; ++i){
        if (a + 5 > s.length) {
            var l = new $fd4eb456bcbd06f8$var$$p(a + 8 + (r - i << 1));
            l.set(s), s = l;
        }
        var h = t1.charCodeAt(i);
        h < 128 || e ? o(h) : h < 2048 ? (o(192 | h >> 6), o(128 | 63 & h)) : h > 55295 && h < 57344 ? (o(240 | (h = 65536 + (1047552 & h) | 1023 & t1.charCodeAt(++i)) >> 18), o(128 | h >> 12 & 63), o(128 | h >> 6 & 63), o(128 | 63 & h)) : (o(224 | h >> 12), o(128 | h >> 6 & 63), o(128 | 63 & h));
    }
    return $fd4eb456bcbd06f8$var$mm(s, 0, a);
}
var $fd4eb456bcbd06f8$var$Nm = function(t1) {
    var e = 0;
    if (t1) for(var n in t1){
        var i = t1[n].length;
        if (i > 65535) throw "extra field too long";
        e += i + 4;
    }
    return e;
}, $fd4eb456bcbd06f8$var$Fm = function(t1, e, n, i, r, s, a, o) {
    var l = i.length, h = n.extra, c = o && o.length, u = $fd4eb456bcbd06f8$var$Nm(h);
    $fd4eb456bcbd06f8$var$Cm(t1, e, null != a ? 33639248 : 67324752), e += 4, null != a && (t1[e++] = 20, t1[e++] = n.os), t1[e] = 20, e += 2, t1[e++] = n.flag << 1 | (null == s && 8), t1[e++] = r && 8, t1[e++] = 255 & n.compression, t1[e++] = n.compression >> 8;
    var d = new Date(null == n.mtime ? Date.now() : n.mtime), p = d.getFullYear() - 1980;
    if (p < 0 || p > 119) throw "date not in range 1980-2099";
    if ($fd4eb456bcbd06f8$var$Cm(t1, e, p << 25 | d.getMonth() + 1 << 21 | d.getDate() << 16 | d.getHours() << 11 | d.getMinutes() << 5 | d.getSeconds() >>> 1), e += 4, null != s && ($fd4eb456bcbd06f8$var$Cm(t1, e, n.crc), $fd4eb456bcbd06f8$var$Cm(t1, e + 4, s), $fd4eb456bcbd06f8$var$Cm(t1, e + 8, n.size)), $fd4eb456bcbd06f8$var$Cm(t1, e + 12, l), $fd4eb456bcbd06f8$var$Cm(t1, e + 14, u), e += 16, null != a && ($fd4eb456bcbd06f8$var$Cm(t1, e, c), $fd4eb456bcbd06f8$var$Cm(t1, e + 6, n.attrs), $fd4eb456bcbd06f8$var$Cm(t1, e + 10, a), e += 14), t1.set(i, e), e += l, u) for(var m in h){
        var f = h[m], g = f.length;
        $fd4eb456bcbd06f8$var$Cm(t1, e, +m), $fd4eb456bcbd06f8$var$Cm(t1, e + 2, g), t1.set(f, e + 4), e += 4 + g;
    }
    return c && (t1.set(o, e), e += c), e;
};
function $fd4eb456bcbd06f8$var$Um(t1, e) {
    e || (e = {});
    var n = {}, i = [];
    $fd4eb456bcbd06f8$var$Pm(t1, "", n, e);
    var r = 0, s = 0;
    for(var a in n){
        var o = n[a], l = o[0], h = o[1], c = 0 == h.level ? 0 : 8, u = (M = $fd4eb456bcbd06f8$var$Om(a)).length, d = h.comment, p = d && $fd4eb456bcbd06f8$var$Om(d), m = p && p.length, f = $fd4eb456bcbd06f8$var$Nm(h.extra);
        if (u > 65535) throw "filename too long";
        var g = c ? $fd4eb456bcbd06f8$var$Lm(l, h) : l, v = g.length, y = $fd4eb456bcbd06f8$var$Em();
        y.p(l), i.push($fd4eb456bcbd06f8$var$Rm(h, {
            size: l.length,
            crc: y.d(),
            c: g,
            f: M,
            m: p,
            u: u != a.length || p && d.length != m,
            o: r,
            compression: c
        })), r += 30 + u + f + v, s += 76 + 2 * (u + f) + (m || 0) + v;
    }
    for(var x = new $fd4eb456bcbd06f8$var$$p(s + 22), b = r, _ = s - r, w = 0; w < i.length; ++w){
        var M = i[w];
        $fd4eb456bcbd06f8$var$Fm(x, M.o, M, M.f, M.u, M.c.length);
        var S = 30 + M.f.length + $fd4eb456bcbd06f8$var$Nm(M.extra);
        x.set(M.c, M.o + S), $fd4eb456bcbd06f8$var$Fm(x, r, M, M.f, M.u, M.c.length, M.o, M.m), r += 16 + S + (M.m ? M.m.length : 0);
    }
    return function(t1, e, n, i, r) {
        $fd4eb456bcbd06f8$var$Cm(t1, e, 101010256), $fd4eb456bcbd06f8$var$Cm(t1, e + 8, n), $fd4eb456bcbd06f8$var$Cm(t1, e + 10, n), $fd4eb456bcbd06f8$var$Cm(t1, e + 12, i), $fd4eb456bcbd06f8$var$Cm(t1, e + 16, r);
    }(x, r, i.length, _, b), x;
}
class $fd4eb456bcbd06f8$var$km {
    async parse(t1) {
        const e = {};
        e["model.usda"] = null;
        let n = $fd4eb456bcbd06f8$var$zm();
        const i = {}, r = {};
        t1.traverseVisible((t1)=>{
            if (t1.isMesh) {
                if (t1.material.isMeshStandardMaterial) {
                    const r = t1.geometry, s = t1.material, a = "geometries/Geometry_" + r.id + ".usd";
                    if (!(a in e)) {
                        const t1 = function(t1) {
                            return `\ndef "Geometry"\n{\n  ${function(t1) {
                                const e = "Geometry", n = t1.attributes, i = n.position.count;
                                return `\n    def Mesh "${e}"\n    {\n        int[] faceVertexCounts = [${function(t1) {
                                    const e = null !== t1.index ? t1.index.count : t1.attributes.position.count;
                                    return Array(e / 3).fill(3).join(", ");
                                }(t1)}]\n        int[] faceVertexIndices = [${function(t1) {
                                    const e = t1.index, n = [];
                                    if (null !== e) for(let t1 = 0; t1 < e.count; t1++)n.push(e.getX(t1));
                                    else {
                                        const e = t1.attributes.position.count;
                                        for(let t1 = 0; t1 < e; t1++)n.push(t1);
                                    }
                                    return n.join(", ");
                                }(t1)}]\n        normal3f[] normals = [${$fd4eb456bcbd06f8$var$Vm(n.normal, i)}] (\n            interpolation = "vertex"\n        )\n        point3f[] points = [${$fd4eb456bcbd06f8$var$Vm(n.position, i)}]\n        float2[] primvars:st = [${function(t1, e) {
                                    if (void 0 === t1) return console.warn("USDZExporter: UVs missing."), Array(e).fill("(0, 0)").join(", ");
                                    const n = [];
                                    for(let e = 0; e < t1.count; e++){
                                        const i = t1.getX(e), r = t1.getY(e);
                                        n.push(`(${i.toPrecision(7)}, ${1 - r.toPrecision(7)})`);
                                    }
                                    return n.join(", ");
                                }(n.uv, i)}] (\n            interpolation = "vertex"\n        )\n        uniform token subdivisionScheme = "none"\n    }\n`;
                            }(t1)}\n}\n`;
                        }(r);
                        e[a] = function(t1) {
                            let e = $fd4eb456bcbd06f8$var$zm();
                            return e += t1, $fd4eb456bcbd06f8$var$Om(e);
                        }(t1);
                    }
                    s.uuid in i || (i[s.uuid] = s), n += function(t1, e, n) {
                        const i = "Object_" + t1.id, r = function(t1) {
                            const e = t1.elements;
                            return `( ${$fd4eb456bcbd06f8$var$Hm(e, 0)}, ${$fd4eb456bcbd06f8$var$Hm(e, 4)}, ${$fd4eb456bcbd06f8$var$Hm(e, 8)}, ${$fd4eb456bcbd06f8$var$Hm(e, 12)} )`;
                        }(t1.matrixWorld);
                        t1.matrixWorld.determinant() < 0 && console.warn("THREE.USDZExporter: USDZ does not support negative scales", t1);
                        return `def Xform "${i}" (\n    prepend references = @./geometries/Geometry_${e.id}.usd@</Geometry>\n)\n{\n    matrix4d xformOp:transform = ${r}\n    uniform token[] xformOpOrder = ["xformOp:transform"]\n\n    rel material:binding = </Materials/Material_${n.id}>\n}\n\n`;
                    }(t1, r, s);
                } else console.warn("THREE.USDZExporter: Unsupported material type (USDZ only supports MeshStandardMaterial)", t1);
            }
        }), n += function(t1, e) {
            const n = [];
            for(const i in t1){
                const r = t1[i];
                n.push($fd4eb456bcbd06f8$var$Gm(r, e));
            }
            return `def "Materials"\n{\n${n.join("")}\n}\n\n`;
        }(i, r), e["model.usda"] = $fd4eb456bcbd06f8$var$Om(n), n = null;
        for(const t1 in r){
            const n = r[t1], i = t1.split("_")[1], s = 1023 === n.format, a = $fd4eb456bcbd06f8$var$Bm(n.image, i), o = await new Promise((t1)=>a.toBlob(t1, s ? "image/png" : "image/jpeg", 1));
            e[`textures/Texture_${t1}.${s ? "png" : "jpg"}`] = new Uint8Array(await o.arrayBuffer());
        }
        let s = 0;
        for(const t1 in e){
            const n = e[t1];
            s += 34 + t1.length;
            const i = 63 & s;
            if (4 !== i) {
                const r = new Uint8Array(64 - i);
                e[t1] = [
                    n,
                    {
                        extra: {
                            12345: r
                        }
                    }
                ];
            }
            s = n.length;
        }
        return $fd4eb456bcbd06f8$var$Um(e, {
            level: 0
        });
    }
}
function $fd4eb456bcbd06f8$var$Bm(t1, e) {
    if ("undefined" != typeof HTMLImageElement && t1 instanceof HTMLImageElement || "undefined" != typeof HTMLCanvasElement && t1 instanceof HTMLCanvasElement || "undefined" != typeof OffscreenCanvas && t1 instanceof OffscreenCanvas || "undefined" != typeof ImageBitmap && t1 instanceof ImageBitmap) {
        const n = 1024 / Math.max(t1.width, t1.height), i = document.createElement("canvas");
        i.width = t1.width * Math.min(1, n), i.height = t1.height * Math.min(1, n);
        const r = i.getContext("2d");
        if (r.drawImage(t1, 0, 0, i.width, i.height), void 0 !== e) {
            const t1 = parseInt(e, 16), n = (t1 >> 16 & 255) / 255, s = (t1 >> 8 & 255) / 255, a = (255 & t1) / 255, o = r.getImageData(0, 0, i.width, i.height), l = o.data;
            for(let t1 = 0; t1 < l.length; t1 += 4)l[t1 + 0] = l[t1 + 0] * n, l[t1 + 1] = l[t1 + 1] * s, l[t1 + 2] = l[t1 + 2] * a;
            r.putImageData(o, 0, 0);
        }
        return i;
    }
}
function $fd4eb456bcbd06f8$var$zm() {
    return '#usda 1.0\n(\n    customLayerData = {\n        string creator = "Three.js USDZExporter"\n    }\n    metersPerUnit = 1\n    upAxis = "Y"\n)\n\n';
}
function $fd4eb456bcbd06f8$var$Hm(t1, e) {
    return `(${t1[e + 0]}, ${t1[e + 1]}, ${t1[e + 2]}, ${t1[e + 3]})`;
}
function $fd4eb456bcbd06f8$var$Vm(t1, e) {
    if (void 0 === t1) return console.warn("USDZExporter: Normals missing."), Array(e).fill("(0, 0, 0)").join(", ");
    const n = [];
    for(let e = 0; e < t1.count; e++){
        const i = t1.getX(e), r = t1.getY(e), s = t1.getZ(e);
        n.push(`(${i.toPrecision(7)}, ${r.toPrecision(7)}, ${s.toPrecision(7)})`);
    }
    return n.join(", ");
}
function $fd4eb456bcbd06f8$var$Gm(t1, e) {
    const n = "            ", i = [], r = [];
    function s(n, i, r) {
        const s = n.id + (r ? "_" + r.getHexString() : ""), a = 1023 === n.format;
        return e[s] = n, `\n        def Shader "Transform2d_${i}" (\n            sdrMetadata = {\n                string role = "math"\n            }\n        )\n        {\n            uniform token info:id = "UsdTransform2d"\n            float2 inputs:in.connect = </Materials/Material_${t1.id}/uvReader_st.outputs:result>\n            float2 inputs:scale = ${$fd4eb456bcbd06f8$var$jm(n.repeat)}\n            float2 inputs:translation = ${$fd4eb456bcbd06f8$var$jm(n.offset)}\n            float2 outputs:result\n        }\n\n        def Shader "Texture_${n.id}_${i}"\n        {\n            uniform token info:id = "UsdUVTexture"\n            asset inputs:file = @textures/Texture_${s}.${a ? "png" : "jpg"}@\n            float2 inputs:st.connect = </Materials/Material_${t1.id}/Transform2d_${i}.outputs:result>\n            token inputs:wrapS = "repeat"\n            token inputs:wrapT = "repeat"\n            float outputs:r\n            float outputs:g\n            float outputs:b\n            float3 outputs:rgb\n            ${t1.transparent || t1.alphaTest > 0 ? "float outputs:a" : ""}\n        }`;
    }
    return null !== t1.map ? (i.push(`${n}color3f inputs:diffuseColor.connect = </Materials/Material_${t1.id}/Texture_${t1.map.id}_diffuse.outputs:rgb>`), t1.transparent ? i.push(`${n}float inputs:opacity.connect = </Materials/Material_${t1.id}/Texture_${t1.map.id}_diffuse.outputs:a>`) : t1.alphaTest > 0 && (i.push(`${n}float inputs:opacity.connect = </Materials/Material_${t1.id}/Texture_${t1.map.id}_diffuse.outputs:a>`), i.push(`${n}float inputs:opacityThreshold = ${t1.alphaTest}`)), r.push(s(t1.map, "diffuse", t1.color))) : i.push(`${n}color3f inputs:diffuseColor = ${$fd4eb456bcbd06f8$var$Wm(t1.color)}`), null !== t1.emissiveMap ? (i.push(`${n}color3f inputs:emissiveColor.connect = </Materials/Material_${t1.id}/Texture_${t1.emissiveMap.id}_emissive.outputs:rgb>`), r.push(s(t1.emissiveMap, "emissive"))) : t1.emissive.getHex() > 0 && i.push(`${n}color3f inputs:emissiveColor = ${$fd4eb456bcbd06f8$var$Wm(t1.emissive)}`), null !== t1.normalMap && (i.push(`${n}normal3f inputs:normal.connect = </Materials/Material_${t1.id}/Texture_${t1.normalMap.id}_normal.outputs:rgb>`), r.push(s(t1.normalMap, "normal"))), null !== t1.aoMap && (i.push(`${n}float inputs:occlusion.connect = </Materials/Material_${t1.id}/Texture_${t1.aoMap.id}_occlusion.outputs:r>`), r.push(s(t1.aoMap, "occlusion"))), null !== t1.roughnessMap && 1 === t1.roughness ? (i.push(`${n}float inputs:roughness.connect = </Materials/Material_${t1.id}/Texture_${t1.roughnessMap.id}_roughness.outputs:g>`), r.push(s(t1.roughnessMap, "roughness"))) : i.push(`${n}float inputs:roughness = ${t1.roughness}`), null !== t1.metalnessMap && 1 === t1.metalness ? (i.push(`${n}float inputs:metallic.connect = </Materials/Material_${t1.id}/Texture_${t1.metalnessMap.id}_metallic.outputs:b>`), r.push(s(t1.metalnessMap, "metallic"))) : i.push(`${n}float inputs:metallic = ${t1.metalness}`), null !== t1.alphaMap ? (i.push(`${n}float inputs:opacity.connect = </Materials/Material_${t1.id}/Texture_${t1.alphaMap.id}_opacity.outputs:r>`), i.push(`${n}float inputs:opacityThreshold = 0.0001`), r.push(s(t1.alphaMap, "opacity"))) : i.push(`${n}float inputs:opacity = ${t1.opacity}`), t1.isMeshPhysicalMaterial && (i.push(`${n}float inputs:clearcoat = ${t1.clearcoat}`), i.push(`${n}float inputs:clearcoatRoughness = ${t1.clearcoatRoughness}`), i.push(`${n}float inputs:ior = ${t1.ior}`)), `\n    def Material "Material_${t1.id}"\n    {\n        def Shader "PreviewSurface"\n        {\n            uniform token info:id = "UsdPreviewSurface"\n${i.join("\n")}\n            int inputs:useSpecularWorkflow = 0\n            token outputs:surface\n        }\n\n        token outputs:surface.connect = </Materials/Material_${t1.id}/PreviewSurface.outputs:surface>\n        token inputs:frame:stPrimvarName = "st"\n\n        def Shader "uvReader_st"\n        {\n            uniform token info:id = "UsdPrimvarReader_float2"\n            token inputs:varname.connect = </Materials/Material_${t1.id}.inputs:frame:stPrimvarName>\n            float2 inputs:fallback = (0.0, 0.0)\n            float2 outputs:result\n        }\n\n${r.join("\n")}\n\n    }\n`;
}
function $fd4eb456bcbd06f8$var$Wm(t1) {
    return `(${t1.r}, ${t1.g}, ${t1.b})`;
}
function $fd4eb456bcbd06f8$var$jm(t1) {
    return `(${t1.x}, ${t1.y})`;
}
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $fd4eb456bcbd06f8$var$qm = function(t1, e, n, i) {
    for(var r, s = arguments.length, a = s < 3 ? e : null === i ? i = Object.getOwnPropertyDescriptor(e, n) : i, o = t1.length - 1; o >= 0; o--)(r = t1[o]) && (a = (s < 3 ? r(a) : s > 3 ? r(e, n, a) : r(e, n)) || a);
    return s > 3 && a && Object.defineProperty(e, n, a), a;
};
let $fd4eb456bcbd06f8$var$Xm = !1, $fd4eb456bcbd06f8$var$$m = !1;
const $fd4eb456bcbd06f8$var$Ym = ($fd4eb456bcbd06f8$var$Jm = [
    "quick-look",
    "scene-viewer",
    "webxr",
    "none"
], (t1)=>{
    try {
        const e = $fd4eb456bcbd06f8$var$mu(t1), n = (e.length ? e[0].terms : []).filter((t1)=>t1 && "ident" === t1.type).map((t1)=>t1.value).filter((t1)=>$fd4eb456bcbd06f8$var$Jm.indexOf(t1) > -1), i = new Set;
        for (const t1 of n)i.add(t1);
        return i;
    } catch (t1) {}
    return new Set;
});
var $fd4eb456bcbd06f8$var$Jm;
const $fd4eb456bcbd06f8$var$Km = "quick-look", $fd4eb456bcbd06f8$var$Zm = "scene-viewer", $fd4eb456bcbd06f8$var$Qm = "webxr", $fd4eb456bcbd06f8$var$tf = "none", $fd4eb456bcbd06f8$var$ef = Symbol("arButtonContainer"), $fd4eb456bcbd06f8$var$nf = Symbol("enterARWithWebXR"), $fd4eb456bcbd06f8$var$rf = Symbol("openSceneViewer"), $fd4eb456bcbd06f8$var$sf = Symbol("openIOSARQuickLook"), $fd4eb456bcbd06f8$var$af = Symbol("canActivateAR"), $fd4eb456bcbd06f8$var$of = Symbol("arMode"), $fd4eb456bcbd06f8$var$lf = Symbol("arModes"), $fd4eb456bcbd06f8$var$hf = Symbol("arAnchor"), $fd4eb456bcbd06f8$var$cf = Symbol("preload"), $fd4eb456bcbd06f8$var$uf = Symbol("onARButtonContainerClick"), $fd4eb456bcbd06f8$var$df = Symbol("onARStatus"), $fd4eb456bcbd06f8$var$pf = Symbol("onARTracking"), $fd4eb456bcbd06f8$var$mf = Symbol("onARTap"), $fd4eb456bcbd06f8$var$ff = Symbol("selectARMode"), $fd4eb456bcbd06f8$var$gf = Symbol("triggerLoad");
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $fd4eb456bcbd06f8$var$vf, $fd4eb456bcbd06f8$var$yf, $fd4eb456bcbd06f8$var$xf;
const $fd4eb456bcbd06f8$var$bf = Symbol("evaluate"), $fd4eb456bcbd06f8$var$_f = Symbol("lastValue");
class $fd4eb456bcbd06f8$var$wf {
    constructor(){
        this[$fd4eb456bcbd06f8$var$vf] = null;
    }
    static evaluatableFor(t1, e = $fd4eb456bcbd06f8$var$wu) {
        if (t1 instanceof $fd4eb456bcbd06f8$var$wf) return t1;
        if ("number" === t1.type) return "%" === t1.unit ? new $fd4eb456bcbd06f8$var$Tf(t1, e) : t1;
        switch(t1.name.value){
            case "calc":
                return new $fd4eb456bcbd06f8$var$Lf(t1, e);
            case "env":
                return new $fd4eb456bcbd06f8$var$Af(t1);
        }
        return $fd4eb456bcbd06f8$var$wu;
    }
    static evaluate(t1) {
        return t1 instanceof $fd4eb456bcbd06f8$var$wf ? t1.evaluate() : t1;
    }
    static isConstant(t1) {
        return !(t1 instanceof $fd4eb456bcbd06f8$var$wf) || t1.isConstant;
    }
    static applyIntrinsics(t1, e) {
        const { basis: n, keywords: i } = e, { auto: r } = i;
        return n.map((e, n)=>{
            const s = null == r[n] ? e : r[n];
            let a = t1[n] ? t1[n] : s;
            if ("ident" === a.type) {
                const t1 = a.value;
                t1 in i && (a = i[t1][n]);
            }
            return null != a && "ident" !== a.type || (a = s), "%" === a.unit ? $fd4eb456bcbd06f8$var$pu(a.number / 100 * e.number, e.unit) : (a = $fd4eb456bcbd06f8$var$Tu(a, e), a.unit !== e.unit ? e : a);
        });
    }
    get isConstant() {
        return !1;
    }
    evaluate() {
        return this.isConstant && null != this[$fd4eb456bcbd06f8$var$_f] || (this[$fd4eb456bcbd06f8$var$_f] = this[$fd4eb456bcbd06f8$var$bf]()), this[$fd4eb456bcbd06f8$var$_f];
    }
}
$fd4eb456bcbd06f8$var$vf = $fd4eb456bcbd06f8$var$_f;
const $fd4eb456bcbd06f8$var$Mf = Symbol("percentage"), $fd4eb456bcbd06f8$var$Sf = Symbol("basis");
class $fd4eb456bcbd06f8$var$Tf extends $fd4eb456bcbd06f8$var$wf {
    constructor(t1, e){
        super(), this[$fd4eb456bcbd06f8$var$Mf] = t1, this[$fd4eb456bcbd06f8$var$Sf] = e;
    }
    get isConstant() {
        return !0;
    }
    [$fd4eb456bcbd06f8$var$bf]() {
        return $fd4eb456bcbd06f8$var$pu(this[$fd4eb456bcbd06f8$var$Mf].number / 100 * this[$fd4eb456bcbd06f8$var$Sf].number, this[$fd4eb456bcbd06f8$var$Sf].unit);
    }
}
const $fd4eb456bcbd06f8$var$Ef = Symbol("identNode");
class $fd4eb456bcbd06f8$var$Af extends $fd4eb456bcbd06f8$var$wf {
    constructor(t1){
        super(), this[$fd4eb456bcbd06f8$var$yf] = null;
        const e = t1.arguments.length ? t1.arguments[0].terms[0] : null;
        null != e && "ident" === e.type && (this[$fd4eb456bcbd06f8$var$Ef] = e);
    }
    get isConstant() {
        return !1;
    }
    [($fd4eb456bcbd06f8$var$yf = $fd4eb456bcbd06f8$var$Ef, $fd4eb456bcbd06f8$var$bf)]() {
        if (null != this[$fd4eb456bcbd06f8$var$Ef] && "window-scroll-y" === this[$fd4eb456bcbd06f8$var$Ef].value) return {
            type: "number",
            number: window.pageYOffset / (Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight) - window.innerHeight) || 0,
            unit: null
        };
        return $fd4eb456bcbd06f8$var$wu;
    }
}
const $fd4eb456bcbd06f8$var$Rf = /[\*\/]/, $fd4eb456bcbd06f8$var$Cf = Symbol("evalutor");
class $fd4eb456bcbd06f8$var$Lf extends $fd4eb456bcbd06f8$var$wf {
    constructor(t1, e = $fd4eb456bcbd06f8$var$wu){
        if (super(), this[$fd4eb456bcbd06f8$var$xf] = null, 1 !== t1.arguments.length) return;
        const n = t1.arguments[0].terms.slice(), i = [];
        for(; n.length;){
            const t1 = n.shift();
            if (i.length > 0) {
                const n = i[i.length - 1];
                if ("operator" === n.type && $fd4eb456bcbd06f8$var$Rf.test(n.value)) {
                    const n = i.pop(), r = i.pop();
                    if (null == r) return;
                    i.push(new $fd4eb456bcbd06f8$var$Of(n, $fd4eb456bcbd06f8$var$wf.evaluatableFor(r, e), $fd4eb456bcbd06f8$var$wf.evaluatableFor(t1, e)));
                    continue;
                }
            }
            i.push("operator" === t1.type ? t1 : $fd4eb456bcbd06f8$var$wf.evaluatableFor(t1, e));
        }
        for(; i.length > 2;){
            const [t1, n, r] = i.splice(0, 3);
            if ("operator" !== n.type) return;
            i.unshift(new $fd4eb456bcbd06f8$var$Of(n, $fd4eb456bcbd06f8$var$wf.evaluatableFor(t1, e), $fd4eb456bcbd06f8$var$wf.evaluatableFor(r, e)));
        }
        1 === i.length && (this[$fd4eb456bcbd06f8$var$Cf] = i[0]);
    }
    get isConstant() {
        return null == this[$fd4eb456bcbd06f8$var$Cf] || $fd4eb456bcbd06f8$var$wf.isConstant(this[$fd4eb456bcbd06f8$var$Cf]);
    }
    [($fd4eb456bcbd06f8$var$xf = $fd4eb456bcbd06f8$var$Cf, $fd4eb456bcbd06f8$var$bf)]() {
        return null != this[$fd4eb456bcbd06f8$var$Cf] ? $fd4eb456bcbd06f8$var$wf.evaluate(this[$fd4eb456bcbd06f8$var$Cf]) : $fd4eb456bcbd06f8$var$wu;
    }
}
const $fd4eb456bcbd06f8$var$Pf = Symbol("operator"), $fd4eb456bcbd06f8$var$Df = Symbol("left"), $fd4eb456bcbd06f8$var$If = Symbol("right");
class $fd4eb456bcbd06f8$var$Of extends $fd4eb456bcbd06f8$var$wf {
    constructor(t1, e, n){
        super(), this[$fd4eb456bcbd06f8$var$Pf] = t1, this[$fd4eb456bcbd06f8$var$Df] = e, this[$fd4eb456bcbd06f8$var$If] = n;
    }
    get isConstant() {
        return $fd4eb456bcbd06f8$var$wf.isConstant(this[$fd4eb456bcbd06f8$var$Df]) && $fd4eb456bcbd06f8$var$wf.isConstant(this[$fd4eb456bcbd06f8$var$If]);
    }
    [$fd4eb456bcbd06f8$var$bf]() {
        const t1 = $fd4eb456bcbd06f8$var$Tu($fd4eb456bcbd06f8$var$wf.evaluate(this[$fd4eb456bcbd06f8$var$Df])), e = $fd4eb456bcbd06f8$var$Tu($fd4eb456bcbd06f8$var$wf.evaluate(this[$fd4eb456bcbd06f8$var$If])), { number: n, unit: i } = t1, { number: r, unit: s } = e;
        if (null != s && null != i && s != i) return $fd4eb456bcbd06f8$var$wu;
        const a = i || s;
        let o;
        switch(this[$fd4eb456bcbd06f8$var$Pf].value){
            case "+":
                o = n + r;
                break;
            case "-":
                o = n - r;
                break;
            case "/":
                o = n / r;
                break;
            case "*":
                o = n * r;
                break;
            default:
                return $fd4eb456bcbd06f8$var$wu;
        }
        return {
            type: "number",
            number: o,
            unit: a
        };
    }
}
const $fd4eb456bcbd06f8$var$Nf = Symbol("evaluatables"), $fd4eb456bcbd06f8$var$Ff = Symbol("intrinsics");
class $fd4eb456bcbd06f8$var$Uf extends $fd4eb456bcbd06f8$var$wf {
    constructor(t1, e){
        super(), this[$fd4eb456bcbd06f8$var$Ff] = e;
        const n = t1[0], i = null != n ? n.terms : [];
        this[$fd4eb456bcbd06f8$var$Nf] = e.basis.map((t1, e)=>{
            const n = i[e];
            return null == n ? {
                type: "ident",
                value: "auto"
            } : "ident" === n.type ? n : $fd4eb456bcbd06f8$var$wf.evaluatableFor(n, t1);
        });
    }
    get isConstant() {
        for (const t1 of this[$fd4eb456bcbd06f8$var$Nf])if (!$fd4eb456bcbd06f8$var$wf.isConstant(t1)) return !1;
        return !0;
    }
    [$fd4eb456bcbd06f8$var$bf]() {
        const t1 = this[$fd4eb456bcbd06f8$var$Nf].map((t1)=>$fd4eb456bcbd06f8$var$wf.evaluate(t1));
        return $fd4eb456bcbd06f8$var$wf.applyIntrinsics(t1, this[$fd4eb456bcbd06f8$var$Ff]).map((t1)=>t1.number);
    }
}
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $fd4eb456bcbd06f8$var$kf, $fd4eb456bcbd06f8$var$Bf, $fd4eb456bcbd06f8$var$zf, $fd4eb456bcbd06f8$var$Hf;
const $fd4eb456bcbd06f8$var$Vf = Symbol("instances"), $fd4eb456bcbd06f8$var$Gf = Symbol("activateListener"), $fd4eb456bcbd06f8$var$Wf = Symbol("deactivateListener"), $fd4eb456bcbd06f8$var$jf = Symbol("notifyInstances"), $fd4eb456bcbd06f8$var$qf = Symbol("notify"), $fd4eb456bcbd06f8$var$Xf = Symbol("callback");
class $fd4eb456bcbd06f8$var$$f {
    constructor(t1){
        this[$fd4eb456bcbd06f8$var$Xf] = t1;
    }
    static [$fd4eb456bcbd06f8$var$jf]() {
        for (const t1 of $fd4eb456bcbd06f8$var$$f[$fd4eb456bcbd06f8$var$Vf])t1[$fd4eb456bcbd06f8$var$qf]();
    }
    static [($fd4eb456bcbd06f8$var$kf = $fd4eb456bcbd06f8$var$Vf, $fd4eb456bcbd06f8$var$Gf)]() {
        window.addEventListener("scroll", this[$fd4eb456bcbd06f8$var$jf], {
            passive: !0
        });
    }
    static [$fd4eb456bcbd06f8$var$Wf]() {
        window.removeEventListener("scroll", this[$fd4eb456bcbd06f8$var$jf]);
    }
    observe() {
        0 === $fd4eb456bcbd06f8$var$$f[$fd4eb456bcbd06f8$var$Vf].size && $fd4eb456bcbd06f8$var$$f[$fd4eb456bcbd06f8$var$Gf](), $fd4eb456bcbd06f8$var$$f[$fd4eb456bcbd06f8$var$Vf].add(this);
    }
    disconnect() {
        $fd4eb456bcbd06f8$var$$f[$fd4eb456bcbd06f8$var$Vf].delete(this), 0 === $fd4eb456bcbd06f8$var$$f[$fd4eb456bcbd06f8$var$Vf].size && $fd4eb456bcbd06f8$var$$f[$fd4eb456bcbd06f8$var$Wf]();
    }
    [$fd4eb456bcbd06f8$var$qf]() {
        this[$fd4eb456bcbd06f8$var$Xf]();
    }
}
$fd4eb456bcbd06f8$var$$f[$fd4eb456bcbd06f8$var$kf] = new Set;
const $fd4eb456bcbd06f8$var$Yf = Symbol("computeStyleCallback"), $fd4eb456bcbd06f8$var$Jf = Symbol("astWalker"), $fd4eb456bcbd06f8$var$Kf = Symbol("dependencies"), $fd4eb456bcbd06f8$var$Zf = Symbol("onScroll");
class $fd4eb456bcbd06f8$var$Qf {
    constructor(t1){
        this[$fd4eb456bcbd06f8$var$Bf] = {}, this[$fd4eb456bcbd06f8$var$zf] = new $fd4eb456bcbd06f8$var$_u([
            "function"
        ]), this[$fd4eb456bcbd06f8$var$Hf] = ()=>{
            this[$fd4eb456bcbd06f8$var$Yf]({
                relatedState: "window-scroll"
            });
        }, this[$fd4eb456bcbd06f8$var$Yf] = t1;
    }
    observeEffectsFor(t1) {
        const e = {}, n = this[$fd4eb456bcbd06f8$var$Kf];
        this[$fd4eb456bcbd06f8$var$Jf].walk(t1, (t1)=>{
            const { name: i } = t1, r = t1.arguments[0].terms[0];
            if ("env" === i.value && null != r && "ident" === r.type && "window-scroll-y" === r.value) {
                if (null == e["window-scroll"]) {
                    const t1 = "window-scroll" in n ? n["window-scroll"] : new $fd4eb456bcbd06f8$var$$f(this[$fd4eb456bcbd06f8$var$Zf]);
                    t1.observe(), delete n["window-scroll"], e["window-scroll"] = t1;
                }
            }
        });
        for(const t1 in n)n[t1].disconnect();
        this[$fd4eb456bcbd06f8$var$Kf] = e;
    }
    dispose() {
        for(const t1 in this[$fd4eb456bcbd06f8$var$Kf])this[$fd4eb456bcbd06f8$var$Kf][t1].disconnect();
    }
}
$fd4eb456bcbd06f8$var$Bf = $fd4eb456bcbd06f8$var$Kf, $fd4eb456bcbd06f8$var$zf = $fd4eb456bcbd06f8$var$Jf, $fd4eb456bcbd06f8$var$Hf = $fd4eb456bcbd06f8$var$Zf;
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fd4eb456bcbd06f8$var$tg = (t1)=>{
    const e = t1.observeEffects || !1, n = t1.intrinsics instanceof Function ? t1.intrinsics : ()=>t1.intrinsics;
    return (i, r)=>{
        const s = i.updated, a = i.connectedCallback, o = i.disconnectedCallback, l = Symbol(`${r}StyleEffector`), h = Symbol(`${r}StyleEvaluator`), c = Symbol(`${r}UpdateEvaluator`), u = Symbol(`${r}EvaluateAndSync`);
        Object.defineProperties(i, {
            [l]: {
                value: null,
                writable: !0
            },
            [h]: {
                value: null,
                writable: !0
            },
            [c]: {
                value: function() {
                    const t1 = $fd4eb456bcbd06f8$var$mu(this[r]);
                    this[h] = new $fd4eb456bcbd06f8$var$Uf(t1, n(this)), null == this[l] && e && (this[l] = new $fd4eb456bcbd06f8$var$Qf(()=>this[u]())), null != this[l] && this[l].observeEffectsFor(t1);
                }
            },
            [u]: {
                value: function() {
                    if (null == this[h]) return;
                    const e = this[h].evaluate();
                    this[t1.updateHandler](e);
                }
            },
            updated: {
                value: function(t1) {
                    t1.has(r) && (this[c](), this[u]()), s.call(this, t1);
                }
            },
            connectedCallback: {
                value: function() {
                    a.call(this), this.requestUpdate(r, this[r]);
                }
            },
            disconnectedCallback: {
                value: function() {
                    o.call(this), null != this[l] && (this[l].dispose(), this[l] = null);
                }
            }
        });
    };
}, $fd4eb456bcbd06f8$var$eg = new $fd4eb456bcbd06f8$var$g, $fd4eb456bcbd06f8$var$ng = new $fd4eb456bcbd06f8$var$V, $fd4eb456bcbd06f8$var$ig = Object.freeze({
    minimumRadius: 0,
    maximumRadius: 1 / 0,
    minimumPolarAngle: Math.PI / 8,
    maximumPolarAngle: Math.PI - Math.PI / 8,
    minimumAzimuthalAngle: -1 / 0,
    maximumAzimuthalAngle: 1 / 0,
    minimumFieldOfView: 10,
    maximumFieldOfView: 45,
    interactionPolicy: "always-allow",
    touchAction: "pan-y"
}), $fd4eb456bcbd06f8$var$rg = Math.PI / 8, $fd4eb456bcbd06f8$var$sg = 33, $fd4eb456bcbd06f8$var$ag = 34, $fd4eb456bcbd06f8$var$og = 37, $fd4eb456bcbd06f8$var$lg = 38, $fd4eb456bcbd06f8$var$hg = 39, $fd4eb456bcbd06f8$var$cg = 40, $fd4eb456bcbd06f8$var$ug = "user-interaction", $fd4eb456bcbd06f8$var$dg = "none";
/* @license
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $fd4eb456bcbd06f8$var$pg extends $fd4eb456bcbd06f8$var$i {
    constructor(t1, e, n){
        super(), this.camera = t1, this.element = e, this.scene = n, this.sensitivity = 1, this.isUserChange = !1, this._interactionEnabled = !1, this._disableZoom = !1, this.isUserPointing = !1, this.enablePan = !0, this.panProjection = new $fd4eb456bcbd06f8$var$v, this.panPerPixel = 0, this.spherical = new $fd4eb456bcbd06f8$var$Ko, this.goalSpherical = new $fd4eb456bcbd06f8$var$Ko, this.thetaDamper = new $fd4eb456bcbd06f8$var$du, this.phiDamper = new $fd4eb456bcbd06f8$var$du, this.radiusDamper = new $fd4eb456bcbd06f8$var$du, this.logFov = Math.log($fd4eb456bcbd06f8$var$ig.maximumFieldOfView), this.goalLogFov = this.logFov, this.fovDamper = new $fd4eb456bcbd06f8$var$du, this.touchMode = null, this.pointers = [], this.startTime = 0, this.startPointerPosition = {
            clientX: 0,
            clientY: 0
        }, this.lastSeparation = 0, this.touchDecided = !1, this.onContext = (t1)=>{
            if (this.enablePan) t1.preventDefault();
            else for (const t1 of this.pointers)this.onPointerUp(new PointerEvent("pointercancel", Object.assign(Object.assign({}, this.startPointerPosition), {
                pointerId: t1.id
            })));
        }, this.touchModeZoom = (t1, e)=>{
            if (!this._disableZoom) {
                const t1 = this.twoTouchDistance(this.pointers[0], this.pointers[1]), e = .04 * (this.lastSeparation - t1) * 50 / this.scene.height;
                this.lastSeparation = t1, this.userAdjustOrbit(0, 0, e);
            }
            this.panPerPixel > 0 && this.movePan(t1, e);
        }, this.disableScroll = (t1)=>{
            t1.preventDefault();
        }, this.touchModeRotate = (t1, e)=>{
            const { touchAction: n } = this._options;
            if (!this.touchDecided && "none" !== n) {
                this.touchDecided = !0;
                const i = Math.abs(t1), r = Math.abs(e);
                if (this.isUserChange && ("pan-y" === n && r > i || "pan-x" === n && i > r)) return void (this.touchMode = null);
                this.element.addEventListener("touchmove", this.disableScroll, {
                    passive: !1
                });
            }
            this.handleSinglePointerMove(t1, e);
        }, this.onPointerDown = (t1)=>{
            if (!this.canInteract || this.pointers.length > 2) return;
            const { element: e } = this;
            0 === this.pointers.length && (e.addEventListener("pointermove", this.onPointerMove), e.addEventListener("pointerup", this.onPointerUp), this.touchMode = null, this.touchDecided = !1, this.startPointerPosition.clientX = t1.clientX, this.startPointerPosition.clientY = t1.clientY, this.startTime = performance.now());
            try {
                e.setPointerCapture(t1.pointerId);
            } catch (t1) {}
            this.pointers.push({
                clientX: t1.clientX,
                clientY: t1.clientY,
                id: t1.pointerId
            }), this.isUserPointing = !1, "touch" === t1.pointerType ? (this.isUserChange = !t1.altKey, this.onTouchChange(t1)) : (this.isUserChange = !0, this.onMouseDown(t1));
        }, this.onPointerMove = (t1)=>{
            const e = this.pointers.find((e)=>e.id === t1.pointerId);
            if (null == e) return;
            const n = this.pointers.length, i = (t1.clientX - e.clientX) / n, r = (t1.clientY - e.clientY) / n;
            0 === i && 0 === r || (e.clientX = t1.clientX, e.clientY = t1.clientY, "touch" === t1.pointerType ? (this.isUserChange = !t1.altKey, null !== this.touchMode && this.touchMode(i, r)) : (this.isUserChange = !0, this.panPerPixel > 0 ? this.movePan(i, r) : this.handleSinglePointerMove(i, r)));
        }, this.onPointerUp = (t1)=>{
            const { element: e } = this, n = this.pointers.findIndex((e)=>e.id === t1.pointerId);
            -1 !== n && this.pointers.splice(n, 1), this.panPerPixel > 0 && !t1.altKey && this.resetRadius(), 0 === this.pointers.length ? (e.removeEventListener("pointermove", this.onPointerMove), e.removeEventListener("pointerup", this.onPointerUp), e.removeEventListener("touchmove", this.disableScroll), this.enablePan && this.recenter(t1)) : null !== this.touchMode && this.onTouchChange(t1), this.scene.element[$fd4eb456bcbd06f8$var$kg].style.opacity = 0, e.style.cursor = "grab", this.panPerPixel = 0, this.isUserPointing && this.dispatchEvent({
                type: "pointer-change-end"
            });
        }, this.onWheel = (t1)=>{
            if (!this.canInteract) return;
            this.isUserChange = !0;
            const e = t1.deltaY * (1 == t1.deltaMode ? 18 : 1) * .04 / 30;
            this.userAdjustOrbit(0, 0, e), t1.preventDefault();
        }, this.onKeyDown = (t1)=>{
            let e = !0;
            const { isUserChange: n } = this;
            switch(this.isUserChange = !0, t1.keyCode){
                case $fd4eb456bcbd06f8$var$sg:
                    this.userAdjustOrbit(0, 0, .04);
                    break;
                case $fd4eb456bcbd06f8$var$ag:
                    this.userAdjustOrbit(0, 0, -0.04);
                    break;
                case $fd4eb456bcbd06f8$var$lg:
                    this.userAdjustOrbit(0, -$fd4eb456bcbd06f8$var$rg, 0);
                    break;
                case $fd4eb456bcbd06f8$var$cg:
                    this.userAdjustOrbit(0, $fd4eb456bcbd06f8$var$rg, 0);
                    break;
                case $fd4eb456bcbd06f8$var$og:
                    this.userAdjustOrbit(-$fd4eb456bcbd06f8$var$rg, 0, 0);
                    break;
                case $fd4eb456bcbd06f8$var$hg:
                    this.userAdjustOrbit($fd4eb456bcbd06f8$var$rg, 0, 0);
                    break;
                default:
                    e = !1, this.isUserChange = n;
            }
            e && t1.preventDefault();
        }, this._options = Object.assign({}, $fd4eb456bcbd06f8$var$ig), this.setOrbit(0, Math.PI / 2, 1), this.setFieldOfView(100), this.jumpToGoal();
    }
    get interactionEnabled() {
        return this._interactionEnabled;
    }
    enableInteraction() {
        if (!1 === this._interactionEnabled) {
            const { element: t1 } = this;
            t1.addEventListener("pointerdown", this.onPointerDown), t1.addEventListener("pointercancel", this.onPointerUp), this._disableZoom || t1.addEventListener("wheel", this.onWheel), t1.addEventListener("keydown", this.onKeyDown), t1.addEventListener("touchmove", ()=>{}, {
                passive: !1
            }), t1.addEventListener("contextmenu", this.onContext), this.element.style.cursor = "grab", this._interactionEnabled = !0, this.updateTouchActionStyle();
        }
    }
    disableInteraction() {
        if (!0 === this._interactionEnabled) {
            const { element: t1 } = this;
            t1.removeEventListener("pointerdown", this.onPointerDown), t1.removeEventListener("pointermove", this.onPointerMove), t1.removeEventListener("pointerup", this.onPointerUp), t1.removeEventListener("pointercancel", this.onPointerUp), t1.removeEventListener("wheel", this.onWheel), t1.removeEventListener("keydown", this.onKeyDown), t1.removeEventListener("contextmenu", this.onContext), t1.style.cursor = "", this.touchMode = null, this._interactionEnabled = !1, this.updateTouchActionStyle();
        }
    }
    get options() {
        return this._options;
    }
    set disableZoom(t1) {
        this._disableZoom != t1 && (this._disableZoom = t1, !0 === t1 ? this.element.removeEventListener("wheel", this.onWheel) : this.element.addEventListener("wheel", this.onWheel), this.updateTouchActionStyle());
    }
    getCameraSpherical(t1 = new $fd4eb456bcbd06f8$var$Ko) {
        return t1.copy(this.spherical);
    }
    getFieldOfView() {
        return this.camera.fov;
    }
    applyOptions(t1) {
        Object.assign(this._options, t1), this.setOrbit(), this.setFieldOfView(Math.exp(this.goalLogFov));
    }
    updateNearFar(t1, e) {
        this.camera.near = Math.max(t1, e / 1e3), this.camera.far = e, this.camera.updateProjectionMatrix();
    }
    updateAspect(t1) {
        this.camera.aspect = t1, this.camera.updateProjectionMatrix();
    }
    setOrbit(t1 = this.goalSpherical.theta, e = this.goalSpherical.phi, n = this.goalSpherical.radius) {
        const { minimumAzimuthalAngle: i, maximumAzimuthalAngle: r, minimumPolarAngle: s, maximumPolarAngle: a, minimumRadius: o, maximumRadius: l } = this._options, { theta: h, phi: c, radius: u } = this.goalSpherical, d = $fd4eb456bcbd06f8$var$lu(t1, i, r);
        isFinite(i) || isFinite(r) || (this.spherical.theta = this.wrapAngle(this.spherical.theta - d) + d);
        const p = $fd4eb456bcbd06f8$var$lu(e, s, a), m = $fd4eb456bcbd06f8$var$lu(n, o, l);
        return (d !== h || p !== c || m !== u) && (this.goalSpherical.theta = d, this.goalSpherical.phi = p, this.goalSpherical.radius = m, this.goalSpherical.makeSafe(), !0);
    }
    setRadius(t1) {
        this.goalSpherical.radius = t1, this.setOrbit();
    }
    setFieldOfView(t1) {
        const { minimumFieldOfView: e, maximumFieldOfView: n } = this._options;
        t1 = $fd4eb456bcbd06f8$var$lu(t1, e, n), this.goalLogFov = Math.log(t1);
    }
    setDamperDecayTime(t1) {
        this.thetaDamper.setDecayTime(t1), this.phiDamper.setDecayTime(t1), this.radiusDamper.setDecayTime(t1), this.fovDamper.setDecayTime(t1);
    }
    adjustOrbit(t1, e, n) {
        const { theta: i, phi: r, radius: s } = this.goalSpherical, { minimumRadius: a, maximumRadius: o, minimumFieldOfView: l, maximumFieldOfView: h } = this._options, c = this.spherical.theta - i, u = Math.PI - .001, d = i - $fd4eb456bcbd06f8$var$lu(t1, -u - c, u - c), p = r - e, m = 0 === n ? 0 : ((n > 0 ? o : a) - s) / (Math.log(n > 0 ? h : l) - this.goalLogFov), f = s + n * (isFinite(m) ? m : 2 * (o - a));
        if (this.setOrbit(d, p, f), 0 !== n) {
            const t1 = this.goalLogFov + n;
            this.setFieldOfView(Math.exp(t1));
        }
    }
    jumpToGoal() {
        this.update(0, 1e4);
    }
    update(t1, e) {
        if (this.isStationary()) return;
        const { maximumPolarAngle: n, maximumRadius: i } = this._options, r = this.spherical.theta - this.goalSpherical.theta;
        Math.abs(r) > Math.PI && !isFinite(this._options.minimumAzimuthalAngle) && !isFinite(this._options.maximumAzimuthalAngle) && (this.spherical.theta -= 2 * Math.sign(r) * Math.PI), this.spherical.theta = this.thetaDamper.update(this.spherical.theta, this.goalSpherical.theta, e, Math.PI), this.spherical.phi = this.phiDamper.update(this.spherical.phi, this.goalSpherical.phi, e, n), this.spherical.radius = this.radiusDamper.update(this.spherical.radius, this.goalSpherical.radius, e, i), this.logFov = this.fovDamper.update(this.logFov, this.goalLogFov, e, 1), this.moveCamera();
    }
    updateTouchActionStyle() {
        const { style: t1 } = this.element;
        if (this._interactionEnabled) {
            const { touchAction: e } = this._options;
            this._disableZoom && "none" !== e ? t1.touchAction = "manipulation" : t1.touchAction = e;
        } else t1.touchAction = "";
    }
    isStationary() {
        return this.goalSpherical.theta === this.spherical.theta && this.goalSpherical.phi === this.spherical.phi && this.goalSpherical.radius === this.spherical.radius && this.goalLogFov === this.logFov;
    }
    dispatchChange() {
        const t1 = this.isUserChange ? $fd4eb456bcbd06f8$var$ug : $fd4eb456bcbd06f8$var$dg;
        this.dispatchEvent({
            type: "change",
            source: t1
        });
    }
    moveCamera() {
        this.spherical.makeSafe(), this.camera.position.setFromSpherical(this.spherical), this.camera.setRotationFromEuler(new $fd4eb456bcbd06f8$var$Ct(this.spherical.phi - Math.PI / 2, this.spherical.theta, 0, "YXZ")), this.camera.fov !== Math.exp(this.logFov) && (this.camera.fov = Math.exp(this.logFov), this.camera.updateProjectionMatrix()), this.dispatchChange();
    }
    get canInteract() {
        if ("allow-when-focused" == this._options.interactionPolicy) return this.element.getRootNode().activeElement === this.element;
        return "always-allow" === this._options.interactionPolicy;
    }
    userAdjustOrbit(t1, e, n) {
        this.adjustOrbit(t1 * this.sensitivity, e * this.sensitivity, n), this.dispatchChange();
    }
    wrapAngle(t1) {
        const e = (t1 + Math.PI) / (2 * Math.PI);
        return 2 * (e - Math.floor(e)) * Math.PI - Math.PI;
    }
    pixelLengthToSphericalAngle(t1) {
        return 2 * Math.PI * t1 / this.element.clientHeight;
    }
    twoTouchDistance(t1, e) {
        const { clientX: n, clientY: i } = t1, { clientX: r, clientY: s } = e, a = r - n, o = s - i;
        return Math.sqrt(a * a + o * o);
    }
    handleSinglePointerMove(t1, e) {
        const n = this.pixelLengthToSphericalAngle(t1), i = this.pixelLengthToSphericalAngle(e);
        !1 === this.isUserPointing && (this.isUserPointing = !0, this.dispatchEvent({
            type: "pointer-change-start"
        })), this.userAdjustOrbit(n, i, 0);
    }
    initializePan() {
        const { theta: t1, phi: e } = this.spherical, n = t1 - this.scene.yaw;
        this.panPerPixel = .018 / this.scene.height, this.panProjection.set(-Math.cos(n), -Math.cos(e) * Math.sin(n), 0, 0, Math.sin(e), 0, Math.sin(n), -Math.cos(e) * Math.cos(n), 0);
    }
    movePan(t1, e) {
        const { scene: n } = this, i = $fd4eb456bcbd06f8$var$ng.set(t1, e, 0), r = this.spherical.radius * Math.exp(this.logFov) * this.panPerPixel;
        i.multiplyScalar(r);
        const s = n.getTarget();
        s.add(i.applyMatrix3(this.panProjection)), n.boundingSphere.clampPoint(s, s), n.setTarget(s.x, s.y, s.z), this.dispatchChange();
    }
    recenter(t1) {
        if (performance.now() > this.startTime + 300 || Math.abs(t1.clientX - this.startPointerPosition.clientX) > 2 || Math.abs(t1.clientY - this.startPointerPosition.clientY) > 2) return;
        const { scene: e } = this, n = e.positionAndNormalFromPoint(e.getNDC(t1.clientX, t1.clientY));
        if (null == n) {
            const { cameraTarget: t1 } = e.element;
            e.element.cameraTarget = "", e.element.cameraTarget = t1, this.userAdjustOrbit(0, 0, 1);
        } else e.target.worldToLocal(n.position), e.setTarget(n.position.x, n.position.y, n.position.z);
    }
    resetRadius() {
        const { scene: t1 } = this, e = t1.positionAndNormalFromPoint($fd4eb456bcbd06f8$var$eg.set(0, 0));
        if (null == e) return;
        t1.target.worldToLocal(e.position);
        const n = t1.getTarget(), { theta: i, phi: r } = this.spherical, s = i - t1.yaw, a = $fd4eb456bcbd06f8$var$ng.set(Math.sin(r) * Math.sin(s), Math.cos(r), Math.sin(r) * Math.cos(s)), o = a.dot(e.position.sub(n));
        n.add(a.multiplyScalar(o)), t1.setTarget(n.x, n.y, n.z), this.setOrbit(void 0, void 0, this.goalSpherical.radius - o);
    }
    onTouchChange(t1) {
        if (1 === this.pointers.length) this.touchMode = this.touchModeRotate;
        else {
            if (this._disableZoom) return this.touchMode = null, void this.element.removeEventListener("touchmove", this.disableScroll);
            this.touchMode = this.touchDecided && null === this.touchMode ? null : this.touchModeZoom, this.touchDecided = !0, this.element.addEventListener("touchmove", this.disableScroll, {
                passive: !1
            }), this.lastSeparation = this.twoTouchDistance(this.pointers[0], this.pointers[1]), this.enablePan && null != this.touchMode && (this.initializePan(), t1.altKey || (this.scene.element[$fd4eb456bcbd06f8$var$kg].style.opacity = 1));
        }
    }
    onMouseDown(t1) {
        this.panPerPixel = 0, this.enablePan && (2 === t1.button || t1.ctrlKey || t1.metaKey || t1.shiftKey) && (this.initializePan(), this.scene.element[$fd4eb456bcbd06f8$var$kg].style.opacity = 1), this.element.style.cursor = "grabbing";
    }
}
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fd4eb456bcbd06f8$var$mg = (t1)=>t1 < .5 ? 2 * t1 * t1 : (4 - 2 * t1) * t1 - 1, $fd4eb456bcbd06f8$var$fg = (t1, e, n = $fd4eb456bcbd06f8$var$mg)=>(i)=>t1 + (e - t1) * n(i), $fd4eb456bcbd06f8$var$gg = (t1)=>{
    const e = [], n = [];
    let i = t1.initialValue;
    for(let r = 0; r < t1.keyframes.length; ++r){
        const s = t1.keyframes[r], { value: a, frames: o } = s, l = s.ease || $fd4eb456bcbd06f8$var$mg, h = $fd4eb456bcbd06f8$var$fg(i, a, l);
        e.push(h), n.push(o), i = a;
    }
    return ((t1, e)=>{
        const n = e.map((i = 0, (t1)=>i += t1));
        var i;
        return (e)=>{
            e = $fd4eb456bcbd06f8$var$lu(e, 0, 1), e *= n[n.length - 1];
            const i = n.findIndex((t1)=>t1 >= e), r = i < 1 ? 0 : n[i - 1], s = n[i];
            return t1[i]((e - r) / (s - r));
        };
    })(e, n);
};
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $fd4eb456bcbd06f8$var$vg = function(t1, e, n, i) {
    for(var r, s = arguments.length, a = s < 3 ? e : null === i ? i = Object.getOwnPropertyDescriptor(e, n) : i, o = t1.length - 1; o >= 0; o--)(r = t1[o]) && (a = (s < 3 ? r(a) : s > 3 ? r(e, n, a) : r(e, n)) || a);
    return s > 3 && a && Object.defineProperty(e, n, a), a;
};
const $fd4eb456bcbd06f8$var$yg = $fd4eb456bcbd06f8$var$gg({
    initialValue: 0,
    keyframes: [
        {
            frames: 5,
            value: -1
        },
        {
            frames: 1,
            value: -1
        },
        {
            frames: 8,
            value: 1
        },
        {
            frames: 1,
            value: 1
        },
        {
            frames: 5,
            value: 0
        },
        {
            frames: 18,
            value: 0
        }
    ]
}), $fd4eb456bcbd06f8$var$xg = $fd4eb456bcbd06f8$var$gg({
    initialValue: 0,
    keyframes: [
        {
            frames: 1,
            value: 1
        },
        {
            frames: 5,
            value: 1
        },
        {
            frames: 1,
            value: 0
        },
        {
            frames: 6,
            value: 0
        }
    ]
}), $fd4eb456bcbd06f8$var$bg = [
    "front",
    "right",
    "back",
    "left"
], $fd4eb456bcbd06f8$var$_g = [
    "upper-",
    "",
    "lower-"
], $fd4eb456bcbd06f8$var$wg = "auto", $fd4eb456bcbd06f8$var$Mg = "when-focused", $fd4eb456bcbd06f8$var$Sg = "wiggle", $fd4eb456bcbd06f8$var$Tg = "always-allow", $fd4eb456bcbd06f8$var$Eg = "pan-y", $fd4eb456bcbd06f8$var$Ag = (t1)=>{
    const e = t1.enablePan ? 30 : 45;
    return {
        basis: [
            $fd4eb456bcbd06f8$var$Mu($fd4eb456bcbd06f8$var$pu(e, "deg"))
        ],
        keywords: {
            auto: [
                null
            ]
        }
    };
}, $fd4eb456bcbd06f8$var$Rg = (t1)=>{
    const e = t1.enablePan ? 12 : 25;
    return {
        basis: [
            $fd4eb456bcbd06f8$var$Mu($fd4eb456bcbd06f8$var$pu(e, "deg"))
        ],
        keywords: {
            auto: [
                null
            ]
        }
    };
}, $fd4eb456bcbd06f8$var$Cg = (()=>{
    const t1 = $fd4eb456bcbd06f8$var$mu("0deg 75deg 105%")[0].terms, e = $fd4eb456bcbd06f8$var$Tu(t1[0]), n = $fd4eb456bcbd06f8$var$Tu(t1[1]);
    return (t1)=>{
        const i = t1[$fd4eb456bcbd06f8$var$_p].idealCameraDistance();
        return {
            basis: [
                e,
                n,
                $fd4eb456bcbd06f8$var$pu(i, "m")
            ],
            keywords: {
                auto: [
                    null,
                    null,
                    $fd4eb456bcbd06f8$var$pu(105, "%")
                ]
            }
        };
    };
})(), $fd4eb456bcbd06f8$var$Lg = (t1)=>{
    const e = 1.1 * t1[$fd4eb456bcbd06f8$var$_p].boundingSphere.radius * (t1.enablePan ? 2 : 1);
    return {
        basis: [
            $fd4eb456bcbd06f8$var$pu(-1 / 0, "rad"),
            $fd4eb456bcbd06f8$var$pu(Math.PI / 8, "rad"),
            $fd4eb456bcbd06f8$var$pu(e, "m")
        ],
        keywords: {
            auto: [
                null,
                null,
                null
            ]
        }
    };
}, $fd4eb456bcbd06f8$var$Pg = (t1)=>{
    const e = $fd4eb456bcbd06f8$var$Cg(t1), n = new $fd4eb456bcbd06f8$var$Uf([], e).evaluate()[2];
    return {
        basis: [
            $fd4eb456bcbd06f8$var$pu(1 / 0, "rad"),
            $fd4eb456bcbd06f8$var$pu(Math.PI - Math.PI / 8, "rad"),
            $fd4eb456bcbd06f8$var$pu(n, "m")
        ],
        keywords: {
            auto: [
                null,
                null,
                null
            ]
        }
    };
}, $fd4eb456bcbd06f8$var$Dg = (t1)=>{
    const e = t1[$fd4eb456bcbd06f8$var$_p].boundingBox.getCenter(new $fd4eb456bcbd06f8$var$V);
    return {
        basis: [
            $fd4eb456bcbd06f8$var$pu(e.x, "m"),
            $fd4eb456bcbd06f8$var$pu(e.y, "m"),
            $fd4eb456bcbd06f8$var$pu(e.z, "m")
        ],
        keywords: {
            auto: [
                null,
                null,
                null
            ]
        }
    };
}, $fd4eb456bcbd06f8$var$Ig = Math.PI / 2, $fd4eb456bcbd06f8$var$Og = Math.PI / 3, $fd4eb456bcbd06f8$var$Ng = $fd4eb456bcbd06f8$var$Ig / 2, $fd4eb456bcbd06f8$var$Fg = 2 * Math.PI, $fd4eb456bcbd06f8$var$Ug = Symbol("controls"), $fd4eb456bcbd06f8$var$kg = Symbol("panElement"), $fd4eb456bcbd06f8$var$Bg = Symbol("promptElement"), $fd4eb456bcbd06f8$var$zg = Symbol("promptAnimatedContainer"), $fd4eb456bcbd06f8$var$Hg = Symbol("fingerAnimatedContainers"), $fd4eb456bcbd06f8$var$Vg = Symbol("deferInteractionPrompt"), $fd4eb456bcbd06f8$var$Gg = Symbol("updateAria"), $fd4eb456bcbd06f8$var$Wg = Symbol("updateCameraForRadius"), $fd4eb456bcbd06f8$var$jg = Symbol("onBlur"), $fd4eb456bcbd06f8$var$qg = Symbol("onFocus"), $fd4eb456bcbd06f8$var$Xg = Symbol("onChange"), $fd4eb456bcbd06f8$var$$g = Symbol("onPointerChange"), $fd4eb456bcbd06f8$var$Yg = Symbol("waitingToPromptUser"), $fd4eb456bcbd06f8$var$Jg = Symbol("userHasInteracted"), $fd4eb456bcbd06f8$var$Kg = Symbol("promptElementVisibleTime"), $fd4eb456bcbd06f8$var$Zg = Symbol("lastPromptOffset"), $fd4eb456bcbd06f8$var$Qg = Symbol("focusedTime"), $fd4eb456bcbd06f8$var$tv = Symbol("lastSpherical"), $fd4eb456bcbd06f8$var$ev = Symbol("jumpCamera"), $fd4eb456bcbd06f8$var$nv = Symbol("initialized"), $fd4eb456bcbd06f8$var$iv = Symbol("maintainThetaPhi"), $fd4eb456bcbd06f8$var$rv = Symbol("syncCameraOrbit"), $fd4eb456bcbd06f8$var$sv = Symbol("syncFieldOfView"), $fd4eb456bcbd06f8$var$av = Symbol("syncCameraTarget"), $fd4eb456bcbd06f8$var$ov = Symbol("syncMinCameraOrbit"), $fd4eb456bcbd06f8$var$lv = Symbol("syncMaxCameraOrbit"), $fd4eb456bcbd06f8$var$hv = Symbol("syncMinFieldOfView"), $fd4eb456bcbd06f8$var$cv = Symbol("syncMaxFieldOfView");
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $fd4eb456bcbd06f8$var$uv = function(t1, e, n, i) {
    for(var r, s = arguments.length, a = s < 3 ? e : null === i ? i = Object.getOwnPropertyDescriptor(e, n) : i, o = t1.length - 1; o >= 0; o--)(r = t1[o]) && (a = (s < 3 ? r(a) : s > 3 ? r(e, n, a) : r(e, n)) || a);
    return s > 3 && a && Object.defineProperty(e, n, a), a;
};
const $fd4eb456bcbd06f8$var$dv = "auto", $fd4eb456bcbd06f8$var$pv = "manual", $fd4eb456bcbd06f8$var$mv = "auto", $fd4eb456bcbd06f8$var$fv = "eager", $fd4eb456bcbd06f8$var$gv = "interaction", $fd4eb456bcbd06f8$var$vv = Symbol("defaultProgressBarElement"), $fd4eb456bcbd06f8$var$yv = Symbol("defaultProgressMaskElement"), $fd4eb456bcbd06f8$var$xv = Symbol("posterContainerElement"), $fd4eb456bcbd06f8$var$bv = Symbol("defaultPosterElement"), $fd4eb456bcbd06f8$var$_v = Symbol("posterDismissalSource"), $fd4eb456bcbd06f8$var$wv = Symbol("hidePoster"), $fd4eb456bcbd06f8$var$Mv = Symbol("modelIsRevealed"), $fd4eb456bcbd06f8$var$Sv = Symbol("updateProgressBar"), $fd4eb456bcbd06f8$var$Tv = Symbol("lastReportedProgress"), $fd4eb456bcbd06f8$var$Ev = Symbol("transitioned"), $fd4eb456bcbd06f8$var$Av = Symbol("onTransitionEnd"), $fd4eb456bcbd06f8$var$Rv = Symbol("ariaLabelCallToAction"), $fd4eb456bcbd06f8$var$Cv = Symbol("onClick"), $fd4eb456bcbd06f8$var$Lv = Symbol("onKeydown"), $fd4eb456bcbd06f8$var$Pv = Symbol("onProgress");
class $fd4eb456bcbd06f8$var$Dv {
    constructor(){
        this.pluginCallbacks = [], this.register(function(t1) {
            return new $fd4eb456bcbd06f8$var$ay(t1);
        }), this.register(function(t1) {
            return new $fd4eb456bcbd06f8$var$oy(t1);
        }), this.register(function(t1) {
            return new $fd4eb456bcbd06f8$var$ly(t1);
        }), this.register(function(t1) {
            return new $fd4eb456bcbd06f8$var$cy(t1);
        }), this.register(function(t1) {
            return new $fd4eb456bcbd06f8$var$uy(t1);
        }), this.register(function(t1) {
            return new $fd4eb456bcbd06f8$var$hy(t1);
        });
    }
    register(t1) {
        return -1 === this.pluginCallbacks.indexOf(t1) && this.pluginCallbacks.push(t1), this;
    }
    unregister(t1) {
        return -1 !== this.pluginCallbacks.indexOf(t1) && this.pluginCallbacks.splice(this.pluginCallbacks.indexOf(t1), 1), this;
    }
    parse(t1, e, n, i) {
        "object" == typeof n && (console.warn("THREE.GLTFExporter: parse() expects options as the fourth argument now."), i = n);
        const r = new $fd4eb456bcbd06f8$var$sy, s = [];
        for(let t1 = 0, e = this.pluginCallbacks.length; t1 < e; t1++)s.push(this.pluginCallbacks[t1](r));
        r.setPlugins(s), r.write(t1, e, i).catch(n);
    }
    parseAsync(t1, e) {
        const n = this;
        return new Promise(function(i, r) {
            n.parse(t1, i, r, e);
        });
    }
}
const $fd4eb456bcbd06f8$var$Iv = 0, $fd4eb456bcbd06f8$var$Ov = 1, $fd4eb456bcbd06f8$var$Nv = 2, $fd4eb456bcbd06f8$var$Fv = 3, $fd4eb456bcbd06f8$var$Uv = 4, $fd4eb456bcbd06f8$var$kv = 5121, $fd4eb456bcbd06f8$var$Bv = 5123, $fd4eb456bcbd06f8$var$zv = 5126, $fd4eb456bcbd06f8$var$Hv = 5125, $fd4eb456bcbd06f8$var$Vv = 34962, $fd4eb456bcbd06f8$var$Gv = 34963, $fd4eb456bcbd06f8$var$Wv = 9728, $fd4eb456bcbd06f8$var$jv = 9729, $fd4eb456bcbd06f8$var$qv = 9984, $fd4eb456bcbd06f8$var$Xv = 9985, $fd4eb456bcbd06f8$var$$v = 9986, $fd4eb456bcbd06f8$var$Yv = 9987, $fd4eb456bcbd06f8$var$Jv = 33071, $fd4eb456bcbd06f8$var$Kv = 33648, $fd4eb456bcbd06f8$var$Zv = 10497, $fd4eb456bcbd06f8$var$Qv = {};
$fd4eb456bcbd06f8$var$Qv[1003] = $fd4eb456bcbd06f8$var$Wv, $fd4eb456bcbd06f8$var$Qv[1004] = $fd4eb456bcbd06f8$var$qv, $fd4eb456bcbd06f8$var$Qv[1005] = $fd4eb456bcbd06f8$var$$v, $fd4eb456bcbd06f8$var$Qv[1006] = $fd4eb456bcbd06f8$var$jv, $fd4eb456bcbd06f8$var$Qv[1007] = $fd4eb456bcbd06f8$var$Xv, $fd4eb456bcbd06f8$var$Qv[1008] = $fd4eb456bcbd06f8$var$Yv, $fd4eb456bcbd06f8$var$Qv[1001] = $fd4eb456bcbd06f8$var$Jv, $fd4eb456bcbd06f8$var$Qv[1e3] = $fd4eb456bcbd06f8$var$Zv, $fd4eb456bcbd06f8$var$Qv[1002] = $fd4eb456bcbd06f8$var$Kv;
const $fd4eb456bcbd06f8$var$ty = {
    scale: "scale",
    position: "translation",
    quaternion: "rotation",
    morphTargetInfluences: "weights"
};
function $fd4eb456bcbd06f8$var$ey(t1, e) {
    return t1.length === e.length && t1.every(function(t1, n) {
        return t1 === e[n];
    });
}
function $fd4eb456bcbd06f8$var$ny(t1) {
    return 4 * Math.ceil(t1 / 4);
}
function $fd4eb456bcbd06f8$var$iy(t1, e = 0) {
    const n = $fd4eb456bcbd06f8$var$ny(t1.byteLength);
    if (n !== t1.byteLength) {
        const i = new Uint8Array(n);
        if (i.set(new Uint8Array(t1)), 0 !== e) for(let r = t1.byteLength; r < n; r++)i[r] = e;
        return i.buffer;
    }
    return t1;
}
let $fd4eb456bcbd06f8$var$ry = null;
class $fd4eb456bcbd06f8$var$sy {
    constructor(){
        this.plugins = [], this.options = {}, this.pending = [], this.buffers = [], this.byteOffset = 0, this.buffers = [], this.nodeMap = new Map, this.skins = [], this.extensionsUsed = {}, this.uids = new Map, this.uid = 0, this.json = {
            asset: {
                version: "2.0",
                generator: "THREE.GLTFExporter"
            }
        }, this.cache = {
            meshes: new Map,
            attributes: new Map,
            attributesNormalized: new Map,
            materials: new Map,
            textures: new Map,
            images: new Map
        };
    }
    setPlugins(t1) {
        this.plugins = t1;
    }
    async write(t1, e, n) {
        this.options = Object.assign({}, {
            binary: !1,
            trs: !1,
            onlyVisible: !0,
            truncateDrawRange: !0,
            embedImages: !0,
            maxTextureSize: 1 / 0,
            animations: [],
            includeCustomExtensions: !1
        }, n), this.options.animations.length > 0 && (this.options.trs = !0), this.processInput(t1), await Promise.all(this.pending);
        const i = this, r = i.buffers, s = i.json;
        n = i.options;
        const a = i.extensionsUsed, o = new Blob(r, {
            type: "application/octet-stream"
        }), l = Object.keys(a);
        if (l.length > 0 && (s.extensionsUsed = l), s.buffers && s.buffers.length > 0 && (s.buffers[0].byteLength = o.size), !0 === n.binary) {
            const t1 = new window.FileReader;
            t1.readAsArrayBuffer(o), t1.onloadend = function() {
                const n = $fd4eb456bcbd06f8$var$iy(t1.result), i = new DataView(new ArrayBuffer(8));
                i.setUint32(0, n.byteLength, !0), i.setUint32(4, 5130562, !0);
                const r = $fd4eb456bcbd06f8$var$iy(function(t1) {
                    if (void 0 !== window.TextEncoder) return (new TextEncoder).encode(t1).buffer;
                    const e = new Uint8Array(new ArrayBuffer(t1.length));
                    for(let n = 0, i = t1.length; n < i; n++){
                        const i = t1.charCodeAt(n);
                        e[n] = i > 255 ? 32 : i;
                    }
                    return e.buffer;
                }(JSON.stringify(s)), 32), a = new DataView(new ArrayBuffer(8));
                a.setUint32(0, r.byteLength, !0), a.setUint32(4, 1313821514, !0);
                const o = new ArrayBuffer(12), l = new DataView(o);
                l.setUint32(0, 1179937895, !0), l.setUint32(4, 2, !0);
                const h = 12 + a.byteLength + r.byteLength + i.byteLength + n.byteLength;
                l.setUint32(8, h, !0);
                const c = new Blob([
                    o,
                    a,
                    r,
                    i,
                    n
                ], {
                    type: "application/octet-stream"
                }), u = new window.FileReader;
                u.readAsArrayBuffer(c), u.onloadend = function() {
                    e(u.result);
                };
            };
        } else if (s.buffers && s.buffers.length > 0) {
            const t1 = new window.FileReader;
            t1.readAsDataURL(o), t1.onloadend = function() {
                const n = t1.result;
                s.buffers[0].uri = n, e(s);
            };
        } else e(s);
    }
    serializeUserData(t1, e) {
        if (0 === Object.keys(t1.userData).length) return;
        const n = this.options, i = this.extensionsUsed;
        try {
            const r = JSON.parse(JSON.stringify(t1.userData));
            if (n.includeCustomExtensions && r.gltfExtensions) {
                void 0 === e.extensions && (e.extensions = {});
                for(const t1 in r.gltfExtensions)e.extensions[t1] = r.gltfExtensions[t1], i[t1] = !0;
                delete r.gltfExtensions;
            }
            Object.keys(r).length > 0 && (e.extras = r);
        } catch (e) {
            console.warn("THREE.GLTFExporter: userData of '" + t1.name + "' won't be serialized because of JSON.stringify error - " + e.message);
        }
    }
    getUID(t1) {
        return this.uids.has(t1) || this.uids.set(t1, this.uid++), this.uids.get(t1);
    }
    isNormalizedNormalAttribute(t1) {
        if (this.cache.attributesNormalized.has(t1)) return !1;
        const e = new $fd4eb456bcbd06f8$var$V;
        for(let n = 0, i = t1.count; n < i; n++)if (Math.abs(e.fromBufferAttribute(t1, n).length() - 1) > 5e-4) return !1;
        return !0;
    }
    createNormalizedNormalAttribute(t1) {
        const e = this.cache;
        if (e.attributesNormalized.has(t1)) return e.attributesNormalized.get(t1);
        const n = t1.clone(), i = new $fd4eb456bcbd06f8$var$V;
        for(let t1 = 0, e = n.count; t1 < e; t1++)i.fromBufferAttribute(n, t1), 0 === i.x && 0 === i.y && 0 === i.z ? i.setX(1) : i.normalize(), n.setXYZ(t1, i.x, i.y, i.z);
        return e.attributesNormalized.set(t1, n), n;
    }
    applyTextureTransform(t1, e) {
        let n = !1;
        const i = {};
        0 === e.offset.x && 0 === e.offset.y || (i.offset = e.offset.toArray(), n = !0), 0 !== e.rotation && (i.rotation = e.rotation, n = !0), 1 === e.repeat.x && 1 === e.repeat.y || (i.scale = e.repeat.toArray(), n = !0), n && (t1.extensions = t1.extensions || {}, t1.extensions.KHR_texture_transform = i, this.extensionsUsed.KHR_texture_transform = !0);
    }
    buildMetalRoughTexture(t1, e) {
        if (t1 === e) return t1;
        console.warn("THREE.GLTFExporter: Merged metalnessMap and roughnessMap textures.");
        const n = t1?.image, i = e?.image, r = Math.max(n?.width || 0, i?.width || 0), s = Math.max(n?.height || 0, i?.height || 0), a = document.createElement("canvas");
        a.width = r, a.height = s;
        const o = a.getContext("2d");
        o.fillStyle = "#00ffff", o.fillRect(0, 0, r, s);
        const l = o.getImageData(0, 0, r, s);
        if (n) {
            o.drawImage(n, 0, 0, r, s);
            const t1 = o.getImageData(0, 0, r, s).data;
            for(let e = 2; e < t1.length; e += 4)l.data[e] = t1[e];
        }
        if (i) {
            o.drawImage(i, 0, 0, r, s);
            const t1 = o.getImageData(0, 0, r, s).data;
            for(let e = 1; e < t1.length; e += 4)l.data[e] = t1[e];
        }
        o.putImageData(l, 0, 0);
        const h = (t1 || e).clone();
        return h.source = new $fd4eb456bcbd06f8$var$I(a), h;
    }
    processBuffer(t1) {
        const e = this.json, n = this.buffers;
        return e.buffers || (e.buffers = [
            {
                byteLength: 0
            }
        ]), n.push(t1), 0;
    }
    processBufferView(t1, e, n, i, r) {
        const s = this.json;
        let a;
        s.bufferViews || (s.bufferViews = []), a = e === $fd4eb456bcbd06f8$var$kv ? 1 : e === $fd4eb456bcbd06f8$var$Bv ? 2 : 4;
        const o = $fd4eb456bcbd06f8$var$ny(i * t1.itemSize * a), l = new DataView(new ArrayBuffer(o));
        let h = 0;
        for(let r = n; r < n + i; r++)for(let n = 0; n < t1.itemSize; n++){
            let i;
            t1.itemSize > 4 ? i = t1.array[r * t1.itemSize + n] : 0 === n ? i = t1.getX(r) : 1 === n ? i = t1.getY(r) : 2 === n ? i = t1.getZ(r) : 3 === n && (i = t1.getW(r)), e === $fd4eb456bcbd06f8$var$zv ? l.setFloat32(h, i, !0) : e === $fd4eb456bcbd06f8$var$Hv ? l.setUint32(h, i, !0) : e === $fd4eb456bcbd06f8$var$Bv ? l.setUint16(h, i, !0) : e === $fd4eb456bcbd06f8$var$kv && l.setUint8(h, i), h += a;
        }
        const c = {
            buffer: this.processBuffer(l.buffer),
            byteOffset: this.byteOffset,
            byteLength: o
        };
        void 0 !== r && (c.target = r), r === $fd4eb456bcbd06f8$var$Vv && (c.byteStride = t1.itemSize * a), this.byteOffset += o, s.bufferViews.push(c);
        return {
            id: s.bufferViews.length - 1,
            byteLength: 0
        };
    }
    processBufferViewImage(t1) {
        const e = this, n = e.json;
        return n.bufferViews || (n.bufferViews = []), new Promise(function(i) {
            const r = new window.FileReader;
            r.readAsArrayBuffer(t1), r.onloadend = function() {
                const t1 = $fd4eb456bcbd06f8$var$iy(r.result), s = {
                    buffer: e.processBuffer(t1),
                    byteOffset: e.byteOffset,
                    byteLength: t1.byteLength
                };
                e.byteOffset += t1.byteLength, i(n.bufferViews.push(s) - 1);
            };
        });
    }
    processAccessor(t1, e, n, i) {
        const r = this.options, s = this.json;
        let a;
        if (t1.array.constructor === Float32Array) a = $fd4eb456bcbd06f8$var$zv;
        else if (t1.array.constructor === Uint32Array) a = $fd4eb456bcbd06f8$var$Hv;
        else if (t1.array.constructor === Uint16Array) a = $fd4eb456bcbd06f8$var$Bv;
        else {
            if (t1.array.constructor !== Uint8Array) throw new Error("THREE.GLTFExporter: Unsupported bufferAttribute component type.");
            a = $fd4eb456bcbd06f8$var$kv;
        }
        if (void 0 === n && (n = 0), void 0 === i && (i = t1.count), r.truncateDrawRange && void 0 !== e && null === e.index) {
            const r = n + i, s = e.drawRange.count === 1 / 0 ? t1.count : e.drawRange.start + e.drawRange.count;
            n = Math.max(n, e.drawRange.start), (i = Math.min(r, s) - n) < 0 && (i = 0);
        }
        if (0 === i) return null;
        const o = function(t1, e, n) {
            const i = {
                min: new Array(t1.itemSize).fill(Number.POSITIVE_INFINITY),
                max: new Array(t1.itemSize).fill(Number.NEGATIVE_INFINITY)
            };
            for(let r = e; r < e + n; r++)for(let e = 0; e < t1.itemSize; e++){
                let n;
                t1.itemSize > 4 ? n = t1.array[r * t1.itemSize + e] : 0 === e ? n = t1.getX(r) : 1 === e ? n = t1.getY(r) : 2 === e ? n = t1.getZ(r) : 3 === e && (n = t1.getW(r)), i.min[e] = Math.min(i.min[e], n), i.max[e] = Math.max(i.max[e], n);
            }
            return i;
        }(t1, n, i);
        let l;
        void 0 !== e && (l = t1 === e.index ? $fd4eb456bcbd06f8$var$Gv : $fd4eb456bcbd06f8$var$Vv);
        const h = this.processBufferView(t1, a, n, i, l), c = {
            bufferView: h.id,
            byteOffset: h.byteOffset,
            componentType: a,
            count: i,
            max: o.max,
            min: o.min,
            type: {
                1: "SCALAR",
                2: "VEC2",
                3: "VEC3",
                4: "VEC4",
                16: "MAT4"
            }[t1.itemSize]
        };
        return !0 === t1.normalized && (c.normalized = !0), s.accessors || (s.accessors = []), s.accessors.push(c) - 1;
    }
    processImage(t1, e, n, i = "image/png") {
        const r = this, s = r.cache, a = r.json, o = r.options, l = r.pending;
        s.images.has(t1) || s.images.set(t1, {});
        const h = s.images.get(t1), c = i + ":flipY/" + n.toString();
        if (void 0 !== h[c]) return h[c];
        a.images || (a.images = []);
        const u = {
            mimeType: i
        };
        if (o.embedImages) {
            const s = $fd4eb456bcbd06f8$var$ry = $fd4eb456bcbd06f8$var$ry || document.createElement("canvas");
            s.width = Math.min(t1.width, o.maxTextureSize), s.height = Math.min(t1.height, o.maxTextureSize);
            const a = s.getContext("2d");
            if (!0 === n && (a.translate(0, s.height), a.scale(1, -1)), "undefined" != typeof HTMLImageElement && t1 instanceof HTMLImageElement || "undefined" != typeof HTMLCanvasElement && t1 instanceof HTMLCanvasElement || "undefined" != typeof OffscreenCanvas && t1 instanceof OffscreenCanvas || "undefined" != typeof ImageBitmap && t1 instanceof ImageBitmap) a.drawImage(t1, 0, 0, s.width, s.height);
            else {
                1023 !== e && console.error("GLTFExporter: Only RGBAFormat is supported."), (t1.width > o.maxTextureSize || t1.height > o.maxTextureSize) && console.warn("GLTFExporter: Image size is bigger than maxTextureSize", t1);
                const n = new Uint8ClampedArray(t1.height * t1.width * 4);
                for(let e = 0; e < n.length; e += 4)n[e + 0] = t1.data[e + 0], n[e + 1] = t1.data[e + 1], n[e + 2] = t1.data[e + 2], n[e + 3] = t1.data[e + 3];
                a.putImageData(new ImageData(n, t1.width, t1.height), 0, 0);
            }
            !0 === o.binary ? l.push(new Promise(function(t1) {
                s.toBlob(function(e) {
                    r.processBufferViewImage(e).then(function(e) {
                        u.bufferView = e, t1();
                    });
                }, i);
            })) : u.uri = s.toDataURL(i);
        } else u.uri = t1.src;
        const d = a.images.push(u) - 1;
        return h[c] = d, d;
    }
    processSampler(t1) {
        const e = this.json;
        e.samplers || (e.samplers = []);
        const n = {
            magFilter: $fd4eb456bcbd06f8$var$Qv[t1.magFilter],
            minFilter: $fd4eb456bcbd06f8$var$Qv[t1.minFilter],
            wrapS: $fd4eb456bcbd06f8$var$Qv[t1.wrapS],
            wrapT: $fd4eb456bcbd06f8$var$Qv[t1.wrapT]
        };
        return e.samplers.push(n) - 1;
    }
    processTexture(t1) {
        const e = this.cache, n = this.json;
        if (e.textures.has(t1)) return e.textures.get(t1);
        n.textures || (n.textures = []);
        let i = t1.userData.mimeType;
        "image/webp" === i && (i = "image/png");
        const r = {
            sampler: this.processSampler(t1),
            source: this.processImage(t1.image, t1.format, t1.flipY, i)
        };
        t1.name && (r.name = t1.name), this._invokeAll(function(e) {
            e.writeTexture && e.writeTexture(t1, r);
        });
        const s = n.textures.push(r) - 1;
        return e.textures.set(t1, s), s;
    }
    processMaterial(t1) {
        const e = this.cache, n = this.json;
        if (e.materials.has(t1)) return e.materials.get(t1);
        if (t1.isShaderMaterial) return console.warn("GLTFExporter: THREE.ShaderMaterial not supported."), null;
        n.materials || (n.materials = []);
        const i = {
            pbrMetallicRoughness: {}
        };
        !0 !== t1.isMeshStandardMaterial && !0 !== t1.isMeshBasicMaterial && console.warn("GLTFExporter: Use MeshStandardMaterial or MeshBasicMaterial for best results.");
        const r = t1.color.toArray().concat([
            t1.opacity
        ]);
        if ($fd4eb456bcbd06f8$var$ey(r, [
            1,
            1,
            1,
            1
        ]) || (i.pbrMetallicRoughness.baseColorFactor = r), t1.isMeshStandardMaterial ? (i.pbrMetallicRoughness.metallicFactor = t1.metalness, i.pbrMetallicRoughness.roughnessFactor = t1.roughness) : (i.pbrMetallicRoughness.metallicFactor = .5, i.pbrMetallicRoughness.roughnessFactor = .5), t1.metalnessMap || t1.roughnessMap) {
            const e = this.buildMetalRoughTexture(t1.metalnessMap, t1.roughnessMap), n = {
                index: this.processTexture(e)
            };
            this.applyTextureTransform(n, e), i.pbrMetallicRoughness.metallicRoughnessTexture = n;
        }
        if (t1.map) {
            const e = {
                index: this.processTexture(t1.map)
            };
            this.applyTextureTransform(e, t1.map), i.pbrMetallicRoughness.baseColorTexture = e;
        }
        if (t1.emissive) {
            const e = t1.emissive.clone().multiplyScalar(t1.emissiveIntensity), n = Math.max(e.r, e.g, e.b);
            if (n > 1 && (e.multiplyScalar(1 / n), console.warn("THREE.GLTFExporter: Some emissive components exceed 1; emissive has been limited")), n > 0 && (i.emissiveFactor = e.toArray()), t1.emissiveMap) {
                const e = {
                    index: this.processTexture(t1.emissiveMap)
                };
                this.applyTextureTransform(e, t1.emissiveMap), i.emissiveTexture = e;
            }
        }
        if (t1.normalMap) {
            const e = {
                index: this.processTexture(t1.normalMap)
            };
            t1.normalScale && 1 !== t1.normalScale.x && (e.scale = t1.normalScale.x), this.applyTextureTransform(e, t1.normalMap), i.normalTexture = e;
        }
        if (t1.aoMap) {
            const e = {
                index: this.processTexture(t1.aoMap),
                texCoord: 1
            };
            1 !== t1.aoMapIntensity && (e.strength = t1.aoMapIntensity), this.applyTextureTransform(e, t1.aoMap), i.occlusionTexture = e;
        }
        t1.transparent ? i.alphaMode = "BLEND" : t1.alphaTest > 0 && (i.alphaMode = "MASK", i.alphaCutoff = t1.alphaTest), 2 === t1.side && (i.doubleSided = !0), "" !== t1.name && (i.name = t1.name), this.serializeUserData(t1, i), this._invokeAll(function(e) {
            e.writeMaterial && e.writeMaterial(t1, i);
        });
        const s = n.materials.push(i) - 1;
        return e.materials.set(t1, s), s;
    }
    processMesh(t1) {
        const e = this.cache, n = this.json, i = [
            t1.geometry.uuid
        ];
        if (Array.isArray(t1.material)) for(let e = 0, n = t1.material.length; e < n; e++)i.push(t1.material[e].uuid);
        else i.push(t1.material.uuid);
        const r = i.join(":");
        if (e.meshes.has(r)) return e.meshes.get(r);
        const s = t1.geometry;
        let a;
        if (a = t1.isLineSegments ? $fd4eb456bcbd06f8$var$Ov : t1.isLineLoop ? $fd4eb456bcbd06f8$var$Nv : t1.isLine ? $fd4eb456bcbd06f8$var$Fv : t1.isPoints ? $fd4eb456bcbd06f8$var$Iv : t1.material.wireframe ? $fd4eb456bcbd06f8$var$Ov : $fd4eb456bcbd06f8$var$Uv, !0 !== s.isBufferGeometry) throw new Error("THREE.GLTFExporter: Geometry is not of type THREE.BufferGeometry.");
        const o = {}, l = {}, h = [], c = [], u = {
            uv: "TEXCOORD_0",
            uv2: "TEXCOORD_1",
            color: "COLOR_0",
            skinWeight: "WEIGHTS_0",
            skinIndex: "JOINTS_0"
        }, d = s.getAttribute("normal");
        void 0 === d || this.isNormalizedNormalAttribute(d) || (console.warn("THREE.GLTFExporter: Creating normalized normal attribute from the non-normalized one."), s.setAttribute("normal", this.createNormalizedNormalAttribute(d)));
        let p = null;
        for(let t1 in s.attributes){
            if ("morph" === t1.slice(0, 5)) continue;
            const n = s.attributes[t1];
            t1 = u[t1] || t1.toUpperCase();
            if (/^(POSITION|NORMAL|TANGENT|TEXCOORD_\d+|COLOR_\d+|JOINTS_\d+|WEIGHTS_\d+)$/.test(t1) || (t1 = "_" + t1), e.attributes.has(this.getUID(n))) {
                l[t1] = e.attributes.get(this.getUID(n));
                continue;
            }
            p = null;
            const i = n.array;
            "JOINTS_0" !== t1 || i instanceof Uint16Array || i instanceof Uint8Array || (console.warn('GLTFExporter: Attribute "skinIndex" converted to type UNSIGNED_SHORT.'), p = new $fd4eb456bcbd06f8$var$oe(new Uint16Array(i), n.itemSize, n.normalized));
            const r = this.processAccessor(p || n, s);
            null !== r && (l[t1] = r, e.attributes.set(this.getUID(n), r));
        }
        if (void 0 !== d && s.setAttribute("normal", d), 0 === Object.keys(l).length) return null;
        if (void 0 !== t1.morphTargetInfluences && t1.morphTargetInfluences.length > 0) {
            const n = [], i = [], r = {};
            if (void 0 !== t1.morphTargetDictionary) for(const e in t1.morphTargetDictionary)r[t1.morphTargetDictionary[e]] = e;
            for(let a = 0; a < t1.morphTargetInfluences.length; ++a){
                const o = {};
                let l = !1;
                for(const t1 in s.morphAttributes){
                    if ("position" !== t1 && "normal" !== t1) {
                        l || (console.warn("GLTFExporter: Only POSITION and NORMAL morph are supported."), l = !0);
                        continue;
                    }
                    const n = s.morphAttributes[t1][a], i = t1.toUpperCase(), r = s.attributes[t1];
                    if (e.attributes.has(this.getUID(n))) {
                        o[i] = e.attributes.get(this.getUID(n));
                        continue;
                    }
                    const h = n.clone();
                    if (!s.morphTargetsRelative) for(let t1 = 0, e = n.count; t1 < e; t1++)h.setXYZ(t1, n.getX(t1) - r.getX(t1), n.getY(t1) - r.getY(t1), n.getZ(t1) - r.getZ(t1));
                    o[i] = this.processAccessor(h, s), e.attributes.set(this.getUID(r), o[i]);
                }
                c.push(o), n.push(t1.morphTargetInfluences[a]), void 0 !== t1.morphTargetDictionary && i.push(r[a]);
            }
            o.weights = n, i.length > 0 && (o.extras = {}, o.extras.targetNames = i);
        }
        const m = Array.isArray(t1.material);
        if (m && 0 === s.groups.length) return null;
        const f = m ? t1.material : [
            t1.material
        ], g = m ? s.groups : [
            {
                materialIndex: 0,
                start: void 0,
                count: void 0
            }
        ];
        for(let t1 = 0, n = g.length; t1 < n; t1++){
            const n = {
                mode: a,
                attributes: l
            };
            if (this.serializeUserData(s, n), c.length > 0 && (n.targets = c), null !== s.index) {
                let i = this.getUID(s.index);
                void 0 === g[t1].start && void 0 === g[t1].count || (i += ":" + g[t1].start + ":" + g[t1].count), e.attributes.has(i) ? n.indices = e.attributes.get(i) : (n.indices = this.processAccessor(s.index, s, g[t1].start, g[t1].count), e.attributes.set(i, n.indices)), null === n.indices && delete n.indices;
            }
            const i = this.processMaterial(f[g[t1].materialIndex]);
            null !== i && (n.material = i), h.push(n);
        }
        o.primitives = h, n.meshes || (n.meshes = []), this._invokeAll(function(e) {
            e.writeMesh && e.writeMesh(t1, o);
        });
        const v = n.meshes.push(o) - 1;
        return e.meshes.set(r, v), v;
    }
    processCamera(t1) {
        const e = this.json;
        e.cameras || (e.cameras = []);
        const n = t1.isOrthographicCamera, i = {
            type: n ? "orthographic" : "perspective"
        };
        return n ? i.orthographic = {
            xmag: 2 * t1.right,
            ymag: 2 * t1.top,
            zfar: t1.far <= 0 ? .001 : t1.far,
            znear: t1.near < 0 ? 0 : t1.near
        } : i.perspective = {
            aspectRatio: t1.aspect,
            yfov: $fd4eb456bcbd06f8$var$f.degToRad(t1.fov),
            zfar: t1.far <= 0 ? .001 : t1.far,
            znear: t1.near < 0 ? 0 : t1.near
        }, "" !== t1.name && (i.name = t1.type), e.cameras.push(i) - 1;
    }
    processAnimation(t1, e) {
        const n = this.json, i = this.nodeMap;
        n.animations || (n.animations = []);
        const r = (t1 = $fd4eb456bcbd06f8$var$Dv.Utils.mergeMorphTargetTracks(t1.clone(), e)).tracks, s = [], a = [];
        for(let t1 = 0; t1 < r.length; ++t1){
            const n = r[t1], o = $fd4eb456bcbd06f8$var$qo.parseTrackName(n.name);
            let l = $fd4eb456bcbd06f8$var$qo.findNode(e, o.nodeName);
            const h = $fd4eb456bcbd06f8$var$ty[o.propertyName];
            if ("bones" === o.objectName && (l = !0 === l.isSkinnedMesh ? l.skeleton.getBoneByName(o.objectIndex) : void 0), !l || !h) return console.warn('THREE.GLTFExporter: Could not export animation track "%s".', n.name), null;
            const c = 1;
            let u, d = n.values.length / n.times.length;
            h === $fd4eb456bcbd06f8$var$ty.morphTargetInfluences && (d /= l.morphTargetInfluences.length), !0 === n.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline ? (u = "CUBICSPLINE", d /= 3) : u = 2300 === n.getInterpolation() ? "STEP" : "LINEAR", a.push({
                input: this.processAccessor(new $fd4eb456bcbd06f8$var$oe(n.times, c)),
                output: this.processAccessor(new $fd4eb456bcbd06f8$var$oe(n.values, d)),
                interpolation: u
            }), s.push({
                sampler: a.length - 1,
                target: {
                    node: i.get(l),
                    path: h
                }
            });
        }
        return n.animations.push({
            name: t1.name || "clip_" + n.animations.length,
            samplers: a,
            channels: s
        }), n.animations.length - 1;
    }
    processSkin(t1) {
        const e = this.json, n = this.nodeMap, i = e.nodes[n.get(t1)], r = t1.skeleton;
        if (void 0 === r) return null;
        const s = t1.skeleton.bones[0];
        if (void 0 === s) return null;
        const a = [], o = new Float32Array(16 * r.bones.length), l = new $fd4eb456bcbd06f8$var$xt;
        for(let e = 0; e < r.bones.length; ++e)a.push(n.get(r.bones[e])), l.copy(r.boneInverses[e]), l.multiply(t1.bindMatrix).toArray(o, 16 * e);
        void 0 === e.skins && (e.skins = []), e.skins.push({
            inverseBindMatrices: this.processAccessor(new $fd4eb456bcbd06f8$var$oe(o, 16)),
            joints: a,
            skeleton: n.get(s)
        });
        return i.skin = e.skins.length - 1;
    }
    processNode(t1) {
        const e = this.json, n = this.options, i = this.nodeMap;
        e.nodes || (e.nodes = []);
        const r = {};
        if (n.trs) {
            const e = t1.quaternion.toArray(), n = t1.position.toArray(), i = t1.scale.toArray();
            $fd4eb456bcbd06f8$var$ey(e, [
                0,
                0,
                0,
                1
            ]) || (r.rotation = e), $fd4eb456bcbd06f8$var$ey(n, [
                0,
                0,
                0
            ]) || (r.translation = n), $fd4eb456bcbd06f8$var$ey(i, [
                1,
                1,
                1
            ]) || (r.scale = i);
        } else t1.matrixAutoUpdate && t1.updateMatrix(), !1 === $fd4eb456bcbd06f8$var$ey(t1.matrix.elements, [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ]) && (r.matrix = t1.matrix.elements);
        if ("" !== t1.name && (r.name = String(t1.name)), this.serializeUserData(t1, r), t1.isMesh || t1.isLine || t1.isPoints) {
            const e = this.processMesh(t1);
            null !== e && (r.mesh = e);
        } else t1.isCamera && (r.camera = this.processCamera(t1));
        if (t1.isSkinnedMesh && this.skins.push(t1), t1.children.length > 0) {
            const e = [];
            for(let i = 0, r = t1.children.length; i < r; i++){
                const r = t1.children[i];
                if (r.visible || !1 === n.onlyVisible) {
                    const t1 = this.processNode(r);
                    null !== t1 && e.push(t1);
                }
            }
            e.length > 0 && (r.children = e);
        }
        this._invokeAll(function(e) {
            e.writeNode && e.writeNode(t1, r);
        });
        const s = e.nodes.push(r) - 1;
        return i.set(t1, s), s;
    }
    processScene(t1) {
        const e = this.json, n = this.options;
        e.scenes || (e.scenes = [], e.scene = 0);
        const i = {};
        "" !== t1.name && (i.name = t1.name), e.scenes.push(i);
        const r = [];
        for(let e = 0, i = t1.children.length; e < i; e++){
            const i = t1.children[e];
            if (i.visible || !1 === n.onlyVisible) {
                const t1 = this.processNode(i);
                null !== t1 && r.push(t1);
            }
        }
        r.length > 0 && (i.nodes = r), this.serializeUserData(t1, i);
    }
    processObjects(t1) {
        const e = new $fd4eb456bcbd06f8$var$Nr;
        e.name = "AuxScene";
        for(let n = 0; n < t1.length; n++)e.children.push(t1[n]);
        this.processScene(e);
    }
    processInput(t1) {
        const e = this.options;
        t1 = t1 instanceof Array ? t1 : [
            t1
        ], this._invokeAll(function(e) {
            e.beforeParse && e.beforeParse(t1);
        });
        const n = [];
        for(let e = 0; e < t1.length; e++)t1[e] instanceof $fd4eb456bcbd06f8$var$Nr ? this.processScene(t1[e]) : n.push(t1[e]);
        n.length > 0 && this.processObjects(n);
        for(let t1 = 0; t1 < this.skins.length; ++t1)this.processSkin(this.skins[t1]);
        for(let n = 0; n < e.animations.length; ++n)this.processAnimation(e.animations[n], t1[0]);
        this._invokeAll(function(e) {
            e.afterParse && e.afterParse(t1);
        });
    }
    _invokeAll(t1) {
        for(let e = 0, n = this.plugins.length; e < n; e++)t1(this.plugins[e]);
    }
}
class $fd4eb456bcbd06f8$var$ay {
    constructor(t1){
        this.writer = t1, this.name = "KHR_lights_punctual";
    }
    writeNode(t1, e) {
        if (!t1.isLight) return;
        if (!t1.isDirectionalLight && !t1.isPointLight && !t1.isSpotLight) return void console.warn("THREE.GLTFExporter: Only directional, point, and spot lights are supported.", t1);
        const n = this.writer, i = n.json, r = n.extensionsUsed, s = {};
        t1.name && (s.name = t1.name), s.color = t1.color.toArray(), s.intensity = t1.intensity, t1.isDirectionalLight ? s.type = "directional" : t1.isPointLight ? (s.type = "point", t1.distance > 0 && (s.range = t1.distance)) : t1.isSpotLight && (s.type = "spot", t1.distance > 0 && (s.range = t1.distance), s.spot = {}, s.spot.innerConeAngle = (t1.penumbra - 1) * t1.angle * -1, s.spot.outerConeAngle = t1.angle), void 0 !== t1.decay && 2 !== t1.decay && console.warn("THREE.GLTFExporter: Light decay may be lost. glTF is physically-based, and expects light.decay=2."), !t1.target || t1.target.parent === t1 && 0 === t1.target.position.x && 0 === t1.target.position.y && -1 === t1.target.position.z || console.warn("THREE.GLTFExporter: Light direction may be lost. For best results, make light.target a child of the light with position 0,0,-1."), r[this.name] || (i.extensions = i.extensions || {}, i.extensions[this.name] = {
            lights: []
        }, r[this.name] = !0);
        const a = i.extensions[this.name].lights;
        a.push(s), e.extensions = e.extensions || {}, e.extensions[this.name] = {
            light: a.length - 1
        };
    }
}
class $fd4eb456bcbd06f8$var$oy {
    constructor(t1){
        this.writer = t1, this.name = "KHR_materials_unlit";
    }
    writeMaterial(t1, e) {
        if (!t1.isMeshBasicMaterial) return;
        const n = this.writer.extensionsUsed;
        e.extensions = e.extensions || {}, e.extensions[this.name] = {}, n[this.name] = !0, e.pbrMetallicRoughness.metallicFactor = 0, e.pbrMetallicRoughness.roughnessFactor = .9;
    }
}
class $fd4eb456bcbd06f8$var$ly {
    constructor(t1){
        this.writer = t1, this.name = "KHR_materials_pbrSpecularGlossiness";
    }
    writeMaterial(t1, e) {
        if (!t1.isGLTFSpecularGlossinessMaterial) return;
        const n = this.writer, i = n.extensionsUsed, r = {};
        e.pbrMetallicRoughness.baseColorFactor && (r.diffuseFactor = e.pbrMetallicRoughness.baseColorFactor);
        const s = [
            1,
            1,
            1
        ];
        if (t1.specular.toArray(s, 0), r.specularFactor = s, r.glossinessFactor = t1.glossiness, e.pbrMetallicRoughness.baseColorTexture && (r.diffuseTexture = e.pbrMetallicRoughness.baseColorTexture), t1.specularMap) {
            const e = {
                index: n.processTexture(t1.specularMap)
            };
            n.applyTextureTransform(e, t1.specularMap), r.specularGlossinessTexture = e;
        }
        e.extensions = e.extensions || {}, e.extensions[this.name] = r, i[this.name] = !0;
    }
}
class $fd4eb456bcbd06f8$var$hy {
    constructor(t1){
        this.writer = t1, this.name = "KHR_materials_clearcoat";
    }
    writeMaterial(t1, e) {
        if (!t1.isMeshPhysicalMaterial) return;
        const n = this.writer, i = n.extensionsUsed, r = {};
        if (r.clearcoatFactor = t1.clearcoat, t1.clearcoatMap) {
            const e = {
                index: n.processTexture(t1.clearcoatMap)
            };
            n.applyTextureTransform(e, t1.clearcoatMap), r.clearcoatTexture = e;
        }
        if (r.clearcoatRoughnessFactor = t1.clearcoatRoughness, t1.clearcoatRoughnessMap) {
            const e = {
                index: n.processTexture(t1.clearcoatRoughnessMap)
            };
            n.applyTextureTransform(e, t1.clearcoatRoughnessMap), r.clearcoatRoughnessTexture = e;
        }
        if (t1.clearcoatNormalMap) {
            const e = {
                index: n.processTexture(t1.clearcoatNormalMap)
            };
            n.applyTextureTransform(e, t1.clearcoatNormalMap), r.clearcoatNormalTexture = e;
        }
        e.extensions = e.extensions || {}, e.extensions[this.name] = r, i[this.name] = !0;
    }
}
class $fd4eb456bcbd06f8$var$cy {
    constructor(t1){
        this.writer = t1, this.name = "KHR_materials_transmission";
    }
    writeMaterial(t1, e) {
        if (!t1.isMeshPhysicalMaterial || 0 === t1.transmission) return;
        const n = this.writer, i = n.extensionsUsed, r = {};
        if (r.transmissionFactor = t1.transmission, t1.transmissionMap) {
            const e = {
                index: n.processTexture(t1.transmissionMap)
            };
            n.applyTextureTransform(e, t1.transmissionMap), r.transmissionTexture = e;
        }
        e.extensions = e.extensions || {}, e.extensions[this.name] = r, i[this.name] = !0;
    }
}
class $fd4eb456bcbd06f8$var$uy {
    constructor(t1){
        this.writer = t1, this.name = "KHR_materials_volume";
    }
    writeMaterial(t1, e) {
        if (!t1.isMeshPhysicalMaterial || 0 === t1.transmission) return;
        const n = this.writer, i = n.extensionsUsed, r = {};
        if (r.thicknessFactor = t1.thickness, t1.thicknessMap) {
            const e = {
                index: n.processTexture(t1.thicknessMap)
            };
            n.applyTextureTransform(e, t1.thicknessMap), r.thicknessTexture = e;
        }
        r.attenuationDistance = t1.attenuationDistance, r.attenuationColor = t1.attenuationColor.toArray(), e.extensions = e.extensions || {}, e.extensions[this.name] = r, i[this.name] = !0;
    }
}
$fd4eb456bcbd06f8$var$Dv.Utils = {
    insertKeyframe: function(t1, e) {
        const n = .001, i = t1.getValueSize(), r = new t1.TimeBufferType(t1.times.length + 1), s = new t1.ValueBufferType(t1.values.length + i), a = t1.createInterpolant(new t1.ValueBufferType(i));
        let o;
        if (0 === t1.times.length) {
            r[0] = e;
            for(let t1 = 0; t1 < i; t1++)s[t1] = 0;
            o = 0;
        } else if (e < t1.times[0]) {
            if (Math.abs(t1.times[0] - e) < n) return 0;
            r[0] = e, r.set(t1.times, 1), s.set(a.evaluate(e), 0), s.set(t1.values, i), o = 0;
        } else if (e > t1.times[t1.times.length - 1]) {
            if (Math.abs(t1.times[t1.times.length - 1] - e) < n) return t1.times.length - 1;
            r[r.length - 1] = e, r.set(t1.times, 0), s.set(t1.values, 0), s.set(a.evaluate(e), t1.values.length), o = r.length - 1;
        } else for(let l = 0; l < t1.times.length; l++){
            if (Math.abs(t1.times[l] - e) < n) return l;
            if (t1.times[l] < e && t1.times[l + 1] > e) {
                r.set(t1.times.slice(0, l + 1), 0), r[l + 1] = e, r.set(t1.times.slice(l + 1), l + 2), s.set(t1.values.slice(0, (l + 1) * i), 0), s.set(a.evaluate(e), (l + 1) * i), s.set(t1.values.slice((l + 1) * i), (l + 2) * i), o = l + 1;
                break;
            }
        }
        return t1.times = r, t1.values = s, o;
    },
    mergeMorphTargetTracks: function(t1, e) {
        const n = [], i = {}, r = t1.tracks;
        for(let t1 = 0; t1 < r.length; ++t1){
            let s = r[t1];
            const a = $fd4eb456bcbd06f8$var$qo.parseTrackName(s.name), o = $fd4eb456bcbd06f8$var$qo.findNode(e, a.nodeName);
            if ("morphTargetInfluences" !== a.propertyName || void 0 === a.propertyIndex) {
                n.push(s);
                continue;
            }
            if (s.createInterpolant !== s.InterpolantFactoryMethodDiscrete && s.createInterpolant !== s.InterpolantFactoryMethodLinear) {
                if (s.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) throw new Error("THREE.GLTFExporter: Cannot merge tracks with glTF CUBICSPLINE interpolation.");
                console.warn("THREE.GLTFExporter: Morph target interpolation mode not yet supported. Using LINEAR instead."), s = s.clone(), s.setInterpolation(2301);
            }
            const l = o.morphTargetInfluences.length, h = o.morphTargetDictionary[a.propertyIndex];
            if (void 0 === h) throw new Error("THREE.GLTFExporter: Morph target name not found: " + a.propertyIndex);
            let c;
            if (void 0 === i[o.uuid]) {
                c = s.clone();
                const t1 = new c.ValueBufferType(l * c.times.length);
                for(let e = 0; e < c.times.length; e++)t1[e * l + h] = c.values[e];
                c.name = (a.nodeName || "") + ".morphTargetInfluences", c.values = t1, i[o.uuid] = c, n.push(c);
                continue;
            }
            const u = s.createInterpolant(new s.ValueBufferType(1));
            c = i[o.uuid];
            for(let t1 = 0; t1 < c.times.length; t1++)c.values[t1 * l + h] = u.evaluate(c.times[t1]);
            for(let t1 = 0; t1 < s.times.length; t1++){
                const e = this.insertKeyframe(c, s.times[t1]);
                c.values[e * l + h] = s.values[t1];
            }
        }
        return t1.tracks = n, t1;
    }
};
/* @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fd4eb456bcbd06f8$var$dy = (t1)=>void 0 !== t1.material && t1.userData && t1.userData.variantMaterials && !!Array.from(t1.userData.variantMaterials.values()).filter((t1)=>$fd4eb456bcbd06f8$var$py(t1.material)), $fd4eb456bcbd06f8$var$py = (t1)=>t1 && t1.isMaterial && !Array.isArray(t1);
class $fd4eb456bcbd06f8$var$my {
    constructor(t1){
        this.writer = t1, this.name = "KHR_materials_variants", this.variantNames = [];
    }
    beforeParse(t1) {
        const e = new Set;
        for (const n of t1)n.traverse((t1)=>{
            if (!$fd4eb456bcbd06f8$var$dy(t1)) return;
            const n = t1.userData.variantMaterials, i = t1.userData.variantData;
            for (const [t1, r] of i){
                const i = n.get(r.index);
                $fd4eb456bcbd06f8$var$py(i.material) && e.add(t1);
            }
        });
        e.forEach((t1)=>this.variantNames.push(t1));
    }
    writeMesh(t1, e) {
        if (!$fd4eb456bcbd06f8$var$dy(t1)) return;
        const n = t1.userData, i = n.variantMaterials, r = n.variantData, s = new Map, a = new Map, o = Array.from(r.values()).sort((t1, e)=>t1.index - e.index);
        for (const [t1, e] of o.entries())a.set(e.index, t1);
        for (const t1 of r.values()){
            const e = i.get(t1.index).material;
            if (!$fd4eb456bcbd06f8$var$py(e)) continue;
            const n = this.writer.processMaterial(e);
            s.has(n) || s.set(n, {
                material: n,
                variants: []
            }), s.get(n).variants.push(a.get(t1.index));
        }
        const l = Array.from(s.values()).map((t1)=>t1.variants.sort((t1, e)=>t1 - e) && t1).sort((t1, e)=>t1.material - e.material);
        if (0 === l.length) return;
        const h = $fd4eb456bcbd06f8$var$py(n.originalMaterial) ? this.writer.processMaterial(n.originalMaterial) : -1;
        for (const t1 of e.primitives)h >= 0 && (t1.material = h), t1.extensions = t1.extensions || {}, t1.extensions[this.name] = {
            mappings: l
        };
    }
    afterParse() {
        if (0 === this.variantNames.length) return;
        const t1 = this.writer.json;
        t1.extensions = t1.extensions || {};
        const e = this.variantNames.map((t1)=>({
                name: t1
            }));
        t1.extensions[this.name] = {
            variants: e
        }, this.writer.extensionsUsed[this.name] = !0;
    }
}
/* @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fd4eb456bcbd06f8$var$fy = Symbol("correlatedObjects"), $fd4eb456bcbd06f8$var$gy = Symbol("sourceObject"), $fd4eb456bcbd06f8$var$vy = Symbol("onUpdate");
class $fd4eb456bcbd06f8$var$yy {
    constructor(t1, e, n = null){
        this[$fd4eb456bcbd06f8$var$vy] = t1, this[$fd4eb456bcbd06f8$var$gy] = e, this[$fd4eb456bcbd06f8$var$fy] = n;
    }
}
/* @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fd4eb456bcbd06f8$var$xy = new $fd4eb456bcbd06f8$var$uo, $fd4eb456bcbd06f8$var$by = new $fd4eb456bcbd06f8$var$re, $fd4eb456bcbd06f8$var$_y = new $fd4eb456bcbd06f8$var$rn(2, 2);
let $fd4eb456bcbd06f8$var$wy = 0;
const $fd4eb456bcbd06f8$var$My = Symbol("threeTexture");
class $fd4eb456bcbd06f8$var$Sy extends $fd4eb456bcbd06f8$var$yy {
    get [$fd4eb456bcbd06f8$var$My]() {
        var t1;
        return console.assert(null != this[$fd4eb456bcbd06f8$var$fy] && this[$fd4eb456bcbd06f8$var$fy].size > 0, "Image correlated object is undefined"), null === (t1 = this[$fd4eb456bcbd06f8$var$fy]) || void 0 === t1 ? void 0 : t1.values().next().value;
    }
    constructor(t1, e, n){
        super(t1, n = null != n ? n : {
            name: e && e.image && e.image.src ? e.image.src.split("/").pop() : "adhoc_image",
            uri: e && e.image && e.image.src ? e.image.src : "adhoc_image" + $fd4eb456bcbd06f8$var$wy++
        }, new Set(e ? [
            e
        ] : []));
    }
    get name() {
        return this[$fd4eb456bcbd06f8$var$gy].name || "";
    }
    get uri() {
        return this[$fd4eb456bcbd06f8$var$gy].uri;
    }
    get bufferView() {
        return this[$fd4eb456bcbd06f8$var$gy].bufferView;
    }
    get type() {
        return null != this.uri ? "external" : "embedded";
    }
    set name(t1) {
        this[$fd4eb456bcbd06f8$var$gy].name = t1;
    }
    async setURI(t1) {
        this[$fd4eb456bcbd06f8$var$gy].uri = t1, this[$fd4eb456bcbd06f8$var$gy].name = t1.split("/").pop();
        const e = await new Promise((e, n)=>{
            $fd4eb456bcbd06f8$var$xy.load(t1, e, void 0, n);
        }), n = this[$fd4eb456bcbd06f8$var$My];
        n.image = e, n.needsUpdate = !0, this[$fd4eb456bcbd06f8$var$vy]();
    }
    async createThumbnail(t1, e) {
        const n = new $fd4eb456bcbd06f8$var$Nr;
        $fd4eb456bcbd06f8$var$by.map = this[$fd4eb456bcbd06f8$var$My];
        const i = new $fd4eb456bcbd06f8$var$Fe($fd4eb456bcbd06f8$var$_y, $fd4eb456bcbd06f8$var$by);
        n.add(i);
        const r = new $fd4eb456bcbd06f8$var$mn(-1, 1, 1, -1, 0, 1), { threeRenderer: s } = $fd4eb456bcbd06f8$var$Fd.singleton, a = new $fd4eb456bcbd06f8$var$k(t1, e);
        s.setRenderTarget(a), s.render(n, r), s.setRenderTarget(null);
        const o = new Uint8Array(t1 * e * 4);
        s.readRenderTargetPixels(a, 0, 0, t1, e, o), $fd4eb456bcbd06f8$var$Kd.width = t1, $fd4eb456bcbd06f8$var$Kd.height = e;
        const l = $fd4eb456bcbd06f8$var$Kd.getContext("2d"), h = l.createImageData(t1, e);
        return h.data.set(o), l.putImageData(h, 0, 0), new Promise(async (t1, e)=>{
            $fd4eb456bcbd06f8$var$Kd.toBlob((n)=>{
                if (!n) return e("Failed to capture thumbnail.");
                t1(URL.createObjectURL(n));
            }, "image/png");
        });
    }
}
var $fd4eb456bcbd06f8$var$Ty, $fd4eb456bcbd06f8$var$Ey;
!function(t1) {
    t1[t1.Nearest = 9728] = "Nearest", t1[t1.Linear = 9729] = "Linear", t1[t1.NearestMipmapNearest = 9984] = "NearestMipmapNearest", t1[t1.LinearMipmapNearest = 9985] = "LinearMipmapNearest", t1[t1.NearestMipmapLinear = 9986] = "NearestMipmapLinear", t1[t1.LinearMipmapLinear = 9987] = "LinearMipmapLinear";
}($fd4eb456bcbd06f8$var$Ty || ($fd4eb456bcbd06f8$var$Ty = {})), function(t1) {
    t1[t1.ClampToEdge = 33071] = "ClampToEdge", t1[t1.MirroredRepeat = 33648] = "MirroredRepeat", t1[t1.Repeat = 10497] = "Repeat";
}($fd4eb456bcbd06f8$var$Ey || ($fd4eb456bcbd06f8$var$Ey = {}));
/* @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fd4eb456bcbd06f8$var$Ay = (()=>{
    const t1 = [
        $fd4eb456bcbd06f8$var$Ty.Nearest,
        $fd4eb456bcbd06f8$var$Ty.Linear,
        $fd4eb456bcbd06f8$var$Ty.NearestMipmapNearest,
        $fd4eb456bcbd06f8$var$Ty.LinearMipmapLinear,
        $fd4eb456bcbd06f8$var$Ty.NearestMipmapLinear,
        $fd4eb456bcbd06f8$var$Ty.LinearMipmapLinear
    ];
    return (e)=>t1.indexOf(e) > -1;
})(), $fd4eb456bcbd06f8$var$Ry = (()=>{
    const t1 = [
        $fd4eb456bcbd06f8$var$Ty.Nearest,
        $fd4eb456bcbd06f8$var$Ty.Linear
    ];
    return (e)=>t1.indexOf(e) > -1;
})(), $fd4eb456bcbd06f8$var$Cy = (()=>{
    const t1 = [
        $fd4eb456bcbd06f8$var$Ey.ClampToEdge,
        $fd4eb456bcbd06f8$var$Ey.MirroredRepeat,
        $fd4eb456bcbd06f8$var$Ey.Repeat
    ];
    return (e)=>t1.indexOf(e) > -1;
})(), $fd4eb456bcbd06f8$var$Ly = Symbol("threeTextures"), $fd4eb456bcbd06f8$var$Py = Symbol("setProperty"), $fd4eb456bcbd06f8$var$Dy = Symbol("sourceSampler");
class $fd4eb456bcbd06f8$var$Iy extends $fd4eb456bcbd06f8$var$yy {
    get [$fd4eb456bcbd06f8$var$Ly]() {
        return console.assert(null != this[$fd4eb456bcbd06f8$var$fy] && this[$fd4eb456bcbd06f8$var$fy].size > 0, "Sampler correlated object is undefined"), this[$fd4eb456bcbd06f8$var$fy];
    }
    get [$fd4eb456bcbd06f8$var$Dy]() {
        return console.assert(null != this[$fd4eb456bcbd06f8$var$gy], "Sampler source is undefined"), this[$fd4eb456bcbd06f8$var$gy];
    }
    constructor(t1, e, n){
        null == (n = null != n ? n : {}).minFilter && (n.minFilter = e ? e.minFilter : $fd4eb456bcbd06f8$var$Ty.LinearMipmapLinear), null == n.magFilter && (n.magFilter = e ? e.magFilter : $fd4eb456bcbd06f8$var$Ty.Linear), null == n.wrapS && (n.wrapS = e ? e.wrapS : $fd4eb456bcbd06f8$var$Ey.Repeat), null == n.wrapT && (n.wrapT = e ? e.wrapT : $fd4eb456bcbd06f8$var$Ey.Repeat), super(t1, n, new Set(e ? [
            e
        ] : []));
    }
    get name() {
        return this[$fd4eb456bcbd06f8$var$gy].name || "";
    }
    get minFilter() {
        return this[$fd4eb456bcbd06f8$var$Dy].minFilter;
    }
    get magFilter() {
        return this[$fd4eb456bcbd06f8$var$Dy].magFilter;
    }
    get wrapS() {
        return this[$fd4eb456bcbd06f8$var$Dy].wrapS;
    }
    get wrapT() {
        return this[$fd4eb456bcbd06f8$var$Dy].wrapT;
    }
    setMinFilter(t1) {
        this[$fd4eb456bcbd06f8$var$Py]("minFilter", t1);
    }
    setMagFilter(t1) {
        this[$fd4eb456bcbd06f8$var$Py]("magFilter", t1);
    }
    setWrapS(t1) {
        this[$fd4eb456bcbd06f8$var$Py]("wrapS", t1);
    }
    setWrapT(t1) {
        this[$fd4eb456bcbd06f8$var$Py]("wrapT", t1);
    }
    [$fd4eb456bcbd06f8$var$Py](t1, e) {
        const n = this[$fd4eb456bcbd06f8$var$Dy];
        if (null != n) {
            if (((t1, e)=>{
                switch(t1){
                    case "minFilter":
                        return $fd4eb456bcbd06f8$var$Ay(e);
                    case "magFilter":
                        return $fd4eb456bcbd06f8$var$Ry(e);
                    case "wrapS":
                    case "wrapT":
                        return $fd4eb456bcbd06f8$var$Cy(e);
                    default:
                        throw new Error(`Cannot configure property "${t1}" on Sampler`);
                }
            })(t1, e)) {
                n[t1] = e;
                for (const n of this[$fd4eb456bcbd06f8$var$Ly])n[t1] = e, n.needsUpdate = !0;
            }
            this[$fd4eb456bcbd06f8$var$vy]();
        }
    }
}
/* @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fd4eb456bcbd06f8$var$Oy = Symbol("image"), $fd4eb456bcbd06f8$var$Ny = Symbol("sampler");
class $fd4eb456bcbd06f8$var$Fy extends $fd4eb456bcbd06f8$var$yy {
    constructor(t1, e, n = null, i = null, r = null){
        super(t1, n || {}, new Set(e ? [
            e
        ] : [])), this[$fd4eb456bcbd06f8$var$Ny] = new $fd4eb456bcbd06f8$var$Iy(t1, e, i), this[$fd4eb456bcbd06f8$var$Oy] = new $fd4eb456bcbd06f8$var$Sy(t1, e, r);
    }
    get name() {
        return this[$fd4eb456bcbd06f8$var$gy].name || "";
    }
    set name(t1) {
        this[$fd4eb456bcbd06f8$var$gy].name = t1;
    }
    get sampler() {
        return this[$fd4eb456bcbd06f8$var$Ny];
    }
    get source() {
        return this[$fd4eb456bcbd06f8$var$Oy];
    }
}
/* @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $fd4eb456bcbd06f8$var$Uy, $fd4eb456bcbd06f8$var$ky;
const $fd4eb456bcbd06f8$var$By = Symbol("texture"), $fd4eb456bcbd06f8$var$zy = Symbol("transform"), $fd4eb456bcbd06f8$var$Hy = Symbol("materials"), $fd4eb456bcbd06f8$var$Vy = Symbol("usage");
var $fd4eb456bcbd06f8$var$Gy;
!function(t1) {
    t1[t1.Base = 0] = "Base", t1[t1.MetallicRoughness = 1] = "MetallicRoughness", t1[t1.Normal = 2] = "Normal", t1[t1.Occlusion = 3] = "Occlusion", t1[t1.Emissive = 4] = "Emissive";
}($fd4eb456bcbd06f8$var$Gy || ($fd4eb456bcbd06f8$var$Gy = {}));
class $fd4eb456bcbd06f8$var$Wy {
    constructor(t1, e, n, i, r, s){
        if (this[$fd4eb456bcbd06f8$var$Uy] = null, this[$fd4eb456bcbd06f8$var$ky] = {
            rotation: 0,
            scale: new $fd4eb456bcbd06f8$var$g(1, 1),
            offset: new $fd4eb456bcbd06f8$var$g(0, 0)
        }, s && n) {
            const e = r.textures ? r.textures[s.index] : null, i = e && r.samplers ? r.samplers[e.sampler] : null, a = e && r.images ? r.images[e.source] : null;
            this[$fd4eb456bcbd06f8$var$zy].rotation = n.rotation, this[$fd4eb456bcbd06f8$var$zy].scale.copy(n.repeat), this[$fd4eb456bcbd06f8$var$zy].offset.copy(n.offset), this[$fd4eb456bcbd06f8$var$By] = new $fd4eb456bcbd06f8$var$Fy(t1, n, e, i, a);
        }
        this.onUpdate = t1, this[$fd4eb456bcbd06f8$var$Hy] = i, this[$fd4eb456bcbd06f8$var$Vy] = e;
    }
    get texture() {
        return this[$fd4eb456bcbd06f8$var$By];
    }
    setTexture(t1) {
        const e = null != t1 ? t1.source[$fd4eb456bcbd06f8$var$My] : null;
        let n = 3001;
        if (this[$fd4eb456bcbd06f8$var$By] = t1, this[$fd4eb456bcbd06f8$var$Hy]) for (const t1 of this[$fd4eb456bcbd06f8$var$Hy]){
            switch(this[$fd4eb456bcbd06f8$var$Vy]){
                case $fd4eb456bcbd06f8$var$Gy.Base:
                    t1.map = e;
                    break;
                case $fd4eb456bcbd06f8$var$Gy.MetallicRoughness:
                    n = 3e3, t1.metalnessMap = e, t1.roughnessMap = e;
                    break;
                case $fd4eb456bcbd06f8$var$Gy.Normal:
                    n = 3e3, t1.normalMap = e;
                    break;
                case $fd4eb456bcbd06f8$var$Gy.Occlusion:
                    n = 3e3, t1.aoMap = e;
                    break;
                case $fd4eb456bcbd06f8$var$Gy.Emissive:
                    t1.emissiveMap = e;
            }
            t1.needsUpdate = !0;
        }
        e && (e.encoding = n, e.rotation = this[$fd4eb456bcbd06f8$var$zy].rotation, e.repeat = this[$fd4eb456bcbd06f8$var$zy].scale, e.offset = this[$fd4eb456bcbd06f8$var$zy].offset), this.onUpdate();
    }
}
$fd4eb456bcbd06f8$var$Uy = $fd4eb456bcbd06f8$var$By, $fd4eb456bcbd06f8$var$ky = $fd4eb456bcbd06f8$var$zy;
/* @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fd4eb456bcbd06f8$var$jy = Symbol("threeMaterials"), $fd4eb456bcbd06f8$var$qy = Symbol("baseColorTexture"), $fd4eb456bcbd06f8$var$Xy = Symbol("metallicRoughnessTexture");
class $fd4eb456bcbd06f8$var$$y extends $fd4eb456bcbd06f8$var$yy {
    constructor(t1, e, n, i){
        super(t1, n, i), null == n.baseColorFactor && (n.baseColorFactor = [
            1,
            1,
            1,
            1
        ]), null == n.roughnessFactor && (n.roughnessFactor = 1), null == n.metallicFactor && (n.metallicFactor = 1);
        const { baseColorTexture: r, metallicRoughnessTexture: s } = n, { map: a, metalnessMap: o } = i.values().next().value;
        this[$fd4eb456bcbd06f8$var$qy] = new $fd4eb456bcbd06f8$var$Wy(t1, $fd4eb456bcbd06f8$var$Gy.Base, a, i, e, r || null), this[$fd4eb456bcbd06f8$var$Xy] = new $fd4eb456bcbd06f8$var$Wy(t1, $fd4eb456bcbd06f8$var$Gy.MetallicRoughness, o, i, e, s || null);
    }
    get [$fd4eb456bcbd06f8$var$jy]() {
        return this[$fd4eb456bcbd06f8$var$fy];
    }
    get baseColorFactor() {
        return this[$fd4eb456bcbd06f8$var$gy].baseColorFactor;
    }
    get metallicFactor() {
        return this[$fd4eb456bcbd06f8$var$gy].metallicFactor;
    }
    get roughnessFactor() {
        return this[$fd4eb456bcbd06f8$var$gy].roughnessFactor;
    }
    get baseColorTexture() {
        return this[$fd4eb456bcbd06f8$var$qy];
    }
    get metallicRoughnessTexture() {
        return this[$fd4eb456bcbd06f8$var$Xy];
    }
    setBaseColorFactor(t1) {
        for (const e of this[$fd4eb456bcbd06f8$var$jy])e.color.fromArray(t1), e.opacity = t1[3];
        this[$fd4eb456bcbd06f8$var$gy].baseColorFactor = t1, this[$fd4eb456bcbd06f8$var$vy]();
    }
    setMetallicFactor(t1) {
        for (const e of this[$fd4eb456bcbd06f8$var$jy])e.metalness = t1;
        this[$fd4eb456bcbd06f8$var$gy].metallicFactor = t1, this[$fd4eb456bcbd06f8$var$vy]();
    }
    setRoughnessFactor(t1) {
        for (const e of this[$fd4eb456bcbd06f8$var$jy])e.roughness = t1;
        this[$fd4eb456bcbd06f8$var$gy].roughnessFactor = t1, this[$fd4eb456bcbd06f8$var$vy]();
    }
}
/* @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $fd4eb456bcbd06f8$var$Yy;
const $fd4eb456bcbd06f8$var$Jy = Symbol("pbrMetallicRoughness"), $fd4eb456bcbd06f8$var$Ky = Symbol("normalTexture"), $fd4eb456bcbd06f8$var$Zy = Symbol("occlusionTexture"), $fd4eb456bcbd06f8$var$Qy = Symbol("emissiveTexture"), $fd4eb456bcbd06f8$var$tx = Symbol("backingThreeMaterial"), $fd4eb456bcbd06f8$var$ex = Symbol("applyAlphaCutoff"), $fd4eb456bcbd06f8$var$nx = Symbol("lazyLoadGLTFInfo"), $fd4eb456bcbd06f8$var$ix = Symbol("initialize"), $fd4eb456bcbd06f8$var$rx = Symbol("getLoadedMaterial"), $fd4eb456bcbd06f8$var$sx = Symbol("ensureMaterialIsLoaded"), $fd4eb456bcbd06f8$var$ax = Symbol("gltfIndex"), $fd4eb456bcbd06f8$var$ox = Symbol("setActive"), $fd4eb456bcbd06f8$var$lx = Symbol("variantIndices"), $fd4eb456bcbd06f8$var$hx = Symbol("isActive"), $fd4eb456bcbd06f8$var$cx = Symbol("variantSet"), $fd4eb456bcbd06f8$var$ux = Symbol("modelVariants");
class $fd4eb456bcbd06f8$var$dx extends $fd4eb456bcbd06f8$var$yy {
    constructor(t1, e, n, i, r, s, a, o){
        super(t1, n, a), this[$fd4eb456bcbd06f8$var$Yy] = new Set, this[$fd4eb456bcbd06f8$var$ax] = i, this[$fd4eb456bcbd06f8$var$hx] = r, this[$fd4eb456bcbd06f8$var$ux] = s, null == o ? this[$fd4eb456bcbd06f8$var$ix](e) : this[$fd4eb456bcbd06f8$var$nx] = o;
    }
    get [($fd4eb456bcbd06f8$var$Yy = $fd4eb456bcbd06f8$var$cx, $fd4eb456bcbd06f8$var$tx)]() {
        return this[$fd4eb456bcbd06f8$var$fy].values().next().value;
    }
    [$fd4eb456bcbd06f8$var$ix](t1) {
        const e = this[$fd4eb456bcbd06f8$var$vy], n = this[$fd4eb456bcbd06f8$var$gy], i = this[$fd4eb456bcbd06f8$var$fy];
        n.extensions && n.extensions.KHR_materials_pbrSpecularGlossiness && console.warn(`Material ${n.name} uses a deprecated extension\n          "KHR_materials_pbrSpecularGlossiness", please use\n          "pbrMetallicRoughness" instead. Specular Glossiness materials are\n          currently supported for rendering, but not for our scene-graph API,\n          nor for auto-generation of USDZ for Quick Look.`), null == n.pbrMetallicRoughness && (n.pbrMetallicRoughness = {}), this[$fd4eb456bcbd06f8$var$Jy] = new $fd4eb456bcbd06f8$var$$y(e, t1, n.pbrMetallicRoughness, i), null == n.emissiveFactor && (n.emissiveFactor = [
            0,
            0,
            0
        ]), null == n.doubleSided && (n.doubleSided = !1), null == n.alphaMode && (n.alphaMode = "OPAQUE"), null == n.alphaCutoff && (n.alphaCutoff = .5);
        const { normalTexture: r, occlusionTexture: s, emissiveTexture: a } = n, { normalMap: o, aoMap: l, emissiveMap: h } = i.values().next().value;
        this[$fd4eb456bcbd06f8$var$Ky] = new $fd4eb456bcbd06f8$var$Wy(e, $fd4eb456bcbd06f8$var$Gy.Normal, o, i, t1, r || null), this[$fd4eb456bcbd06f8$var$Zy] = new $fd4eb456bcbd06f8$var$Wy(e, $fd4eb456bcbd06f8$var$Gy.Occlusion, l, i, t1, s || null), this[$fd4eb456bcbd06f8$var$Qy] = new $fd4eb456bcbd06f8$var$Wy(e, $fd4eb456bcbd06f8$var$Gy.Emissive, h, i, t1, a || null);
    }
    async [$fd4eb456bcbd06f8$var$rx]() {
        if (null != this[$fd4eb456bcbd06f8$var$nx]) {
            const { set: t1, material: e } = await this[$fd4eb456bcbd06f8$var$nx].doLazyLoad();
            return this[$fd4eb456bcbd06f8$var$fy] = t1, this[$fd4eb456bcbd06f8$var$ix](this[$fd4eb456bcbd06f8$var$nx].gltf), this[$fd4eb456bcbd06f8$var$nx] = void 0, this.ensureLoaded = async ()=>{}, e;
        }
        return this[$fd4eb456bcbd06f8$var$fy].values().next().value;
    }
    [$fd4eb456bcbd06f8$var$sx]() {
        if (null != this[$fd4eb456bcbd06f8$var$nx]) throw new Error(`Material "${this.name}" has not been loaded, call 'await\n    myMaterial.ensureLoaded()' before using an unloaded material.`);
    }
    async ensureLoaded() {
        await this[$fd4eb456bcbd06f8$var$rx]();
    }
    get isLoaded() {
        return null == this[$fd4eb456bcbd06f8$var$nx];
    }
    get isActive() {
        return this[$fd4eb456bcbd06f8$var$hx];
    }
    [$fd4eb456bcbd06f8$var$ox](t1) {
        this[$fd4eb456bcbd06f8$var$hx] = t1;
    }
    get name() {
        return this[$fd4eb456bcbd06f8$var$gy].name;
    }
    set name(t1) {
        const e = this[$fd4eb456bcbd06f8$var$gy];
        if (null != e && (e.name = t1), null != this[$fd4eb456bcbd06f8$var$fy]) for (const e of this[$fd4eb456bcbd06f8$var$fy])e.name = t1;
    }
    get pbrMetallicRoughness() {
        return this[$fd4eb456bcbd06f8$var$sx](), this[$fd4eb456bcbd06f8$var$Jy];
    }
    get normalTexture() {
        return this[$fd4eb456bcbd06f8$var$sx](), this[$fd4eb456bcbd06f8$var$Ky];
    }
    get occlusionTexture() {
        return this[$fd4eb456bcbd06f8$var$sx](), this[$fd4eb456bcbd06f8$var$Zy];
    }
    get emissiveTexture() {
        return this[$fd4eb456bcbd06f8$var$sx](), this[$fd4eb456bcbd06f8$var$Qy];
    }
    get emissiveFactor() {
        return this[$fd4eb456bcbd06f8$var$sx](), this[$fd4eb456bcbd06f8$var$gy].emissiveFactor;
    }
    get index() {
        return this[$fd4eb456bcbd06f8$var$ax];
    }
    [$fd4eb456bcbd06f8$var$lx]() {
        return this[$fd4eb456bcbd06f8$var$cx];
    }
    hasVariant(t1) {
        const e = this[$fd4eb456bcbd06f8$var$ux].get(t1);
        return null != e && this[$fd4eb456bcbd06f8$var$cx].has(e.index);
    }
    setEmissiveFactor(t1) {
        this[$fd4eb456bcbd06f8$var$sx]();
        for (const e of this[$fd4eb456bcbd06f8$var$fy])e.emissive.fromArray(t1);
        this[$fd4eb456bcbd06f8$var$gy].emissiveFactor = t1, this[$fd4eb456bcbd06f8$var$vy]();
    }
    [$fd4eb456bcbd06f8$var$ex]() {
        this[$fd4eb456bcbd06f8$var$sx]();
        const t1 = this[$fd4eb456bcbd06f8$var$gy];
        for (const e of this[$fd4eb456bcbd06f8$var$fy])"MASK" === this[$fd4eb456bcbd06f8$var$gy].alphaMode ? e.alphaTest = t1.alphaCutoff : e.alphaTest = void 0, e.needsUpdate = !0;
    }
    setAlphaCutoff(t1) {
        this[$fd4eb456bcbd06f8$var$sx](), this[$fd4eb456bcbd06f8$var$gy].alphaCutoff = t1, this[$fd4eb456bcbd06f8$var$ex](), this[$fd4eb456bcbd06f8$var$vy]();
    }
    getAlphaCutoff() {
        return this[$fd4eb456bcbd06f8$var$sx](), this[$fd4eb456bcbd06f8$var$gy].alphaCutoff;
    }
    setDoubleSided(t1) {
        this[$fd4eb456bcbd06f8$var$sx]();
        for (const e of this[$fd4eb456bcbd06f8$var$fy])e.side = t1 ? 2 : 0, e.needsUpdate = !0;
        this[$fd4eb456bcbd06f8$var$gy].doubleSided = t1, this[$fd4eb456bcbd06f8$var$vy]();
    }
    getDoubleSided() {
        return this[$fd4eb456bcbd06f8$var$sx](), this[$fd4eb456bcbd06f8$var$gy].doubleSided;
    }
    setAlphaMode(t1) {
        this[$fd4eb456bcbd06f8$var$sx]();
        const e = (t1, e)=>{
            t1.transparent = e, t1.depthWrite = !e;
        };
        this[$fd4eb456bcbd06f8$var$gy].alphaMode = t1;
        for (const n of this[$fd4eb456bcbd06f8$var$fy])e(n, "BLEND" === t1), this[$fd4eb456bcbd06f8$var$ex](), n.needsUpdate = !0;
        this[$fd4eb456bcbd06f8$var$vy]();
    }
    getAlphaMode() {
        return this[$fd4eb456bcbd06f8$var$sx](), this[$fd4eb456bcbd06f8$var$gy].alphaMode;
    }
}
var $fd4eb456bcbd06f8$var$px, $fd4eb456bcbd06f8$var$mx, $fd4eb456bcbd06f8$var$fx;
const $fd4eb456bcbd06f8$var$gx = Symbol("materials"), $fd4eb456bcbd06f8$var$vx = Symbol("variantToMaterialMap"), $fd4eb456bcbd06f8$var$yx = Symbol("modelVariants"), $fd4eb456bcbd06f8$var$xx = Symbol("mesh"), $fd4eb456bcbd06f8$var$bx = Symbol("children"), $fd4eb456bcbd06f8$var$_x = Symbol("initialMaterialIdx"), $fd4eb456bcbd06f8$var$wx = Symbol("activeMaterialIdx");
class $fd4eb456bcbd06f8$var$Mx {
    constructor(t1){
        this.name = "", this[$fd4eb456bcbd06f8$var$px] = new Array, this.name = t1;
    }
}
$fd4eb456bcbd06f8$var$px = $fd4eb456bcbd06f8$var$bx;
class $fd4eb456bcbd06f8$var$Sx extends $fd4eb456bcbd06f8$var$Mx {
    constructor(t1, e, n, i){
        super(t1.name), this[$fd4eb456bcbd06f8$var$mx] = new Map, this[$fd4eb456bcbd06f8$var$fx] = new Map, this[$fd4eb456bcbd06f8$var$xx] = t1;
        const { gltf: r, threeGLTF: s, threeObjectMap: a } = i;
        this[$fd4eb456bcbd06f8$var$yx] = n, this.mesh.userData.variantData = n;
        const o = a.get(t1.material);
        null != o.materials ? this[$fd4eb456bcbd06f8$var$_x] = this[$fd4eb456bcbd06f8$var$wx] = o.materials : console.error(`Primitive (${t1.name}) missing initial material reference.`);
        const l = t1.userData.associations || {};
        if (null == l.meshes) return void console.error("Mesh is missing primitive index association");
        const h = ((r.meshes || [])[l.meshes].primitives || [])[l.primitives];
        if (null != h) {
            if (null != h.material) this[$fd4eb456bcbd06f8$var$gx].set(h.material, e[h.material]);
            else {
                const t1 = e.findIndex((t1)=>"Default" === t1.name);
                t1 >= 0 ? this[$fd4eb456bcbd06f8$var$gx].set(t1, e[t1]) : console.warn("gltfPrimitive has no material!");
            }
            if (h.extensions && h.extensions.KHR_materials_variants) {
                const t1 = h.extensions.KHR_materials_variants, i = s.parser.json.extensions.KHR_materials_variants.variants;
                for (const r of t1.mappings){
                    const t1 = e[r.material];
                    this[$fd4eb456bcbd06f8$var$gx].set(r.material, t1);
                    for (const e of r.variants){
                        const { name: r } = i[e];
                        this[$fd4eb456bcbd06f8$var$vx].set(e, t1), t1[$fd4eb456bcbd06f8$var$lx]().add(e), n.has(r) || n.set(r, {
                            name: r,
                            index: e
                        });
                    }
                }
            }
        } else console.error("Mesh primitive definition is missing.");
    }
    get mesh() {
        return this[$fd4eb456bcbd06f8$var$xx];
    }
    async setActiveMaterial(t1) {
        const e = this[$fd4eb456bcbd06f8$var$gx].get(t1);
        return null != e && (this.mesh.material = await e[$fd4eb456bcbd06f8$var$rx](), this[$fd4eb456bcbd06f8$var$wx] = t1), this.mesh.material;
    }
    getActiveMaterial() {
        return this[$fd4eb456bcbd06f8$var$gx].get(this[$fd4eb456bcbd06f8$var$wx]);
    }
    getMaterial(t1) {
        return this[$fd4eb456bcbd06f8$var$gx].get(t1);
    }
    async enableVariant(t1) {
        if (null == t1) return this.setActiveMaterial(this[$fd4eb456bcbd06f8$var$_x]);
        if (null != this[$fd4eb456bcbd06f8$var$vx] && this[$fd4eb456bcbd06f8$var$yx].has(t1)) {
            const e = this[$fd4eb456bcbd06f8$var$yx].get(t1);
            return this.enableVariantHelper(e.index);
        }
        return null;
    }
    async enableVariantHelper(t1) {
        if (null != this[$fd4eb456bcbd06f8$var$vx] && null != t1) {
            const e = this[$fd4eb456bcbd06f8$var$vx].get(t1);
            if (null != e) return this.setActiveMaterial(e.index);
        }
        return null;
    }
    async instantiateVariants() {
        if (null != this[$fd4eb456bcbd06f8$var$vx]) for (const t1 of this[$fd4eb456bcbd06f8$var$vx].keys()){
            if (null != this.mesh.userData.variantMaterials.get(t1).material) continue;
            const e = await this.enableVariantHelper(t1);
            null != e && (this.mesh.userData.variantMaterials.get(t1).material = e);
        }
    }
    get variantInfo() {
        return this[$fd4eb456bcbd06f8$var$vx];
    }
    addVariant(t1, e) {
        if (!this.ensureVariantIsUnused(e)) return !1;
        this[$fd4eb456bcbd06f8$var$yx].has(e) || this[$fd4eb456bcbd06f8$var$yx].set(e, {
            name: e,
            index: this[$fd4eb456bcbd06f8$var$yx].size
        });
        const n = this[$fd4eb456bcbd06f8$var$yx].get(e).index;
        return t1[$fd4eb456bcbd06f8$var$lx]().add(n), this[$fd4eb456bcbd06f8$var$vx].set(n, t1), this[$fd4eb456bcbd06f8$var$gx].set(t1.index, t1), this.updateVariantUserData(n, t1), !0;
    }
    deleteVariant(t1) {
        if (this.variantInfo.has(t1)) {
            this.variantInfo.delete(t1);
            const e = this.mesh.userData.variantMaterials;
            null != e && e.delete(t1);
        }
    }
    updateVariantUserData(t1, e) {
        e[$fd4eb456bcbd06f8$var$lx]().add(t1), this.mesh.userData.variantData = this[$fd4eb456bcbd06f8$var$yx], this.mesh.userData.variantMaterials = this.mesh.userData.variantMaterials || new Map;
        this.mesh.userData.variantMaterials.set(t1, {
            material: e[$fd4eb456bcbd06f8$var$fy].values().next().value,
            gltfMaterialIndex: e.index
        });
    }
    ensureVariantIsUnused(t1) {
        const e = this[$fd4eb456bcbd06f8$var$yx].get(t1);
        return null == e || !this.variantInfo.has(e.index) || (console.warn(`Primitive cannot add variant '${t1}' for this material, it already exists.`), !1);
    }
}
/* @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $fd4eb456bcbd06f8$var$Tx, $fd4eb456bcbd06f8$var$Ex, $fd4eb456bcbd06f8$var$Ax, $fd4eb456bcbd06f8$var$Rx, $fd4eb456bcbd06f8$var$Cx, $fd4eb456bcbd06f8$var$Lx;
$fd4eb456bcbd06f8$var$mx = $fd4eb456bcbd06f8$var$gx, $fd4eb456bcbd06f8$var$fx = $fd4eb456bcbd06f8$var$vx;
const $fd4eb456bcbd06f8$var$Px = Symbol("materials"), $fd4eb456bcbd06f8$var$Dx = Symbol("hierarchy"), $fd4eb456bcbd06f8$var$Ix = Symbol("roots"), $fd4eb456bcbd06f8$var$Ox = Symbol("primitives"), $fd4eb456bcbd06f8$var$Nx = Symbol("correlatedSceneGraph"), $fd4eb456bcbd06f8$var$Fx = Symbol("prepareVariantsForExport"), $fd4eb456bcbd06f8$var$Ux = Symbol("switchVariant"), $fd4eb456bcbd06f8$var$kx = Symbol("threeScene"), $fd4eb456bcbd06f8$var$Bx = Symbol("materialsFromPoint"), $fd4eb456bcbd06f8$var$zx = Symbol("materialFromPoint"), $fd4eb456bcbd06f8$var$Hx = Symbol("variantData"), $fd4eb456bcbd06f8$var$Vx = Symbol("availableVariants"), $fd4eb456bcbd06f8$var$Gx = Symbol("modelOnUpdate"), $fd4eb456bcbd06f8$var$Wx = Symbol("cloneMaterial");
class $fd4eb456bcbd06f8$var$jx {
    constructor(t1, e, n, i){
        this.gltf = t1, this.gltfElementMap = e, this.mapKey = n, this.doLazyLoad = i;
    }
}
class $fd4eb456bcbd06f8$var$qx {
    constructor(t1, e = ()=>{}){
        this[$fd4eb456bcbd06f8$var$Tx] = new Array, this[$fd4eb456bcbd06f8$var$Ex] = new Array, this[$fd4eb456bcbd06f8$var$Ax] = new Array, this[$fd4eb456bcbd06f8$var$Rx] = new Array, this[$fd4eb456bcbd06f8$var$Cx] = ()=>{}, this[$fd4eb456bcbd06f8$var$Lx] = new Map, this[$fd4eb456bcbd06f8$var$Gx] = e, this[$fd4eb456bcbd06f8$var$Nx] = t1;
        const { gltf: n, threeGLTF: i, gltfElementMap: r } = t1;
        this[$fd4eb456bcbd06f8$var$kx] = i.scene;
        for (const [t1, s] of n.materials.entries()){
            const a = r.get(s);
            if (null != a) this[$fd4eb456bcbd06f8$var$Px].push(new $fd4eb456bcbd06f8$var$dx(e, n, s, t1, !0, this[$fd4eb456bcbd06f8$var$Hx], a));
            else {
                const s = (n.materials || [])[t1], o = t1, l = async ()=>{
                    const t1 = await i.parser.getDependency("material", o), e = new Set;
                    return r.set(s, e), e.add(t1), {
                        set: e,
                        material: t1
                    };
                };
                this[$fd4eb456bcbd06f8$var$Px].push(new $fd4eb456bcbd06f8$var$dx(e, n, s, t1, !1, this[$fd4eb456bcbd06f8$var$Hx], a, new $fd4eb456bcbd06f8$var$jx(n, r, s, l)));
            }
        }
        const s = new Map, a = new Array;
        for (const t1 of i.scene.children)a.push(t1);
        for(; a.length > 0;){
            const e = a.pop();
            let n = null;
            e instanceof $fd4eb456bcbd06f8$var$Fe ? (n = new $fd4eb456bcbd06f8$var$Sx(e, this.materials, this[$fd4eb456bcbd06f8$var$Hx], t1), this[$fd4eb456bcbd06f8$var$Ox].push(n)) : n = new $fd4eb456bcbd06f8$var$Mx(e.name);
            const i = s.get(e);
            null != i ? i[$fd4eb456bcbd06f8$var$bx].push(n) : this[$fd4eb456bcbd06f8$var$Ix].push(n), this[$fd4eb456bcbd06f8$var$Dx].push(n);
            for (const t1 of e.children)a.push(t1), s.set(e, n);
        }
    }
    get materials() {
        return this[$fd4eb456bcbd06f8$var$Px];
    }
    [($fd4eb456bcbd06f8$var$Tx = $fd4eb456bcbd06f8$var$Px, $fd4eb456bcbd06f8$var$Ex = $fd4eb456bcbd06f8$var$Dx, $fd4eb456bcbd06f8$var$Ax = $fd4eb456bcbd06f8$var$Ix, $fd4eb456bcbd06f8$var$Rx = $fd4eb456bcbd06f8$var$Ox, $fd4eb456bcbd06f8$var$Cx = $fd4eb456bcbd06f8$var$Gx, $fd4eb456bcbd06f8$var$Lx = $fd4eb456bcbd06f8$var$Hx, $fd4eb456bcbd06f8$var$Vx)]() {
        const t1 = Array.from(this[$fd4eb456bcbd06f8$var$Hx].values());
        return t1.sort((t1, e)=>t1.index - e.index), t1.map((t1)=>t1.name);
    }
    getMaterialByName(t1) {
        const e = this[$fd4eb456bcbd06f8$var$Px].filter((e)=>e.name === t1);
        return e.length > 0 ? e[0] : null;
    }
    [$fd4eb456bcbd06f8$var$Bx](t1) {
        return t1.intersectObject(this[$fd4eb456bcbd06f8$var$kx], !0).map((t1)=>{
            const e = this[$fd4eb456bcbd06f8$var$Dx].find((e)=>{
                if (e instanceof $fd4eb456bcbd06f8$var$Sx) {
                    if (e.mesh === t1.object) return !0;
                }
                return !1;
            });
            return null != e ? e.getActiveMaterial() : null;
        });
    }
    [$fd4eb456bcbd06f8$var$zx](t1) {
        const e = this[$fd4eb456bcbd06f8$var$Bx](t1);
        return e.length > 0 ? e[0] : null;
    }
    async [$fd4eb456bcbd06f8$var$Ux](t1) {
        for (const e of this[$fd4eb456bcbd06f8$var$Ox])await e.enableVariant(t1);
        for (const t1 of this.materials)t1[$fd4eb456bcbd06f8$var$ox](!1);
        for (const t1 of this[$fd4eb456bcbd06f8$var$Ox])this.materials[t1.getActiveMaterial().index][$fd4eb456bcbd06f8$var$ox](!0);
    }
    async [$fd4eb456bcbd06f8$var$Fx]() {
        const t1 = new Array;
        for (const e of this[$fd4eb456bcbd06f8$var$Ox])t1.push(e.instantiateVariants());
        await Promise.all(t1);
    }
    [$fd4eb456bcbd06f8$var$Wx](t1, e) {
        const n = this.materials[t1];
        n.isLoaded || console.error("Cloning an unloaded material,\n           call 'material.ensureLoaded() before cloning the material.");
        const i = n[$fd4eb456bcbd06f8$var$fy], r = JSON.parse(JSON.stringify(n[$fd4eb456bcbd06f8$var$gy]));
        r.name = e;
        this[$fd4eb456bcbd06f8$var$Nx].gltf.materials.push(r);
        const s = new Set;
        for (const [t1, n] of i.entries()){
            const r = n.clone();
            r.name = e + (i.size > 1 ? "_inst" + t1 : ""), s.add(r);
        }
        const a = new $fd4eb456bcbd06f8$var$dx(this[$fd4eb456bcbd06f8$var$Gx], this[$fd4eb456bcbd06f8$var$Nx].gltf, r, this[$fd4eb456bcbd06f8$var$Px].length, !1, this[$fd4eb456bcbd06f8$var$Hx], s);
        return this[$fd4eb456bcbd06f8$var$Px].push(a), a;
    }
    createMaterialInstanceForVariant(t1, e, n, i = !0) {
        let r = null;
        for (const i of this[$fd4eb456bcbd06f8$var$Ox]){
            const s = this[$fd4eb456bcbd06f8$var$Hx].get(n);
            null != s && i.variantInfo.has(s.index) || null != i.getMaterial(t1) && (this.hasVariant(n) || this.createVariant(n), null == r && (r = this[$fd4eb456bcbd06f8$var$Wx](t1, e)), i.addVariant(r, n));
        }
        if (i && null != r) {
            r[$fd4eb456bcbd06f8$var$ox](!0), this.materials[t1][$fd4eb456bcbd06f8$var$ox](!1);
            for (const t1 of this[$fd4eb456bcbd06f8$var$Ox])t1.enableVariant(n);
        }
        return r;
    }
    createVariant(t1) {
        this[$fd4eb456bcbd06f8$var$Hx].has(t1) ? console.warn(`Variant '${t1}'' already exists`) : this[$fd4eb456bcbd06f8$var$Hx].set(t1, {
            name: t1,
            index: this[$fd4eb456bcbd06f8$var$Hx].size
        });
    }
    hasVariant(t1) {
        return this[$fd4eb456bcbd06f8$var$Hx].has(t1);
    }
    setMaterialToVariant(t1, e) {
        if (null != this[$fd4eb456bcbd06f8$var$Vx]().find((t1)=>t1 === e)) {
            if (t1 < 0 || t1 >= this.materials.length) console.error("setMaterialToVariant(): materialIndex is out of bounds.");
            else for (const n of this[$fd4eb456bcbd06f8$var$Ox]){
                const i = n.getMaterial(t1);
                null != i && n.addVariant(i, e);
            }
        } else console.warn(`Can't add material to '${e}', the variant does not exist.'`);
    }
    updateVariantName(t1, e) {
        const n = this[$fd4eb456bcbd06f8$var$Hx].get(t1);
        null != n && (n.name = e, this[$fd4eb456bcbd06f8$var$Hx].set(e, n), this[$fd4eb456bcbd06f8$var$Hx].delete(t1));
    }
    deleteVariant(t1) {
        const e = this[$fd4eb456bcbd06f8$var$Hx].get(t1);
        if (null != e) {
            for (const n of this.materials)n.hasVariant(t1) && n[$fd4eb456bcbd06f8$var$cx].delete(e.index);
            for (const t1 of this[$fd4eb456bcbd06f8$var$Ox])t1.deleteVariant(e.index);
            this[$fd4eb456bcbd06f8$var$Hx].delete(t1);
        }
    }
}
/* @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $fd4eb456bcbd06f8$var$Xx = function(t1, e, n, i) {
    for(var r, s = arguments.length, a = s < 3 ? e : null === i ? i = Object.getOwnPropertyDescriptor(e, n) : i, o = t1.length - 1; o >= 0; o--)(r = t1[o]) && (a = (s < 3 ? r(a) : s > 3 ? r(e, n, a) : r(e, n)) || a);
    return s > 3 && a && Object.defineProperty(e, n, a), a;
};
const $fd4eb456bcbd06f8$var$$x = Symbol("currentGLTF"), $fd4eb456bcbd06f8$var$Yx = Symbol("model"), $fd4eb456bcbd06f8$var$Jx = Symbol("getOnUpdateMethod"), $fd4eb456bcbd06f8$var$Kx = Symbol("textureLoader"), $fd4eb456bcbd06f8$var$Zx = Symbol("originalGltfJson");
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $fd4eb456bcbd06f8$var$Qx = function(t1, e, n, i) {
    for(var r, s = arguments.length, a = s < 3 ? e : null === i ? i = Object.getOwnPropertyDescriptor(e, n) : i, o = t1.length - 1; o >= 0; o--)(r = t1[o]) && (a = (s < 3 ? r(a) : s > 3 ? r(e, n, a) : r(e, n)) || a);
    return s > 3 && a && Object.defineProperty(e, n, a), a;
};
const $fd4eb456bcbd06f8$var$tb = Math.PI / 32, $fd4eb456bcbd06f8$var$eb = {
    basis: [
        $fd4eb456bcbd06f8$var$Mu($fd4eb456bcbd06f8$var$pu($fd4eb456bcbd06f8$var$tb, "rad"))
    ],
    keywords: {
        auto: [
            null
        ]
    }
}, $fd4eb456bcbd06f8$var$nb = Symbol("autoRotateStartTime"), $fd4eb456bcbd06f8$var$ib = Symbol("radiansPerSecond"), $fd4eb456bcbd06f8$var$rb = Symbol("syncRotationRate"), $fd4eb456bcbd06f8$var$sb = Symbol("onCameraChange"), $fd4eb456bcbd06f8$export$68e64b0cee2d229b = ((t1)=>{
    var e, n, i;
    class r extends t1 {
        constructor(){
            super(...arguments), this[e] = new Map, this[n] = (t1)=>{
                t1.forEach((t1)=>{
                    t1 instanceof MutationRecord && "childList" !== t1.type || (t1.addedNodes.forEach((t1)=>{
                        this[$fd4eb456bcbd06f8$var$Gp](t1);
                    }), t1.removedNodes.forEach((t1)=>{
                        this[$fd4eb456bcbd06f8$var$Wp](t1);
                    }), this[$fd4eb456bcbd06f8$var$wp]());
                });
            }, this[i] = new MutationObserver(this[$fd4eb456bcbd06f8$var$Hp]);
        }
        connectedCallback() {
            super.connectedCallback();
            for(let t1 = 0; t1 < this.children.length; ++t1)this[$fd4eb456bcbd06f8$var$Gp](this.children[t1]);
            const { ShadyDOM: t1 } = self;
            null == t1 ? this[$fd4eb456bcbd06f8$var$Vp].observe(this, {
                childList: !0
            }) : this[$fd4eb456bcbd06f8$var$Vp] = t1.observeChildren(this, this[$fd4eb456bcbd06f8$var$Hp]);
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            const { ShadyDOM: t1 } = self;
            null == t1 ? this[$fd4eb456bcbd06f8$var$Vp].disconnect() : t1.unobserveChildren(this[$fd4eb456bcbd06f8$var$Vp]);
        }
        [(e = $fd4eb456bcbd06f8$var$zp, n = $fd4eb456bcbd06f8$var$Hp, i = $fd4eb456bcbd06f8$var$Vp, $fd4eb456bcbd06f8$var$Mp)](t1, e) {
            super[$fd4eb456bcbd06f8$var$Mp](t1, e);
            const n = this[$fd4eb456bcbd06f8$var$_p], { annotationRenderer: i } = n, r = n.getCamera();
            n.shouldRender() && (n.updateHotspots(r.position), i.domElement.style.display = "", i.render(n, r));
        }
        updateHotspot(t1) {
            const e = this[$fd4eb456bcbd06f8$var$zp].get(t1.name);
            null != e && (e.updatePosition(t1.position), e.updateNormal(t1.normal), this[$fd4eb456bcbd06f8$var$wp]());
        }
        positionAndNormalFromPoint(t1, e) {
            const n = this[$fd4eb456bcbd06f8$var$_p], i = n.getNDC(t1, e), r = n.positionAndNormalFromPoint(i);
            if (null == r) return null;
            $fd4eb456bcbd06f8$var$jp.copy(n.target.matrixWorld).invert();
            const s = $fd4eb456bcbd06f8$var$Ip(r.position.applyMatrix4($fd4eb456bcbd06f8$var$jp));
            $fd4eb456bcbd06f8$var$qp.getNormalMatrix($fd4eb456bcbd06f8$var$jp);
            const a = $fd4eb456bcbd06f8$var$Ip(r.normal.applyNormalMatrix($fd4eb456bcbd06f8$var$qp));
            let o = null;
            return null != r.uv && (o = $fd4eb456bcbd06f8$var$Op(r.uv)), {
                position: s,
                normal: a,
                uv: o
            };
        }
        [$fd4eb456bcbd06f8$var$Gp](t1) {
            if (!(t1 instanceof HTMLElement && 0 === t1.slot.indexOf("hotspot"))) return;
            let e = this[$fd4eb456bcbd06f8$var$zp].get(t1.slot);
            null != e ? e.increment() : (e = new $fd4eb456bcbd06f8$var$Eu({
                name: t1.slot,
                position: t1.dataset.position,
                normal: t1.dataset.normal
            }), this[$fd4eb456bcbd06f8$var$zp].set(t1.slot, e), this[$fd4eb456bcbd06f8$var$_p].addHotspot(e)), this[$fd4eb456bcbd06f8$var$_p].queueRender();
        }
        [$fd4eb456bcbd06f8$var$Wp](t1) {
            if (!(t1 instanceof HTMLElement)) return;
            const e = this[$fd4eb456bcbd06f8$var$zp].get(t1.slot);
            e && (e.decrement() && (this[$fd4eb456bcbd06f8$var$_p].removeHotspot(e), this[$fd4eb456bcbd06f8$var$zp].delete(t1.slot)), this[$fd4eb456bcbd06f8$var$_p].queueRender());
        }
    }
    return r;
})(((t1)=>{
    var n, i, r, s;
    class a extends t1 {
        constructor(){
            super(...arguments), this[n] = void 0, this[i] = null, this[r] = new $fd4eb456bcbd06f8$var$fo, this[s] = null, this.variantName = null, this.orientation = "0 0 0", this.scale = "1 1 1";
        }
        get model() {
            return this[$fd4eb456bcbd06f8$var$Yx];
        }
        get availableVariants() {
            return this.model ? this.model[$fd4eb456bcbd06f8$var$Vx]() : [];
        }
        get originalGltfJson() {
            return this[$fd4eb456bcbd06f8$var$Zx];
        }
        [(n = $fd4eb456bcbd06f8$var$Yx, i = $fd4eb456bcbd06f8$var$$x, r = $fd4eb456bcbd06f8$var$Kx, s = $fd4eb456bcbd06f8$var$Zx, $fd4eb456bcbd06f8$var$Jx)]() {
            return ()=>{
                this[$fd4eb456bcbd06f8$var$wp]();
            };
        }
        async createTexture(t1, e = "image/png") {
            const n = this[$fd4eb456bcbd06f8$var$$x], i = await new Promise((e)=>this[$fd4eb456bcbd06f8$var$Kx].load(t1, e));
            return n && i ? (i.encoding = 3001, i.wrapS = 1e3, i.wrapT = 1e3, i.flipY = !1, i.userData.mimeType = e, new $fd4eb456bcbd06f8$var$Fy(this[$fd4eb456bcbd06f8$var$Jx](), i)) : null;
        }
        async updated(t1) {
            if (super.updated(t1), t1.has("variantName")) {
                const t1 = this[$fd4eb456bcbd06f8$var$$x], { variantName: e } = this;
                null != t1 && (await this[$fd4eb456bcbd06f8$var$Yx][$fd4eb456bcbd06f8$var$Ux](e), this[$fd4eb456bcbd06f8$var$wp](), this.dispatchEvent(new CustomEvent("variant-applied")));
            }
            if (t1.has("orientation") || t1.has("scale")) {
                const { modelContainer: t1 } = this[$fd4eb456bcbd06f8$var$_p], e = $fd4eb456bcbd06f8$var$mu(this.orientation)[0].terms, n = $fd4eb456bcbd06f8$var$Tu(e[0]).number, i = $fd4eb456bcbd06f8$var$Tu(e[1]).number, r = $fd4eb456bcbd06f8$var$Tu(e[2]).number;
                t1.quaternion.setFromEuler(new $fd4eb456bcbd06f8$var$Ct(i, r, n, "YXZ"));
                const s = $fd4eb456bcbd06f8$var$mu(this.scale)[0].terms;
                t1.scale.set(s[0].number, s[1].number, s[2].number), this[$fd4eb456bcbd06f8$var$_p].updateBoundingBox(), this[$fd4eb456bcbd06f8$var$_p].updateShadow(), this[$fd4eb456bcbd06f8$var$Ep].arRenderer.onUpdateScene(), this[$fd4eb456bcbd06f8$var$wp]();
            }
        }
        [$fd4eb456bcbd06f8$var$Sp]() {
            super[$fd4eb456bcbd06f8$var$Sp]();
            const { currentGLTF: t1 } = this[$fd4eb456bcbd06f8$var$_p];
            if (null != t1) {
                const { correlatedSceneGraph: e } = t1;
                null != e && t1 !== this[$fd4eb456bcbd06f8$var$$x] && (this[$fd4eb456bcbd06f8$var$Yx] = new $fd4eb456bcbd06f8$var$qx(e, this[$fd4eb456bcbd06f8$var$Jx]()), this[$fd4eb456bcbd06f8$var$Zx] = JSON.parse(JSON.stringify(e.gltf))), "variants" in t1.userData && this.requestUpdate("variantName");
            }
            this[$fd4eb456bcbd06f8$var$$x] = t1, this.dispatchEvent(new CustomEvent("scene-graph-ready"));
        }
        async exportScene(t1) {
            const e = this[$fd4eb456bcbd06f8$var$_p];
            return new Promise(async (n)=>{
                const i = {
                    binary: !0,
                    onlyVisible: !0,
                    maxTextureSize: 1 / 0,
                    forcePowerOfTwoTextures: !1,
                    includeCustomExtensions: !1,
                    embedImages: !0
                };
                Object.assign(i, t1), i.animations = e.animations, i.truncateDrawRange = !0;
                const r = e.shadow;
                let s = !1;
                null != r && (s = r.visible, r.visible = !1), await this[$fd4eb456bcbd06f8$var$Yx][$fd4eb456bcbd06f8$var$Fx]();
                (new $fd4eb456bcbd06f8$var$Dv).register((t1)=>new $fd4eb456bcbd06f8$var$my(t1)).parse(e.modelContainer.children[0], (t1)=>n(new Blob([
                        i.binary ? t1 : JSON.stringify(t1)
                    ], {
                        type: i.binary ? "application/octet-stream" : "application/json"
                    })), i), null != r && (r.visible = s);
            });
        }
        materialFromPoint(t1, e) {
            const n = this[$fd4eb456bcbd06f8$var$_p], i = n.getNDC(t1, e);
            return n.raycaster.setFromCamera(i, n.getCamera()), this[$fd4eb456bcbd06f8$var$Yx][$fd4eb456bcbd06f8$var$zx](n.raycaster);
        }
    }
    return $fd4eb456bcbd06f8$var$Xx([
        $fd4eb456bcbd06f8$var$e({
            type: String,
            attribute: "variant-name"
        })
    ], a.prototype, "variantName", void 0), $fd4eb456bcbd06f8$var$Xx([
        $fd4eb456bcbd06f8$var$e({
            type: String,
            attribute: "orientation"
        })
    ], a.prototype, "orientation", void 0), $fd4eb456bcbd06f8$var$Xx([
        $fd4eb456bcbd06f8$var$e({
            type: String,
            attribute: "scale"
        })
    ], a.prototype, "scale", void 0), a;
})(((t1)=>{
    var n, i, r;
    class s extends t1 {
        constructor(){
            super(...arguments), this.autoRotate = !1, this.autoRotateDelay = 3e3, this.rotationPerSecond = "auto", this[n] = performance.now(), this[i] = 0, this[r] = (t1)=>{
                this.autoRotate && "user-interaction" === t1.detail.source && (this[$fd4eb456bcbd06f8$var$nb] = performance.now());
            };
        }
        connectedCallback() {
            super.connectedCallback(), this.addEventListener("camera-change", this[$fd4eb456bcbd06f8$var$sb]), this[$fd4eb456bcbd06f8$var$nb] = performance.now();
        }
        disconnectedCallback() {
            super.disconnectedCallback(), this.removeEventListener("camera-change", this[$fd4eb456bcbd06f8$var$sb]), this[$fd4eb456bcbd06f8$var$nb] = performance.now();
        }
        updated(t1) {
            super.updated(t1), t1.has("autoRotate") && (this[$fd4eb456bcbd06f8$var$nb] = performance.now());
        }
        [(n = $fd4eb456bcbd06f8$var$nb, i = $fd4eb456bcbd06f8$var$ib, $fd4eb456bcbd06f8$var$rb)](t1) {
            this[$fd4eb456bcbd06f8$var$ib] = t1[0];
        }
        [$fd4eb456bcbd06f8$var$Mp](t1, e) {
            if (super[$fd4eb456bcbd06f8$var$Mp](t1, e), !this.autoRotate || !this[$fd4eb456bcbd06f8$var$Dp]() || this[$fd4eb456bcbd06f8$var$Ep].isPresenting) return;
            const n = Math.min(e, t1 - this[$fd4eb456bcbd06f8$var$nb] - this.autoRotateDelay);
            n > 0 && (this[$fd4eb456bcbd06f8$var$_p].yaw = this.turntableRotation + this[$fd4eb456bcbd06f8$var$ib] * n * .001);
        }
        get turntableRotation() {
            return this[$fd4eb456bcbd06f8$var$_p].yaw;
        }
        resetTurntableRotation(t1 = 0) {
            this[$fd4eb456bcbd06f8$var$_p].yaw = t1;
        }
    }
    return r = $fd4eb456bcbd06f8$var$sb, $fd4eb456bcbd06f8$var$Qx([
        $fd4eb456bcbd06f8$var$e({
            type: Boolean,
            attribute: "auto-rotate"
        })
    ], s.prototype, "autoRotate", void 0), $fd4eb456bcbd06f8$var$Qx([
        $fd4eb456bcbd06f8$var$e({
            type: Number,
            attribute: "auto-rotate-delay"
        })
    ], s.prototype, "autoRotateDelay", void 0), $fd4eb456bcbd06f8$var$Qx([
        $fd4eb456bcbd06f8$var$tg({
            intrinsics: $fd4eb456bcbd06f8$var$eb,
            updateHandler: $fd4eb456bcbd06f8$var$rb
        }),
        $fd4eb456bcbd06f8$var$e({
            type: String,
            attribute: "rotation-per-second"
        })
    ], s.prototype, "rotationPerSecond", void 0), s;
})(((t1)=>{
    var n, i, r;
    class s extends t1 {
        constructor(){
            super(...arguments), this.environmentImage = null, this.skyboxImage = null, this.shadowIntensity = 0, this.shadowSoftness = 1, this.exposure = 1, this[n] = null, this[i] = null, this[r] = (t1)=>{
                t1.element === this && this[$fd4eb456bcbd06f8$var$Gu]();
            };
        }
        connectedCallback() {
            super.connectedCallback(), this[$fd4eb456bcbd06f8$var$Ep].loader.addEventListener("preload", this[$fd4eb456bcbd06f8$var$ju]);
        }
        disconnectedCallback() {
            super.disconnectedCallback(), this[$fd4eb456bcbd06f8$var$Ep].loader.removeEventListener("preload", this[$fd4eb456bcbd06f8$var$ju]);
        }
        updated(t1) {
            super.updated(t1), t1.has("shadowIntensity") && (this[$fd4eb456bcbd06f8$var$_p].setShadowIntensity(.5 * this.shadowIntensity), this[$fd4eb456bcbd06f8$var$wp]()), t1.has("shadowSoftness") && (this[$fd4eb456bcbd06f8$var$_p].setShadowSoftness(this.shadowSoftness), this[$fd4eb456bcbd06f8$var$wp]()), t1.has("exposure") && (this[$fd4eb456bcbd06f8$var$_p].exposure = this.exposure, this[$fd4eb456bcbd06f8$var$wp]()), (t1.has("environmentImage") || t1.has("skyboxImage")) && this[$fd4eb456bcbd06f8$var$Lp]() && this[$fd4eb456bcbd06f8$var$Gu]();
        }
        hasBakedShadow() {
            return this[$fd4eb456bcbd06f8$var$_p].bakedShadows.size > 0;
        }
        [(n = $fd4eb456bcbd06f8$var$Hu, i = $fd4eb456bcbd06f8$var$Wu, r = $fd4eb456bcbd06f8$var$ju, $fd4eb456bcbd06f8$var$Sp)]() {
            super[$fd4eb456bcbd06f8$var$Sp](), null != this[$fd4eb456bcbd06f8$var$Hu] && this[$fd4eb456bcbd06f8$var$Vu](this[$fd4eb456bcbd06f8$var$Hu]);
        }
        async [$fd4eb456bcbd06f8$var$Gu]() {
            const { skyboxImage: t1, environmentImage: e } = this;
            null != this[$fd4eb456bcbd06f8$var$Wu] && (this[$fd4eb456bcbd06f8$var$Wu](), this[$fd4eb456bcbd06f8$var$Wu] = null);
            const { textureUtils: n } = this[$fd4eb456bcbd06f8$var$Ep];
            if (null != n) try {
                const { environmentMap: i, skybox: r } = await new Promise(async (i, r)=>{
                    const s = n.generateEnvironmentMapAndSkybox($fd4eb456bcbd06f8$var$ru(t1), e, {
                        progressTracker: this[$fd4eb456bcbd06f8$var$Ap]
                    });
                    this[$fd4eb456bcbd06f8$var$Wu] = ()=>r(s), i(await s);
                });
                this[$fd4eb456bcbd06f8$var$_p].background = null != r ? r.name === i.name ? i : r : null, this[$fd4eb456bcbd06f8$var$Vu](i), this[$fd4eb456bcbd06f8$var$_p].dispatchEvent({
                    type: "envmap-update"
                });
            } catch (t1) {
                if (t1 instanceof Error) throw this[$fd4eb456bcbd06f8$var$Vu](null), t1;
            }
        }
        [$fd4eb456bcbd06f8$var$Vu](t1) {
            this[$fd4eb456bcbd06f8$var$_p].environment !== t1 && (this[$fd4eb456bcbd06f8$var$Hu] = t1, this[$fd4eb456bcbd06f8$var$_p].environment = this[$fd4eb456bcbd06f8$var$Hu], this.dispatchEvent(new CustomEvent("environment-change")), this[$fd4eb456bcbd06f8$var$wp]());
        }
    }
    return $fd4eb456bcbd06f8$var$zu([
        $fd4eb456bcbd06f8$var$e({
            type: String,
            attribute: "environment-image"
        })
    ], s.prototype, "environmentImage", void 0), $fd4eb456bcbd06f8$var$zu([
        $fd4eb456bcbd06f8$var$e({
            type: String,
            attribute: "skybox-image"
        })
    ], s.prototype, "skyboxImage", void 0), $fd4eb456bcbd06f8$var$zu([
        $fd4eb456bcbd06f8$var$e({
            type: Number,
            attribute: "shadow-intensity"
        })
    ], s.prototype, "shadowIntensity", void 0), $fd4eb456bcbd06f8$var$zu([
        $fd4eb456bcbd06f8$var$e({
            type: Number,
            attribute: "shadow-softness"
        })
    ], s.prototype, "shadowSoftness", void 0), $fd4eb456bcbd06f8$var$zu([
        $fd4eb456bcbd06f8$var$e({
            type: Number
        })
    ], s.prototype, "exposure", void 0), s;
})(((t1)=>{
    var n, i, r, s, a, o, l, h, c, u, d, p, m, f, g, v, y, x;
    class b extends t1 {
        constructor(){
            super(...arguments), this.cameraControls = !1, this.cameraOrbit = "0deg 75deg 105%", this.cameraTarget = "auto auto auto", this.fieldOfView = "auto", this.minCameraOrbit = "auto", this.maxCameraOrbit = "auto", this.minFieldOfView = "auto", this.maxFieldOfView = "auto", this.interactionPromptThreshold = 3e3, this.interactionPromptStyle = $fd4eb456bcbd06f8$var$Sg, this.interactionPrompt = $fd4eb456bcbd06f8$var$wg, this.interactionPolicy = $fd4eb456bcbd06f8$var$Tg, this.orbitSensitivity = 1, this.touchAction = $fd4eb456bcbd06f8$var$Eg, this.disableZoom = !1, this.enablePan = !1, this.interpolationDecay = 50, this.bounds = "legacy", this[n] = this.shadowRoot.querySelector(".interaction-prompt"), this[i] = this.shadowRoot.querySelector("#prompt"), this[r] = [
                this.shadowRoot.querySelector("#finger0"),
                this.shadowRoot.querySelector("#finger1")
            ], this[s] = this.shadowRoot.querySelector(".pan-target"), this[a] = 1 / 0, this[o] = 0, this[l] = 1 / 0, this[h] = !1, this[c] = !1, this[u] = new $fd4eb456bcbd06f8$var$pg(this[$fd4eb456bcbd06f8$var$_p].camera, this[$fd4eb456bcbd06f8$var$xp], this[$fd4eb456bcbd06f8$var$_p]), this[d] = new $fd4eb456bcbd06f8$var$Ko, this[p] = !1, this[m] = !1, this[f] = !1, this[g] = ()=>{
                isFinite(this[$fd4eb456bcbd06f8$var$Qg]) || (this[$fd4eb456bcbd06f8$var$Qg] = performance.now()), this.interactionPrompt !== $fd4eb456bcbd06f8$var$Mg || this[$fd4eb456bcbd06f8$var$Jg] || (this[$fd4eb456bcbd06f8$var$Yg] = !0);
            }, this[v] = ()=>{
                this.interactionPrompt === $fd4eb456bcbd06f8$var$Mg && (this[$fd4eb456bcbd06f8$var$Yg] = !1, this[$fd4eb456bcbd06f8$var$Bg].classList.remove("visible"), this[$fd4eb456bcbd06f8$var$Kg] = 1 / 0, this[$fd4eb456bcbd06f8$var$Qg] = 1 / 0);
            }, this[y] = ({ source: t1 })=>{
                this[$fd4eb456bcbd06f8$var$Gg](), this[$fd4eb456bcbd06f8$var$wp](), t1 === $fd4eb456bcbd06f8$var$ug && (this[$fd4eb456bcbd06f8$var$Jg] = !0, this[$fd4eb456bcbd06f8$var$Vg]()), this.dispatchEvent(new CustomEvent("camera-change", {
                    detail: {
                        source: t1
                    }
                }));
            }, this[x] = (t1)=>{
                "pointer-change-start" === t1.type ? this[$fd4eb456bcbd06f8$var$yp].classList.add("pointer-tumbling") : this[$fd4eb456bcbd06f8$var$yp].classList.remove("pointer-tumbling");
            };
        }
        getCameraOrbit() {
            const { theta: t1, phi: e, radius: n } = this[$fd4eb456bcbd06f8$var$tv];
            return {
                theta: t1,
                phi: e,
                radius: n,
                toString () {
                    return `${this.theta}rad ${this.phi}rad ${this.radius}m`;
                }
            };
        }
        getCameraTarget() {
            return $fd4eb456bcbd06f8$var$Ip(this[$fd4eb456bcbd06f8$var$Ep].isPresenting ? this[$fd4eb456bcbd06f8$var$Ep].arRenderer.target : this[$fd4eb456bcbd06f8$var$_p].getTarget());
        }
        getFieldOfView() {
            return this[$fd4eb456bcbd06f8$var$Ug].getFieldOfView();
        }
        getMinimumFieldOfView() {
            return this[$fd4eb456bcbd06f8$var$Ug].options.minimumFieldOfView;
        }
        getMaximumFieldOfView() {
            return this[$fd4eb456bcbd06f8$var$Ug].options.maximumFieldOfView;
        }
        getIdealAspect() {
            return this[$fd4eb456bcbd06f8$var$_p].idealAspect;
        }
        jumpCameraToGoal() {
            this[$fd4eb456bcbd06f8$var$ev] = !0, this.requestUpdate($fd4eb456bcbd06f8$var$ev, !1);
        }
        resetInteractionPrompt() {
            this[$fd4eb456bcbd06f8$var$Zg] = 0, this[$fd4eb456bcbd06f8$var$Kg] = 1 / 0, this[$fd4eb456bcbd06f8$var$Jg] = !1, this[$fd4eb456bcbd06f8$var$Yg] = this.interactionPrompt === $fd4eb456bcbd06f8$var$wg && this.cameraControls;
        }
        zoom(t1) {
            const e = new WheelEvent("wheel", {
                deltaY: -30 * t1
            });
            this[$fd4eb456bcbd06f8$var$xp].dispatchEvent(e);
        }
        connectedCallback() {
            super.connectedCallback(), this[$fd4eb456bcbd06f8$var$Ug].addEventListener("change", this[$fd4eb456bcbd06f8$var$Xg]), this[$fd4eb456bcbd06f8$var$Ug].addEventListener("pointer-change-start", this[$fd4eb456bcbd06f8$var$$g]), this[$fd4eb456bcbd06f8$var$Ug].addEventListener("pointer-change-end", this[$fd4eb456bcbd06f8$var$$g]);
        }
        disconnectedCallback() {
            super.disconnectedCallback(), this[$fd4eb456bcbd06f8$var$Ug].removeEventListener("change", this[$fd4eb456bcbd06f8$var$Xg]), this[$fd4eb456bcbd06f8$var$Ug].removeEventListener("pointer-change-start", this[$fd4eb456bcbd06f8$var$$g]), this[$fd4eb456bcbd06f8$var$Ug].removeEventListener("pointer-change-end", this[$fd4eb456bcbd06f8$var$$g]);
        }
        updated(t1) {
            super.updated(t1);
            const e = this[$fd4eb456bcbd06f8$var$Ug], n = this[$fd4eb456bcbd06f8$var$_p], i = this[$fd4eb456bcbd06f8$var$xp];
            if (t1.has("cameraControls") && (this.cameraControls ? (e.enableInteraction(), this.interactionPrompt === $fd4eb456bcbd06f8$var$wg && (this[$fd4eb456bcbd06f8$var$Yg] = !0), i.addEventListener("focus", this[$fd4eb456bcbd06f8$var$qg]), i.addEventListener("blur", this[$fd4eb456bcbd06f8$var$jg])) : (i.removeEventListener("focus", this[$fd4eb456bcbd06f8$var$qg]), i.removeEventListener("blur", this[$fd4eb456bcbd06f8$var$jg]), e.disableInteraction(), this[$fd4eb456bcbd06f8$var$Vg]()), this[$fd4eb456bcbd06f8$var$xp].setAttribute("aria-label", this[$fd4eb456bcbd06f8$var$up])), t1.has("disableZoom") && (e.disableZoom = this.disableZoom), t1.has("enablePan") && (e.enablePan = this.enablePan), t1.has("bounds") && (n.tightBounds = "tight" === this.bounds), (t1.has("interactionPrompt") || t1.has("cameraControls") || t1.has("src")) && (this.interactionPrompt === $fd4eb456bcbd06f8$var$wg && this.cameraControls && !this[$fd4eb456bcbd06f8$var$Jg] ? this[$fd4eb456bcbd06f8$var$Yg] = !0 : this[$fd4eb456bcbd06f8$var$Vg]()), t1.has("interactionPolicy")) {
                const t1 = this.interactionPolicy;
                e.applyOptions({
                    interactionPolicy: t1
                });
            }
            if (t1.has("touchAction")) {
                const t1 = this.touchAction;
                e.applyOptions({
                    touchAction: t1
                }), e.updateTouchActionStyle();
            }
            t1.has("orbitSensitivity") && (e.sensitivity = this.orbitSensitivity), t1.has("interpolationDecay") && (e.setDamperDecayTime(this.interpolationDecay), n.setTargetDamperDecayTime(this.interpolationDecay)), !0 === this[$fd4eb456bcbd06f8$var$ev] && Promise.resolve().then(()=>{
                e.jumpToGoal(), n.jumpToGoal(), this[$fd4eb456bcbd06f8$var$ev] = !1;
            });
        }
        async updateFraming() {
            const t1 = this[$fd4eb456bcbd06f8$var$_p], e = t1.adjustedFoV(t1.framedFoVDeg);
            await t1.updateFraming();
            const n = t1.adjustedFoV(t1.framedFoVDeg), i = this[$fd4eb456bcbd06f8$var$Ug].getFieldOfView() / e;
            this[$fd4eb456bcbd06f8$var$Ug].setFieldOfView(n * i), this[$fd4eb456bcbd06f8$var$iv] = !0, this.requestUpdate("maxFieldOfView"), this.requestUpdate("fieldOfView"), this.requestUpdate("minCameraOrbit"), this.requestUpdate("maxCameraOrbit"), this.requestUpdate("cameraOrbit"), await this.updateComplete;
        }
        interact(t1, e, n) {
            const i = this[$fd4eb456bcbd06f8$var$xp], r = this[$fd4eb456bcbd06f8$var$Hg];
            if ("1" === r[0].style.opacity) return void console.warn("interact() failed because an existing interaction is running.");
            const s = new Array;
            s.push({
                x: $fd4eb456bcbd06f8$var$gg(e.x),
                y: $fd4eb456bcbd06f8$var$gg(e.y)
            });
            const a = [
                {
                    x: s[0].x(0),
                    y: s[0].y(0)
                }
            ];
            null != n && (s.push({
                x: $fd4eb456bcbd06f8$var$gg(n.x),
                y: $fd4eb456bcbd06f8$var$gg(n.y)
            }), a.push({
                x: s[1].x(0),
                y: s[1].y(0)
            }));
            let o = performance.now();
            const { width: l, height: h } = this[$fd4eb456bcbd06f8$var$_p], c = (t1)=>{
                for (const [e, n] of a.entries()){
                    const { style: s } = r[e];
                    s.transform = `translateX(${l * n.x}px) translateY(${h * n.y}px)`, "pointerdown" === t1 ? s.opacity = "1" : "pointerup" === t1 && (s.opacity = "0");
                    const a = {
                        pointerId: e - 5678,
                        pointerType: "touch",
                        target: i,
                        clientX: l * n.x,
                        clientY: h * n.y,
                        altKey: !0
                    };
                    i.dispatchEvent(new PointerEvent(t1, a));
                }
            }, u = ()=>{
                if (this[$fd4eb456bcbd06f8$var$Ug].isUserChange) {
                    for (const t1 of this[$fd4eb456bcbd06f8$var$Hg])t1.style.opacity = "0";
                    return void c("pointercancel");
                }
                const e = Math.min(1, (performance.now() - o) / t1);
                for (const [t1, n] of a.entries())n.x = s[t1].x(e), n.y = s[t1].y(e);
                c("pointermove"), e < 1 ? requestAnimationFrame(u) : (c("pointerup"), document.removeEventListener("visibilitychange", d));
            }, d = ()=>{
                let t1 = 0;
                "hidden" === document.visibilityState ? t1 = performance.now() - o : o = performance.now() - t1;
            };
            document.addEventListener("visibilitychange", d), c("pointerdown"), requestAnimationFrame(u);
        }
        [(n = $fd4eb456bcbd06f8$var$Bg, i = $fd4eb456bcbd06f8$var$zg, r = $fd4eb456bcbd06f8$var$Hg, s = $fd4eb456bcbd06f8$var$kg, a = $fd4eb456bcbd06f8$var$Qg, o = $fd4eb456bcbd06f8$var$Zg, l = $fd4eb456bcbd06f8$var$Kg, h = $fd4eb456bcbd06f8$var$Jg, c = $fd4eb456bcbd06f8$var$Yg, u = $fd4eb456bcbd06f8$var$Ug, d = $fd4eb456bcbd06f8$var$tv, p = $fd4eb456bcbd06f8$var$ev, m = $fd4eb456bcbd06f8$var$nv, f = $fd4eb456bcbd06f8$var$iv, $fd4eb456bcbd06f8$var$sv)](t1) {
            const e = this[$fd4eb456bcbd06f8$var$_p];
            e.framedFoVDeg = 180 * t1[0] / Math.PI, this[$fd4eb456bcbd06f8$var$Ug].setFieldOfView(e.adjustedFoV(e.framedFoVDeg));
        }
        [$fd4eb456bcbd06f8$var$rv](t1) {
            const e = this[$fd4eb456bcbd06f8$var$Ug];
            if (this[$fd4eb456bcbd06f8$var$iv]) {
                const { theta: e, phi: n } = this.getCameraOrbit();
                t1[0] = e, t1[1] = n, this[$fd4eb456bcbd06f8$var$iv] = !1;
            }
            e.isUserChange = !1, e.setOrbit(t1[0], t1[1], t1[2]);
        }
        [$fd4eb456bcbd06f8$var$ov](t1) {
            this[$fd4eb456bcbd06f8$var$Ug].applyOptions({
                minimumAzimuthalAngle: t1[0],
                minimumPolarAngle: t1[1],
                minimumRadius: t1[2]
            }), this.jumpCameraToGoal();
        }
        [$fd4eb456bcbd06f8$var$lv](t1) {
            this[$fd4eb456bcbd06f8$var$Ug].applyOptions({
                maximumAzimuthalAngle: t1[0],
                maximumPolarAngle: t1[1],
                maximumRadius: t1[2]
            }), this[$fd4eb456bcbd06f8$var$Wg](t1[2]), this.jumpCameraToGoal();
        }
        [$fd4eb456bcbd06f8$var$hv](t1) {
            this[$fd4eb456bcbd06f8$var$Ug].applyOptions({
                minimumFieldOfView: 180 * t1[0] / Math.PI
            }), this.jumpCameraToGoal();
        }
        [$fd4eb456bcbd06f8$var$cv](t1) {
            const e = this[$fd4eb456bcbd06f8$var$_p].adjustedFoV(180 * t1[0] / Math.PI);
            this[$fd4eb456bcbd06f8$var$Ug].applyOptions({
                maximumFieldOfView: e
            }), this.jumpCameraToGoal();
        }
        [$fd4eb456bcbd06f8$var$av](t1) {
            const [e, n, i] = t1;
            this[$fd4eb456bcbd06f8$var$Ep].arRenderer.isPresenting || this[$fd4eb456bcbd06f8$var$_p].setTarget(e, n, i), this[$fd4eb456bcbd06f8$var$Ug].isUserChange = !1, this[$fd4eb456bcbd06f8$var$Ep].arRenderer.updateTarget();
        }
        [$fd4eb456bcbd06f8$var$Mp](t1, e) {
            if (super[$fd4eb456bcbd06f8$var$Mp](t1, e), this[$fd4eb456bcbd06f8$var$Ep].isPresenting || !this[$fd4eb456bcbd06f8$var$Dp]()) return;
            const n = this[$fd4eb456bcbd06f8$var$Ug], i = this[$fd4eb456bcbd06f8$var$_p], r = performance.now();
            if (this[$fd4eb456bcbd06f8$var$Yg]) {
                const t1 = this.interactionPrompt === $fd4eb456bcbd06f8$var$wg ? this[$fd4eb456bcbd06f8$var$fp] : this[$fd4eb456bcbd06f8$var$Qg];
                this.loaded && r > t1 + this.interactionPromptThreshold && (this[$fd4eb456bcbd06f8$var$Yg] = !1, this[$fd4eb456bcbd06f8$var$Kg] = r, this[$fd4eb456bcbd06f8$var$Bg].classList.add("visible"));
            }
            if (isFinite(this[$fd4eb456bcbd06f8$var$Kg]) && this.interactionPromptStyle === $fd4eb456bcbd06f8$var$Sg) {
                const t1 = (r - this[$fd4eb456bcbd06f8$var$Kg]) / 5e3 % 1, e = $fd4eb456bcbd06f8$var$yg(t1), s = $fd4eb456bcbd06f8$var$xg(t1);
                if (this[$fd4eb456bcbd06f8$var$zg].style.opacity = `${s}`, e !== this[$fd4eb456bcbd06f8$var$Zg]) {
                    const t1 = e * i.width * .05, r = (e - this[$fd4eb456bcbd06f8$var$Zg]) * Math.PI / 16;
                    this[$fd4eb456bcbd06f8$var$zg].style.transform = `translateX(${t1}px)`, n.isUserChange = !1, n.adjustOrbit(r, 0, 0), this[$fd4eb456bcbd06f8$var$Zg] = e;
                }
            }
            if (n.update(t1, e), i.updateTarget(e)) {
                const t1 = n.isUserChange ? $fd4eb456bcbd06f8$var$ug : $fd4eb456bcbd06f8$var$dg;
                this[$fd4eb456bcbd06f8$var$Xg]({
                    type: "change",
                    source: t1
                });
            }
        }
        [$fd4eb456bcbd06f8$var$Vg]() {
            this[$fd4eb456bcbd06f8$var$Yg] = !1, this[$fd4eb456bcbd06f8$var$Bg].classList.remove("visible"), this[$fd4eb456bcbd06f8$var$Kg] = 1 / 0;
        }
        [$fd4eb456bcbd06f8$var$Wg](t1) {
            const e = 2 * Math.max(this[$fd4eb456bcbd06f8$var$_p].boundingSphere.radius, t1);
            this[$fd4eb456bcbd06f8$var$Ug].updateNearFar(0, e);
        }
        [$fd4eb456bcbd06f8$var$Gg]() {
            const { theta: t1, phi: e } = this[$fd4eb456bcbd06f8$var$Ug].getCameraSpherical(this[$fd4eb456bcbd06f8$var$tv]), n = (4 + Math.floor((t1 % $fd4eb456bcbd06f8$var$Fg + $fd4eb456bcbd06f8$var$Ng) / $fd4eb456bcbd06f8$var$Ig)) % 4, i = Math.floor(e / $fd4eb456bcbd06f8$var$Og), r = $fd4eb456bcbd06f8$var$bg[n], s = $fd4eb456bcbd06f8$var$_g[i];
            this[$fd4eb456bcbd06f8$var$mp](`View from stage ${s}${r}`);
        }
        get [$fd4eb456bcbd06f8$var$up]() {
            return super[$fd4eb456bcbd06f8$var$up] + (this.cameraControls ? ". Use mouse, touch or arrow keys to move." : "");
        }
        async [$fd4eb456bcbd06f8$var$Tp](t1) {
            const e = this[$fd4eb456bcbd06f8$var$Ug], n = this[$fd4eb456bcbd06f8$var$_p], i = n.adjustedFoV(n.framedFoVDeg);
            super[$fd4eb456bcbd06f8$var$Tp](t1);
            const r = n.adjustedFoV(n.framedFoVDeg) / i, s = e.getFieldOfView() * (isFinite(r) ? r : 1);
            e.updateAspect(this[$fd4eb456bcbd06f8$var$_p].aspect), this.requestUpdate("maxFieldOfView", this.maxFieldOfView), await this.updateComplete, this[$fd4eb456bcbd06f8$var$Ug].setFieldOfView(s), this.jumpCameraToGoal();
        }
        [$fd4eb456bcbd06f8$var$Sp]() {
            super[$fd4eb456bcbd06f8$var$Sp](), this[$fd4eb456bcbd06f8$var$nv] ? this[$fd4eb456bcbd06f8$var$iv] = !0 : this[$fd4eb456bcbd06f8$var$nv] = !0, this.requestUpdate("maxFieldOfView", this.maxFieldOfView), this.requestUpdate("fieldOfView", this.fieldOfView), this.requestUpdate("minCameraOrbit", this.minCameraOrbit), this.requestUpdate("maxCameraOrbit", this.maxCameraOrbit), this.requestUpdate("cameraOrbit", this.cameraOrbit), this.requestUpdate("cameraTarget", this.cameraTarget), this.jumpCameraToGoal();
        }
    }
    return g = $fd4eb456bcbd06f8$var$qg, v = $fd4eb456bcbd06f8$var$jg, y = $fd4eb456bcbd06f8$var$Xg, x = $fd4eb456bcbd06f8$var$$g, $fd4eb456bcbd06f8$var$vg([
        $fd4eb456bcbd06f8$var$e({
            type: Boolean,
            attribute: "camera-controls"
        })
    ], b.prototype, "cameraControls", void 0), $fd4eb456bcbd06f8$var$vg([
        $fd4eb456bcbd06f8$var$tg({
            intrinsics: $fd4eb456bcbd06f8$var$Cg,
            observeEffects: !0,
            updateHandler: $fd4eb456bcbd06f8$var$rv
        }),
        $fd4eb456bcbd06f8$var$e({
            type: String,
            attribute: "camera-orbit",
            hasChanged: ()=>!0
        })
    ], b.prototype, "cameraOrbit", void 0), $fd4eb456bcbd06f8$var$vg([
        $fd4eb456bcbd06f8$var$tg({
            intrinsics: $fd4eb456bcbd06f8$var$Dg,
            observeEffects: !0,
            updateHandler: $fd4eb456bcbd06f8$var$av
        }),
        $fd4eb456bcbd06f8$var$e({
            type: String,
            attribute: "camera-target",
            hasChanged: ()=>!0
        })
    ], b.prototype, "cameraTarget", void 0), $fd4eb456bcbd06f8$var$vg([
        $fd4eb456bcbd06f8$var$tg({
            intrinsics: $fd4eb456bcbd06f8$var$Ag,
            observeEffects: !0,
            updateHandler: $fd4eb456bcbd06f8$var$sv
        }),
        $fd4eb456bcbd06f8$var$e({
            type: String,
            attribute: "field-of-view",
            hasChanged: ()=>!0
        })
    ], b.prototype, "fieldOfView", void 0), $fd4eb456bcbd06f8$var$vg([
        $fd4eb456bcbd06f8$var$tg({
            intrinsics: $fd4eb456bcbd06f8$var$Lg,
            updateHandler: $fd4eb456bcbd06f8$var$ov
        }),
        $fd4eb456bcbd06f8$var$e({
            type: String,
            attribute: "min-camera-orbit",
            hasChanged: ()=>!0
        })
    ], b.prototype, "minCameraOrbit", void 0), $fd4eb456bcbd06f8$var$vg([
        $fd4eb456bcbd06f8$var$tg({
            intrinsics: $fd4eb456bcbd06f8$var$Pg,
            updateHandler: $fd4eb456bcbd06f8$var$lv
        }),
        $fd4eb456bcbd06f8$var$e({
            type: String,
            attribute: "max-camera-orbit",
            hasChanged: ()=>!0
        })
    ], b.prototype, "maxCameraOrbit", void 0), $fd4eb456bcbd06f8$var$vg([
        $fd4eb456bcbd06f8$var$tg({
            intrinsics: $fd4eb456bcbd06f8$var$Rg,
            updateHandler: $fd4eb456bcbd06f8$var$hv
        }),
        $fd4eb456bcbd06f8$var$e({
            type: String,
            attribute: "min-field-of-view",
            hasChanged: ()=>!0
        })
    ], b.prototype, "minFieldOfView", void 0), $fd4eb456bcbd06f8$var$vg([
        $fd4eb456bcbd06f8$var$tg({
            intrinsics: $fd4eb456bcbd06f8$var$Ag,
            updateHandler: $fd4eb456bcbd06f8$var$cv
        }),
        $fd4eb456bcbd06f8$var$e({
            type: String,
            attribute: "max-field-of-view",
            hasChanged: ()=>!0
        })
    ], b.prototype, "maxFieldOfView", void 0), $fd4eb456bcbd06f8$var$vg([
        $fd4eb456bcbd06f8$var$e({
            type: Number,
            attribute: "interaction-prompt-threshold"
        })
    ], b.prototype, "interactionPromptThreshold", void 0), $fd4eb456bcbd06f8$var$vg([
        $fd4eb456bcbd06f8$var$e({
            type: String,
            attribute: "interaction-prompt-style"
        })
    ], b.prototype, "interactionPromptStyle", void 0), $fd4eb456bcbd06f8$var$vg([
        $fd4eb456bcbd06f8$var$e({
            type: String,
            attribute: "interaction-prompt"
        })
    ], b.prototype, "interactionPrompt", void 0), $fd4eb456bcbd06f8$var$vg([
        $fd4eb456bcbd06f8$var$e({
            type: String,
            attribute: "interaction-policy"
        })
    ], b.prototype, "interactionPolicy", void 0), $fd4eb456bcbd06f8$var$vg([
        $fd4eb456bcbd06f8$var$e({
            type: Number,
            attribute: "orbit-sensitivity"
        })
    ], b.prototype, "orbitSensitivity", void 0), $fd4eb456bcbd06f8$var$vg([
        $fd4eb456bcbd06f8$var$e({
            type: String,
            attribute: "touch-action"
        })
    ], b.prototype, "touchAction", void 0), $fd4eb456bcbd06f8$var$vg([
        $fd4eb456bcbd06f8$var$e({
            type: Boolean,
            attribute: "disable-zoom"
        })
    ], b.prototype, "disableZoom", void 0), $fd4eb456bcbd06f8$var$vg([
        $fd4eb456bcbd06f8$var$e({
            type: Boolean,
            attribute: "enable-pan"
        })
    ], b.prototype, "enablePan", void 0), $fd4eb456bcbd06f8$var$vg([
        $fd4eb456bcbd06f8$var$e({
            type: Number,
            attribute: "interpolation-decay"
        })
    ], b.prototype, "interpolationDecay", void 0), $fd4eb456bcbd06f8$var$vg([
        $fd4eb456bcbd06f8$var$e({
            type: String,
            attribute: "bounds"
        })
    ], b.prototype, "bounds", void 0), b;
})(((t1)=>{
    var n, i, r, s, a, o, l, h, c, u;
    class d extends t1 {
        constructor(){
            super(...arguments), this.ar = !1, this.arScale = "auto", this.arPlacement = "floor", this.arModes = "webxr scene-viewer", this.iosSrc = null, this.xrEnvironment = !1, this[n] = !1, this[i] = this.shadowRoot.querySelector(".ar-button"), this[r] = document.createElement("a"), this[s] = new Set, this[a] = $fd4eb456bcbd06f8$var$tf, this[o] = !1, this[l] = (t1)=>{
                t1.preventDefault(), this.activateAR();
            }, this[h] = ({ status: t1 })=>{
                t1 !== $fd4eb456bcbd06f8$var$Zu && this[$fd4eb456bcbd06f8$var$Ep].arRenderer.presentedScene !== this[$fd4eb456bcbd06f8$var$_p] || (this.setAttribute("ar-status", t1), this.dispatchEvent(new CustomEvent("ar-status", {
                    detail: {
                        status: t1
                    }
                })), t1 === $fd4eb456bcbd06f8$var$Zu ? this.removeAttribute("ar-tracking") : t1 === $fd4eb456bcbd06f8$var$Qu && this.setAttribute("ar-tracking", $fd4eb456bcbd06f8$var$nd));
            }, this[c] = ({ status: t1 })=>{
                this.setAttribute("ar-tracking", t1), this.dispatchEvent(new CustomEvent("ar-tracking", {
                    detail: {
                        status: t1
                    }
                }));
            }, this[u] = (t1)=>{
                "_apple_ar_quicklook_button_tapped" == t1.data && this.dispatchEvent(new CustomEvent("quick-look-button-tapped"));
            };
        }
        get canActivateAR() {
            return this[$fd4eb456bcbd06f8$var$of] !== $fd4eb456bcbd06f8$var$tf;
        }
        connectedCallback() {
            super.connectedCallback(), this[$fd4eb456bcbd06f8$var$Ep].arRenderer.addEventListener("status", this[$fd4eb456bcbd06f8$var$df]), this.setAttribute("ar-status", $fd4eb456bcbd06f8$var$Zu), this[$fd4eb456bcbd06f8$var$Ep].arRenderer.addEventListener("tracking", this[$fd4eb456bcbd06f8$var$pf]), this[$fd4eb456bcbd06f8$var$hf].addEventListener("message", this[$fd4eb456bcbd06f8$var$mf]);
        }
        disconnectedCallback() {
            super.disconnectedCallback(), this[$fd4eb456bcbd06f8$var$Ep].arRenderer.removeEventListener("status", this[$fd4eb456bcbd06f8$var$df]), this[$fd4eb456bcbd06f8$var$Ep].arRenderer.removeEventListener("tracking", this[$fd4eb456bcbd06f8$var$pf]), this[$fd4eb456bcbd06f8$var$hf].removeEventListener("message", this[$fd4eb456bcbd06f8$var$mf]);
        }
        async update(t1) {
            super.update(t1), t1.has("arScale") && (this[$fd4eb456bcbd06f8$var$_p].canScale = "fixed" !== this.arScale), t1.has("arPlacement") && (this[$fd4eb456bcbd06f8$var$_p].updateShadow(), this[$fd4eb456bcbd06f8$var$wp]()), (t1.has("ar") || t1.has("arModes") || t1.has("src") || t1.has("iosSrc")) && (t1.has("arModes") && (this[$fd4eb456bcbd06f8$var$lf] = $fd4eb456bcbd06f8$var$Ym(this.arModes)), this[$fd4eb456bcbd06f8$var$ff]());
        }
        async activateAR() {
            switch(this[$fd4eb456bcbd06f8$var$of]){
                case $fd4eb456bcbd06f8$var$Km:
                    this[$fd4eb456bcbd06f8$var$sf]();
                    break;
                case $fd4eb456bcbd06f8$var$Qm:
                    await this[$fd4eb456bcbd06f8$var$nf]();
                    break;
                case $fd4eb456bcbd06f8$var$Zm:
                    this[$fd4eb456bcbd06f8$var$rf]();
                    break;
                default:
                    console.warn("No AR Mode can be activated. This is probably due to missing configuration or device capabilities");
            }
        }
        async [(n = $fd4eb456bcbd06f8$var$af, i = $fd4eb456bcbd06f8$var$ef, r = $fd4eb456bcbd06f8$var$hf, s = $fd4eb456bcbd06f8$var$lf, a = $fd4eb456bcbd06f8$var$of, o = $fd4eb456bcbd06f8$var$cf, l = $fd4eb456bcbd06f8$var$uf, h = $fd4eb456bcbd06f8$var$df, c = $fd4eb456bcbd06f8$var$pf, u = $fd4eb456bcbd06f8$var$mf, $fd4eb456bcbd06f8$var$ff)]() {
            if (this[$fd4eb456bcbd06f8$var$of] = $fd4eb456bcbd06f8$var$tf, this.ar) {
                if (null != this.src) for (const t1 of this[$fd4eb456bcbd06f8$var$lf]){
                    if ("webxr" === t1 && $fd4eb456bcbd06f8$var$ph && !$fd4eb456bcbd06f8$var$Xm && await this[$fd4eb456bcbd06f8$var$Ep].arRenderer.supportsPresentation()) {
                        this[$fd4eb456bcbd06f8$var$of] = $fd4eb456bcbd06f8$var$Qm;
                        break;
                    }
                    if ("scene-viewer" === t1 && $fd4eb456bcbd06f8$var$xh && !$fd4eb456bcbd06f8$var$$m) {
                        this[$fd4eb456bcbd06f8$var$of] = $fd4eb456bcbd06f8$var$Zm;
                        break;
                    }
                    if ("quick-look" === t1 && $fd4eb456bcbd06f8$var$gh) {
                        this[$fd4eb456bcbd06f8$var$of] = $fd4eb456bcbd06f8$var$Km;
                        break;
                    }
                }
                !this.canActivateAR && null != this.iosSrc && $fd4eb456bcbd06f8$var$gh && (this[$fd4eb456bcbd06f8$var$of] = $fd4eb456bcbd06f8$var$Km);
            }
            if (this.canActivateAR) this[$fd4eb456bcbd06f8$var$ef].classList.add("enabled"), this[$fd4eb456bcbd06f8$var$ef].addEventListener("click", this[$fd4eb456bcbd06f8$var$uf]);
            else if (this[$fd4eb456bcbd06f8$var$ef].classList.contains("enabled")) {
                this[$fd4eb456bcbd06f8$var$ef].removeEventListener("click", this[$fd4eb456bcbd06f8$var$uf]), this[$fd4eb456bcbd06f8$var$ef].classList.remove("enabled");
                const t1 = $fd4eb456bcbd06f8$var$ed;
                this.setAttribute("ar-status", t1), this.dispatchEvent(new CustomEvent("ar-status", {
                    detail: {
                        status: t1
                    }
                }));
            }
        }
        async [$fd4eb456bcbd06f8$var$nf]() {
            console.log("Attempting to present in AR with WebXR..."), await this[$fd4eb456bcbd06f8$var$gf]();
            try {
                this[$fd4eb456bcbd06f8$var$ef].removeEventListener("click", this[$fd4eb456bcbd06f8$var$uf]);
                const { arRenderer: t1 } = this[$fd4eb456bcbd06f8$var$Ep];
                t1.placeOnWall = "wall" === this.arPlacement, await t1.present(this[$fd4eb456bcbd06f8$var$_p], this.xrEnvironment);
            } catch (t1) {
                console.warn("Error while trying to present in AR with WebXR"), console.error(t1), await this[$fd4eb456bcbd06f8$var$Ep].arRenderer.stopPresenting(), $fd4eb456bcbd06f8$var$Xm = !0, console.warn("Falling back to next ar-mode"), await this[$fd4eb456bcbd06f8$var$ff](), this.activateAR();
            } finally{
                this[$fd4eb456bcbd06f8$var$ff]();
            }
        }
        async [$fd4eb456bcbd06f8$var$gf]() {
            this.loaded || (this[$fd4eb456bcbd06f8$var$cf] = !0, this[$fd4eb456bcbd06f8$var$gp](), await ((t1, e, n = null)=>new Promise((i)=>{
                    t1.addEventListener(e, function r(s) {
                        n && !n(s) || (i(s), t1.removeEventListener(e, r));
                    });
                }))(this, "load"), this[$fd4eb456bcbd06f8$var$cf] = !1);
        }
        [$fd4eb456bcbd06f8$var$Lp]() {
            return super[$fd4eb456bcbd06f8$var$Lp]() || this[$fd4eb456bcbd06f8$var$cf];
        }
        [$fd4eb456bcbd06f8$var$rf]() {
            const t1 = self.location.toString(), e = new URL(t1), n = new URL(this.src, t1), i = new URLSearchParams(n.search);
            if (e.hash = "#model-viewer-no-ar-fallback", i.set("mode", "ar_preferred"), i.has("disable_occlusion") || i.set("disable_occlusion", "true"), "fixed" === this.arScale && i.set("resizable", "false"), "wall" === this.arPlacement && i.set("enable_vertical_placement", "true"), i.has("sound")) {
                const e = new URL(i.get("sound"), t1);
                i.set("sound", e.toString());
            }
            if (i.has("link")) {
                const e = new URL(i.get("link"), t1);
                i.set("link", e.toString());
            }
            const r = `intent://arvr.google.com/scene-viewer/1.0?${i.toString() + "&file=" + encodeURIComponent(n.toString())}#Intent;scheme=https;package=com.google.ar.core;action=android.intent.action.VIEW;S.browser_fallback_url=${encodeURIComponent(e.toString())};end;`;
            self.addEventListener("hashchange", ()=>{
                "#model-viewer-no-ar-fallback" === self.location.hash && ($fd4eb456bcbd06f8$var$$m = !0, self.history.back(), console.warn("Error while trying to present in AR with Scene Viewer"), console.warn("Falling back to next ar-mode"), this[$fd4eb456bcbd06f8$var$ff]());
            }, {
                once: !0
            }), this[$fd4eb456bcbd06f8$var$hf].setAttribute("href", r), console.log("Attempting to present in AR with Scene Viewer..."), this[$fd4eb456bcbd06f8$var$hf].click();
        }
        async [$fd4eb456bcbd06f8$var$sf]() {
            const t1 = !this.iosSrc;
            this[$fd4eb456bcbd06f8$var$ef].classList.remove("enabled");
            const e = t1 ? await this.prepareUSDZ() : this.iosSrc, n = new URL(e, self.location.toString());
            "fixed" === this.arScale && (n.hash && (n.hash += "&"), n.hash += "allowsContentScaling=0");
            const i = this[$fd4eb456bcbd06f8$var$hf];
            i.setAttribute("rel", "ar");
            const r = document.createElement("img");
            i.appendChild(r), i.setAttribute("href", n.toString()), t1 && i.setAttribute("download", "model.usdz"), console.log("Attempting to present in AR with Quick Look..."), i.click(), i.removeChild(r), t1 && URL.revokeObjectURL(e), this[$fd4eb456bcbd06f8$var$ef].classList.add("enabled");
        }
        async prepareUSDZ() {
            const t1 = this[$fd4eb456bcbd06f8$var$Ap].beginActivity();
            await this[$fd4eb456bcbd06f8$var$gf]();
            const e = this[$fd4eb456bcbd06f8$var$_p], n = e.shadow;
            let i = !1;
            null != n && (i = n.visible, n.visible = !1), t1(.2);
            const r = new $fd4eb456bcbd06f8$var$km, s = await r.parse(e.modelContainer), a = new Blob([
                s
            ], {
                type: "model/vnd.usdz+zip"
            }), o = URL.createObjectURL(a);
            return t1(1), null != n && (n.visible = i), o;
        }
    }
    return $fd4eb456bcbd06f8$var$qm([
        $fd4eb456bcbd06f8$var$e({
            type: Boolean,
            attribute: "ar"
        })
    ], d.prototype, "ar", void 0), $fd4eb456bcbd06f8$var$qm([
        $fd4eb456bcbd06f8$var$e({
            type: String,
            attribute: "ar-scale"
        })
    ], d.prototype, "arScale", void 0), $fd4eb456bcbd06f8$var$qm([
        $fd4eb456bcbd06f8$var$e({
            type: String,
            attribute: "ar-placement"
        })
    ], d.prototype, "arPlacement", void 0), $fd4eb456bcbd06f8$var$qm([
        $fd4eb456bcbd06f8$var$e({
            type: String,
            attribute: "ar-modes"
        })
    ], d.prototype, "arModes", void 0), $fd4eb456bcbd06f8$var$qm([
        $fd4eb456bcbd06f8$var$e({
            type: String,
            attribute: "ios-src"
        })
    ], d.prototype, "iosSrc", void 0), $fd4eb456bcbd06f8$var$qm([
        $fd4eb456bcbd06f8$var$e({
            type: Boolean,
            attribute: "xr-environment"
        })
    ], d.prototype, "xrEnvironment", void 0), d;
})(((t1)=>{
    var n, i, r, s, a, o, l, h, c, u, d, p, m, f;
    class g extends t1 {
        constructor(...t1){
            super(...t1), this.poster = null, this.reveal = $fd4eb456bcbd06f8$var$dv, this.loading = $fd4eb456bcbd06f8$var$mv, this.generateSchema = !1, this.seamlessPoster = !1, this[n] = !1, this[i] = !1, this[r] = 0, this[s] = null, this[a] = this.shadowRoot.querySelector(".slot.poster"), this[o] = this.shadowRoot.querySelector("#default-poster"), this[l] = this.shadowRoot.querySelector("#default-progress-bar > .bar"), this[h] = this.shadowRoot.querySelector("#default-progress-bar > .mask"), this[c] = this[$fd4eb456bcbd06f8$var$bv].getAttribute("aria-label"), this[u] = ((t1, e)=>{
                let n = null;
                const i = (...i)=>{
                    null == n && (t1(...i), n = self.setTimeout(()=>n = null, e));
                };
                return i.flush = ()=>{
                    null != n && (self.clearTimeout(n), n = null);
                }, i;
            })((t1)=>{
                const e = this[$fd4eb456bcbd06f8$var$vv].parentNode;
                requestAnimationFrame(()=>{
                    this[$fd4eb456bcbd06f8$var$yv].style.opacity = "" + .2 * (1 - t1), this[$fd4eb456bcbd06f8$var$vv].style.transform = `scaleX(${t1})`, 0 === t1 && (e.removeChild(this[$fd4eb456bcbd06f8$var$vv]), e.appendChild(this[$fd4eb456bcbd06f8$var$vv])), 1 === t1 ? this[$fd4eb456bcbd06f8$var$vv].classList.add("hide") : this[$fd4eb456bcbd06f8$var$vv].classList.remove("hide");
                });
            }, 100), this[d] = ()=>{
                this.reveal !== $fd4eb456bcbd06f8$var$pv && this.reveal !== $fd4eb456bcbd06f8$var$dv && this.dismissPoster();
            }, this[p] = (t1)=>{
                if (this.reveal !== $fd4eb456bcbd06f8$var$pv) switch(t1.keyCode){
                    case 32:
                    case 13:
                        this.dismissPoster();
                }
            }, this[m] = (t1)=>{
                const e = t1.detail.totalProgress;
                this[$fd4eb456bcbd06f8$var$Tv] = Math.max(e, this[$fd4eb456bcbd06f8$var$Tv]), 1 === e && (this[$fd4eb456bcbd06f8$var$Sv].flush(), !this[$fd4eb456bcbd06f8$var$Pp]() || null == this[$fd4eb456bcbd06f8$var$_v] && this.reveal !== $fd4eb456bcbd06f8$var$dv || this[$fd4eb456bcbd06f8$var$wv]()), this[$fd4eb456bcbd06f8$var$Sv](e), this.dispatchEvent(new CustomEvent("progress", {
                    detail: {
                        totalProgress: e
                    }
                }));
            }, this[f] = ()=>{
                this[$fd4eb456bcbd06f8$var$Ev] = !0;
                const t1 = this.getRootNode();
                t1 && t1.activeElement === this && this[$fd4eb456bcbd06f8$var$xp].focus();
                const e = this[$fd4eb456bcbd06f8$var$bv];
                e.setAttribute("aria-hidden", "true"), e.tabIndex = -1, this.dispatchEvent(new CustomEvent("poster-dismissed"));
            };
            const e = self.ModelViewerElement || {}, g = e.dracoDecoderLocation || "https://www.gstatic.com/draco/versioned/decoders/1.4.1/";
            $fd4eb456bcbd06f8$var$Jc.setDRACODecoderLocation(g);
            const v = e.ktx2TranscoderLocation || "https://www.gstatic.com/basis-universal/versioned/2021-04-15-ba1c3e4/";
            $fd4eb456bcbd06f8$var$Jc.setKTX2TranscoderLocation(v), e.meshoptDecoderLocation && $fd4eb456bcbd06f8$var$Jc.setMeshoptDecoderLocation(e.meshoptDecoderLocation);
        }
        static set dracoDecoderLocation(t1) {
            $fd4eb456bcbd06f8$var$Jc.setDRACODecoderLocation(t1);
        }
        static get dracoDecoderLocation() {
            return $fd4eb456bcbd06f8$var$Jc.getDRACODecoderLocation();
        }
        static set ktx2TranscoderLocation(t1) {
            $fd4eb456bcbd06f8$var$Jc.setKTX2TranscoderLocation(t1);
        }
        static get ktx2TranscoderLocation() {
            return $fd4eb456bcbd06f8$var$Jc.getKTX2TranscoderLocation();
        }
        static set meshoptDecoderLocation(t1) {
            $fd4eb456bcbd06f8$var$Jc.setMeshoptDecoderLocation(t1);
        }
        static get meshoptDecoderLocation() {
            return $fd4eb456bcbd06f8$var$Jc.getMeshoptDecoderLocation();
        }
        static mapURLs(t1) {
            $fd4eb456bcbd06f8$var$Fd.singleton.loader[$fd4eb456bcbd06f8$var$Xc].manager.setURLModifier(t1);
        }
        dismissPoster() {
            this[$fd4eb456bcbd06f8$var$Pp]() ? this[$fd4eb456bcbd06f8$var$wv]() : (this[$fd4eb456bcbd06f8$var$_v] = $fd4eb456bcbd06f8$var$gv, this[$fd4eb456bcbd06f8$var$gp]());
        }
        showPoster() {
            const t1 = this[$fd4eb456bcbd06f8$var$xv], e = this[$fd4eb456bcbd06f8$var$bv];
            e.removeAttribute("tabindex"), e.removeAttribute("aria-hidden"), t1.classList.add("show");
            const n = this.modelIsVisible;
            this[$fd4eb456bcbd06f8$var$Mv] = !1, this[$fd4eb456bcbd06f8$var$cp](n), this[$fd4eb456bcbd06f8$var$Ev] = !1;
        }
        getDimensions() {
            return $fd4eb456bcbd06f8$var$Ip(this[$fd4eb456bcbd06f8$var$_p].size);
        }
        connectedCallback() {
            super.connectedCallback(), this[$fd4eb456bcbd06f8$var$xv].addEventListener("click", this[$fd4eb456bcbd06f8$var$Cv]), this[$fd4eb456bcbd06f8$var$xv].addEventListener("keydown", this[$fd4eb456bcbd06f8$var$Lv]), this[$fd4eb456bcbd06f8$var$Ap].addEventListener("progress", this[$fd4eb456bcbd06f8$var$Pv]);
        }
        disconnectedCallback() {
            super.disconnectedCallback(), this[$fd4eb456bcbd06f8$var$xv].removeEventListener("click", this[$fd4eb456bcbd06f8$var$Cv]), this[$fd4eb456bcbd06f8$var$xv].removeEventListener("keydown", this[$fd4eb456bcbd06f8$var$Lv]), this[$fd4eb456bcbd06f8$var$Ap].removeEventListener("progress", this[$fd4eb456bcbd06f8$var$Pv]);
        }
        async updated(t1) {
            super.updated(t1), t1.has("poster") && null != this.poster && (this[$fd4eb456bcbd06f8$var$bv].style.backgroundImage = `url(${this.poster})`), t1.has("alt") && this[$fd4eb456bcbd06f8$var$bv].setAttribute("aria-label", this[$fd4eb456bcbd06f8$var$dp]), (t1.has("reveal") || t1.has("loading")) && this[$fd4eb456bcbd06f8$var$gp](), t1.has("generateSchema") && (!0 === this.generateSchema ? this[$fd4eb456bcbd06f8$var$_p].updateSchema(this.src) : this[$fd4eb456bcbd06f8$var$_p].updateSchema(null)), t1.has("seamlessPoster") && (!0 === this.seamlessPoster ? this[$fd4eb456bcbd06f8$var$xv].classList.add("quick") : this[$fd4eb456bcbd06f8$var$xv].classList.remove("quick"));
        }
        [(n = $fd4eb456bcbd06f8$var$Mv, i = $fd4eb456bcbd06f8$var$Ev, r = $fd4eb456bcbd06f8$var$Tv, s = $fd4eb456bcbd06f8$var$_v, a = $fd4eb456bcbd06f8$var$xv, o = $fd4eb456bcbd06f8$var$bv, l = $fd4eb456bcbd06f8$var$vv, h = $fd4eb456bcbd06f8$var$yv, c = $fd4eb456bcbd06f8$var$Rv, u = $fd4eb456bcbd06f8$var$Sv, d = $fd4eb456bcbd06f8$var$Cv, p = $fd4eb456bcbd06f8$var$Lv, m = $fd4eb456bcbd06f8$var$Pv, $fd4eb456bcbd06f8$var$Lp)]() {
            return !!this.src && (null != this[$fd4eb456bcbd06f8$var$_v] || this.loading === $fd4eb456bcbd06f8$var$fv || this.reveal === $fd4eb456bcbd06f8$var$dv && this[$fd4eb456bcbd06f8$var$hp]);
        }
        [$fd4eb456bcbd06f8$var$Pp]() {
            const { src: t1 } = this;
            return !!t1 && super[$fd4eb456bcbd06f8$var$Pp]() && 1 === this[$fd4eb456bcbd06f8$var$Tv];
        }
        [(f = $fd4eb456bcbd06f8$var$Av, $fd4eb456bcbd06f8$var$wv)]() {
            this[$fd4eb456bcbd06f8$var$_v] = null;
            const t1 = this[$fd4eb456bcbd06f8$var$xv];
            if (t1.classList.contains("show")) {
                const e = this.modelIsVisible;
                this[$fd4eb456bcbd06f8$var$Mv] = !0, this[$fd4eb456bcbd06f8$var$cp](e), requestAnimationFrame(()=>{
                    t1.classList.remove("show"), !0 === this.seamlessPoster ? this[$fd4eb456bcbd06f8$var$Av]() : t1.addEventListener("transitionend", this[$fd4eb456bcbd06f8$var$Av], {
                        once: !0
                    });
                });
            } else this[$fd4eb456bcbd06f8$var$Ev] = !0;
        }
        [$fd4eb456bcbd06f8$var$Cp]() {
            return super[$fd4eb456bcbd06f8$var$Cp]() && this[$fd4eb456bcbd06f8$var$Mv];
        }
        [$fd4eb456bcbd06f8$var$Dp]() {
            return super[$fd4eb456bcbd06f8$var$Dp]() && this[$fd4eb456bcbd06f8$var$Ev];
        }
        async [$fd4eb456bcbd06f8$var$gp]() {
            this[$fd4eb456bcbd06f8$var$Tv] = 0, !0 === this.generateSchema && this[$fd4eb456bcbd06f8$var$_p].updateSchema(this.src), null != this[$fd4eb456bcbd06f8$var$_p].currentGLTF && null != this.src && this[$fd4eb456bcbd06f8$var$Lp]() || this.showPoster(), this[$fd4eb456bcbd06f8$var$mp]("Loading"), await super[$fd4eb456bcbd06f8$var$gp]();
        }
    }
    return $fd4eb456bcbd06f8$var$uv([
        $fd4eb456bcbd06f8$var$e({
            type: String
        })
    ], g.prototype, "poster", void 0), $fd4eb456bcbd06f8$var$uv([
        $fd4eb456bcbd06f8$var$e({
            type: String
        })
    ], g.prototype, "reveal", void 0), $fd4eb456bcbd06f8$var$uv([
        $fd4eb456bcbd06f8$var$e({
            type: String
        })
    ], g.prototype, "loading", void 0), $fd4eb456bcbd06f8$var$uv([
        $fd4eb456bcbd06f8$var$e({
            type: Boolean,
            attribute: "generate-schema"
        })
    ], g.prototype, "generateSchema", void 0), $fd4eb456bcbd06f8$var$uv([
        $fd4eb456bcbd06f8$var$e({
            type: Boolean,
            attribute: "seamless-poster"
        })
    ], g.prototype, "seamlessPoster", void 0), g;
})(((t1)=>{
    var n;
    class i extends t1 {
        constructor(...t1){
            super(t1), this.autoplay = !1, this.animationName = void 0, this.animationCrossfadeDuration = 300, this[n] = !0, this[$fd4eb456bcbd06f8$var$_p].subscribeMixerEvent("loop", (t1)=>{
                const e = t1.action._loopCount;
                this.dispatchEvent(new CustomEvent("loop", {
                    detail: {
                        count: e
                    }
                }));
            }), this[$fd4eb456bcbd06f8$var$_p].subscribeMixerEvent("finished", ()=>{
                this[$fd4eb456bcbd06f8$var$kp] = !0, this.dispatchEvent(new CustomEvent("finished"));
            });
        }
        get availableAnimations() {
            return this.loaded ? this[$fd4eb456bcbd06f8$var$_p].animationNames : [];
        }
        get duration() {
            return this[$fd4eb456bcbd06f8$var$_p].duration;
        }
        get paused() {
            return this[$fd4eb456bcbd06f8$var$kp];
        }
        get currentTime() {
            return this[$fd4eb456bcbd06f8$var$_p].animationTime;
        }
        set currentTime(t1) {
            this[$fd4eb456bcbd06f8$var$_p].animationTime = t1, this[$fd4eb456bcbd06f8$var$wp]();
        }
        get timeScale() {
            return this[$fd4eb456bcbd06f8$var$_p].animationTimeScale;
        }
        set timeScale(t1) {
            this[$fd4eb456bcbd06f8$var$_p].animationTimeScale = t1;
        }
        pause() {
            this[$fd4eb456bcbd06f8$var$kp] || (this[$fd4eb456bcbd06f8$var$kp] = !0, this.dispatchEvent(new CustomEvent("pause")));
        }
        play(t1) {
            this.availableAnimations.length > 0 && (this[$fd4eb456bcbd06f8$var$kp] = !1, this[$fd4eb456bcbd06f8$var$Up](t1), this.dispatchEvent(new CustomEvent("play")));
        }
        [(n = $fd4eb456bcbd06f8$var$kp, $fd4eb456bcbd06f8$var$Sp)]() {
            super[$fd4eb456bcbd06f8$var$Sp](), this[$fd4eb456bcbd06f8$var$kp] = !0, this.autoplay && this.play();
        }
        [$fd4eb456bcbd06f8$var$Mp](t1, e) {
            super[$fd4eb456bcbd06f8$var$Mp](t1, e), this[$fd4eb456bcbd06f8$var$kp] || !this[$fd4eb456bcbd06f8$var$Dp]() && !this[$fd4eb456bcbd06f8$var$Ep].isPresenting || (this[$fd4eb456bcbd06f8$var$_p].updateAnimation(e / 1e3), this[$fd4eb456bcbd06f8$var$wp]());
        }
        updated(t1) {
            super.updated(t1), t1.has("autoplay") && this.autoplay && this.play(), t1.has("animationName") && this[$fd4eb456bcbd06f8$var$Up]();
        }
        async [$fd4eb456bcbd06f8$var$gp]() {
            return this[$fd4eb456bcbd06f8$var$_p].stopAnimation(), super[$fd4eb456bcbd06f8$var$gp]();
        }
        [$fd4eb456bcbd06f8$var$Up](t1 = $fd4eb456bcbd06f8$var$Bp) {
            var e;
            const n = null !== (e = t1.repetitions) && void 0 !== e ? e : 1 / 0, i = t1.pingpong ? 2202 : 1 === n ? 2200 : 2201;
            this[$fd4eb456bcbd06f8$var$_p].playAnimation(this.animationName, this.animationCrossfadeDuration / 1e3, i, n), this[$fd4eb456bcbd06f8$var$kp] && (this[$fd4eb456bcbd06f8$var$_p].updateAnimation(0), this[$fd4eb456bcbd06f8$var$wp]());
        }
    }
    return $fd4eb456bcbd06f8$var$Fp([
        $fd4eb456bcbd06f8$var$e({
            type: Boolean
        })
    ], i.prototype, "autoplay", void 0), $fd4eb456bcbd06f8$var$Fp([
        $fd4eb456bcbd06f8$var$e({
            type: String,
            attribute: "animation-name"
        })
    ], i.prototype, "animationName", void 0), $fd4eb456bcbd06f8$var$Fp([
        $fd4eb456bcbd06f8$var$e({
            type: Number,
            attribute: "animation-crossfade-duration"
        })
    ], i.prototype, "animationCrossfadeDuration", void 0), i;
})(((t1)=>{
    var e;
    const n = Symbol("endPolyfillCoordination");
    return e = n, class extends t1 {
        constructor(){
            super(...arguments), this[e] = null;
        }
        connectedCallback() {
            super.connectedCallback && super.connectedCallback(), null == this[n] && (this[n] = ((t1)=>{
                if (null == t1.shadowRoot || t1.hasAttribute("data-js-focus-visible")) return ()=>{};
                if (!self.applyFocusVisiblePolyfill) {
                    const e = ()=>{
                        self.applyFocusVisiblePolyfill(t1.shadowRoot);
                    };
                    return self.addEventListener("focus-visible-polyfill-ready", e, {
                        once: !0
                    }), ()=>{
                        self.removeEventListener("focus-visible-polyfill-ready", e);
                    };
                }
                return self.applyFocusVisiblePolyfill(t1.shadowRoot), ()=>{};
            })(this));
        }
        disconnectedCallback() {
            super.disconnectedCallback && super.disconnectedCallback(), null != this[n] && (this[n](), this[n] = null);
        }
    };
})($fd4eb456bcbd06f8$var$Np)))))))));
customElements.define("model-viewer", $fd4eb456bcbd06f8$export$68e64b0cee2d229b);


//# sourceMappingURL=malmo-escape.bcd6ea59.js.map
